/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 2:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(2199),
    getSymbols = __webpack_require__(4664),
    keys = __webpack_require__(5950);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ 79:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var listCacheClear = __webpack_require__(3702),
    listCacheDelete = __webpack_require__(80),
    listCacheGet = __webpack_require__(4739),
    listCacheHas = __webpack_require__(8655),
    listCacheSet = __webpack_require__(1175);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 80:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(6025);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 92:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'caret-down';
var width = 320;
var height = 512;
var ligatures = [];
var unicode = 'f0d7';
var svgPathData = 'M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.xB = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 104:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(3661);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ 119:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '۱',
            2: '۲',
            3: '۳',
            4: '۴',
            5: '۵',
            6: '۶',
            7: '۷',
            8: '۸',
            9: '۹',
            0: '۰',
        },
        numberMap = {
            '۱': '1',
            '۲': '2',
            '۳': '3',
            '۴': '4',
            '۵': '5',
            '۶': '6',
            '۷': '7',
            '۸': '8',
            '۹': '9',
            '۰': '0',
        };

    var fa = moment.defineLocale('fa', {
        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
            '_'
        ),
        monthsShort:
            'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
                '_'
            ),
        weekdays:
            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
                '_'
            ),
        weekdaysShort:
            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
                '_'
            ),
        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function (input) {
            return /بعد از ظهر/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'قبل از ظهر';
            } else {
                return 'بعد از ظهر';
            }
        },
        calendar: {
            sameDay: '[امروز ساعت] LT',
            nextDay: '[فردا ساعت] LT',
            nextWeek: 'dddd [ساعت] LT',
            lastDay: '[دیروز ساعت] LT',
            lastWeek: 'dddd [پیش] [ساعت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'در %s',
            past: '%s پیش',
            s: 'چند ثانیه',
            ss: '%d ثانیه',
            m: 'یک دقیقه',
            mm: '%d دقیقه',
            h: 'یک ساعت',
            hh: '%d ساعت',
            d: 'یک روز',
            dd: '%d روز',
            M: 'یک ماه',
            MM: '%d ماه',
            y: 'یک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string
                .replace(/[۰-۹]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal: '%dم',
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return fa;

})));


/***/ }),

/***/ 137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ UserInvitationView_UserInvitationView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/UserInvitationView/UserInvitationView.vue?vue&type=template&id=4fde788d
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('UserInvitation',{attrs:{"invitation":_vm.invitation}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: ./src/components/UserInvitation/UserInvitation.vue + 3 modules
var UserInvitation = __webpack_require__(9442);
// EXTERNAL MODULE: ./src/components/Spinner/Spinner.vue + 3 modules
var Spinner = __webpack_require__(683);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/views/UserInvitationView/UserInvitationView.ts?vue&type=script&lang=ts&external




var fetchInvitation = function (token, hash) { return (0,tslib_es6/* __awaiter */.sH)(void 0, void 0, Promise, function () {
    return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
        return [2 /*return*/, lib/* Vue */.lD.prototype.$kwInterface.axios.get("/auth/invitation/" + token + "/" + hash)
                .then(function (response) {
                return response.data;
            })];
    });
}); };
var UserInvitationView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(UserInvitationView, _super);
    function UserInvitationView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.invitation = null;
        return _this;
    }
    UserInvitationView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                UserInvitation: UserInvitation/* default */.A,
                Spinner: Spinner/* default */.A
            },
            beforeRouteEnter: function (to, from, next) {
                return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
                    var invitation;
                    return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, fetchInvitation(to.params.token, to.params.hash)
                                    .catch(function () {
                                    next({ name: 'error-404' });
                                    return;
                                })];
                            case 1:
                                invitation = _a.sent();
                                next(function (vm) {
                                    vm.invitation = invitation;
                                    vm.loading = false;
                                });
                                return [2 /*return*/];
                        }
                    });
                });
            },
            beforeRouteUpdate: function (to, from, next) {
                return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
                    var invitation;
                    return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, fetchInvitation(to.params.token, to.params.hash)
                                    .catch(function () {
                                    next({ name: 'error-404' });
                                    return;
                                })];
                            case 1:
                                invitation = _a.sent();
                                this.invitation = invitation;
                                this.loading = false;
                                next();
                                return [2 /*return*/];
                        }
                    });
                });
            }
        })
    ], UserInvitationView);
    return UserInvitationView;
}(lib/* Vue */.lD));
/* harmony default export */ var UserInvitationViewvue_type_script_lang_ts_external = (UserInvitationView);

;// ./src/views/UserInvitationView/UserInvitationView.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var UserInvitationView_UserInvitationViewvue_type_script_lang_ts_external = (UserInvitationViewvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/UserInvitationView/UserInvitationView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  UserInvitationView_UserInvitationViewvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var UserInvitationView_UserInvitationView = (component.exports);

/***/ }),

/***/ 158:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوری',
            'فروری',
            'مارچ',
            'اپریل',
            'مئی',
            'جون',
            'جولائی',
            'اگست',
            'ستمبر',
            'اکتوبر',
            'نومبر',
            'دسمبر',
        ],
        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];

    var ur = moment.defineLocale('ur', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[آج بوقت] LT',
            nextDay: '[کل بوقت] LT',
            nextWeek: 'dddd [بوقت] LT',
            lastDay: '[گذشتہ روز بوقت] LT',
            lastWeek: '[گذشتہ] dddd [بوقت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s بعد',
            past: '%s قبل',
            s: 'چند سیکنڈ',
            ss: '%d سیکنڈ',
            m: 'ایک منٹ',
            mm: '%d منٹ',
            h: 'ایک گھنٹہ',
            hh: '%d گھنٹے',
            d: 'ایک دن',
            dd: '%d دن',
            M: 'ایک ماہ',
            MM: '%d ماہ',
            y: 'ایک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ur;

})));


/***/ }),

/***/ 181:
/***/ (function(module) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),

/***/ 217:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Am Faoilleach',
            'An Gearran',
            'Am Màrt',
            'An Giblean',
            'An Cèitean',
            'An t-Ògmhios',
            'An t-Iuchar',
            'An Lùnastal',
            'An t-Sultain',
            'An Dàmhair',
            'An t-Samhain',
            'An Dùbhlachd',
        ],
        monthsShort = [
            'Faoi',
            'Gear',
            'Màrt',
            'Gibl',
            'Cèit',
            'Ògmh',
            'Iuch',
            'Lùn',
            'Sult',
            'Dàmh',
            'Samh',
            'Dùbh',
        ],
        weekdays = [
            'Didòmhnaich',
            'Diluain',
            'Dimàirt',
            'Diciadain',
            'Diardaoin',
            'Dihaoine',
            'Disathairne',
        ],
        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

    var gd = moment.defineLocale('gd', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[An-diugh aig] LT',
            nextDay: '[A-màireach aig] LT',
            nextWeek: 'dddd [aig] LT',
            lastDay: '[An-dè aig] LT',
            lastWeek: 'dddd [seo chaidh] [aig] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ann an %s',
            past: 'bho chionn %s',
            s: 'beagan diogan',
            ss: '%d diogan',
            m: 'mionaid',
            mm: '%d mionaidean',
            h: 'uair',
            hh: '%d uairean',
            d: 'latha',
            dd: '%d latha',
            M: 'mìos',
            MM: '%d mìosan',
            y: 'bliadhna',
            yy: '%d bliadhna',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gd;

})));


/***/ }),

/***/ 249:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createCompounder = __webpack_require__(5539);

/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */
var kebabCase = createCompounder(function(result, word, index) {
  return result + (index ? '-' : '') + word.toLowerCase();
});

module.exports = kebabCase;


/***/ }),

/***/ 270:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(7068),
    isObjectLike = __webpack_require__(346);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ 289:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(2651);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 294:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ UsersForm_UsersForm; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UsersForm/UsersForm.vue?vue&type=template&id=569b62c2
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FormModal',{attrs:{"visible":_vm.show,"size":"lg","title":_vm.modalTitle,"ok-title":_vm.$t('interface.' + (_vm.localValue.id ? 'edit' : 'create'))},on:{"hidden":function($event){return _vm.$emit('canceled')}}},[(_vm.invitationLoading)?_c('Spinner'):_c('k-form',{attrs:{"action":_vm.formAction,"method":_vm.formMethod},on:{"submitComplete":_vm.submitComplete}},[_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":_vm.$t('interface.users.form.email')}},[(!_vm.localValue.id)?[_c('k-form-input',{attrs:{"name":"email","type":"email","required":""}}),_c('b-alert',{staticClass:"mt-1 mb-0",attrs:{"variant":"warning","show":""}},[_vm._v(" "+_vm._s(_vm.$t('interface.users.form.invitationExplain'))+" ")])]:[_vm._v(" "+_vm._s(_vm.localValue.email)+" "),(_vm.invitationStatus)?_c('b-alert',{staticClass:"mt-1 mb-0",attrs:{"variant":"warning","show":""}},[_c('p',[_vm._v(_vm._s(_vm.$t('interface.users.invitation.' + _vm.invitationStatus)))]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.resendInvitation.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('interface.users.form.resendInvitation'))+" ")])],1):_vm._e()]],2)],1),(_vm.localValue.id && !_vm.invitationStatus && _vm.localValue.status)?_c('b-col',[_c('b-form-group',{attrs:{"label":_vm.$t('interface.activeStatus.label')}},[_c('k-form-select',{attrs:{"name":"status","reduce":opt => opt.value,"size":"sm","options":[
              { value: true, label: _vm.$t('interface.activeStatus.on') },
              { value: false, label: _vm.$t('interface.activeStatus.off') }
            ],"clearable":false},model:{value:(_vm.localValue.status.active),callback:function ($$v) {_vm.$set(_vm.localValue.status, "active", $$v)},expression:"localValue.status.active"}})],1)],1):_vm._e()],1),(_vm.userRoles.length > 0)?_c('h2',{staticClass:"form-title-alt"},[_vm._v(" "+_vm._s(_vm.$t('interface.users.form.roles'))+" ")]):_vm._e(),(Array.isArray(_vm.localValue.roles) && _vm.localValue.roles.length === 0)?_c('input',{attrs:{"type":"hidden","name":"roles"},domProps:{"value":null}}):_vm._e(),_vm._l((_vm.localValue.roles),function(role,i){return _c('input',{key:'role-' + i,attrs:{"type":"hidden","name":"roles[]"},domProps:{"value":role}})}),_c('k-form-checkbox-group',{model:{value:(_vm.localValue.roles),callback:function ($$v) {_vm.$set(_vm.localValue, "roles", $$v)},expression:"localValue.roles"}},_vm._l((_vm.userRoles),function(role,i){return _c('div',{key:i,staticClass:"mt-2"},[_c('k-form-checkbox',{attrs:{"value":role.key}},[_vm._v(" "+_vm._s(role.name)+" "),_c('p',{staticClass:"mb-0 text-muted small"},[_vm._v(" "+_vm._s(role.description)+" ")])]),(role.key === 'manager' && _vm.localValue.roles && _vm.localValue.roles.includes(role.key))?_c('b-form-group',{staticClass:"mt-2 pl-4",attrs:{"label":_vm.$t('interface.users.form.managedUsers'),"label-size":"sm"}},[(!_vm.localValue.team_users || _vm.localValue.team_users.length === 0)?_c('input',{attrs:{"type":"hidden","name":"team_users"},domProps:{"value":null}}):_vm._e(),_vm._l((_vm.localValue.team_users),function(user,i){return _c('input',{key:i,attrs:{"type":"hidden","name":"team_users[]"},domProps:{"value":user.id}})}),_c('k-form-select',{attrs:{"label":"fullname","options":_vm.computedTeamUsers,"size":"sm","multiple":""},model:{value:(_vm.localValue.team_users),callback:function ($$v) {_vm.$set(_vm.localValue, "team_users", $$v)},expression:"localValue.team_users"}})],2):_vm._e()],1)}),0),(_vm.userPermissions.length > 0)?_c('h2',{staticClass:"form-title-alt"},[_vm._v(" "+_vm._s(_vm.$t('interface.users.form.limitations'))+" ")]):_vm._e(),_vm._l((_vm.userPermissions),function(category,i){return [_c('div',{key:i},[_c('div',{staticClass:"accordion",attrs:{"role":"tablist"}},[_c('b-card',{staticClass:"mb-1",attrs:{"no-body":""}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('accordion-' + category.key),expression:"'accordion-' + category.key"}],staticClass:"text-left",attrs:{"block":"","variant":"light","size":"sm"}},[_vm._v(" "+_vm._s(category.name)+" ")]),_c('b-collapse',{attrs:{"id":'accordion-' + category.key,"accordion":"my-accordion","role":"tabpanel"}},[_c('b-card-body',_vm._l((category.permissions),function(permission,i){return _c('b-form-group',{key:i,attrs:{"label":permission.name,"label-size":"sm","content-cols":"8","label-cols":"4","description":permission.description}},[_c('k-form-select',{attrs:{"name":'permissions[' + permission.key + ']',"options":permission.levels,"reduce":opt => opt.value,"size":"sm","clearable":false},model:{value:(_vm.localValue.permissions[permission.key]),callback:function ($$v) {_vm.$set(_vm.localValue.permissions, permission.key, $$v)},expression:"localValue.permissions[permission.key]"}})],1)}),1)],1)],1)],1)])]})],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__(1146);
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: ./src/components/FormModal/FormModal.vue + 2 modules
var FormModal = __webpack_require__(7401);
// EXTERNAL MODULE: ./src/components/Spinner/Spinner.vue + 3 modules
var Spinner = __webpack_require__(683);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/UsersForm/UsersForm.ts?vue&type=script&lang=ts&external








var UsersForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(UsersForm, _super);
    function UsersForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.localValue = {
            permissions: {},
            team_users: []
        };
        _this.invitationLoading = false;
        return _this;
    }
    UsersForm.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadUserPermissions()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.loadUserRoles()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.loadTeamUsers()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(UsersForm.prototype, "modalTitle", {
        get: function () {
            var _a;
            return this.$t('interface.users.' + (((_a = this.value) === null || _a === void 0 ? void 0 : _a.id) ? 'editTitle' : 'newTitle'));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UsersForm.prototype, "computedTeamUsers", {
        get: function () {
            var _this = this;
            return this.teamUsers.filter(function (user) { return !_this.localValue.id || _this.localValue.id !== user.id; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UsersForm.prototype, "formAction", {
        // Return form action
        get: function () {
            var url = '/team/user';
            if (this.localValue.id) {
                url += '/' + this.localValue.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UsersForm.prototype, "formMethod", {
        // Return form url
        get: function () {
            return this.localValue.id ? 'PUT' : 'POST';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UsersForm.prototype, "invitationStatus", {
        get: function () {
            var invitation = this.localValue.invitation;
            if (!invitation) {
                return false;
            }
            else if (invitation.refused_at) {
                return 'refused';
            }
            else if (external_moment_default()(invitation.expire_at).isBefore()) {
                return 'expired';
            }
            else {
                return 'wait';
            }
        },
        enumerable: false,
        configurable: true
    });
    // Watch v-model value
    UsersForm.prototype.watchValue = function (value) {
        var localValue = value ? JSON.parse(JSON.stringify(value)) : {};
        if (!localValue.permissions) {
            var permissions_1 = {};
            this.userPermissions.forEach(function (category) {
                category.permissions.forEach(function (permission) {
                    permissions_1[permission.key] = permission.defaultLevel.value;
                });
            });
            localValue.permissions = permissions_1;
        }
        this.localValue = localValue;
    };
    UsersForm.prototype.submitComplete = function (response) {
        var teamUser = response.data;
        this.setTeamUser(teamUser);
        if (teamUser.id === this.teamUser.id) {
            this.$store.dispatch('user/getUserFromApi');
        }
        return response.data;
    };
    // Resend the user invitation
    UsersForm.prototype.resendInvitation = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.invitationLoading = true;
                        return [4 /*yield*/, this.$kwInterface.axios.post('/team/user/' + this.localValue.id + '/resend_invitation')
                                .then(function (response) {
                                _this.submitComplete(response);
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.invitationLoading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], UsersForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], UsersForm.prototype, "show", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], UsersForm.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('updated')
    ], UsersForm.prototype, "submitComplete", null);
    UsersForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadUserRoles', 'loadUserPermissions', 'loadTeamUsers', 'setTeamUser'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('globalDatas', ['userRoles', 'userPermissions', 'teamUsers'])), (0,external_vuex_.mapGetters)('user', ['teamUser'])),
            components: {
                FormModal: FormModal/* default */.A,
                Spinner: Spinner/* default */.A,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BAlert: external_bootstrap_vue_.BAlert, BCard: external_bootstrap_vue_.BCard, BCardHeader: external_bootstrap_vue_.BCardHeader, BCardBody: external_bootstrap_vue_.BCardBody, BCollapse: external_bootstrap_vue_.BCollapse, BButton: external_bootstrap_vue_.BButton, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol,
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormCheckbox: form_vue_.KFormCheckbox, KFormCheckboxGroup: form_vue_.KFormCheckboxGroup, KFormSelect: form_vue_.KFormSelect
            },
            directives: {
                'b-toggle': external_bootstrap_vue_.VBToggle
            }
        })
    ], UsersForm);
    return UsersForm;
}(lib/* Vue */.lD));
/* harmony default export */ var UsersFormvue_type_script_lang_ts_external = (UsersForm);

;// ./src/components/UsersForm/UsersForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var UsersForm_UsersFormvue_type_script_lang_ts_external = (UsersFormvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/UsersForm/UsersForm.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  UsersForm_UsersFormvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var UsersForm_UsersForm = (component.exports);

/***/ }),

/***/ 304:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhTw = moment.defineLocale('zh-tw', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhTw;

})));


/***/ }),

/***/ 306:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0
//! author : Sashko Todorov : https://github.com/bkyceh

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mk = moment.defineLocale('mk', {
        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Денес во] LT',
            nextDay: '[Утре во] LT',
            nextWeek: '[Во] dddd [во] LT',
            lastDay: '[Вчера во] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Изминатата] dddd [во] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Изминатиот] dddd [во] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пред %s',
            s: 'неколку секунди',
            ss: '%d секунди',
            m: 'една минута',
            mm: '%d минути',
            h: 'еден час',
            hh: '%d часа',
            d: 'еден ден',
            dd: '%d дена',
            M: 'еден месец',
            MM: '%d месеци',
            y: 'една година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return mk;

})));


/***/ }),

/***/ 317:
/***/ (function(module) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ 346:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 361:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 392:
/***/ (function(module) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ UsersList_UsersList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UsersList/UsersList.vue?vue&type=template&id=2d58e8fe
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex-table"},[_c('PageHeader',{attrs:{"pageTitle":_vm.$t('interface.pageTitle.users'),"buttons":_vm.headerButtons}}),(_vm.$kwInterface.appMessages)?_c('AppMessages'):_vm._e(),(_vm.loading)?_c('Spinner'):_c('k-table',{ref:"table",attrs:{"url":"/team/user","ajaxDatas":{ include: 'permissions,roles,team_users' },"columns":_vm.columns,"filters":_vm.filters,"onlyTopFilters":"","rowActions":_vm.rowActions,"rowClick":_vm.editUser,"stateKey":"teamUsers"}}),_c(_vm.formComponent,{tag:"component",attrs:{"show":_vm.edited !== null},on:{"canceled":function($event){_vm.edited = null; _vm.editedIndex = null},"updated":_vm.userUpdated},model:{value:(_vm.edited),callback:function ($$v) {_vm.edited=$$v},expression:"edited"}}),_c('UsersDelete',{on:{"deleted":_vm.deleted},model:{value:(_vm.toDeleteUser),callback:function ($$v) {_vm.toDeleteUser=$$v},expression:"toDeleteUser"}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__(1146);
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(8399);
// EXTERNAL MODULE: ./src/components/PageHeader/PageHeader.vue + 3 modules
var PageHeader = __webpack_require__(6124);
// EXTERNAL MODULE: ./src/components/UsersForm/UsersForm.vue + 3 modules
var UsersForm = __webpack_require__(303);
// EXTERNAL MODULE: ./src/components/UsersDelete/UsersDelete.vue + 3 modules
var UsersDelete = __webpack_require__(994);
// EXTERNAL MODULE: ./src/components/Spinner/Spinner.vue + 3 modules
var Spinner = __webpack_require__(683);
// EXTERNAL MODULE: ./src/components/AppMessages/AppMessages.vue + 3 modules
var AppMessages = __webpack_require__(3808);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/UsersList/UsersList.ts?vue&type=script&lang=ts&external










var UsersList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(UsersList, _super);
    function UsersList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.edited = null;
        _this.editedIndex = null;
        _this.toDeleteUser = null;
        _this.deleteIndex = null;
        _this.loading = false;
        return _this;
    }
    UsersList.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadUserRoles()];
                    case 1:
                        _a.sent();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(UsersList.prototype, "formComponent", {
        get: function () {
            var _a;
            return (_a = this.$kwInterface.teamUserComponent) !== null && _a !== void 0 ? _a : UsersForm/* default */.A;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UsersList.prototype, "rowActions", {
        get: function () {
            var _this = this;
            return [
                {
                    icon: 'edit',
                    click: this.editUser
                },
                {
                    icon: 'delete',
                    condition: function (teamUser) { return teamUser.user_id !== _this.user.id; },
                    click: function (teamUser, index) {
                        _this.toDelete(teamUser, index);
                    }
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UsersList.prototype, "columns", {
        // Table columns
        get: function () {
            var _this = this;
            return [
                {
                    data: 'fullname',
                    name: this.$t('interface.users.list.fullname')
                },
                {
                    data: 'email',
                    name: this.$t('interface.users.list.email')
                },
                {
                    data: 'roles',
                    name: this.$t('interface.users.list.roles'),
                    render: 'array'
                },
                {
                    data: 'last_connexion',
                    name: this.$t('interface.users.list.lastConnexion'),
                    render: 'datetime'
                },
                {
                    data: 'created_at',
                    name: this.$t('interface.list.createdAt'),
                    render: 'datetime',
                    visible: false
                },
                {
                    data: 'updated_at',
                    name: this.$t('interface.list.updatedAt'),
                    render: 'datetime',
                    visible: false
                },
                {
                    data: 'status.name',
                    name: this.$t('interface.users.list.status'),
                    render: function (data, row) {
                        if (row.invitation) {
                            if (row.invitation.refused_at) {
                                return _this.$t('interface.users.invitation.refused');
                            }
                            else if (external_moment_default()(row.invitation.expire_at).isBefore()) {
                                return _this.$t('interface.users.invitation.expired');
                            }
                            else {
                                return _this.$t('interface.users.invitation.wait');
                            }
                        }
                        return data;
                    }
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UsersList.prototype, "filters", {
        // Table filters
        get: function () {
            return [
                {
                    type: 'select',
                    label: this.$t('interface.activeStatus.label'),
                    name: 'status',
                    options: [
                        { value: 1, label: this.$t('interface.activeStatus.on') },
                        { value: 0, label: this.$t('interface.activeStatus.off') },
                        { value: 2, label: this.$t('interface.users.list.withInvitation') }
                    ],
                    optionLabel: 'label',
                    value: 'value'
                },
                {
                    type: 'select',
                    label: this.$t('interface.users.list.roles'),
                    name: 'roles',
                    options: this.userRoles,
                    multiple: true,
                    optionLabel: 'name',
                    value: 'key'
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UsersList.prototype, "headerButtons", {
        // Page header buttons
        get: function () {
            var _this = this;
            return [
                {
                    label: this.$t('interface.users.newLabel'),
                    click: function () { return (0,tslib_es6/* __awaiter */.sH)(_this, void 0, void 0, function () {
                        var check, _a;
                        return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    check = this.$kwInterface.canCreateUser;
                                    _a = check === undefined;
                                    if (_a) return [3 /*break*/, 2];
                                    return [4 /*yield*/, check(this.$kwInterface.store)];
                                case 1:
                                    _a = (_b.sent());
                                    _b.label = 2;
                                case 2:
                                    if (_a) {
                                        this.edited = {};
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); }
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    // Open team user form
    UsersList.prototype.editUser = function (teamUser, rowIndex) {
        this.edited = teamUser;
        this.editedIndex = rowIndex;
    };
    // Update or insert a team user in table
    UsersList.prototype.userUpdated = function (teamUser) {
        var table = this.$refs.table;
        if (this.editedIndex !== null) {
            table.updateRow(this.editedIndex, teamUser);
            this.editedIndex = null;
        }
        else {
            table.addRow(teamUser);
        }
        this.edited = null;
    };
    // Ask to delete a team user
    UsersList.prototype.toDelete = function (teamUser, index) {
        this.toDeleteUser = teamUser;
        this.deleteIndex = index;
    };
    // A team user is deleted
    UsersList.prototype.deleted = function () {
        if (this.deleteIndex !== null) {
            var table = this.$refs.table;
            table.deleteRow(this.deleteIndex);
            this.deleteIndex = null;
            this.toDeleteUser = null;
        }
    };
    UsersList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('globalDatas', ['userRoles'])), (0,external_vuex_.mapState)('user', ['user'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadUserRoles'])),
            components: {
                PageHeader: PageHeader/* default */.A,
                UsersForm: UsersForm/* default */.A,
                UsersDelete: UsersDelete/* default */.A,
                Spinner: Spinner/* default */.A,
                AppMessages: AppMessages/* default */.A,
                KTable: table_vue_.KTable
            }
        })
    ], UsersList);
    return UsersList;
}(lib/* Vue */.lD));
/* harmony default export */ var UsersListvue_type_script_lang_ts_external = (UsersList);

;// ./src/components/UsersList/UsersList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var UsersList_UsersListvue_type_script_lang_ts_external = (UsersListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/UsersList/UsersList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  UsersList_UsersListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var UsersList_UsersList = (component.exports);

/***/ }),

/***/ 527:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersPast =
            'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
                ' '
            ),
        numbersFuture = [
            'nolla',
            'yhden',
            'kahden',
            'kolmen',
            'neljän',
            'viiden',
            'kuuden',
            numbersPast[7],
            numbersPast[8],
            numbersPast[9],
        ];
    function translate(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                result = isFuture ? 'sekunnin' : 'sekuntia';
                break;
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10
            ? isFuture
                ? numbersFuture[number]
                : numbersPast[number]
            : number;
    }

    var fi = moment.defineLocale('fi', {
        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
            '_'
        ),
        monthsShort:
            'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
                '_'
            ),
        weekdays:
            'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
                '_'
            ),
        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM[ta] YYYY',
            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l: 'D.M.YYYY',
            ll: 'Do MMM YYYY',
            lll: 'Do MMM YYYY, [klo] HH.mm',
            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
        },
        calendar: {
            sameDay: '[tänään] [klo] LT',
            nextDay: '[huomenna] [klo] LT',
            nextWeek: 'dddd [klo] LT',
            lastDay: '[eilen] [klo] LT',
            lastWeek: '[viime] dddd[na] [klo] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s päästä',
            past: '%s sitten',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fi;

})));


/***/ }),

/***/ 583:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseProperty = __webpack_require__(7237),
    basePropertyDeep = __webpack_require__(7255),
    isKey = __webpack_require__(8586),
    toKey = __webpack_require__(7797);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),

/***/ 593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ Password_Password; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Password/Password.vue?vue&type=template&id=47b40274
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-form-group',{staticClass:"password-field",attrs:{"label":_vm.passwordLabel}},[_c('b-input-group',[_c('k-form-input',{attrs:{"type":_vm.showPassword ? 'text' : 'password',"name":"password","required":"","requiredIndicator":false},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_c('b-input-group-append',{on:{"click":function($event){$event.preventDefault();_vm.showPassword = !_vm.showPassword}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', _vm.showPassword ? 'eye' : 'eye-slash']}})],1)],1),_c('div',{staticClass:"password-indicators mt-2"},[_c('div',{staticClass:"password-indicator"},[_c('div',{class:{
              indicator: true,
              valid: _vm.hasLowercaseLetter
            }},[_c('font-awesome-icon',{attrs:{"icon":['fas', _vm.hasLowercaseLetter ? 'check' : 'times']}})],1),_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('interface.password.minLetter')))])]),_c('div',{staticClass:"password-indicator"},[_c('div',{class:{
              indicator: true,
              valid: _vm.hasUppercaseLetter
            }},[_c('font-awesome-icon',{attrs:{"icon":['fas', _vm.hasUppercaseLetter ? 'check' : 'times']}})],1),_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('interface.password.minUppercase')))])]),_c('div',{staticClass:"password-indicator"},[_c('div',{class:{
              indicator: true,
              valid: _vm.hasNumber
            }},[_c('font-awesome-icon',{attrs:{"icon":['fas', _vm.hasNumber ? 'check' : 'times']}})],1),_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('interface.password.minNumber')))])]),_c('div',{staticClass:"password-indicator"},[_c('div',{class:{
              indicator: true,
              valid: _vm.hasSpecialCaracters
            }},[_c('font-awesome-icon',{attrs:{"icon":['fas', _vm.hasSpecialCaracters ? 'check' : 'times']}})],1),_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('interface.password.minSpecial')))])]),_c('div',{staticClass:"password-indicator"},[_c('div',{class:{
              indicator: true,
              valid: _vm.hasMin8
            }},[_c('font-awesome-icon',{attrs:{"icon":['fas', _vm.hasMin8 ? 'check' : 'times']}})],1),_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('interface.password.minLength')))])])])],1),(_vm.confirmPassword !== false)?_c('b-form-group',{staticClass:"password-field",attrs:{"label":_vm.confirmPasswordLabel}},[_c('b-input-group',[_c('k-form-input',{attrs:{"type":_vm.showPasswordConfirm ? 'text' : 'password',"name":"password_confirmation","required":"","requiredIndicator":false,"automaticRules":false,"validate":{
              sameValue: {
                attribute: 'password',
                message: _vm.$t('interface.user.passwordNotEquals')
              }
            }}}),_c('b-input-group-append',{on:{"click":function($event){$event.preventDefault();_vm.showPasswordConfirm = !_vm.showPasswordConfirm}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', _vm.showPasswordConfirm ? 'eye' : 'eye-slash']}})],1)],1)],1):_vm._e()],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(622);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(9356);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Password/Password.ts?vue&type=script&lang=ts&external






var Password = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(Password, _super);
    function Password() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showPassword = false;
        _this.showPasswordConfirm = false;
        _this.password = '';
        return _this;
    }
    Object.defineProperty(Password.prototype, "passwordLabel", {
        get: function () {
            var _a;
            return (_a = this.label) !== null && _a !== void 0 ? _a : this.$t('interface.user.newPassword');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Password.prototype, "confirmPasswordLabel", {
        get: function () {
            var _a;
            return (_a = this.confirmLabel) !== null && _a !== void 0 ? _a : this.$t('interface.user.confirmPassword');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Password.prototype, "hasLowercaseLetter", {
        get: function () {
            return this.password.match(/.*[a-z].*/) !== null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Password.prototype, "hasUppercaseLetter", {
        get: function () {
            return this.password.match(/.*[A-Z].*/) !== null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Password.prototype, "hasSpecialCaracters", {
        get: function () {
            return this.password.match(/.*[,;:=+_()#?!@$%^&*-].*/) !== null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Password.prototype, "hasNumber", {
        get: function () {
            return this.password.match(/.*[0-9].*/) !== null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Password.prototype, "hasMin8", {
        get: function () {
            return this.password.match(/.*.{8,}.*/) !== null;
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], Password.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], Password.prototype, "confirmLabel", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: true })
    ], Password.prototype, "confirmPassword", void 0);
    Password = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: { BInputGroup: external_bootstrap_vue_.BInputGroup, BInputGroupAppend: external_bootstrap_vue_.BInputGroupAppend, FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon, KFormInput: form_vue_.KFormInput, BFormGroup: external_bootstrap_vue_.BFormGroup }
        })
    ], Password);
    return Password;
}((external_vue_default())));
/* harmony default export */ var Passwordvue_type_script_lang_ts_external = (Password);

;// ./src/components/Password/Password.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var Password_Passwordvue_type_script_lang_ts_external = (Passwordvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/Password/Password.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  Password_Passwordvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Password_Password = (component.exports);

/***/ }),

/***/ 609:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner
//! author : Peter Viszt  : https://github.com/passatgt

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var weekEndings =
        'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
    function translate(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch (key) {
            case 's':
                return isFuture || withoutSuffix
                    ? 'néhány másodperc'
                    : 'néhány másodperce';
            case 'ss':
                return num + (isFuture || withoutSuffix)
                    ? ' másodperc'
                    : ' másodperce';
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (
            (isFuture ? '' : '[múlt] ') +
            '[' +
            weekEndings[this.day()] +
            '] LT[-kor]'
        );
    }

    var hu = moment.defineLocale('hu', {
        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY. MMMM D.',
            LLL: 'YYYY. MMMM D. H:mm',
            LLLL: 'YYYY. MMMM D., dddd H:mm',
        },
        meridiemParse: /de|du/i,
        isPM: function (input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar: {
            sameDay: '[ma] LT[-kor]',
            nextDay: '[holnap] LT[-kor]',
            nextWeek: function () {
                return week.call(this, true);
            },
            lastDay: '[tegnap] LT[-kor]',
            lastWeek: function () {
                return week.call(this, false);
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s múlva',
            past: '%s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return hu;

})));


/***/ }),

/***/ 622:
/***/ (function(module) {

"use strict";
module.exports = require("vue");

/***/ }),

/***/ 631:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseHasIn = __webpack_require__(8077),
    hasPath = __webpack_require__(9326);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),

/***/ 641:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFor = __webpack_require__(6649),
    keys = __webpack_require__(5950);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),

/***/ 659:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(1873);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ Spinner_Spinner; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Spinner/Spinner.vue?vue&type=template&id=53a75352
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"spinner-component loading",style:({ 'font-size': _vm.computedSize })},[_c('font-awesome-icon',{attrs:{"icon":['fad', 'spinner-third'],"spin":""}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(9356);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Spinner/Spinner.ts?vue&type=script&lang=ts&external



var Spinner = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(Spinner, _super);
    function Spinner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Spinner.prototype, "computedSize", {
        get: function () {
            var size = String(this.size);
            if (!isNaN(Number(this.size))) {
                size += 'rem';
            }
            return size;
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: '3rem' })
    ], Spinner.prototype, "size", void 0);
    Spinner = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            }
        })
    ], Spinner);
    return Spinner;
}(lib/* Vue */.lD));
/* harmony default export */ var Spinnervue_type_script_lang_ts_external = (Spinner);

;// ./src/components/Spinner/Spinner.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var Spinner_Spinnervue_type_script_lang_ts_external = (Spinnervue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/Spinner/Spinner.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  Spinner_Spinnervue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Spinner_Spinner = (component.exports);

/***/ }),

/***/ 684:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ptBr = moment.defineLocale('pt-br', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays:
            'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
                '_'
            ),
        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'poucos segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        invalidDate: 'Data inválida',
    });

    return ptBr;

})));


/***/ }),

/***/ 689:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getAllKeys = __webpack_require__(2);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ 695:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(8096),
    isArguments = __webpack_require__(2428),
    isArray = __webpack_require__(6449),
    isBuffer = __webpack_require__(3656),
    isIndex = __webpack_require__(361),
    isTypedArray = __webpack_require__(7167);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 708:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'ޖެނުއަރީ',
            'ފެބްރުއަރީ',
            'މާރިޗު',
            'އޭޕްރީލު',
            'މޭ',
            'ޖޫން',
            'ޖުލައި',
            'އޯގަސްޓު',
            'ސެޕްޓެމްބަރު',
            'އޮކްޓޯބަރު',
            'ނޮވެމްބަރު',
            'ޑިސެމްބަރު',
        ],
        weekdays = [
            'އާދިއްތަ',
            'ހޯމަ',
            'އަންގާރަ',
            'ބުދަ',
            'ބުރާސްފަތި',
            'ހުކުރު',
            'ހޮނިހިރު',
        ];

    var dv = moment.defineLocale('dv', {
        months: months,
        monthsShort: months,
        weekdays: weekdays,
        weekdaysShort: weekdays,
        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/M/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /މކ|މފ/,
        isPM: function (input) {
            return 'މފ' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'މކ';
            } else {
                return 'މފ';
            }
        },
        calendar: {
            sameDay: '[މިއަދު] LT',
            nextDay: '[މާދަމާ] LT',
            nextWeek: 'dddd LT',
            lastDay: '[އިއްޔެ] LT',
            lastWeek: '[ފާއިތުވި] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ތެރޭގައި %s',
            past: 'ކުރިން %s',
            s: 'ސިކުންތުކޮޅެއް',
            ss: 'd% ސިކުންތު',
            m: 'މިނިޓެއް',
            mm: 'މިނިޓު %d',
            h: 'ގަޑިއިރެއް',
            hh: 'ގަޑިއިރު %d',
            d: 'ދުވަހެއް',
            dd: 'ދުވަސް %d',
            M: 'މަހެއް',
            MM: 'މަސް %d',
            y: 'އަހަރެއް',
            yy: 'އަހަރު %d',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 7, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return dv;

})));


/***/ }),

/***/ 726:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'search';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f002';
var svgPathData = 'M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.Mj = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 748:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sw = moment.defineLocale('sw', {
        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays:
            'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
                '_'
            ),
        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'hh:mm A',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[leo saa] LT',
            nextDay: '[kesho saa] LT',
            nextWeek: '[wiki ijayo] dddd [saat] LT',
            lastDay: '[jana] LT',
            lastWeek: '[wiki iliyopita] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s baadaye',
            past: 'tokea %s',
            s: 'hivi punde',
            ss: 'sekunde %d',
            m: 'dakika moja',
            mm: 'dakika %d',
            h: 'saa limoja',
            hh: 'masaa %d',
            d: 'siku moja',
            dd: 'siku %d',
            M: 'mwezi mmoja',
            MM: 'miezi %d',
            y: 'mwaka mmoja',
            yy: 'miaka %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sw;

})));


/***/ }),

/***/ 756:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(3805);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),

/***/ 768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ NotificationsConfig_NotificationsConfig; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/NotificationsConfig/NotificationsConfig.vue?vue&type=template&id=1cf633ba
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){$event.preventDefault();_vm.modal = true}}},[_vm._v(" "+_vm._s(_vm.$t('interface.configuration'))+" ")]),_c('FormModal',{attrs:{"title":_vm.$t('interface.notifications.modalTitle'),"size":"lg","scrollable":""},on:{"submitComplete":_vm.submitComplete},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('k-form',{attrs:{"action":"/user?with_file=1","method":"PUT"}},[_c('b-form-group',{attrs:{"label":_vm.$t('interface.notifications.receiveActivityOf')}},[_c('b-form-radio-group',{attrs:{"name":"team_user_configs[notifications_all_users]","stacked":""},model:{value:(_vm.config.notifications_all_users),callback:function ($$v) {_vm.$set(_vm.config, "notifications_all_users", $$v)},expression:"config.notifications_all_users"}},[_c('b-form-radio',{attrs:{"value":true}},[_vm._v(" "+_vm._s(_vm.$t('interface.notifications.receiveActivityAll'))+" ")]),_c('b-form-radio',{staticClass:"mt-1",attrs:{"value":false}},[_vm._v(" "+_vm._s(_vm.$t('interface.notifications.receiveActivityUsers'))+" ")])],1),_c('TeamUserSelect',{staticClass:"mt-2",attrs:{"disabled":_vm.config.notifications_all_users,"multiple":"","filter":val => val.id !== _vm.teamUser.id,"reduce":opt => opt.id},model:{value:(_vm.teamUsers),callback:function ($$v) {_vm.teamUsers=$$v},expression:"teamUsers"}}),(_vm.teamUsers.length === 0)?_c('input',{attrs:{"type":"hidden","name":"team_user_configs[notifications_users]"},domProps:{"value":null}}):_vm._l((_vm.teamUsers),function(user,i){return _c('input',{key:i,attrs:{"name":"team_user_configs[notifications_users][]","type":"hidden"},domProps:{"value":user}})})],2),_c('k-form-checkbox',{model:{value:(_vm.config.notifications_only_my_user),callback:function ($$v) {_vm.$set(_vm.config, "notifications_only_my_user", $$v)},expression:"config.notifications_only_my_user"}},[_vm._v(" "+_vm._s(_vm.$t('interface.notifications.receiveOnlyMyUser'))+" "),_c('div',{staticClass:"small"},[_vm._v(" "+_vm._s(_vm.$t('interface.notifications.receiveOnlyMyUserExplain'))+" ")])]),_c('input',{attrs:{"type":"hidden","name":"team_user_configs[notifications_only_my_user]"},domProps:{"value":_vm.config.notifications_only_my_user ?? false}}),(_vm.types && _vm.types.length > 0)?[_c('h3',{staticClass:"form-title-alt"},[_vm._v(" "+_vm._s(_vm.$t('interface.notifications.eventToReceive'))+" ")]),_c('b-row',_vm._l((_vm.types),function(type,i){return _c('b-col',{key:i,attrs:{"cols":"6"}},[_c('b-form-group',{staticClass:"notification-element-group mb-4",scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('k-form-checkbox',{staticClass:"d-inline-block mr-1",attrs:{"noLabel":"","indeterminate":_vm.groupStatus[type.key] === null},on:{"input":state => _vm.updateGroup(type, state)},model:{value:(_vm.groupStatus[type.key]),callback:function ($$v) {_vm.$set(_vm.groupStatus, type.key, $$v)},expression:"groupStatus[type.key]"}}),_vm._v(" "+_vm._s(type.label)+" ")]},proxy:true}],null,true)},[_c('k-form-checkbox-group',{attrs:{"name":"team_user_configs[notifications_elements][]","stacked":""},model:{value:(_vm.config.notifications_elements),callback:function ($$v) {_vm.$set(_vm.config, "notifications_elements", $$v)},expression:"config.notifications_elements"}},_vm._l((type.actions),function(action,i){return _c('k-form-checkbox',{key:i,attrs:{"value":type.key + '.' + action.key},on:{"input":function($event){return _vm.actionUpdated(type)}}},[_vm._v(" "+_vm._s(action.label)+" ")])}),1)],1)],1)}),1)]:_vm._e()],2)],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: ./src/components/FormModal/FormModal.vue + 2 modules
var FormModal = __webpack_require__(7401);
// EXTERNAL MODULE: ./src/components/TeamUserSelect/TeamUserSelect.vue + 3 modules
var TeamUserSelect = __webpack_require__(2735);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/NotificationsConfig/NotificationsConfig.ts?vue&type=script&lang=ts&external







var NotificationsConfig = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(NotificationsConfig, _super);
    function NotificationsConfig() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modal = false;
        _this.config = {};
        _this.teamUsers = [];
        _this.groupStatus = {};
        _this.groupUpdating = false;
        return _this;
    }
    NotificationsConfig.prototype.watchTeamUser = function () {
        var _this = this;
        var _a;
        this.config = JSON.parse(JSON.stringify(this.teamUser.configs));
        this.teamUsers = ((_a = this.config.notifications_users) !== null && _a !== void 0 ? _a : []).map(function (user) { return user.id; });
        this.types.forEach(function (type) {
            _this.setGroupStatus(type);
        });
    };
    NotificationsConfig.prototype.actionUpdated = function (element) {
        if (this.groupUpdating) {
            return;
        }
        this.setGroupStatus(element);
    };
    NotificationsConfig.prototype.setGroupStatus = function (element) {
        var _this = this;
        this.groupUpdating = true;
        var checked = true;
        var nbchecked = 0;
        var elements = this.config.notifications_elements;
        element.actions.forEach(function (action) {
            var key = element.key + '.' + action.key;
            if (!elements.includes(key)) {
                checked = false;
            }
            else {
                nbchecked++;
            }
        });
        lib/* Vue */.lD.set(this.groupStatus, element.key, !checked && nbchecked > 0 ? null : checked);
        this.$nextTick(function () {
            _this.groupUpdating = false;
        });
    };
    Object.defineProperty(NotificationsConfig.prototype, "types", {
        get: function () {
            var _a, _b, _c;
            return ((_c = (_b = (_a = this.$kwInterface) === null || _a === void 0 ? void 0 : _a.notifications) === null || _b === void 0 ? void 0 : _b.elements(this.$kwInterface.i18n)) !== null && _c !== void 0 ? _c : [])
                .sort(function (a, b) {
                if (a.label < b.label)
                    return -1;
                else if (a.label > b.label)
                    return 1;
                else
                    return 0;
            });
        },
        enumerable: false,
        configurable: true
    });
    NotificationsConfig.prototype.submitComplete = function (response) {
        this.setUser(response.data);
    };
    NotificationsConfig.prototype.updateGroup = function (element, state) {
        var _this = this;
        if (this.groupUpdating) {
            return;
        }
        element.actions.forEach(function (action) {
            var key = element.key + '.' + action.key;
            var index = _this.config.notifications_elements.indexOf(key);
            if (index === -1 && state) {
                _this.config.notifications_elements.push(key);
            }
            else if (index >= 0 && !state) {
                lib/* Vue */.lD.delete(_this.config.notifications_elements, index);
            }
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('teamUser', { deep: true, immediate: true })
    ], NotificationsConfig.prototype, "watchTeamUser", null);
    NotificationsConfig = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BButton: external_bootstrap_vue_.BButton, BFormGroup: external_bootstrap_vue_.BFormGroup, BFormRadio: external_bootstrap_vue_.BFormRadio, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup,
                FormModal: FormModal/* default */.A, TeamUserSelect: TeamUserSelect/* default */.A,
                KForm: form_vue_.KForm, KFormCheckbox: form_vue_.KFormCheckbox, KFormCheckboxGroup: form_vue_.KFormCheckboxGroup
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['teamUser'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('user', ['setUser']))
        })
    ], NotificationsConfig);
    return NotificationsConfig;
}(lib/* Vue */.lD));
/* harmony default export */ var NotificationsConfigvue_type_script_lang_ts_external = (NotificationsConfig);

;// ./src/components/NotificationsConfig/NotificationsConfig.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var NotificationsConfig_NotificationsConfigvue_type_script_lang_ts_external = (NotificationsConfigvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/NotificationsConfig/NotificationsConfig.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  NotificationsConfig_NotificationsConfigvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var NotificationsConfig_NotificationsConfig = (component.exports);

/***/ }),

/***/ 776:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(756),
    keys = __webpack_require__(5950);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),

/***/ 828:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var deburrLetter = __webpack_require__(4647),
    toString = __webpack_require__(3222);

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

/** Used to compose unicode capture groups. */
var rsCombo = '[' + rsComboRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

module.exports = deburr;


/***/ }),

/***/ 838:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esDo = moment.defineLocale('es-do', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return esDo;

})));


/***/ }),

/***/ 848:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ AppMessage_AppMessage; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AppMessage/AppMessage.vue?vue&type=template&id=a7d4d9d4
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-alert',{staticClass:"mb-2 app-message",attrs:{"show":"","variant":_vm.themeClass,"dismissible":_vm.canHide},on:{"dismissed":_vm.hide}},[(_vm.value.icon)?_c('div',{staticClass:"app-message-icon",style:({ 'font-size': _vm.value.icon_size })},[_c('font-awesome-icon',{attrs:{"icon":_vm.value.icon}})],1):_vm._e(),_c('div',{staticClass:"app-message-body"},[(_vm.value.title)?_c('h5',{staticClass:"alert-heading"},[_vm._v(" "+_vm._s(_vm.value.title)+" ")]):_vm._e(),_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.value.content)}}),(_vm.value.links)?_c('ul',_vm._l((_vm.value.links),function(link,i){return _c('li',{key:i},[_c('b-button',_vm._g(_vm._b({attrs:{"variant":"link"}},'b-button',_vm.btnAttributes(link),false),_vm.btnAction(link)),[_vm._v(" "+_vm._s(link.label)+" ")])],1)}),0):_vm._e()]),(_vm.value.buttons)?_c('div',{staticClass:"mt-3"},_vm._l((_vm.value.buttons),function(link,i){return _c('b-button',_vm._g(_vm._b({key:i,class:{ outline: link.outline, 'ml-2': i > 0 }},'b-button',_vm.btnAttributes(link),false),_vm.btnAction(link)),[_vm._v(" "+_vm._s(link.label)+" ")])}),1):_vm._e()])])
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(9356);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: ./node_modules/lodash/forEach.js
var forEach = __webpack_require__(9754);
var forEach_default = /*#__PURE__*/__webpack_require__.n(forEach);
// EXTERNAL MODULE: ./src/mitt.ts + 1 modules
var mitt = __webpack_require__(6912);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/AppMessage/AppMessage.ts?vue&type=script&lang=ts&external







var AppMessage = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(AppMessage, _super);
    function AppMessage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(AppMessage.prototype, "themeClass", {
        get: function () {
            var _a;
            return (_a = this.value.theme) !== null && _a !== void 0 ? _a : this.theme;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AppMessage.prototype, "canHide", {
        get: function () {
            return 'can_hide' in this.value ? this.value.can_hide === true : this.dismissible !== false;
        },
        enumerable: false,
        configurable: true
    });
    AppMessage.prototype.getRouteLink = function (route) {
        var link = route;
        forEach_default()(this.$route.params, function (value, key) {
            link = link.replace('{' + key + '}', value);
        });
        return link;
    };
    AppMessage.prototype.btnAttributes = function (link) {
        var _a;
        var attributes = {};
        if (link.url) {
            attributes.href = link.url;
            attributes.target = (_a = link.target) !== null && _a !== void 0 ? _a : null;
        }
        else if (link.route) {
            attributes.to = this.getRouteLink(link.route);
        }
        return attributes;
    };
    AppMessage.prototype.btnAction = function (link) {
        var _this = this;
        var events = {};
        if (link.hide) {
            events.click = function () { return _this.hide(); };
        }
        else if (link.emit) {
            events.click = function () { return _this.$emit(link.emit); };
        }
        else if (link.emitter) {
            events.click = function () { return mitt/* default */.A.emit(link.emitter); };
        }
        return events;
    };
    AppMessage.prototype.hide = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.hideAppMessage(this.value.id);
                        return [4 /*yield*/, this.$kwInterface.axios.delete('/app/message/' + this.value.id)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], AppMessage.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'purple' })
    ], AppMessage.prototype, "theme", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: true })
    ], AppMessage.prototype, "dismissible", void 0);
    AppMessage = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                BButton: external_bootstrap_vue_.BButton, BAlert: external_bootstrap_vue_.BAlert
            },
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('user', ['hideAppMessage']))
        })
    ], AppMessage);
    return AppMessage;
}(lib/* Vue */.lD));
/* harmony default export */ var AppMessagevue_type_script_lang_ts_external = (AppMessage);

;// ./src/components/AppMessage/AppMessage.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var AppMessage_AppMessagevue_type_script_lang_ts_external = (AppMessagevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/AppMessage/AppMessage.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  AppMessage_AppMessagevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AppMessage_AppMessage = (component.exports);

/***/ }),

/***/ 882:
/***/ (function(module) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),

/***/ 909:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseForOwn = __webpack_require__(641),
    createBaseEach = __webpack_require__(8329);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),

/***/ 935:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'chevron-down';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f078';
var svgPathData = 'M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.Jt = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 938:
/***/ (function(module) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 945:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(79),
    Map = __webpack_require__(8223),
    MapCache = __webpack_require__(3661);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ UsersDelete_UsersDelete; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UsersDelete/UsersDelete.vue?vue&type=template&id=027d3de5
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{attrs:{"title":_vm.$t('interface.deleteConfirmation'),"cancel-title":_vm.$t('interface.cancel'),"ok-title":_vm.$t('interface.delete'),"busy":_vm.loading,"hide-header-close":_vm.loading,"no-close-on-esc":_vm.loading,"no-close-on-backdrop":_vm.loading},on:{"ok":_vm.onOk,"cancel":_vm.onCancel},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('b-overlay',{attrs:{"show":_vm.loading,"rounded":"sm","variant":"white","opacity":.8,"blur":"5px"}},[_vm._v(" "+_vm._s(_vm.$t('interface.users.deleteMsg'))+" ")])],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/UsersDelete/UsersDelete.ts?vue&type=script&lang=ts&external




var UsersDelete = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(UsersDelete, _super);
    function UsersDelete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showModal = false;
        _this.loading = false;
        return _this;
    }
    UsersDelete.prototype.watchValue = function (value) {
        this.value = value;
        this.showModal = value !== null;
    };
    UsersDelete.prototype.onCancel = function () {
        return null;
    };
    UsersDelete.prototype.onOk = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.$kwInterface.axios.delete(this.apiUrl)
                                .then(function () {
                                if (_this.value) {
                                    _this.deleteTeamUser(_this.value);
                                }
                                _this.$emit('deleted');
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(UsersDelete.prototype, "apiUrl", {
        get: function () {
            var _a;
            return '/team/user/' + ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id);
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], UsersDelete.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], UsersDelete.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('input')
    ], UsersDelete.prototype, "onCancel", null);
    UsersDelete = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['deleteTeamUser'])),
            components: {
                BModal: external_bootstrap_vue_.BModal,
                BOverlay: external_bootstrap_vue_.BOverlay
            }
        })
    ], UsersDelete);
    return UsersDelete;
}(lib/* Vue */.lD));
/* harmony default export */ var UsersDeletevue_type_script_lang_ts_external = (UsersDelete);

;// ./src/components/UsersDelete/UsersDelete.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var UsersDelete_UsersDeletevue_type_script_lang_ts_external = (UsersDeletevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/UsersDelete/UsersDelete.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  UsersDelete_UsersDeletevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var UsersDelete_UsersDelete = (component.exports);

/***/ }),

/***/ 999:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseRest = __webpack_require__(9302),
    isIterateeCall = __webpack_require__(6800);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),

/***/ 1011:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sv = moment.defineLocale('sv', {
        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: 'för %s sedan',
            s: 'några sekunder',
            ss: '%d sekunder',
            m: 'en minut',
            mm: '%d minuter',
            h: 'en timme',
            hh: '%d timmar',
            d: 'en dag',
            dd: '%d dagar',
            M: 'en månad',
            MM: '%d månader',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? ':e'
                        : b === 1
                          ? ':a'
                          : b === 2
                            ? ':a'
                            : b === 3
                              ? ':e'
                              : ':e';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sv;

})));


/***/ }),

/***/ 1025:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '௧',
            2: '௨',
            3: '௩',
            4: '௪',
            5: '௫',
            6: '௬',
            7: '௭',
            8: '௮',
            9: '௯',
            0: '௦',
        },
        numberMap = {
            '௧': '1',
            '௨': '2',
            '௩': '3',
            '௪': '4',
            '௫': '5',
            '௬': '6',
            '௭': '7',
            '௮': '8',
            '௯': '9',
            '௦': '0',
        };

    var ta = moment.defineLocale('ta', {
        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
            '_'
        ),
        monthsShort:
            'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
                '_'
            ),
        weekdays:
            'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
                '_'
            ),
        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
            '_'
        ),
        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, HH:mm',
            LLLL: 'dddd, D MMMM YYYY, HH:mm',
        },
        calendar: {
            sameDay: '[இன்று] LT',
            nextDay: '[நாளை] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[நேற்று] LT',
            lastWeek: '[கடந்த வாரம்] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s இல்',
            past: '%s முன்',
            s: 'ஒரு சில விநாடிகள்',
            ss: '%d விநாடிகள்',
            m: 'ஒரு நிமிடம்',
            mm: '%d நிமிடங்கள்',
            h: 'ஒரு மணி நேரம்',
            hh: '%d மணி நேரம்',
            d: 'ஒரு நாள்',
            dd: '%d நாட்கள்',
            M: 'ஒரு மாதம்',
            MM: '%d மாதங்கள்',
            y: 'ஒரு வருடம்',
            yy: '%d ஆண்டுகள்',
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal: function (number) {
            return number + 'வது';
        },
        preparse: function (string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem: function (hour, minute, isLower) {
            if (hour < 2) {
                return ' யாமம்';
            } else if (hour < 6) {
                return ' வைகறை'; // வைகறை
            } else if (hour < 10) {
                return ' காலை'; // காலை
            } else if (hour < 14) {
                return ' நண்பகல்'; // நண்பகல்
            } else if (hour < 18) {
                return ' எற்பாடு'; // எற்பாடு
            } else if (hour < 22) {
                return ' மாலை'; // மாலை
            } else {
                return ' யாமம்';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'யாமம்') {
                return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                return hour;
            } else if (meridiem === 'நண்பகல்') {
                return hour >= 10 ? hour : hour + 12;
            } else {
                return hour + 12;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ta;

})));


/***/ }),

/***/ 1033:
/***/ (function(module) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ 1042:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(6110);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 1052:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

    function translateFuture(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'leS'
                : output.indexOf('jar') !== -1
                  ? time.slice(0, -3) + 'waQ'
                  : output.indexOf('DIS') !== -1
                    ? time.slice(0, -3) + 'nem'
                    : time + ' pIq';
        return time;
    }

    function translatePast(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'Hu’'
                : output.indexOf('jar') !== -1
                  ? time.slice(0, -3) + 'wen'
                  : output.indexOf('DIS') !== -1
                    ? time.slice(0, -3) + 'ben'
                    : time + ' ret';
        return time;
    }

    function translate(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch (string) {
            case 'ss':
                return numberNoun + ' lup';
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }

    function numberAsNoun(number) {
        var hundred = Math.floor((number % 1000) / 100),
            ten = Math.floor((number % 100) / 10),
            one = number % 10,
            word = '';
        if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
        }
        if (ten > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
        }
        if (one > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[one];
        }
        return word === '' ? 'pagh' : word;
    }

    var tlh = moment.defineLocale('tlh', {
        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
            '_'
        ),
        monthsShort:
            'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
            '_'
        ),
        weekdaysShort:
            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysMin:
            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L',
        },
        relativeTime: {
            future: translateFuture,
            past: translatePast,
            s: 'puS lup',
            ss: translate,
            m: 'wa’ tup',
            mm: translate,
            h: 'wa’ rep',
            hh: translate,
            d: 'wa’ jaj',
            dd: translate,
            M: 'wa’ jar',
            MM: translate,
            y: 'wa’ DIS',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlh;

})));


/***/ }),

/***/ 1126:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIteratee = __webpack_require__(5389),
    baseSum = __webpack_require__(7721);

/**
 * This method is like `_.sum` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be summed.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the sum.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.sumBy(objects, function(o) { return o.n; });
 * // => 20
 *
 * // The `_.property` iteratee shorthand.
 * _.sumBy(objects, 'n');
 * // => 20
 */
function sumBy(array, iteratee) {
  return (array && array.length)
    ? baseSum(array, baseIteratee(iteratee, 2))
    : 0;
}

module.exports = sumBy;


/***/ }),

/***/ 1135:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk
//! author : Chien Kira : https://github.com/chienkira

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var vi = moment.defineLocale('vi', {
        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
            '_'
        ),
        monthsShort:
            'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
            '_'
        ),
        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /sa|ch/i,
        isPM: function (input) {
            return /^ch$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [năm] YYYY',
            LLL: 'D MMMM [năm] YYYY HH:mm',
            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
            l: 'DD/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần trước lúc] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s tới',
            past: '%s trước',
            s: 'vài giây',
            ss: '%d giây',
            m: 'một phút',
            mm: '%d phút',
            h: 'một giờ',
            hh: '%d giờ',
            d: 'một ngày',
            dd: '%d ngày',
            w: 'một tuần',
            ww: '%d tuần',
            M: 'một tháng',
            MM: '%d tháng',
            y: 'một năm',
            yy: '%d năm',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return vi;

})));


/***/ }),

/***/ 1146:
/***/ (function(module) {

"use strict";
module.exports = require("moment");

/***/ }),

/***/ 1155:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fad';
var iconName = 'file-audio';
var width = 384;
var height = 512;
var ligatures = [];
var unicode = 'f1c7';
var svgPathData = ['M384 128H272a16 16 0 0 1-16-16V0H24A23.94 23.94 0 0 0 0 23.88V488a23.94 23.94 0 0 0 23.88 24H360a23.94 23.94 0 0 0 24-23.88V128zM160 404a12 12 0 0 1-20.5 8.5L104 376H76a12 12 0 0 1-12-12v-56a12 12 0 0 1 12-12h28l35.5-36.48A12 12 0 0 1 160 268zm33.24-51.13a24.05 24.05 0 0 0 0-33.57c-22.08-22.91 12.2-56.48 34.38-33.66a72.64 72.64 0 0 1 0 100.9c-21.78 22.38-56.86-10.48-34.38-33.7zm86.2 83.66c-21.67 22.4-56.66-10.31-34.19-33.52a96.39 96.39 0 0 0 0-133.85c-22-22.81 12.22-56.32 34.19-33.51 54.08 55.87 54.08 144.94 0 200.85z', 'M377 105L279.1 7a24 24 0 0 0-17-7H256v112a16 16 0 0 0 16 16h112v-6.1a23.9 23.9 0 0 0-7-16.9zM148 256a12 12 0 0 0-8.53 3.53L104 296H76a12 12 0 0 0-12 12v56a12 12 0 0 0 12 12h28l35.5 36.48A12 12 0 0 0 160 404V268a12 12 0 0 0-12-12zm79.59 29.61c-22.18-22.82-56.46 10.75-34.38 33.66a24.05 24.05 0 0 1 0 33.57c-22.48 23.22 12.6 56.08 34.38 33.67a72.64 72.64 0 0 0 .03-100.9zm51.82-50c-22-22.81-56.16 10.7-34.19 33.51a96.39 96.39 0 0 1 0 133.85c-22.47 23.21 12.52 55.92 34.19 33.52 54.08-55.91 54.08-145 0-200.88z'];

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.qe = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 1175:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(6025);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 1221:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sindhi [sd]
//! author : Narain Sagar : https://github.com/narainsagar

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوري',
            'فيبروري',
            'مارچ',
            'اپريل',
            'مئي',
            'جون',
            'جولاءِ',
            'آگسٽ',
            'سيپٽمبر',
            'آڪٽوبر',
            'نومبر',
            'ڊسمبر',
        ],
        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];

    var sd = moment.defineLocale('sd', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[اڄ] LT',
            nextDay: '[سڀاڻي] LT',
            nextWeek: 'dddd [اڳين هفتي تي] LT',
            lastDay: '[ڪالهه] LT',
            lastWeek: '[گزريل هفتي] dddd [تي] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s پوء',
            past: '%s اڳ',
            s: 'چند سيڪنڊ',
            ss: '%d سيڪنڊ',
            m: 'هڪ منٽ',
            mm: '%d منٽ',
            h: 'هڪ ڪلاڪ',
            hh: '%d ڪلاڪ',
            d: 'هڪ ڏينهن',
            dd: '%d ڏينهن',
            M: 'هڪ مهينو',
            MM: '%d مهينا',
            y: 'هڪ سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sd;

})));


/***/ }),

/***/ 1256:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'shopping-cart';
var width = 576;
var height = 512;
var ligatures = [];
var unicode = 'f07a';
var svgPathData = 'M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports._R = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 1275:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'bell';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f0f3';
var svgPathData = 'M224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64zm215.39-149.71c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.z$ = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 1290:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    var bn = moment.defineLocale('bn', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort:
            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
                '_'
            ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'রাত' && hour >= 4) ||
                (meridiem === 'দুপুর' && hour < 5) ||
                meridiem === 'বিকাল'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bn;

})));


/***/ }),

/***/ 1300:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fad';
var iconName = 'file-image';
var width = 384;
var height = 512;
var ligatures = [];
var unicode = 'f1c5';
var svgPathData = ['M384 128H272a16 16 0 0 1-16-16V0H24A23.94 23.94 0 0 0 0 23.88V488a23.94 23.94 0 0 0 23.88 24H360a23.94 23.94 0 0 0 24-23.88V128zm-271.46 48a48 48 0 1 1-48 48 48 48 0 0 1 48-48zm208 240h-256l.46-48.48L104.51 328c4.69-4.69 11.8-4.2 16.49.48L160.54 368 264 264.48a12 12 0 0 1 17 0L320.54 304z', 'M377 105L279.1 7a24 24 0 0 0-17-7H256v112a16 16 0 0 0 16 16h112v-6.1a23.9 23.9 0 0 0-7-16.9zM112.54 272a48 48 0 1 0-48-48 48 48 0 0 0 48 48zM264 264.45L160.54 368 121 328.48c-4.69-4.68-11.8-5.17-16.49-.48L65 367.52 64.54 416h256V304L281 264.48a12 12 0 0 0-17-.03z'];

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.xd = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 1305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_ConfigurationView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ConfigurationView.vue?vue&type=template&id=5026ad64
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.component,{tag:"component"})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ConfigurationView.vue?vue&type=script&lang=ts


var ConfigurationView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ConfigurationView, _super);
    function ConfigurationView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ConfigurationView.prototype, "component", {
        get: function () {
            var _a;
            return (_a = this.$kwInterface.configPage) !== null && _a !== void 0 ? _a : 'router-view';
        },
        enumerable: false,
        configurable: true
    });
    ConfigurationView = (0,tslib_es6/* __decorate */.Cg)([
        lib/* Component */.uA
    ], ConfigurationView);
    return ConfigurationView;
}(lib/* Vue */.lD));
/* harmony default export */ var ConfigurationViewvue_type_script_lang_ts = (ConfigurationView);

;// ./src/views/ConfigurationView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_ConfigurationViewvue_type_script_lang_ts = (ConfigurationViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/ConfigurationView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_ConfigurationViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_ConfigurationView = (component.exports);

/***/ }),

/***/ 1306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ EmailVerification_EmailVerification; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/EmailVerification/EmailVerification.vue?vue&type=template&id=c491c664
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('div',[_c('b-alert',{attrs:{"variant":"danger","show":_vm.errorMsg !== null}},[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]),_c('p',{staticClass:"text-center font-weight-bold h5 text-danger"},[_vm._v(" "+_vm._s(_vm.responseMsg)+" ")]),_c('p',{staticClass:"text-center mt-4"},[_c('b-button',{attrs:{"variant":"primary","to":_vm.$kwInterface.goToHome(_vm.$router, _vm.$store)}},[_vm._v(" "+_vm._s(_vm.$t('interface.backToHome'))+" ")])],1)],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: ./src/components/Spinner/Spinner.vue + 3 modules
var Spinner = __webpack_require__(683);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/EmailVerification/EmailVerification.ts?vue&type=script&lang=ts&external




var EmailVerification = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(EmailVerification, _super);
    function EmailVerification() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.responseMsg = null;
        _this.errorMsg = null;
        _this.loading = false;
        return _this;
    }
    EmailVerification.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validEmail()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    EmailVerification.prototype.validEmail = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        this.errorMsg = null;
                        this.responseMsg = null;
                        return [4 /*yield*/, this.$kwInterface.axios.post("/auth/email/verify/" + this.token + "/" + this.hash)
                                .then(function (response) {
                                _this.responseMsg = response.data.message;
                            })
                                .catch(function (error) {
                                if (error.response.status === 404) {
                                    _this.$router.push({ name: 'error-404' });
                                    return;
                                }
                                _this.errorMsg = error.response.data.message;
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], EmailVerification.prototype, "token", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], EmailVerification.prototype, "hash", void 0);
    EmailVerification = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: Spinner/* default */.A,
                BAlert: external_bootstrap_vue_.BAlert, BButton: external_bootstrap_vue_.BButton
            }
        })
    ], EmailVerification);
    return EmailVerification;
}(lib/* Vue */.lD));
/* harmony default export */ var EmailVerificationvue_type_script_lang_ts_external = (EmailVerification);

;// ./src/components/EmailVerification/EmailVerification.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var EmailVerification_EmailVerificationvue_type_script_lang_ts_external = (EmailVerificationvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/EmailVerification/EmailVerification.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  EmailVerification_EmailVerificationvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var EmailVerification_EmailVerification = (component.exports);

/***/ }),

/***/ 1331:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2552),
    getPrototype = __webpack_require__(8879),
    isObjectLike = __webpack_require__(346);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ 1380:
/***/ (function(module) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ 1420:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(79);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 1459:
/***/ (function(module) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ 1470:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            mm: 'munutenn',
            MM: 'miz',
            dd: 'devezh',
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }
    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            m: 'v',
            b: 'v',
            d: 'z',
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    var monthsParse = [
            /^gen/i,
            /^c[ʼ\']hwe/i,
            /^meu/i,
            /^ebr/i,
            /^mae/i,
            /^(mez|eve)/i,
            /^gou/i,
            /^eos/i,
            /^gwe/i,
            /^her/i,
            /^du/i,
            /^ker/i,
        ],
        monthsRegex =
            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        monthsStrictRegex =
            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
        monthsShortStrictRegex =
            /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        fullWeekdaysParse = [
            /^sul/i,
            /^lun/i,
            /^meurzh/i,
            /^merc[ʼ\']her/i,
            /^yaou/i,
            /^gwener/i,
            /^sadorn/i,
        ],
        shortWeekdaysParse = [
            /^Sul/i,
            /^Lun/i,
            /^Meu/i,
            /^Mer/i,
            /^Yao/i,
            /^Gwe/i,
            /^Sad/i,
        ],
        minWeekdaysParse = [
            /^Su/i,
            /^Lu/i,
            /^Me([^r]|$)/i,
            /^Mer/i,
            /^Ya/i,
            /^Gw/i,
            /^Sa/i,
        ];

    var br = moment.defineLocale('br', {
        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
            '_'
        ),
        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParse: minWeekdaysParse,
        fullWeekdaysParse: fullWeekdaysParse,
        shortWeekdaysParse: shortWeekdaysParse,
        minWeekdaysParse: minWeekdaysParse,

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [a viz] MMMM YYYY',
            LLL: 'D [a viz] MMMM YYYY HH:mm',
            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hiziv da] LT',
            nextDay: '[Warcʼhoazh da] LT',
            nextWeek: 'dddd [da] LT',
            lastDay: '[Decʼh da] LT',
            lastWeek: 'dddd [paset da] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'a-benn %s',
            past: '%s ʼzo',
            s: 'un nebeud segondennoù',
            ss: '%d eilenn',
            m: 'ur vunutenn',
            mm: relativeTimeWithMutation,
            h: 'un eur',
            hh: '%d eur',
            d: 'un devezh',
            dd: relativeTimeWithMutation,
            M: 'ur miz',
            MM: relativeTimeWithMutation,
            y: 'ur bloaz',
            yy: specialMutationForYears,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal: function (number) {
            var output = number === 1 ? 'añ' : 'vet';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
        isPM: function (token) {
            return token === 'g.m.';
        },
        meridiem: function (hour, minute, isLower) {
            return hour < 12 ? 'a.m.' : 'g.m.';
        },
    });

    return br;

})));


/***/ }),

/***/ 1488:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Algeria) [ar-dz]
//! author : Amine Roukh: https://github.com/Amine27
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi
//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                  ? 1
                  : n === 2
                    ? 2
                    : n % 100 >= 3 && n % 100 <= 10
                      ? 3
                      : n % 100 >= 11
                        ? 4
                        : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'جانفي',
            'فيفري',
            'مارس',
            'أفريل',
            'ماي',
            'جوان',
            'جويلية',
            'أوت',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arDz = moment.defineLocale('ar-dz', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arDz;

})));


/***/ }),

/***/ 1509:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                  ? 1
                  : n === 2
                    ? 2
                    : n % 100 >= 3 && n % 100 <= 10
                      ? 3
                      : n % 100 >= 11
                        ? 4
                        : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var ar = moment.defineLocale('ar', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ar;

})));


/***/ }),

/***/ 1541:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Macau) [zh-mo]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Tan Yuanhong : https://github.com/le0tan

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhMo = moment.defineLocale('zh-mo', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'D/M/YYYY',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s內',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhMo;

})));


/***/ }),

/***/ 1545:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '༡',
            2: '༢',
            3: '༣',
            4: '༤',
            5: '༥',
            6: '༦',
            7: '༧',
            8: '༨',
            9: '༩',
            0: '༠',
        },
        numberMap = {
            '༡': '1',
            '༢': '2',
            '༣': '3',
            '༤': '4',
            '༥': '5',
            '༦': '6',
            '༧': '7',
            '༨': '8',
            '༩': '9',
            '༠': '0',
        };

    var bo = moment.defineLocale('bo', {
        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
            '_'
        ),
        monthsShort:
            'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
                '_'
            ),
        monthsShortRegex: /^(ཟླ་\d{1,2})/,
        monthsParseExact: true,
        weekdays:
            'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
                '_'
            ),
        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
            '_'
        ),
        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[དི་རིང] LT',
            nextDay: '[སང་ཉིན] LT',
            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay: '[ཁ་སང] LT',
            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ལ་',
            past: '%s སྔན་ལ',
            s: 'ལམ་སང',
            ss: '%d སྐར་ཆ།',
            m: 'སྐར་མ་གཅིག',
            mm: '%d སྐར་མ',
            h: 'ཆུ་ཚོད་གཅིག',
            hh: '%d ཆུ་ཚོད',
            d: 'ཉིན་གཅིག',
            dd: '%d ཉིན་',
            M: 'ཟླ་བ་གཅིག',
            MM: '%d ཟླ་བ',
            y: 'ལོ་གཅིག',
            yy: '%d ལོ',
        },
        preparse: function (string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'མཚན་མོ' && hour >= 4) ||
                (meridiem === 'ཉིན་གུང' && hour < 5) ||
                meridiem === 'དགོང་དག'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'མཚན་མོ';
            } else if (hour < 10) {
                return 'ཞོགས་ཀས';
            } else if (hour < 17) {
                return 'ཉིན་གུང';
            } else if (hour < 20) {
                return 'དགོང་དག';
            } else {
                return 'མཚན་མོ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bo;

})));


/***/ }),

/***/ 1549:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hashClear = __webpack_require__(2032),
    hashDelete = __webpack_require__(3862),
    hashGet = __webpack_require__(6721),
    hashHas = __webpack_require__(2749),
    hashSet = __webpack_require__(5749);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 1632:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd
//! author : Anthony : https://github.com/anthonylau

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhHk = moment.defineLocale('zh-hk', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1200) {
                return '上午';
            } else if (hm === 1200) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: '[下]ddddLT',
            lastDay: '[昨天]LT',
            lastWeek: '[上]ddddLT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhHk;

})));


/***/ }),

/***/ 1635:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   C6: function() { return /* binding */ __extends; },
/* harmony export */   Cg: function() { return /* binding */ __decorate; },
/* harmony export */   Cl: function() { return /* binding */ __assign; },
/* harmony export */   YH: function() { return /* binding */ __generator; },
/* harmony export */   aN: function() { return /* binding */ __spreadArrays; },
/* harmony export */   sH: function() { return /* binding */ __awaiter; }
/* harmony export */ });
/* unused harmony exports __rest, __param, __esDecorate, __runInitializers, __propKey, __setFunctionName, __metadata, __createBinding, __exportStar, __values, __read, __spread, __spreadArray, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault, __classPrivateFieldGet, __classPrivateFieldSet, __classPrivateFieldIn, __addDisposableResource, __disposeResources, __rewriteRelativeImportExtension */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  }
  return __assign.apply(this, arguments);
}

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
  return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
  function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
  var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
  var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
  var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
  var _, done = false;
  for (var i = decorators.length - 1; i >= 0; i--) {
      var context = {};
      for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
      for (var p in contextIn.access) context.access[p] = contextIn.access[p];
      context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
      var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
      if (kind === "accessor") {
          if (result === void 0) continue;
          if (result === null || typeof result !== "object") throw new TypeError("Object expected");
          if (_ = accept(result.get)) descriptor.get = _;
          if (_ = accept(result.set)) descriptor.set = _;
          if (_ = accept(result.init)) initializers.unshift(_);
      }
      else if (_ = accept(result)) {
          if (kind === "field") initializers.unshift(_);
          else descriptor[key] = _;
      }
  }
  if (target) Object.defineProperty(target, contextIn.name, descriptor);
  done = true;
};

function __runInitializers(thisArg, initializers, value) {
  var useValue = arguments.length > 2;
  for (var i = 0; i < initializers.length; i++) {
      value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
  }
  return useValue ? value : void 0;
};

function __propKey(x) {
  return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
  if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
  return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
  }
  Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

function __exportStar(m, o) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
      next: function () {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
      }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  }
  catch (error) { e = { error: error }; }
  finally {
      try {
          if (r && !r.done && (m = i["return"])) m.call(i);
      }
      finally { if (e) throw e.error; }
  }
  return ar;
}

/** @deprecated */
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++)
      ar = ar.concat(__read(arguments[i]));
  return ar;
}

/** @deprecated */
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++)
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
          r[k] = a[j];
  return r;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []), i, q = [];
  return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
  function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
  function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
  function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
  function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
  function fulfill(value) { resume("next", value); }
  function reject(value) { resume("throw", value); }
  function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
  var i, p;
  return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
  function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator], i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
  function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
  function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
  return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
  o["default"] = v;
};

var ownKeys = function(o) {
  ownKeys = Object.getOwnPropertyNames || function (o) {
    var ar = [];
    for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
    return ar;
  };
  return ownKeys(o);
};

function __importStar(mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
  __setModuleDefault(result, mod);
  return result;
}

function __importDefault(mod) {
  return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
  if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
  if (value !== null && value !== void 0) {
    if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
    var dispose, inner;
    if (async) {
      if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
      dispose = value[Symbol.asyncDispose];
    }
    if (dispose === void 0) {
      if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
      dispose = value[Symbol.dispose];
      if (async) inner = dispose;
    }
    if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
    if (inner) dispose = function() { try { inner.call(this); } catch (e) { return Promise.reject(e); } };
    env.stack.push({ value: value, dispose: dispose, async: async });
  }
  else if (async) {
    env.stack.push({ async: true });
  }
  return value;
}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources(env) {
  function fail(e) {
    env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
    env.hasError = true;
  }
  var r, s = 0;
  function next() {
    while (r = env.stack.pop()) {
      try {
        if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
        if (r.dispose) {
          var result = r.dispose.call(r.value);
          if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
        }
        else s |= 1;
      }
      catch (e) {
        fail(e);
      }
    }
    if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
    if (env.hasError) throw env.error;
  }
  return next();
}

function __rewriteRelativeImportExtension(path, preserveJsx) {
  if (typeof path === "string" && /^\.\.?\//.test(path)) {
      return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function (m, tsx, d, ext, cm) {
          return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : (d + ext + "." + cm.toLowerCase() + "js");
      });
  }
  return path;
}

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __esDecorate,
  __runInitializers,
  __propKey,
  __setFunctionName,
  __metadata,
  __awaiter,
  __generator,
  __createBinding,
  __exportStar,
  __values,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet,
  __classPrivateFieldSet,
  __classPrivateFieldIn,
  __addDisposableResource,
  __disposeResources,
  __rewriteRelativeImportExtension,
});


/***/ }),

/***/ 1656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ normalizeComponent; }
/* harmony export */ });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 1658:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'trash';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f1f8';
var svgPathData = 'M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.yL = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 1713:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var he = moment.defineLocale('he', {
        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
            '_'
        ),
        monthsShort:
            'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [ב]MMMM YYYY',
            LLL: 'D [ב]MMMM YYYY HH:mm',
            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
            l: 'D/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[היום ב־]LT',
            nextDay: '[מחר ב־]LT',
            nextWeek: 'dddd [בשעה] LT',
            lastDay: '[אתמול ב־]LT',
            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'בעוד %s',
            past: 'לפני %s',
            s: 'מספר שניות',
            ss: '%d שניות',
            m: 'דקה',
            mm: '%d דקות',
            h: 'שעה',
            hh: function (number) {
                if (number === 2) {
                    return 'שעתיים';
                }
                return number + ' שעות';
            },
            d: 'יום',
            dd: function (number) {
                if (number === 2) {
                    return 'יומיים';
                }
                return number + ' ימים';
            },
            M: 'חודש',
            MM: function (number) {
                if (number === 2) {
                    return 'חודשיים';
                }
                return number + ' חודשים';
            },
            y: 'שנה',
            yy: function (number) {
                if (number === 2) {
                    return 'שנתיים';
                } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                }
                return number + ' שנים';
            },
        },
        meridiemParse:
            /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM: function (input) {
            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 5) {
                return 'לפנות בוקר';
            } else if (hour < 10) {
                return 'בבוקר';
            } else if (hour < 12) {
                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
                return 'בערב';
            }
        },
    });

    return he;

})));


/***/ }),

/***/ 1733:
/***/ (function(module) {

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

module.exports = asciiWords;


/***/ }),

/***/ 1734:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Irish or Irish Gaelic [ga]
//! author : André Silva : https://github.com/askpt

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Eanáir',
            'Feabhra',
            'Márta',
            'Aibreán',
            'Bealtaine',
            'Meitheamh',
            'Iúil',
            'Lúnasa',
            'Meán Fómhair',
            'Deireadh Fómhair',
            'Samhain',
            'Nollaig',
        ],
        monthsShort = [
            'Ean',
            'Feabh',
            'Márt',
            'Aib',
            'Beal',
            'Meith',
            'Iúil',
            'Lún',
            'M.F.',
            'D.F.',
            'Samh',
            'Noll',
        ],
        weekdays = [
            'Dé Domhnaigh',
            'Dé Luain',
            'Dé Máirt',
            'Dé Céadaoin',
            'Déardaoin',
            'Dé hAoine',
            'Dé Sathairn',
        ],
        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];

    var ga = moment.defineLocale('ga', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Inniu ag] LT',
            nextDay: '[Amárach ag] LT',
            nextWeek: 'dddd [ag] LT',
            lastDay: '[Inné ag] LT',
            lastWeek: 'dddd [seo caite] [ag] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i %s',
            past: '%s ó shin',
            s: 'cúpla soicind',
            ss: '%d soicind',
            m: 'nóiméad',
            mm: '%d nóiméad',
            h: 'uair an chloig',
            hh: '%d uair an chloig',
            d: 'lá',
            dd: '%d lá',
            M: 'mí',
            MM: '%d míonna',
            y: 'bliain',
            yy: '%d bliain',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ga;

})));


/***/ }),

/***/ 1765:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzm = moment.defineLocale('tzm', {
        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
            '_'
        ),
        monthsShort:
            'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
                '_'
            ),
        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past: 'ⵢⴰⵏ %s',
            s: 'ⵉⵎⵉⴽ',
            ss: '%d ⵉⵎⵉⴽ',
            m: 'ⵎⵉⵏⵓⴺ',
            mm: '%d ⵎⵉⵏⵓⴺ',
            h: 'ⵙⴰⵄⴰ',
            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d: 'ⴰⵙⵙ',
            dd: '%d oⵙⵙⴰⵏ',
            M: 'ⴰⵢoⵓⵔ',
            MM: '%d ⵉⵢⵢⵉⵔⵏ',
            y: 'ⴰⵙⴳⴰⵙ',
            yy: '%d ⵉⵙⴳⴰⵙⵏ',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzm;

})));


/***/ }),

/***/ 1769:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(6449),
    isKey = __webpack_require__(8586),
    stringToPath = __webpack_require__(1802),
    toString = __webpack_require__(3222);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ 1781:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1635);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9077);
/* harmony import */ var _utils_number__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3757);



var NumberMixin = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__extends */ .C6)(NumberMixin, _super);
    function NumberMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // Return a number
    NumberMixin.prototype.number = function (val) {
        return (0,_utils_number__WEBPACK_IMPORTED_MODULE_1__/* .toNumber */ .Ro)(val);
    };
    // Round a number
    NumberMixin.prototype.roundNumber = function (number, decimal) {
        return (0,_utils_number__WEBPACK_IMPORTED_MODULE_1__/* .round */ .LI)(number, decimal);
    };
    // Show a number
    NumberMixin.prototype.showNumber = function (number, decimal, minDecimal) {
        return (0,_utils_number__WEBPACK_IMPORTED_MODULE_1__/* .showNumber */ .Zo)(number, decimal, minDecimal);
    };
    // Count the number of decimals
    NumberMixin.prototype.countDecimals = function (number) {
        return (0,_utils_number__WEBPACK_IMPORTED_MODULE_1__/* .getNbDecimals */ .hB)(number);
    };
    // Show a formatted number
    NumberMixin.prototype.formattedNumber = function (number, currency) {
        if (currency === void 0) { currency = null; }
        return (0,_utils_number__WEBPACK_IMPORTED_MODULE_1__/* .formatToDisplay */ .jg)(number, currency);
    };
    NumberMixin = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__decorate */ .Cg)([
        vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .uA
    ], NumberMixin);
    return NumberMixin;
}(vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Vue */ .lD));
/* harmony default export */ __webpack_exports__.A = (NumberMixin);


/***/ }),

/***/ 1791:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignValue = __webpack_require__(6547),
    baseAssignValue = __webpack_require__(3360);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ 1794:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/IrakliJani

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ka = moment.defineLocale('ka', {
        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
            '_'
        ),
        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
        weekdays: {
            standalone:
                'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
                    '_'
                ),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
                '_'
            ),
            isFormat: /(წინა|შემდეგ)/,
        },
        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[დღეს] LT[-ზე]',
            nextDay: '[ხვალ] LT[-ზე]',
            lastDay: '[გუშინ] LT[-ზე]',
            nextWeek: '[შემდეგ] dddd LT[-ზე]',
            lastWeek: '[წინა] dddd LT-ზე',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return s.replace(
                    /(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,
                    function ($0, $1, $2) {
                        return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
                    }
                );
            },
            past: function (s) {
                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის წინ');
                }
                if (/წელი/.test(s)) {
                    return s.replace(/წელი$/, 'წლის წინ');
                }
                return s;
            },
            s: 'რამდენიმე წამი',
            ss: '%d წამი',
            m: 'წუთი',
            mm: '%d წუთი',
            h: 'საათი',
            hh: '%d საათი',
            d: 'დღე',
            dd: '%d დღე',
            M: 'თვე',
            MM: '%d თვე',
            y: 'წელი',
            yy: '%d წელი',
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal: function (number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-ლი';
            }
            if (
                number < 20 ||
                (number <= 100 && number % 20 === 0) ||
                number % 100 === 0
            ) {
                return 'მე-' + number;
            }
            return number + '-ე';
        },
        week: {
            dow: 1,
            doy: 7,
        },
    });

    return ka;

})));


/***/ }),

/***/ 1799:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(7217),
    baseIsEqual = __webpack_require__(270);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),

/***/ 1802:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(2224);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ 1811:
/***/ (function(module) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ 1827:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian (Switzerland) [it-ch]
//! author : xfh : https://github.com/xfh

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var itCh = moment.defineLocale('it-ch', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return itCh;

})));


/***/ }),

/***/ 1848:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mi = moment.defineLocale('mi', {
        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
            '_'
        ),
        monthsShort:
            'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
                '_'
            ),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            ss: '%d hēkona',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mi;

})));


/***/ }),

/***/ 1873:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(9325);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 1882:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2552),
    isObject = __webpack_require__(3805);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 1885:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var te = moment.defineLocale('te', {
        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
            '_'
        ),
        monthsShort:
            'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
                '_'
            ),
        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[నేడు] LT',
            nextDay: '[రేపు] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[నిన్న] LT',
            lastWeek: '[గత] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s లో',
            past: '%s క్రితం',
            s: 'కొన్ని క్షణాలు',
            ss: '%d సెకన్లు',
            m: 'ఒక నిమిషం',
            mm: '%d నిమిషాలు',
            h: 'ఒక గంట',
            hh: '%d గంటలు',
            d: 'ఒక రోజు',
            dd: '%d రోజులు',
            M: 'ఒక నెల',
            MM: '%d నెలలు',
            y: 'ఒక సంవత్సరం',
            yy: '%d సంవత్సరాలు',
        },
        dayOfMonthOrdinalParse: /\d{1,2}వ/,
        ordinal: '%dవ',
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'రాత్రి') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
                return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'రాత్రి';
            } else if (hour < 10) {
                return 'ఉదయం';
            } else if (hour < 17) {
                return 'మధ్యాహ్నం';
            } else if (hour < 20) {
                return 'సాయంత్రం';
            } else {
                return 'రాత్రి';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return te;

})));


/***/ }),

/***/ 1901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_RegisterView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/RegisterView.vue?vue&type=template&id=a42b5e62
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.component,{tag:"component"})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: ./src/components/Register/Register.vue + 3 modules
var Register = __webpack_require__(9727);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/RegisterView.vue?vue&type=script&lang=ts



var RegisterView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(RegisterView, _super);
    function RegisterView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(RegisterView.prototype, "component", {
        get: function () {
            var _a;
            return (_a = this.$kwInterface.registerComponent) !== null && _a !== void 0 ? _a : Register/* default */.A;
        },
        enumerable: false,
        configurable: true
    });
    RegisterView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Register: Register/* default */.A
            }
        })
    ], RegisterView);
    return RegisterView;
}(lib/* Vue */.lD));
/* harmony default export */ var RegisterViewvue_type_script_lang_ts = (RegisterView);

;// ./src/views/RegisterView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_RegisterViewvue_type_script_lang_ts = (RegisterViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/RegisterView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_RegisterViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_RegisterView = (component.exports);

/***/ }),

/***/ 1908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_LoginView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/LoginView.vue?vue&type=template&id=dde4b842
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.component,{tag:"component"})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: ./src/components/Login/Login.vue + 3 modules
var Login = __webpack_require__(7033);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/LoginView.vue?vue&type=script&lang=ts



var LoginView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(LoginView, _super);
    function LoginView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(LoginView.prototype, "component", {
        get: function () {
            var _a;
            return (_a = this.$kwInterface.loginView) !== null && _a !== void 0 ? _a : Login/* default */.A;
        },
        enumerable: false,
        configurable: true
    });
    LoginView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Login: Login/* default */.A
            }
        })
    ], LoginView);
    return LoginView;
}(lib/* Vue */.lD));
/* harmony default export */ var LoginViewvue_type_script_lang_ts = (LoginView);

;// ./src/views/LoginView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_LoginViewvue_type_script_lang_ts = (LoginViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/LoginView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_LoginViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_LoginView = (component.exports);

/***/ }),

/***/ 1961:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(9653);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),

/***/ 1986:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(1873),
    Uint8Array = __webpack_require__(7828),
    eq = __webpack_require__(5288),
    equalArrays = __webpack_require__(5911),
    mapToArray = __webpack_require__(317),
    setToArray = __webpack_require__(4247);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ 1991:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'key';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f084';
var svgPathData = 'M512 176.001C512 273.203 433.202 352 336 352c-11.22 0-22.19-1.062-32.827-3.069l-24.012 27.014A23.999 23.999 0 0 1 261.223 384H224v40c0 13.255-10.745 24-24 24h-40v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-78.059c0-6.365 2.529-12.47 7.029-16.971l161.802-161.802C163.108 213.814 160 195.271 160 176 160 78.798 238.797.001 335.999 0 433.488-.001 512 78.511 512 176.001zM336 128c0 26.51 21.49 48 48 48s48-21.49 48-48-21.49-48-48-48-48 21.49-48 48z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.bM = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 2032:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(1042);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 2124:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Devanagari script [gom-deva]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
            m: ['एका मिणटान', 'एक मिनूट'],
            mm: [number + ' मिणटांनी', number + ' मिणटां'],
            h: ['एका वरान', 'एक वर'],
            hh: [number + ' वरांनी', number + ' वरां'],
            d: ['एका दिसान', 'एक दीस'],
            dd: [number + ' दिसांनी', number + ' दीस'],
            M: ['एका म्हयन्यान', 'एक म्हयनो'],
            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
            y: ['एका वर्सान', 'एक वर्स'],
            yy: [number + ' वर्सांनी', number + ' वर्सां'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomDeva = moment.defineLocale('gom-deva', {
        months: {
            standalone:
                'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
                    '_'
                ),
            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort:
            'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [वाजतां]',
            LTS: 'A h:mm:ss [वाजतां]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
        },
        calendar: {
            sameDay: '[आयज] LT',
            nextDay: '[फाल्यां] LT',
            nextWeek: '[फुडलो] dddd[,] LT',
            lastDay: '[काल] LT',
            lastWeek: '[फाटलो] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s आदीं',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'वेर' only applies to day of the month
                case 'D':
                    return number + 'वेर';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राती') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळीं') {
                return hour;
            } else if (meridiem === 'दनपारां') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'सांजे') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'राती';
            } else if (hour < 12) {
                return 'सकाळीं';
            } else if (hour < 16) {
                return 'दनपारां';
            } else if (hour < 20) {
                return 'सांजे';
            } else {
                return 'राती';
            }
        },
    });

    return gomDeva;

})));


/***/ }),

/***/ 2165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_TeamParamsView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/TeamParamsView.vue?vue&type=template&id=5cc82c60
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TeamParams')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: ./src/components/TeamParams/TeamParams.vue + 3 modules
var TeamParams = __webpack_require__(4587);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/TeamParamsView.vue?vue&type=script&lang=ts



var TeamParamsView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TeamParamsView, _super);
    function TeamParamsView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TeamParamsView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                TeamParams: TeamParams/* default */.A
            }
        })
    ], TeamParamsView);
    return TeamParamsView;
}(lib/* Vue */.lD));
/* harmony default export */ var TeamParamsViewvue_type_script_lang_ts = (TeamParamsView);

;// ./src/views/TeamParamsView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_TeamParamsViewvue_type_script_lang_ts = (TeamParamsViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/TeamParamsView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_TeamParamsViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_TeamParamsView = (component.exports);

/***/ }),

/***/ 2199:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(4528),
    isArray = __webpack_require__(6449);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ 2218:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Yoruba Nigeria [yo]
//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var yo = moment.defineLocale('yo', {
        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
            '_'
        ),
        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Ònì ni] LT',
            nextDay: '[Ọ̀la ni] LT',
            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
            lastDay: '[Àna ni] LT',
            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ní %s',
            past: '%s kọjá',
            s: 'ìsẹjú aayá die',
            ss: 'aayá %d',
            m: 'ìsẹjú kan',
            mm: 'ìsẹjú %d',
            h: 'wákati kan',
            hh: 'wákati %d',
            d: 'ọjọ́ kan',
            dd: 'ọjọ́ %d',
            M: 'osù kan',
            MM: 'osù %d',
            y: 'ọdún kan',
            yy: 'ọdún %d',
        },
        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
        ordinal: 'ọjọ́ %d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return yo;

})));


/***/ }),

/***/ 2224:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoize = __webpack_require__(104);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ 2225:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

module.exports = unicodeWords;


/***/ }),

/***/ 2264:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '၁',
            2: '၂',
            3: '၃',
            4: '၄',
            5: '၅',
            6: '၆',
            7: '၇',
            8: '၈',
            9: '၉',
            0: '၀',
        },
        numberMap = {
            '၁': '1',
            '၂': '2',
            '၃': '3',
            '၄': '4',
            '၅': '5',
            '၆': '6',
            '၇': '7',
            '၈': '8',
            '၉': '9',
            '၀': '0',
        };

    var my = moment.defineLocale('my', {
        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
            '_'
        ),
        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
            '_'
        ),
        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            ss: '%d စက္ကန့်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်',
        },
        preparse: function (string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return my;

})));


/***/ }),

/***/ 2271:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
              ? forms[1]
              : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            hh: 'час_часа_часов',
            dd: 'день_дня_дней',
            ww: 'неделя_недели_недель',
            MM: 'месяц_месяца_месяцев',
            yy: 'год_года_лет',
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    var monthsParse = [
        /^янв/i,
        /^фев/i,
        /^мар/i,
        /^апр/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^авг/i,
        /^сен/i,
        /^окт/i,
        /^ноя/i,
        /^дек/i,
    ];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    var ru = moment.defineLocale('ru', {
        months: {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
                '_'
            ),
            standalone:
                'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
                    '_'
                ),
        },
        monthsShort: {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
                '_'
            ),
            standalone:
                'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
                    '_'
                ),
        },
        weekdays: {
            standalone:
                'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
                    '_'
                ),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
                '_'
            ),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
        },
        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex:
            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex:
            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex:
            /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соответствует только сокращённым формам
        monthsShortStrictRegex:
            /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., H:mm',
            LLLL: 'dddd, D MMMM YYYY г., H:mm',
        },
        calendar: {
            sameDay: '[Сегодня, в] LT',
            nextDay: '[Завтра, в] LT',
            lastDay: '[Вчера, в] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            lastWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'через %s',
            past: '%s назад',
            s: 'несколько секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'час',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            w: 'неделя',
            ww: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM: function (input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ru;

})));


/***/ }),

/***/ 2274:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nb = moment.defineLocale('nb', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'noen sekunder',
            ss: '%d sekunder',
            m: 'ett minutt',
            mm: '%d minutter',
            h: 'én time',
            hh: '%d timer',
            d: 'én dag',
            dd: '%d dager',
            w: 'én uke',
            ww: '%d uker',
            M: 'én måned',
            MM: '%d måneder',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nb;

})));


/***/ }),

/***/ 2297:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var msMy = moment.defineLocale('ms-my', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return msMy;

})));


/***/ }),

/***/ 2349:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'times';
var width = 320;
var height = 512;
var ligatures = [];
var unicode = 'f00d';
var svgPathData = 'M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.GR = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 2353:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Libya) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '1',
            2: '2',
            3: '3',
            4: '4',
            5: '5',
            6: '6',
            7: '7',
            8: '8',
            9: '9',
            0: '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                  ? 1
                  : n === 2
                    ? 2
                    : n % 100 >= 3 && n % 100 <= 10
                      ? 3
                      : n % 100 >= 11
                        ? 4
                        : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arLy = moment.defineLocale('ar-ly', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arLy;

})));


/***/ }),

/***/ 2399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1635);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9077);
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9998);
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vuex__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _TeamFormMixin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2783);




var TeamConfigMixin = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__extends */ .C6)(TeamConfigMixin, _super);
    function TeamConfigMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.localConfig = {};
        return _this;
    }
    TeamConfigMixin.prototype.mounted = function () {
        return (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__awaiter */ .sH)(this, void 0, Promise, function () {
            return (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__generator */ .YH)(this, function (_a) {
                this.setLocalTeam(this.team);
                this.setLocalTeamConfigs(this.teamConfigs);
                return [2 /*return*/];
            });
        });
    };
    TeamConfigMixin.prototype.setLocalTeamConfigs = function (config) {
        this.localConfig = JSON.parse(JSON.stringify(config));
    };
    TeamConfigMixin.prototype.cancel = function () {
        this.setLocalTeam(this.team);
        this.setLocalTeamConfigs(this.teamConfigs);
    };
    (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__decorate */ .Cg)([
        (0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Watch */ .ox)('teamConfigs')
    ], TeamConfigMixin.prototype, "setLocalTeamConfigs", null);
    TeamConfigMixin = (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__decorate */ .Cg)([
        (0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .uA)({
            computed: (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .Cl)({}, (0,vuex__WEBPACK_IMPORTED_MODULE_1__.mapGetters)('user', ['teamConfigs']))
        })
    ], TeamConfigMixin);
    return TeamConfigMixin;
}((0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Mixins */ .Xe)(_TeamFormMixin__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)));
/* harmony default export */ __webpack_exports__.A = (TeamConfigMixin);


/***/ }),

/***/ 2428:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(7534),
    isObjectLike = __webpack_require__(346);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 2475:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek Latin [uz-latn]
//! author : Rasulbek Mirzayev : github.com/Rasulbeeek

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uzLatn = moment.defineLocale('uz-latn', {
        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
        weekdays:
            'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
                '_'
            ),
        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Bugun soat] LT [da]',
            nextDay: '[Ertaga] LT [da]',
            nextWeek: 'dddd [kuni soat] LT [da]',
            lastDay: '[Kecha soat] LT [da]',
            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Yaqin %s ichida',
            past: 'Bir necha %s oldin',
            s: 'soniya',
            ss: '%d soniya',
            m: 'bir daqiqa',
            mm: '%d daqiqa',
            h: 'bir soat',
            hh: '%d soat',
            d: 'bir kun',
            dd: '%d kun',
            M: 'bir oy',
            MM: '%d oy',
            y: 'bir yil',
            yy: '%d yil',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return uzLatn;

})));


/***/ }),

/***/ 2477:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123
//! author : Kristian Sakarisson : https://github.com/sakarisson

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fo = moment.defineLocale('fo', {
        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays:
            'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
                '_'
            ),
        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D. MMMM, YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Í dag kl.] LT',
            nextDay: '[Í morgin kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[Í gjár kl.] LT',
            lastWeek: '[síðstu] dddd [kl] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'um %s',
            past: '%s síðani',
            s: 'fá sekund',
            ss: '%d sekundir',
            m: 'ein minuttur',
            mm: '%d minuttir',
            h: 'ein tími',
            hh: '%d tímar',
            d: 'ein dagur',
            dd: '%d dagar',
            M: 'ein mánaður',
            MM: '%d mánaðir',
            y: 'eitt ár',
            yy: '%d ár',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fo;

})));


/***/ }),

/***/ 2478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_PaymentTermsView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/PaymentTermsView.vue?vue&type=template&id=1e628004
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PaymentTerms')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: ./src/components/PaymentTerms/PaymentTerms.vue + 3 modules
var PaymentTerms = __webpack_require__(4043);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/PaymentTermsView.vue?vue&type=script&lang=ts



var PaymentTermsView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PaymentTermsView, _super);
    function PaymentTermsView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PaymentTermsView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                PaymentTerms: PaymentTerms/* default */.A
            }
        })
    ], PaymentTermsView);
    return PaymentTermsView;
}(lib/* Vue */.lD));
/* harmony default export */ var PaymentTermsViewvue_type_script_lang_ts = (PaymentTermsView);

;// ./src/views/PaymentTermsView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_PaymentTermsViewvue_type_script_lang_ts = (PaymentTermsViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/PaymentTermsView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_PaymentTermsViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_PaymentTermsView = (component.exports);

/***/ }),

/***/ 2513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_UnitsView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/UnitsView.vue?vue&type=template&id=3b9a0cdc
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Units')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: ./src/components/Units/Units.vue + 3 modules
var Units = __webpack_require__(7563);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/UnitsView.vue?vue&type=script&lang=ts



var UnitsView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(UnitsView, _super);
    function UnitsView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UnitsView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Units: Units/* default */.A
            }
        })
    ], UnitsView);
    return UnitsView;
}(lib/* Vue */.lD));
/* harmony default export */ var UnitsViewvue_type_script_lang_ts = (UnitsView);

;// ./src/views/UnitsView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_UnitsViewvue_type_script_lang_ts = (UnitsViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/UnitsView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_UnitsViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_UnitsView = (component.exports);

/***/ }),

/***/ 2552:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(1873),
    getRawTag = __webpack_require__(659),
    objectToString = __webpack_require__(9350);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 2572:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^(maart|mrt\.?)$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex =
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex:
            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays:
            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            w: 'één week',
            ww: '%d weken',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nl;

})));


/***/ }),

/***/ 2573:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'file-alt';
var width = 384;
var height = 512;
var ligatures = [];
var unicode = 'f15c';
var svgPathData = 'M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 236c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-72v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm96-114.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.h8 = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 2648:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng
//! author : uu109 : https://github.com/uu109

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhCn = moment.defineLocale('zh-cn', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日Ah点mm分',
            LLLL: 'YYYY年M月D日ddddAh点mm分',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[下]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            lastDay: '[昨天]LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[上]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s后',
            past: '%s前',
            s: '几秒',
            ss: '%d 秒',
            m: '1 分钟',
            mm: '%d 分钟',
            h: '1 小时',
            hh: '%d 小时',
            d: '1 天',
            dd: '%d 天',
            w: '1 周',
            ww: '%d 周',
            M: '1 个月',
            MM: '%d 个月',
            y: '1 年',
            yy: '%d 年',
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return zhCn;

})));


/***/ }),

/***/ 2651:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isKeyable = __webpack_require__(4218);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 2682:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        };

    var arSa = moment.defineLocale('ar-sa', {
        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return arSa;

})));


/***/ }),

/***/ 2703:
/***/ (function(module) {

"use strict";
module.exports = require("pusher-js");

/***/ }),

/***/ 2735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ TeamUserSelect_TeamUserSelect; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TeamUserSelect/TeamUserSelect.vue?vue&type=template&id=07c1e962
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"team-users-selector"},[_c('k-form-select',_vm._g(_vm._b({attrs:{"options":_vm.computedTeamUsers},scopedSlots:_vm._u([{key:"selected-option",fn:function({ initials, avatar, fullname }){return [_c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"mr-3"},[_c('b-avatar',{attrs:{"text":initials,"src":avatar && avatar.file ? 'data:image.png;base64,' + avatar.file : null}})],1),_c('div',[_vm._v(" "+_vm._s(fullname)+" ")])])]}},{key:"option",fn:function({ initials, avatar, fullname }){return [_c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"mr-3"},[_c('b-avatar',{attrs:{"text":initials,"src":avatar && avatar.file ? 'data:image.png;base64,' + avatar.file : null}})],1),_c('div',[_vm._v(" "+_vm._s(fullname)+" ")])])]}}]),model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}},'k-form-select',_vm.attributes,false),_vm.listeners))],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/TeamUserSelect/TeamUserSelect.ts?vue&type=script&lang=ts&external





var TeamUserSelect = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TeamUserSelect, _super);
    function TeamUserSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.localValue = null;
        return _this;
    }
    TeamUserSelect.prototype.mounted = function () {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.loadTeamUsers()];
                    case 1:
                        _b.sent();
                        if (this.selectDefault !== false && !this.value && (!this.role || ((_a = this.teamUser.roles) === null || _a === void 0 ? void 0 : _a.includes(this.role)))) {
                            this.$emit('input', this.teamUser);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(TeamUserSelect.prototype, "computedTeamUsers", {
        get: function () {
            var user = this.role ? this.teamUsersRole(this.role) : this.activeTeamUsers;
            if (this.$kwInterface.teamUserFilter && !this.withoutGlobalFilter) {
                user = user.filter(this.$kwInterface.teamUserFilter);
            }
            if (this.filter) {
                user = user.filter(this.filter);
            }
            return user;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TeamUserSelect.prototype, "attributes", {
        get: function () {
            return Object.assign({}, {
                clearable: false,
                name: this.name,
                id: this.id,
                label: 'fullname'
            }, this.$attrs);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TeamUserSelect.prototype, "listeners", {
        get: function () {
            return Object.assign({}, {
                input: this.updatedValue
            });
        },
        enumerable: false,
        configurable: true
    });
    TeamUserSelect.prototype.watchValue = function (value) {
        if (JSON.stringify(value) !== JSON.stringify(this.localValue)) {
            this.localValue = value ? JSON.parse(JSON.stringify(value)) : null;
        }
    };
    TeamUserSelect.prototype.updatedValue = function (value) {
        return value;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], TeamUserSelect.prototype, "selectDefault", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], TeamUserSelect.prototype, "name", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], TeamUserSelect.prototype, "id", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], TeamUserSelect.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], TeamUserSelect.prototype, "filter", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], TeamUserSelect.prototype, "role", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], TeamUserSelect.prototype, "withoutGlobalFilter", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], TeamUserSelect.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('input')
    ], TeamUserSelect.prototype, "updatedValue", null);
    TeamUserSelect = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadTeamUsers'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('globalDatas', ['activeTeamUsers', 'teamUsersRole'])), (0,external_vuex_.mapGetters)('user', ['teamUser'])),
            components: {
                BAvatar: external_bootstrap_vue_.BAvatar,
                KFormSelect: form_vue_.KFormSelect
            }
        })
    ], TeamUserSelect);
    return TeamUserSelect;
}(lib/* Vue */.lD));
/* harmony default export */ var TeamUserSelectvue_type_script_lang_ts_external = (TeamUserSelect);

;// ./src/components/TeamUserSelect/TeamUserSelect.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var TeamUserSelect_TeamUserSelectvue_type_script_lang_ts_external = (TeamUserSelectvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/TeamUserSelect/TeamUserSelect.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  TeamUserSelect_TeamUserSelectvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TeamUserSelect_TeamUserSelect = (component.exports);

/***/ }),

/***/ 2749:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(1042);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 2783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1635);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9077);
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9998);
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vuex__WEBPACK_IMPORTED_MODULE_1__);



var TeamFormMixin = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__extends */ .C6)(TeamFormMixin, _super);
    function TeamFormMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.localTeam = {};
        return _this;
    }
    TeamFormMixin.prototype.mounted = function () {
        this.setLocalTeam(this.team);
    };
    Object.defineProperty(TeamFormMixin.prototype, "formAction", {
        get: function () {
            return '/team?with_file=1';
        },
        enumerable: false,
        configurable: true
    });
    TeamFormMixin.prototype.formSubmitted = function (response) {
        this.applyNewTeam(response.data);
    };
    TeamFormMixin.prototype.setLocalTeam = function (team) {
        this.localTeam = JSON.parse(JSON.stringify(team));
    };
    TeamFormMixin.prototype.applyNewTeam = function (team) {
        this.setTeam(team);
        this.localTeam = team;
    };
    TeamFormMixin.prototype.cancel = function () {
        this.setLocalTeam(this.team);
    };
    (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__decorate */ .Cg)([
        (0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Watch */ .ox)('team')
    ], TeamFormMixin.prototype, "setLocalTeam", null);
    TeamFormMixin = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__decorate */ .Cg)([
        (0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .uA)({
            computed: (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .Cl)({}, (0,vuex__WEBPACK_IMPORTED_MODULE_1__.mapGetters)('user', ['team'])),
            methods: (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .Cl)({}, (0,vuex__WEBPACK_IMPORTED_MODULE_1__.mapActions)('user', ['setTeam']))
        })
    ], TeamFormMixin);
    return TeamFormMixin;
}(vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Vue */ .lD));
/* harmony default export */ __webpack_exports__.A = (TeamFormMixin);


/***/ }),

/***/ 2804:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(6110),
    root = __webpack_require__(9325);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ 2824:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(7805),
    cloneBuffer = __webpack_require__(3290),
    cloneTypedArray = __webpack_require__(1961),
    copyArray = __webpack_require__(3007),
    initCloneObject = __webpack_require__(5529),
    isArguments = __webpack_require__(2428),
    isArray = __webpack_require__(6449),
    isArrayLikeObject = __webpack_require__(3693),
    isBuffer = __webpack_require__(3656),
    isFunction = __webpack_require__(1882),
    isObject = __webpack_require__(3805),
    isPlainObject = __webpack_require__(1331),
    isTypedArray = __webpack_require__(7167),
    safeGet = __webpack_require__(4974),
    toPlainObject = __webpack_require__(9884);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),

/***/ 2854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_ForgotPasswordView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ForgotPasswordView.vue?vue&type=template&id=d2a9944a
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ForgotPassword')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: ./src/components/ForgotPassword/ForgotPassword.vue + 3 modules
var ForgotPassword = __webpack_require__(8000);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ForgotPasswordView.vue?vue&type=script&lang=ts



var ForgotPasswordView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ForgotPasswordView, _super);
    function ForgotPasswordView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ForgotPasswordView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                ForgotPassword: ForgotPassword/* default */.A
            }
        })
    ], ForgotPasswordView);
    return ForgotPasswordView;
}(lib/* Vue */.lD));
/* harmony default export */ var ForgotPasswordViewvue_type_script_lang_ts = (ForgotPasswordView);

;// ./src/views/ForgotPasswordView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_ForgotPasswordViewvue_type_script_lang_ts = (ForgotPasswordViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/ForgotPasswordView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_ForgotPasswordViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_ForgotPasswordView = (component.exports);

/***/ }),

/***/ 2865:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSetToString = __webpack_require__(9570),
    shortOut = __webpack_require__(1811);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ 2903:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(3805),
    isPrototype = __webpack_require__(5527),
    nativeKeysIn = __webpack_require__(181);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),

/***/ 2912:
/***/ (function(module) {

"use strict";
module.exports = "data:image/png;base64,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";

/***/ }),

/***/ 2934:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
//! comment : miestasmia corrected the translation by colindean
//! comment : Vivakvo corrected the translation by colindean and miestasmia

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eo = moment.defineLocale('eo', {
        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: '[la] D[-an de] MMMM, YYYY',
            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function (input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar: {
            sameDay: '[Hodiaŭ je] LT',
            nextDay: '[Morgaŭ je] LT',
            nextWeek: 'dddd[n je] LT',
            lastDay: '[Hieraŭ je] LT',
            lastWeek: '[pasintan] dddd[n je] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'post %s',
            past: 'antaŭ %s',
            s: 'kelkaj sekundoj',
            ss: '%d sekundoj',
            m: 'unu minuto',
            mm: '%d minutoj',
            h: 'unu horo',
            hh: '%d horoj',
            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
            dd: '%d tagoj',
            M: 'unu monato',
            MM: '%d monatoj',
            y: 'unu jaro',
            yy: '%d jaroj',
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal: '%da',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eo;

})));


/***/ }),

/***/ 2949:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(2651);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 2959:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fad';
var iconName = 'file-archive';
var width = 384;
var height = 512;
var ligatures = [];
var unicode = 'f1c6';
var svgPathData = ['M272 128a16 16 0 0 1-16-16V0h-96v32h-32V0H24A23.94 23.94 0 0 0 0 23.88V488a23.94 23.94 0 0 0 23.88 24H360a23.94 23.94 0 0 0 24-23.88V128zM95.9 32h32v32h-32zm83.47 342.08a52.43 52.43 0 1 1-102.74-21L96 256v-32h32v-32H96v-32h32v-32H96V96h32V64h32v32h-32v32h32v32h-32v32h32v32h-32v32h22.33a12.08 12.08 0 0 1 11.8 9.7l17.3 87.7a52.54 52.54 0 0 1-.06 20.68z', 'M377 105L279.1 7a24 24 0 0 0-17-7H256v112a16 16 0 0 0 16 16h112v-6.1a23.9 23.9 0 0 0-7-16.9zM127.9 32h-32v32h32zM96 160v32h32v-32zM160 0h-32v32h32zM96 96v32h32V96zm83.43 257.4l-17.3-87.7a12.08 12.08 0 0 0-11.8-9.7H128v-32H96v32l-19.37 97.1a52.43 52.43 0 1 0 102.8.3zm-51.1 36.6c-17.9 0-32.5-12-32.5-27s14.5-27 32.4-27 32.5 12.1 32.5 27-14.5 27-32.4 27zM160 192h-32v32h32zm0-64h-32v32h32zm0-64h-32v32h32z'];

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.oH = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 2986:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'times';
var width = 352;
var height = 512;
var ligatures = [];
var unicode = 'f00d';
var svgPathData = 'M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.GR = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 3004:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Singapore) [en-sg]
//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enSg = moment.defineLocale('en-sg', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enSg;

})));


/***/ }),

/***/ 3007:
/***/ (function(module) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ 3030:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fad';
var iconName = 'file-excel';
var width = 384;
var height = 512;
var ligatures = [];
var unicode = 'f1c3';
var svgPathData = ['M384 128H272a16 16 0 0 1-16-16V0H24A23.94 23.94 0 0 0 0 23.88V488a23.94 23.94 0 0 0 23.88 24H360a23.94 23.94 0 0 0 24-23.88V128zM280.51 446.09A12 12 0 0 1 274 448h-34.9a12 12 0 0 1-10.6-6.3C208.9 405.5 192 373 192 373c-6.4 14.8-10 20-36.6 68.8a11.89 11.89 0 0 1-10.5 6.3H110a12 12 0 0 1-10.1-18.5l60.3-93.5-60.3-93.5a12 12 0 0 1 10.1-18.5h34.8a12 12 0 0 1 10.6 6.3c26.1 48.8 20 33.6 36.6 68.5 0 0 6.1-11.7 36.6-68.5a12 12 0 0 1 10.6-6.3H274a11.93 11.93 0 0 1 10.1 18.4L224 336l60.1 93.5a12 12 0 0 1-3.59 16.59z', 'M377 105L279.1 7a24 24 0 0 0-17-7H256v112a16 16 0 0 0 16 16h112v-6.1a23.9 23.9 0 0 0-7-16.9zM224 336l60.1-93.5a11.93 11.93 0 0 0-10.1-18.4h-34.8a12 12 0 0 0-10.6 6.3c-30.5 56.8-36.6 68.5-36.6 68.5-16.6-34.9-10.5-19.7-36.6-68.5a12 12 0 0 0-10.6-6.3H110a12 12 0 0 0-10.1 18.5l60.3 93.5-60.3 93.5a12 12 0 0 0 10.1 18.5h34.9a11.89 11.89 0 0 0 10.5-6.3c26.6-48.8 30.2-54 36.6-68.8 0 0 16.9 32.5 36.5 68.7a12 12 0 0 0 10.6 6.3H274a12 12 0 0 0 10.1-18.5z'];

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.fn = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 3035:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            ss: [number + 'sekundi', number + 'sekundit'],
            m: ['ühe minuti', 'üks minut'],
            mm: [number + ' minuti', number + ' minutit'],
            h: ['ühe tunni', 'tund aega', 'üks tund'],
            hh: [number + ' tunni', number + ' tundi'],
            d: ['ühe päeva', 'üks päev'],
            M: ['kuu aja', 'kuu aega', 'üks kuu'],
            MM: [number + ' kuu', number + ' kuud'],
            y: ['ühe aasta', 'aasta', 'üks aasta'],
            yy: [number + ' aasta', number + ' aastat'],
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    var et = moment.defineLocale('et', {
        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
            '_'
        ),
        monthsShort:
            'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
        weekdays:
            'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
                '_'
            ),
        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Täna,] LT',
            nextDay: '[Homme,] LT',
            nextWeek: '[Järgmine] dddd LT',
            lastDay: '[Eile,] LT',
            lastWeek: '[Eelmine] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s pärast',
            past: '%s tagasi',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: '%d päeva',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return et;

})));


/***/ }),

/***/ 3040:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Hash = __webpack_require__(1549),
    ListCache = __webpack_require__(79),
    Map = __webpack_require__(8223);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 3048:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ResetPassword_ResetPassword; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ResetPassword/ResetPassword.vue?vue&type=template&id=528cced5
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-card',{staticClass:"login-form mb-5",attrs:{"title":_vm.$t('interface.pageTitle.resetPassword')}},[_c('k-form',{attrs:{"action":"/auth/reset-password","method":"post","dontAskLogin":"","beforeSubmit":_vm.beforeSubmit},on:{"submitComplete":_vm.submitComplete,"submitError":_vm.submitError}},[_c('input',{attrs:{"type":"hidden","name":"token"},domProps:{"value":_vm.token}}),_c('b-form-group',{attrs:{"label":_vm.$t('interface.auth.email')}},[_c('k-form-input',{attrs:{"type":"email","name":"email","required":"","value":_vm.$route.query.email}})],1),_c('Password'),_c('b-alert',{attrs:{"show":_vm.errorMessage !== null,"variant":"danger"}},[_vm._v(" "+_vm._s(_vm.errorMessage)+" ")]),_c('p',{staticClass:"text-center mb-0"},[_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_vm._v(" "+_vm._s(_vm.$t('interface.auth.forgotPasswordBtn'))+" ")])],1)],1)],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(9356);
// EXTERNAL MODULE: ./src/components/Password/Password.vue + 3 modules
var Password = __webpack_require__(593);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ResetPassword/ResetPassword.ts?vue&type=script&lang=ts&external







var ResetPassword = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ResetPassword, _super);
    function ResetPassword() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.errorMessage = null;
        return _this;
    }
    ResetPassword.prototype.beforeSubmit = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.$kwInterface.withCsrf) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.$kwInterface.axios.get('/csrf-cookie')];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ResetPassword.prototype.submitComplete = function (response) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var data;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = response.data;
                        this.setToken(data.token);
                        this.setUser(data.user);
                        if (!this.$kwInterface.goToHome) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.$kwInterface.goToHome(this.$router, this.$store)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ResetPassword.prototype.submitError = function (error) {
        var _a;
        this.errorMessage = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data.message;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ResetPassword.prototype, "token", void 0);
    ResetPassword = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('auth', ['setToken'])), (0,external_vuex_.mapActions)('user', ['setUser'])),
            components: {
                BCard: external_bootstrap_vue_.BCard, BFormGroup: external_bootstrap_vue_.BFormGroup, BButton: external_bootstrap_vue_.BButton, BAlert: external_bootstrap_vue_.BAlert, BInputGroup: external_bootstrap_vue_.BInputGroup, BInputGroupAppend: external_bootstrap_vue_.BInputGroupAppend,
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                Password: Password/* default */.A
            }
        })
    ], ResetPassword);
    return ResetPassword;
}(lib/* Vue */.lD));
/* harmony default export */ var ResetPasswordvue_type_script_lang_ts_external = (ResetPassword);

;// ./src/components/ResetPassword/ResetPassword.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ResetPassword_ResetPasswordvue_type_script_lang_ts_external = (ResetPasswordvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/ResetPassword/ResetPassword.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ResetPassword_ResetPasswordvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ResetPassword_ResetPassword = (component.exports);

/***/ }),

/***/ 3072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ Avatar_Avatar; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Avatar/Avatar.vue?vue&type=template&id=3aa74436
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-avatar',{attrs:{"text":_vm.initials,"src":_vm.avatar,"size":_vm.size,"variant":_vm.variant}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Avatar/Avatar.ts?vue&type=script&lang=ts&external




var Avatar = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(Avatar, _super);
    function Avatar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Avatar.prototype.mounted = function () {
        this.loadTeamUsers();
    };
    Object.defineProperty(Avatar.prototype, "initials", {
        get: function () {
            if (this.user) {
                return this.user.initials;
            }
            else if (this.teamUser) {
                return this.teamUser.initials;
            }
            return this.name.split(' ')
                .map(function (text) {
                return text.substr(0, 1);
            })
                .slice(0, 2)
                .join('');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Avatar.prototype, "avatar", {
        get: function () {
            var file = this.file;
            if (file) {
                return 'data:image.png;base64,' + file;
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Avatar.prototype, "file", {
        get: function () {
            var _this = this;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            if ((_b = (_a = this.user) === null || _a === void 0 ? void 0 : _a.avatar) === null || _b === void 0 ? void 0 : _b.file) {
                return (_d = (_c = this.user) === null || _c === void 0 ? void 0 : _c.avatar) === null || _d === void 0 ? void 0 : _d.file;
            }
            if ((_e = this.teamUser) === null || _e === void 0 ? void 0 : _e.avatar) {
                if ((_g = (_f = this.teamUser) === null || _f === void 0 ? void 0 : _f.avatar) === null || _g === void 0 ? void 0 : _g.file) {
                    return (_j = (_h = this.teamUser) === null || _h === void 0 ? void 0 : _h.avatar) === null || _j === void 0 ? void 0 : _j.file;
                }
                var teamUser = this.teamUsers.find(function (val) { return val.id === _this.teamUser.id; });
                return (_l = (_k = teamUser === null || teamUser === void 0 ? void 0 : teamUser.avatar) === null || _k === void 0 ? void 0 : _k.file) !== null && _l !== void 0 ? _l : null;
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], Avatar.prototype, "user", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], Avatar.prototype, "teamUser", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], Avatar.prototype, "name", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], Avatar.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'secondary' })
    ], Avatar.prototype, "variant", void 0);
    Avatar = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BAvatar: external_bootstrap_vue_.BAvatar
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('globalDatas', ['teamUsers'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadTeamUsers']))
        })
    ], Avatar);
    return Avatar;
}(lib/* Vue */.lD));
/* harmony default export */ var Avatarvue_type_script_lang_ts_external = (Avatar);

;// ./src/components/Avatar/Avatar.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var Avatar_Avatarvue_type_script_lang_ts_external = (Avatarvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/Avatar/Avatar.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  Avatar_Avatarvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Avatar_Avatar = (component.exports);

/***/ }),

/***/ 3164:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ko = moment.defineLocale('ko', {
        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
            '_'
        ),
        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY년 MMMM D일',
            LLL: 'YYYY년 MMMM D일 A h:mm',
            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
            l: 'YYYY.MM.DD.',
            ll: 'YYYY년 MMMM D일',
            lll: 'YYYY년 MMMM D일 A h:mm',
            llll: 'YYYY년 MMMM D일 dddd A h:mm',
        },
        calendar: {
            sameDay: '오늘 LT',
            nextDay: '내일 LT',
            nextWeek: 'dddd LT',
            lastDay: '어제 LT',
            lastWeek: '지난주 dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s 후',
            past: '%s 전',
            s: '몇 초',
            ss: '%d초',
            m: '1분',
            mm: '%d분',
            h: '한 시간',
            hh: '%d시간',
            d: '하루',
            dd: '%d일',
            M: '한 달',
            MM: '%d달',
            y: '일 년',
            yy: '%d년',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse: /오전|오후/,
        isPM: function (token) {
            return token === '오후';
        },
        meridiem: function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        },
    });

    return ko;

})));


/***/ }),

/***/ 3174:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'cogs';
var width = 640;
var height = 512;
var ligatures = [];
var unicode = 'f085';
var svgPathData = 'M512.1 191l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0L552 6.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zm-10.5-58.8c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.7-82.4 14.3-52.8 52.8zM386.3 286.1l33.7 16.8c10.1 5.8 14.5 18.1 10.5 29.1-8.9 24.2-26.4 46.4-42.6 65.8-7.4 8.9-20.2 11.1-30.3 5.3l-29.1-16.8c-16 13.7-34.6 24.6-54.9 31.7v33.6c0 11.6-8.3 21.6-19.7 23.6-24.6 4.2-50.4 4.4-75.9 0-11.5-2-20-11.9-20-23.6V418c-20.3-7.2-38.9-18-54.9-31.7L74 403c-10 5.8-22.9 3.6-30.3-5.3-16.2-19.4-33.3-41.6-42.2-65.7-4-10.9.4-23.2 10.5-29.1l33.3-16.8c-3.9-20.9-3.9-42.4 0-63.4L12 205.8c-10.1-5.8-14.6-18.1-10.5-29 8.9-24.2 26-46.4 42.2-65.8 7.4-8.9 20.2-11.1 30.3-5.3l29.1 16.8c16-13.7 34.6-24.6 54.9-31.7V57.1c0-11.5 8.2-21.5 19.6-23.5 24.6-4.2 50.5-4.4 76-.1 11.5 2 20 11.9 20 23.6v33.6c20.3 7.2 38.9 18 54.9 31.7l29.1-16.8c10-5.8 22.9-3.6 30.3 5.3 16.2 19.4 33.2 41.6 42.1 65.8 4 10.9.1 23.2-10 29.1l-33.7 16.8c3.9 21 3.9 42.5 0 63.5zm-117.6 21.1c59.2-77-28.7-164.9-105.7-105.7-59.2 77 28.7 164.9 105.7 105.7zm243.4 182.7l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0l8.2-14.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zM501.6 431c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.6-82.4 14.3-52.8 52.8z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.Ub = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 3221:
/***/ (function(module) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ 3222:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(7556);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 3243:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(6110);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ 3270:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'info-circle';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f05a';
var svgPathData = 'M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.iW = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 3290:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(9325);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;


/***/ }),

/***/ 3309:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'caret-square-left';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f191';
var svgPathData = 'M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM259.515 124.485l-123.03 123.03c-4.686 4.686-4.686 12.284 0 16.971l123.029 123.029c7.56 7.56 20.485 2.206 20.485-8.485V132.971c.001-10.691-12.925-16.045-20.484-8.486z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.Zi = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 3322:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['секунда', 'секунде', 'секунди'],
            m: ['један минут', 'једног минута'],
            mm: ['минут', 'минута', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            d: ['један дан', 'једног дана'],
            dd: ['дан', 'дана', 'дана'],
            M: ['један месец', 'једног месеца'],
            MM: ['месец', 'месеца', 'месеци'],
            y: ['једну годину', 'једне године'],
            yy: ['годину', 'године', 'година'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            if (
                number % 10 >= 1 &&
                number % 10 <= 4 &&
                (number % 100 < 10 || number % 100 >= 20)
            ) {
                return number % 10 === 1 ? wordKey[0] : wordKey[1];
            }
            return wordKey[2];
        },
        translate: function (number, withoutSuffix, key, isFuture) {
            var wordKey = translator.words[key],
                word;

            if (key.length === 1) {
                // Nominativ
                if (key === 'y' && withoutSuffix) return 'једна година';
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }

            word = translator.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === 'yy' && withoutSuffix && word === 'годину') {
                return number + ' година';
            }

            return number + ' ' + word;
        },
    };

    var srCyrl = moment.defineLocale('sr-cyrl', {
        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
            '_'
        ),
        monthsShort:
            'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
        monthsParseExact: true,
        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[у] [недељу] [у] LT';
                    case 3:
                        return '[у] [среду] [у] LT';
                    case 6:
                        return '[у] [суботу] [у] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[у] dddd [у] LT';
                }
            },
            lastDay: '[јуче у] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[прошле] [недеље] [у] LT',
                    '[прошлог] [понедељка] [у] LT',
                    '[прошлог] [уторка] [у] LT',
                    '[прошле] [среде] [у] LT',
                    '[прошлог] [четвртка] [у] LT',
                    '[прошлог] [петка] [у] LT',
                    '[прошле] [суботе] [у] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пре %s',
            s: 'неколико секунди',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: translator.translate,
            dd: translator.translate,
            M: translator.translate,
            MM: translator.translate,
            y: translator.translate,
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return srCyrl;

})));


/***/ }),

/***/ 3345:
/***/ (function(module) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ 3346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_Error404View; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/Error404View.vue?vue&type=template&id=4d067ca6
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Error404')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: ./src/components/Error404/Error404.vue + 3 modules
var Error404 = __webpack_require__(8122);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/Error404View.vue?vue&type=script&lang=ts



var Error404View = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(Error404View, _super);
    function Error404View() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Error404View = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Error404: Error404/* default */.A
            }
        })
    ], Error404View);
    return Error404View;
}(lib/* Vue */.lD));
/* harmony default export */ var Error404Viewvue_type_script_lang_ts = (Error404View);

;// ./src/views/Error404View.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_Error404Viewvue_type_script_lang_ts = (Error404Viewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/Error404View.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_Error404Viewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_Error404View = (component.exports);

/***/ }),

/***/ 3360:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var defineProperty = __webpack_require__(3243);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ 3383:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Latin script [gom-latn]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['thoddea sekondamni', 'thodde sekond'],
            ss: [number + ' sekondamni', number + ' sekond'],
            m: ['eka mintan', 'ek minut'],
            mm: [number + ' mintamni', number + ' mintam'],
            h: ['eka voran', 'ek vor'],
            hh: [number + ' voramni', number + ' voram'],
            d: ['eka disan', 'ek dis'],
            dd: [number + ' disamni', number + ' dis'],
            M: ['eka mhoinean', 'ek mhoino'],
            MM: [number + ' mhoineamni', number + ' mhoine'],
            y: ['eka vorsan', 'ek voros'],
            yy: [number + ' vorsamni', number + ' vorsam'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomLatn = moment.defineLocale('gom-latn', {
        months: {
            standalone:
                'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
                    '_'
                ),
            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort:
            'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [vazta]',
            LTS: 'A h:mm:ss [vazta]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [vazta]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
        },
        calendar: {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Fuddlo] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fattlo] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s adim',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'er' only applies to day of the month
                case 'D':
                    return number + 'er';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /rati|sokallim|donparam|sanje/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'rati') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'sokallim') {
                return hour;
            } else if (meridiem === 'donparam') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'sanje') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'rati';
            } else if (hour < 12) {
                return 'sokallim';
            } else if (hour < 16) {
                return 'donparam';
            } else if (hour < 20) {
                return 'sanje';
            } else {
                return 'rati';
            }
        },
    });

    return gomLatn;

})));


/***/ }),

/***/ 3386:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ms = moment.defineLocale('ms', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ms;

})));


/***/ }),

/***/ 3425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ DynamicList_DynamicList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/DynamicList/DynamicList.vue?vue&type=template&id=9d030738
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dynamic-list"},[(_vm.searchable !== false || _vm.withoutAddButton === false || _vm.exportable)?_c('b-form-row',[(_vm.searchable !== false)?_c('b-col',{attrs:{"md":"4","order-md":"1","order":"3"}},[_c('k-form-input',{attrs:{"type":"search","placeholder":_vm.$t('interface.searchPlaceholder')},on:{"input":_vm.searchData},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}})],1):_vm._e(),(_vm.withoutAddButton === false)?_c('b-col',{staticClass:"pb-2 pb-md-0",attrs:{"order-md":"2","order":"1"}},[_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.createData.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('interface.add'))+" ")])],1):_vm._e(),(_vm.exportable)?_c('b-col',{attrs:{"order-md":"3","order":"2","cols":"auto"}},[_c('b-button',{on:{"click":function($event){_vm.exportModalState = true}}},[_vm._v(" Exporter ")])],1):_vm._e()],1):_vm._e(),_c('table',{class:{
      table: true,
      'table-bordered': true,
      'table-striped': this.elements.length > 0 && this.loading,
      'table-hover': this.elements.length > 0 && this.loading,
      'my-2': true
    }},[_c('thead',[_c('tr',[(_vm.sortable !== false)?_c('th',{staticClass:"sort-column"}):_vm._e(),_vm._l((_vm.tableColumns),function(column,i){return _c('th',{key:i,class:column.class},[_vm._v(" "+_vm._s(column.label)+" ")])}),(_vm.withActions)?_c('th',{staticClass:"col-actions",style:({ width: _vm.actionsColWidth })}):_vm._e()],2)]),(_vm.loading || _vm.elements.length === 0)?_c('tbody',[(_vm.loading)?_c('tr',[_c('td',{staticClass:"loading",attrs:{"colspan":_vm.colspan}},[_c('font-awesome-icon',{attrs:{"icon":['fad', 'spinner-third'],"spin":""}})],1)]):(_vm.elements.length === 0)?_c('tr',[_c('td',{staticClass:"text-center p-5",attrs:{"colspan":_vm.colspan}},[_c('p',[_vm._v(_vm._s(_vm.$t('interface.noResults')))]),(_vm.withoutAddButton === false)?_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.createData.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('interface.add'))+" ")]):_vm._e()],1)]):_vm._e()]):_c(_vm.tbodyComponent,_vm._g(_vm._b({tag:"component"},'component',_vm.tbodyAttributes,false),_vm.tbodyEvents),_vm._l((_vm.elements),function(element,i){return _c('tr',{key:i,on:{"dblclick":function($event){$event.preventDefault();return _vm.updateData(element, i)}}},[(_vm.sortable !== false)?_c('td',{staticClass:"sort-column"},[_c('font-awesome-icon',{staticClass:"sort-handler",attrs:{"icon":['fas', 'arrows-v']}})],1):_vm._e(),_vm._l((_vm.tableColumns),function(column,j){return _c('td',{key:j,class:_vm.columnClass(column)},[(column.component)?_c(column.component,{tag:"component",attrs:{"value":_vm.getViewValue(column, element),"row":element}}):(column.type === 'textarea')?[_c('TextareaView',{attrs:{"value":_vm.getViewValue(column, element)}})]:(column.type === 'color')?[_c('span',{staticClass:"color-preview",style:({ 'background-color': _vm.getViewValue(column, element) })})]:[_vm._v(" "+_vm._s(_vm.getViewValue(column, element))+" ")]],2)}),(_vm.withActions)?_c('td',{staticClass:"col-actions"},[_vm._l((_vm.extraActions),function(action,i){return _c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],key:i,staticClass:"mr-2",attrs:{"size":"sm","title":action.label,"variant":action.variant},on:{"click":function($event){$event.preventDefault();return action.action(element)}}},[_c('font-awesome-icon',{attrs:{"icon":action.icon}})],1)}),(_vm.canEdit)?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"mr-2",attrs:{"size":"sm","title":_vm.$t('interface.edit')},on:{"click":function($event){$event.preventDefault();return _vm.updateData(element, i)}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'edit']}})],1):_vm._e(),(_vm.canDelete)?_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: _vm.cantDeleteElement ? _vm.cantDeleteElementMessage : null }),expression:"{ title: cantDeleteElement ? cantDeleteElementMessage : null }"}],staticClass:"d-inline-block"},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],attrs:{"size":"sm","title":_vm.$t('interface.delete'),"variant":"danger","disabled":_vm.cantDeleteElement},on:{"click":function($event){$event.preventDefault();return _vm.askDeleteElement(element, i)}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'trash']}})],1)],1):_vm._e()],2):_vm._e()],2)}),0)],1),_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"mt-3 mt-sm-0 text-center text-sm-left",attrs:{"cols":"12","md":"auto","sm":"6","order-sm":"1","order":"2"}},[_vm._v(" "+_vm._s(_vm.$t('interface.rowLengthSelectPrefix'))+" "),_c('k-form-select',{staticClass:"d-inline-block",staticStyle:{"width":"70px"},attrs:{"options":_vm.perPageChoices,"clearable":false,"size":"sm"},on:{"input":_vm.reloadDatas},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}}),_vm._v(" "+_vm._s(_vm.$t('interface.rowLengthSelectSuffix'))+" ")],1),_c('b-col',{staticClass:"text-center mt-3 mt-md-0",attrs:{"order":"3","order-md":"2","cols":"12","md":""}},[_vm._v(" "+_vm._s(_vm.$t('interface.paginationInfos', { begin: _vm.displayBegin, end: _vm.displayEnd, total: _vm.totalRows }))+" ")]),_c('b-col',{staticClass:"mt-3 mt-sm-0",attrs:{"md":"auto","cols":"12","sm":"6","order":"1","order-sm":"2","order-md":"3"}},[_c('b-pagination',{staticClass:"mb-0 float-sm-right justify-content-center justify-content-sm-left",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},on:{"change":_vm.pageChanged},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1),_c('FormModal',{ref:"modal",attrs:{"title":_vm.editedElement ? _vm.updateTitle : _vm.createTitle,"cancel-title":_vm.$t('interface.cancel'),"ok-title":_vm.editedElement ? _vm.$t('interface.edit') : _vm.$t('interface.add'),"size":_vm.modalSize},on:{"hidden":_vm.cleanForm}},[(_vm.customForm)?_c(_vm.customForm,_vm._b({tag:"component",on:{"submitComplete":_vm.formSubmitted},model:{value:(_vm.editedElement),callback:function ($$v) {_vm.editedElement=$$v},expression:"editedElement"}},'component',_vm.customFormProperties,false)):_vm._e(),(!_vm.customForm)?_c('k-form',{attrs:{"action":_vm.computedFormUrl,"method":_vm.formMethod},on:{"submitComplete":_vm.formSubmitted},model:{value:(_vm.formValues),callback:function ($$v) {_vm.formValues=$$v},expression:"formValues"}},_vm._l((_vm.formColumns),function(column,i){return _c('b-form-group',{key:i,attrs:{"label":column.noFormLabel ? null : column.label,"description":column.comments}},[(_vm.editedElement && column.cantUpdate === true)?_c('div',[_vm._v(" "+_vm._s(_vm.getViewValue(column, _vm.editedElement))+" ")]):(column.type === 'select')?_c('k-form-select',{attrs:{"name":column.key,"options":column.options,"getOptionLabel":column.optionLabel,"reduce":column.optionValue,"clearable":column.clearable,"required":column.required !== false,"ajax":typeof column.ajax === 'function' ? column.ajax(_vm.editedElement) : column.ajax},model:{value:(_vm.formValues[column.key]),callback:function ($$v) {_vm.$set(_vm.formValues, column.key, $$v)},expression:"formValues[column.key]"}}):(column.type === 'editor')?_c('k-form-editor',{attrs:{"name":column.key,"autofocus":i === 0,"required":column.required !== false},model:{value:(_vm.formValues[column.key]),callback:function ($$v) {_vm.$set(_vm.formValues, column.key, $$v)},expression:"formValues[column.key]"}}):(column.type === 'number')?_c('k-form-number',{attrs:{"name":column.key,"autofocus":i === 0,"required":column.required !== false},model:{value:(_vm.formValues[column.key]),callback:function ($$v) {_vm.$set(_vm.formValues, column.key, $$v)},expression:"formValues[column.key]"}}):(column.type === 'boolean')?_c('k-form-checkbox',{attrs:{"name":column.key},model:{value:(_vm.formValues[column.key]),callback:function ($$v) {_vm.$set(_vm.formValues, column.key, $$v)},expression:"formValues[column.key]"}},[_vm._v(" "+_vm._s(column.formLabel ? column.formLabel : column.label)+" ")]):(column.type === 'textarea')?_c('k-form-textarea',{attrs:{"name":column.key,"autofocus":i === 0,"required":column.required !== false},model:{value:(_vm.formValues[column.key]),callback:function ($$v) {_vm.$set(_vm.formValues, column.key, $$v)},expression:"formValues[column.key]"}}):_c('k-form-input',{attrs:{"type":column.type === 'color' ? 'color' : 'text',"name":column.key,"autofocus":i === 0,"required":column.required !== false},model:{value:(_vm.formValues[column.key]),callback:function ($$v) {_vm.$set(_vm.formValues, column.key, $$v)},expression:"formValues[column.key]"}})],1)}),1):_vm._e()],1),_c('b-modal',{attrs:{"title":_vm.$t('interface.deleteConfirmation'),"id":_vm.deleteModalId,"cancel-title":_vm.$t('interface.cancel'),"ok-title":_vm.$t('interface.delete'),"ok-variant":"danger","busy":_vm.computedDeleteLoading,"hide-header-close":_vm.computedDeleteLoading,"no-close-on-backdrop":_vm.computedDeleteLoading,"no-close-on-esc":_vm.computedDeleteLoading,"ok-disabled":_vm.deletingError !== null},on:{"hidden":_vm.cleanDeleteElement,"ok":function($event){$event.preventDefault();return _vm.runDeleteElement.apply(null, arguments)}}},[(_vm.deletingError)?_c('div',[_vm._v(" "+_vm._s(_vm.deletingError)+" ")]):(_vm.deleteLoading)?_c('div',{staticClass:"loading"},[_c('font-awesome-icon',{attrs:{"icon":['fad', 'spinner-third'],"spin":""}})],1):(_vm.forceDeleteElement)?_c('div',[_c('k-form',{ref:"deleteWithReplacementForm",attrs:{"action":_vm.url + '/' + _vm.deleteElement.id,"method":"DELETE"},on:{"submitComplete":_vm.successfullyDeleted}},[(_vm.replacementMessage)?_c('p',{staticClass:"text-justify"},[_vm._v(" "+_vm._s(_vm.replacementMessage)+" ")]):_vm._e(),_c('b-form-group',{attrs:{"label":_vm.$t('interface.replacementElement.label')}},[_c('k-form-select',{attrs:{"name":"replace_id","clearable":false,"ajax":_vm.replacementAjaxUrl,"getOptionLabel":_vm.replacementOptionLabel,"reduce":_vm.replacementOptionValue ? _vm.replacementOptionValue : opt => opt.id,"required":""}})],1)],1)],1):_c('div',[_vm._v(" "+_vm._s(_vm.deleteMsg)+" "),(_vm.deleteElement && _vm.deleteColumnIndex !== false)?_c('p',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.getViewValue(_vm.columns[_vm.deleteColumnIndex], _vm.deleteElement))+" ")]):_vm._e(),(_vm.deleteAlertMessage)?_c('p',{staticClass:"font-weight-bold alert-danger p-2 text-justify rounded"},[_vm._v(" "+_vm._s(_vm.deleteAlertMessage)+" ")]):_vm._e()])]),(_vm.exportable !== false)?_c('ExportDatas',{attrs:{"model":_vm.exportable,"allColumns":"","noFilters":""},model:{value:(_vm.exportModalState),callback:function ($$v) {_vm.exportModalState=$$v},expression:"exportModalState"}}):_vm._e()],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: ./node_modules/lodash/merge.js
var merge = __webpack_require__(5364);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(9356);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(8399);
// EXTERNAL MODULE: ./src/components/FormModal/FormModal.vue + 2 modules
var FormModal = __webpack_require__(7401);
// EXTERNAL MODULE: ./src/components/TextareaView/TextareaView.vue + 3 modules
var TextareaView = __webpack_require__(4598);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
;// external "vuedraggable"
var external_vuedraggable_namespaceObject = require("vuedraggable");
var external_vuedraggable_default = /*#__PURE__*/__webpack_require__.n(external_vuedraggable_namespaceObject);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/DynamicList/DynamicList.ts?vue&type=script&lang=ts&external










var DynamicList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(DynamicList, _super);
    function DynamicList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Loader for data recovery
        _this.loading = true;
        // Pagination informations
        _this.currentPage = 1;
        _this.perPage = 25;
        _this.displayBegin = 0;
        _this.displayEnd = 0;
        _this.totalRows = 0;
        _this.perPageChoices = [25, 50, 100];
        // Search
        _this.searchTerm = null;
        _this.searchTimeout = null;
        // Creation / modification
        _this.formValues = {};
        _this.editedElement = null;
        _this.editedElementIndex = null;
        // Delete
        _this.deleteElement = null;
        _this.deleteElementIndex = null;
        _this.deleteLoading = false;
        _this.forceDeleteElement = false;
        _this.deletingError = null;
        _this.deleteModalId = 'delete-modal-' + Math.random().toString(36).substr(2, 9);
        // List of elements
        _this.elements = [];
        // Modal state for datas export
        _this.exportModalState = false;
        return _this;
    }
    DynamicList.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDatas()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(DynamicList.prototype, "colspan", {
        get: function () {
            var length = this.columns.length + 1;
            if (this.sortable) {
                length++;
            }
            if (this.withActions) {
                length++;
            }
            return length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DynamicList.prototype, "computedFormUrl", {
        // Return form url
        get: function () {
            var _a;
            var url = (_a = this.formUrl) !== null && _a !== void 0 ? _a : this.url;
            if (this.editedElement) {
                url += '/' + this.editedElement.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DynamicList.prototype, "formMethod", {
        // Return form method
        get: function () {
            return this.editedElement ? 'PUT' : 'POST';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DynamicList.prototype, "computedSearchTerm", {
        // Return search parameter for ajax query
        get: function () {
            if (!this.searchTerm) {
                return null;
            }
            return '%' + encodeURIComponent(this.searchTerm) + '%';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DynamicList.prototype, "computedDatas", {
        // Return datas for ajax query
        get: function () {
            return merge_default()(this.datas, {
                per_page: this.perPage,
                page: this.currentPage,
                search: this.computedSearchTerm,
                sort: this.sort
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DynamicList.prototype, "computedColumns", {
        // Return columns for the table
        get: function () {
            var _this = this;
            var columns = Array.from(this.columns);
            // noinspection PointlessBooleanExpressionJS
            if (this.withActiveStatus !== false) {
                columns.push({
                    key: 'status',
                    label: this.$t('interface.activeStatus.label'),
                    keyShow: 'status.name',
                    keyValue: 'status.active',
                    type: 'select',
                    options: [
                        { id: true, label: this.$t('interface.activeStatus.on') },
                        { id: false, label: this.$t('interface.activeStatus.off') }
                    ],
                    defaultOption: true,
                    optionValue: function (opt) { return opt.id; },
                    clearable: false,
                    class: 'd-none d-md-table-cell'
                });
            }
            // noinspection PointlessBooleanExpressionJS
            if (this.withDefault !== false) {
                columns.push({
                    key: 'use_default',
                    label: this.$t('interface.byDefault'),
                    formLabel: this.$t('interface.useForDefault'),
                    noFormLabel: true,
                    show: function (value) { return value ? _this.$t('interface.yes') : _this.$t('interface.no'); },
                    type: 'boolean',
                    class: 'd-none d-md-table-cell'
                });
            }
            return columns;
        },
        enumerable: false,
        configurable: true
    });
    DynamicList.prototype.columnClass = function (column) {
        var columnClass = {};
        if (typeof column.class === 'string') {
            columnClass[column.class] = true;
        }
        else if (column.class) {
            columnClass = column.class;
        }
        return Object.assign({
            'color-column': column.type === 'color'
        }, columnClass);
    };
    Object.defineProperty(DynamicList.prototype, "formColumns", {
        get: function () {
            return this.computedColumns.filter(function (column) { return column.hideOnForm !== true; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DynamicList.prototype, "tableColumns", {
        get: function () {
            return this.computedColumns.filter(function (column) { return column.type !== 'editor' && column.hideOnList !== true; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DynamicList.prototype, "replacementAjaxUrl", {
        get: function () {
            var element = this.deleteElement;
            if (this.replacementUrl) {
                return this.replacementUrl(element);
            }
            return this.url + '?filter[exclude]=' + element.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DynamicList.prototype, "computedDeleteLoading", {
        get: function () {
            return this.deleteLoading && this.deletingError === null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DynamicList.prototype, "modal", {
        get: function () {
            return this.$refs.modal;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DynamicList.prototype, "tbodyComponent", {
        get: function () {
            return this.sortable !== false ? (external_vuedraggable_default()) : 'tbody';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DynamicList.prototype, "tbodyAttributes", {
        get: function () {
            if (this.sortable === false) {
                return {};
            }
            return {
                tag: 'tbody',
                handle: '.sort-handler',
                list: this.elements
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DynamicList.prototype, "tbodyEvents", {
        get: function () {
            var _this = this;
            if (this.sortable === false) {
                return {};
            }
            return {
                end: function (event) {
                    _this.$nextTick(function () {
                        _this.$emit('sorted', _this.elements, event);
                    });
                }
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DynamicList.prototype, "withActions", {
        get: function () {
            var _a, _b;
            return this.canEdit || this.canDelete || ((_b = (_a = this.extraActions) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DynamicList.prototype, "cantDeleteElement", {
        get: function () {
            return this.cantDeleteLastOne !== false && this.totalRows === 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DynamicList.prototype, "cantDeleteElementMessage", {
        get: function () {
            var _a;
            return (_a = this.cantDeleteLastOneMessage) !== null && _a !== void 0 ? _a : this.$t('interface.canDeleteLastOne');
        },
        enumerable: false,
        configurable: true
    });
    // Function called when page is changed
    DynamicList.prototype.pageChanged = function (page) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.currentPage = page;
                        return [4 /*yield*/, this.getDatas()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // Function called when parameters is changed
    DynamicList.prototype.reloadDatas = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.currentPage = 1;
                        return [4 /*yield*/, this.getDatas()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // Get datas from server
    DynamicList.prototype.getDatas = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.$kwInterface.axios
                                .get(this.url, {
                                params: this.computedDatas
                            })
                                .then(function (response) {
                                var datas = response.data;
                                _this.parseMeta(datas.meta);
                                _this.elements = datas.data;
                                _this.loading = false;
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // Event when search input change
    DynamicList.prototype.searchData = function () {
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }
        this.searchTimeout = setTimeout(this.reloadDatas, 400);
    };
    // Parse meta datas from server response
    DynamicList.prototype.parseMeta = function (meta) {
        var _a, _b;
        this.currentPage = meta.current_page;
        this.displayBegin = (_a = meta.from) !== null && _a !== void 0 ? _a : 0;
        this.displayEnd = (_b = meta.to) !== null && _b !== void 0 ? _b : 0;
        this.totalRows = meta.total;
    };
    DynamicList.prototype.createData = function () {
        var values = {};
        var columns = this.computedColumns.filter(function (column) { return Object.prototype.hasOwnProperty.call(column, 'defaultOption'); });
        columns.forEach(function (column) {
            values[column.key] = column.defaultOption;
        });
        this.formValues = values;
        this.modal.show();
    };
    // Open the form for edition
    DynamicList.prototype.updateData = function (element, index) {
        var _this = this;
        var values = {};
        this.computedColumns
            .filter(function (column) {
            return !Object.prototype.hasOwnProperty.call(column, 'cantUpdate') || column.cantUpdate !== true;
        })
            .forEach(function (column) {
            values[column.key] = _this.getEditValue(column, element);
        });
        this.formValues = values;
        this.editedElement = element;
        this.editedElementIndex = index;
        this.modal.show();
    };
    // Clean the form, called when the modal is hidden
    DynamicList.prototype.cleanForm = function () {
        this.editedElement = null;
        this.editedElementIndex = null;
        this.formValues = {};
    };
    // Event when the form is successfully submitted
    DynamicList.prototype.formSubmitted = function (response) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var idx, formElement, newIdx, original;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                idx = this.editedElementIndex;
                formElement = response.data;
                this.$emit('submitted', formElement);
                // If no index, it's a new element
                if (idx === undefined || idx === null) {
                    newIdx = this.elements.push(formElement) - 1;
                    this.totalRows++;
                    this.displayEnd++;
                    // noinspection PointlessBooleanExpressionJS
                    if (this.withDefault !== false && formElement.use_default === true) {
                        // If the element has use_default = true, set false the other elements
                        this.setDefautValues(newIdx);
                    }
                    this.sortValues();
                    this.modal.hide();
                    this.$emit('created', formElement);
                    return [2 /*return*/];
                }
                // Update the edited element
                this.elements[idx] = formElement;
                this.sortValues();
                // noinspection PointlessBooleanExpressionJS
                if (this.withDefault !== false) {
                    original = this.editedElement;
                    if (formElement.use_default === true && original.use_default !== true) {
                        this.setDefautValues(idx);
                    }
                }
                this.$emit('updated', formElement);
                return [2 /*return*/];
            });
        });
    };
    // Set the default values to false for the other elements
    DynamicList.prototype.setDefautValues = function (idx) {
        this.elements.forEach(function (el, i) {
            if (i !== idx) {
                el.use_default = false;
            }
        });
    };
    // Sort the elements
    DynamicList.prototype.sortValues = function () {
        var elements = this.elements;
        if (this.sortFunction) {
            this.elements = this.sortFunction(elements);
            return;
        }
        this.defaultSortFunction();
    };
    DynamicList.prototype.defaultSortFunction = function () {
        var _this = this;
        var sort = this.sort;
        if (!sort) {
            return;
        }
        this.elements.sort(function (a, b) {
            var sort = _this.sort;
            var valA = a[sort];
            var valB = b[sort];
            if (typeof valA !== 'number') {
                valA = valA.toUpperCase();
                valB = valB.toUpperCase();
            }
            return (valA < valB) ? -1 : (valA > valB) ? 1 : 0;
        });
    };
    // Open modal to ask confirmation for deleting element
    DynamicList.prototype.askDeleteElement = function (element, index) {
        this.deleteElement = element;
        this.deleteElementIndex = index;
        this.$root.$emit('bv::show::modal', this.deleteModalId);
    };
    // Delete an element
    DynamicList.prototype.runDeleteElement = function () {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var form, deleteElement, index;
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.forceDeleteElement) {
                            form = this.$refs.deleteWithReplacementForm;
                            form.submit();
                            return [2 /*return*/];
                        }
                        deleteElement = this.deleteElement;
                        index = this.deleteElementIndex;
                        if (!deleteElement || index === null)
                            return [2 /*return*/];
                        this.deleteLoading = true;
                        return [4 /*yield*/, this.$kwInterface.axios.delete(((_a = this.formUrl) !== null && _a !== void 0 ? _a : this.url) + '/' + deleteElement.id)
                                .then(this.successfullyDeleted)
                                .catch(function (error) {
                                var data = error.response.data;
                                if (data.error && data.error === 'need_replacement_model') {
                                    _this.deleteLoading = false;
                                    _this.forceDeleteElement = true;
                                }
                                else {
                                    if (error.response.data && error.response.data.message) {
                                        _this.deletingError = error.response.data.message;
                                    }
                                    else {
                                        throw new Error(error);
                                    }
                                }
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // Called when an element is successfully deleted
    DynamicList.prototype.successfullyDeleted = function () {
        if (this.deleteElementIndex === null || this.deleteElementIndex === undefined) {
            return;
        }
        this.elements.splice(this.deleteElementIndex, 1);
        this.sortValues();
        this.totalRows--;
        this.displayEnd--;
        this.$emit('deleted', this.deleteElement);
        this.$root.$emit('bv::hide::modal', this.deleteModalId);
    };
    // Called when delete modal is hidden
    DynamicList.prototype.cleanDeleteElement = function () {
        this.deleteElement = null;
        this.deleteElementIndex = null;
        this.deleteLoading = false;
        this.forceDeleteElement = false;
        this.deletingError = null;
    };
    // Used for return value to show in table
    DynamicList.prototype.getViewValue = function (column, element) {
        var key = column.keyShow ? column.keyShow : column.key;
        var value = key.split('.').reduce(function (o, i) { return o && o[i]; }, element);
        return column.show ? column.show(value, element) : value;
    };
    // Used for return value to form value
    DynamicList.prototype.getEditValue = function (column, element) {
        var key = column.keyValue ? column.keyValue : column.key;
        return key.split('.').reduce(function (o, i) { return o && o[i]; }, element);
    };
    // Get all rows
    DynamicList.prototype.getRows = function () {
        return this.elements;
    };
    // Return a specific row
    DynamicList.prototype.getRow = function (index) {
        return this.elements[index];
    };
    // Add a new element
    DynamicList.prototype.addRow = function (element) {
        this.elements.push(element);
        this.totalRows++;
        this.displayEnd++;
        this.sortValues();
    };
    // Update an element
    DynamicList.prototype.updateRow = function (index, element) {
        lib/* Vue */.lD.set(this.elements, index, element);
    };
    // Delete an element
    DynamicList.prototype.deleteRow = function (index) {
        lib/* Vue */.lD.delete(this.elements, index);
        this.totalRows--;
        this.displayEnd--;
    };
    // Refresh datas from server
    DynamicList.prototype.refresh = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDatas()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], DynamicList.prototype, "url", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)()
    ], DynamicList.prototype, "formUrl", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], DynamicList.prototype, "createTitle", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], DynamicList.prototype, "updateTitle", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], DynamicList.prototype, "deleteMsg", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], DynamicList.prototype, "deleteAlertMessage", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: function () { return ({}); } })
    ], DynamicList.prototype, "datas", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true, default: function () { return []; } })
    ], DynamicList.prototype, "columns", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], DynamicList.prototype, "withDefault", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], DynamicList.prototype, "withActiveStatus", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], DynamicList.prototype, "sort", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], DynamicList.prototype, "sortFunction", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], DynamicList.prototype, "modalSize", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], DynamicList.prototype, "replacementMessage", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], DynamicList.prototype, "replacementUrl", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)()
    ], DynamicList.prototype, "replacementOptionLabel", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)()
    ], DynamicList.prototype, "replacementOptionValue", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], DynamicList.prototype, "customForm", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], DynamicList.prototype, "customFormProperties", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], DynamicList.prototype, "extraActions", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: '85px' })
    ], DynamicList.prototype, "actionsColWidth", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], DynamicList.prototype, "exportable", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], DynamicList.prototype, "sortable", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], DynamicList.prototype, "cantDeleteLastOne", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], DynamicList.prototype, "cantDeleteLastOneMessage", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 0 })
    ], DynamicList.prototype, "deleteColumnIndex", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], DynamicList.prototype, "withoutAddButton", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: true })
    ], DynamicList.prototype, "searchable", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: true })
    ], DynamicList.prototype, "canEdit", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: true })
    ], DynamicList.prototype, "canDelete", void 0);
    DynamicList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BFormRow: external_bootstrap_vue_.BFormRow, BCol: external_bootstrap_vue_.BCol, BButton: external_bootstrap_vue_.BButton, BRow: external_bootstrap_vue_.BRow, BPagination: external_bootstrap_vue_.BPagination, BFormGroup: external_bootstrap_vue_.BFormGroup, BModal: external_bootstrap_vue_.BModal,
                KFormInput: form_vue_.KFormInput, KFormSelect: form_vue_.KFormSelect, KForm: form_vue_.KForm, KFormEditor: form_vue_.KFormEditor, KFormNumber: form_vue_.KFormNumber, KFormCheckbox: form_vue_.KFormCheckbox, KFormTextarea: form_vue_.KFormTextarea,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                FormModal: FormModal/* default */.A,
                ExportDatas: table_vue_.Export,
                TextareaView: TextareaView/* default */.A,
                draggable: (external_vuedraggable_default())
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], DynamicList);
    return DynamicList;
}(lib/* Vue */.lD));
/* harmony default export */ var DynamicListvue_type_script_lang_ts_external = (DynamicList);

;// ./src/components/DynamicList/DynamicList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var DynamicList_DynamicListvue_type_script_lang_ts_external = (DynamicListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/DynamicList/DynamicList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  DynamicList_DynamicListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DynamicList_DynamicList = (component.exports);

/***/ }),

/***/ 3471:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "img/logo-public.92d21c36.png";

/***/ }),

/***/ 3478:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var se = moment.defineLocale('se', {
        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
            '_'
        ),
        monthsShort:
            'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
        weekdays:
            'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
                '_'
            ),
        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'MMMM D. [b.] YYYY',
            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
        },
        calendar: {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s geažes',
            past: 'maŋit %s',
            s: 'moadde sekunddat',
            ss: '%d sekunddat',
            m: 'okta minuhta',
            mm: '%d minuhtat',
            h: 'okta diimmu',
            hh: '%d diimmut',
            d: 'okta beaivi',
            dd: '%d beaivvit',
            M: 'okta mánnu',
            MM: '%d mánut',
            y: 'okta jahki',
            yy: '%d jagit',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return se;

})));


/***/ }),

/***/ 3488:
/***/ (function(module) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ 3497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ Disconnect_Disconnect; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Disconnect/Disconnect.vue?vue&type=template&id=77b76c78
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form',{attrs:{"action":"/auth/logout","method":"post","beforeSubmit":_vm.beforeSubmit},on:{"submitComplete":_vm.submitComplete}},[_c('b-button',{attrs:{"type":"submit","variant":_vm.variant}},[_vm._v(" "+_vm._s(_vm.computedLabel)+" ")])],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Disconnect/Disconnect.ts?vue&type=script&lang=ts&external





var Disconnect = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(Disconnect, _super);
    function Disconnect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Disconnect.prototype, "computedLabel", {
        get: function () {
            var _a;
            return (_a = this.label) !== null && _a !== void 0 ? _a : this.$t('interface.auth.disconnect');
        },
        enumerable: false,
        configurable: true
    });
    Disconnect.prototype.beforeSubmit = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.$kwInterface.withCsrf) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.$kwInterface.axios.get('/csrf-cookie')];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    Disconnect.prototype.submitComplete = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                this.setToken(null);
                if (this.redirectAfterLogout) {
                    this.$router.push({ name: 'login' });
                }
                this.$emit('logout');
                return [2 /*return*/];
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], Disconnect.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'link' })
    ], Disconnect.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: true })
    ], Disconnect.prototype, "redirectAfterLogout", void 0);
    Disconnect = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('auth', ['setToken'])),
            components: {
                BButton: external_bootstrap_vue_.BButton,
                KForm: form_vue_.KForm
            }
        })
    ], Disconnect);
    return Disconnect;
}(lib/* Vue */.lD));
/* harmony default export */ var Disconnectvue_type_script_lang_ts_external = (Disconnect);

;// ./src/components/Disconnect/Disconnect.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var Disconnect_Disconnectvue_type_script_lang_ts_external = (Disconnectvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/Disconnect/Disconnect.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  Disconnect_Disconnectvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Disconnect_Disconnect = (component.exports);

/***/ }),

/***/ 3508:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eu = moment.defineLocale('eu', {
        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
            '_'
        ),
        monthsShort:
            'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
                '_'
            ),
        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY[ko] MMMM[ren] D[a]',
            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l: 'YYYY-M-D',
            ll: 'YYYY[ko] MMM D[a]',
            lll: 'YYYY[ko] MMM D[a] HH:mm',
            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
        },
        calendar: {
            sameDay: '[gaur] LT[etan]',
            nextDay: '[bihar] LT[etan]',
            nextWeek: 'dddd LT[etan]',
            lastDay: '[atzo] LT[etan]',
            lastWeek: '[aurreko] dddd LT[etan]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s barru',
            past: 'duela %s',
            s: 'segundo batzuk',
            ss: '%d segundo',
            m: 'minutu bat',
            mm: '%d minutu',
            h: 'ordu bat',
            hh: '%d ordu',
            d: 'egun bat',
            dd: '%d egun',
            M: 'hilabete bat',
            MM: '%d hilabete',
            y: 'urte bat',
            yy: '%d urte',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eu;

})));


/***/ }),

/***/ 3530:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'building';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f1ad';
var svgPathData = 'M436 480h-20V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v456H12c-6.627 0-12 5.373-12 12v20h448v-20c0-6.627-5.373-12-12-12zM128 76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76zm0 96c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40zm52 148h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12zm76 160h-64v-84c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v84zm64-172c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.UR = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 3601:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var da = moment.defineLocale('da', {
        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'på dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[i] dddd[s kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'få sekunder',
            ss: '%d sekunder',
            m: 'et minut',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dage',
            M: 'en måned',
            MM: '%d måneder',
            y: 'et år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return da;

})));


/***/ }),

/***/ 3605:
/***/ (function(module) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 3615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ PageHeaderButtons_PageHeaderButtons; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/PageHeaderButtons/PageHeaderButtons.vue?vue&type=template&id=33f8988c
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.isResponsive)?_c('b-dropdown',{staticClass:"responsive-menu",attrs:{"text":_vm.$t('interface.menu'),"size":"sm","variant":"primary"}},[_vm._l((_vm.buttons),function(button,i){return [(button.disabled)?_c('b-dropdown-item',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: button.title, disabled: button.title === undefined }),expression:"{ title: button.title, disabled: button.title === undefined }"}],key:i,attrs:{"disabled":""}},[(button.icon)?_c('font-awesome-icon',{attrs:{"icon":button.icon}}):_vm._e(),_vm._v(" "+_vm._s(button.label)+" ")],1):(button.items)?[_c('b-dropdown-divider',{key:'divider-' + i}),_c('b-dropdown-group',{key:i,attrs:{"variant":button.variant ? button.variant : 'primary',"size":"sm","header":button.label}},[_vm._l((_vm.subButtons(button.items)),function(item,j){return [(item.component)?_c(item.component,_vm._g(_vm._b({directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: item.title, disabled: item.title === undefined, placement: 'right' }),expression:"{ title: item.title, disabled: item.title === undefined, placement: 'right' }"}],key:j,tag:"component"},'component',_vm.getButtonAttributes(item, false),false),_vm.getButtonEvents(item))):_c('b-dropdown-item',_vm._g(_vm._b({directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: item.title, disabled: item.title === undefined, placement: 'right' }),expression:"{ title: item.title, disabled: item.title === undefined, placement: 'right' }"}],key:j},'b-dropdown-item',_vm.getButtonAttributes(item, false),false),_vm.getButtonEvents(item)),[_vm._v(" "+_vm._s(item.label)+" ")])]})],2),_c('b-dropdown-divider',{key:'divider2-' + i})]:(button.component)?_c(button.component,_vm._g(_vm._b({directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: button.title, disabled: button.title === undefined }),expression:"{ title: button.title, disabled: button.title === undefined }"}],key:i,tag:"component"},'component',_vm.getButtonAttributes(button),false),_vm.getButtonEvents(button))):_c('b-dropdown-item',_vm._g(_vm._b({directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: button.title, disabled: button.title === undefined }),expression:"{ title: button.title, disabled: button.title === undefined }"}],key:i},'b-dropdown-item',_vm.getButtonAttributes(button),false),_vm.getButtonEvents(button)),[(button.icon)?_c('font-awesome-icon',{attrs:{"icon":button.icon}}):_vm._e(),_vm._v(" "+_vm._s(button.label)+" ")],1)]})],2):_c('b-button-group',[_vm._l((_vm.buttons),function(button,i){return [(button.disabled)?_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: button.title, disabled: button.title === undefined }),expression:"{ title: button.title, disabled: button.title === undefined }"}],key:i,staticClass:"btn-disabled"},[_c('div',{class:'btn btn-' + (button.variant ? button.variant : 'primary') + ' btn-sm disabled'},[(button.icon)?_c('font-awesome-icon',{attrs:{"icon":button.icon}}):_vm._e(),_vm._v(" "+_vm._s(button.label)+" ")],1)]):(button.items)?_c('b-dropdown',{key:i,attrs:{"variant":button.variant ? button.variant : 'primary',"size":"sm"},scopedSlots:_vm._u([{key:"button-content",fn:function(){return [_c('span',[(button.icon)?_c('font-awesome-icon',{attrs:{"icon":button.icon}}):_vm._e(),_vm._v(" "+_vm._s(button.label)+" ")],1)]},proxy:true}],null,true)},[_vm._l((_vm.subButtons(button.items)),function(item,i){return [(item.isSeparator)?_c('b-dropdown-divider',{key:i}):(item.component)?_c(item.component,_vm._g(_vm._b({directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: item.title, disabled: item.title === undefined, placement: 'right' }),expression:"{ title: item.title, disabled: item.title === undefined, placement: 'right' }"}],key:i,tag:"component"},'component',_vm.getButtonAttributes(item, false),false),_vm.getButtonEvents(item))):_c('b-dropdown-item',_vm._g(_vm._b({directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: item.title, disabled: item.title === undefined, placement: 'right' }),expression:"{ title: item.title, disabled: item.title === undefined, placement: 'right' }"}],key:i},'b-dropdown-item',_vm.getButtonAttributes(item, false),false),_vm.getButtonEvents(item)),[_vm._v(" "+_vm._s(item.label)+" ")])]})],2):(button.component)?_c(button.component,_vm._g(_vm._b({directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: button.title, disabled: button.title === undefined }),expression:"{ title: button.title, disabled: button.title === undefined }"}],key:i,tag:"component"},'component',_vm.getButtonAttributes(button),false),_vm.getButtonEvents(button))):_c('b-button',_vm._g(_vm._b({directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: button.title, disabled: button.title === undefined }),expression:"{ title: button.title, disabled: button.title === undefined }"}],key:i},'b-button',_vm.getButtonAttributes(button),false),_vm.getButtonEvents(button)),[(button.icon)?_c('font-awesome-icon',{attrs:{"icon":button.icon}}):_vm._e(),_vm._v(" "+_vm._s(button.label)+" ")],1)]})],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: ./src/mixins/PageHeaderMixin.ts
var PageHeaderMixin = __webpack_require__(8484);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: ./node_modules/lodash/forEach.js
var forEach = __webpack_require__(9754);
var forEach_default = /*#__PURE__*/__webpack_require__.n(forEach);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(9356);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/PageHeaderButtons/PageHeaderButtons.ts?vue&type=script&lang=ts&external







var PageHeaderButtons = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PageHeaderButtons, _super);
    function PageHeaderButtons() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(PageHeaderButtons.prototype, "isResponsive", {
        get: function () {
            return this.noResponsive === false && this.windowWidth <= this.responsiveBreakpoint && this.buttons.length > this.responsiveElementCount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PageHeaderButtons.prototype, "subButtons", {
        get: function () {
            var _this = this;
            return function (buttons) {
                return buttons.filter(function (button) {
                    return _this.showMenuEntry(button)
                        && (button.userPermission === undefined || _this.can(button.userPermission[0], button.userPermission[1]));
                });
            };
        },
        enumerable: false,
        configurable: true
    });
    PageHeaderButtons.prototype.getButtonAttributes = function (button, topLevel) {
        if (topLevel === void 0) { topLevel = true; }
        var attr = {
            variant: button.variant ? button.variant : (topLevel ? 'primary' : null),
            size: 'sm',
            disabled: button.disabled
        };
        if ('to' in button) {
            attr.to = button.to;
        }
        if ('href' in button) {
            attr.href = button.href;
            attr.target = button.target;
        }
        if ('attributes' in button) {
            forEach_default()(button.attributes, function (value, key) {
                attr[key] = value;
            });
        }
        return attr;
    };
    PageHeaderButtons.prototype.getButtonEvents = function (button) {
        var _this = this;
        var events = {};
        if ('modal' in button) {
            var modal_1 = button.modal;
            if (modal_1) {
                events.click = function () { return _this.openModal(modal_1); };
            }
        }
        else if ('click' in button) {
            events.click = button.click;
        }
        if ('events' in button) {
            forEach_default()(button.events, function (value, key) {
                events[key] = value;
            });
        }
        return events;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], PageHeaderButtons.prototype, "buttons", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], PageHeaderButtons.prototype, "noResponsive", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 900 })
    ], PageHeaderButtons.prototype, "responsiveBreakpoint", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 2 })
    ], PageHeaderButtons.prototype, "responsiveElementCount", void 0);
    PageHeaderButtons = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('dynamicModals', ['openModal'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['can'])), (0,external_vuex_.mapState)('app', ['windowWidth'])),
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            },
            components: {
                BButtonGroup: external_bootstrap_vue_.BButtonGroup, BDropdown: external_bootstrap_vue_.BDropdown, BDropdownDivider: external_bootstrap_vue_.BDropdownDivider, BDropdownItem: external_bootstrap_vue_.BDropdownItem, BButton: external_bootstrap_vue_.BButton, BDropdownGroup: external_bootstrap_vue_.BDropdownGroup,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
            }
        })
    ], PageHeaderButtons);
    return PageHeaderButtons;
}((0,lib/* Mixins */.Xe)(PageHeaderMixin/* default */.A)));
/* harmony default export */ var PageHeaderButtonsvue_type_script_lang_ts_external = (PageHeaderButtons);

;// ./src/components/PageHeaderButtons/PageHeaderButtons.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var PageHeaderButtons_PageHeaderButtonsvue_type_script_lang_ts_external = (PageHeaderButtonsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/PageHeaderButtons/PageHeaderButtons.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  PageHeaderButtons_PageHeaderButtonsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PageHeaderButtons_PageHeaderButtons = (component.exports);

/***/ }),

/***/ 3635:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cv = moment.defineLocale('cv', {
        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
            '_'
        ),
        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
        weekdays:
            'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
                '_'
            ),
        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        },
        calendar: {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (output) {
                var affix = /сехет$/i.exec(output)
                    ? 'рен'
                    : /ҫул$/i.exec(output)
                      ? 'тан'
                      : 'ран';
                return output + affix;
            },
            past: '%s каялла',
            s: 'пӗр-ик ҫеккунт',
            ss: '%d ҫеккунт',
            m: 'пӗр минут',
            mm: '%d минут',
            h: 'пӗр сехет',
            hh: '%d сехет',
            d: 'пӗр кун',
            dd: '%d кун',
            M: 'пӗр уйӑх',
            MM: '%d уйӑх',
            y: 'пӗр ҫул',
            yy: '%d ҫул',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal: '%d-мӗш',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return cv;

})));


/***/ }),

/***/ 3650:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(4335);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 3656:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(9325),
    stubFalse = __webpack_require__(9935);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 3661:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(3040),
    mapCacheDelete = __webpack_require__(7670),
    mapCacheGet = __webpack_require__(289),
    mapCacheHas = __webpack_require__(4509),
    mapCacheSet = __webpack_require__(2949);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 3663:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(1799),
    getMatchData = __webpack_require__(776),
    matchesStrictComparable = __webpack_require__(7197);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),

/***/ 3670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_UserProfileView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/UserProfileView.vue?vue&type=template&id=2e9004ec
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.viewComponent,{tag:"component"})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/UserProfileView.vue?vue&type=script&lang=ts


var UserProfileView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(UserProfileView, _super);
    function UserProfileView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(UserProfileView.prototype, "viewComponent", {
        get: function () {
            return this.$kwInterface.userProfileView;
        },
        enumerable: false,
        configurable: true
    });
    UserProfileView = (0,tslib_es6/* __decorate */.Cg)([
        lib/* Component */.uA
    ], UserProfileView);
    return UserProfileView;
}(lib/* Vue */.lD));
/* harmony default export */ var UserProfileViewvue_type_script_lang_ts = (UserProfileView);

;// ./src/views/UserProfileView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_UserProfileViewvue_type_script_lang_ts = (UserProfileViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/UserProfileView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_UserProfileViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_UserProfileView = (component.exports);

/***/ }),

/***/ 3693:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArrayLike = __webpack_require__(4894),
    isObjectLike = __webpack_require__(346);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),

/***/ 3702:
/***/ (function(module) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 3729:
/***/ (function(module) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),

/***/ 3739:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ml = moment.defineLocale('ml', {
        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
            '_'
        ),
        monthsShort:
            'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
                '_'
            ),
        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm -നു',
            LTS: 'A h:mm:ss -നു',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm -നു',
            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
        },
        calendar: {
            sameDay: '[ഇന്ന്] LT',
            nextDay: '[നാളെ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ഇന്നലെ] LT',
            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s കഴിഞ്ഞ്',
            past: '%s മുൻപ്',
            s: 'അൽപ നിമിഷങ്ങൾ',
            ss: '%d സെക്കൻഡ്',
            m: 'ഒരു മിനിറ്റ്',
            mm: '%d മിനിറ്റ്',
            h: 'ഒരു മണിക്കൂർ',
            hh: '%d മണിക്കൂർ',
            d: 'ഒരു ദിവസം',
            dd: '%d ദിവസം',
            M: 'ഒരു മാസം',
            MM: '%d മാസം',
            y: 'ഒരു വർഷം',
            yy: '%d വർഷം',
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'രാത്രി' && hour >= 4) ||
                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                meridiem === 'വൈകുന്നേരം'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'രാത്രി';
            } else if (hour < 12) {
                return 'രാവിലെ';
            } else if (hour < 17) {
                return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
                return 'വൈകുന്നേരം';
            } else {
                return 'രാത്രി';
            }
        },
    });

    return ml;

})));


/***/ }),

/***/ 3757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  jg: function() { return /* binding */ formatToDisplay; },
  hB: function() { return /* binding */ getNbDecimals; },
  LI: function() { return /* binding */ round; },
  Zo: function() { return /* binding */ showNumber; },
  Ro: function() { return /* binding */ toNumber; }
});

;// external "numeral"
var external_numeral_namespaceObject = require("numeral");
var external_numeral_default = /*#__PURE__*/__webpack_require__.n(external_numeral_namespaceObject);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
;// ./src/utils/number.ts


// Return a number
var toNumber = function (val) {
    if (val === undefined || val === null) {
        return 0;
    }
    else if (typeof val === 'string') {
        return parseFloat(val);
    }
    return val;
};
// Round a number
var round = function (number, decimal) {
    var numSign = number >= 0 ? 1 : -1;
    return parseFloat((Math.round((number * Math.pow(10, decimal)) + (numSign * 0.0001)) / Math.pow(10, decimal)).toFixed(decimal));
};
// Show a number
var showNumber = function (number, decimal, minDecimal) {
    if (number === undefined) {
        number = 0;
    }
    else if (typeof number === 'string') {
        number = toNumber(number);
    }
    if (decimal) {
        number = round(number, decimal);
    }
    else if (number !== null) {
        number = number.toString();
    }
    if (number !== null && decimal !== null && minDecimal !== null && minDecimal !== undefined && getNbDecimals(number) < minDecimal) {
        number = Number(number).toFixed(minDecimal);
    }
    return number;
};
// Count the number of decimals
var getNbDecimals = function (number) {
    if (typeof number === 'string') {
        number = Number(number);
    }
    if (Math.floor(number) === number) {
        return 0;
    }
    return number.toString().split('.')[1].length || 0;
};
// Show a formatted number
var formatToDisplay = function (number, currency) {
    if (currency === void 0) { currency = null; }
    var config = lib/* Vue */.lD.prototype.$kwInterface.store.getters['user/teamConfigs'];
    var formatted = external_numeral_default()(number).format('0,0.00[000]');
    // Thousands separator
    switch (config.number_format_number_thousands) {
        case 'space':
            formatted = formatted.replaceAll(',', ' ');
            break;
        case 'none':
            formatted = formatted.replaceAll(',', '');
            break;
    }
    // Decimals separator
    if (config.number_format_decimals === ',') {
        formatted = formatted.replaceAll('.', ',');
    }
    if (currency !== false) {
        var sigle = currency ? currency.symbol : config.currency.symbol;
        switch (config.currency_position) {
            case 'before':
                formatted = sigle + ' ' + formatted;
                break;
            case 'after':
                formatted += ' ' + sigle;
                break;
        }
    }
    return formatted;
};



/***/ }),

/***/ 3784:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^(maart|mrt\.?)$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex =
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nlBe = moment.defineLocale('nl-be', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex:
            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays:
            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nlBe;

})));


/***/ }),

/***/ 3805:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 3808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ AppMessages_AppMessages; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AppMessages/AppMessages.vue?vue&type=template&id=768246d9
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{
  'app-messages': true,
  'mb-3': _vm.messages.length > 0
}},_vm._l((_vm.messages),function(message){return _c('AppMessage',{key:message.id,attrs:{"value":message}})}),1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: ./src/components/AppMessage/AppMessage.vue + 3 modules
var AppMessage = __webpack_require__(848);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: ./src/utils/date.ts + 1 modules
var date = __webpack_require__(4755);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/AppMessages/AppMessages.ts?vue&type=script&lang=ts&external





var AppMessages = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(AppMessages, _super);
    function AppMessages() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AppMessages.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadAppMessages()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(AppMessages.prototype, "messages", {
        get: function () {
            var _this = this;
            return this.appMessages.filter(function (message) {
                return (message.ident === _this.$route.name || message.ident === _this.$route.path)
                    && (message.expire_at === null || (0,date/* moment */.n$)(message.expire_at).isSameOrAfter((0,date/* moment */.n$)(), 'day'));
            }).slice(0, 3);
        },
        enumerable: false,
        configurable: true
    });
    AppMessages = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                AppMessage: AppMessage/* default */.A
            },
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('user', ['loadAppMessages'])),
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('user', ['appMessages']))
        })
    ], AppMessages);
    return AppMessages;
}(lib/* Vue */.lD));
/* harmony default export */ var AppMessagesvue_type_script_lang_ts_external = (AppMessages);

;// ./src/components/AppMessages/AppMessages.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var AppMessages_AppMessagesvue_type_script_lang_ts_external = (AppMessagesvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/AppMessages/AppMessages.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  AppMessages_AppMessagesvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AppMessages_AppMessages = (component.exports);

/***/ }),

/***/ 3827:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ja = moment.defineLocale('ja', {
        eras: [
            {
                since: '2019-05-01',
                offset: 1,
                name: '令和',
                narrow: '㋿',
                abbr: 'R',
            },
            {
                since: '1989-01-08',
                until: '2019-04-30',
                offset: 1,
                name: '平成',
                narrow: '㍻',
                abbr: 'H',
            },
            {
                since: '1926-12-25',
                until: '1989-01-07',
                offset: 1,
                name: '昭和',
                narrow: '㍼',
                abbr: 'S',
            },
            {
                since: '1912-07-30',
                until: '1926-12-24',
                offset: 1,
                name: '大正',
                narrow: '㍽',
                abbr: 'T',
            },
            {
                since: '1873-01-01',
                until: '1912-07-29',
                offset: 6,
                name: '明治',
                narrow: '㍾',
                abbr: 'M',
            },
            {
                since: '0001-01-01',
                until: '1873-12-31',
                offset: 1,
                name: '西暦',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: '紀元前',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        eraYearOrdinalRegex: /(元|\d+)年/,
        eraYearOrdinalParse: function (input, match) {
            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
        },
        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日 dddd HH:mm',
            l: 'YYYY/MM/DD',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日(ddd) HH:mm',
        },
        meridiemParse: /午前|午後/i,
        isPM: function (input) {
            return input === '午後';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar: {
            sameDay: '[今日] LT',
            nextDay: '[明日] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[来週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            lastDay: '[昨日] LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[先週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}日/,
        ordinal: function (number, period) {
            switch (period) {
                case 'y':
                    return number === 1 ? '元年' : number + '年';
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '数秒',
            ss: '%d秒',
            m: '1分',
            mm: '%d分',
            h: '1時間',
            hh: '%d時間',
            d: '1日',
            dd: '%d日',
            M: '1ヶ月',
            MM: '%dヶ月',
            y: '1年',
            yy: '%d年',
        },
    });

    return ja;

})));


/***/ }),

/***/ 3838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ TeamApiToken_TeamApiToken; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TeamApiToken/TeamApiToken.vue?vue&type=template&id=40d20c60
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('PageHeader',{attrs:{"pageTitle":_vm.$t('interface.pageTitle.apiToken'),"buttons":_vm.buttons}}),(_vm.$kwInterface.appMessages)?_c('AppMessages'):_vm._e(),(_vm.$kwInterface.apiDocumentationUrl)?_c('p',[_vm._v(" "+_vm._s(_vm.$t('interface.apiToken.documentation'))+" "),_c('a',{attrs:{"href":_vm.$kwInterface.apiDocumentationUrl,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.$kwInterface.apiDocumentationUrl)+" ")])]):_vm._e(),_c('DynamicList',{ref:"list",attrs:{"searchable":false,"sort":"id","url":"/api_token","columns":_vm.columns,"createTitle":_vm.$t('interface.apiToken.new'),"updateTitle":_vm.$t('interface.apiToken.edit'),"deleteMsg":_vm.$t('interface.apiToken.deleteMsg'),"customForm":_vm.formComponent,"modalSize":"lg","closeOnSubmit":"","withoutAddButton":""}}),_c('FormModal',{attrs:{"size":_vm.created ? 'md' : 'lg',"title":_vm.created ? null : _vm.$t('interface.apiToken.new'),"closeOnSubmit":false,"ok-only":_vm.created !== null,"ok-title":_vm.$t('interface.save')},on:{"submitComplete":_vm.submitComplete,"hidden":function($event){_vm.created = null}},model:{value:(_vm.add),callback:function ($$v) {_vm.add=$$v},expression:"add"}},[(_vm.created)?_c('b-alert',{staticClass:"text-center mb-0",attrs:{"variant":"warning","show":""}},[_c('p',[_vm._v(" "+_vm._s(_vm.$t('interface.apiToken.copyLine1'))),_c('br'),_vm._v(" "+_vm._s(_vm.$t('interface.apiToken.copyLine2'))+" ")]),_c('b-form-row',[_c('b-col',[_c('k-form-input',{staticClass:"text-center",attrs:{"value":_vm.created.token}})],1),_c('b-col',{staticClass:"pt-1",attrs:{"cols":"auto"}},[_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.copy.apply(null, arguments)}}},[(!_vm.copied)?[_vm._v(" "+_vm._s(_vm.$t('interface.apiToken.copy'))+" ")]:[_vm._v(" "+_vm._s(_vm.$t('interface.apiToken.copied'))+" ")]],2)],1)],1)],1):_c('TeamApiTokenForm')],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: ./src/components/DynamicList/DynamicList.vue + 4 modules
var DynamicList = __webpack_require__(3425);
// EXTERNAL MODULE: ./src/mixins/DateMixin.ts
var DateMixin = __webpack_require__(4774);
// EXTERNAL MODULE: ./src/components/TeamApiTokenForm/TeamApiTokenForm.vue + 3 modules
var TeamApiTokenForm = __webpack_require__(5324);
// EXTERNAL MODULE: ./src/components/PageHeader/PageHeader.vue + 3 modules
var PageHeader = __webpack_require__(6124);
// EXTERNAL MODULE: ./src/components/FormModal/FormModal.vue + 2 modules
var FormModal = __webpack_require__(7401);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: ./src/components/AppMessages/AppMessages.vue + 3 modules
var AppMessages = __webpack_require__(3808);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/TeamApiToken/TeamApiToken.ts?vue&type=script&lang=ts&external










var TeamApiToken = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TeamApiToken, _super);
    function TeamApiToken() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formComponent = TeamApiTokenForm/* default */.A;
        _this.add = false;
        _this.created = null;
        _this.copied = false;
        return _this;
    }
    Object.defineProperty(TeamApiToken.prototype, "buttons", {
        get: function () {
            var _this = this;
            return [
                {
                    label: 'Ajouter',
                    click: function () {
                        _this.add = true;
                    }
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TeamApiToken.prototype, "columns", {
        get: function () {
            var _this = this;
            return [
                {
                    label: this.$t('interface.apiToken.name'),
                    key: 'name'
                },
                {
                    label: this.$t('interface.apiToken.createdAt'),
                    key: 'created_at',
                    show: function (val) { return _this.datetime(val); },
                    class: 'd-none d-md-table-cell'
                },
                {
                    label: this.$t('interface.apiToken.expireAt'),
                    key: 'expires_at',
                    show: function (val) { return _this.datetime(val); },
                    class: 'd-none d-md-table-cell'
                },
                {
                    label: this.$t('interface.apiToken.lastUse'),
                    key: 'last_used_at',
                    show: function (val) { return _this.datetime(val); },
                    class: 'd-none d-md-table-cell'
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    TeamApiToken.prototype.submitComplete = function (response) {
        var token = response.data;
        this.$refs.list.addRow(token);
        this.created = token;
    };
    TeamApiToken.prototype.copy = function () {
        var _this = this;
        if (this.created) {
            navigator.clipboard.writeText(this.created.token);
            this.copied = true;
            setTimeout(function () { return _this.copied = false; }, 2000);
        }
    };
    TeamApiToken = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                DynamicList: DynamicList/* default */.A,
                PageHeader: PageHeader/* default */.A,
                TeamApiTokenForm: TeamApiTokenForm/* default */.A,
                FormModal: FormModal/* default */.A,
                BAlert: external_bootstrap_vue_.BAlert, BButton: external_bootstrap_vue_.BButton, BFormRow: external_bootstrap_vue_.BFormRow, BCol: external_bootstrap_vue_.BCol,
                KFormInput: form_vue_.KFormInput,
                AppMessages: AppMessages/* default */.A
            }
        })
    ], TeamApiToken);
    return TeamApiToken;
}((0,lib/* Mixins */.Xe)(DateMixin/* default */.A)));
/* harmony default export */ var TeamApiTokenvue_type_script_lang_ts_external = (TeamApiToken);

;// ./src/components/TeamApiToken/TeamApiToken.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var TeamApiToken_TeamApiTokenvue_type_script_lang_ts_external = (TeamApiTokenvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/TeamApiToken/TeamApiToken.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  TeamApiToken_TeamApiTokenvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TeamApiToken_TeamApiToken = (component.exports);

/***/ }),

/***/ 3861:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        },
        monthsParse = [
            /^जन/i,
            /^फ़र|फर/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सितं|सित/i,
            /^अक्टू/i,
            /^नव|नवं/i,
            /^दिसं|दिस/i,
        ],
        shortMonthsParse = [
            /^जन/i,
            /^फ़र/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सित/i,
            /^अक्टू/i,
            /^नव/i,
            /^दिस/i,
        ];

    var hi = moment.defineLocale('hi', {
        months: {
            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
                '_'
            ),
            standalone:
                'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
                    '_'
                ),
        },
        monthsShort:
            'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm बजे',
            LTS: 'A h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
        },

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: shortMonthsParse,

        monthsRegex:
            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsShortRegex:
            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsStrictRegex:
            /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,

        monthsShortStrictRegex:
            /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,

        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[कल] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[कल] LT',
            lastWeek: '[पिछले] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s में',
            past: '%s पहले',
            s: 'कुछ ही क्षण',
            ss: '%d सेकंड',
            m: 'एक मिनट',
            mm: '%d मिनट',
            h: 'एक घंटा',
            hh: '%d घंटे',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महीने',
            MM: '%d महीने',
            y: 'एक वर्ष',
            yy: '%d वर्ष',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
                return hour;
            } else if (meridiem === 'दोपहर') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात';
            } else if (hour < 10) {
                return 'सुबह';
            } else if (hour < 17) {
                return 'दोपहर';
            } else if (hour < 20) {
                return 'शाम';
            } else {
                return 'रात';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return hi;

})));


/***/ }),

/***/ 3862:
/***/ (function(module) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 3872:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enAu = moment.defineLocale('en-au', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enAu;

})));


/***/ }),

/***/ 3928:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'user-friends';
var width = 640;
var height = 512;
var ligatures = [];
var unicode = 'f500';
var svgPathData = 'M192 256c61.9 0 112-50.1 112-112S253.9 32 192 32 80 82.1 80 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C51.6 288 0 339.6 0 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zM480 256c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96zm48 32h-3.8c-13.9 4.8-28.6 8-44.2 8s-30.3-3.2-44.2-8H432c-20.4 0-39.2 5.9-55.7 15.4 24.4 26.3 39.7 61.2 39.7 99.8v38.4c0 2.2-.5 4.3-.6 6.4H592c26.5 0 48-21.5 48-48 0-61.9-50.1-112-112-112z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.O2 = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 3945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ AppLogos_AppLogos; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AppLogos/AppLogos.vue?vue&type=template&id=5f7e5f43
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-overlay',{attrs:{"show":_vm.loading}},[_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('interface.customize.logo')))]),_c('th',[_vm._v(_vm._s(_vm.$t('interface.customize.example')))]),_c('th',[_vm._v(_vm._s(_vm.$t('interface.customize.myLogo')))])])]),_c('tbody',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('interface.customize.logoSideBar')))]),_c('td',[_c('img',{staticClass:"my-2 border app-logo-hover p-1",staticStyle:{"max-width":"100px"},attrs:{"src":_vm.sidebarLogo,"alt":"Logo"}}),_c('p',{staticClass:"small mb-0"},[_vm._v(" "+_vm._s(_vm.$t('interface.customize.logoSidebarSize'))+" ")])]),_c('td',[(_vm.localTeam.logo_sidebar)?[_c('div',{staticClass:"mb-2"},[_c('div',{staticClass:"d-inline-block border app-logo-hover p-1"},[_c('img',{staticStyle:{"max-width":"100px"},attrs:{"src":'data:image/' +  _vm.localTeam.logo_sidebar.extension +';base64,' + _vm.localTeam.logo_sidebar.file,"alt":"logo"}})])]),_c('b-button',{attrs:{"size":"sm","variant":"secondary"},on:{"click":function($event){$event.preventDefault();return _vm.deleteLogo('logo_sidebar')}}},[_vm._v(" "+_vm._s(_vm.$t('interface.delete'))+" ")])]:_c('k-form-file',{attrs:{"url":_vm.formAction,"btnMode":"","btnSize":"sm","name":"logo_sidebar","method":"PUT","accept":['image/png', 'image/jpeg', 'image/jpg'],"validateMaxWidth":200,"validateMaxHeight":50},on:{"onUpload":_vm.applyNewTeam}})],2)]),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('interface.customize.logoCollapsedSideBar')))]),_c('td',[_c('img',{staticClass:"my-2 border",staticStyle:{"max-width":"100px"},attrs:{"src":_vm.sidebarCollapsedLogo,"alt":"Logo"}}),_c('p',{staticClass:"small mb-0"},[_vm._v(" "+_vm._s(_vm.$t('interface.customize.logoCollapsedSidebarSize'))+" ")])]),_c('td',[(_vm.localTeam.logo_sidebar_collapsed)?[_c('div',{staticClass:"mb-2"},[_c('img',{staticStyle:{"max-width":"100px"},attrs:{"src":'data:image/' +  _vm.localTeam.logo_sidebar_collapsed.extension +';base64,' + _vm.localTeam.logo_sidebar_collapsed.file,"alt":"logo"}})]),_c('b-button',{attrs:{"size":"sm","variant":"secondary"},on:{"click":function($event){$event.preventDefault();return _vm.deleteLogo('logo_sidebar_collapsed')}}},[_vm._v(" "+_vm._s(_vm.$t('interface.delete'))+" ")])]:_c('k-form-file',{attrs:{"url":_vm.formAction,"btnMode":"","btnSize":"sm","name":"logo_sidebar_collapsed","method":"PUT","accept":['image/png', 'image/jpeg', 'image/jpg'],"validateMaxWidth":30,"validateMaxHeight":35},on:{"onUpload":_vm.applyNewTeam}})],2)]),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('interface.customize.logoHiddenSideBar')))]),_c('td',[_c('img',{staticClass:"my-2 border",staticStyle:{"max-width":"100px"},attrs:{"src":_vm.sidebarHiddenLogo,"alt":"Logo"}}),_c('p',{staticClass:"small mb-0"},[_vm._v(" "+_vm._s(_vm.$t('interface.customize.logoHiddenSidebarSize'))+" ")])]),_c('td',[(_vm.localTeam.logo_sidebar_hidden)?[_c('div',{staticClass:"mb-2"},[_c('img',{staticStyle:{"max-width":"100px"},attrs:{"src":'data:image/' +  _vm.localTeam.logo_sidebar_hidden.extension +';base64,' + _vm.localTeam.logo_sidebar_hidden.file,"alt":"logo"}})]),_c('b-button',{attrs:{"size":"sm","variant":"secondary"},on:{"click":function($event){$event.preventDefault();return _vm.deleteLogo('logo_sidebar_hidden')}}},[_vm._v(" "+_vm._s(_vm.$t('interface.delete'))+" ")])]:_c('k-form-file',{attrs:{"url":_vm.formAction,"btnMode":"","btnSize":"sm","name":"logo_sidebar_hidden","method":"PUT","accept":['image/png', 'image/jpeg', 'image/jpg'],"validateMaxWidth":200,"validateMaxHeight":50},on:{"onUpload":_vm.applyNewTeam}})],2)])])])])
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: ./src/mixins/TeamFormMixin.ts
var TeamFormMixin = __webpack_require__(2783);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/AppLogos/AppLogos.ts?vue&type=script&lang=ts&external





var AppLogos = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(AppLogos, _super);
    function AppLogos() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        return _this;
    }
    Object.defineProperty(AppLogos.prototype, "sidebarLogo", {
        get: function () {
            var _a;
            if ((_a = this.$kwInterface) === null || _a === void 0 ? void 0 : _a.sidebarLogo) {
                return this.$kwInterface.sidebarLogo;
            }
            var images = __webpack_require__(8141);
            return images('./logo-sidebar.png');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AppLogos.prototype, "sidebarCollapsedLogo", {
        get: function () {
            var _a;
            if ((_a = this.$kwInterface) === null || _a === void 0 ? void 0 : _a.sidebarCollapsedLogo) {
                return this.$kwInterface.sidebarCollapsedLogo;
            }
            var images = __webpack_require__(8141);
            return images('./logo-sidebar-collapsed.png');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AppLogos.prototype, "sidebarHiddenLogo", {
        get: function () {
            var _a;
            if ((_a = this.$kwInterface) === null || _a === void 0 ? void 0 : _a.sidebarHiddenLogo) {
                return this.$kwInterface.sidebarHiddenLogo;
            }
            var images = __webpack_require__(8141);
            return images('./logo-sidebar-alt.png');
        },
        enumerable: false,
        configurable: true
    });
    AppLogos.prototype.deleteLogo = function (type) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var data;
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        data = {};
                        data[type] = null;
                        return [4 /*yield*/, this.$kwInterface.axios.put(this.formAction, data)
                                .then(function (response) {
                                _this.applyNewTeam(response.data);
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AppLogos = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KFormFile: form_vue_.KFormFile,
                BButton: external_bootstrap_vue_.BButton, BAlert: external_bootstrap_vue_.BAlert, BOverlay: external_bootstrap_vue_.BOverlay
            }
        })
    ], AppLogos);
    return AppLogos;
}((0,lib/* Mixins */.Xe)(TeamFormMixin/* default */.A)));
/* harmony default export */ var AppLogosvue_type_script_lang_ts_external = (AppLogos);

;// ./src/components/AppLogos/AppLogos.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var AppLogos_AppLogosvue_type_script_lang_ts_external = (AppLogosvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/AppLogos/AppLogos.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  AppLogos_AppLogosvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AppLogos_AppLogos = (component.exports);

/***/ }),

/***/ 3966:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'edit';
var width = 576;
var height = 512;
var ligatures = [];
var unicode = 'f044';
var svgPathData = 'M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.MT = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 4016:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fad';
var iconName = 'file-powerpoint';
var width = 384;
var height = 512;
var ligatures = [];
var unicode = 'f1c4';
var svgPathData = ['M384 128H272a16 16 0 0 1-16-16V0H24A23.94 23.94 0 0 0 0 23.88V488a23.94 23.94 0 0 0 23.88 24H360a23.94 23.94 0 0 0 24-23.88V128zM165.9 378.8V436a12 12 0 0 1-12 12h-30.8a12 12 0 0 1-12-12V236.2a12 12 0 0 1 12-12h81c44.5 0 72.9 32.8 72.9 77 0 90.3-88.8 77.6-111.1 77.6zm27.8-107.6h-27.9v60.7h26.9c9.2 0 16.2-2.9 21.1-8.5 10-11.4 9.8-33.2.2-44.1-4.8-5.4-11.5-8.1-20.3-8.1z', 'M377 105L279.1 7a24 24 0 0 0-17-7H256v112a16 16 0 0 0 16 16h112v-6.1a23.9 23.9 0 0 0-7-16.9zM204.1 224.2h-81a12 12 0 0 0-12 12V436a12 12 0 0 0 12 12h30.8a12 12 0 0 0 12-12v-57.2c22.3 0 111.1 12.7 111.1-77.6 0-44.2-28.4-77-72.9-77zm9.7 99.2c-4.9 5.6-11.9 8.5-21.1 8.5h-26.9v-60.7h27.9c8.8 0 15.5 2.7 20.3 8.1 9.6 10.9 9.8 32.7-.2 44.1z'];

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.zk = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 4043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ PaymentTerms_PaymentTerms; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/PaymentTerms/PaymentTerms.vue?vue&type=template&id=5e00b8a8
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DynamicList',{attrs:{"url":_vm.apiUrl,"columns":_vm.columns,"createTitle":_vm.$t('interface.paymentTerm.new'),"updateTitle":_vm.$t('interface.paymentTerm.edit'),"deleteMsg":_vm.$t('interface.paymentTerm.deleteMsg'),"sort":"label","customForm":_vm.formComponent},on:{"submitted":_vm.setPaymentTerm,"deleted":_vm.deletePaymentTerm}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: ./src/components/DynamicList/DynamicList.vue + 4 modules
var DynamicList = __webpack_require__(3425);
// EXTERNAL MODULE: ./src/components/PaymentTermForm/PaymentTermForm.vue + 3 modules
var PaymentTermForm = __webpack_require__(6890);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/PaymentTerms/PaymentTerms.ts?vue&type=script&lang=ts&external





var PaymentTerms = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PaymentTerms, _super);
    function PaymentTerms() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formComponent = PaymentTermForm/* default */.A;
        _this.columns = [
            {
                label: _this.$t('interface.paymentTerm.label'),
                key: 'label',
                required: true
            }
        ];
        return _this;
    }
    Object.defineProperty(PaymentTerms.prototype, "apiUrl", {
        get: function () {
            return '/payment_term';
        },
        enumerable: false,
        configurable: true
    });
    PaymentTerms = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['setPaymentTerm', 'deletePaymentTerm'])),
            components: {
                DynamicList: DynamicList/* default */.A
            }
        })
    ], PaymentTerms);
    return PaymentTerms;
}(lib/* Vue */.lD));
/* harmony default export */ var PaymentTermsvue_type_script_lang_ts_external = (PaymentTerms);

;// ./src/components/PaymentTerms/PaymentTerms.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var PaymentTerms_PaymentTermsvue_type_script_lang_ts_external = (PaymentTermsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/PaymentTerms/PaymentTerms.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  PaymentTerms_PaymentTermsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PaymentTerms_PaymentTerms = (component.exports);

/***/ }),

/***/ 4051:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var xPseudo = moment.defineLocale('x-pseudo', {
        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
            '_'
        ),
        monthsShort:
            'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
                '_'
            ),
        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[T~ódá~ý át] LT',
            nextDay: '[T~ómó~rró~w át] LT',
            nextWeek: 'dddd [át] LT',
            lastDay: '[Ý~ést~érdá~ý át] LT',
            lastWeek: '[L~ást] dddd [át] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'í~ñ %s',
            past: '%s á~gó',
            s: 'á ~féw ~sécó~ñds',
            ss: '%d s~écóñ~ds',
            m: 'á ~míñ~úté',
            mm: '%d m~íñú~tés',
            h: 'á~ñ hó~úr',
            hh: '%d h~óúrs',
            d: 'á ~dáý',
            dd: '%d d~áýs',
            M: 'á ~móñ~th',
            MM: '%d m~óñt~hs',
            y: 'á ~ýéár',
            yy: '%d ý~éárs',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return xPseudo;

})));


/***/ }),

/***/ 4063:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var id = moment.defineLocale('id', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Besok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kemarin pukul] LT',
            lastWeek: 'dddd [lalu pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lalu',
            s: 'beberapa detik',
            ss: '%d detik',
            m: 'semenit',
            mm: '%d menit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return id;

})));


/***/ }),

/***/ 4066:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(3488);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),

/***/ 4151:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fal';
var iconName = 'plus-circle';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f055';
var svgPathData = 'M384 250v12c0 6.6-5.4 12-12 12h-98v98c0 6.6-5.4 12-12 12h-12c-6.6 0-12-5.4-12-12v-98h-98c-6.6 0-12-5.4-12-12v-12c0-6.6 5.4-12 12-12h98v-98c0-6.6 5.4-12 12-12h12c6.6 0 12 5.4 12 12v98h98c6.6 0 12 5.4 12 12zm120 6c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-32 0c0-119.9-97.3-216-216-216-119.9 0-216 97.3-216 216 0 119.9 97.3 216 216 216 119.9 0 216-97.3 216-216z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.OQ = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 4218:
/***/ (function(module) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 4226:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cy = moment.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
            '_'
        ),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
            '_'
        ),
        weekdays:
            'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
                '_'
            ),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact: true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            ss: '%d eiliad',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function (number) {
            var b = number,
                output = '',
                lookup = [
                    '',
                    'af',
                    'il',
                    'ydd',
                    'ydd',
                    'ed',
                    'ed',
                    'ed',
                    'fed',
                    'fed',
                    'fed', // 1af to 10fed
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'fed', // 11eg to 20fed
                ];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cy;

})));


/***/ }),

/***/ 4247:
/***/ (function(module) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ 4248:
/***/ (function(module) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ 4335:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 4359:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fad';
var iconName = 'file-pdf';
var width = 384;
var height = 512;
var ligatures = [];
var unicode = 'f1c1';
var svgPathData = ['M86.1 428.1c0 .8 13.2-5.4 34.9-40.2-6.7 6.3-29.1 24.5-34.9 40.2zm93.8-218.9c-2.9 0-3 30.9 2 46.9 5.6-10 6.4-46.9-2-46.9zm80.2 142.1c37.1 15.8 42.8 9 42.8 9 4.1-2.7-2.5-11.9-42.8-9zm-79.9-48c-7.7 20.2-17.3 43.3-28.4 62.7 18.3-7 39-17.2 62.9-21.9-12.7-9.6-24.9-23.4-34.5-40.8zM272 128a16 16 0 0 1-16-16V0H24A23.94 23.94 0 0 0 0 23.88V488a23.94 23.94 0 0 0 23.88 24H360a23.94 23.94 0 0 0 24-23.88V128zm21.9 254.4c-16.9 0-42.3-7.7-64-19.5-24.9 4.1-53.2 14.7-79 23.2-25.4 43.8-43.2 61.8-61.1 61.8-5.5 0-15.9-3.1-21.5-10-19.1-23.5 27.4-54.1 54.5-68 .1 0 .1-.1.2-.1 12.1-21.2 29.2-58.2 40.8-85.8-8.5-32.9-13.1-58.7-8.1-77 5.4-19.7 43.1-22.6 47.8 6.8 5.4 17.6-1.7 45.7-6.2 64.2 9.4 24.8 22.7 41.6 42.7 53.8 19.3-2.5 59.7-6.4 73.6 7.2 11.5 11.4 9.5 43.4-19.7 43.4z', 'M377 105L279.1 7a24 24 0 0 0-17-7H256v112a16 16 0 0 0 16 16h112v-6.1a23.9 23.9 0 0 0-7-16.9zM240 331.8c-20-12.2-33.3-29-42.7-53.8 4.5-18.5 11.6-46.6 6.2-64.2-4.7-29.4-42.4-26.5-47.8-6.8-5 18.3-.4 44.1 8.1 77-11.6 27.6-28.7 64.6-40.8 85.8-.1 0-.1.1-.2.1-27.1 13.9-73.6 44.5-54.5 68 5.6 6.9 16 10 21.5 10 17.9 0 35.7-18 61.1-61.8 25.8-8.5 54.1-19.1 79-23.2 21.7 11.8 47.1 19.5 64 19.5 29.2 0 31.2-32 19.7-43.4-13.9-13.6-54.3-9.7-73.6-7.2zM86.1 428.1c5.8-15.7 28.2-33.9 34.9-40.2-21.7 34.8-34.9 41-34.9 40.2zm93.8-218.9c8.4 0 7.6 36.9 2 46.9-5-16-4.9-46.9-2-46.9zM151.8 366c11.1-19.4 20.7-42.5 28.4-62.7 9.6 17.4 21.8 31.2 34.5 40.8-23.9 4.7-44.6 14.9-62.9 21.9zm151.1-5.7s-5.7 6.8-42.8-9c40.3-2.9 46.9 6.3 42.8 9z'];

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.O_ = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 4394:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2552),
    isObjectLike = __webpack_require__(346);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 4418:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsNominative =
            'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
                '_'
            ),
        monthsSubjective =
            'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
                '_'
            ),
        monthsParse = [
            /^sty/i,
            /^lut/i,
            /^mar/i,
            /^kwi/i,
            /^maj/i,
            /^cze/i,
            /^lip/i,
            /^sie/i,
            /^wrz/i,
            /^paź/i,
            /^lis/i,
            /^gru/i,
        ];
    function plural(n) {
        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
    }
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                return result + (plural(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix ? 'godzina' : 'godzinę';
            case 'hh':
                return result + (plural(number) ? 'godziny' : 'godzin');
            case 'ww':
                return result + (plural(number) ? 'tygodnie' : 'tygodni');
            case 'MM':
                return result + (plural(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural(number) ? 'lata' : 'lat');
        }
    }

    var pl = moment.defineLocale('pl', {
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays:
            'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W niedzielę o] LT';

                    case 2:
                        return '[We wtorek o] LT';

                    case 3:
                        return '[W środę o] LT';

                    case 6:
                        return '[W sobotę o] LT';

                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: '%s temu',
            s: 'kilka sekund',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: '1 dzień',
            dd: '%d dni',
            w: 'tydzień',
            ww: translate,
            M: 'miesiąc',
            MM: translate,
            y: 'rok',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pl;

})));


/***/ }),

/***/ 4429:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! author : Rasid Redzic : https://github.com/rasidre
//! based on (hr) translation by Bojan Marković

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 'm':
                return withoutSuffix
                    ? 'jedna minuta'
                    : isFuture
                      ? 'jednu minutu'
                      : 'jedne minute';
        }
    }

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jedan sat';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var bs = moment.defineLocale('bs', {
        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: processRelativeTime,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bs;

})));


/***/ }),

/***/ 4448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ VatRates_VatRates; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VatRates/VatRates.vue?vue&type=template&id=09dc0a7f
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DynamicList',{attrs:{"url":_vm.apiUrl,"columns":_vm.columns,"createTitle":_vm.$t('interface.vatRate.new'),"updateTitle":_vm.$t('interface.vatRate.edit'),"deleteMsg":_vm.$t('interface.vatRate.deleteMsg'),"sort":"rate","replacementMessage":_vm.$t('interface.vatRate.replacementComments'),"replacementUrl":_vm.replacementUrl,"replacementOptionLabel":_vm.replacementLabel,"withDefault":"","withActiveStatus":""},on:{"submitted":_vm.submitted,"deleted":_vm.deleted}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: ./src/components/DynamicList/DynamicList.vue + 4 modules
var DynamicList = __webpack_require__(3425);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/VatRates/VatRates.ts?vue&type=script&lang=ts&external




var VatRates = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(VatRates, _super);
    function VatRates() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.columns = [
            {
                label: _this.$t('interface.vatRate.rateLabel'),
                key: 'rate',
                type: 'number',
                show: function (rate) { return rate + ' %'; },
                cantUpdate: true
            },
            {
                label: _this.$t('interface.vatRate.label'),
                key: 'label',
                comments: _this.$t('interface.vatRate.commentsLabel'),
                required: false,
                class: 'd-none d-md-table-cell'
            },
            {
                label: _this.$t('interface.vatRate.mentionLabel'),
                key: 'legal_notice',
                required: false,
                class: 'd-none d-md-table-cell'
            },
            {
                label: _this.$t('interface.vatRate.rateAccount'),
                key: 'rate_account',
                type: 'text',
                comments: _this.$t('interface.vatRate.rateAccountComments'),
                hideOnList: true,
                required: false
            },
            {
                label: _this.$t('interface.vatRate.salesAccount'),
                key: 'sales_account',
                type: 'text',
                comments: _this.$t('interface.vatRate.salesAccountComments'),
                hideOnList: true,
                required: false
            }
        ];
        return _this;
    }
    VatRates.prototype.replacementUrl = function (element) {
        return this.apiUrl +
            '?filter[exclude]=' + element.id +
            '&filter[rate]=' + element.rate;
    };
    VatRates.prototype.replacementLabel = function (opt) {
        var label = opt.rate + ' %';
        if (opt.label) {
            label += ' (' + opt.label + ')';
        }
        return label;
    };
    VatRates.prototype.submitted = function (rate) {
        if (this.accountantMode === false) {
            this.setVatRate(rate);
        }
    };
    VatRates.prototype.deleted = function (rate) {
        if (this.accountantMode === false) {
            this.deleteVatRate(rate);
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], VatRates.prototype, "accountantMode", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: '/vat_rate' })
    ], VatRates.prototype, "apiUrl", void 0);
    VatRates = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['setVatRate', 'deleteVatRate'])),
            components: {
                DynamicList: DynamicList/* default */.A
            }
        })
    ], VatRates);
    return VatRates;
}(lib/* Vue */.lD));
/* harmony default export */ var VatRatesvue_type_script_lang_ts_external = (VatRates);

;// ./src/components/VatRates/VatRates.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var VatRates_VatRatesvue_type_script_lang_ts_external = (VatRatesvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/VatRates/VatRates.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  VatRates_VatRatesvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VatRates_VatRates = (component.exports);

/***/ }),

/***/ 4451:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '೧',
            2: '೨',
            3: '೩',
            4: '೪',
            5: '೫',
            6: '೬',
            7: '೭',
            8: '೮',
            9: '೯',
            0: '೦',
        },
        numberMap = {
            '೧': '1',
            '೨': '2',
            '೩': '3',
            '೪': '4',
            '೫': '5',
            '೬': '6',
            '೭': '7',
            '೮': '8',
            '೯': '9',
            '೦': '0',
        };

    var kn = moment.defineLocale('kn', {
        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
            '_'
        ),
        monthsShort:
            'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
            '_'
        ),
        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[ಇಂದು] LT',
            nextDay: '[ನಾಳೆ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ನಿನ್ನೆ] LT',
            lastWeek: '[ಕೊನೆಯ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ನಂತರ',
            past: '%s ಹಿಂದೆ',
            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
            ss: '%d ಸೆಕೆಂಡುಗಳು',
            m: 'ಒಂದು ನಿಮಿಷ',
            mm: '%d ನಿಮಿಷ',
            h: 'ಒಂದು ಗಂಟೆ',
            hh: '%d ಗಂಟೆ',
            d: 'ಒಂದು ದಿನ',
            dd: '%d ದಿನ',
            M: 'ಒಂದು ತಿಂಗಳು',
            MM: '%d ತಿಂಗಳು',
            y: 'ಒಂದು ವರ್ಷ',
            yy: '%d ವರ್ಷ',
        },
        preparse: function (string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ರಾತ್ರಿ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
                return hour;
            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ಸಂಜೆ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ರಾತ್ರಿ';
            } else if (hour < 10) {
                return 'ಬೆಳಿಗ್ಗೆ';
            } else if (hour < 17) {
                return 'ಮಧ್ಯಾಹ್ನ';
            } else if (hour < 20) {
                return 'ಸಂಜೆ';
            } else {
                return 'ರಾತ್ರಿ';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal: function (number) {
            return number + 'ನೇ';
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return kn;

})));


/***/ }),

/***/ 4457:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly
//! author : Emanuel Cepoi : https://github.com/cepem

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
                ss: 'secunde',
                mm: 'minute',
                hh: 'ore',
                dd: 'zile',
                ww: 'săptămâni',
                MM: 'luni',
                yy: 'ani',
            },
            separator = ' ';
        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    var ro = moment.defineLocale('ro', {
        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
            '_'
        ),
        monthsShort:
            'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'peste %s',
            past: '%s în urmă',
            s: 'câteva secunde',
            ss: relativeTimeWithPlural,
            m: 'un minut',
            mm: relativeTimeWithPlural,
            h: 'o oră',
            hh: relativeTimeWithPlural,
            d: 'o zi',
            dd: relativeTimeWithPlural,
            w: 'o săptămână',
            ww: relativeTimeWithPlural,
            M: 'o lună',
            MM: relativeTimeWithPlural,
            y: 'un an',
            yy: relativeTimeWithPlural,
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ro;

})));


/***/ }),

/***/ 4496:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arMa = moment.defineLocale('ar-ma', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arMa;

})));


/***/ }),

/***/ 4509:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(2651);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 4528:
/***/ (function(module) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ 4552:
/***/ (function(module) {

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

module.exports = basePropertyOf;


/***/ }),

/***/ 4566:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! authors : https://github.com/mechuwind
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nn = moment.defineLocale('nn', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s sidan',
            s: 'nokre sekund',
            ss: '%d sekund',
            m: 'eit minutt',
            mm: '%d minutt',
            h: 'ein time',
            hh: '%d timar',
            d: 'ein dag',
            dd: '%d dagar',
            w: 'ei veke',
            ww: '%d veker',
            M: 'ein månad',
            MM: '%d månader',
            y: 'eit år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nn;

})));


/***/ }),

/***/ 4587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ TeamParams_TeamParams; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TeamParams/TeamParams.vue?vue&type=template&id=0e27f1f3
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form',{attrs:{"action":_vm.formAction,"method":"put"},on:{"submitComplete":_vm.formSubmitted}},[_c('b-card',[_c('h3',{staticClass:"form-title mt-0"},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'cogs']}}),_vm._v(" "+_vm._s(_vm.$t('interface.teamParams.accountParams'))+" ")],1),_c('b-row',[_c('b-col',{attrs:{"md":"6","lg":"4","sm":"12"}},[_c('b-form-group',{attrs:{"label":_vm.$t('interface.teamParams.currency'),"label-for":"configs[currency]"}},[_c('k-form-select',{attrs:{"options":_vm.currencies,"name":"configs[currency]","id":"configs[currency]","getOptionLabel":opt => opt.name + ' (' + opt.symbol + ')',"reduce":opt => opt.id,"clearable":false,"required":""},model:{value:(_vm.currency.id),callback:function ($$v) {_vm.$set(_vm.currency, "id", $$v)},expression:"currency.id"}})],1)],1),_c('b-col',{attrs:{"md":"6","lg":"4","sm":"12"}},[_c('b-form-group',{attrs:{"label":_vm.$t('interface.teamParams.timezone'),"label-for":"configs[timezone]"}},[_c('k-form-select',{attrs:{"options":_vm.timezones,"name":"configs[timezone]","id":"configs[timezone]","getOptionLabel":opt => opt.timezone + ' (' + opt.diff + ')',"reduce":opt => opt.id,"clearable":false,"required":""},model:{value:(_vm.timezone.id),callback:function ($$v) {_vm.$set(_vm.timezone, "id", $$v)},expression:"timezone.id"}})],1)],1)],1),_c('b-form-group',{attrs:{"label":_vm.$t('interface.teamParams.phoneNumber'),"label-for":"configs[timezone]"}},[_c('k-form-checkbox',{model:{value:(_vm.localConfig.phone_clickable),callback:function ($$v) {_vm.$set(_vm.localConfig, "phone_clickable", $$v)},expression:"localConfig.phone_clickable"}},[_vm._v(" "+_vm._s(_vm.$t('interface.teamParams.phoneNumberClick'))+" ")]),_c('input',{attrs:{"type":"hidden","name":"configs[phone_clickable]"},domProps:{"value":_vm.localConfig.phone_clickable ?? false}})],1),_c('h3',{staticClass:"form-title"},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'calculator-alt']}}),_vm._v(" "+_vm._s(_vm.$t('interface.teamParams.numberFormat'))+" ")],1),_c('b-row',[_c('b-col',{attrs:{"md":"6","lg":"4","sm":"12"}},[_c('b-form-group',{attrs:{"label":_vm.$t('interface.teamParams.decimalsSeparator'),"label-for":"configs[number_format_decimals]"}},[_c('k-form-select',{attrs:{"options":_vm.numberFormatDecimals,"name":"configs[number_format_decimals]","id":"configs[number_format_decimals]","clearable":false,"required":""},model:{value:(_vm.localConfig.number_format_decimals),callback:function ($$v) {_vm.$set(_vm.localConfig, "number_format_decimals", $$v)},expression:"localConfig.number_format_decimals"}})],1)],1),_c('b-col',{attrs:{"md":"6","lg":"4","sm":"12"}},[_c('b-form-group',{attrs:{"label":_vm.$t('interface.teamParams.thousandsSeparator'),"label-for":"configs[number_format_number_thousands]"}},[_c('k-form-select',{attrs:{"options":_vm.numberFormatThousands,"name":"configs[number_format_number_thousands]","id":"configs[number_format_number_thousands]","reduce":el => el.id,"clearable":false,"required":""},model:{value:(_vm.localConfig.number_format_number_thousands),callback:function ($$v) {_vm.$set(_vm.localConfig, "number_format_number_thousands", $$v)},expression:"localConfig.number_format_number_thousands"}})],1)],1),_c('b-col',{attrs:{"md":"6","lg":"4","sm":"12"}},[_c('b-form-group',{attrs:{"label":_vm.$t('interface.teamParams.currencyPosition'),"label-for":"configs[currency_position]"}},[_c('k-form-select',{attrs:{"options":_vm.currencyPositions,"name":"configs[currency_position]","id":"configs[currency_position]","reduce":el => el.id,"clearable":false,"required":""},model:{value:(_vm.localConfig.currency_position),callback:function ($$v) {_vm.$set(_vm.localConfig, "currency_position", $$v)},expression:"localConfig.currency_position"}})],1)],1),_c('b-col',{attrs:{"md":"6","lg":"4","sm":"12"}},[_c('b-form-group',{attrs:{"label":_vm.$t('interface.teamParams.nbDecimals'),"label-for":"configs[number_nb_decimals]","description":_vm.$t('interface.teamParams.nbDecimalsDescription')}},[_c('k-form-select',{attrs:{"options":_vm.numberNbDecimals,"reduce":opt => opt.value,"name":"configs[number_nb_decimals]","id":"configs[number_nb_decimals]","clearable":false,"required":""},model:{value:(_vm.localConfig.number_nb_decimals),callback:function ($$v) {_vm.$set(_vm.localConfig, "number_nb_decimals", $$v)},expression:"localConfig.number_nb_decimals"}})],1)],1)],1),_c('h3',{staticClass:"form-title"},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'calendar-alt']}}),_vm._v(" "+_vm._s(_vm.$t('interface.teamParams.dateFormatTitle'))+" ")],1),_c('b-row',[_c('b-col',{attrs:{"md":"6","lg":"4","sm":"12"}},[_c('b-form-group',{attrs:{"label":_vm.$t('interface.teamParams.dateFormat'),"label-for":"configs[date_format]"}},[_c('k-form-select',{attrs:{"options":_vm.dateFormats,"name":"configs[date_format]","id":"configs[date_format]","clearable":false,"required":""},model:{value:(_vm.localConfig.date_format),callback:function ($$v) {_vm.$set(_vm.localConfig, "date_format", $$v)},expression:"localConfig.date_format"}})],1)],1)],1)],1),_c('k-form-sticky-bar',{staticClass:"text-center mt-3",attrs:{"parent":"#page"}},[_c('b-button',{staticClass:"mr-4",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('interface.cancel'))+" ")]),_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_vm._v(" "+_vm._s(_vm.$t('interface.save'))+" ")])],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: ./src/mixins/TeamConfigMixin.ts
var TeamConfigMixin = __webpack_require__(2399);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(9356);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/TeamParams/TeamParams.ts?vue&type=script&lang=ts&external







var TeamParams = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TeamParams, _super);
    function TeamParams() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.currencyPositions = [
            { label: _this.$t('interface.teamParams.currencyPositionsBefore'), id: 'before' },
            { label: _this.$t('interface.teamParams.currencyPositionsAfter'), id: 'after' },
            { label: _this.$t('interface.teamParams.currencyPositionsNone'), id: 'none' }
        ];
        _this.dateFormats = ['DD-MM-YYYY', 'YYYY-MM-DD', 'DD/MM/YYYY', 'YYYY/MM/DD'];
        _this.numberFormatDecimals = ['.', ','];
        _this.numberNbDecimals = [
            { value: 0, label: _this.$t('interface.teamParams.numberNbDecimals0') },
            { value: 1, label: _this.$t('interface.teamParams.numberNbDecimals1') },
            { value: 2, label: _this.$t('interface.teamParams.numberNbDecimals2') }
        ];
        _this.numberFormatThousands = [
            { label: _this.$t('interface.teamParams.numberFormatThousandsSpace'), id: 'space' },
            { label: _this.$t('interface.teamParams.numberFormatThousandsNone'), id: 'none' }
        ];
        return _this;
    }
    TeamParams.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setLocalTeam(this.team);
                        this.setLocalTeamConfigs(this.teamConfigs);
                        return [4 /*yield*/, this.loadTimezones()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.loadCurrencies()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TeamParams = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('globalDatas', ['currencies', 'timezones'])), (0,external_vuex_.mapGetters)('user', ['timezone', 'currency'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadCurrencies', 'loadTimezones'])),
            components: {
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                KForm: form_vue_.KForm, KFormSelect: form_vue_.KFormSelect, KFormStickyBar: form_vue_.KFormStickyBar, KFormCheckbox: form_vue_.KFormCheckbox,
                BButton: external_bootstrap_vue_.BButton, BCard: external_bootstrap_vue_.BCard, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BFormGroup: external_bootstrap_vue_.BFormGroup
            }
        })
    ], TeamParams);
    return TeamParams;
}((0,lib/* Mixins */.Xe)(TeamConfigMixin/* default */.A)));
/* harmony default export */ var TeamParamsvue_type_script_lang_ts_external = (TeamParams);

;// ./src/components/TeamParams/TeamParams.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var TeamParams_TeamParamsvue_type_script_lang_ts_external = (TeamParamsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/TeamParams/TeamParams.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  TeamParams_TeamParamsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TeamParams_TeamParams = (component.exports);

/***/ }),

/***/ 4598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ TextareaView_TextareaView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TextareaView/TextareaView.vue?vue&type=template&id=c4a2c2bc
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.value !== null)?_c('div',{staticClass:"textarea-view"},[_vm._v(_vm._s(_vm.value))]):_vm._e()
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/TextareaView/TextareaView.ts?vue&type=script&lang=ts&external


var TextareaView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TextareaView, _super);
    function TextareaView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], TextareaView.prototype, "value", void 0);
    TextareaView = (0,tslib_es6/* __decorate */.Cg)([
        lib/* Component */.uA
    ], TextareaView);
    return TextareaView;
}(lib/* Vue */.lD));
/* harmony default export */ var TextareaViewvue_type_script_lang_ts_external = (TextareaView);

;// ./src/components/TextareaView/TextareaView.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var TextareaView_TextareaViewvue_type_script_lang_ts_external = (TextareaViewvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/TextareaView/TextareaView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  TextareaView_TextareaViewvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TextareaView_TextareaView = (component.exports);

/***/ }),

/***/ 4600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_TagsView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/TagsView.vue?vue&type=template&id=1793a414
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Tags')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: ./src/components/Tags/Tags.vue + 3 modules
var Tags = __webpack_require__(7005);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/TagsView.vue?vue&type=script&lang=ts



var TagsView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TagsView, _super);
    function TagsView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TagsView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Tags: Tags/* default */.A
            }
        })
    ], TagsView);
    return TagsView;
}(lib/* Vue */.lD));
/* harmony default export */ var TagsViewvue_type_script_lang_ts = (TagsView);

;// ./src/views/TagsView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_TagsViewvue_type_script_lang_ts = (TagsViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/TagsView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_TagsViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_TagsView = (component.exports);

/***/ }),

/***/ 4647:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var basePropertyOf = __webpack_require__(4552);

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

module.exports = deburrLetter;


/***/ }),

/***/ 4664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(9770),
    stubArray = __webpack_require__(3345);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ 4691:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    var el = moment.defineLocale('el', {
        monthsNominativeEl:
            'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
                '_'
            ),
        monthsGenitiveEl:
            'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
                '_'
            ),
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return this._monthsNominativeEl;
            } else if (
                typeof format === 'string' &&
                /D/.test(format.substring(0, format.indexOf('MMMM')))
            ) {
                // if there is a day number before 'MMMM'
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
            '_'
        ),
        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        isPM: function (input) {
            return (input + '').toLowerCase()[0] === 'μ';
        },
        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendarEl: {
            sameDay: '[Σήμερα {}] LT',
            nextDay: '[Αύριο {}] LT',
            nextWeek: 'dddd [{}] LT',
            lastDay: '[Χθες {}] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 6:
                        return '[το προηγούμενο] dddd [{}] LT';
                    default:
                        return '[την προηγούμενη] dddd [{}] LT';
                }
            },
            sameElse: 'L',
        },
        calendar: function (key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();
            if (isFunction(output)) {
                output = output.apply(mom);
            }
            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
        },
        relativeTime: {
            future: 'σε %s',
            past: '%s πριν',
            s: 'λίγα δευτερόλεπτα',
            ss: '%d δευτερόλεπτα',
            m: 'ένα λεπτό',
            mm: '%d λεπτά',
            h: 'μία ώρα',
            hh: '%d ώρες',
            d: 'μία μέρα',
            dd: '%d μέρες',
            M: 'ένας μήνας',
            MM: '%d μήνες',
            y: 'ένας χρόνος',
            yy: '%d χρόνια',
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: '%dη',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4st is the first week of the year.
        },
    });

    return el;

})));


/***/ }),

/***/ 4697:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deCh = moment.defineLocale('de-ch', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deCh;

})));


/***/ }),

/***/ 4739:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(6025);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 4755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  $T: function() { return /* binding */ dateToString; },
  Yq: function() { return /* binding */ formatDate; },
  Rt: function() { return /* binding */ formatDatetime; },
  uT: function() { return /* binding */ formatFromNow; },
  n$: function() { return /* binding */ moment; }
});

;// external "moment-timezone"
var external_moment_timezone_namespaceObject = require("moment-timezone");
var external_moment_timezone_default = /*#__PURE__*/__webpack_require__.n(external_moment_timezone_namespaceObject);
// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(622);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
;// ./src/utils/date.ts


var getTimezone = function () {
    return (external_vue_default()).prototype.$kwInterface.store.getters['user/timezone'].timezone;
};
var moment = function (inp) {
    var timezone = getTimezone();
    var instance;
    if ((external_vue_default()).prototype.$kwInterface.serverTimezone && timezone) {
        instance = external_moment_timezone_default().tz(inp, (external_vue_default()).prototype.$kwInterface.serverTimezone)
            .tz(timezone);
    }
    else {
        instance = external_moment_timezone_default()(inp);
    }
    return instance.locale('fr');
};
// Show a formated date
var formatDate = function (date) {
    if (date === undefined || date === null || date === '') {
        return '';
    }
    var config = (external_vue_default()).prototype.$kwInterface.store.getters['user/teamConfigs'];
    return external_moment_timezone_default()(date).format(config.date_format);
};
// Show a "string" date
var dateToString = function (date) {
    if (date === undefined || date === null || date === '') {
        return '';
    }
    var config = (external_vue_default()).prototype.$kwInterface.store.getters['user/teamConfigs'];
    var i18n = (external_vue_default()).prototype.$kwInterface.i18n;
    var moment = external_moment_timezone_default()(date);
    if (moment.isSame(external_moment_timezone_default()(), 'day')) {
        return i18n.t('interface.today');
    }
    else if (moment.isSame(external_moment_timezone_default()().add(1, 'day'), 'day')) {
        return i18n.t('interface.tomorrow');
    }
    else if (moment.isSame(external_moment_timezone_default()().add(-1, 'day'), 'day')) {
        return i18n.t('interface.yesterday');
    }
    else {
        return moment.format(config.date_format);
    }
};
// Show a formated datetime
var formatDatetime = function (date) {
    if (date === undefined || date === null || date === '') {
        return '';
    }
    var config = (external_vue_default()).prototype.$kwInterface.store.getters['user/teamConfigs'];
    var i18n = (external_vue_default()).prototype.$kwInterface.i18n;
    var m = moment(date);
    var lang;
    if (m.isSame(new Date(), 'day')) {
        lang = 'datetimeToday';
    }
    else {
        lang = 'datetime';
    }
    var format = i18n.t('interface.' + lang, {
        date: config.date_format,
        time: 'HH[h]mm'
    });
    return moment(date).format(String(format));
};
var formatFromNow = function (date) {
    if (date === undefined || date === null || date === '') {
        return '';
    }
    var m = moment(date).locale('fr');
    return m.fromNow();
};



/***/ }),

/***/ 4774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1635);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9077);
/* harmony import */ var _utils_date__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4755);



var DateMixin = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__extends */ .C6)(DateMixin, _super);
    function DateMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // Show a formated date
    DateMixin.prototype.date = function (date) {
        return (0,_utils_date__WEBPACK_IMPORTED_MODULE_1__/* .formatDate */ .Yq)(date);
    };
    // Show a "string" date
    DateMixin.prototype.stringDate = function (date) {
        return (0,_utils_date__WEBPACK_IMPORTED_MODULE_1__/* .dateToString */ .$T)(date);
    };
    // Show a formated datetime
    DateMixin.prototype.datetime = function (date) {
        return (0,_utils_date__WEBPACK_IMPORTED_MODULE_1__/* .formatDatetime */ .Rt)(date);
    };
    DateMixin.prototype.fromNow = function (date) {
        return (0,_utils_date__WEBPACK_IMPORTED_MODULE_1__/* .formatFromNow */ .uT)(date);
    };
    DateMixin = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__decorate */ .Cg)([
        vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .uA
    ], DateMixin);
    return DateMixin;
}(vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Vue */ .lD));
/* harmony default export */ __webpack_exports__.A = (DateMixin);


/***/ }),

/***/ 4840:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 4865:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'eye';
var width = 576;
var height = 512;
var ligatures = [];
var unicode = 'f06e';
var svgPathData = 'M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.pS = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 4894:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(1882),
    isLength = __webpack_require__(294);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 4901:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2552),
    isLength = __webpack_require__(294),
    isObjectLike = __webpack_require__(346);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 4903:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bambara [bm]
//! author : Estelle Comment : https://github.com/estellecomment

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var bm = moment.defineLocale('bm', {
        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
            '_'
        ),
        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'MMMM [tile] D [san] YYYY',
            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
        },
        calendar: {
            sameDay: '[Bi lɛrɛ] LT',
            nextDay: '[Sini lɛrɛ] LT',
            nextWeek: 'dddd [don lɛrɛ] LT',
            lastDay: '[Kunu lɛrɛ] LT',
            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s kɔnɔ',
            past: 'a bɛ %s bɔ',
            s: 'sanga dama dama',
            ss: 'sekondi %d',
            m: 'miniti kelen',
            mm: 'miniti %d',
            h: 'lɛrɛ kelen',
            hh: 'lɛrɛ %d',
            d: 'tile kelen',
            dd: 'tile %d',
            M: 'kalo kelen',
            MM: 'kalo %d',
            y: 'san kelen',
            yy: 'san %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return bm;

})));


/***/ }),

/***/ 4932:
/***/ (function(module) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 4974:
/***/ (function(module) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),

/***/ 4994:
/***/ (function(module) {

"use strict";
module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAjCAYAAABsFtHvAAAFTGlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNS41LjAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgeG1sbnM6ZXhpZj0iaHR0cDovL25zLmFkb2JlLmNvbS9leGlmLzEuMC8iCiAgICB4bWxuczpwaG90b3Nob3A9Imh0dHA6Ly9ucy5hZG9iZS5jb20vcGhvdG9zaG9wLzEuMC8iCiAgICB4bWxuczp0aWZmPSJodHRwOi8vbnMuYWRvYmUuY29tL3RpZmYvMS4wLyIKICAgIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIKICAgIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIgogICAgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZUV2ZW50IyIKICAgZXhpZjpDb2xvclNwYWNlPSIxIgogICBleGlmOlBpeGVsWERpbWVuc2lvbj0iMzEiCiAgIGV4aWY6UGl4ZWxZRGltZW5zaW9uPSIzNSIKICAgcGhvdG9zaG9wOkNvbG9yTW9kZT0iMyIKICAgcGhvdG9zaG9wOklDQ1Byb2ZpbGU9InNSR0IgSUVDNjE5NjYtMi4xIgogICB0aWZmOkltYWdlTGVuZ3RoPSIzNSIKICAgdGlmZjpJbWFnZVdpZHRoPSIzMSIKICAgdGlmZjpSZXNvbHV0aW9uVW5pdD0iMiIKICAgdGlmZjpYUmVzb2x1dGlvbj0iNjAwLjAiCiAgIHRpZmY6WVJlc29sdXRpb249IjYwMC4wIgogICB4bXA6TWV0YWRhdGFEYXRlPSIyMDIxLTAxLTE1VDAxOjAwOjQxKzAxOjAwIgogICB4bXA6TW9kaWZ5RGF0ZT0iMjAyMS0wMS0xNVQwMTowMDo0MSswMTowMCI+CiAgIDx4bXBNTTpIaXN0b3J5PgogICAgPHJkZjpTZXE+CiAgICAgPHJkZjpsaQogICAgICB4bXBNTTphY3Rpb249InByb2R1Y2VkIgogICAgICB4bXBNTTpzb2Z0d2FyZUFnZW50PSJBZmZpbml0eSBQaG90byAoSnVsIDMwIDIwMjApIgogICAgICB4bXBNTTp3aGVuPSIyMDIxLTAxLTEzVDE0OjE0OjI4KzAxOjAwIi8+CiAgICAgPHJkZjpsaQogICAgICBzdEV2dDphY3Rpb249InByb2R1Y2VkIgogICAgICBzdEV2dDpzb2Z0d2FyZUFnZW50PSJBZmZpbml0eSBQaG90byAoSnVsIDMwIDIwMjApIgogICAgICBzdEV2dDp3aGVuPSIyMDIxLTAxLTE1VDAxOjAwOjQxKzAxOjAwIi8+CiAgICA8L3JkZjpTZXE+CiAgIDwveG1wTU06SGlzdG9yeT4KICA8L3JkZjpEZXNjcmlwdGlvbj4KIDwvcmRmOlJERj4KPC94OnhtcG1ldGE+Cjw/eHBhY2tldCBlbmQ9InIiPz7E0sCbAAABgWlDQ1BzUkdCIElFQzYxOTY2LTIuMQAAKJF1kd8rg1EYxz/biBhTFBculsbVJqYWKWUSSloz5dfN9u6X2o+3993ScqvcKkrc+HXBX8Ctcq0UkZI75Zq4Yb2e19SW7Dmd53zO9zzP0znPAWsopaT1mj5IZ3JacMLvnF9YdNY9Y6GZdoZxhRVdHQ0EpqlqH3cSLXbjMWtVj/vXGqMxXQFLvfCIomo54Unh6dWcavK2cJuSDEeFT4XdmlxQ+NbUIyV+MTlR4i+TtVBwDKwtws5EBUcqWElqaWF5Oa50Kq/83sd8iT2WmZuVtUtmJzpBJvDjZIpxxvDRz5B4Hx689MqOKvl9P/kzZCVXEa9SQGOFBElyuEXNS/WYrHHRYzJSFMz+/+2rHh/wlqrb/VD7ZBhv3VC3BcVNw/g8NIziEdge4SJTzs8ewOC76JtlzbUPjnU4uyxrkR0434COBzWshX8km0xrPA6vJ9C0AK3X0LBU6tnvOcf3EFqTr7qC3T3okXjH8jeaDmf9hw5zjQAAAAlwSFlzAABcRgAAXEYBFJRDQQAAAqtJREFUWIXFlztoVEEUhr+bLNkghmBARERFGAjRQoNRtFAchCHggsRHoagQC0ml4CM2NoqdhY0PEDQKoiCkEAVxmrFQ0EJQsIjLgCKJRYzxgZKo7K7FvcGbdXfm3t3V/OWc/853ztyZw0xgpRoGNgMBf1QAvgMDwmhNClmpBoATQEc0T1wBUAJ2C6NNBtgONFeZKwckhlupDgGXmF1IufLAU4CmCtnFVS2pSuCdCcAjwGph9NQMvJQU4ABvAW7iTvY1sEEYPT0zkGkAeAXwAGh12N4B64XRX+ODTXWCFwGvPOBxYF05uC64lWol4VLOc9gmgB5h9HilYE3LbqXqJDwF7Q7bJNAtjB6tZkhduZVqKTAMLHHYxoAuFzg13Eq1ELgLrHLYRgk3V8WlrglupWol3NXdDtsEsFEY/T7JnIn+uZUqAF4AnQ7bVAR2LnVcvsrbrFRZ4JkHPA2sEUbbpGDwV94H9ABdHt+gMDqfBgz+yucnAANIK1Xqk1NXh4upD9gxV3CAa1aqxXMFbwOuRCfjv8MBthHeYv4J/BbwxhEPgFNWqmWNhJeA/cA+oBf47PC2EXZCrwIr1TSQdXh+AUeE0ZdnBqxUB4GrnrnPASeF0VVvSr7KC8CZODjSdeCR59vjwFqXwQd/Iow+Wz4ojC4C/bgvnwHw2Eq1oFb4SLWAMPotsMvzfRa4WCv8pyd+D3ju8eyxUh2oBe68VgujC8BW4KNnnvNWKpEW7n00CKO/AMeAosPWQdh+Z3W/hnQ4YfQN4L7Htgk43XB4pH7gk8czaKVa3nC4MHoSOOyxZYGXVqqWhsIj3QbueDztwFASuGsT/aVo9x8Ffnise61UuSbgm8PkvXtXSGCM8M3v01CGsEv1Ai2xQBH4AFxIC48SeGilyhH2gGYqt+H8b0rrvfZCz26HAAAAAElFTkSuQmCC";

/***/ }),

/***/ 5050:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Gujarati [gu]
//! author : Kaushik Thanki : https://github.com/Kaushik1987

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '૧',
            2: '૨',
            3: '૩',
            4: '૪',
            5: '૫',
            6: '૬',
            7: '૭',
            8: '૮',
            9: '૯',
            0: '૦',
        },
        numberMap = {
            '૧': '1',
            '૨': '2',
            '૩': '3',
            '૪': '4',
            '૫': '5',
            '૬': '6',
            '૭': '7',
            '૮': '8',
            '૯': '9',
            '૦': '0',
        };

    var gu = moment.defineLocale('gu', {
        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
            '_'
        ),
        monthsShort:
            'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
            '_'
        ),
        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm વાગ્યે',
            LTS: 'A h:mm:ss વાગ્યે',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
        },
        calendar: {
            sameDay: '[આજ] LT',
            nextDay: '[કાલે] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ગઇકાલે] LT',
            lastWeek: '[પાછલા] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s મા',
            past: '%s પહેલા',
            s: 'અમુક પળો',
            ss: '%d સેકંડ',
            m: 'એક મિનિટ',
            mm: '%d મિનિટ',
            h: 'એક કલાક',
            hh: '%d કલાક',
            d: 'એક દિવસ',
            dd: '%d દિવસ',
            M: 'એક મહિનો',
            MM: '%d મહિનો',
            y: 'એક વર્ષ',
            yy: '%d વર્ષ',
        },
        preparse: function (string) {
            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'રાત') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'સવાર') {
                return hour;
            } else if (meridiem === 'બપોર') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'સાંજ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'રાત';
            } else if (hour < 10) {
                return 'સવાર';
            } else if (hour < 17) {
                return 'બપોર';
            } else if (hour < 20) {
                return 'સાંજ';
            } else {
                return 'રાત';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return gu;

})));


/***/ }),

/***/ 5083:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(1882),
    isMasked = __webpack_require__(7296),
    isObject = __webpack_require__(3805),
    toSource = __webpack_require__(7473);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 5093:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    0
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        var flags = null,
            parsedParts = false,
            isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            isNowValid =
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidEra &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));
            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        } else {
            return isNowValid;
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year',
    };

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1,
    };

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        match1to2NoLeadingZero = /^[1-9]\d?/, //         1-99
        match1to2HasZero = /^([1-9]\d|\d)/, //           0-99
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        if (!mom.isValid()) {
            return NaN;
        }

        var d = mom._d,
            isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }

    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;

        if (!mom.isValid() || isNaN(value)) {
            return;
        }

        d = mom._d;
        isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return void (isUTC
                    ? d.setUTCMilliseconds(value)
                    : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }

        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        void (isUTC
            ? d.setUTCFullYear(year, month, date)
            : d.setFullYear(year, month, date));
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // PARSING

    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        var month = value,
            date = mom.date();

        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        void (mom._isUTC
            ? mom._d.setUTCMonth(month, date)
            : mom._d.setMonth(month, date));
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            shortP,
            longP;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // PARSING

    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
              ? weekdays[m.day()]
              : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
              ? this._weekdaysShort[m.day()]
              : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
              ? this._weekdaysMin[m.day()]
              : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            "object" !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = undefined;
                __webpack_require__(5358)("./" + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                      ? DATE
                      : a[HOUR] < 0 ||
                          a[HOUR] > 24 ||
                          (a[HOUR] === 24 &&
                              (a[MINUTE] !== 0 ||
                                  a[SECOND] !== 0 ||
                                  a[MILLISECOND] !== 0))
                        ? HOUR
                        : a[MINUTE] < 0 || a[MINUTE] > 59
                          ? MINUTE
                          : a[SECOND] < 0 || a[SECOND] > 59
                            ? SECOND
                            : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                              ? MILLISECOND
                              : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
              ? 'lastWeek'
              : diff < 0
                ? 'lastDay'
                : diff < 1
                  ? 'sameDay'
                  : diff < 2
                    ? 'nextDay'
                    : diff < 7
                      ? 'nextWeek'
                      : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            erasName,
            erasAbbr,
            erasNarrow,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);

            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday() + this.localeData()._week.dow,
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // PARSING

    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // PARSING

    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // PARSING

    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y'),
        valueOf$1 = asMilliseconds;

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.30.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));


/***/ }),

/***/ 5096:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inci",
        5: "'inci",
        8: "'inci",
        70: "'inci",
        80: "'inci",
        2: "'nci",
        7: "'nci",
        20: "'nci",
        50: "'nci",
        3: "'üncü",
        4: "'üncü",
        100: "'üncü",
        6: "'ncı",
        9: "'uncu",
        10: "'uncu",
        30: "'uncu",
        60: "'ıncı",
        90: "'ıncı",
    };

    var tr = moment.defineLocale('tr', {
        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
            '_'
        ),
        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
            '_'
        ),
        weekdaysShort: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'öö' : 'ÖÖ';
            } else {
                return isLower ? 'ös' : 'ÖS';
            }
        },
        meridiemParse: /öö|ÖÖ|ös|ÖS/,
        isPM: function (input) {
            return input === 'ös' || input === 'ÖS';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[yarın saat] LT',
            nextWeek: '[gelecek] dddd [saat] LT',
            lastDay: '[dün] LT',
            lastWeek: '[geçen] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s önce',
            s: 'birkaç saniye',
            ss: '%d saniye',
            m: 'bir dakika',
            mm: '%d dakika',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            w: 'bir hafta',
            ww: '%d hafta',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir yıl',
            yy: '%d yıl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'ıncı";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return tr;

})));


/***/ }),

/***/ 5118:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  FT: function() { return /* binding */ applyProps; },
  Gu: function() { return /* binding */ generateProps; },
  BQ: function() { return /* binding */ getBreakpoints; }
});

;// ./node_modules/bootstrap-vue/src/constants/config.js
const NAME = 'BvConfig'
const PROP_NAME = '$bvConfig'

const DEFAULT_BREAKPOINT = ['xs', 'sm', 'md', 'lg', 'xl']

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(622);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
// EXTERNAL MODULE: ./node_modules/lodash/kebabCase.js
var kebabCase = __webpack_require__(249);
var kebabCase_default = /*#__PURE__*/__webpack_require__.n(kebabCase);
// EXTERNAL MODULE: ./node_modules/lodash/forEach.js
var forEach = __webpack_require__(9754);
var forEach_default = /*#__PURE__*/__webpack_require__.n(forEach);
;// ./src/utils/breakpoints.ts




var getBreakpoints = function () {
    var _a, _b, _c;
    return (_c = (_b = (_a = (external_vue_default()).prototype.$bvConfig) === null || _a === void 0 ? void 0 : _a.$_config) === null || _b === void 0 ? void 0 : _b.breakpoints) !== null && _c !== void 0 ? _c : DEFAULT_BREAKPOINT;
};
var generateProps = function (prefix, defaultValue, breakpoints) {
    var props = {};
    if (!breakpoints) {
        breakpoints = getBreakpoints();
    }
    breakpoints.forEach(function (breakpoint) {
        var key = prefix;
        if (breakpoint !== 'xs') {
            key += '-' + breakpoint;
        }
        props[key] = {
            default: defaultValue,
            type: [String, Number]
        };
    });
    return props;
};
var applyProps = function (prefix, properties, valuePrefix) {
    var props = {};
    var transformedProperties = JSON.parse(JSON.stringify(properties));
    forEach_default()(transformedProperties, function (value, key) {
        transformedProperties[kebabCase_default()(key)] = value;
    });
    getBreakpoints().forEach(function (breakpoint) {
        // Key to use for property
        var key;
        if (typeof prefix === 'function') {
            key = prefix(breakpoint);
        }
        else {
            key = prefix;
            if (breakpoint !== 'xs') {
                key += '-' + breakpoint;
            }
        }
        // Key to use for value
        var valueKey;
        if (valuePrefix === undefined) {
            valueKey = key;
        }
        else if (typeof valuePrefix === 'function') {
            valueKey = valuePrefix(breakpoint);
        }
        else {
            valueKey = valuePrefix;
            if (breakpoint !== 'xs') {
                valueKey += '-' + breakpoint;
            }
        }
        props[kebabCase_default()(valueKey)] = transformedProperties[kebabCase_default()(key)];
    });
    return props;
};



/***/ }),

/***/ 5149:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fad';
var iconName = 'spinner-third';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f3f4';
var svgPathData = ['M478.71 364.58zm-22 6.11l-27.83-15.9a15.92 15.92 0 0 1-6.94-19.2A184 184 0 1 1 256 72c5.89 0 11.71.29 17.46.83-.74-.07-1.48-.15-2.23-.21-8.49-.69-15.23-7.31-15.23-15.83v-32a16 16 0 0 1 15.34-16C266.24 8.46 261.18 8 256 8 119 8 8 119 8 256s111 248 248 248c98 0 182.42-56.95 222.71-139.42-4.13 7.86-14.23 10.55-22 6.11z', 'M271.23 72.62c-8.49-.69-15.23-7.31-15.23-15.83V24.73c0-9.11 7.67-16.78 16.77-16.17C401.92 17.18 504 124.67 504 256a246 246 0 0 1-25 108.24c-4 8.17-14.37 11-22.26 6.45l-27.84-15.9c-7.41-4.23-9.83-13.35-6.2-21.07A182.53 182.53 0 0 0 440 256c0-96.49-74.27-175.63-168.77-183.38z'];

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.sq = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 5177:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var af = moment.defineLocale('af', {
        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
            '_'
        ),
        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM: function (input) {
            return /^nm$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Vandag om] LT',
            nextDay: '[Môre om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[Gister om] LT',
            lastWeek: '[Laas] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oor %s',
            past: '%s gelede',
            s: "'n paar sekondes",
            ss: '%d sekondes',
            m: "'n minuut",
            mm: '%d minute',
            h: "'n uur",
            hh: '%d ure',
            d: "'n dag",
            dd: '%d dae',
            M: "'n maand",
            MM: '%d maande',
            y: "'n jaar",
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            ); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week: {
            dow: 1, // Maandag is die eerste dag van die week.
            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
        },
    });

    return af;

})));


/***/ }),

/***/ 5250:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(7217),
    assignMergeValue = __webpack_require__(7805),
    baseFor = __webpack_require__(6649),
    baseMergeDeep = __webpack_require__(2824),
    isObject = __webpack_require__(3805),
    keysIn = __webpack_require__(7241),
    safeGet = __webpack_require__(4974);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),

/***/ 5262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_AppColorsView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/AppColorsView.vue?vue&type=template&id=6c722bc5
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-tabs',{staticClass:"tabs-card"},[_c('b-tab',{attrs:{"title":_vm.$t('interface.customize.colorTab')}},[_c('AppColors')],1),_c('b-tab',{attrs:{"title":_vm.$t('interface.customize.logoTab')}},[_c('AppLogos')],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: ./src/components/AppColors/AppColors.vue + 3 modules
var AppColors = __webpack_require__(9256);
// EXTERNAL MODULE: ./src/components/AppLogos/AppLogos.vue + 3 modules
var AppLogos = __webpack_require__(3945);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/AppColorsView.vue?vue&type=script&lang=ts





var AppColorsView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(AppColorsView, _super);
    function AppColorsView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AppColorsView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                AppColors: AppColors/* default */.A,
                AppLogos: AppLogos/* default */.A,
                BTabs: external_bootstrap_vue_.BTabs, BTab: external_bootstrap_vue_.BTab
            }
        })
    ], AppColorsView);
    return AppColorsView;
}(lib/* Vue */.lD));
/* harmony default export */ var AppColorsViewvue_type_script_lang_ts = (AppColorsView);

;// ./src/views/AppColorsView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_AppColorsViewvue_type_script_lang_ts = (AppColorsViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/AppColorsView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_AppColorsViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_AppColorsView = (component.exports);

/***/ }),

/***/ 5288:
/***/ (function(module) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 5324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ TeamApiTokenForm_TeamApiTokenForm; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TeamApiTokenForm/TeamApiTokenForm.vue?vue&type=template&id=83d5cb0a
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('k-form',{attrs:{"action":_vm.formAction,"method":_vm.formMethod},on:{"submitComplete":_vm.submitComplete}},[_c('b-form-group',{attrs:{"label":_vm.$t('interface.apiToken.form.name')}},[_c('k-form-input',{attrs:{"name":"name","required":""},model:{value:(_vm.token.name),callback:function ($$v) {_vm.$set(_vm.token, "name", $$v)},expression:"token.name"}})],1),(!_vm.token.id || (_vm.token.id && _vm.token.expires_at))?_c('b-form-group',{attrs:{"label":_vm.$t('interface.apiToken.form.expireAt')}},[(!_vm.token.id)?_c('k-form-datepicker',{attrs:{"name":"expires_at"},model:{value:(_vm.token.expires_at),callback:function ($$v) {_vm.$set(_vm.token, "expires_at", $$v)},expression:"token.expires_at"}}):_vm._e(),[_vm._v(" "+_vm._s(_vm.datetime(_vm.token.expires_at))+" ")]],2):_vm._e(),_c('h2',{staticClass:"form-title-alt"},[_vm._v(" "+_vm._s(_vm.$t('interface.users.form.limitations'))+" ")]),_vm._l((_vm.permissions),function(category,i){return [_c('div',{key:i},[_c('div',{staticClass:"accordion",attrs:{"role":"tablist"}},[_c('b-card',{staticClass:"mb-1",attrs:{"no-body":""}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('accordion-' + category.key),expression:"'accordion-' + category.key"}],staticClass:"text-left",attrs:{"block":"","variant":"light","size":"sm"}},[_vm._v(" "+_vm._s(category.name)+" ")]),_c('b-collapse',{attrs:{"id":'accordion-' + category.key,"accordion":"my-accordion","role":"tabpanel"}},[_c('b-card-body',_vm._l((category.permissions),function(permission,i){return _c('b-form-group',{key:i,attrs:{"label":permission.name,"label-size":"sm","content-cols":"8","label-cols":"4"}},[_c('k-form-select',{attrs:{"name":'abilities[' + permission.key + ']',"options":permission.levels,"reduce":opt => opt.value,"size":"sm","clearable":false},model:{value:(_vm.token.abilities[permission.key]),callback:function ($$v) {_vm.$set(_vm.token.abilities, permission.key, $$v)},expression:"token.abilities[permission.key]"}})],1)}),1)],1)],1)],1)])]})],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: ./src/components/Spinner/Spinner.vue + 3 modules
var Spinner = __webpack_require__(683);
// EXTERNAL MODULE: ./src/mixins/DateMixin.ts
var DateMixin = __webpack_require__(4774);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/TeamApiTokenForm/TeamApiTokenForm.ts?vue&type=script&lang=ts&external







var TeamApiTokenForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TeamApiTokenForm, _super);
    function TeamApiTokenForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.token = {
            abilities: {}
        };
        return _this;
    }
    TeamApiTokenForm.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadUserPermissions()];
                    case 1:
                        _a.sent();
                        this.watchValue(this.value);
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(TeamApiTokenForm.prototype, "formAction", {
        get: function () {
            var _a;
            var url = '/api_token';
            if ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id) {
                url += '/' + this.value.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TeamApiTokenForm.prototype, "formMethod", {
        get: function () {
            var _a;
            return ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id) ? 'PUT' : 'POST';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TeamApiTokenForm.prototype, "permissions", {
        get: function () {
            return this.userPermissions.map(function (category) {
                category.permissions = category.permissions.filter(function (permission) { return !permission.notForApi; });
                return category;
            }).filter(function (category) { return category.permissions.length > 0; });
        },
        enumerable: false,
        configurable: true
    });
    TeamApiTokenForm.prototype.watchValue = function (value) {
        var token = value ? JSON.parse(JSON.stringify(value)) : { abilities: {} };
        var abilities = {};
        this.permissions.forEach(function (category) {
            category.permissions.forEach(function (permission) {
                if (!token.id || (Array.isArray(token.abilities) && token.abilities[0] === '*')) {
                    abilities[permission.key] = permission.defaultLevel.value;
                }
                else if (token.abilities[permission.key]) {
                    abilities[permission.key] = Number(token.abilities[permission.key]);
                }
                else {
                    abilities[permission.key] = permission.levels[0].value;
                }
            });
        });
        token.abilities = abilities;
        this.token = token;
    };
    TeamApiTokenForm.prototype.submitComplete = function (response) {
        this.$emit('submitComplete', response);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], TeamApiTokenForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value')
    ], TeamApiTokenForm.prototype, "watchValue", null);
    TeamApiTokenForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadUserPermissions'])),
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('globalDatas', ['userPermissions'])),
            components: {
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormDatepicker: form_vue_.KFormDatepicker, KFormSelect: form_vue_.KFormSelect,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BCard: external_bootstrap_vue_.BCard, BCardHeader: external_bootstrap_vue_.BCardHeader, BCardBody: external_bootstrap_vue_.BCardBody, BCollapse: external_bootstrap_vue_.BCollapse, BButton: external_bootstrap_vue_.BButton,
                Spinner: Spinner/* default */.A
            },
            directives: {
                'b-toggle': external_bootstrap_vue_.VBToggle
            }
        })
    ], TeamApiTokenForm);
    return TeamApiTokenForm;
}((0,lib/* Mixins */.Xe)(DateMixin/* default */.A)));
/* harmony default export */ var TeamApiTokenFormvue_type_script_lang_ts_external = (TeamApiTokenForm);

;// ./src/components/TeamApiTokenForm/TeamApiTokenForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var TeamApiTokenForm_TeamApiTokenFormvue_type_script_lang_ts_external = (TeamApiTokenFormvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/TeamApiTokenForm/TeamApiTokenForm.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  TeamApiTokenForm_TeamApiTokenFormvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TeamApiTokenForm_TeamApiTokenForm = (component.exports);

/***/ }),

/***/ 5355:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_EmailVerificationView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/EmailVerificationView.vue?vue&type=template&id=090bb6b4
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('EmailVerification',{attrs:{"token":_vm.$route.params.token,"hash":_vm.$route.params.hash}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: ./src/components/EmailVerification/EmailVerification.vue + 3 modules
var EmailVerification = __webpack_require__(1306);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/EmailVerificationView.vue?vue&type=script&lang=ts



var EmailVerificationView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(EmailVerificationView, _super);
    function EmailVerificationView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmailVerificationView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                EmailVerification: EmailVerification/* default */.A
            }
        })
    ], EmailVerificationView);
    return EmailVerificationView;
}(lib/* Vue */.lD));
/* harmony default export */ var EmailVerificationViewvue_type_script_lang_ts = (EmailVerificationView);

;// ./src/views/EmailVerificationView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_EmailVerificationViewvue_type_script_lang_ts = (EmailVerificationViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/EmailVerificationView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_EmailVerificationViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_EmailVerificationView = (component.exports);

/***/ }),

/***/ 5358:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./af": 5177,
	"./af.js": 5177,
	"./ar": 1509,
	"./ar-dz": 1488,
	"./ar-dz.js": 1488,
	"./ar-kw": 8676,
	"./ar-kw.js": 8676,
	"./ar-ly": 2353,
	"./ar-ly.js": 2353,
	"./ar-ma": 4496,
	"./ar-ma.js": 4496,
	"./ar-ps": 6947,
	"./ar-ps.js": 6947,
	"./ar-sa": 2682,
	"./ar-sa.js": 2682,
	"./ar-tn": 9756,
	"./ar-tn.js": 9756,
	"./ar.js": 1509,
	"./az": 5533,
	"./az.js": 5533,
	"./be": 8959,
	"./be.js": 8959,
	"./bg": 7777,
	"./bg.js": 7777,
	"./bm": 4903,
	"./bm.js": 4903,
	"./bn": 1290,
	"./bn-bd": 7357,
	"./bn-bd.js": 7357,
	"./bn.js": 1290,
	"./bo": 1545,
	"./bo.js": 1545,
	"./br": 1470,
	"./br.js": 1470,
	"./bs": 4429,
	"./bs.js": 4429,
	"./ca": 7306,
	"./ca.js": 7306,
	"./cs": 6464,
	"./cs.js": 6464,
	"./cv": 3635,
	"./cv.js": 3635,
	"./cy": 4226,
	"./cy.js": 4226,
	"./da": 3601,
	"./da.js": 3601,
	"./de": 7853,
	"./de-at": 6111,
	"./de-at.js": 6111,
	"./de-ch": 4697,
	"./de-ch.js": 4697,
	"./de.js": 7853,
	"./dv": 708,
	"./dv.js": 708,
	"./el": 4691,
	"./el.js": 4691,
	"./en-au": 3872,
	"./en-au.js": 3872,
	"./en-ca": 8298,
	"./en-ca.js": 8298,
	"./en-gb": 6195,
	"./en-gb.js": 6195,
	"./en-ie": 6584,
	"./en-ie.js": 6584,
	"./en-il": 5543,
	"./en-il.js": 5543,
	"./en-in": 9033,
	"./en-in.js": 9033,
	"./en-nz": 9402,
	"./en-nz.js": 9402,
	"./en-sg": 3004,
	"./en-sg.js": 3004,
	"./eo": 2934,
	"./eo.js": 2934,
	"./es": 7650,
	"./es-do": 838,
	"./es-do.js": 838,
	"./es-mx": 7730,
	"./es-mx.js": 7730,
	"./es-us": 6575,
	"./es-us.js": 6575,
	"./es.js": 7650,
	"./et": 3035,
	"./et.js": 3035,
	"./eu": 3508,
	"./eu.js": 3508,
	"./fa": 119,
	"./fa.js": 119,
	"./fi": 527,
	"./fi.js": 527,
	"./fil": 5995,
	"./fil.js": 5995,
	"./fo": 2477,
	"./fo.js": 2477,
	"./fr": 5498,
	"./fr-ca": 6435,
	"./fr-ca.js": 6435,
	"./fr-ch": 7892,
	"./fr-ch.js": 7892,
	"./fr.js": 5498,
	"./fy": 7071,
	"./fy.js": 7071,
	"./ga": 1734,
	"./ga.js": 1734,
	"./gd": 217,
	"./gd.js": 217,
	"./gl": 7329,
	"./gl.js": 7329,
	"./gom-deva": 2124,
	"./gom-deva.js": 2124,
	"./gom-latn": 3383,
	"./gom-latn.js": 3383,
	"./gu": 5050,
	"./gu.js": 5050,
	"./he": 1713,
	"./he.js": 1713,
	"./hi": 3861,
	"./hi.js": 3861,
	"./hr": 6308,
	"./hr.js": 6308,
	"./hu": 609,
	"./hu.js": 609,
	"./hy-am": 7160,
	"./hy-am.js": 7160,
	"./id": 4063,
	"./id.js": 4063,
	"./is": 9374,
	"./is.js": 9374,
	"./it": 8383,
	"./it-ch": 1827,
	"./it-ch.js": 1827,
	"./it.js": 8383,
	"./ja": 3827,
	"./ja.js": 3827,
	"./jv": 9722,
	"./jv.js": 9722,
	"./ka": 1794,
	"./ka.js": 1794,
	"./kk": 7088,
	"./kk.js": 7088,
	"./km": 6870,
	"./km.js": 6870,
	"./kn": 4451,
	"./kn.js": 4451,
	"./ko": 3164,
	"./ko.js": 3164,
	"./ku": 8174,
	"./ku-kmr": 6181,
	"./ku-kmr.js": 6181,
	"./ku.js": 8174,
	"./ky": 8474,
	"./ky.js": 8474,
	"./lb": 9680,
	"./lb.js": 9680,
	"./lo": 5867,
	"./lo.js": 5867,
	"./lt": 5766,
	"./lt.js": 5766,
	"./lv": 9532,
	"./lv.js": 9532,
	"./me": 8076,
	"./me.js": 8076,
	"./mi": 1848,
	"./mi.js": 1848,
	"./mk": 306,
	"./mk.js": 306,
	"./ml": 3739,
	"./ml.js": 3739,
	"./mn": 9053,
	"./mn.js": 9053,
	"./mr": 6169,
	"./mr.js": 6169,
	"./ms": 3386,
	"./ms-my": 2297,
	"./ms-my.js": 2297,
	"./ms.js": 3386,
	"./mt": 7075,
	"./mt.js": 7075,
	"./my": 2264,
	"./my.js": 2264,
	"./nb": 2274,
	"./nb.js": 2274,
	"./ne": 8235,
	"./ne.js": 8235,
	"./nl": 2572,
	"./nl-be": 3784,
	"./nl-be.js": 3784,
	"./nl.js": 2572,
	"./nn": 4566,
	"./nn.js": 4566,
	"./oc-lnc": 9330,
	"./oc-lnc.js": 9330,
	"./pa-in": 9849,
	"./pa-in.js": 9849,
	"./pl": 4418,
	"./pl.js": 4418,
	"./pt": 9834,
	"./pt-br": 684,
	"./pt-br.js": 684,
	"./pt.js": 9834,
	"./ro": 4457,
	"./ro.js": 4457,
	"./ru": 2271,
	"./ru.js": 2271,
	"./sd": 1221,
	"./sd.js": 1221,
	"./se": 3478,
	"./se.js": 3478,
	"./si": 7538,
	"./si.js": 7538,
	"./sk": 5784,
	"./sk.js": 5784,
	"./sl": 6637,
	"./sl.js": 6637,
	"./sq": 6794,
	"./sq.js": 6794,
	"./sr": 5719,
	"./sr-cyrl": 3322,
	"./sr-cyrl.js": 3322,
	"./sr.js": 5719,
	"./ss": 6000,
	"./ss.js": 6000,
	"./sv": 1011,
	"./sv.js": 1011,
	"./sw": 748,
	"./sw.js": 748,
	"./ta": 1025,
	"./ta.js": 1025,
	"./te": 1885,
	"./te.js": 1885,
	"./tet": 8861,
	"./tet.js": 8861,
	"./tg": 8952,
	"./tg.js": 8952,
	"./th": 5802,
	"./th.js": 5802,
	"./tk": 9527,
	"./tk.js": 9527,
	"./tl-ph": 9231,
	"./tl-ph.js": 9231,
	"./tlh": 1052,
	"./tlh.js": 1052,
	"./tr": 5096,
	"./tr.js": 5096,
	"./tzl": 9846,
	"./tzl.js": 9846,
	"./tzm": 1765,
	"./tzm-latn": 7711,
	"./tzm-latn.js": 7711,
	"./tzm.js": 1765,
	"./ug-cn": 8414,
	"./ug-cn.js": 8414,
	"./uk": 6618,
	"./uk.js": 6618,
	"./ur": 158,
	"./ur.js": 158,
	"./uz": 7609,
	"./uz-latn": 2475,
	"./uz-latn.js": 2475,
	"./uz.js": 7609,
	"./vi": 1135,
	"./vi.js": 1135,
	"./x-pseudo": 4051,
	"./x-pseudo.js": 4051,
	"./yo": 2218,
	"./yo.js": 2218,
	"./zh-cn": 2648,
	"./zh-cn.js": 2648,
	"./zh-hk": 1632,
	"./zh-hk.js": 1632,
	"./zh-mo": 1541,
	"./zh-mo.js": 1541,
	"./zh-tw": 304,
	"./zh-tw.js": 304
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5358;

/***/ }),

/***/ 5364:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseMerge = __webpack_require__(5250),
    createAssigner = __webpack_require__(999);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),

/***/ 5388:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'code';
var width = 640;
var height = 512;
var ligatures = [];
var unicode = 'f121';
var svgPathData = 'M278.9 511.5l-61-17.7c-6.4-1.8-10-8.5-8.2-14.9L346.2 8.7c1.8-6.4 8.5-10 14.9-8.2l61 17.7c6.4 1.8 10 8.5 8.2 14.9L293.8 503.3c-1.9 6.4-8.5 10.1-14.9 8.2zm-114-112.2l43.5-46.4c4.6-4.9 4.3-12.7-.8-17.2L117 256l90.6-79.7c5.1-4.5 5.5-12.3.8-17.2l-43.5-46.4c-4.5-4.8-12.1-5.1-17-.5L3.8 247.2c-5.1 4.7-5.1 12.8 0 17.5l144.1 135.1c4.9 4.6 12.5 4.4 17-.5zm327.2.6l144.1-135.1c5.1-4.7 5.1-12.8 0-17.5L492.1 112.1c-4.8-4.5-12.4-4.3-17 .5L431.6 159c-4.6 4.9-4.3 12.7.8 17.2L523 256l-90.6 79.7c-5.1 4.5-5.5 12.3-.8 17.2l43.5 46.4c4.5 4.9 12.1 5.1 17 .6z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.jT = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 5389:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseMatches = __webpack_require__(3663),
    baseMatchesProperty = __webpack_require__(7978),
    identity = __webpack_require__(3488),
    isArray = __webpack_require__(6449),
    property = __webpack_require__(583);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),

/***/ 5434:
/***/ (function(module) {

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

module.exports = hasUnicodeWord;


/***/ }),

/***/ 5453:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'users-cog';
var width = 640;
var height = 512;
var ligatures = [];
var unicode = 'f509';
var svgPathData = 'M610.5 341.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 368.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5zM96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm224 32c1.9 0 3.7-.5 5.6-.6 8.3-21.7 20.5-42.1 36.3-59.2 7.4-8 17.9-12.6 28.9-12.6 6.9 0 13.7 1.8 19.6 5.3l7.9 4.6c.8-.5 1.6-.9 2.4-1.4 7-14.6 11.2-30.8 11.2-48 0-61.9-50.1-112-112-112S208 82.1 208 144c0 61.9 50.1 112 112 112zm105.2 194.5c-2.3-1.2-4.6-2.6-6.8-3.9-8.2 4.8-15.3 9.8-27.5 9.8-10.9 0-21.4-4.6-28.9-12.6-18.3-19.8-32.3-43.9-40.2-69.6-10.7-34.5 24.9-49.7 25.8-50.3-.1-2.6-.1-5.2 0-7.8l-7.9-4.6c-3.8-2.2-7-5-9.8-8.1-3.3.2-6.5.6-9.8.6-24.6 0-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h255.4c-3.7-6-6.2-12.8-6.2-20.3v-9.2zM173.1 274.6C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.lF = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 5481:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(9325);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 5498:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsStrictRegex =
            /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsShortStrictRegex =
            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
        monthsRegex =
            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsParse = [
            /^janv/i,
            /^févr/i,
            /^mars/i,
            /^avr/i,
            /^mai/i,
            /^juin/i,
            /^juil/i,
            /^août/i,
            /^sept/i,
            /^oct/i,
            /^nov/i,
            /^déc/i,
        ];

    var fr = moment.defineLocale('fr', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            w: 'une semaine',
            ww: '%d semaines',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal: function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fr;

})));


/***/ }),

/***/ 5527:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 5529:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseCreate = __webpack_require__(9344),
    getPrototype = __webpack_require__(8879),
    isPrototype = __webpack_require__(5527);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),

/***/ 5533:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı',
    };

    var az = moment.defineLocale('az', {
        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
            '_'
        ),
        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays:
            'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
                '_'
            ),
        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[sabah saat] LT',
            nextWeek: '[gələn həftə] dddd [saat] LT',
            lastDay: '[dünən] LT',
            lastWeek: '[keçən həftə] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s əvvəl',
            s: 'bir neçə saniyə',
            ss: '%d saniyə',
            m: 'bir dəqiqə',
            mm: '%d dəqiqə',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir il',
            yy: '%d il',
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM: function (input) {
            return /^(gündüz|axşam)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'gecə';
            } else if (hour < 12) {
                return 'səhər';
            } else if (hour < 17) {
                return 'gündüz';
            } else {
                return 'axşam';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal: function (number) {
            if (number === 0) {
                // special case for zero
                return number + '-ıncı';
            }
            var a = number % 10,
                b = (number % 100) - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return az;

})));


/***/ }),

/***/ 5539:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayReduce = __webpack_require__(882),
    deburr = __webpack_require__(828),
    words = __webpack_require__(6645);

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

module.exports = createCompounder;


/***/ }),

/***/ 5543:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Israel) [en-il]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIl = moment.defineLocale('en-il', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
    });

    return enIl;

})));


/***/ }),

/***/ 5580:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(6110),
    root = __webpack_require__(9325);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ 5713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ NotificationsList_NotificationsList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/NotificationsList/NotificationsList.vue?vue&type=template&id=1da19c1d
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('PageHeader',{attrs:{"pageTitle":_vm.$t('interface.pageTitle.notificationCenter')}},[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-overlay',{attrs:{"show":_vm.markReadLoading}},[_c('b-button',{attrs:{"variant":"primary","size":"sm","disabled":_vm.headerNotificationsTotal === 0},on:{"click":function($event){$event.preventDefault();return _vm.markAllAsRead.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('interface.notifications.markAllAsRead'))+" ")])],1)],1),_c('b-col',{staticClass:"text-right"},[_c('NotificationsConfig')],1)],1),(_vm.$kwInterface.appMessages)?_c('AppMessages'):_vm._e(),_c('div',{staticClass:"notifications-list"},[_c('b-row',{staticClass:"mb-4",attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label":_vm.$t('interface.notifications.state')}},[_c('k-form-checkbox',{attrs:{"switch":""},model:{value:(_vm.unreadOnly),callback:function ($$v) {_vm.unreadOnly=$$v},expression:"unreadOnly"}},[_vm._v(" "+_vm._s(_vm.$t('interface.notifications.unread'))+" ")])],1)],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label":_vm.$t('interface.notifications.date')}},[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"pr-1",attrs:{"cols":"auto"}},[_vm._v(" "+_vm._s(_vm.$t('interface.notifications.sincePeriod'))+" ")]),_c('b-col',{staticClass:"p-0",staticStyle:{"max-width":"110px"},attrs:{"cols":"auto"}},[_c('k-form-datepicker',{attrs:{"max-date":_vm.end,"size":"sm"},model:{value:(_vm.begin),callback:function ($$v) {_vm.begin=$$v},expression:"begin"}})],1),_c('b-col',{staticClass:"px-1",attrs:{"cols":"auto"}},[_vm._v(" "+_vm._s(_vm.$t('interface.notifications.untilPeriod'))+" ")]),_c('b-col',{staticClass:"p-0",staticStyle:{"max-width":"110px"},attrs:{"cols":"auto"}},[_c('k-form-datepicker',{attrs:{"min-date":_vm.begin,"size":"sm"},model:{value:(_vm.end),callback:function ($$v) {_vm.end=$$v},expression:"end"}})],1)],1)],1)],1),(_vm.activeTeamUsers.length > 0)?_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticStyle:{"min-width":"120px"},attrs:{"label":"Utilisateur"}},[_c('TeamUserSelect',{attrs:{"reduce":opt => opt.id,"size":"sm","filter":user => user.id !== _vm.teamUser.id,"clearable":""},model:{value:(_vm.filterTeamUser),callback:function ($$v) {_vm.filterTeamUser=$$v},expression:"filterTeamUser"}})],1)],1):_vm._e()],1),_c('div',{staticClass:"notifications"},[(_vm.notifications.length === 0 && !_vm.loading)?_c('div',{staticClass:"text-center font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('interface.notifications.empty'))+" ")]):_vm._l((_vm.notificationsByDay),function(notifications,day){return _c('div',{key:day},[_c('div',{staticClass:"day-title"},[_vm._v(" "+_vm._s(_vm.stringDate(day))+" "),_c('b-badge',{attrs:{"variant":"primary"}},[_vm._v(" "+_vm._s(notifications.length)+" ")])],1),_vm._l((notifications),function(notification,i){return _c('NotificationsItem',{key:i,model:{value:(notifications[i]),callback:function ($$v) {_vm.$set(notifications, i, $$v)},expression:"notifications[i]"}})})],2)}),(_vm.loading)?_c('Spinner'):_vm._e()],2)],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(9356);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
;// external "lodash"
var external_lodash_namespaceObject = require("lodash");
// EXTERNAL MODULE: ./src/utils/date.ts + 1 modules
var date = __webpack_require__(4755);
// EXTERNAL MODULE: ./src/mixins/DateMixin.ts
var DateMixin = __webpack_require__(4774);
// EXTERNAL MODULE: ./src/mitt.ts + 1 modules
var mitt = __webpack_require__(6912);
// EXTERNAL MODULE: ./src/components/NotificationsItem/NotificationsItem.vue + 3 modules
var NotificationsItem = __webpack_require__(9450);
// EXTERNAL MODULE: ./src/components/NotificationsConfig/NotificationsConfig.vue + 3 modules
var NotificationsConfig = __webpack_require__(768);
// EXTERNAL MODULE: ./src/components/Spinner/Spinner.vue + 3 modules
var Spinner = __webpack_require__(683);
// EXTERNAL MODULE: ./src/components/PageHeader/PageHeader.vue + 3 modules
var PageHeader = __webpack_require__(6124);
// EXTERNAL MODULE: ./src/components/TeamUserSelect/TeamUserSelect.vue + 3 modules
var TeamUserSelect = __webpack_require__(2735);
// EXTERNAL MODULE: ./src/components/AppMessages/AppMessages.vue + 3 modules
var AppMessages = __webpack_require__(3808);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/NotificationsList/NotificationsList.ts?vue&type=script&lang=ts&external
















var NotificationsList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(NotificationsList, _super);
    function NotificationsList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.markReadLoading = false;
        _this.page = 1;
        _this.total = 0;
        _this.notifications = [];
        _this.unreadOnly = false;
        _this.begin = null;
        _this.end = null;
        _this.filterTeamUser = null;
        return _this;
    }
    NotificationsList.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadNotifications()];
                    case 1:
                        _a.sent();
                        mitt/* default */.A.on('notificationCreated', this.notificationCreated);
                        mitt/* default */.A.on('notificationUpdated', this.notificationUpdated);
                        document.getElementById('page').addEventListener('scroll', this.scrollEvent);
                        return [2 /*return*/];
                }
            });
        });
    };
    NotificationsList.prototype.beforeDestroy = function () {
        mitt/* default */.A.off('notificationCreated', this.notificationCreated);
        mitt/* default */.A.off('notificationUpdated', this.notificationUpdated);
        document.getElementById('page').removeEventListener('scroll', this.scrollEvent);
    };
    NotificationsList.prototype.scrollEvent = function () {
        var _a = document.getElementById('page'), scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
        if (scrollTop + clientHeight >= scrollHeight - 5 && this.notifications.length < this.total && !this.loading) {
            this.page++;
        }
    };
    Object.defineProperty(NotificationsList.prototype, "notificationsByDay", {
        get: function () {
            return (0,external_lodash_namespaceObject.groupBy)(this.notifications, function (notification) { return (0,date/* moment */.n$)(notification.created_at).format('YYYY-MM-DD'); });
        },
        enumerable: false,
        configurable: true
    });
    NotificationsList.prototype.watchPage = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadNotifications()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NotificationsList.prototype.watchUnread = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.page = 1;
                        this.notifications = [];
                        return [4 /*yield*/, this.loadNotifications()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NotificationsList.prototype.loadNotifications = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var filter;
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.loading) {
                            return [2 /*return*/];
                        }
                        this.loading = true;
                        filter = {};
                        if (this.unreadOnly) {
                            filter.is_read = false;
                        }
                        if (this.begin) {
                            filter.created_since = this.begin;
                        }
                        if (this.end) {
                            filter.created_until = this.end;
                        }
                        if (this.filterTeamUser) {
                            filter.team_user = this.filterTeamUser;
                        }
                        return [4 /*yield*/, this.$kwInterface.axios.get('/notification', {
                                params: {
                                    page: this.page,
                                    sort: 'created_at:desc',
                                    filter: filter
                                }
                            })
                                .then(function (response) {
                                var _a;
                                (_a = _this.notifications).push.apply(_a, response.data.data);
                                _this.total = response.data.meta.total;
                                _this.$nextTick(function () {
                                    _this.loading = false;
                                });
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NotificationsList.prototype.notificationCreated = function (notification) {
        this.notifications.unshift(notification);
    };
    NotificationsList.prototype.notificationUpdated = function (notification) {
        var index = this.notifications.findIndex(function (val) { return val.id === notification.id; });
        if (index >= 0) {
            lib/* Vue */.lD.set(this.notifications, index, notification);
        }
    };
    NotificationsList.prototype.markAllAsRead = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.markReadLoading = true;
                        return [4 /*yield*/, this.$kwInterface.axios.post('/notification/all/read')
                                .then(function () {
                                _this.markReadLoading = false;
                                _this.notifications.forEach(function (notification) {
                                    notification.read = true;
                                });
                                _this.resetHeaderNotifications();
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('page')
    ], NotificationsList.prototype, "watchPage", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('unreadOnly'),
        (0,lib/* Watch */.ox)('begin'),
        (0,lib/* Watch */.ox)('end'),
        (0,lib/* Watch */.ox)('filterTeamUser')
    ], NotificationsList.prototype, "watchUnread", null);
    NotificationsList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BButton: external_bootstrap_vue_.BButton, BCol: external_bootstrap_vue_.BCol, BPagination: external_bootstrap_vue_.BPagination, BBadge: external_bootstrap_vue_.BBadge, BOverlay: external_bootstrap_vue_.BOverlay, BRow: external_bootstrap_vue_.BRow, BFormGroup: external_bootstrap_vue_.BFormGroup,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                NotificationsItem: NotificationsItem/* default */.A, NotificationsConfig: NotificationsConfig/* default */.A,
                KFormCheckbox: form_vue_.KFormCheckbox, KFormDatepicker: form_vue_.KFormDatepicker,
                Spinner: Spinner/* default */.A,
                PageHeader: PageHeader/* default */.A, TeamUserSelect: TeamUserSelect/* default */.A,
                AppMessages: AppMessages/* default */.A
            },
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('notifications', ['resetHeaderNotifications'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('notifications', ['headerNotificationsTotal'])), (0,external_vuex_.mapGetters)('user', ['teamUser'])), (0,external_vuex_.mapGetters)('globalDatas', ['activeTeamUsers']))
        })
    ], NotificationsList);
    return NotificationsList;
}((0,lib/* Mixins */.Xe)(DateMixin/* default */.A)));
/* harmony default export */ var NotificationsListvue_type_script_lang_ts_external = (NotificationsList);

;// ./src/components/NotificationsList/NotificationsList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var NotificationsList_NotificationsListvue_type_script_lang_ts_external = (NotificationsListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/NotificationsList/NotificationsList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  NotificationsList_NotificationsListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var NotificationsList_NotificationsList = (component.exports);

/***/ }),

/***/ 5719:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekunda', 'sekunde', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            d: ['jedan dan', 'jednog dana'],
            dd: ['dan', 'dana', 'dana'],
            M: ['jedan mesec', 'jednog meseca'],
            MM: ['mesec', 'meseca', 'meseci'],
            y: ['jednu godinu', 'jedne godine'],
            yy: ['godinu', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            if (
                number % 10 >= 1 &&
                number % 10 <= 4 &&
                (number % 100 < 10 || number % 100 >= 20)
            ) {
                return number % 10 === 1 ? wordKey[0] : wordKey[1];
            }
            return wordKey[2];
        },
        translate: function (number, withoutSuffix, key, isFuture) {
            var wordKey = translator.words[key],
                word;

            if (key.length === 1) {
                // Nominativ
                if (key === 'y' && withoutSuffix) return 'jedna godina';
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }

            word = translator.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === 'yy' && withoutSuffix && word === 'godinu') {
                return number + ' godina';
            }

            return number + ' ' + word;
        },
    };

    var sr = moment.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedelje] [u] LT',
                    '[prošlog] [ponedeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pre %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: translator.translate,
            dd: translator.translate,
            M: translator.translate,
            MM: translator.translate,
            y: translator.translate,
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sr;

})));


/***/ }),

/***/ 5749:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(1042);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 5766:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundė_sekundžių_sekundes',
        m: 'minutė_minutės_minutę',
        mm: 'minutės_minučių_minutes',
        h: 'valanda_valandos_valandą',
        hh: 'valandos_valandų_valandas',
        d: 'diena_dienos_dieną',
        dd: 'dienos_dienų_dienas',
        M: 'mėnuo_mėnesio_mėnesį',
        MM: 'mėnesiai_mėnesių_mėnesius',
        y: 'metai_metų_metus',
        yy: 'metai_metų_metus',
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return 'kelios sekundės';
        } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix
            ? forms(key)[0]
            : isFuture
              ? forms(key)[1]
              : forms(key)[2];
    }
    function special(number) {
        return number % 10 === 0 || (number > 10 && number < 20);
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) {
            return (
                result + translateSingular(number, withoutSuffix, key[0], isFuture)
            );
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }
    var lt = moment.defineLocale('lt', {
        months: {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
                '_'
            ),
            standalone:
                'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
                    '_'
                ),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
        },
        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays: {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
                '_'
            ),
            standalone:
                'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
                    '_'
                ),
            isFormat: /dddd HH:mm/,
        },
        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY [m.] MMMM D [d.]',
            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l: 'YYYY-MM-DD',
            ll: 'YYYY [m.] MMMM D [d.]',
            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
        },
        calendar: {
            sameDay: '[Šiandien] LT',
            nextDay: '[Rytoj] LT',
            nextWeek: 'dddd LT',
            lastDay: '[Vakar] LT',
            lastWeek: '[Praėjusį] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'po %s',
            past: 'prieš %s',
            s: translateSeconds,
            ss: translate,
            m: translateSingular,
            mm: translate,
            h: translateSingular,
            hh: translate,
            d: translateSingular,
            dd: translate,
            M: translateSingular,
            MM: translate,
            y: translateSingular,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal: function (number) {
            return number + '-oji';
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lt;

})));


/***/ }),

/***/ 5784:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months =
            'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
                '_'
            ),
        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
    function plural(n) {
        return n > 1 && n < 5;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minúty' : 'minút');
                } else {
                    return result + 'minútami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodín');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'deň' : 'dňom';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dni' : 'dní');
                } else {
                    return result + 'dňami';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
                } else {
                    return result + 'mesiacmi';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokom';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'rokov');
                } else {
                    return result + 'rokmi';
                }
        }
    }

    var sk = moment.defineLocale('sk', {
        months: months,
        monthsShort: monthsShort,
        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return '[vo štvrtok o] LT';
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulú nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[minulý] dddd [o] LT';
                    case 3:
                        return '[minulú stredu o] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [o] LT';
                    case 6:
                        return '[minulú sobotu o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pred %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sk;

})));


/***/ }),

/***/ 5802:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var th = moment.defineLocale('th', {
        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
            '_'
        ),
        monthsShort:
            'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY เวลา H:mm',
            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function (input) {
            return input === 'หลังเที่ยง';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar: {
            sameDay: '[วันนี้ เวลา] LT',
            nextDay: '[พรุ่งนี้ เวลา] LT',
            nextWeek: 'dddd[หน้า เวลา] LT',
            lastDay: '[เมื่อวานนี้ เวลา] LT',
            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'อีก %s',
            past: '%sที่แล้ว',
            s: 'ไม่กี่วินาที',
            ss: '%d วินาที',
            m: '1 นาที',
            mm: '%d นาที',
            h: '1 ชั่วโมง',
            hh: '%d ชั่วโมง',
            d: '1 วัน',
            dd: '%d วัน',
            w: '1 สัปดาห์',
            ww: '%d สัปดาห์',
            M: '1 เดือน',
            MM: '%d เดือน',
            y: '1 ปี',
            yy: '%d ปี',
        },
    });

    return th;

})));


/***/ }),

/***/ 5837:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'id-card';
var width = 576;
var height = 512;
var ligatures = [];
var unicode = 'f2c2';
var svgPathData = 'M528 32H48C21.5 32 0 53.5 0 80v16h576V80c0-26.5-21.5-48-48-48zM0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V128H0v304zm352-232c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zM176 192c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zM67.1 396.2C75.5 370.5 99.6 352 128 352h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.9-5.2 19.8-15.6 19.8H82.7c-10.4 0-18.8-10-15.6-19.8z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.Lm = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 5861:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DataView = __webpack_require__(5580),
    Map = __webpack_require__(8223),
    Promise = __webpack_require__(2804),
    Set = __webpack_require__(6545),
    WeakMap = __webpack_require__(8303),
    baseGetTag = __webpack_require__(2552),
    toSource = __webpack_require__(7473);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ 5867:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var lo = moment.defineLocale('lo', {
        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
            '_'
        ),
        monthsShort:
            'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
                '_'
            ),
        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function (input) {
            return input === 'ຕອນແລງ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ຕອນເຊົ້າ';
            } else {
                return 'ຕອນແລງ';
            }
        },
        calendar: {
            sameDay: '[ມື້ນີ້ເວລາ] LT',
            nextDay: '[ມື້ອື່ນເວລາ] LT',
            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ອີກ %s',
            past: '%sຜ່ານມາ',
            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
            ss: '%d ວິນາທີ',
            m: '1 ນາທີ',
            mm: '%d ນາທີ',
            h: '1 ຊົ່ວໂມງ',
            hh: '%d ຊົ່ວໂມງ',
            d: '1 ມື້',
            dd: '%d ມື້',
            M: '1 ເດືອນ',
            MM: '%d ເດືອນ',
            y: '1 ປີ',
            yy: '%d ປີ',
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal: function (number) {
            return 'ທີ່' + number;
        },
    });

    return lo;

})));


/***/ }),

/***/ 5891:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'tags';
var width = 640;
var height = 512;
var ligatures = [];
var unicode = 'f02c';
var svgPathData = 'M497.941 225.941L286.059 14.059A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v204.118a48 48 0 0 0 14.059 33.941l211.882 211.882c18.744 18.745 49.136 18.746 67.882 0l204.118-204.118c18.745-18.745 18.745-49.137 0-67.882zM112 160c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm513.941 133.823L421.823 497.941c-18.745 18.745-49.137 18.745-67.882 0l-.36-.36L527.64 323.522c16.999-16.999 26.36-39.6 26.36-63.64s-9.362-46.641-26.36-63.64L331.397 0h48.721a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.DX = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 5911:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(8859),
    arraySome = __webpack_require__(4248),
    cacheHas = __webpack_require__(9219);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ 5913:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fad';
var iconName = 'file-word';
var width = 384;
var height = 512;
var ligatures = [];
var unicode = 'f1c2';
var svgPathData = ['M384 128H272a16 16 0 0 1-16-16V0H24A23.94 23.94 0 0 0 0 23.88V488a23.94 23.94 0 0 0 23.88 24H360a23.94 23.94 0 0 0 24-23.88V128zm-67.3 142.7l-38 168A11.9 11.9 0 0 1 267 448h-38a12 12 0 0 1-11.6-9.1c-25.8-103.5-20.8-81.2-25.6-110.5h-.5c-1.1 14.3-2.4 17.4-25.6 110.5a12 12 0 0 1-11.6 9.1H117a12 12 0 0 1-11.7-9.4l-37.8-168A12 12 0 0 1 79.2 256h24.5a12 12 0 0 1 11.8 9.7c15.6 78 20.1 109.5 21 122.2 1.6-10.2 7.3-32.7 29.4-122.7a11.9 11.9 0 0 1 11.7-9.1h29.1a12 12 0 0 1 11.7 9.2c24 100.4 28.8 124 29.6 129.4-.2-11.2-2.6-17.8 21.6-129.2a11.59 11.59 0 0 1 11.5-9.5H305a12 12 0 0 1 12 12 11.8 11.8 0 0 1-.3 2.7z', 'M377 105L279.1 7a24 24 0 0 0-17-7H256v112a16 16 0 0 0 16 16h112v-6.1a23.9 23.9 0 0 0-7-16.9zm-72 151h-23.9a11.59 11.59 0 0 0-11.5 9.5c-24.2 111.4-21.8 118-21.6 129.2-.8-5.4-5.6-29-29.6-129.4a12 12 0 0 0-11.7-9.2h-29.1a11.9 11.9 0 0 0-11.7 9.1c-22.1 90-27.8 112.5-29.4 122.7-.9-12.7-5.4-44.2-21-122.2a12 12 0 0 0-11.8-9.7H79.2a12 12 0 0 0-11.7 14.6l37.8 168A12 12 0 0 0 117 448h37.1a12 12 0 0 0 11.6-9.1c23.2-93.1 24.5-96.2 25.6-110.5h.5c4.8 29.3-.2 7 25.6 110.5A12 12 0 0 0 229 448h38a11.9 11.9 0 0 0 11.7-9.3l38-168a11.8 11.8 0 0 0 .3-2.7 12 12 0 0 0-12-12z'];

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.W1 = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 5950:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(695),
    baseKeys = __webpack_require__(8984),
    isArrayLike = __webpack_require__(4894);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 5974:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'circle';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f111';
var svgPathData = 'M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.GE = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 5995:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Filipino [fil]
//! author : Dan Hagman : https://github.com/hagmandan
//! author : Matthew Co : https://github.com/matthewdeeco

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fil = moment.defineLocale('fil', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fil;

})));


/***/ }),

/***/ 6000:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ss = moment.defineLocale('ss', {
        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
            '_'
        ),
        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays:
            'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
                '_'
            ),
        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Namuhla nga] LT',
            nextDay: '[Kusasa nga] LT',
            nextWeek: 'dddd [nga] LT',
            lastDay: '[Itolo nga] LT',
            lastWeek: 'dddd [leliphelile] [nga] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'nga %s',
            past: 'wenteka nga %s',
            s: 'emizuzwana lomcane',
            ss: '%d mzuzwana',
            m: 'umzuzu',
            mm: '%d emizuzu',
            h: 'lihora',
            hh: '%d emahora',
            d: 'lilanga',
            dd: '%d emalanga',
            M: 'inyanga',
            MM: '%d tinyanga',
            y: 'umnyaka',
            yy: '%d iminyaka',
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'ekuseni';
            } else if (hours < 15) {
                return 'emini';
            } else if (hours < 19) {
                return 'entsambama';
            } else {
                return 'ebusuku';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ekuseni') {
                return hour;
            } else if (meridiem === 'emini') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) {
                    return 0;
                }
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: '%d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ss;

})));


/***/ }),

/***/ 6009:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(4840);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 6025:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(5288);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 6041:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'calendar-alt';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f073';
var svgPathData = 'M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm320-196c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM192 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM64 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.BE = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 6110:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsNative = __webpack_require__(5083),
    getValue = __webpack_require__(392);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 6111:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deAt = moment.defineLocale('de-at', {
        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deAt;

})));


/***/ }),

/***/ 6124:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ PageHeader_PageHeader; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/PageHeader/PageHeader.vue?vue&type=template&id=2e69c918
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-row',{staticClass:"app-title pb-2",attrs:{"align-v":"center"}},[_c('b-col',_vm._b({},'b-col',_vm.titleColProperties,false),[_c('h1',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.computedPageTitle))])]),(_vm.computedButtons.length > 0)?_c('b-col',_vm._b({staticClass:"pl-0"},'b-col',_vm.buttonsColProperties,false),[_c('PageHeaderButtons',{attrs:{"buttons":_vm.computedButtons,"responsive-breakpoint":_vm.responsiveMenuBreakpoint,"responsive-element-count":_vm.responsiveMenuElementCount,"no-responsive":_vm.noResponsiveMenu}})],1):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: ./src/utils/breakpoints.ts + 1 modules
var utils_breakpoints = __webpack_require__(5118);
// EXTERNAL MODULE: ./src/components/PageHeaderButtons/PageHeaderButtons.vue + 3 modules
var PageHeaderButtons = __webpack_require__(3615);
// EXTERNAL MODULE: ./src/mixins/PageHeaderMixin.ts
var PageHeaderMixin = __webpack_require__(8484);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/PageHeader/PageHeader.ts?vue&type=script&lang=ts&external







var PageHeader = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PageHeader, _super);
    function PageHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(PageHeader.prototype, "titleColProperties", {
        get: function () {
            var breakpoints = this.$kwInterface.pageHeaderBreakpoints;
            var defaultCols = {};
            if (breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.titleCols) {
                defaultCols = (0,utils_breakpoints/* applyProps */.FT)(function (breakpoint) { return breakpoint; }, breakpoints.titleCols, function (breakpoint) { return breakpoint === 'xs' ? 'cols' : breakpoint; });
            }
            var defaultOrder = {};
            if (breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.titleOrder) {
                defaultOrder = (0,utils_breakpoints/* applyProps */.FT)(function (breakpoint) { return breakpoint; }, breakpoints.titleOrder, function (breakpoint) { return breakpoint === 'xs' ? 'cols' : breakpoint; });
            }
            return Object.assign((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, defaultCols), defaultOrder), (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({ class: this.titleClass }, (0,utils_breakpoints/* applyProps */.FT)('title-order', this.$props, 'order')), (0,utils_breakpoints/* applyProps */.FT)('title-cols', this.$props, function (breakpoint) { return breakpoint === 'xs' ? 'cols' : breakpoint; })));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PageHeader.prototype, "buttonsColProperties", {
        get: function () {
            var breakpoints = this.$kwInterface.pageHeaderBreakpoints;
            var defaultCols = {};
            if (breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.buttonsCols) {
                defaultCols = (0,utils_breakpoints/* applyProps */.FT)(function (breakpoint) { return breakpoint; }, breakpoints.buttonsCols, function (breakpoint) { return breakpoint === 'xs' ? 'cols' : breakpoint; });
            }
            var defaultOrder = {};
            if (breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.buttonsOrder) {
                defaultOrder = (0,utils_breakpoints/* applyProps */.FT)(function (breakpoint) { return breakpoint; }, breakpoints.buttonsOrder, function (breakpoint) { return breakpoint === 'xs' ? 'cols' : breakpoint; });
            }
            var cssClass = {
                'text-center': true,
                'text-sm-center': true,
                'mt-2': true,
                'mt-sm-0': true
            };
            if (this.buttonsClass) {
                if (typeof this.buttonsClass === 'string') {
                    cssClass[this.buttonsClass] = true;
                }
                else {
                    cssClass = Object.assign(cssClass, this.buttonsClass);
                }
            }
            return Object.assign({
                cols: 12,
                md: '*',
                class: 'text-center text-sm-center mt-2 mt-sm-0'
            }, (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, defaultCols), defaultOrder), (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({ class: cssClass }, (0,utils_breakpoints/* applyProps */.FT)('buttons-order', this.$props, 'order')), (0,utils_breakpoints/* applyProps */.FT)('buttons-cols', this.$props, function (breakpoint) { return breakpoint === 'xs' ? 'cols' : breakpoint; })));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PageHeader.prototype, "computedPageTitle", {
        get: function () {
            var _a;
            var title = this.pageTitle;
            if (this.useMeta) {
                title = (_a = this.$route.meta) === null || _a === void 0 ? void 0 : _a.title;
            }
            if (title && this.addTitleConfigPrefix && this.$kwInterface.addTitleConfigPrefix !== false && this.$route.fullPath.substr(0, 14) === '/configuration') {
                title = this.$t('interface.configuration') + ' - ' + title;
            }
            return title;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PageHeader.prototype, "computedButtons", {
        get: function () {
            var _this = this;
            var _a, _b, _c;
            var buttons;
            if (this.useMeta) {
                buttons = (_b = (_a = this.$route.meta) === null || _a === void 0 ? void 0 : _a.buttons) !== null && _b !== void 0 ? _b : [];
            }
            else {
                buttons = (_c = this.buttons) !== null && _c !== void 0 ? _c : [];
            }
            return buttons.filter(function (button) {
                return _this.showMenuEntry(button)
                    && (button.userPermission === undefined || _this.can(button.userPermission[0], button.userPermission[1]));
            });
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], PageHeader.prototype, "useMeta", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: function () { return []; } })
    ], PageHeader.prototype, "buttons", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PageHeader.prototype, "pageTitle", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PageHeader.prototype, "titleClass", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PageHeader.prototype, "buttonsClass", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: true })
    ], PageHeader.prototype, "addTitleConfigPrefix", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], PageHeader.prototype, "noResponsiveMenu", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 900 })
    ], PageHeader.prototype, "responsiveMenuBreakpoint", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 2 })
    ], PageHeader.prototype, "responsiveMenuElementCount", void 0);
    PageHeader = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['can'])),
            components: {
                PageHeaderButtons: PageHeaderButtons/* default */.A,
                BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol
            },
            props: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,utils_breakpoints/* generateProps */.Gu)('title-order', '*', (0,utils_breakpoints/* getBreakpoints */.BQ)())), (0,utils_breakpoints/* generateProps */.Gu)('buttons-order', '*', (0,utils_breakpoints/* getBreakpoints */.BQ)())), (0,utils_breakpoints/* generateProps */.Gu)('title-cols', 'auto', (0,utils_breakpoints/* getBreakpoints */.BQ)())), (0,utils_breakpoints/* generateProps */.Gu)('buttons-cols', 'auto', (0,utils_breakpoints/* getBreakpoints */.BQ)()))
        })
    ], PageHeader);
    return PageHeader;
}((0,lib/* Mixins */.Xe)(PageHeaderMixin/* default */.A)));
/* harmony default export */ var PageHeadervue_type_script_lang_ts_external = (PageHeader);

;// ./src/components/PageHeader/PageHeader.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var PageHeader_PageHeadervue_type_script_lang_ts_external = (PageHeadervue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/PageHeader/PageHeader.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  PageHeader_PageHeadervue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PageHeader_PageHeader = (component.exports);

/***/ }),

/***/ 6139:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignValue = __webpack_require__(6547),
    copyObject = __webpack_require__(1791),
    createAssigner = __webpack_require__(999),
    isArrayLike = __webpack_require__(4894),
    isPrototype = __webpack_require__(5527),
    keys = __webpack_require__(5950);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),

/***/ 6169:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
        var output = '';
        if (withoutSuffix) {
            switch (string) {
                case 's':
                    output = 'काही सेकंद';
                    break;
                case 'ss':
                    output = '%d सेकंद';
                    break;
                case 'm':
                    output = 'एक मिनिट';
                    break;
                case 'mm':
                    output = '%d मिनिटे';
                    break;
                case 'h':
                    output = 'एक तास';
                    break;
                case 'hh':
                    output = '%d तास';
                    break;
                case 'd':
                    output = 'एक दिवस';
                    break;
                case 'dd':
                    output = '%d दिवस';
                    break;
                case 'M':
                    output = 'एक महिना';
                    break;
                case 'MM':
                    output = '%d महिने';
                    break;
                case 'y':
                    output = 'एक वर्ष';
                    break;
                case 'yy':
                    output = '%d वर्षे';
                    break;
            }
        } else {
            switch (string) {
                case 's':
                    output = 'काही सेकंदां';
                    break;
                case 'ss':
                    output = '%d सेकंदां';
                    break;
                case 'm':
                    output = 'एका मिनिटा';
                    break;
                case 'mm':
                    output = '%d मिनिटां';
                    break;
                case 'h':
                    output = 'एका तासा';
                    break;
                case 'hh':
                    output = '%d तासां';
                    break;
                case 'd':
                    output = 'एका दिवसा';
                    break;
                case 'dd':
                    output = '%d दिवसां';
                    break;
                case 'M':
                    output = 'एका महिन्या';
                    break;
                case 'MM':
                    output = '%d महिन्यां';
                    break;
                case 'y':
                    output = 'एका वर्षा';
                    break;
                case 'yy':
                    output = '%d वर्षां';
                    break;
            }
        }
        return output.replace(/%d/i, number);
    }

    var mr = moment.defineLocale('mr', {
        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
            '_'
        ),
        monthsShort:
            'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm वाजता',
            LTS: 'A h:mm:ss वाजता',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm वाजता',
            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[उद्या] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            ss: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr,
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
                return hour;
            } else if (
                meridiem === 'दुपारी' ||
                meridiem === 'सायंकाळी' ||
                meridiem === 'रात्री'
            ) {
                return hour >= 12 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour >= 0 && hour < 6) {
                return 'पहाटे';
            } else if (hour < 12) {
                return 'सकाळी';
            } else if (hour < 17) {
                return 'दुपारी';
            } else if (hour < 20) {
                return 'सायंकाळी';
            } else {
                return 'रात्री';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return mr;

})));


/***/ }),

/***/ 6181:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Kurdish [ku-kmr]
//! authors : Mazlum Özdogan : https://github.com/mergehez

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(num, withoutSuffix, key, isFuture) {
        var format = {
            s: ['çend sanîye', 'çend sanîyeyan'],
            ss: [num + ' sanîye', num + ' sanîyeyan'],
            m: ['deqîqeyek', 'deqîqeyekê'],
            mm: [num + ' deqîqe', num + ' deqîqeyan'],
            h: ['saetek', 'saetekê'],
            hh: [num + ' saet', num + ' saetan'],
            d: ['rojek', 'rojekê'],
            dd: [num + ' roj', num + ' rojan'],
            w: ['hefteyek', 'hefteyekê'],
            ww: [num + ' hefte', num + ' hefteyan'],
            M: ['mehek', 'mehekê'],
            MM: [num + ' meh', num + ' mehan'],
            y: ['salek', 'salekê'],
            yy: [num + ' sal', num + ' salan'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    // function obliqueNumSuffix(num) {
    //     if(num.includes(':'))
    //         num = parseInt(num.split(':')[0]);
    //     else
    //         num = parseInt(num);
    //     return num == 0 || num % 10 == 1 ? 'ê'
    //                         : (num > 10 && num % 10 == 0 ? 'î' : 'an');
    // }
    function ezafeNumSuffix(num) {
        num = '' + num;
        var l = num.substring(num.length - 1),
            ll = num.length > 1 ? num.substring(num.length - 2) : '';
        if (
            !(ll == 12 || ll == 13) &&
            (l == '2' || l == '3' || ll == '50' || l == '70' || l == '80')
        )
            return 'yê';
        return 'ê';
    }

    var kuKmr = moment.defineLocale('ku-kmr', {
        // According to the spelling rules defined by the work group of Weqfa Mezopotamyayê (Mesopotamia Foundation)
        // this should be: 'Kanûna Paşîn_Sibat_Adar_Nîsan_Gulan_Hezîran_Tîrmeh_Tebax_Îlon_Çirîya Pêşîn_Çirîya Paşîn_Kanûna Pêşîn'
        // But the names below are more well known and handy
        months: 'Rêbendan_Sibat_Adar_Nîsan_Gulan_Hezîran_Tîrmeh_Tebax_Îlon_Cotmeh_Mijdar_Berfanbar'.split(
            '_'
        ),
        monthsShort: 'Rêb_Sib_Ada_Nîs_Gul_Hez_Tîr_Teb_Îlo_Cot_Mij_Ber'.split('_'),
        monthsParseExact: true,
        weekdays: 'Yekşem_Duşem_Sêşem_Çarşem_Pêncşem_În_Şemî'.split('_'),
        weekdaysShort: 'Yek_Du_Sê_Çar_Pên_În_Şem'.split('_'),
        weekdaysMin: 'Ye_Du_Sê_Ça_Pê_În_Şe'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'bn' : 'BN';
            } else {
                return isLower ? 'pn' : 'PN';
            }
        },
        meridiemParse: /bn|BN|pn|PN/,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM[a] YYYY[an]',
            LLL: 'Do MMMM[a] YYYY[an] HH:mm',
            LLLL: 'dddd, Do MMMM[a] YYYY[an] HH:mm',
            ll: 'Do MMM[.] YYYY[an]',
            lll: 'Do MMM[.] YYYY[an] HH:mm',
            llll: 'ddd[.], Do MMM[.] YYYY[an] HH:mm',
        },
        calendar: {
            sameDay: '[Îro di saet] LT [de]',
            nextDay: '[Sibê di saet] LT [de]',
            nextWeek: 'dddd [di saet] LT [de]',
            lastDay: '[Duh di saet] LT [de]',
            lastWeek: 'dddd[a borî di saet] LT [de]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'di %s de',
            past: 'berî %s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(?:yê|ê|\.)/,
        ordinal: function (num, period) {
            var p = period.toLowerCase();
            if (p.includes('w') || p.includes('m')) return num + '.';

            return num + ezafeNumSuffix(num);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return kuKmr;

})));


/***/ }),

/***/ 6184:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'file-download';
var width = 384;
var height = 512;
var ligatures = [];
var unicode = 'f56d';
var svgPathData = 'M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm76.45 211.36l-96.42 95.7c-6.65 6.61-17.39 6.61-24.04 0l-96.42-95.7C73.42 337.29 80.54 320 94.82 320H160v-80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v80h65.18c14.28 0 21.4 17.29 11.27 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.mH = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 6195:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enGb = moment.defineLocale('en-gb', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enGb;

})));


/***/ }),

/***/ 6308:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var hr = moment.defineLocale('hr', {
        months: {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
                '_'
            ),
            standalone:
                'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
                    '_'
                ),
        },
        monthsShort:
            'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM YYYY',
            LLL: 'Do MMMM YYYY H:mm',
            LLLL: 'dddd, Do MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prošlu] [nedjelju] [u] LT';
                    case 3:
                        return '[prošlu] [srijedu] [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hr;

})));


/***/ }),

/***/ 6342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_NotificationsView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/NotificationsView.vue?vue&type=template&id=c68c087e
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('NotificationsList')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: ./src/components/NotificationsList/NotificationsList.vue + 4 modules
var NotificationsList = __webpack_require__(5713);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/NotificationsView.vue?vue&type=script&lang=ts



var NotificationsView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(NotificationsView, _super);
    function NotificationsView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NotificationsView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                NotificationsList: NotificationsList/* default */.A
            }
        })
    ], NotificationsView);
    return NotificationsView;
}(lib/* Vue */.lD));
/* harmony default export */ var NotificationsViewvue_type_script_lang_ts = (NotificationsView);

;// ./src/views/NotificationsView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_NotificationsViewvue_type_script_lang_ts = (NotificationsViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/NotificationsView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_NotificationsViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_NotificationsView = (component.exports);

/***/ }),

/***/ 6435:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCa = moment.defineLocale('fr-ca', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
    });

    return frCa;

})));


/***/ }),

/***/ 6449:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 6464:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = {
            standalone:
                'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
                    '_'
                ),
            format: 'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split(
                '_'
            ),
            isFormat: /DD?[o.]?(\[[^\[\]]*\]|\s)+MMMM/,
        },
        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
        monthsParse = [
            /^led/i,
            /^úno/i,
            /^bře/i,
            /^dub/i,
            /^kvě/i,
            /^(čvn|červen$|června)/i,
            /^(čvc|červenec|července)/i,
            /^srp/i,
            /^zář/i,
            /^říj/i,
            /^lis/i,
            /^pro/i,
        ],
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsRegex =
            /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;

    function plural(n) {
        return n > 1 && n < 5 && ~~(n / 10) !== 1;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekund');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'den' : 'dnem';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokem';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
        }
    }

    var cs = moment.defineLocale('cs', {
        months: months,
        monthsShort: monthsShort,
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsStrictRegex:
            /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
        monthsShortStrictRegex:
            /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
            l: 'D. M. YYYY',
        },
        calendar: {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'před %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cs;

})));


/***/ }),

/***/ 6545:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(6110),
    root = __webpack_require__(9325);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 6547:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(3360),
    eq = __webpack_require__(5288);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ 6571:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_AppVersionsView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/AppVersionsView.vue?vue&type=template&id=46aeb532
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-card',[_c('AppVersions')],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: ./src/components/AppVersions/AppVersions.vue + 3 modules
var AppVersions = __webpack_require__(7641);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/AppVersionsView.vue?vue&type=script&lang=ts




var AppVersionsView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(AppVersionsView, _super);
    function AppVersionsView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AppVersionsView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BCard: external_bootstrap_vue_.BCard,
                AppVersions: AppVersions/* default */.A
            }
        })
    ], AppVersionsView);
    return AppVersionsView;
}(lib/* Vue */.lD));
/* harmony default export */ var AppVersionsViewvue_type_script_lang_ts = (AppVersionsView);

;// ./src/views/AppVersionsView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_AppVersionsViewvue_type_script_lang_ts = (AppVersionsViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/AppVersionsView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_AppVersionsViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_AppVersionsView = (component.exports);

/***/ }),

/***/ 6575:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (United States) [es-us]
//! author : bustta : https://github.com/bustta
//! author : chrisrodz : https://github.com/chrisrodz

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esUs = moment.defineLocale('es-us', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'MM/DD/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return esUs;

})));


/***/ }),

/***/ 6584:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIe = moment.defineLocale('en-ie', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enIe;

})));


/***/ }),

/***/ 6598:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'plus-circle';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f055';
var svgPathData = 'M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.OQ = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 6599:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   u1: function() { return /* binding */ createDecorator; },
/* harmony export */   vE: function() { return /* binding */ mixins; }
/* harmony export */ });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(622);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/**
  * vue-class-component v7.2.6
  * (c) 2015-present Evan You
  * @license MIT
  */


function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

// The rational behind the verbose Reflect-feature check below is the fact that there are polyfills
// which add an implementation for Reflect.defineMetadata but not for Reflect.getOwnMetadataKeys.
// Without this check consumers will encounter hard to track down runtime errors.
function reflectionIsSupported() {
  return typeof Reflect !== 'undefined' && Reflect.defineMetadata && Reflect.getOwnMetadataKeys;
}
function copyReflectionMetadata(to, from) {
  forwardMetadata(to, from);
  Object.getOwnPropertyNames(from.prototype).forEach(function (key) {
    forwardMetadata(to.prototype, from.prototype, key);
  });
  Object.getOwnPropertyNames(from).forEach(function (key) {
    forwardMetadata(to, from, key);
  });
}

function forwardMetadata(to, from, propertyKey) {
  var metaKeys = propertyKey ? Reflect.getOwnMetadataKeys(from, propertyKey) : Reflect.getOwnMetadataKeys(from);
  metaKeys.forEach(function (metaKey) {
    var metadata = propertyKey ? Reflect.getOwnMetadata(metaKey, from, propertyKey) : Reflect.getOwnMetadata(metaKey, from);

    if (propertyKey) {
      Reflect.defineMetadata(metaKey, metadata, to, propertyKey);
    } else {
      Reflect.defineMetadata(metaKey, metadata, to);
    }
  });
}

var fakeArray = {
  __proto__: []
};
var hasProto = fakeArray instanceof Array;
function createDecorator(factory) {
  return function (target, key, index) {
    var Ctor = typeof target === 'function' ? target : target.constructor;

    if (!Ctor.__decorators__) {
      Ctor.__decorators__ = [];
    }

    if (typeof index !== 'number') {
      index = undefined;
    }

    Ctor.__decorators__.push(function (options) {
      return factory(options, key, index);
    });
  };
}
function mixins() {
  for (var _len = arguments.length, Ctors = new Array(_len), _key = 0; _key < _len; _key++) {
    Ctors[_key] = arguments[_key];
  }

  return vue__WEBPACK_IMPORTED_MODULE_0___default().extend({
    mixins: Ctors
  });
}
function isPrimitive(value) {
  var type = _typeof(value);

  return value == null || type !== 'object' && type !== 'function';
}
function warn(message) {
  if (typeof console !== 'undefined') {
    console.warn('[vue-class-component] ' + message);
  }
}

function collectDataFromConstructor(vm, Component) {
  // override _init to prevent to init as Vue instance
  var originalInit = Component.prototype._init;

  Component.prototype._init = function () {
    var _this = this;

    // proxy to actual vm
    var keys = Object.getOwnPropertyNames(vm); // 2.2.0 compat (props are no longer exposed as self properties)

    if (vm.$options.props) {
      for (var key in vm.$options.props) {
        if (!vm.hasOwnProperty(key)) {
          keys.push(key);
        }
      }
    }

    keys.forEach(function (key) {
      Object.defineProperty(_this, key, {
        get: function get() {
          return vm[key];
        },
        set: function set(value) {
          vm[key] = value;
        },
        configurable: true
      });
    });
  }; // should be acquired class property values


  var data = new Component(); // restore original _init to avoid memory leak (#209)

  Component.prototype._init = originalInit; // create plain data object

  var plainData = {};
  Object.keys(data).forEach(function (key) {
    if (data[key] !== undefined) {
      plainData[key] = data[key];
    }
  });

  if (false) {}

  return plainData;
}

var $internalHooks = ['data', 'beforeCreate', 'created', 'beforeMount', 'mounted', 'beforeDestroy', 'destroyed', 'beforeUpdate', 'updated', 'activated', 'deactivated', 'render', 'errorCaptured', 'serverPrefetch' // 2.6
];
function componentFactory(Component) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  options.name = options.name || Component._componentTag || Component.name; // prototype props.

  var proto = Component.prototype;
  Object.getOwnPropertyNames(proto).forEach(function (key) {
    if (key === 'constructor') {
      return;
    } // hooks


    if ($internalHooks.indexOf(key) > -1) {
      options[key] = proto[key];
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(proto, key);

    if (descriptor.value !== void 0) {
      // methods
      if (typeof descriptor.value === 'function') {
        (options.methods || (options.methods = {}))[key] = descriptor.value;
      } else {
        // typescript decorated data
        (options.mixins || (options.mixins = [])).push({
          data: function data() {
            return _defineProperty({}, key, descriptor.value);
          }
        });
      }
    } else if (descriptor.get || descriptor.set) {
      // computed properties
      (options.computed || (options.computed = {}))[key] = {
        get: descriptor.get,
        set: descriptor.set
      };
    }
  });
  (options.mixins || (options.mixins = [])).push({
    data: function data() {
      return collectDataFromConstructor(this, Component);
    }
  }); // decorate options

  var decorators = Component.__decorators__;

  if (decorators) {
    decorators.forEach(function (fn) {
      return fn(options);
    });
    delete Component.__decorators__;
  } // find super


  var superProto = Object.getPrototypeOf(Component.prototype);
  var Super = superProto instanceof (vue__WEBPACK_IMPORTED_MODULE_0___default()) ? superProto.constructor : (vue__WEBPACK_IMPORTED_MODULE_0___default());
  var Extended = Super.extend(options);
  forwardStaticMembers(Extended, Component, Super);

  if (reflectionIsSupported()) {
    copyReflectionMetadata(Extended, Component);
  }

  return Extended;
}
var reservedPropertyNames = (/* unused pure expression or super */ null && ([// Unique id
'cid', // Super Vue constructor
'super', // Component options that will be used by the component
'options', 'superOptions', 'extendOptions', 'sealedOptions', // Private assets
'component', 'directive', 'filter']));
var shouldIgnore = {
  prototype: true,
  arguments: true,
  callee: true,
  caller: true
};

function forwardStaticMembers(Extended, Original, Super) {
  // We have to use getOwnPropertyNames since Babel registers methods as non-enumerable
  Object.getOwnPropertyNames(Original).forEach(function (key) {
    // Skip the properties that should not be overwritten
    if (shouldIgnore[key]) {
      return;
    } // Some browsers does not allow reconfigure built-in properties


    var extendedDescriptor = Object.getOwnPropertyDescriptor(Extended, key);

    if (extendedDescriptor && !extendedDescriptor.configurable) {
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(Original, key); // If the user agent does not support `__proto__` or its family (IE <= 10),
    // the sub class properties may be inherited properties from the super class in TypeScript.
    // We need to exclude such properties to prevent to overwrite
    // the component options object which stored on the extended constructor (See #192).
    // If the value is a referenced value (object or function),
    // we can check equality of them and exclude it if they have the same reference.
    // If it is a primitive value, it will be forwarded for safety.

    if (!hasProto) {
      // Only `cid` is explicitly exluded from property forwarding
      // because we cannot detect whether it is a inherited property or not
      // on the no `__proto__` environment even though the property is reserved.
      if (key === 'cid') {
        return;
      }

      var superDescriptor = Object.getOwnPropertyDescriptor(Super, key);

      if (!isPrimitive(descriptor.value) && superDescriptor && superDescriptor.value === descriptor.value) {
        return;
      }
    } // Warn if the users manually declare reserved properties


    if (false) {}

    Object.defineProperty(Extended, key, descriptor);
  });
}

function Component(options) {
  if (typeof options === 'function') {
    return componentFactory(options);
  }

  return function (Component) {
    return componentFactory(Component, options);
  };
}

Component.registerHooks = function registerHooks(keys) {
  $internalHooks.push.apply($internalHooks, _toConsumableArray(keys));
};

/* harmony default export */ __webpack_exports__.Ay = (Component);



/***/ }),

/***/ 6614:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'download';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f019';
var svgPathData = 'M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.cb = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 6618:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
              ? forms[1]
              : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            dd: 'день_дні_днів',
            MM: 'місяць_місяці_місяців',
            yy: 'рік_роки_років',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        } else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
                nominative:
                    'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
                        '_'
                    ),
                accusative:
                    'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
                        '_'
                    ),
                genitive:
                    'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
                        '_'
                    ),
            },
            nounCase;

        if (m === true) {
            return weekdays['nominative']
                .slice(1, 7)
                .concat(weekdays['nominative'].slice(0, 1));
        }
        if (!m) {
            return weekdays['nominative'];
        }

        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
            ? 'accusative'
            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
              ? 'genitive'
              : 'nominative';
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    var uk = moment.defineLocale('uk', {
        months: {
            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
                '_'
            ),
            standalone:
                'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
                    '_'
                ),
        },
        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
            '_'
        ),
        weekdays: weekdaysCaseReplace,
        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY р.',
            LLL: 'D MMMM YYYY р., HH:mm',
            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
        },
        calendar: {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: '%s тому',
            s: 'декілька секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'годину',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            M: 'місяць',
            MM: relativeTimeWithPlural,
            y: 'рік',
            yy: relativeTimeWithPlural,
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function (input) {
            return /^(дня|вечора)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return uk;

})));


/***/ }),

/***/ 6637:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nekaj sekund'
                    : 'nekaj sekundami';
            case 'ss':
                if (number === 1) {
                    result += withoutSuffix ? 'sekundo' : 'sekundi';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
                } else {
                    result += 'sekund';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    var sl = moment.defineLocale('sl', {
        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD. MM. YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danes ob] LT',
            nextDay: '[jutri ob] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay: '[včeraj ob] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'čez %s',
            past: 'pred %s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sl;

})));


/***/ }),

/***/ 6645:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var asciiWords = __webpack_require__(1733),
    hasUnicodeWord = __webpack_require__(5434),
    toString = __webpack_require__(3222),
    unicodeWords = __webpack_require__(2225);

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = words;


/***/ }),

/***/ 6649:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createBaseFor = __webpack_require__(3221);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ 6697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_CivilitiesView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/CivilitiesView.vue?vue&type=template&id=e4b9eed4
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Civilities')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: ./src/components/Civilities/Civilities.vue + 3 modules
var Civilities = __webpack_require__(8458);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/CivilitiesView.vue?vue&type=script&lang=ts



var CivilitiesView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CivilitiesView, _super);
    function CivilitiesView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CivilitiesView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Civilities: Civilities/* default */.A
            }
        })
    ], CivilitiesView);
    return CivilitiesView;
}(lib/* Vue */.lD));
/* harmony default export */ var CivilitiesViewvue_type_script_lang_ts = (CivilitiesView);

;// ./src/views/CivilitiesView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_CivilitiesViewvue_type_script_lang_ts = (CivilitiesViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/CivilitiesView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_CivilitiesViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_CivilitiesView = (component.exports);

/***/ }),

/***/ 6721:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(1042);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 6757:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var apply = __webpack_require__(1033);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ 6777:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'chevron-right';
var width = 320;
var height = 512;
var ligatures = [];
var unicode = 'f054';
var svgPathData = 'M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.Xk = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 6794:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sq = moment.defineLocale('sq', {
        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
            '_'
        ),
        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
            '_'
        ),
        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /PD|MD/,
        isPM: function (input) {
            return input.charAt(0) === 'M';
        },
        meridiem: function (hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Sot në] LT',
            nextDay: '[Nesër në] LT',
            nextWeek: 'dddd [në] LT',
            lastDay: '[Dje në] LT',
            lastWeek: 'dddd [e kaluar në] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'në %s',
            past: '%s më parë',
            s: 'disa sekonda',
            ss: '%d sekonda',
            m: 'një minutë',
            mm: '%d minuta',
            h: 'një orë',
            hh: '%d orë',
            d: 'një ditë',
            dd: '%d ditë',
            M: 'një muaj',
            MM: '%d muaj',
            y: 'një vit',
            yy: '%d vite',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sq;

})));


/***/ }),

/***/ 6800:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(5288),
    isArrayLike = __webpack_require__(4894),
    isIndex = __webpack_require__(361),
    isObject = __webpack_require__(3805);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ 6870:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '១',
            2: '២',
            3: '៣',
            4: '៤',
            5: '៥',
            6: '៦',
            7: '៧',
            8: '៨',
            9: '៩',
            0: '០',
        },
        numberMap = {
            '១': '1',
            '២': '2',
            '៣': '3',
            '៤': '4',
            '៥': '5',
            '៦': '6',
            '៧': '7',
            '៨': '8',
            '៩': '9',
            '០': '0',
        };

    var km = moment.defineLocale('km', {
        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        monthsShort:
            'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
                '_'
            ),
        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ព្រឹក|ល្ងាច/,
        isPM: function (input) {
            return input === 'ល្ងាច';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ព្រឹក';
            } else {
                return 'ល្ងាច';
            }
        },
        calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            ss: '%d វិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ',
        },
        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
        ordinal: 'ទី%d',
        preparse: function (string) {
            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return km;

})));


/***/ }),

/***/ 6890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ PaymentTermForm_PaymentTermForm; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/PaymentTermForm/PaymentTermForm.vue?vue&type=template&id=4c8e967e
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form',{attrs:{"action":_vm.formUrl,"method":_vm.localTerm.id ? 'PUT' : 'POST'},on:{"submitComplete":_vm.formSubmitted}},[_c('b-form-group',{attrs:{"label":_vm.$t('interface.paymentTerm.label')}},[_c('k-form-input',{attrs:{"name":"label","required":""},model:{value:(_vm.localTerm.label),callback:function ($$v) {_vm.$set(_vm.localTerm, "label", $$v)},expression:"localTerm.label"}})],1),_c('k-form-checkbox',{staticClass:"mb-3",model:{value:(_vm.localTerm.with_deadlines),callback:function ($$v) {_vm.$set(_vm.localTerm, "with_deadlines", $$v)},expression:"localTerm.with_deadlines"}},[_vm._v(" Cette condition de paiement comporte des échéances ")]),_c('input',{attrs:{"type":"hidden","name":"with_deadlines"},domProps:{"value":_vm.localTerm.with_deadlines ?? false}}),(_vm.localTerm.with_deadlines)?[_c('p',{staticClass:"font-weight-bold mb-0"},[_vm._v(" Liste des échéances ")]),_c('table',{staticClass:"table table-sm table-bordered mb-1 align-middle"},[_c('thead',{staticClass:"small"},[_c('tr',[_c('th',{staticStyle:{"width":"100px"}},[_vm._v("Pourcentage")]),_c('th',[_vm._v("Délai")]),(_vm.localTerm.deadlines.length > 2)?_c('th'):_vm._e()])]),_c('tbody',_vm._l((_vm.localTerm.deadlines),function(deadline,i){return _c('tr',{key:i},[_c('td',[_c('b-input-group',{attrs:{"size":"sm","append":"%"}},[_c('k-form-number',{attrs:{"size":"sm","name":'deadlines[' + i + '][pourcent]',"min":0},on:{"change":function($event){return _vm.pourcentUpdated(i)}},model:{value:(_vm.localTerm.deadlines[i].pourcent),callback:function ($$v) {_vm.$set(_vm.localTerm.deadlines[i], "pourcent", $$v)},expression:"localTerm.deadlines[i].pourcent"}})],1)],1),_c('td',[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-input-group',{staticStyle:{"width":"120px"},attrs:{"size":"sm"},scopedSlots:_vm._u([{key:"append",fn:function(){return [_c('k-form-select',{attrs:{"size":"sm","name":'deadlines[' + i + '][delay_type]',"options":_vm.delayTypes,"reduce":opt => opt.value,"clearable":false},model:{value:(_vm.localTerm.deadlines[i].delay_type),callback:function ($$v) {_vm.$set(_vm.localTerm.deadlines[i], "delay_type", $$v)},expression:"localTerm.deadlines[i].delay_type"}})]},proxy:true}],null,true)},[_c('k-form-number',{attrs:{"size":"sm","name":'deadlines[' + i + '][delay]',"min":i === 0 ? 0 : 1,"maxDecimal":0},model:{value:(_vm.localTerm.deadlines[i].delay),callback:function ($$v) {_vm.$set(_vm.localTerm.deadlines[i], "delay", $$v)},expression:"localTerm.deadlines[i].delay"}})],1)],1),_c('b-col',{staticClass:"small text-nowrap pl-0"},[(i === 0)?[_vm._v(" après date de facture ")]:[_vm._v(" après dernière échéance ")]],2)],1)],1),(_vm.localTerm.deadlines.length > 2)?_c('td',[_c('b-button',{staticClass:"p-0 text-danger",attrs:{"size":"sm","variant":"icon"},on:{"click":function($event){$event.preventDefault();return _vm.deleteDeadline(i)}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'times']}})],1)],1):_vm._e()])}),0)]),_c('p',[_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.addDeadline.apply(null, arguments)}}},[_vm._v(" Ajouter une échéance ")])],1),_c('b-alert',{staticClass:"small",attrs:{"variant":"warning","show":""}},[_vm._v(" Le réglage ci-dessus permet de générer automatiquement les échéances d'une facture. Cependant, il reste possible de personnaliser les échéances sur une facture directement. ")])]:[_c('b-form-group',{attrs:{"label":_vm.$t('interface.paymentTerm.nbDays')}},[_c('k-form-spinner',{attrs:{"name":"day_number","required":"","min":0},model:{value:(_vm.localTerm.day_number),callback:function ($$v) {_vm.$set(_vm.localTerm, "day_number", $$v)},expression:"localTerm.day_number"}})],1),_c('input',{attrs:{"type":"hidden","name":"end_month"},domProps:{"value":_vm.endMonth || _vm.endMonthDay}}),_c('input',{attrs:{"type":"hidden","name":"end_month_day"},domProps:{"value":_vm.endMonthDay ? _vm.localTerm.end_month_day : null}}),_c('k-form-checkbox',{on:{"input":_vm.checkEndMonth},model:{value:(_vm.endMonth),callback:function ($$v) {_vm.endMonth=$$v},expression:"endMonth"}},[_vm._v(" "+_vm._s(_vm.$t('interface.paymentTerm.endMonth'))+" ")]),_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"cols":"auto"}},[_c('k-form-checkbox',{on:{"input":_vm.checkEndMonthDay},model:{value:(_vm.endMonthDay),callback:function ($$v) {_vm.endMonthDay=$$v},expression:"endMonthDay"}},[_vm._v(" "+_vm._s(_vm.$t('interface.paymentTerm.endMonthDay'))+" ")])],1),_c('b-col',[_c('k-form-number',{staticStyle:{"width":"60px"},attrs:{"min":1,"max":31,"noDefaultValue":"","required":_vm.endMonthDay,"disabled":!_vm.endMonthDay},model:{value:(_vm.localTerm.end_month_day),callback:function ($$v) {_vm.$set(_vm.localTerm, "end_month_day", $$v)},expression:"localTerm.end_month_day"}})],1)],1)]],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: ./node_modules/lodash/sumBy.js
var sumBy = __webpack_require__(1126);
var sumBy_default = /*#__PURE__*/__webpack_require__.n(sumBy);
// EXTERNAL MODULE: ./src/mixins/NumberMixin.ts
var NumberMixin = __webpack_require__(1781);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(9356);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/PaymentTermForm/PaymentTermForm.ts?vue&type=script&lang=ts&external







var PaymentTermForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PaymentTermForm, _super);
    function PaymentTermForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.localTerm = {
            deadlines: []
        };
        _this.endMonth = false;
        _this.endMonthDay = false;
        return _this;
    }
    PaymentTermForm.prototype.watchValue = function (term) {
        this.setLocalTerm(term);
    };
    Object.defineProperty(PaymentTermForm.prototype, "formUrl", {
        get: function () {
            var url = '/payment_term';
            if (this.localTerm.id) {
                url += '/' + this.localTerm.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentTermForm.prototype, "delayTypes", {
        get: function () {
            return [
                { value: 'day', label: this.$t('interface.day') },
                { value: 'month', label: this.$t('interface.month') },
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentTermForm.prototype, "maxPourcent", {
        get: function () {
            var _this = this;
            return function (index) {
                return 100 - sumBy_default()(_this.localTerm.deadlines.filter(function (deadline, i) { return i !== index; }), function (deadline) { return _this.number(deadline.pourcent); });
            };
        },
        enumerable: false,
        configurable: true
    });
    PaymentTermForm.prototype.setLocalTerm = function (term) {
        var localTerm = term ? JSON.parse(JSON.stringify(term)) : {};
        if (localTerm.end_month_day === 0) {
            localTerm.end_month_day = null;
        }
        if (localTerm && localTerm.end_month) {
            if (localTerm.end_month_day) {
                this.endMonthDay = true;
            }
            else {
                this.endMonth = true;
            }
        }
        if (!localTerm.deadlines) {
            localTerm.deadlines = [
                { pourcent: 50, delay: 0, delay_type: 'month' },
                { pourcent: 50, delay: 1, delay_type: 'month' }
            ];
        }
        this.localTerm = localTerm;
    };
    PaymentTermForm.prototype.formSubmitted = function (response) {
        return response;
    };
    PaymentTermForm.prototype.checkEndMonth = function () {
        if (this.endMonth) {
            this.endMonthDay = false;
        }
    };
    PaymentTermForm.prototype.checkEndMonthDay = function () {
        if (this.endMonthDay) {
            this.endMonth = false;
        }
    };
    PaymentTermForm.prototype.addDeadline = function () {
        var _this = this;
        var _a;
        var pourcent = 100 - sumBy_default()(this.localTerm.deadlines, function (deadline) { return _this.number(deadline.pourcent); });
        if (pourcent <= 0) {
            pourcent = Math.floor(100 / (((_a = this.localTerm.deadlines.length) !== null && _a !== void 0 ? _a : 0) + 1));
            var check_1 = 100;
            this.localTerm.deadlines.forEach(function (deadline) {
                deadline.pourcent = pourcent;
                check_1 -= _this.number(pourcent);
            });
            pourcent = check_1;
        }
        this.localTerm.deadlines.push({
            pourcent: pourcent,
            delay: 1,
            delay_type: 'month'
        });
    };
    PaymentTermForm.prototype.deleteDeadline = function (index) {
        var pourcent = this.localTerm.deadlines[index].pourcent;
        lib/* Vue */.lD.delete(this.localTerm.deadlines, index);
        this.localTerm.deadlines[this.localTerm.deadlines.length - 1].pourcent += pourcent;
    };
    PaymentTermForm.prototype.pourcentUpdated = function (index) {
        var _this = this;
        var deadlines = this.localTerm.deadlines;
        var isLast = (deadlines.length - 1) === index;
        var nbDeadlines;
        var usedPourcent;
        if (isLast) { // Last deadline
            usedPourcent = this.number(deadlines[index].pourcent);
            nbDeadlines = deadlines.length - 1;
        }
        else {
            usedPourcent = sumBy_default()(deadlines.filter(function (deadline, i) { return i <= index; }), function (deadline) { return _this.number(deadline.pourcent); });
            nbDeadlines = deadlines.length - (index + 1);
        }
        var checkPourcent = 100 - usedPourcent;
        var pourcent = this.roundNumber(checkPourcent / nbDeadlines, 2);
        var updatedIndex = [];
        deadlines.forEach(function (deadline, i) {
            if ((isLast && i < index) || (!isLast && i > index)) {
                deadline.pourcent = pourcent;
                updatedIndex.push(i);
                checkPourcent -= pourcent;
            }
        });
        if (checkPourcent !== 0) {
            var deadline = deadlines[updatedIndex[updatedIndex.length - 1]];
            deadline.pourcent += checkPourcent;
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], PaymentTermForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], PaymentTermForm.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('submitComplete')
    ], PaymentTermForm.prototype, "formSubmitted", null);
    PaymentTermForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormSpinner: form_vue_.KFormSpinner, KFormCheckbox: form_vue_.KFormCheckbox, KFormNumber: form_vue_.KFormNumber, KFormSelect: form_vue_.KFormSelect,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BInputGroup: external_bootstrap_vue_.BInputGroup, BButton: external_bootstrap_vue_.BButton, BAlert: external_bootstrap_vue_.BAlert,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            }
        })
    ], PaymentTermForm);
    return PaymentTermForm;
}((0,lib/* Mixins */.Xe)(NumberMixin/* default */.A)));
/* harmony default export */ var PaymentTermFormvue_type_script_lang_ts_external = (PaymentTermForm);

;// ./src/components/PaymentTermForm/PaymentTermForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var PaymentTermForm_PaymentTermFormvue_type_script_lang_ts_external = (PaymentTermFormvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/PaymentTermForm/PaymentTermForm.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  PaymentTermForm_PaymentTermFormvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PaymentTermForm_PaymentTermForm = (component.exports);

/***/ }),

/***/ 6912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ mitt; }
});

;// external "mitt"
var external_mitt_namespaceObject = require("mitt");
var external_mitt_default = /*#__PURE__*/__webpack_require__.n(external_mitt_namespaceObject);
// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(622);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
;// ./src/mitt.ts


var emitter = external_mitt_default()();
emitter.on('*', function (type, data) {
    var broadcast = (external_vue_default()).prototype.$localBroadcast;
    if (!broadcast || (data && data.dontPropagate)) {
        return;
    }
    broadcast.emitter(type, data);
});
/* harmony default export */ var mitt = (emitter);


/***/ }),

/***/ 6947:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Palestine) [ar-ps]
//! author : Majd Al-Shihabi : https://github.com/majdal

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        };

    var arPs = moment.defineLocale('ar-ps', {
        months: 'كانون الثاني_شباط_آذار_نيسان_أيّار_حزيران_تمّوز_آب_أيلول_تشري الأوّل_تشرين الثاني_كانون الأوّل'.split(
            '_'
        ),
        monthsShort:
            'ك٢_شباط_آذار_نيسان_أيّار_حزيران_تمّوز_آب_أيلول_ت١_ت٢_ك١'.split('_'),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        preparse: function (string) {
            return string
                .replace(/[٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .split('') // reversed since negative lookbehind not supported everywhere
                .reverse()
                .join('')
                .replace(/[١٢](?![\u062a\u0643])/g, function (match) {
                    return numberMap[match];
                })
                .split('')
                .reverse()
                .join('')
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return arPs;

})));


/***/ }),

/***/ 7005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ Tags_Tags; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Tags/Tags.vue?vue&type=template&id=c3b91110
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DynamicList',{attrs:{"url":_vm.apiUrl,"columns":_vm.columns,"createTitle":_vm.$t('interface.tag.new'),"updateTitle":_vm.$t('interface.tag.edit'),"deleteMsg":_vm.$t('interface.tag.deleteMsg'),"sort":"name"},on:{"submitted":_vm.setTag,"deleted":_vm.deleteTag}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: ./src/components/DynamicList/DynamicList.vue + 4 modules
var DynamicList = __webpack_require__(3425);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Tags/Tags.ts?vue&type=script&lang=ts&external




var Tags = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(Tags, _super);
    function Tags() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.columns = [
            {
                label: _this.$t('interface.tag.label'),
                key: 'name',
                required: true
            }
        ];
        return _this;
    }
    Object.defineProperty(Tags.prototype, "apiUrl", {
        get: function () {
            return '/tag';
        },
        enumerable: false,
        configurable: true
    });
    Tags = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['setTag', 'deleteTag'])),
            components: {
                DynamicList: DynamicList/* default */.A
            }
        })
    ], Tags);
    return Tags;
}(lib/* Vue */.lD));
/* harmony default export */ var Tagsvue_type_script_lang_ts_external = (Tags);

;// ./src/components/Tags/Tags.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var Tags_Tagsvue_type_script_lang_ts_external = (Tagsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/Tags/Tags.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  Tags_Tagsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Tags_Tags = (component.exports);

/***/ }),

/***/ 7033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ Login_Login; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Login/Login.vue?vue&type=template&id=1ad6aab1
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-card',{staticClass:"login-form",attrs:{"title":_vm.showTitle ? _vm.$t('interface.auth.title') : null}},[_c('k-form',{ref:"form",attrs:{"action":"/auth/login?with_file=1","method":"post","value":_vm.formDatas,"beforeSubmit":_vm.beforeSubmit,"dontAskLogin":""},on:{"submitComplete":_vm.submitComplete,"submitError":_vm.submitError}},[_c('b-form-group',{attrs:{"label":_vm.$t('interface.auth.email')}},[_c('k-form-input',{attrs:{"type":"email","name":"email","required":"","readonly":_vm.readonlyEmail},model:{value:(_vm.localEmail),callback:function ($$v) {_vm.localEmail=$$v},expression:"localEmail"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('interface.auth.password')}},[_c('k-form-input',{attrs:{"type":"password","name":"password","required":"","automaticRules":false},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_c('k-form-checkbox',{staticClass:"mb-2",attrs:{"name":"remember_me","size":"sm"},model:{value:(_vm.rememberMe),callback:function ($$v) {_vm.rememberMe=$$v},expression:"rememberMe"}},[_vm._v(" "+_vm._s(_vm.$t('interface.auth.rememberMe'))+" ")]),_c('b-alert',{staticClass:"text-center",attrs:{"show":_vm.errorMsg !== null && !_vm.alreadyLogged,"variant":"danger"}},[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]),_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_vm._v(" "+_vm._s(_vm.$t('interface.auth.connect'))+" ")]),(_vm.canResetPassword || _vm.canCreateAccount)?_c('div',{staticClass:"small mt-3"},[(_vm.canResetPassword)?_c('router-link',{attrs:{"to":{ name: 'forgot-password' }}},[_vm._v(" "+_vm._s(_vm.$t('interface.auth.forgotPassword'))+" ")]):_vm._e(),(_vm.canResetPassword && _vm.canCreateAccount)?[_c('br')]:_vm._e(),(_vm.canCreateAccount)?_c('router-link',{attrs:{"to":{ name: 'register' }}},[_vm._v(" "+_vm._s(_vm.$t('interface.auth.createAccount'))+" ")]):_vm._e()],2):_vm._e()],1)],1),_c('b-modal',{attrs:{"ok-title":_vm.$t('interface.continue'),"cancel-title":_vm.$t('interface.cancel'),"modal-class":"text-justify"},on:{"cancel":_vm.cancelDisconnect,"ok":_vm.goForceLogin},model:{value:(_vm.alreadyLogged),callback:function ($$v) {_vm.alreadyLogged=$$v},expression:"alreadyLogged"}},[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")])],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Login/Login.ts?vue&type=script&lang=ts&external





var Login = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(Login, _super);
    function Login() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.errorMsg = null;
        _this.alreadyLogged = false;
        _this.localEmail = null;
        _this.password = null;
        _this.rememberMe = false;
        _this.forceLogin = false;
        return _this;
    }
    Login.prototype.beforeSubmit = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.errorMsg = null;
                        if (!this.$kwInterface.withCsrf) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.$kwInterface.axios.get('/csrf-cookie')];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(Login.prototype, "formDatas", {
        get: function () {
            var datas = {
                email: this.localEmail,
                password: this.password,
                remember_me: this.rememberMe
            };
            if (this.forceLogin) {
                datas.force = true;
            }
            return datas;
        },
        enumerable: false,
        configurable: true
    });
    Login.prototype.watchEmail = function (email) {
        this.localEmail = email;
    };
    Login.prototype.submitComplete = function (response) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var data;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = response.data;
                        this.setToken(data.token);
                        this.setUser(data.user);
                        if (!this.redirectAfterLogin) return [3 /*break*/, 4];
                        this.setRedirectTo(null);
                        if (!this.redirectTo) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.$router.push(this.redirectTo)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        if (!this.$kwInterface.goToHome) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.$kwInterface.goToHome(this.$router, this.$store)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        this.$emit('logged');
                        return [2 /*return*/];
                }
            });
        });
    };
    Login.prototype.submitError = function (error) {
        var _a, _b, _c;
        this.errorMsg = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data.message) !== null && _b !== void 0 ? _b : null;
        if (((_c = error.response) === null || _c === void 0 ? void 0 : _c.status) === 449) {
            this.alreadyLogged = true;
        }
    };
    Login.prototype.cancelDisconnect = function (event) {
        event.preventDefault();
        this.forceLogin = false;
        this.closeModal();
    };
    Login.prototype.goForceLogin = function (event) {
        event.preventDefault();
        this.forceLogin = true;
        this.closeModal();
        var form = this.$refs.form;
        form.submit();
    };
    Login.prototype.closeModal = function () {
        this.errorMsg = null;
        this.alreadyLogged = false;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: true })
    ], Login.prototype, "redirectAfterLogin", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], Login.prototype, "email", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], Login.prototype, "readonlyEmail", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], Login.prototype, "canCreateAccount", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: true })
    ], Login.prototype, "canResetPassword", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: true })
    ], Login.prototype, "showTitle", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('email', { immediate: true })
    ], Login.prototype, "watchEmail", null);
    Login = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('auth', ['setToken', 'setRedirectTo'])), (0,external_vuex_.mapActions)('user', ['setUser'])),
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('auth', ['redirectTo'])),
            components: {
                BCard: external_bootstrap_vue_.BCard, BFormGroup: external_bootstrap_vue_.BFormGroup, BButton: external_bootstrap_vue_.BButton, BAlert: external_bootstrap_vue_.BAlert, BModal: external_bootstrap_vue_.BModal,
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormCheckbox: form_vue_.KFormCheckbox
            }
        })
    ], Login);
    return Login;
}(lib/* Vue */.lD));
/* harmony default export */ var Loginvue_type_script_lang_ts_external = (Login);

;// ./src/components/Login/Login.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var Login_Loginvue_type_script_lang_ts_external = (Loginvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/Login/Login.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  Login_Loginvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Login_Login = (component.exports);

/***/ }),

/***/ 7068:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(7217),
    equalArrays = __webpack_require__(5911),
    equalByTag = __webpack_require__(1986),
    equalObjects = __webpack_require__(689),
    getTag = __webpack_require__(5861),
    isArray = __webpack_require__(6449),
    isBuffer = __webpack_require__(3656),
    isTypedArray = __webpack_require__(7167);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ 7071:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

    var fy = moment.defineLocale('fy', {
        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        monthsParseExact: true,
        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
            '_'
        ),
        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oer %s',
            past: '%s lyn',
            s: 'in pear sekonden',
            ss: '%d sekonden',
            m: 'ien minút',
            mm: '%d minuten',
            h: 'ien oere',
            hh: '%d oeren',
            d: 'ien dei',
            dd: '%d dagen',
            M: 'ien moanne',
            MM: '%d moannen',
            y: 'ien jier',
            yy: '%d jierren',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fy;

})));


/***/ }),

/***/ 7075:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maltese (Malta) [mt]
//! author : Alessandro Maruccia : https://github.com/alesma

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mt = moment.defineLocale('mt', {
        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
        weekdays:
            'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
                '_'
            ),
        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Illum fil-]LT',
            nextDay: '[Għada fil-]LT',
            nextWeek: 'dddd [fil-]LT',
            lastDay: '[Il-bieraħ fil-]LT',
            lastWeek: 'dddd [li għadda] [fil-]LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'f’ %s',
            past: '%s ilu',
            s: 'ftit sekondi',
            ss: '%d sekondi',
            m: 'minuta',
            mm: '%d minuti',
            h: 'siegħa',
            hh: '%d siegħat',
            d: 'ġurnata',
            dd: '%d ġranet',
            M: 'xahar',
            MM: '%d xhur',
            y: 'sena',
            yy: '%d sni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mt;

})));


/***/ }),

/***/ 7088:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ші',
        1: '-ші',
        2: '-ші',
        3: '-ші',
        4: '-ші',
        5: '-ші',
        6: '-шы',
        7: '-ші',
        8: '-ші',
        9: '-шы',
        10: '-шы',
        20: '-шы',
        30: '-шы',
        40: '-шы',
        50: '-ші',
        60: '-шы',
        70: '-ші',
        80: '-ші',
        90: '-шы',
        100: '-ші',
    };

    var kk = moment.defineLocale('kk', {
        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
            '_'
        ),
        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
            '_'
        ),
        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгін сағат] LT',
            nextDay: '[Ертең сағат] LT',
            nextWeek: 'dddd [сағат] LT',
            lastDay: '[Кеше сағат] LT',
            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ішінде',
            past: '%s бұрын',
            s: 'бірнеше секунд',
            ss: '%d секунд',
            m: 'бір минут',
            mm: '%d минут',
            h: 'бір сағат',
            hh: '%d сағат',
            d: 'бір күн',
            dd: '%d күн',
            M: 'бір ай',
            MM: '%d ай',
            y: 'бір жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return kk;

})));


/***/ }),

/***/ 7160:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var hyAm = moment.defineLocale('hy-am', {
        months: {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
                '_'
            ),
            standalone:
                'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
                    '_'
                ),
        },
        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        weekdays:
            'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
                '_'
            ),
        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY թ.',
            LLL: 'D MMMM YYYY թ., HH:mm',
            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
        },
        calendar: {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function () {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function () {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s հետո',
            past: '%s առաջ',
            s: 'մի քանի վայրկյան',
            ss: '%d վայրկյան',
            m: 'րոպե',
            mm: '%d րոպե',
            h: 'ժամ',
            hh: '%d ժամ',
            d: 'օր',
            dd: '%d օր',
            M: 'ամիս',
            MM: '%d ամիս',
            y: 'տարի',
            yy: '%d տարի',
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function (input) {
            return /^(ցերեկվա|երեկոյան)$/.test(input);
        },
        meridiem: function (hour) {
            if (hour < 4) {
                return 'գիշերվա';
            } else if (hour < 12) {
                return 'առավոտվա';
            } else if (hour < 17) {
                return 'ցերեկվա';
            } else {
                return 'երեկոյան';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) {
                        return number + '-ին';
                    }
                    return number + '-րդ';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hyAm;

})));


/***/ }),

/***/ 7167:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(4901),
    baseUnary = __webpack_require__(7301),
    nodeUtil = __webpack_require__(6009);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 7197:
/***/ (function(module) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),

/***/ 7217:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(79),
    stackClear = __webpack_require__(1420),
    stackDelete = __webpack_require__(938),
    stackGet = __webpack_require__(3605),
    stackHas = __webpack_require__(9817),
    stackSet = __webpack_require__(945);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 7237:
/***/ (function(module) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),

/***/ 7241:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(695),
    baseKeysIn = __webpack_require__(2903),
    isArrayLike = __webpack_require__(4894);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),

/***/ 7255:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(7422);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),

/***/ 7296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var coreJsData = __webpack_require__(5481);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 7301:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 7306:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ca = moment.defineLocale('ca', {
        months: {
            standalone:
                'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
                    '_'
                ),
            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort:
            'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
                '_'
            ),
        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a les] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextDay: function () {
                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastDay: function () {
                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [passat a ' +
                    (this.hours() !== 1 ? 'les' : 'la') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'uns segons',
            ss: '%d segons',
            m: 'un minut',
            mm: '%d minuts',
            h: 'una hora',
            hh: '%d hores',
            d: 'un dia',
            dd: '%d dies',
            M: 'un mes',
            MM: '%d mesos',
            y: 'un any',
            yy: '%d anys',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                      ? 'n'
                      : number === 3
                        ? 'r'
                        : number === 4
                          ? 't'
                          : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ca;

})));


/***/ }),

/***/ 7309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_ResetPasswordView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ResetPasswordView.vue?vue&type=template&id=7948c0c3
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ResetPassword',{attrs:{"token":_vm.$route.params.token}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: ./src/components/ResetPassword/ResetPassword.vue + 3 modules
var ResetPassword = __webpack_require__(3048);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ResetPasswordView.vue?vue&type=script&lang=ts



var ResetPasswordView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ResetPasswordView, _super);
    function ResetPasswordView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ResetPasswordView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                ResetPassword: ResetPassword/* default */.A
            }
        })
    ], ResetPasswordView);
    return ResetPasswordView;
}(lib/* Vue */.lD));
/* harmony default export */ var ResetPasswordViewvue_type_script_lang_ts = (ResetPasswordView);

;// ./src/views/ResetPasswordView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_ResetPasswordViewvue_type_script_lang_ts = (ResetPasswordViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/ResetPasswordView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_ResetPasswordViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_ResetPasswordView = (component.exports);

/***/ }),

/***/ 7312:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'eye-slash';
var width = 640;
var height = 512;
var ligatures = [];
var unicode = 'f070';
var svgPathData = 'M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.k6 = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 7329:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var gl = moment.defineLocale('gl', {
        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
            '_'
        ),
        monthsShort:
            'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextDay: function () {
                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
            },
            lastDay: function () {
                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (str) {
                if (str.indexOf('un') === 0) {
                    return 'n' + str;
                }
                return 'en ' + str;
            },
            past: 'hai %s',
            s: 'uns segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'unha hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            M: 'un mes',
            MM: '%d meses',
            y: 'un ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gl;

})));


/***/ }),

/***/ 7334:
/***/ (function(module) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ 7352:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'check';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f00c';
var svgPathData = 'M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.e6 = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 7357:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali (Bangladesh) [bn-bd]
//! author : Asraf Hossain Patoary : https://github.com/ashwoolford

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    var bnBd = moment.defineLocale('bn-bd', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort:
            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
                '_'
            ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },

        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'রাত') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ভোর') {
                return hour;
            } else if (meridiem === 'সকাল') {
                return hour;
            } else if (meridiem === 'দুপুর') {
                return hour >= 3 ? hour : hour + 12;
            } else if (meridiem === 'বিকাল') {
                return hour + 12;
            } else if (meridiem === 'সন্ধ্যা') {
                return hour + 12;
            }
        },

        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 6) {
                return 'ভোর';
            } else if (hour < 12) {
                return 'সকাল';
            } else if (hour < 15) {
                return 'দুপুর';
            } else if (hour < 18) {
                return 'বিকাল';
            } else if (hour < 20) {
                return 'সন্ধ্যা';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bnBd;

})));


/***/ }),

/***/ 7385:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'chart-line';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f201';
var svgPathData = 'M117.65 277.65c6.25 6.25 16.38 6.25 22.63 0L192 225.94l84.69 84.69c6.25 6.25 16.38 6.25 22.63 0L409.54 200.4l29.49 29.5c15.12 15.12 40.97 4.41 40.97-16.97V112c0-8.84-7.16-16-16-16H363.07c-21.38 0-32.09 25.85-16.97 40.97l29.5 29.49-87.6 87.6-84.69-84.69c-6.25-6.25-16.38-6.25-22.63 0l-74.34 74.34c-6.25 6.25-6.25 16.38 0 22.63l11.31 11.31zM496 400H48V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.gK = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 7401:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ FormModal_FormModal; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/FormModal/FormModal.ts?vue&type=script&lang=ts&external



var FormModal = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(FormModal, _super);
    function FormModal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormModal.prototype.getModalForm = function () {
        var content = this.$refs.body;
        if (this.form) {
            return this.form;
        }
        return content.querySelector('form');
    };
    FormModal.prototype.onOk = function () {
        var _this = this;
        var form = this.getModalForm();
        if (!form) {
            this.hide();
            return;
        }
        this.isTransitioning = true;
        var component = form.$formComponent;
        try {
            component.submit();
            component.$on('submitComplete', function (reponse) {
                if (_this.closeOnSubmit) {
                    _this.hide();
                }
                _this.isTransitioning = false;
                _this.$emit('submitComplete', reponse);
            });
            component.$on('submitError', function (reponse) {
                _this.$emit('submitError', reponse);
                _this.isTransitioning = false;
            });
            component.$on('validateDatasErrors', function () {
                _this.$emit('validateDatasErrors');
                _this.isTransitioning = false;
            });
            component.$on('validationErrors', function (reponse) {
                _this.$emit('validationErrors', reponse);
                _this.isTransitioning = false;
            });
        }
        catch (error) {
            this.getModalForm().submit();
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: function () { return this.$kwInterface.i18n.t('interface.save'); } })
    ], FormModal.prototype, "okTitle", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: function () { return this.$kwInterface.i18n.t('interface.cancel'); } })
    ], FormModal.prototype, "cancelTitle", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: true })
    ], FormModal.prototype, "closeOnSubmit", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], FormModal.prototype, "form", void 0);
    FormModal = (0,tslib_es6/* __decorate */.Cg)([
        lib/* Component */.uA
    ], FormModal);
    return FormModal;
}((0,lib/* Mixins */.Xe)(external_bootstrap_vue_.BModal)));
/* harmony default export */ var FormModalvue_type_script_lang_ts_external = (FormModal);

;// ./src/components/FormModal/FormModal.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var FormModal_FormModalvue_type_script_lang_ts_external = (FormModalvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/FormModal/FormModal.vue
var render, staticRenderFns
;



/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  FormModal_FormModalvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FormModal_FormModal = (component.exports);

/***/ }),

/***/ 7422:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(1769),
    toKey = __webpack_require__(7797);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ 7473:
/***/ (function(module) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 7514:
/***/ (function(module) {

"use strict";
module.exports = "data:image/png;base64,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";

/***/ }),

/***/ 7534:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2552),
    isObjectLike = __webpack_require__(346);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 7538:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    /*jshint -W100*/
    var si = moment.defineLocale('si', {
        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
            '_'
        ),
        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
            '_'
        ),
        weekdays:
            'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
                '_'
            ),
        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'a h:mm',
            LTS: 'a h:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY MMMM D',
            LLL: 'YYYY MMMM D, a h:mm',
            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
        },
        calendar: {
            sameDay: '[අද] LT[ට]',
            nextDay: '[හෙට] LT[ට]',
            nextWeek: 'dddd LT[ට]',
            lastDay: '[ඊයේ] LT[ට]',
            lastWeek: '[පසුගිය] dddd LT[ට]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sකින්',
            past: '%sකට පෙර',
            s: 'තත්පර කිහිපය',
            ss: 'තත්පර %d',
            m: 'මිනිත්තුව',
            mm: 'මිනිත්තු %d',
            h: 'පැය',
            hh: 'පැය %d',
            d: 'දිනය',
            dd: 'දින %d',
            M: 'මාසය',
            MM: 'මාස %d',
            y: 'වසර',
            yy: 'වසර %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal: function (number) {
            return number + ' වැනි';
        },
        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM: function (input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        },
    });

    return si;

})));


/***/ }),

/***/ 7556:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(1873),
    arrayMap = __webpack_require__(4932),
    isArray = __webpack_require__(6449),
    isSymbol = __webpack_require__(4394);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 7563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ Units_Units; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Units/Units.vue?vue&type=template&id=260dde68
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DynamicList',{attrs:{"url":_vm.apiUrl,"columns":_vm.columns,"createTitle":_vm.$t('interface.unit.new'),"updateTitle":_vm.$t('interface.unit.edit'),"deleteMsg":_vm.$t('interface.unit.deleteMsg'),"sort":"label","withDefault":""},on:{"submitted":_vm.setUnit,"deleted":_vm.deleteUnit}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: ./src/components/DynamicList/DynamicList.vue + 4 modules
var DynamicList = __webpack_require__(3425);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Units/Units.ts?vue&type=script&lang=ts&external




var Units = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(Units, _super);
    function Units() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.columns = [
            {
                label: _this.$t('interface.unit.label'),
                key: 'label',
                required: true
            }
        ];
        return _this;
    }
    Object.defineProperty(Units.prototype, "apiUrl", {
        get: function () {
            return '/unit';
        },
        enumerable: false,
        configurable: true
    });
    Units = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['setUnit', 'deleteUnit'])),
            components: {
                DynamicList: DynamicList/* default */.A
            }
        })
    ], Units);
    return Units;
}(lib/* Vue */.lD));
/* harmony default export */ var Unitsvue_type_script_lang_ts_external = (Units);

;// ./src/components/Units/Units.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var Units_Unitsvue_type_script_lang_ts_external = (Unitsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/Units/Units.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  Units_Unitsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Units_Units = (component.exports);

/***/ }),

/***/ 7583:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'circle';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f111';
var svgPathData = 'M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.GE = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 7609:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uz = moment.defineLocale('uz', {
        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
            '_'
        ),
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Бугун соат] LT [да]',
            nextDay: '[Эртага] LT [да]',
            nextWeek: 'dddd [куни соат] LT [да]',
            lastDay: '[Кеча соат] LT [да]',
            lastWeek: '[Утган] dddd [куни соат] LT [да]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Якин %s ичида',
            past: 'Бир неча %s олдин',
            s: 'фурсат',
            ss: '%d фурсат',
            m: 'бир дакика',
            mm: '%d дакика',
            h: 'бир соат',
            hh: '%d соат',
            d: 'бир кун',
            dd: '%d кун',
            M: 'бир ой',
            MM: '%d ой',
            y: 'бир йил',
            yy: '%d йил',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return uz;

})));


/***/ }),

/***/ 7619:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'palette';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f53f';
var svgPathData = 'M204.3 5C104.9 24.4 24.8 104.3 5.2 203.4c-37 187 131.7 326.4 258.8 306.7 41.2-6.4 61.4-54.6 42.5-91.7-23.1-45.4 9.9-98.4 60.9-98.4h79.7c35.8 0 64.8-29.6 64.9-65.3C511.5 97.1 368.1-26.9 204.3 5zM96 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm32-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128-64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.fy = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 7641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ AppVersions_AppVersions; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AppVersions/AppVersions.vue?vue&type=template&id=58519944
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_vm._l((_vm.updates),function(update,i){return _c('div',{key:i,staticClass:"mb-5"},[_c('p',{staticClass:"font-weight-bold mb-1 border-bottom"},[_vm._v(" "+_vm._s(_vm.formatDate(update.date))+" - Version "+_vm._s(update.version)+" ")]),_c('FroalaView',{attrs:{"value":update.content}})],1)}),_c('b-pagination',{attrs:{"disabled":_vm.loading,"total-rows":_vm.total,"per-page":_vm.perPage,"align":"center"},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: ./src/components/Spinner/Spinner.vue + 3 modules
var Spinner = __webpack_require__(683);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: ./src/utils/date.ts + 1 modules
var utils_date = __webpack_require__(4755);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/AppVersions/AppVersions.ts?vue&type=script&lang=ts&external






var AppVersions = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(AppVersions, _super);
    function AppVersions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.page = 1;
        _this.perPage = 10;
        _this.total = 0;
        _this.updates = [];
        return _this;
    }
    AppVersions.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadUpdates()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AppVersions.prototype.formatDate = function (date) {
        return (0,utils_date/* moment */.n$)(date).format('DD MMMM YYYY');
    };
    AppVersions.prototype.watchPage = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadUpdates()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AppVersions.prototype.loadUpdates = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                this.loading = true;
                this.$kwInterface.axios.get('/app/version', {
                    params: {
                        page: this.page,
                        per_page: this.perPage,
                        sort: 'date:desc'
                    }
                })
                    .then(function (response) {
                    _this.updates = response.data.data;
                    _this.total = response.data.meta.total;
                    _this.loading = false;
                });
                return [2 /*return*/];
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('page')
    ], AppVersions.prototype, "watchPage", null);
    AppVersions = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: Spinner/* default */.A,
                FroalaView: form_vue_.FroalaView,
                BPagination: external_bootstrap_vue_.BPagination
            }
        })
    ], AppVersions);
    return AppVersions;
}(lib/* Vue */.lD));
/* harmony default export */ var AppVersionsvue_type_script_lang_ts_external = (AppVersions);

;// ./src/components/AppVersions/AppVersions.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var AppVersions_AppVersionsvue_type_script_lang_ts_external = (AppVersionsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/AppVersions/AppVersions.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  AppVersions_AppVersionsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AppVersions_AppVersions = (component.exports);

/***/ }),

/***/ 7650:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return es;

})));


/***/ }),

/***/ 7670:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(2651);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 7706:
/***/ (function(module) {

"use strict";
module.exports = "data:image/png;base64,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";

/***/ }),

/***/ 7711:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzmLatn = moment.defineLocale('tzm-latn', {
        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
            '_'
        ),
        monthsShort:
            'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
                '_'
            ),
        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dadkh s yan %s',
            past: 'yan %s',
            s: 'imik',
            ss: '%d imik',
            m: 'minuḍ',
            mm: '%d minuḍ',
            h: 'saɛa',
            hh: '%d tassaɛin',
            d: 'ass',
            dd: '%d ossan',
            M: 'ayowr',
            MM: '%d iyyirn',
            y: 'asgas',
            yy: '%d isgasn',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzmLatn;

})));


/***/ }),

/***/ 7721:
/***/ (function(module) {

/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */
function baseSum(array, iteratee) {
  var result,
      index = -1,
      length = array.length;

  while (++index < length) {
    var current = iteratee(array[index]);
    if (current !== undefined) {
      result = result === undefined ? current : (result + current);
    }
  }
  return result;
}

module.exports = baseSum;


/***/ }),

/***/ 7730:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Mexico) [es-mx]
//! author : JC Franco : https://github.com/jcfranco

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esMx = moment.defineLocale('es-mx', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return esMx;

})));


/***/ }),

/***/ 7777:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var bg = moment.defineLocale('bg', {
        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Днес в] LT',
            nextDay: '[Утре в] LT',
            nextWeek: 'dddd [в] LT',
            lastDay: '[Вчера в] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Миналата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Миналия] dddd [в] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'след %s',
            past: 'преди %s',
            s: 'няколко секунди',
            ss: '%d секунди',
            m: 'минута',
            mm: '%d минути',
            h: 'час',
            hh: '%d часа',
            d: 'ден',
            dd: '%d дена',
            w: 'седмица',
            ww: '%d седмици',
            M: 'месец',
            MM: '%d месеца',
            y: 'година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bg;

})));


/***/ }),

/***/ 7797:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(4394);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ 7798:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'broadcast-tower';
var width = 640;
var height = 512;
var ligatures = [];
var unicode = 'f519';
var svgPathData = 'M150.94 192h33.73c11.01 0 18.61-10.83 14.86-21.18-4.93-13.58-7.55-27.98-7.55-42.82s2.62-29.24 7.55-42.82C203.29 74.83 195.68 64 184.67 64h-33.73c-7.01 0-13.46 4.49-15.41 11.23C130.64 92.21 128 109.88 128 128c0 18.12 2.64 35.79 7.54 52.76 1.94 6.74 8.39 11.24 15.4 11.24zM89.92 23.34C95.56 12.72 87.97 0 75.96 0H40.63c-6.27 0-12.14 3.59-14.74 9.31C9.4 45.54 0 85.65 0 128c0 24.75 3.12 68.33 26.69 118.86 2.62 5.63 8.42 9.14 14.61 9.14h34.84c12.02 0 19.61-12.74 13.95-23.37-49.78-93.32-16.71-178.15-.17-209.29zM614.06 9.29C611.46 3.58 605.6 0 599.33 0h-35.42c-11.98 0-19.66 12.66-14.02 23.25 18.27 34.29 48.42 119.42.28 209.23-5.72 10.68 1.8 23.52 13.91 23.52h35.23c6.27 0 12.13-3.58 14.73-9.29C630.57 210.48 640 170.36 640 128s-9.42-82.48-25.94-118.71zM489.06 64h-33.73c-11.01 0-18.61 10.83-14.86 21.18 4.93 13.58 7.55 27.98 7.55 42.82s-2.62 29.24-7.55 42.82c-3.76 10.35 3.85 21.18 14.86 21.18h33.73c7.02 0 13.46-4.49 15.41-11.24 4.9-16.97 7.53-34.64 7.53-52.76 0-18.12-2.64-35.79-7.54-52.76-1.94-6.75-8.39-11.24-15.4-11.24zm-116.3 100.12c7.05-10.29 11.2-22.71 11.2-36.12 0-35.35-28.63-64-63.96-64-35.32 0-63.96 28.65-63.96 64 0 13.41 4.15 25.83 11.2 36.12l-130.5 313.41c-3.4 8.15.46 17.52 8.61 20.92l29.51 12.31c8.15 3.4 17.52-.46 20.91-8.61L244.96 384h150.07l49.2 118.15c3.4 8.16 12.76 12.01 20.91 8.61l29.51-12.31c8.15-3.4 12-12.77 8.61-20.92l-130.5-313.41zM271.62 320L320 203.81 368.38 320h-96.76z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.YX = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 7805:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(3360),
    eq = __webpack_require__(5288);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),

/***/ 7828:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(9325);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 7853:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return de;

})));


/***/ }),

/***/ 7892:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCh = moment.defineLocale('fr-ch', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return frCh;

})));


/***/ }),

/***/ 7935:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'calculator-alt';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f64c';
var svgPathData = 'M192 288H32c-17.67 0-32 14.33-32 32v160c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V320c0-17.67-14.33-32-32-32zm-29.09 140.29c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0L112 422.63l-28.29 28.29c-3.12 3.12-8.19 3.12-11.31 0L61.09 439.6c-3.12-3.12-3.12-8.19 0-11.31L89.37 400l-28.29-28.29c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l28.3 28.28 28.29-28.29c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31L134.63 400l28.28 28.29zM480 0H320c-17.67 0-32 14.33-32 32v160c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32zm-16 120c0 4.42-3.58 8-8 8h-40v40c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-40h-40c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h40V56c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v40h40c4.42 0 8 3.58 8 8v16zm16 168H320c-17.67 0-32 14.33-32 32v160c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V320c0-17.67-14.33-32-32-32zm-16 152c0 4.42-3.58 8-8 8H344c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm0-64c0 4.42-3.58 8-8 8H344c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zM192 0H32C14.33 0 0 14.33 0 32v160c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32zm-16 120c0 4.42-3.58 8-8 8H56c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.$g = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 7978:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(270),
    get = __webpack_require__(8156),
    hasIn = __webpack_require__(631),
    isKey = __webpack_require__(8586),
    isStrictComparable = __webpack_require__(756),
    matchesStrictComparable = __webpack_require__(7197),
    toKey = __webpack_require__(7797);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),

/***/ 8000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ForgotPassword_ForgotPassword; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ForgotPassword/ForgotPassword.vue?vue&type=template&id=26cbdb97
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-card',{staticClass:"login-form",attrs:{"title":_vm.$t('interface.auth.forgotPassword')}},[(_vm.responseMessage)?_c('div',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.responseMessage)+" ")]):_c('k-form',{attrs:{"action":"/auth/forgot-password","method":"post","beforeSubmit":_vm.beforeSubmit,"dontAskLogin":""},on:{"submitComplete":_vm.submitComplete,"submitError":_vm.submitError}},[_c('b-form-group',{attrs:{"label":_vm.$t('interface.auth.loginEmail')}},[_c('k-form-input',{attrs:{"type":"email","name":"email","required":""}})],1),_c('b-alert',{attrs:{"show":_vm.errorMessage !== null,"variant":"danger"}},[_vm._v(" "+_vm._s(_vm.errorMessage)+" ")]),_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_vm._v(" "+_vm._s(_vm.$t('interface.auth.forgotPasswordBtn'))+" ")]),_c('div',{staticClass:"small mt-3"},[_c('router-link',{attrs:{"to":{ name: 'login' }}},[_vm._v(" "+_vm._s(_vm.$t('interface.backToLogin'))+" ")]),_c('br'),_c('router-link',{attrs:{"to":{ name: 'register' }}},[_vm._v(" "+_vm._s(_vm.$t('interface.auth.createAccount'))+" ")])],1)],1)],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ForgotPassword/ForgotPassword.ts?vue&type=script&lang=ts&external




var ForgotPassword = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ForgotPassword, _super);
    function ForgotPassword() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.responseMessage = null;
        _this.errorMessage = null;
        return _this;
    }
    ForgotPassword.prototype.beforeSubmit = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.$kwInterface.withCsrf) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.$kwInterface.axios.get('/csrf-cookie')];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ForgotPassword.prototype.submitComplete = function (response) {
        this.responseMessage = response.data.message;
    };
    ForgotPassword.prototype.submitError = function (error) {
        var _a;
        this.errorMessage = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data.message;
    };
    ForgotPassword = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BCard: external_bootstrap_vue_.BCard, BFormGroup: external_bootstrap_vue_.BFormGroup, BButton: external_bootstrap_vue_.BButton, BAlert: external_bootstrap_vue_.BAlert,
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput
            }
        })
    ], ForgotPassword);
    return ForgotPassword;
}(lib/* Vue */.lD));
/* harmony default export */ var ForgotPasswordvue_type_script_lang_ts_external = (ForgotPassword);

;// ./src/components/ForgotPassword/ForgotPassword.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ForgotPassword_ForgotPasswordvue_type_script_lang_ts_external = (ForgotPasswordvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/ForgotPassword/ForgotPassword.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ForgotPassword_ForgotPasswordvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ForgotPassword_ForgotPassword = (component.exports);

/***/ }),

/***/ 8057:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/form-vue");

/***/ }),

/***/ 8076:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekund', 'sekunda', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1
                ? wordKey[0]
                : number >= 2 && number <= 4
                  ? wordKey[1]
                  : wordKey[2];
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return (
                    number +
                    ' ' +
                    translator.correctGrammaticalCase(number, wordKey)
                );
            }
        },
    };

    var me = moment.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedjelje] [u] LT',
                    '[prošlog] [ponedjeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srijede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'dan',
            dd: translator.translate,
            M: 'mjesec',
            MM: translator.translate,
            y: 'godinu',
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return me;

})));


/***/ }),

/***/ 8077:
/***/ (function(module) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),

/***/ 8094:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'file-import';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f56f';
var svgPathData = 'M16 288c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h112v-64zm489-183L407.1 7c-4.5-4.5-10.6-7-17-7H384v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H152c-13.3 0-24 10.7-24 24v264h128v-65.2c0-14.3 17.3-21.4 27.4-11.3L379 308c6.6 6.7 6.6 17.4 0 24l-95.7 96.4c-10.1 10.1-27.4 3-27.4-11.3V352H128v136c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H376c-13.2 0-24-10.8-24-24z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.$M = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 8096:
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 8122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ Error404; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Error404/Error404.vue?vue&type=template&id=13a406d0
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"error-404"},[_c('p',{staticClass:"content"},[_vm._v(" "+_vm._s(_vm.$t('interface.error404Content'))+" ")]),_c('router-link',{attrs:{"to":{ name: 'login' }}},[_vm._v(" "+_vm._s(_vm.$t('interface.error404Link'))+" ")])],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Error404/Error404.ts?vue&type=script&lang=ts&external



var Error404View = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(Error404View, _super);
    function Error404View() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Error404View.prototype, "logo", {
        get: function () {
            var _a;
            if ((_a = this.$kwInterface) === null || _a === void 0 ? void 0 : _a.publicLogo) {
                return this.$kwInterface.publicLogo;
            }
            var images = __webpack_require__(8141);
            return images('./logo-public.png');
        },
        enumerable: false,
        configurable: true
    });
    Error404View = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('app', ['app']))
        })
    ], Error404View);
    return Error404View;
}(lib/* Vue */.lD));
/* harmony default export */ var Error404vue_type_script_lang_ts_external = (Error404View);

;// ./src/components/Error404/Error404.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var Error404_Error404vue_type_script_lang_ts_external = (Error404vue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/Error404/Error404.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  Error404_Error404vue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Error404 = (component.exports);

/***/ }),

/***/ 8141:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./favicon.png": 7514,
	"./logo-public.png": 3471,
	"./logo-sidebar-alt.png": 2912,
	"./logo-sidebar-collapsed.png": 4994,
	"./logo-sidebar.png": 7706
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8141;

/***/ }),

/***/ 8156:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(7422);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ 8174:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kurdish [ku]
//! author : Shahram Mebashar : https://github.com/ShahramMebashar

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        months = [
            'کانونی دووەم',
            'شوبات',
            'ئازار',
            'نیسان',
            'ئایار',
            'حوزەیران',
            'تەمموز',
            'ئاب',
            'ئەیلوول',
            'تشرینی یەكەم',
            'تشرینی دووەم',
            'كانونی یەکەم',
        ];

    var ku = moment.defineLocale('ku', {
        months: months,
        monthsShort: months,
        weekdays:
            'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
                '_'
            ),
        weekdaysShort:
            'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ئێواره‌|به‌یانی/,
        isPM: function (input) {
            return /ئێواره‌/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'به‌یانی';
            } else {
                return 'ئێواره‌';
            }
        },
        calendar: {
            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
            nextDay: '[به‌یانی كاتژمێر] LT',
            nextWeek: 'dddd [كاتژمێر] LT',
            lastDay: '[دوێنێ كاتژمێر] LT',
            lastWeek: 'dddd [كاتژمێر] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'له‌ %s',
            past: '%s',
            s: 'چه‌ند چركه‌یه‌ك',
            ss: 'چركه‌ %d',
            m: 'یه‌ك خوله‌ك',
            mm: '%d خوله‌ك',
            h: 'یه‌ك كاتژمێر',
            hh: '%d كاتژمێر',
            d: 'یه‌ك ڕۆژ',
            dd: '%d ڕۆژ',
            M: 'یه‌ك مانگ',
            MM: '%d مانگ',
            y: 'یه‌ك ساڵ',
            yy: '%d ساڵ',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ku;

})));


/***/ }),

/***/ 8223:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(6110),
    root = __webpack_require__(9325);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 8228:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'arrows-v';
var width = 256;
var height = 512;
var ligatures = [];
var unicode = 'f07d';
var svgPathData = 'M160 406.186V105.815l43.728 46.208c9.289 9.815 24.846 10.03 34.402.474l10.84-10.84c9.373-9.373 9.373-24.569 0-33.941L150.627 9.373c-12.497-12.497-32.758-12.497-45.255 0L7.029 107.715c-9.373 9.373-9.373 24.569 0 33.941l10.84 10.84c9.556 9.556 25.113 9.341 34.402-.474L96 105.815v300.371l-43.728-46.208c-9.289-9.815-24.846-10.03-34.402-.474l-10.84 10.84c-9.373 9.373-9.373 24.569 0 33.941l98.343 98.343c12.497 12.497 32.758 12.497 45.255 0l98.343-98.343c9.373-9.373 9.373-24.569 0-33.941l-10.84-10.84c-9.556-9.556-25.113-9.341-34.402.474L160 406.186z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.KI = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 8235:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    var ne = moment.defineLocale('ne', {
        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
            '_'
        ),
        monthsShort:
            'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
            '_'
        ),
        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'Aको h:mm बजे',
            LTS: 'Aको h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, Aको h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राति') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
                return hour;
            } else if (meridiem === 'दिउँसो') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 3) {
                return 'राति';
            } else if (hour < 12) {
                return 'बिहान';
            } else if (hour < 16) {
                return 'दिउँसो';
            } else if (hour < 20) {
                return 'साँझ';
            } else {
                return 'राति';
            }
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[भोलि] LT',
            nextWeek: '[आउँदो] dddd[,] LT',
            lastDay: '[हिजो] LT',
            lastWeek: '[गएको] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमा',
            past: '%s अगाडि',
            s: 'केही क्षण',
            ss: '%d सेकेण्ड',
            m: 'एक मिनेट',
            mm: '%d मिनेट',
            h: 'एक घण्टा',
            hh: '%d घण्टा',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महिना',
            MM: '%d महिना',
            y: 'एक बर्ष',
            yy: '%d बर्ष',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ne;

})));


/***/ }),

/***/ 8298:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enCa = moment.defineLocale('en-ca', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'YYYY-MM-DD',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY h:mm A',
            LLLL: 'dddd, MMMM D, YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
    });

    return enCa;

})));


/***/ }),

/***/ 8303:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(6110),
    root = __webpack_require__(9325);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ 8329:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArrayLike = __webpack_require__(4894);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),

/***/ 8349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_PaymentMethodsView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/PaymentMethodsView.vue?vue&type=template&id=58337eee
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PaymentMethods')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: ./src/components/PaymentMethods/PaymentMethods.vue + 3 modules
var PaymentMethods = __webpack_require__(9017);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/PaymentMethodsView.vue?vue&type=script&lang=ts



var PaymentMethodsView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PaymentMethodsView, _super);
    function PaymentMethodsView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PaymentMethodsView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                PaymentMethods: PaymentMethods/* default */.A
            }
        })
    ], PaymentMethodsView);
    return PaymentMethodsView;
}(lib/* Vue */.lD));
/* harmony default export */ var PaymentMethodsViewvue_type_script_lang_ts = (PaymentMethodsView);

;// ./src/views/PaymentMethodsView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_PaymentMethodsViewvue_type_script_lang_ts = (PaymentMethodsViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/PaymentMethodsView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_PaymentMethodsViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_PaymentMethodsView = (component.exports);

/***/ }),

/***/ 8358:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'map-signs';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f277';
var svgPathData = 'M507.31 84.69L464 41.37c-6-6-14.14-9.37-22.63-9.37H288V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v16H56c-13.25 0-24 10.75-24 24v80c0 13.25 10.75 24 24 24h385.37c8.49 0 16.62-3.37 22.63-9.37l43.31-43.31c6.25-6.26 6.25-16.38 0-22.63zM224 496c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V384h-64v112zm232-272H288v-32h-64v32H70.63c-8.49 0-16.62 3.37-22.63 9.37L4.69 276.69c-6.25 6.25-6.25 16.38 0 22.63L48 342.63c6 6 14.14 9.37 22.63 9.37H456c13.25 0 24-10.75 24-24v-80c0-13.25-10.75-24-24-24z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.kn = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 8383:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz
//! author: Marco : https://github.com/Manfre98

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var it = moment.defineLocale('it', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: function () {
                return (
                    '[Oggi a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextDay: function () {
                return (
                    '[Domani a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextWeek: function () {
                return (
                    'dddd [a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastDay: function () {
                return (
                    '[Ieri a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return (
                            '[La scorsa] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                  ? ' '
                                  : "ll'") +
                            ']LT'
                        );
                    default:
                        return (
                            '[Lo scorso] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                  ? ' '
                                  : "ll'") +
                            ']LT'
                        );
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'tra %s',
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            w: 'una settimana',
            ww: '%d settimane',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return it;

})));


/***/ }),

/***/ 8399:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/table-vue");

/***/ }),

/***/ 8414:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uyghur (China) [ug-cn]
//! author: boyaq : https://github.com/boyaq

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ugCn = moment.defineLocale('ug-cn', {
        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        monthsShort:
            'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
                '_'
            ),
        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
            '_'
        ),
        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
        },
        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                meridiem === 'يېرىم كېچە' ||
                meridiem === 'سەھەر' ||
                meridiem === 'چۈشتىن بۇرۇن'
            ) {
                return hour;
            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
                return hour + 12;
            } else {
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return 'يېرىم كېچە';
            } else if (hm < 900) {
                return 'سەھەر';
            } else if (hm < 1130) {
                return 'چۈشتىن بۇرۇن';
            } else if (hm < 1230) {
                return 'چۈش';
            } else if (hm < 1800) {
                return 'چۈشتىن كېيىن';
            } else {
                return 'كەچ';
            }
        },
        calendar: {
            sameDay: '[بۈگۈن سائەت] LT',
            nextDay: '[ئەتە سائەت] LT',
            nextWeek: '[كېلەركى] dddd [سائەت] LT',
            lastDay: '[تۆنۈگۈن] LT',
            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s كېيىن',
            past: '%s بۇرۇن',
            s: 'نەچچە سېكونت',
            ss: '%d سېكونت',
            m: 'بىر مىنۇت',
            mm: '%d مىنۇت',
            h: 'بىر سائەت',
            hh: '%d سائەت',
            d: 'بىر كۈن',
            dd: '%d كۈن',
            M: 'بىر ئاي',
            MM: '%d ئاي',
            y: 'بىر يىل',
            yy: '%d يىل',
        },

        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '-كۈنى';
                case 'w':
                case 'W':
                    return number + '-ھەپتە';
                default:
                    return number;
            }
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return ugCn;

})));


/***/ }),

/***/ 8430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_HistoricsView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/HistoricsView.vue?vue&type=template&id=c906b20a
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('HistoricList',{attrs:{"withFilters":""}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: ./src/components/HistoricList/HistoricList.vue + 3 modules
var HistoricList = __webpack_require__(9209);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/HistoricsView.vue?vue&type=script&lang=ts



var HistoricsView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(HistoricsView, _super);
    function HistoricsView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HistoricsView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                HistoricList: HistoricList/* default */.A
            }
        })
    ], HistoricsView);
    return HistoricsView;
}(lib/* Vue */.lD));
/* harmony default export */ var HistoricsViewvue_type_script_lang_ts = (HistoricsView);

;// ./src/views/HistoricsView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_HistoricsViewvue_type_script_lang_ts = (HistoricsViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/HistoricsView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_HistoricsViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_HistoricsView = (component.exports);

/***/ }),

/***/ 8458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ Civilities_Civilities; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Civilities/Civilities.vue?vue&type=template&id=3df08a06
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DynamicList',{attrs:{"url":_vm.apiUrl,"columns":_vm.columns,"createTitle":_vm.$t('interface.civility.new'),"updateTitle":_vm.$t('interface.civility.edit'),"deleteMsg":_vm.$t('interface.civility.deleteMsg'),"sort":"name","withDefault":""},on:{"submitted":_vm.setCivility,"deleted":_vm.deleteCivility}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: ./src/components/DynamicList/DynamicList.vue + 4 modules
var DynamicList = __webpack_require__(3425);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Civilities/Civilities.ts?vue&type=script&lang=ts&external




var Civilities = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(Civilities, _super);
    function Civilities() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.columns = [
            {
                label: _this.$t('interface.civility.label'),
                key: 'name',
                required: true
            },
            {
                label: _this.$t('interface.civility.label2'),
                key: 'short_name',
                required: true,
                class: 'd-none d-md-table-cell'
            }
        ];
        return _this;
    }
    Object.defineProperty(Civilities.prototype, "apiUrl", {
        get: function () {
            return '/civility';
        },
        enumerable: false,
        configurable: true
    });
    Civilities = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['setCivility', 'deleteCivility'])),
            components: {
                DynamicList: DynamicList/* default */.A
            }
        })
    ], Civilities);
    return Civilities;
}(lib/* Vue */.lD));
/* harmony default export */ var Civilitiesvue_type_script_lang_ts_external = (Civilities);

;// ./src/components/Civilities/Civilities.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var Civilities_Civilitiesvue_type_script_lang_ts_external = (Civilitiesvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/Civilities/Civilities.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  Civilities_Civilitiesvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Civilities_Civilities = (component.exports);

/***/ }),

/***/ 8474:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-чү',
        1: '-чи',
        2: '-чи',
        3: '-чү',
        4: '-чү',
        5: '-чи',
        6: '-чы',
        7: '-чи',
        8: '-чи',
        9: '-чу',
        10: '-чу',
        20: '-чы',
        30: '-чу',
        40: '-чы',
        50: '-чү',
        60: '-чы',
        70: '-чи',
        80: '-чи',
        90: '-чу',
        100: '-чү',
    };

    var ky = moment.defineLocale('ky', {
        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
            '_'
        ),
        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
            '_'
        ),
        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
            '_'
        ),
        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгүн саат] LT',
            nextDay: '[Эртең саат] LT',
            nextWeek: 'dddd [саат] LT',
            lastDay: '[Кечээ саат] LT',
            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ичинде',
            past: '%s мурун',
            s: 'бирнече секунд',
            ss: '%d секунд',
            m: 'бир мүнөт',
            mm: '%d мүнөт',
            h: 'бир саат',
            hh: '%d саат',
            d: 'бир күн',
            dd: '%d күн',
            M: 'бир ай',
            MM: '%d ай',
            y: 'бир жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ky;

})));


/***/ }),

/***/ 8484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1635);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9077);


var PageHeaderMixin = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__extends */ .C6)(PageHeaderMixin, _super);
    function PageHeaderMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PageHeaderMixin.prototype.showMenuEntry = function (entry) {
        var showMenuEntry = this.$kwInterface.showMenuEntry;
        return showMenuEntry ? showMenuEntry(entry, this.$kwInterface.store, true) : true;
    };
    PageHeaderMixin = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__decorate */ .Cg)([
        vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .uA
    ], PageHeaderMixin);
    return PageHeaderMixin;
}(vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Vue */ .lD));
/* harmony default export */ __webpack_exports__.A = (PageHeaderMixin);


/***/ }),

/***/ 8540:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'users';
var width = 640;
var height = 512;
var ligatures = [];
var unicode = 'f0c0';
var svgPathData = 'M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.gd = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 8583:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_TeamInformationsView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/TeamInformationsView.vue?vue&type=template&id=1c316fd1
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TeamInfos')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: ./src/components/TeamInfos/TeamInfos.vue + 3 modules
var TeamInfos = __webpack_require__(9282);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/TeamInformationsView.vue?vue&type=script&lang=ts



var TeamInformationsView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TeamInformationsView, _super);
    function TeamInformationsView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TeamInformationsView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                TeamInfos: TeamInfos/* default */.A
            }
        })
    ], TeamInformationsView);
    return TeamInformationsView;
}(lib/* Vue */.lD));
/* harmony default export */ var TeamInformationsViewvue_type_script_lang_ts = (TeamInformationsView);

;// ./src/views/TeamInformationsView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_TeamInformationsViewvue_type_script_lang_ts = (TeamInformationsViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/TeamInformationsView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_TeamInformationsViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_TeamInformationsView = (component.exports);

/***/ }),

/***/ 8586:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(6449),
    isSymbol = __webpack_require__(4394);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ 8629:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fad';
var iconName = 'file-csv';
var width = 384;
var height = 512;
var ligatures = [];
var unicode = 'f6dd';
var svgPathData = ['M384 128H272a16 16 0 0 1-16-16V0H24A23.94 23.94 0 0 0 0 23.88V488a23.94 23.94 0 0 0 23.88 24H360a23.94 23.94 0 0 0 24-23.88V128zM128 280a8 8 0 0 1-8 8h-8a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h8a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8h-8a48 48 0 0 1-48-48v-32a48 48 0 0 1 48-48h8a8 8 0 0 1 8 8zm44.27 104H160a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h12.27c5.95 0 10.41-3.5 10.41-6.62a5.28 5.28 0 0 0-2.12-3.84l-21.89-18.77a37.11 37.11 0 0 1-13.33-28.14c0-21.3 19-38.62 42.41-38.62H200a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8h-12.27c-5.95 0-10.41 3.5-10.41 6.62a5.28 5.28 0 0 0 2.12 3.84l21.89 18.77a37.12 37.12 0 0 1 13.33 28.13c.01 21.29-19 38.63-42.39 38.63zM320 284.8c0 35.48-12.88 68.89-36.28 94.09-.27.29-.54.56-.83.83a16 16 0 0 1-22.61-.83c-23.4-25.2-36.28-58.61-36.28-94.09V264a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v20.8a109 109 0 0 0 16 56.88 109 109 0 0 0 16-56.88V264a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8z', 'M377 105L279.1 7a24 24 0 0 0-17-7H256v112a16 16 0 0 0 16 16h112v-6.1a23.9 23.9 0 0 0-7-16.9zM120 256h-8a48 48 0 0 0-48 48v32a48 48 0 0 0 48 48h8a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-8a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h8a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm192 0h-16a8 8 0 0 0-8 8v20.8a109 109 0 0 1-16 56.88 109 109 0 0 1-16-56.88V264a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v20.8c0 35.48 12.88 68.89 36.28 94.09a16 16 0 0 0 22.61.83c.29-.27.56-.54.83-.83 23.4-25.2 36.28-58.61 36.28-94.09V264a8 8 0 0 0-8-8zm-110.67 61.24l-21.89-18.77a5.28 5.28 0 0 1-2.12-3.84c0-3.12 4.46-6.62 10.41-6.62H200a8 8 0 0 0 8-8V264a8 8 0 0 0-8-8h-12.25c-23.39 0-42.41 17.32-42.41 38.62a37.11 37.11 0 0 0 13.33 28.14l21.89 18.77a5.28 5.28 0 0 1 2.12 3.84c0 3.12-4.46 6.62-10.41 6.62H160a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h12.27c23.39 0 42.4-17.33 42.39-38.62a37.12 37.12 0 0 0-13.33-28.13z'];

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.Wx = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 8655:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(6025);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 8662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_TeamApiTokenView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/TeamApiTokenView.vue?vue&type=template&id=5d66780e
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TeamApiToken')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: ./src/components/TeamApiToken/TeamApiToken.vue + 3 modules
var TeamApiToken = __webpack_require__(3838);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/TeamApiTokenView.vue?vue&type=script&lang=ts



var TeamApiTokenView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TeamApiTokenView, _super);
    function TeamApiTokenView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TeamApiTokenView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                TeamApiToken: TeamApiToken/* default */.A
            }
        })
    ], TeamApiTokenView);
    return TeamApiTokenView;
}(lib/* Vue */.lD));
/* harmony default export */ var TeamApiTokenViewvue_type_script_lang_ts = (TeamApiTokenView);

;// ./src/views/TeamApiTokenView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_TeamApiTokenViewvue_type_script_lang_ts = (TeamApiTokenViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/TeamApiTokenView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_TeamApiTokenViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_TeamApiTokenView = (component.exports);

/***/ }),

/***/ 8676:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Kuwait) [ar-kw]
//! author : Nusret Parlak: https://github.com/nusretparlak

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arKw = moment.defineLocale('ar-kw', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arKw;

})));


/***/ }),

/***/ 8856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_VatRatesView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/VatRatesView.vue?vue&type=template&id=25800927
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VatRates')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: ./src/components/VatRates/VatRates.vue + 3 modules
var VatRates = __webpack_require__(4448);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/VatRatesView.vue?vue&type=script&lang=ts



var VatRatesView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(VatRatesView, _super);
    function VatRatesView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VatRatesView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                VatRates: VatRates/* default */.A
            }
        })
    ], VatRatesView);
    return VatRatesView;
}(lib/* Vue */.lD));
/* harmony default export */ var VatRatesViewvue_type_script_lang_ts = (VatRatesView);

;// ./src/views/VatRatesView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_VatRatesViewvue_type_script_lang_ts = (VatRatesViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/VatRatesView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_VatRatesViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_VatRatesView = (component.exports);

/***/ }),

/***/ 8857:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'bars';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f0c9';
var svgPathData = 'M436 124H12c-6.627 0-12-5.373-12-12V80c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12zm0 160H12c-6.627 0-12-5.373-12-12v-32c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12zm0 160H12c-6.627 0-12-5.373-12-12v-32c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.ck = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 8858:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fad';
var iconName = 'file-video';
var width = 384;
var height = 512;
var ligatures = [];
var unicode = 'f1c8';
var svgPathData = ['M384 128H272a16 16 0 0 1-16-16V0H24A23.94 23.94 0 0 0 0 23.88V488a23.94 23.94 0 0 0 23.88 24H360a23.94 23.94 0 0 0 24-23.88V128zm-64 264c0 21.44-25.94 32-41 17l-55-55v38a24 24 0 0 1-24 24H88a24 24 0 0 1-24-24V280a24 24 0 0 1 24-24h112a24 24 0 0 1 24 24v38.06l55-55c15-15.06 41-4.5 41 16.94z', 'M377 105L279.1 7a24 24 0 0 0-17-7H256v112a16 16 0 0 0 16 16h112v-6.1a23.9 23.9 0 0 0-7-16.9zm-98 158.06l-55 55V280a24 24 0 0 0-24-24H88a24 24 0 0 0-24 24v112a24 24 0 0 0 24 24h112a24 24 0 0 0 24-24v-38l55 55c15.06 15 41 4.44 41-17V280c0-21.44-26-32-41-16.94z'];

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.n$ = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 8859:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(3661),
    setCacheAdd = __webpack_require__(1380),
    setCacheHas = __webpack_require__(1459);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ 8861:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tetun Dili (East Timor) [tet]
//! author : Joshua Brooks : https://github.com/joshbrooks
//! author : Onorio De J. Afonso : https://github.com/marobo
//! author : Sonia Simoes : https://github.com/soniasimoes

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tet = moment.defineLocale('tet', {
        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'iha %s',
            past: '%s liuba',
            s: 'segundu balun',
            ss: 'segundu %d',
            m: 'minutu ida',
            mm: 'minutu %d',
            h: 'oras ida',
            hh: 'oras %d',
            d: 'loron ida',
            dd: 'loron %d',
            M: 'fulan ida',
            MM: 'fulan %d',
            y: 'tinan ida',
            yy: 'tinan %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tet;

})));


/***/ }),

/***/ 8879:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(4335);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ 8946:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fad';
var iconName = 'file-alt';
var width = 384;
var height = 512;
var ligatures = [];
var unicode = 'f15c';
var svgPathData = ['M384 128H272a16 16 0 0 1-16-16V0H24A23.94 23.94 0 0 0 0 23.88V488a23.94 23.94 0 0 0 23.88 24H360a23.94 23.94 0 0 0 24-23.88V128zm-96 244a12 12 0 0 1-12 12H108a12 12 0 0 1-12-12v-8a12 12 0 0 1 12-12h168a12 12 0 0 1 12 12zm0-64a12 12 0 0 1-12 12H108a12 12 0 0 1-12-12v-8a12 12 0 0 1 12-12h168a12 12 0 0 1 12 12zm0-64a12 12 0 0 1-12 12H108a12 12 0 0 1-12-12v-8a12 12 0 0 1 12-12h168a12 12 0 0 1 12 12z', 'M377 105L279.1 7a24 24 0 0 0-17-7H256v112a16 16 0 0 0 16 16h112v-6.1a23.9 23.9 0 0 0-7-16.9zM276 352H108a12 12 0 0 0-12 12v8a12 12 0 0 0 12 12h168a12 12 0 0 0 12-12v-8a12 12 0 0 0-12-12zm0-64H108a12 12 0 0 0-12 12v8a12 12 0 0 0 12 12h168a12 12 0 0 0 12-12v-8a12 12 0 0 0-12-12zm0-64H108a12 12 0 0 0-12 12v8a12 12 0 0 0 12 12h168a12 12 0 0 0 12-12v-8a12 12 0 0 0-12-12z'];

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.h8 = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 8952:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tajik [tg]
//! author : Orif N. Jr. : https://github.com/orif-jr

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ум',
        1: '-ум',
        2: '-юм',
        3: '-юм',
        4: '-ум',
        5: '-ум',
        6: '-ум',
        7: '-ум',
        8: '-ум',
        9: '-ум',
        10: '-ум',
        12: '-ум',
        13: '-ум',
        20: '-ум',
        30: '-юм',
        40: '-ум',
        50: '-ум',
        60: '-ум',
        70: '-ум',
        80: '-ум',
        90: '-ум',
        100: '-ум',
    };

    var tg = moment.defineLocale('tg', {
        months: {
            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
                '_'
            ),
            standalone:
                'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
                    '_'
                ),
        },
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
            '_'
        ),
        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Имрӯз соати] LT',
            nextDay: '[Фардо соати] LT',
            lastDay: '[Дирӯз соати] LT',
            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'баъди %s',
            past: '%s пеш',
            s: 'якчанд сония',
            m: 'як дақиқа',
            mm: '%d дақиқа',
            h: 'як соат',
            hh: '%d соат',
            d: 'як рӯз',
            dd: '%d рӯз',
            M: 'як моҳ',
            MM: '%d моҳ',
            y: 'як сол',
            yy: '%d сол',
        },
        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'шаб') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'субҳ') {
                return hour;
            } else if (meridiem === 'рӯз') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'бегоҳ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'шаб';
            } else if (hour < 11) {
                return 'субҳ';
            } else if (hour < 16) {
                return 'рӯз';
            } else if (hour < 19) {
                return 'бегоҳ';
            } else {
                return 'шаб';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1th is the first week of the year.
        },
    });

    return tg;

})));


/***/ }),

/***/ 8959:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
              ? forms[1]
              : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            dd: 'дзень_дні_дзён',
            MM: 'месяц_месяцы_месяцаў',
            yy: 'год_гады_гадоў',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
        } else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    var be = moment.defineLocale('be', {
        months: {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
                '_'
            ),
            standalone:
                'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
                    '_'
                ),
        },
        monthsShort:
            'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
        weekdays: {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
                '_'
            ),
            standalone:
                'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
                    '_'
                ),
            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
        },
        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., HH:mm',
            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
        },
        calendar: {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function () {
                return '[У] dddd [ў] LT';
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return '[У мінулую] dddd [ў] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[У мінулы] dddd [ў] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'праз %s',
            past: '%s таму',
            s: 'некалькі секунд',
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithPlural,
            hh: relativeTimeWithPlural,
            d: 'дзень',
            dd: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM: function (input) {
            return /^(дня|вечара)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночы';
            } else if (hour < 12) {
                return 'раніцы';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечара';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) &&
                        number % 100 !== 12 &&
                        number % 100 !== 13
                        ? number + '-і'
                        : number + '-ы';
                case 'D':
                    return number + '-га';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return be;

})));


/***/ }),

/***/ 8984:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(5527),
    nativeKeys = __webpack_require__(3650);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 8992:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'history';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f1da';
var svgPathData = 'M504 255.531c.253 136.64-111.18 248.372-247.82 248.468-59.015.042-113.223-20.53-155.822-54.911-11.077-8.94-11.905-25.541-1.839-35.607l11.267-11.267c8.609-8.609 22.353-9.551 31.891-1.984C173.062 425.135 212.781 440 256 440c101.705 0 184-82.311 184-184 0-101.705-82.311-184-184-184-48.814 0-93.149 18.969-126.068 49.932l50.754 50.754c10.08 10.08 2.941 27.314-11.313 27.314H24c-8.837 0-16-7.163-16-16V38.627c0-14.254 17.234-21.393 27.314-11.314l49.372 49.372C129.209 34.136 189.552 8 256 8c136.81 0 247.747 110.78 248 247.531zm-180.912 78.784l9.823-12.63c8.138-10.463 6.253-25.542-4.21-33.679L288 256.349V152c0-13.255-10.745-24-24-24h-16c-13.255 0-24 10.745-24 24v135.651l65.409 50.874c10.463 8.137 25.541 6.253 33.679-4.21z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.In = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 9017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ PaymentMethods_PaymentMethods; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/PaymentMethods/PaymentMethods.vue?vue&type=template&id=731d2aa5
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DynamicList',{attrs:{"url":_vm.apiUrl,"columns":_vm.columns,"createTitle":_vm.$t('interface.paymentMethod.new'),"updateTitle":_vm.$t('interface.paymentMethod.edit'),"deleteMsg":_vm.$t('interface.paymentMethod.deleteMsg'),"sort":"label","replacementMessage":_vm.$t('interface.paymentMethod.replacementComments'),"withActiveStatus":""},on:{"submitted":_vm.submitted,"deleted":_vm.deleted}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: ./src/components/DynamicList/DynamicList.vue + 4 modules
var DynamicList = __webpack_require__(3425);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/PaymentMethods/PaymentMethods.ts?vue&type=script&lang=ts&external




var PaymentMethods = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PaymentMethods, _super);
    function PaymentMethods() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.columns = [
            {
                label: _this.$t('interface.paymentMethod.label'),
                key: 'label',
                required: true
            },
            {
                label: _this.$t('interface.paymentMethod.typeLabel'),
                key: 'type',
                keyShow: 'type.label',
                keyValue: 'type.id',
                required: true,
                type: 'select',
                options: [
                    { id: 1, label: _this.$t('interface.paymentMethod.types.card') },
                    { id: 2, label: _this.$t('interface.paymentMethod.types.check') },
                    { id: 3, label: _this.$t('interface.paymentMethod.types.cash') },
                    { id: 4, label: _this.$t('interface.paymentMethod.types.directDebit') },
                    { id: 5, label: _this.$t('interface.paymentMethod.types.directTransfert') },
                    { id: 0, label: _this.$t('interface.paymentMethod.types.other') }
                ],
                optionValue: function (opt) { return opt.id; },
                clearable: false,
                comments: _this.$t('interface.paymentMethod.typeComments'),
                class: 'd-none d-md-table-cell'
            },
            {
                label: _this.$t('interface.paymentMethod.pdfContent'),
                key: 'pdf_content',
                type: 'textarea',
                comments: _this.$t('interface.paymentMethod.pdfContentComments'),
                hideOnList: true,
                required: false
            },
            {
                label: _this.$t('interface.paymentMethod.bankAccount'),
                key: 'bank_account',
                type: 'text',
                comments: _this.$t('interface.paymentMethod.bankAccountComments'),
                hideOnList: true,
                required: false
            }
        ];
        return _this;
    }
    PaymentMethods.prototype.submitted = function (paymentMethod) {
        if (this.accountantMode === false) {
            this.setPaymentMethod(paymentMethod);
        }
    };
    PaymentMethods.prototype.deleted = function (paymentMethod) {
        if (this.accountantMode === false) {
            this.deletePaymentMethod(paymentMethod);
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], PaymentMethods.prototype, "accountantMode", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: '/payment_method' })
    ], PaymentMethods.prototype, "apiUrl", void 0);
    PaymentMethods = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['setPaymentMethod', 'deletePaymentMethod'])),
            components: {
                DynamicList: DynamicList/* default */.A
            }
        })
    ], PaymentMethods);
    return PaymentMethods;
}(lib/* Vue */.lD));
/* harmony default export */ var PaymentMethodsvue_type_script_lang_ts_external = (PaymentMethods);

;// ./src/components/PaymentMethods/PaymentMethods.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var PaymentMethods_PaymentMethodsvue_type_script_lang_ts_external = (PaymentMethodsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/PaymentMethods/PaymentMethods.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  PaymentMethods_PaymentMethodsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PaymentMethods_PaymentMethods = (component.exports);

/***/ }),

/***/ 9033:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (India) [en-in]
//! author : Jatin Agrawal : https://github.com/jatinag22

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIn = moment.defineLocale('en-in', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return enIn;

})));


/***/ }),

/***/ 9048:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fal';
var iconName = 'cog';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f013';
var svgPathData = 'M482.696 299.276l-32.61-18.827a195.168 195.168 0 0 0 0-48.899l32.61-18.827c9.576-5.528 14.195-16.902 11.046-27.501-11.214-37.749-31.175-71.728-57.535-99.595-7.634-8.07-19.817-9.836-29.437-4.282l-32.562 18.798a194.125 194.125 0 0 0-42.339-24.48V38.049c0-11.13-7.652-20.804-18.484-23.367-37.644-8.909-77.118-8.91-114.77 0-10.831 2.563-18.484 12.236-18.484 23.367v37.614a194.101 194.101 0 0 0-42.339 24.48L105.23 81.345c-9.621-5.554-21.804-3.788-29.437 4.282-26.36 27.867-46.321 61.847-57.535 99.595-3.149 10.599 1.47 21.972 11.046 27.501l32.61 18.827a195.168 195.168 0 0 0 0 48.899l-32.61 18.827c-9.576 5.528-14.195 16.902-11.046 27.501 11.214 37.748 31.175 71.728 57.535 99.595 7.634 8.07 19.817 9.836 29.437 4.283l32.562-18.798a194.08 194.08 0 0 0 42.339 24.479v37.614c0 11.13 7.652 20.804 18.484 23.367 37.645 8.909 77.118 8.91 114.77 0 10.831-2.563 18.484-12.236 18.484-23.367v-37.614a194.138 194.138 0 0 0 42.339-24.479l32.562 18.798c9.62 5.554 21.803 3.788 29.437-4.283 26.36-27.867 46.321-61.847 57.535-99.595 3.149-10.599-1.47-21.972-11.046-27.501zm-65.479 100.461l-46.309-26.74c-26.988 23.071-36.559 28.876-71.039 41.059v53.479a217.145 217.145 0 0 1-87.738 0v-53.479c-33.621-11.879-43.355-17.395-71.039-41.059l-46.309 26.74c-19.71-22.09-34.689-47.989-43.929-75.958l46.329-26.74c-6.535-35.417-6.538-46.644 0-82.079l-46.329-26.74c9.24-27.969 24.22-53.869 43.929-75.969l46.309 26.76c27.377-23.434 37.063-29.065 71.039-41.069V44.464a216.79 216.79 0 0 1 87.738 0v53.479c33.978 12.005 43.665 17.637 71.039 41.069l46.309-26.76c19.709 22.099 34.689 47.999 43.929 75.969l-46.329 26.74c6.536 35.426 6.538 46.644 0 82.079l46.329 26.74c-9.24 27.968-24.219 53.868-43.929 75.957zM256 160c-52.935 0-96 43.065-96 96s43.065 96 96 96 96-43.065 96-96-43.065-96-96-96zm0 160c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.dB = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 9053:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Mongolian [mn]
//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 's':
                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
            case 'ss':
                return number + (withoutSuffix ? ' секунд' : ' секундын');
            case 'm':
            case 'mm':
                return number + (withoutSuffix ? ' минут' : ' минутын');
            case 'h':
            case 'hh':
                return number + (withoutSuffix ? ' цаг' : ' цагийн');
            case 'd':
            case 'dd':
                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
            case 'M':
            case 'MM':
                return number + (withoutSuffix ? ' сар' : ' сарын');
            case 'y':
            case 'yy':
                return number + (withoutSuffix ? ' жил' : ' жилийн');
            default:
                return number;
        }
    }

    var mn = moment.defineLocale('mn', {
        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
            '_'
        ),
        monthsShort:
            '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY оны MMMMын D',
            LLL: 'YYYY оны MMMMын D HH:mm',
            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
        },
        meridiemParse: /ҮӨ|ҮХ/i,
        isPM: function (input) {
            return input === 'ҮХ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ҮӨ';
            } else {
                return 'ҮХ';
            }
        },
        calendar: {
            sameDay: '[Өнөөдөр] LT',
            nextDay: '[Маргааш] LT',
            nextWeek: '[Ирэх] dddd LT',
            lastDay: '[Өчигдөр] LT',
            lastWeek: '[Өнгөрсөн] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s дараа',
            past: '%s өмнө',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + ' өдөр';
                default:
                    return number;
            }
        },
    });

    return mn;

})));


/***/ }),

/***/ 9077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  uA: function() { return /* reexport */ vue_class_component_esm/* default */.Ay; },
  O5: function() { return /* reexport */ Emit; },
  y_: function() { return /* reexport */ Inject; },
  Xe: function() { return /* reexport */ vue_class_component_esm/* mixins */.vE; },
  kv: function() { return /* reexport */ Prop; },
  ku: function() { return /* reexport */ Provide; },
  lD: function() { return /* reexport */ (external_vue_default()); },
  ox: function() { return /* reexport */ Watch; }
});

// UNUSED EXPORTS: InjectReactive, Model, ModelSync, PropSync, ProvideReactive, Ref, VModel

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(622);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
// EXTERNAL MODULE: ./node_modules/vue-class-component/dist/vue-class-component.esm.js
var vue_class_component_esm = __webpack_require__(6599);
;// ./node_modules/vue-property-decorator/lib/decorators/Emit.js
var __spreadArrays = (undefined && undefined.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
// Code copied from Vue/src/shared/util.js
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = function (str) { return str.replace(hyphenateRE, '-$1').toLowerCase(); };
/**
 * decorator of an event-emitter function
 * @param  event The name of the event
 * @return MethodDecorator
 */
function Emit(event) {
    return function (_target, propertyKey, descriptor) {
        var key = hyphenate(propertyKey);
        var original = descriptor.value;
        descriptor.value = function emitter() {
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var emit = function (returnValue) {
                var emitName = event || key;
                if (returnValue === undefined) {
                    if (args.length === 0) {
                        _this.$emit(emitName);
                    }
                    else if (args.length === 1) {
                        _this.$emit(emitName, args[0]);
                    }
                    else {
                        _this.$emit.apply(_this, __spreadArrays([emitName], args));
                    }
                }
                else {
                    args.unshift(returnValue);
                    _this.$emit.apply(_this, __spreadArrays([emitName], args));
                }
            };
            var returnValue = original.apply(this, args);
            if (isPromise(returnValue)) {
                returnValue.then(emit);
            }
            else {
                emit(returnValue);
            }
            return returnValue;
        };
    };
}
function isPromise(obj) {
    return obj instanceof Promise || (obj && typeof obj.then === 'function');
}

;// ./node_modules/vue-property-decorator/lib/decorators/Inject.js

/**
 * decorator of an inject
 * @param from key
 * @return PropertyDecorator
 */
function Inject(options) {
    return (0,vue_class_component_esm/* createDecorator */.u1)(function (componentOptions, key) {
        if (typeof componentOptions.inject === 'undefined') {
            componentOptions.inject = {};
        }
        if (!Array.isArray(componentOptions.inject)) {
            componentOptions.inject[key] = options || key;
        }
    });
}

;// ./node_modules/vue-property-decorator/lib/helpers/metadata.js
/** @see {@link https://github.com/vuejs/vue-class-component/blob/master/src/reflect.ts} */
var reflectMetadataIsSupported = typeof Reflect !== 'undefined' && typeof Reflect.getMetadata !== 'undefined';
function metadata_applyMetadata(options, target, key) {
    if (reflectMetadataIsSupported) {
        if (!Array.isArray(options) &&
            typeof options !== 'function' &&
            !options.hasOwnProperty('type') &&
            typeof options.type === 'undefined') {
            var type = Reflect.getMetadata('design:type', target, key);
            if (type !== Object) {
                options.type = type;
            }
        }
    }
}

;// ./node_modules/vue-property-decorator/lib/decorators/Model.js


/**
 * decorator of model
 * @param  event event name
 * @param options options
 * @return PropertyDecorator
 */
function Model(event, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
            componentOptions.model = { prop: k, event: event || k };
        })(target, key);
    };
}

;// ./node_modules/vue-property-decorator/lib/decorators/ModelSync.js


/**
 * decorator of synced model and prop
 * @param propName the name to interface with from outside, must be different from decorated property
 * @param  event event name
 * @param options options
 * @return PropertyDecorator
 */
function ModelSync(propName, event, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[propName] = options;
            componentOptions.model = { prop: propName, event: event || k };
            (componentOptions.computed || (componentOptions.computed = {}))[k] = {
                get: function () {
                    return this[propName];
                },
                set: function (value) {
                    // @ts-ignore
                    this.$emit(event, value);
                },
            };
        })(target, key);
    };
}

;// ./node_modules/vue-property-decorator/lib/decorators/Prop.js


/**
 * decorator of a prop
 * @param  options the options for the prop
 * @return PropertyDecorator | void
 */
function Prop(options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        metadata_applyMetadata(options, target, key);
        (0,vue_class_component_esm/* createDecorator */.u1)(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
        })(target, key);
    };
}

;// ./node_modules/vue-property-decorator/lib/decorators/PropSync.js


/**
 * decorator of a synced prop
 * @param propName the name to interface with from outside, must be different from decorated property
 * @param options the options for the synced prop
 * @return PropertyDecorator | void
 */
function PropSync(propName, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[propName] = options;
            (componentOptions.computed || (componentOptions.computed = {}))[k] = {
                get: function () {
                    return this[propName];
                },
                set: function (value) {
                    this.$emit("update:" + propName, value);
                },
            };
        })(target, key);
    };
}

;// ./node_modules/vue-property-decorator/lib/helpers/provideInject.js
function needToProduceProvide(original) {
    return (typeof original !== 'function' ||
        (!original.managed && !original.managedReactive));
}
function produceProvide(original) {
    var provide = function () {
        var _this = this;
        var rv = typeof original === 'function' ? original.call(this) : original;
        rv = Object.create(rv || null);
        // set reactive services (propagates previous services if necessary)
        rv[reactiveInjectKey] = Object.create(this[reactiveInjectKey] || {});
        for (var i in provide.managed) {
            rv[provide.managed[i]] = this[i];
        }
        var _loop_1 = function (i) {
            rv[provide.managedReactive[i]] = this_1[i]; // Duplicates the behavior of `@Provide`
            Object.defineProperty(rv[reactiveInjectKey], provide.managedReactive[i], {
                enumerable: true,
                configurable: true,
                get: function () { return _this[i]; },
            });
        };
        var this_1 = this;
        for (var i in provide.managedReactive) {
            _loop_1(i);
        }
        return rv;
    };
    provide.managed = {};
    provide.managedReactive = {};
    return provide;
}
/** Used for keying reactive provide/inject properties */
var reactiveInjectKey = '__reactiveInject__';
function inheritInjected(componentOptions) {
    // inject parent reactive services (if any)
    if (!Array.isArray(componentOptions.inject)) {
        componentOptions.inject = componentOptions.inject || {};
        componentOptions.inject[reactiveInjectKey] = {
            from: reactiveInjectKey,
            default: {},
        };
    }
}

;// ./node_modules/vue-property-decorator/lib/decorators/Provide.js


/**
 * decorator of a provide
 * @param key key
 * @return PropertyDecorator | void
 */
function Provide(key) {
    return (0,vue_class_component_esm/* createDecorator */.u1)(function (componentOptions, k) {
        var provide = componentOptions.provide;
        inheritInjected(componentOptions);
        if (needToProduceProvide(provide)) {
            provide = componentOptions.provide = produceProvide(provide);
        }
        provide.managed[k] = key || k;
    });
}

;// ./node_modules/vue-property-decorator/lib/decorators/Watch.js

/**
 * decorator of a watch function
 * @param  path the path or the expression to observe
 * @param  WatchOption
 * @return MethodDecorator
 */
function Watch(path, options) {
    if (options === void 0) { options = {}; }
    var _a = options.deep, deep = _a === void 0 ? false : _a, _b = options.immediate, immediate = _b === void 0 ? false : _b;
    return (0,vue_class_component_esm/* createDecorator */.u1)(function (componentOptions, handler) {
        if (typeof componentOptions.watch !== 'object') {
            componentOptions.watch = Object.create(null);
        }
        var watch = componentOptions.watch;
        if (typeof watch[path] === 'object' && !Array.isArray(watch[path])) {
            watch[path] = [watch[path]];
        }
        else if (typeof watch[path] === 'undefined') {
            watch[path] = [];
        }
        watch[path].push({ handler: handler, deep: deep, immediate: immediate });
    });
}

;// ./node_modules/vue-property-decorator/lib/index.js
/** vue-property-decorator verson 9.1.2 MIT LICENSE copyright 2020 kaorun343 */
/// <reference types='reflect-metadata'/>

















/***/ }),

/***/ 9209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ HistoricList_HistoricList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/HistoricList/HistoricList.vue?vue&type=template&id=6eec9c4a
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-table',{attrs:{"columns":_vm.columns,"url":"/historic","ajaxDatas":_vm.ajaxDatas,"filters":_vm.filters,"movableColumn":false,"hideable":false,"searchable":false,"sortIndex":0,"sortOrder":"desc","onlyTopFilters":"","stateKey":"historics"}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(8399);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/HistoricList/HistoricList.ts?vue&type=script&lang=ts&external




var HistoricList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(HistoricList, _super);
    function HistoricList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HistoricList.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadTeamUsers()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(HistoricList.prototype, "ajaxDatas", {
        // Return ajax params
        get: function () {
            var data = {
                include: 'team_user'
            };
            if (this.type || this.id) {
                data.filter = {
                    model: [
                        {}
                    ]
                };
                if (this.type) {
                    data.filter.model[0].type = this.type;
                }
                if (this.id) {
                    data.filter.model[0].id = this.id;
                }
            }
            return data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HistoricList.prototype, "filters", {
        // Return table filters
        get: function () {
            if (this.withFilters === false) {
                return null;
            }
            var filters = [
                {
                    type: 'period',
                    label: this.$t('interface.historics.date'),
                    name: 'min_date',
                    name2: 'max_date'
                },
                {
                    type: 'select',
                    label: this.$t('interface.historics.user'),
                    name: 'user',
                    options: this.teamUsers,
                    multiple: true,
                    optionLabel: 'fullname',
                    value: 'id'
                }
            ];
            if (this.$kwInterface.historicsList && this.$kwInterface.historicsList.filters) {
                filters.push.apply(filters, this.$kwInterface.historicsList.filters);
            }
            return filters;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HistoricList.prototype, "columns", {
        get: function () {
            var columns = [
                {
                    data: 'date',
                    name: this.$t('interface.historics.date'),
                    render: 'datetime'
                },
                {
                    data: 'message',
                    name: this.$t('interface.historics.action'),
                    sortable: false
                },
                {
                    data: 'team_user.fullname',
                    name: this.$t('interface.historics.user'),
                    sortable: false
                }
            ];
            if (this.$kwInterface.historicsList && this.$kwInterface.historicsList.columns) {
                columns.push.apply(columns, this.$kwInterface.historicsList.columns);
            }
            return columns;
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], HistoricList.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], HistoricList.prototype, "id", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], HistoricList.prototype, "withFilters", void 0);
    HistoricList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('globalDatas', ['teamUsers'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadTeamUsers'])),
            components: {
                KTable: table_vue_.KTable
            }
        })
    ], HistoricList);
    return HistoricList;
}(lib/* Vue */.lD));
/* harmony default export */ var HistoricListvue_type_script_lang_ts_external = (HistoricList);

;// ./src/components/HistoricList/HistoricList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var HistoricList_HistoricListvue_type_script_lang_ts_external = (HistoricListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/HistoricList/HistoricList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  HistoricList_HistoricListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var HistoricList_HistoricList = (component.exports);

/***/ }),

/***/ 9219:
/***/ (function(module) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ 9231:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tlPh = moment.defineLocale('tl-ph', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlPh;

})));


/***/ }),

/***/ 9256:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ AppColors_AppColors; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AppColors/AppColors.vue?vue&type=template&id=5691f051
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form',{attrs:{"method":"PUT","action":_vm.formAction},on:{"submitComplete":_vm.formSubmitted}},[_vm._l((_vm.availableColors),function(part,i){return _c('div',{key:i},[_c('h3',{class:{
      'form-title-alt': true,
      'mt-0': i === 0
    }},[_vm._v(" "+_vm._s(part.label)+" ")]),_c('b-row',_vm._l((part.colors),function(label,key){return _c('b-col',{key:key,attrs:{"cols":"3"}},[_c('b-form-group',{attrs:{"label":label}},[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"pr-0",attrs:{"cols":"auto"}},[_c('k-form-input',{staticClass:"d-inline-block",staticStyle:{"min-width":"50px"},attrs:{"type":"color","name":'configs[app_color_' + key + ']'},on:{"input":val => _vm.applyColor(key, val)},model:{value:(_vm.colors[key]),callback:function ($$v) {_vm.$set(_vm.colors, key, $$v)},expression:"colors[key]"}})],1),_c('b-col',[(!_vm.isSameColor(key))?_c('font-awesome-icon',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: 'Réinitialiser' }),expression:"{ title: 'Réinitialiser' }"}],staticClass:"text-danger",attrs:{"icon":['fas', 'times']},on:{"click":function($event){$event.preventDefault();return _vm.resetColor(key)}}}):_vm._e()],1)],1)],1)],1)}),1)],1)}),_c('p',{staticClass:"mb-5"}),_c('k-form-sticky-bar',{attrs:{"parent":"#page"}},[_c('b-button',{attrs:{"variant":"secondary"},on:{"click":function($event){$event.preventDefault();return _vm.loadColors.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('interface.cancel'))+" ")]),_c('b-button',{staticClass:"ml-4",attrs:{"type":"submit","variant":"primary"}},[_vm._v(" "+_vm._s(_vm.$t('interface.save'))+" ")])],1)],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: ./node_modules/lodash/forEach.js
var forEach = __webpack_require__(9754);
var forEach_default = /*#__PURE__*/__webpack_require__.n(forEach);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(9356);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: ./src/mixins/TeamConfigMixin.ts
var TeamConfigMixin = __webpack_require__(2399);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/AppColors/AppColors.ts?vue&type=script&lang=ts&external








var AppColors = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(AppColors, _super);
    function AppColors() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.colors = {};
        return _this;
    }
    Object.defineProperty(AppColors.prototype, "availableColors", {
        get: function () {
            return [
                {
                    label: this.$t('interface.customize.color.main'),
                    colors: {
                        body_bg: this.$t('interface.customize.color.background'),
                        body_color: this.$t('interface.customize.color.color'),
                        card_bg: this.$t('interface.customize.color.cardBackground'),
                        card_color: this.$t('interface.customize.color.cardColor')
                    }
                },
                {
                    label: this.$t('interface.customize.color.sidebar'),
                    colors: {
                        sidebar_bg: this.$t('interface.customize.color.background'),
                        sidebar_color: this.$t('interface.customize.color.color'),
                        sidebar_menu_hover_bg: this.$t('interface.customize.color.sidebarMenuBackground'),
                        sidebar_menu_hover_color: this.$t('interface.customize.color.sidebarMenuColor'),
                        sidebar_group_active_bg: this.$t('interface.customize.color.sidebarGroupBackground'),
                        sidebar_group_active_color: this.$t('interface.customize.color.sidebarGroupColor'),
                        sidebar_element_active_bg: this.$t('interface.customize.color.sidebarElementBackground'),
                        sidebar_element_active_color: this.$t('interface.customize.color.sidebarElementColor')
                    }
                },
                {
                    label: this.$t('interface.customize.color.sidebarConfig'),
                    colors: {
                        configuration_sidebar_bg: this.$t('interface.customize.color.background'),
                        configuration_sidebar_color: this.$t('interface.customize.color.color')
                    }
                },
                {
                    label: this.$t('interface.customize.color.header'),
                    colors: {
                        header_bg: this.$t('interface.customize.color.background'),
                        header_color: this.$t('interface.customize.color.color'),
                        header_menu_color: this.$t('interface.customize.color.headerMenuColor'),
                        header_menu_hover_color: this.$t('interface.customize.color.headerMenuHoverColor'),
                        header_menu_active_color: this.$t('interface.customize.color.headerMenuActiveColor'),
                        header_dropdown_hover_color: this.$t('interface.customize.color.headerDropdownHoverColor'),
                        header_dropdown_hover_bg: this.$t('interface.customize.color.headerDropdownHoverBackground')
                    }
                },
                {
                    label: this.$t('interface.customize.color.link'),
                    colors: {
                        primary: this.$t('interface.customize.color.linkPrimary'),
                        btn_primary_color: this.$t('interface.customize.color.linkBtnPrimaryColor'),
                        btn_primary_hover: this.$t('interface.customize.color.linkBtnPrimaryHover'),
                        btn_primary_color_hover: this.$t('interface.customize.color.linkBtnPrimaryColorHover'),
                        secondary: this.$t('interface.customize.color.linkSecondary'),
                        btn_secondary_color: this.$t('interface.customize.color.linkBtnSecondaryColor'),
                        btn_secondary_hover: this.$t('interface.customize.color.linkBtnSecondaryHover'),
                        btn_secondary_color_hover: this.$t('interface.customize.color.linkBtnSecondaryColorHover'),
                        light: this.$t('interface.customize.color.linkLight'),
                        btn_light_color: this.$t('interface.customize.color.linkBtnLightColor'),
                        btn_light_hover: this.$t('interface.customize.color.linkBtnLightHover'),
                        btn_light_color_hover: this.$t('interface.customize.color.linkBtnLightColorHover'),
                        link_color: this.$t('interface.customize.color.linkLinkColor'),
                        link_color_hover: this.$t('interface.customize.color.linkLinkColorHover')
                    }
                },
                {
                    label: this.$t('interface.customize.color.table'),
                    colors: {
                        table_bg: this.$t('interface.customize.color.background'),
                        table_color: this.$t('interface.customize.color.color'),
                        table_hover_bg: this.$t('interface.customize.color.tableHoverBackgroudn'),
                        table_hover_color: this.$t('interface.customize.color.tableHoverColor')
                    }
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    AppColors.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                this.loadColors();
                return [2 /*return*/];
            });
        });
    };
    AppColors.prototype.beforeDestroy = function () {
        this.setLocalTeamConfigs(this.teamConfigs);
        this.loadColors();
        this.applyAllColors();
    };
    Object.defineProperty(AppColors.prototype, "color", {
        get: function () {
            var _this = this;
            var _a;
            var valueColors = ((_a = this.colors) !== null && _a !== void 0 ? _a : {});
            return function (key) {
                var _a;
                return (_a = valueColors[key]) !== null && _a !== void 0 ? _a : _this.defaultColors(key);
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AppColors.prototype, "defaultColors", {
        get: function () {
            var _a;
            var appColors = ((_a = this.app.colors) !== null && _a !== void 0 ? _a : {});
            return function (key) {
                return appColors[key];
            };
        },
        enumerable: false,
        configurable: true
    });
    AppColors.prototype.loadColors = function () {
        var _this = this;
        var appColors = {};
        forEach_default()(this.localConfig, function (config, key) {
            if (key.substr(0, 10) === 'app_color_') {
                var newKey = key.substr(10);
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                appColors[newKey] = config !== null && config !== void 0 ? config : _this.defaultColors((newKey));
            }
        });
        this.colors = appColors;
        this.applyAllColors();
    };
    AppColors.prototype.applyColor = function (key, color) {
        document.documentElement.style.setProperty('--' + key.replaceAll('_', '-'), color);
    };
    AppColors.prototype.resetColor = function (key) {
        var color = this.defaultColors(key);
        lib/* Vue */.lD.set(this.colors, key, color);
        this.applyColor(key, color);
    };
    AppColors.prototype.applyAllColors = function () {
        var _this = this;
        forEach_default()(this.availableColors, function (parts) {
            forEach_default()(parts.colors, function (color, key) { return _this.applyColor(key, _this.color(key)); });
        });
    };
    AppColors.prototype.isSameColor = function (key) {
        var app = this.defaultColors(key);
        var color = this.color(key);
        return !app || !color || app.toLowerCase() === color.toLowerCase();
    };
    AppColors = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('app', ['app'])),
            components: {
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormStickyBar: form_vue_.KFormStickyBar,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BAlert: external_bootstrap_vue_.BAlert, BButton: external_bootstrap_vue_.BButton, BTabs: external_bootstrap_vue_.BTabs, BTab: external_bootstrap_vue_.BTab,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], AppColors);
    return AppColors;
}((0,lib/* Mixins */.Xe)(TeamConfigMixin/* default */.A)));
/* harmony default export */ var AppColorsvue_type_script_lang_ts_external = (AppColors);

;// ./src/components/AppColors/AppColors.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var AppColors_AppColorsvue_type_script_lang_ts_external = (AppColorsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/AppColors/AppColors.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  AppColors_AppColorsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AppColors_AppColors = (component.exports);

/***/ }),

/***/ 9282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ TeamInfos_TeamInfos; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TeamInfos/TeamInfos.vue?vue&type=template&id=51485c64
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form',{staticStyle:{"max-width":"1200px"},attrs:{"action":_vm.formAction,"method":"put"},on:{"submitComplete":_vm.formSubmitted}},[_c('b-card',[_c('b-form-group',{attrs:{"label":_vm.$t('interface.team.companyName'),"label-for":"company_name"}},[_c('k-form-input',{attrs:{"name":"company_name","id":"company_name","required":""},model:{value:(_vm.localTeam.company_name),callback:function ($$v) {_vm.$set(_vm.localTeam, "company_name", $$v)},expression:"localTeam.company_name"}})],1),_c('h3',{staticClass:"form-title"},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'map-signs']}}),_vm._v(" "+_vm._s(_vm.$t('interface.team.addressTitle'))+" ")],1),_c('k-form-address',{attrs:{"prefix-name":"","countries-list":_vm.countries,"required":"","road-required":"","with-road3":""},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}}),_c('h3',{staticClass:"form-title"},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'id-card']}}),_vm._v(" "+_vm._s(_vm.$t('interface.team.coordinatesTitle'))+" ")],1),_c('b-form-row',[_c('b-col',{attrs:{"sm":"12","md":"6","lg":"4"}},[_c('b-form-group',{attrs:{"label":_vm.$t('interface.team.phone'),"label-for":"phone"}},[_c('k-form-phone',{attrs:{"name":"phone","id":"phone"},model:{value:(_vm.localTeam.phone),callback:function ($$v) {_vm.$set(_vm.localTeam, "phone", $$v)},expression:"localTeam.phone"}})],1)],1),_c('b-col',{attrs:{"sm":"12","md":"6","lg":"4"}},[_c('b-form-group',{attrs:{"label":_vm.$t('interface.team.mobile'),"label-for":"mobile"}},[_c('k-form-phone',{attrs:{"name":"mobile","id":"mobile","placeholderNumberType":"MOBILE"},model:{value:(_vm.localTeam.mobile),callback:function ($$v) {_vm.$set(_vm.localTeam, "mobile", $$v)},expression:"localTeam.mobile"}})],1)],1),_c('b-col',{attrs:{"sm":"12","md":"6","lg":"4"}},[_c('b-form-group',{attrs:{"label":_vm.$t('interface.team.fax'),"label-for":"fax"}},[_c('k-form-phone',{attrs:{"name":"fax","id":"fax"},model:{value:(_vm.localTeam.fax),callback:function ($$v) {_vm.$set(_vm.localTeam, "fax", $$v)},expression:"localTeam.fax"}})],1)],1),_c('b-col',{attrs:{"sm":"12","md":"6"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.$t('interface.team.email'),"label-for":"email"}},[_c('k-form-input',{attrs:{"type":"email","name":"email","id":"email"},model:{value:(_vm.localTeam.email),callback:function ($$v) {_vm.$set(_vm.localTeam, "email", $$v)},expression:"localTeam.email"}})],1)],1),_c('b-col',{attrs:{"sm":"12","md":"6"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.$t('interface.team.website'),"label-for":"website"}},[_c('k-form-input',{attrs:{"name":"website","id":"website","validate":"url"},model:{value:(_vm.localTeam.website),callback:function ($$v) {_vm.$set(_vm.localTeam, "website", $$v)},expression:"localTeam.website"}})],1)],1)],1),_c('h3',{staticClass:"form-title"},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'info-circle']}}),_vm._v(" "+_vm._s(_vm.$t('interface.team.companyInfosTitle'))+" ")],1),_c('b-form-row',[_c('b-col',{attrs:{"sm":"12","md":"6","lg":"4"}},[_c('b-form-group',{attrs:{"label":_vm.$t('interface.team.companyType'),"label-for":"company_type"}},[_c('k-form-input',{attrs:{"name":"company_type","id":"company_type"},model:{value:(_vm.localTeam.company_type),callback:function ($$v) {_vm.$set(_vm.localTeam, "company_type", $$v)},expression:"localTeam.company_type"}})],1)],1),_c('b-col',{attrs:{"sm":"12","md":"6","lg":"4"}},[_c('b-form-group',{attrs:{"label":_vm.$t('interface.team.companySiret'),"label-for":"company_siret"}},[_c('k-form-input',{attrs:{"name":"company_siret","id":"company_siret"},model:{value:(_vm.localTeam.company_siret),callback:function ($$v) {_vm.$set(_vm.localTeam, "company_siret", $$v)},expression:"localTeam.company_siret"}})],1)],1),_c('b-col',{attrs:{"sm":"12","md":"6","lg":"4"}},[_c('b-form-group',{attrs:{"label":_vm.$t('interface.team.companyRcs'),"label-for":"company_rcs"}},[_c('k-form-input',{attrs:{"name":"company_rcs","id":"company_rcs"},model:{value:(_vm.localTeam.company_rcs),callback:function ($$v) {_vm.$set(_vm.localTeam, "company_rcs", $$v)},expression:"localTeam.company_rcs"}})],1)],1),_c('b-col',{attrs:{"sm":"12","md":"6","lg":"4"}},[_c('b-form-group',{attrs:{"label":_vm.$t('interface.team.companyVatRate'),"label-for":"company_vatrate"}},[_c('k-form-input',{attrs:{"name":"company_vatrate","id":"company_vatrate"},model:{value:(_vm.localTeam.company_vatrate),callback:function ($$v) {_vm.$set(_vm.localTeam, "company_vatrate", $$v)},expression:"localTeam.company_vatrate"}})],1)],1),_c('b-col',{attrs:{"sm":"12","md":"6","lg":"4"}},[_c('b-form-group',{attrs:{"label":_vm.$t('interface.team.companyNaf'),"label-for":"company_naf"}},[_c('k-form-input',{attrs:{"name":"company_naf","id":"company_naf"},model:{value:(_vm.localTeam.company_naf),callback:function ($$v) {_vm.$set(_vm.localTeam, "company_naf", $$v)},expression:"localTeam.company_naf"}})],1)],1),_c('b-col',{attrs:{"sm":"12","md":"6","lg":"4"}},[_c('b-form-group',{attrs:{"label":_vm.$t('interface.team.companyCapital'),"label-for":"company_capital"}},[_c('k-form-input',{attrs:{"name":"company_capital","id":"company_capital"},model:{value:(_vm.localTeam.company_capital),callback:function ($$v) {_vm.$set(_vm.localTeam, "company_capital", $$v)},expression:"localTeam.company_capital"}})],1)],1)],1)],1),_c('k-form-sticky-bar',{staticClass:"text-center mt-3",attrs:{"parent":"#page"}},[_c('b-button',{staticClass:"mr-4",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('interface.cancel')))]),_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_vm._v(_vm._s(_vm.$t('interface.save')))])],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: ./src/mixins/TeamFormMixin.ts
var TeamFormMixin = __webpack_require__(2783);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(9356);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/TeamInfos/TeamInfos.ts?vue&type=script&lang=ts&external







var TeamInfos = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TeamInfos, _super);
    function TeamInfos() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.address = {
            road1: null,
            road2: null,
            road3: null,
            postal_code: null,
            town: null,
            country: null
        };
        return _this;
    }
    TeamInfos.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setLocalTeam(this.team);
                        return [4 /*yield*/, this.loadCountries()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TeamInfos.prototype.setAddress = function () {
        var team = this.localTeam;
        var country = team.country;
        this.address = {
            road1: team.road1,
            road2: team.road2,
            road3: team.road3,
            postal_code: team.postal_code,
            town: team.town,
            country: country !== null && country !== void 0 ? country : null
        };
    };
    TeamInfos.prototype.addressUpdated = function () {
        var team = this.localTeam;
        var address = this.address;
        team.road1 = address.road1;
        team.road2 = address.road2;
        team.road3 = address.road3;
        team.postal_code = address.postal_code;
        team.town = address.town;
        team.country = address.country;
    };
    TeamInfos.prototype.setLocalTeam = function (team) {
        this.localTeam = JSON.parse(JSON.stringify(team));
        this.setAddress();
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('address')
    ], TeamInfos.prototype, "addressUpdated", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('team')
    ], TeamInfos.prototype, "setLocalTeam", null);
    TeamInfos = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('globalDatas', ['countries'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadCountries'])),
            components: {
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormAddress: form_vue_.KFormAddress, KFormPhone: form_vue_.KFormPhone, KFormStickyBar: form_vue_.KFormStickyBar,
                BCard: external_bootstrap_vue_.BCard, BFormGroup: external_bootstrap_vue_.BFormGroup, BFormRow: external_bootstrap_vue_.BFormRow, BCol: external_bootstrap_vue_.BCol, BButton: external_bootstrap_vue_.BButton
            }
        })
    ], TeamInfos);
    return TeamInfos;
}((0,lib/* Mixins */.Xe)(TeamFormMixin/* default */.A)));
/* harmony default export */ var TeamInfosvue_type_script_lang_ts_external = (TeamInfos);

;// ./src/components/TeamInfos/TeamInfos.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var TeamInfos_TeamInfosvue_type_script_lang_ts_external = (TeamInfosvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/TeamInfos/TeamInfos.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  TeamInfos_TeamInfosvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TeamInfos_TeamInfos = (component.exports);

/***/ }),

/***/ 9302:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(3488),
    overRest = __webpack_require__(6757),
    setToString = __webpack_require__(2865);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ 9325:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(4840);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 9326:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(1769),
    isArguments = __webpack_require__(2428),
    isArray = __webpack_require__(6449),
    isIndex = __webpack_require__(361),
    isLength = __webpack_require__(294),
    toKey = __webpack_require__(7797);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),

/***/ 9330:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Occitan, lengadocian dialecte [oc-lnc]
//! author : Quentin PAGÈS : https://github.com/Quenty31

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ocLnc = moment.defineLocale('oc-lnc', {
        months: {
            standalone:
                'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
                    '_'
                ),
            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort:
            'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
            '_'
        ),
        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: '[uèi a] LT',
            nextDay: '[deman a] LT',
            nextWeek: 'dddd [a] LT',
            lastDay: '[ièr a] LT',
            lastWeek: 'dddd [passat a] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'unas segondas',
            ss: '%d segondas',
            m: 'una minuta',
            mm: '%d minutas',
            h: 'una ora',
            hh: '%d oras',
            d: 'un jorn',
            dd: '%d jorns',
            M: 'un mes',
            MM: '%d meses',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                      ? 'n'
                      : number === 3
                        ? 'r'
                        : number === 4
                          ? 't'
                          : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4,
        },
    });

    return ocLnc;

})));


/***/ }),

/***/ 9344:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(3805);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),

/***/ 9350:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 9356:
/***/ (function(module) {

"use strict";
module.exports = require("@fortawesome/vue-fontawesome");

/***/ }),

/***/ 9371:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'print';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f02f';
var svgPathData = 'M448 192V77.25c0-8.49-3.37-16.62-9.37-22.63L393.37 9.37c-6-6-14.14-9.37-22.63-9.37H96C78.33 0 64 14.33 64 32v160c-35.35 0-64 28.65-64 64v112c0 8.84 7.16 16 16 16h48v96c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-96h48c8.84 0 16-7.16 16-16V256c0-35.35-28.65-64-64-64zm-64 256H128v-96h256v96zm0-224H128V64h192v48c0 8.84 7.16 16 16 16h48v96zm48 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.Jx = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 9374:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nokkrar sekúndur'
                    : 'nokkrum sekúndum';
            case 'ss':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
                    );
                }
                return result + 'sekúnda';
            case 'm':
                return withoutSuffix ? 'mínúta' : 'mínútu';
            case 'mm':
                if (plural(number)) {
                    return (
                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
                    );
                } else if (withoutSuffix) {
                    return result + 'mínúta';
                }
                return result + 'mínútu';
            case 'hh':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture
                            ? 'klukkustundir'
                            : 'klukkustundum')
                    );
                }
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) {
                    return 'dagur';
                }
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'dagar';
                    }
                    return result + (isFuture ? 'daga' : 'dögum');
                } else if (withoutSuffix) {
                    return result + 'dagur';
                }
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) {
                    return 'mánuður';
                }
                return isFuture ? 'mánuð' : 'mánuði';
            case 'MM':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'mánuðir';
                    }
                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                } else if (withoutSuffix) {
                    return result + 'mánuður';
                }
                return result + (isFuture ? 'mánuð' : 'mánuði');
            case 'y':
                return withoutSuffix || isFuture ? 'ár' : 'ári';
            case 'yy':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                }
                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    var is = moment.defineLocale('is', {
        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
        weekdays:
            'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
                '_'
            ),
        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
        },
        calendar: {
            sameDay: '[í dag kl.] LT',
            nextDay: '[á morgun kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[í gær kl.] LT',
            lastWeek: '[síðasta] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'eftir %s',
            past: 'fyrir %s síðan',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: 'klukkustund',
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return is;

})));


/***/ }),

/***/ 9402:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enNz = moment.defineLocale('en-nz', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enNz;

})));


/***/ }),

/***/ 9442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ UserInvitation_UserInvitation; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserInvitation/UserInvitation.vue?vue&type=template&id=0d7c9350
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h1',{staticClass:"text-center mb-4"},[_vm._v(" "+_vm._s(_vm.$t('interface.userInvitation.rightToAccount'))+" "+_vm._s(_vm.invitation.team)+" ")]),(_vm.invitation.status === 'logout')?_c('div',{staticClass:"text-center"},[_c('p',[_vm._v(" "+_vm._s(_vm.$t('interface.userInvitation.canManage', { team: _vm.invitation.team }))+" ")]),_c('Disconnect',{attrs:{"variant":"primary","redirectAfterLogout":false},on:{"logout":_vm.disconnected}})],1):(_vm.invitation.status === 'register')?_c('b-card',{staticClass:"register-form"},[_c('p',{staticClass:"text-center mb-4"},[_vm._v(" "+_vm._s(_vm.$t('interface.userInvitation.needRegister', { team: _vm.invitation.team }))+" ")]),_c('k-form',{attrs:{"action":_vm.invitationUrl + '/register'},on:{"submitComplete":_vm.registerComplete}},[_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":_vm.$t('interface.userInvitation.firstname')}},[_c('k-form-input',{attrs:{"name":"firstname","required":""}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":_vm.$t('interface.userInvitation.lastname')}},[_c('k-form-input',{attrs:{"name":"lastname","required":""}})],1)],1)],1),_c('b-row',[_c('b-col',[_c('b-form-group',{staticClass:"pt-2",attrs:{"label":_vm.$t('interface.userInvitation.email')}},[_vm._v(" "+_vm._s(_vm.invitation.email)+" ")])],1),_c('b-col',[_c('b-form-group',{attrs:{"label":_vm.$t('interface.userInvitation.password')}},[_c('k-form-input',{attrs:{"type":"password","name":"password","required":""}})],1)],1)],1),_c('p',{staticClass:"text-center mt-3 mb-0"},[_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_vm._v(" "+_vm._s(_vm.$t('interface.userInvitation.createAccount'))+" ")])],1)],1)],1):(_vm.invitation.status === 'choice')?_c('b-card',{staticClass:"register-form text-center"},[_c('k-form',{ref:"form",attrs:{"action":_vm.invitationUrl + '/choice'},on:{"submitComplete":_vm.choiceComplete}},[_c('input',{attrs:{"type":"hidden","name":"status"},domProps:{"value":_vm.status}}),_c('p',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('interface.userInvitation.loggedUser'))+" "+_vm._s(_vm.user.fullname)+" ")]),_c('p',[_vm._v(" "+_vm._s(_vm.$t('interface.userInvitation.inAccept', { team: _vm.invitation.team }))+" ")]),_c('b-button',{staticClass:"mr-4",attrs:{"variant":"secondary"},on:{"click":function($event){$event.preventDefault();return _vm.choice(false)}}},[_vm._v(" "+_vm._s(_vm.$t('interface.userInvitation.deny'))+" ")]),_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.choice(true)}}},[_vm._v(" "+_vm._s(_vm.$t('interface.userInvitation.accept'))+" ")])],1)],1):_c('div',[_c('p',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.$t('interface.userInvitation.needLogin', { team: _vm.invitation.team }))+" ")]),_c('Login',{attrs:{"email":_vm.invitation.email,"readonlyEmail":"","redirectAfterLogin":false,"canCreateAccount":false,"showTitle":false},on:{"logged":_vm.logged}})],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: ./src/components/Disconnect/Disconnect.vue + 3 modules
var Disconnect = __webpack_require__(3497);
// EXTERNAL MODULE: ./src/components/Login/Login.vue + 3 modules
var Login = __webpack_require__(7033);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/UserInvitation/UserInvitation.ts?vue&type=script&lang=ts&external







var UserInvitation = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(UserInvitation, _super);
    function UserInvitation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.status = null;
        return _this;
    }
    Object.defineProperty(UserInvitation.prototype, "invitationUrl", {
        get: function () {
            return "/auth/invitation/" + this.invitation.token + "/" + this.invitation.hash;
        },
        enumerable: false,
        configurable: true
    });
    UserInvitation.prototype.logged = function () {
        this.invitation.status = 'choice';
    };
    UserInvitation.prototype.disconnected = function () {
        this.invitation.status = this.invitation.user_id ? 'auth' : 'register';
    };
    UserInvitation.prototype.registerComplete = function (response) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var data;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = response.data;
                        this.setToken(data.token);
                        this.setUser(data.user);
                        return [4 /*yield*/, this.redirect()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    UserInvitation.prototype.choice = function (state) {
        this.status = state;
        var form = this.$refs.form;
        form.submit();
    };
    UserInvitation.prototype.choiceComplete = function (response) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var data;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = response.data;
                        this.setUser(data.user);
                        return [4 /*yield*/, this.redirect()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    UserInvitation.prototype.redirect = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.$kwInterface.goToHome) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.$kwInterface.goToHome(this.$router, this.$store)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], UserInvitation.prototype, "invitation", void 0);
    UserInvitation = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('auth', ['setToken'])), (0,external_vuex_.mapActions)('user', ['setUser'])),
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('user', ['user'])),
            components: {
                BCard: external_bootstrap_vue_.BCard, BFormGroup: external_bootstrap_vue_.BFormGroup, BButton: external_bootstrap_vue_.BButton, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol,
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput,
                Disconnect: Disconnect/* default */.A, Login: Login/* default */.A
            }
        })
    ], UserInvitation);
    return UserInvitation;
}(lib/* Vue */.lD));
/* harmony default export */ var UserInvitationvue_type_script_lang_ts_external = (UserInvitation);

;// ./src/components/UserInvitation/UserInvitation.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var UserInvitation_UserInvitationvue_type_script_lang_ts_external = (UserInvitationvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/UserInvitation/UserInvitation.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  UserInvitation_UserInvitationvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var UserInvitation_UserInvitation = (component.exports);

/***/ }),

/***/ 9450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ NotificationsItem_NotificationsItem; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/NotificationsItem/NotificationsItem.vue?vue&type=template&id=6084c978
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{
    notification: true,
    unread: !_vm.value.read
  },on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')},"mouseenter":function($event){return _vm.$emit('mouseenter')},"mouseleave":function($event){return _vm.$emit('mouseleave')}}},[_c('div',{staticClass:"icon"},[(_vm.value.team_user)?_c('Avatar',{attrs:{"team-user":_vm.value.team_user}}):_c('font-awesome-icon',{style:({ color: _vm.value.icon_color ?? null }),attrs:{"icon":_vm.value.icon ?? ['fas', 'info-circle']}})],1),_c('div',{staticClass:"infos"},[_c('div',{staticClass:"datetime"},[_vm._v(" "+_vm._s(_vm.datetimeShow)+" ")]),(_vm.component)?[_c(_vm.component.component,{tag:"component",model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})]:(_vm.value.title || _vm.value.summary || _vm.value.content)?[(_vm.value.title)?_c('div',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.value.title)+" ")]):_vm._e(),(_vm.value.summary)?_c('div',{staticClass:"notification-summary"},[_vm._v(" "+_vm._s(_vm.value.summary)+" ")]):_vm._e(),(_vm.value.content)?_c('div',{staticClass:"notification-actions"},[_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){$event.preventDefault();_vm.showContent = true}}},[_vm._v(" Voir ")]),_c('b-modal',{attrs:{"title":_vm.value.title,"ok-only":"","ok-title":_vm.$t('interface.close'),"size":"lg"},on:{"hidden":_vm.contentHidden},model:{value:(_vm.showContent),callback:function ($$v) {_vm.showContent=$$v},expression:"showContent"}},[_c('FroalaView',{attrs:{"value":_vm.value.content}})],1)],1):_vm._e()]:_vm._e()],2),(!_vm.value.read)?_c('div',{staticClass:"state"},[(_vm.loading)?_c('Spinner',{staticClass:"p-0",attrs:{"size":"1"}}):_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.left",value:({ title: _vm.$t('interface.notifications.markAsRead') }),expression:"{ title: $t('interface.notifications.markAsRead') }",modifiers:{"left":true}}],staticClass:"p-0",attrs:{"variant":"link"},on:{"mouseenter":function($event){_vm.iconStyle = 'far'},"mouseleave":function($event){_vm.iconStyle = 'fas'},"click":function($event){$event.preventDefault();return _vm.markAsRead.apply(null, arguments)}}},[_c('font-awesome-icon',{attrs:{"icon":[_vm.iconStyle, 'circle']}})],1)],1):_vm._e()])
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-class-component/dist/vue-class-component.esm.js
var vue_class_component_esm = __webpack_require__(6599);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(9356);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: ./src/mixins/DateMixin.ts
var DateMixin = __webpack_require__(4774);
// EXTERNAL MODULE: ./src/components/Avatar/Avatar.vue + 3 modules
var Avatar = __webpack_require__(3072);
// EXTERNAL MODULE: ./src/components/Spinner/Spinner.vue + 3 modules
var Spinner = __webpack_require__(683);
// EXTERNAL MODULE: ./src/mitt.ts + 1 modules
var mitt = __webpack_require__(6912);
// EXTERNAL MODULE: ./src/utils/date.ts + 1 modules
var date = __webpack_require__(4755);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/NotificationsItem/NotificationsItem.ts?vue&type=script&lang=ts&external











var NotificationsItem = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(NotificationsItem, _super);
    function NotificationsItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.iconStyle = 'fas';
        _this.showContent = false;
        _this.datetimeShow = null;
        _this.interval = null;
        return _this;
    }
    NotificationsItem.prototype.mounted = function () {
        this.setDatetimeShow();
        if ((0,date/* moment */.n$)(this.value.created_at).isSame(new Date(), 'day')) {
            this.interval = setInterval(this.setDatetimeShow, 1000);
        }
    };
    NotificationsItem.prototype.beforeDestroy = function () {
        if (this.interval) {
            clearInterval(this.interval);
        }
    };
    NotificationsItem.prototype.setDatetimeShow = function () {
        var datetime = (0,date/* moment */.n$)(this.value.created_at);
        if (datetime.isSame(new Date(), 'day')) {
            this.datetimeShow = this.fromNow(this.value.created_at);
        }
        else {
            this.datetimeShow = datetime.format('HH:MM');
        }
    };
    Object.defineProperty(NotificationsItem.prototype, "component", {
        get: function () {
            var _this = this;
            var _a;
            return (_a = this.$kwInterface.notifications) === null || _a === void 0 ? void 0 : _a.components.find(function (component) {
                return ('element' in component && component.element === _this.value.element_type)
                    || ('action' in component && component.action === _this.value.action);
            });
        },
        enumerable: false,
        configurable: true
    });
    NotificationsItem.prototype.markAsRead = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.$kwInterface.axios.put('/notification/' + this.value.id + '/read')
                                .then(function (response) {
                                _this.$emit('input', response.data);
                                _this.loading = false;
                                mitt/* default */.A.emit('notificationUpdated', response.data);
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NotificationsItem.prototype.contentHidden = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.value.read) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.markAsRead()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], NotificationsItem.prototype, "value", void 0);
    NotificationsItem = (0,tslib_es6/* __decorate */.Cg)([
        (0,vue_class_component_esm/* default */.Ay)({
            components: {
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                Avatar: Avatar/* default */.A, Spinner: Spinner/* default */.A,
                BButton: external_bootstrap_vue_.BButton, BModal: external_bootstrap_vue_.BModal,
                FroalaView: form_vue_.FroalaView
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], NotificationsItem);
    return NotificationsItem;
}((0,lib/* Mixins */.Xe)(DateMixin/* default */.A)));
/* harmony default export */ var NotificationsItemvue_type_script_lang_ts_external = (NotificationsItem);

;// ./src/components/NotificationsItem/NotificationsItem.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var NotificationsItem_NotificationsItemvue_type_script_lang_ts_external = (NotificationsItemvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/NotificationsItem/NotificationsItem.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  NotificationsItem_NotificationsItemvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var NotificationsItem_NotificationsItem = (component.exports);

/***/ }),

/***/ 9467:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

;// external "@fortawesome/fontawesome-svg-core"
var fontawesome_svg_core_namespaceObject = require("@fortawesome/fontawesome-svg-core");
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-duotone-svg-icons/faSpinnerThird.js
var faSpinnerThird = __webpack_require__(5149);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faEdit.js
var faEdit = __webpack_require__(3966);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faTrash.js
var faTrash = __webpack_require__(1658);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faBars.js
var faBars = __webpack_require__(8857);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faCaretDown.js
var faCaretDown = __webpack_require__(92);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-light-svg-icons/faPlusCircle.js
var faPlusCircle = __webpack_require__(4151);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faPlusCircle.js
var pro_solid_svg_icons_faPlusCircle = __webpack_require__(6598);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faCircle.js
var faCircle = __webpack_require__(7583);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faCircle.js
var pro_solid_svg_icons_faCircle = __webpack_require__(5974);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faChevronRight.js
var faChevronRight = __webpack_require__(6777);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faChevronDown.js
var faChevronDown = __webpack_require__(935);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faCaretSquareLeft.js
var faCaretSquareLeft = __webpack_require__(3309);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faSearch.js
var faSearch = __webpack_require__(726);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faTimes.js
var faTimes = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faTimes.js
var pro_solid_svg_icons_faTimes = __webpack_require__(2986);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faMapSigns.js
var faMapSigns = __webpack_require__(8358);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faIdCard.js
var faIdCard = __webpack_require__(5837);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faInfoCircle.js
var faInfoCircle = __webpack_require__(3270);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faCalculatorAlt.js
var faCalculatorAlt = __webpack_require__(7935);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faCogs.js
var faCogs = __webpack_require__(3174);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faCalendarAlt.js
var faCalendarAlt = __webpack_require__(6041);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faUsersCog.js
var faUsersCog = __webpack_require__(5453);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faUsers.js
var faUsers = __webpack_require__(8540);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faShoppingCart.js
var faShoppingCart = __webpack_require__(1256);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faTags.js
var faTags = __webpack_require__(5891);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faFileImport.js
var faFileImport = __webpack_require__(8094);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faBuilding.js
var faBuilding = __webpack_require__(3530);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faHistory.js
var faHistory = __webpack_require__(8992);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faDownload.js
var faDownload = __webpack_require__(6614);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faArrowsV.js
var faArrowsV = __webpack_require__(8228);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faCheck.js
var faCheck = __webpack_require__(7352);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faEye.js
var faEye = __webpack_require__(4865);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faEyeSlash.js
var faEyeSlash = __webpack_require__(7312);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faBell.js
var faBell = __webpack_require__(1275);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faPalette.js
var faPalette = __webpack_require__(7619);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faCode.js
var faCode = __webpack_require__(5388);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-duotone-svg-icons/faFileImage.js
var faFileImage = __webpack_require__(1300);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-duotone-svg-icons/faFileAlt.js
var faFileAlt = __webpack_require__(8946);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-duotone-svg-icons/faFileWord.js
var faFileWord = __webpack_require__(5913);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-duotone-svg-icons/faFilePowerpoint.js
var faFilePowerpoint = __webpack_require__(4016);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-duotone-svg-icons/faFilePdf.js
var faFilePdf = __webpack_require__(4359);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-duotone-svg-icons/faFileExcel.js
var faFileExcel = __webpack_require__(3030);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-duotone-svg-icons/faFileCsv.js
var faFileCsv = __webpack_require__(8629);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-duotone-svg-icons/faFileArchive.js
var faFileArchive = __webpack_require__(2959);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-duotone-svg-icons/faFileAudio.js
var faFileAudio = __webpack_require__(1155);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-duotone-svg-icons/faFileVideo.js
var faFileVideo = __webpack_require__(8858);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faPrint.js
var faPrint = __webpack_require__(9371);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faFileDownload.js
var faFileDownload = __webpack_require__(6184);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faBroadcastTower.js
var faBroadcastTower = __webpack_require__(7798);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faKey.js
var faKey = __webpack_require__(1991);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-light-svg-icons/faCog.js
var faCog = __webpack_require__(9048);
;// ./src/fontawesome.ts




















































fontawesome_svg_core_namespaceObject.library.add(faEdit/* faEdit */.MT, faTrash/* faTrash */.yL, faSpinnerThird/* faSpinnerThird */.sq, faBars/* faBars */.ck, faCaretDown/* faCaretDown */.xB, faPlusCircle/* faPlusCircle */.OQ, pro_solid_svg_icons_faPlusCircle/* faPlusCircle */.OQ, faCircle/* faCircle */.GE, pro_solid_svg_icons_faCircle/* faCircle */.GE, faChevronRight/* faChevronRight */.Xk, faChevronDown/* faChevronDown */.Jt, faCaretSquareLeft/* faCaretSquareLeft */.Zi, faSearch/* faSearch */.Mj, faTimes/* faTimes */.GR, faMapSigns/* faMapSigns */.kn, faIdCard/* faIdCard */.Lm, faInfoCircle/* faInfoCircle */.iW, faCalculatorAlt/* faCalculatorAlt */.$g, faCogs/* faCogs */.Ub, faCalendarAlt/* faCalendarAlt */.BE, faUsersCog/* faUsersCog */.lF, faShoppingCart/* faShoppingCart */._R, faTags/* faTags */.DX, faFileImport/* faFileImport */.$M, faBuilding/* faBuilding */.UR, faUsers/* faUsers */.gd, faHistory/* faHistory */.In, faDownload/* faDownload */.cb, faArrowsV/* faArrowsV */.KI, faCheck/* faCheck */.e6, pro_solid_svg_icons_faTimes/* faTimes */.GR, faEye/* faEye */.pS, faEyeSlash/* faEyeSlash */.k6, faBell/* faBell */.z$, faPalette/* faPalette */.fy, faCode/* faCode */.jT, faFileImage/* faFileImage */.xd, faFileAlt/* faFileAlt */.h8, faFileWord/* faFileWord */.W1, faFilePowerpoint/* faFilePowerpoint */.zk, faFilePdf/* faFilePdf */.O_, faFileCsv/* faFileCsv */.Wx, faFileArchive/* faFileArchive */.oH, faFileAudio/* faFileAudio */.qe, faFileVideo/* faFileVideo */.n$, faFileExcel/* faFileExcel */.fn, faPrint/* faPrint */.Jx, faFileDownload/* faFileDownload */.mH, faBroadcastTower/* faBroadcastTower */.YX, faKey/* faKey */.bM, faCog/* faCog */.dB);


/***/ }),

/***/ 9527:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkmen [tk]
//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inji",
        5: "'inji",
        8: "'inji",
        70: "'inji",
        80: "'inji",
        2: "'nji",
        7: "'nji",
        20: "'nji",
        50: "'nji",
        3: "'ünji",
        4: "'ünji",
        100: "'ünji",
        6: "'njy",
        9: "'unjy",
        10: "'unjy",
        30: "'unjy",
        60: "'ynjy",
        90: "'ynjy",
    };

    var tk = moment.defineLocale('tk', {
        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
            '_'
        ),
        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün sagat] LT',
            nextDay: '[ertir sagat] LT',
            nextWeek: '[indiki] dddd [sagat] LT',
            lastDay: '[düýn] LT',
            lastWeek: '[geçen] dddd [sagat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s soň',
            past: '%s öň',
            s: 'birnäçe sekunt',
            m: 'bir minut',
            mm: '%d minut',
            h: 'bir sagat',
            hh: '%d sagat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir aý',
            MM: '%d aý',
            y: 'bir ýyl',
            yy: '%d ýyl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'unjy";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return tk;

})));


/***/ }),

/***/ 9529:
/***/ (function(module) {

"use strict";
module.exports = require("bootstrap-vue");

/***/ }),

/***/ 9532:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        h: 'stundas_stundām_stunda_stundas'.split('_'),
        hh: 'stundas_stundām_stunda_stundas'.split('_'),
        d: 'dienas_dienām_diena_dienas'.split('_'),
        dd: 'dienas_dienām_diena_dienas'.split('_'),
        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        y: 'gada_gadiem_gads_gadi'.split('_'),
        yy: 'gada_gadiem_gads_gadi'.split('_'),
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */
    function format(forms, number, withoutSuffix) {
        if (withoutSuffix) {
            // E.g. "21 minūte", "3 minūtes".
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        } else {
            // E.g. "21 minūtes" as in "pēc 21 minūtes".
            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
        }
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        return number + ' ' + format(units[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format(units[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
    }

    var lv = moment.defineLocale('lv', {
        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
        weekdays:
            'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
                '_'
            ),
        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY.',
            LL: 'YYYY. [gada] D. MMMM',
            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
        },
        calendar: {
            sameDay: '[Šodien pulksten] LT',
            nextDay: '[Rīt pulksten] LT',
            nextWeek: 'dddd [pulksten] LT',
            lastDay: '[Vakar pulksten] LT',
            lastWeek: '[Pagājušā] dddd [pulksten] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'pēc %s',
            past: 'pirms %s',
            s: relativeSeconds,
            ss: relativeTimeWithPlural,
            m: relativeTimeWithSingular,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithSingular,
            hh: relativeTimeWithPlural,
            d: relativeTimeWithSingular,
            dd: relativeTimeWithPlural,
            M: relativeTimeWithSingular,
            MM: relativeTimeWithPlural,
            y: relativeTimeWithSingular,
            yy: relativeTimeWithPlural,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lv;

})));


/***/ }),

/***/ 9570:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var constant = __webpack_require__(7334),
    defineProperty = __webpack_require__(3243),
    identity = __webpack_require__(3488);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ 9653:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Uint8Array = __webpack_require__(7828);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),

/***/ 9680:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eng Minutt', 'enger Minutt'],
            h: ['eng Stonn', 'enger Stonn'],
            d: ['een Dag', 'engem Dag'],
            M: ['ee Mount', 'engem Mount'],
            y: ['ee Joer', 'engem Joer'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
        }
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
        }
        return 'virun ' + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            // Negative Number --> always true
            return true;
        } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10,
                firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    var lb = moment.defineLocale('lb', {
        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
                '_'
            ),
        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function () {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch (this.day()) {
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            },
        },
        relativeTime: {
            future: processFutureTime,
            past: processPastTime,
            s: 'e puer Sekonnen',
            ss: '%d Sekonnen',
            m: processRelativeTime,
            mm: '%d Minutten',
            h: processRelativeTime,
            hh: '%d Stonnen',
            d: processRelativeTime,
            dd: '%d Deeg',
            M: processRelativeTime,
            MM: '%d Méint',
            y: processRelativeTime,
            yy: '%d Joer',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lb;

})));


/***/ }),

/***/ 9722:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Javanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var jv = moment.defineLocale('jv', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'enjing') {
                return hour;
            } else if (meridiem === 'siyang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'enjing';
            } else if (hours < 15) {
                return 'siyang';
            } else if (hours < 19) {
                return 'sonten';
            } else {
                return 'ndalu';
            }
        },
        calendar: {
            sameDay: '[Dinten puniko pukul] LT',
            nextDay: '[Mbenjang pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kala wingi pukul] LT',
            lastWeek: 'dddd [kepengker pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'wonten ing %s',
            past: '%s ingkang kepengker',
            s: 'sawetawis detik',
            ss: '%d detik',
            m: 'setunggal menit',
            mm: '%d menit',
            h: 'setunggal jam',
            hh: '%d jam',
            d: 'sedinten',
            dd: '%d dinten',
            M: 'sewulan',
            MM: '%d wulan',
            y: 'setaun',
            yy: '%d taun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return jv;

})));


/***/ }),

/***/ 9727:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ Register_Register; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Register/Register.vue?vue&type=template&id=35952274
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-card',{staticClass:"register-form",attrs:{"title":_vm.$t('interface.pageTitle.register')}},[_c('k-form',{attrs:{"action":"/auth/register","method":"post","dontAskLogin":"","beforeSubmit":_vm.beforeSubmit},on:{"submitComplete":_vm.submitComplete}},[_c('b-form-group',{attrs:{"label":_vm.$t('interface.auth.companyName')}},[_c('k-form-input',{attrs:{"name":"company_name","required":""}})],1),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":_vm.$t('interface.auth.firstname')}},[_c('k-form-input',{attrs:{"name":"firstname","required":""}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":_vm.$t('interface.auth.lastname')}},[_c('k-form-input',{attrs:{"name":"lastname","required":""}})],1)],1)],1),_c('b-form-group',{attrs:{"label":_vm.$t('interface.auth.phone')}},[_c('k-form-phone',{attrs:{"name":"phone","required":""}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('interface.auth.email')}},[_c('k-form-input',{attrs:{"type":"email","name":"email","required":""}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('interface.auth.password')}},[_c('k-form-input',{attrs:{"type":"password","name":"password","required":""}})],1),_c('p',{staticClass:"text-center mb-0 mt-4"},[_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_vm._v(" "+_vm._s(_vm.$t('interface.auth.createAccount'))+" ")])],1),_c('div',{staticClass:"small mt-3"},[_c('router-link',{attrs:{"to":{ name: 'login' }}},[_vm._v(" "+_vm._s(_vm.$t('interface.backToLogin'))+" ")])],1)],1)],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Register/Register.ts?vue&type=script&lang=ts&external





var Register = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(Register, _super);
    function Register() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Register.prototype.beforeSubmit = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.$kwInterface.withCsrf) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.$kwInterface.axios.get('/csrf-cookie')];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    Register.prototype.submitComplete = function (response) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var data;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = response.data;
                        this.setToken(data.token);
                        this.setUser(data.user);
                        if (!this.$kwInterface.goToHome) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.$kwInterface.goToHome(this.$router, this.$store)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    Register = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('auth', ['setToken'])), (0,external_vuex_.mapActions)('user', ['setUser'])),
            components: {
                BCard: external_bootstrap_vue_.BCard, BFormGroup: external_bootstrap_vue_.BFormGroup, BButton: external_bootstrap_vue_.BButton, BAlert: external_bootstrap_vue_.BAlert, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol,
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormPhone: form_vue_.KFormPhone
            }
        })
    ], Register);
    return Register;
}(lib/* Vue */.lD));
/* harmony default export */ var Registervue_type_script_lang_ts_external = (Register);

;// ./src/components/Register/Register.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var Register_Registervue_type_script_lang_ts_external = (Registervue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/Register/Register.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  Register_Registervue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Register_Register = (component.exports);

/***/ }),

/***/ 9754:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayEach = __webpack_require__(3729),
    baseEach = __webpack_require__(909),
    castFunction = __webpack_require__(4066),
    isArray = __webpack_require__(6449);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),

/***/ 9756:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arTn = moment.defineLocale('ar-tn', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort:
            'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arTn;

})));


/***/ }),

/***/ 9770:
/***/ (function(module) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ 9817:
/***/ (function(module) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 9834:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pt = moment.defineLocale('pt', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays:
            'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
                '_'
            ),
        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            w: 'uma semana',
            ww: '%d semanas',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pt;

})));


/***/ }),

/***/ 9846:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.
    var tzl = moment.defineLocale('tzl', {
        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM [dallas] YYYY',
            LLL: 'D. MMMM [dallas] YYYY HH.mm',
            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM: function (input) {
            return "d'o" === input.toLowerCase();
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? "d'o" : "D'O";
            } else {
                return isLower ? "d'a" : "D'A";
            }
        },
        calendar: {
            sameDay: '[oxhi à] LT',
            nextDay: '[demà à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[ieiri à] LT',
            lastWeek: '[sür el] dddd [lasteu à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'osprei %s',
            past: 'ja%s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['viensas secunds', "'iensas secunds"],
            ss: [number + ' secunds', '' + number + ' secunds'],
            m: ["'n míut", "'iens míut"],
            mm: [number + ' míuts', '' + number + ' míuts'],
            h: ["'n þora", "'iensa þora"],
            hh: [number + ' þoras', '' + number + ' þoras'],
            d: ["'n ziua", "'iensa ziua"],
            dd: [number + ' ziuas', '' + number + ' ziuas'],
            M: ["'n mes", "'iens mes"],
            MM: [number + ' mesen', '' + number + ' mesen'],
            y: ["'n ar", "'iens ar"],
            yy: [number + ' ars', '' + number + ' ars'],
        };
        return isFuture
            ? format[key][0]
            : withoutSuffix
              ? format[key][0]
              : format[key][1];
    }

    return tzl;

})));


/***/ }),

/***/ 9849:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

;(function (global, factory) {
    true ? factory(__webpack_require__(5093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '੧',
            2: '੨',
            3: '੩',
            4: '੪',
            5: '੫',
            6: '੬',
            7: '੭',
            8: '੮',
            9: '੯',
            0: '੦',
        },
        numberMap = {
            '੧': '1',
            '੨': '2',
            '੩': '3',
            '੪': '4',
            '੫': '5',
            '੬': '6',
            '੭': '7',
            '੮': '8',
            '੯': '9',
            '੦': '0',
        };

    var paIn = moment.defineLocale('pa-in', {
        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
            '_'
        ),
        monthsShort:
            'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
                '_'
            ),
        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
            '_'
        ),
        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm ਵਜੇ',
            LTS: 'A h:mm:ss ਵਜੇ',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
        },
        calendar: {
            sameDay: '[ਅਜ] LT',
            nextDay: '[ਕਲ] LT',
            nextWeek: '[ਅਗਲਾ] dddd, LT',
            lastDay: '[ਕਲ] LT',
            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ਵਿੱਚ',
            past: '%s ਪਿਛਲੇ',
            s: 'ਕੁਝ ਸਕਿੰਟ',
            ss: '%d ਸਕਿੰਟ',
            m: 'ਇਕ ਮਿੰਟ',
            mm: '%d ਮਿੰਟ',
            h: 'ਇੱਕ ਘੰਟਾ',
            hh: '%d ਘੰਟੇ',
            d: 'ਇੱਕ ਦਿਨ',
            dd: '%d ਦਿਨ',
            M: 'ਇੱਕ ਮਹੀਨਾ',
            MM: '%d ਮਹੀਨੇ',
            y: 'ਇੱਕ ਸਾਲ',
            yy: '%d ਸਾਲ',
        },
        preparse: function (string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ਰਾਤ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
                return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ਰਾਤ';
            } else if (hour < 10) {
                return 'ਸਵੇਰ';
            } else if (hour < 17) {
                return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
                return 'ਸ਼ਾਮ';
            } else {
                return 'ਰਾਤ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return paIn;

})));


/***/ }),

/***/ 9851:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_UsersView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/UsersView.vue?vue&type=template&id=a6e3dbbe
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('UsersList')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: ./src/components/UsersList/UsersList.vue + 3 modules
var UsersList = __webpack_require__(467);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/UsersView.vue?vue&type=script&lang=ts



var UsersView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(UsersView, _super);
    function UsersView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UsersView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                UsersList: UsersList/* default */.A
            }
        })
    ], UsersView);
    return UsersView;
}(lib/* Vue */.lD));
/* harmony default export */ var UsersViewvue_type_script_lang_ts = (UsersView);

;// ./src/views/UsersView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_UsersViewvue_type_script_lang_ts = (UsersViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/UsersView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_UsersViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_UsersView = (component.exports);

/***/ }),

/***/ 9884:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(1791),
    keysIn = __webpack_require__(7241);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),

/***/ 9935:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 9998:
/***/ (function(module) {

"use strict";
module.exports = require("vuex");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	!function() {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	!function() {
/******/ 		__webpack_require__.nmd = function(module) {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	!function() {
/******/ 		__webpack_require__.p = "";
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
!function() {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  AppColors: function() { return /* reexport */ AppColors/* default */.A; },
  AppColorsView: function() { return /* reexport */ AppColorsView["default"]; },
  AppLogos: function() { return /* reexport */ AppLogos/* default */.A; },
  AppMessage: function() { return /* reexport */ AppMessage/* default */.A; },
  AppMessages: function() { return /* reexport */ AppMessages/* default */.A; },
  AppStore: function() { return /* reexport */ modules_App; },
  AppVersions: function() { return /* reexport */ AppVersions/* default */.A; },
  AppVersionsView: function() { return /* reexport */ AppVersionsView["default"]; },
  AuthStore: function() { return /* reexport */ modules_Auth; },
  Avatar: function() { return /* reexport */ Avatar/* default */.A; },
  BroadcastStore: function() { return /* reexport */ BroadcastStore; },
  Civilities: function() { return /* reexport */ Civilities/* default */.A; },
  CivilitiesView: function() { return /* reexport */ CivilitiesView["default"]; },
  CivilitySelect: function() { return /* reexport */ CivilitySelect_CivilitySelect; },
  CommentsDelete: function() { return /* reexport */ CommentsDelete_CommentsDelete; },
  CommentsForm: function() { return /* reexport */ CommentsForm_CommentsForm; },
  CommentsItem: function() { return /* reexport */ CommentsItem_CommentsItem; },
  CommentsList: function() { return /* reexport */ CommentsList_CommentsList; },
  CommentsTab: function() { return /* reexport */ CommentsTab_CommentsTab; },
  ConfigurationView: function() { return /* reexport */ ConfigurationView["default"]; },
  ConfirmModal: function() { return /* reexport */ ConfirmModal_ConfirmModal; },
  CountrySelect: function() { return /* reexport */ CountrySelect_CountrySelect; },
  CurrencySelect: function() { return /* reexport */ CurrencySelect_CurrencySelect; },
  DateMixin: function() { return /* reexport */ DateMixin/* default */.A; },
  Disconnect: function() { return /* reexport */ Disconnect/* default */.A; },
  DynamicList: function() { return /* reexport */ DynamicList/* default */.A; },
  DynamicModal: function() { return /* reexport */ DynamicModal_DynamicModal; },
  DynamicModalsStore: function() { return /* reexport */ modules_DynamicModals; },
  EmailVerification: function() { return /* reexport */ EmailVerification/* default */.A; },
  EmailVerificationView: function() { return /* reexport */ EmailVerificationView["default"]; },
  Error404: function() { return /* reexport */ Error404/* default */.A; },
  Error404View: function() { return /* reexport */ Error404View["default"]; },
  FileDelete: function() { return /* reexport */ FileDelete_FileDelete; },
  FileItem: function() { return /* reexport */ FileItem_FileItem; },
  FileMixin: function() { return /* reexport */ mixins_FileMixin; },
  FilePreview: function() { return /* reexport */ FilePreview_FilePreview; },
  FilesList: function() { return /* reexport */ FilesList_FilesList; },
  FilesTab: function() { return /* reexport */ FilesTab_FilesTab; },
  ForgotPassword: function() { return /* reexport */ ForgotPassword/* default */.A; },
  ForgotPasswordView: function() { return /* reexport */ ForgotPasswordView["default"]; },
  FormModal: function() { return /* reexport */ FormModal/* default */.A; },
  GlobalDatasStore: function() { return /* reexport */ modules_GlobalDatas; },
  Header: function() { return /* reexport */ Header_Header; },
  HeaderMenu: function() { return /* reexport */ HeaderMenu_HeaderMenu; },
  HistoricList: function() { return /* reexport */ HistoricList/* default */.A; },
  HistoricTab: function() { return /* reexport */ HistoricTab_HistoricTab; },
  HistoricsView: function() { return /* reexport */ HistoricsView["default"]; },
  IFrame: function() { return /* reexport */ IFrame; },
  Interface: function() { return /* reexport */ Interface_Interface; },
  KwixeoInterface: function() { return /* reexport */ install; },
  Lang: function() { return /* reexport */ src_lang; },
  LocalBroadcast: function() { return /* reexport */ broadcasts_LocalBroadcast; },
  Login: function() { return /* reexport */ Login/* default */.A; },
  LoginView: function() { return /* reexport */ LoginView["default"]; },
  MainMenu: function() { return /* reexport */ MainMenu_MainMenu; },
  MainSearch: function() { return /* reexport */ MainSearch_MainSearch; },
  NotificationMixin: function() { return /* reexport */ mixins_NotificationMixin; },
  NotificationsAlerts: function() { return /* reexport */ NotificationsAlerts_NotificationsAlerts; },
  NotificationsConfig: function() { return /* reexport */ NotificationsConfig/* default */.A; },
  NotificationsHeader: function() { return /* reexport */ NotificationsHeader_NotificationsHeader; },
  NotificationsItem: function() { return /* reexport */ NotificationsItem/* default */.A; },
  NotificationsList: function() { return /* reexport */ NotificationsList/* default */.A; },
  NotificationsView: function() { return /* reexport */ NotificationsView["default"]; },
  NumberMixin: function() { return /* reexport */ NumberMixin/* default */.A; },
  PageHeader: function() { return /* reexport */ PageHeader/* default */.A; },
  PageHeaderButtons: function() { return /* reexport */ PageHeaderButtons/* default */.A; },
  Password: function() { return /* reexport */ Password/* default */.A; },
  PaymentMethodSelect: function() { return /* reexport */ PaymentMethodSelect_PaymentMethodSelect; },
  PaymentMethods: function() { return /* reexport */ PaymentMethods/* default */.A; },
  PaymentMethodsView: function() { return /* reexport */ PaymentMethodsView["default"]; },
  PaymentTermForm: function() { return /* reexport */ PaymentTermForm/* default */.A; },
  PaymentTermSelect: function() { return /* reexport */ PaymentTermSelect_PaymentTermSelect; },
  PaymentTerms: function() { return /* reexport */ PaymentTerms/* default */.A; },
  PaymentTermsView: function() { return /* reexport */ PaymentTermsView["default"]; },
  PdfViewer: function() { return /* reexport */ PdfViewer_PdfViewer; },
  PhoneMixin: function() { return /* reexport */ PhoneMixin; },
  Register: function() { return /* reexport */ Register/* default */.A; },
  RegisterView: function() { return /* reexport */ RegisterView["default"]; },
  ResetPassword: function() { return /* reexport */ ResetPassword/* default */.A; },
  ResetPasswordView: function() { return /* reexport */ ResetPasswordView["default"]; },
  ServerBroadcast: function() { return /* reexport */ broadcasts_ServerBroadcast; },
  Sidebar: function() { return /* reexport */ Sidebar_Sidebar; },
  SidebarOptions: function() { return /* reexport */ mixins_SidebarOptions; },
  Spinner: function() { return /* reexport */ Spinner/* default */.A; },
  Tab: function() { return /* reexport */ Tabs_Tab; },
  Tabs: function() { return /* reexport */ Tabs_Tabs; },
  TagSelect: function() { return /* reexport */ TagSelect_TagSelect; },
  Tags: function() { return /* reexport */ Tags/* default */.A; },
  TagsView: function() { return /* reexport */ TagsView["default"]; },
  TeamApiToken: function() { return /* reexport */ TeamApiToken/* default */.A; },
  TeamApiTokenForm: function() { return /* reexport */ TeamApiTokenForm/* default */.A; },
  TeamApiTokenView: function() { return /* reexport */ TeamApiTokenView["default"]; },
  TeamConfigMixin: function() { return /* reexport */ TeamConfigMixin/* default */.A; },
  TeamFormMixin: function() { return /* reexport */ TeamFormMixin/* default */.A; },
  TeamInformationsView: function() { return /* reexport */ TeamInformationsView["default"]; },
  TeamInfos: function() { return /* reexport */ TeamInfos/* default */.A; },
  TeamParams: function() { return /* reexport */ TeamParams/* default */.A; },
  TeamParamsView: function() { return /* reexport */ TeamParamsView["default"]; },
  TeamUserSelect: function() { return /* reexport */ TeamUserSelect/* default */.A; },
  TestMode: function() { return /* reexport */ TestMode_TestMode; },
  TestModeActivation: function() { return /* reexport */ TestModeActivation_TestModeActivation; },
  TextMixin: function() { return /* reexport */ mixins_TextMixin; },
  TextareaView: function() { return /* reexport */ TextareaView/* default */.A; },
  TimezoneSelect: function() { return /* reexport */ TimezoneSelect_TimezoneSelect; },
  UnitSelect: function() { return /* reexport */ UnitSelect_UnitSelect; },
  Units: function() { return /* reexport */ Units/* default */.A; },
  UnitsView: function() { return /* reexport */ UnitsView["default"]; },
  UserAuth: function() { return /* reexport */ UserAuth_UserAuth; },
  UserEmail: function() { return /* reexport */ UserEmail_UserEmail; },
  UserFormMixin: function() { return /* reexport */ mixins_UserFormMixin; },
  UserInfos: function() { return /* reexport */ UserInfos_UserInfos; },
  UserInvitation: function() { return /* reexport */ UserInvitation/* default */.A; },
  UserInvitationView: function() { return /* reexport */ UserInvitationView["default"]; },
  UserMenu: function() { return /* reexport */ UserMenu_UserMenu; },
  UserPassword: function() { return /* reexport */ UserPassword_UserPassword; },
  UserProfile: function() { return /* reexport */ UserProfile_UserProfile; },
  UserProfileView: function() { return /* reexport */ UserProfileView["default"]; },
  UserStore: function() { return /* reexport */ modules_User; },
  UsersDelete: function() { return /* reexport */ UsersDelete/* default */.A; },
  UsersForm: function() { return /* reexport */ UsersForm/* default */.A; },
  UsersList: function() { return /* reexport */ UsersList/* default */.A; },
  UsersView: function() { return /* reexport */ UsersView["default"]; },
  VatRateSelect: function() { return /* reexport */ VatRateSelect_VatRateSelect; },
  VatRates: function() { return /* reexport */ VatRates/* default */.A; },
  VatRatesView: function() { return /* reexport */ VatRatesView["default"]; },
  afterEach: function() { return /* reexport */ afterEach; },
  applyProps: function() { return /* reexport */ breakpoints/* applyProps */.FT; },
  beforeEach: function() { return /* reexport */ beforeEach; },
  checkAuth: function() { return /* reexport */ checkAuth; },
  checkUserPermission: function() { return /* reexport */ checkUserPermission; },
  configMenu: function() { return /* reexport */ configs; },
  convertHtmlToText: function() { return /* reexport */ convertHtmlToText; },
  dateToString: function() { return /* reexport */ date/* dateToString */.$T; },
  emitter: function() { return /* reexport */ mitt/* default */.A; },
  formatDate: function() { return /* reexport */ date/* formatDate */.Yq; },
  formatDatetime: function() { return /* reexport */ date/* formatDatetime */.Rt; },
  formatToDisplay: function() { return /* reexport */ number/* formatToDisplay */.jg; },
  generateProps: function() { return /* reexport */ breakpoints/* generateProps */.Gu; },
  getBreakpoints: function() { return /* reexport */ breakpoints/* getBreakpoints */.BQ; },
  getNbDecimals: function() { return /* reexport */ number/* getNbDecimals */.hB; },
  moment: function() { return /* reexport */ date/* moment */.n$; },
  parsePhone: function() { return /* reexport */ parsePhone; },
  redirectIfForbidden: function() { return /* reexport */ redirectIfForbidden; },
  round: function() { return /* reexport */ number/* round */.LI; },
  routes: function() { return /* reexport */ router_routes; },
  serialize: function() { return /* reexport */ src_serialize; },
  showNumber: function() { return /* reexport */ number/* showNumber */.Zo; },
  showPhone: function() { return /* reexport */ showPhone; },
  teamBroadcastChannel: function() { return /* reexport */ team; },
  toNumber: function() { return /* reexport */ number/* toNumber */.Ro; },
  userBroadcastChannel: function() { return /* reexport */ broadcasts_user; },
  userMenu: function() { return /* reexport */ user; }
});

;// ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./src/components/AppColors/AppColors.vue + 3 modules
var AppColors = __webpack_require__(9256);
// EXTERNAL MODULE: ./src/components/AppLogos/AppLogos.vue + 3 modules
var AppLogos = __webpack_require__(3945);
// EXTERNAL MODULE: ./src/components/AppMessage/AppMessage.vue + 3 modules
var AppMessage = __webpack_require__(848);
// EXTERNAL MODULE: ./src/components/AppMessages/AppMessages.vue + 3 modules
var AppMessages = __webpack_require__(3808);
// EXTERNAL MODULE: ./src/components/AppVersions/AppVersions.vue + 3 modules
var AppVersions = __webpack_require__(7641);
// EXTERNAL MODULE: ./src/components/Avatar/Avatar.vue + 3 modules
var Avatar = __webpack_require__(3072);
// EXTERNAL MODULE: ./src/components/Civilities/Civilities.vue + 3 modules
var Civilities = __webpack_require__(8458);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CivilitySelect/CivilitySelect.vue?vue&type=template&id=1c6460cd
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form-select',_vm._g(_vm._b({attrs:{"options":_vm.civilities,"label":"name"}},'k-form-select',_vm.attributes,false),_vm.$listeners))
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 10 modules
var lib = __webpack_require__(9077);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CivilitySelect/CivilitySelect.ts?vue&type=script&lang=ts&external




var CivilitySelect = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CivilitySelect, _super);
    function CivilitySelect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CivilitySelect.prototype.created = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadCivilities()];
                    case 1:
                        _a.sent();
                        if (this.selectDefault !== false && !this.value && this.defaultCivility) {
                            this.$emit('input', this.defaultCivility);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(CivilitySelect.prototype, "attributes", {
        get: function () {
            return Object.assign({}, {
                value: this.value,
                clearable: false
            }, this.$attrs);
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CivilitySelect.prototype, "selectDefault", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CivilitySelect.prototype, "value", void 0);
    CivilitySelect = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadCivilities'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('globalDatas', ['defaultCivility'])), (0,external_vuex_.mapState)('globalDatas', ['civilities'])),
            components: {
                KFormSelect: form_vue_.KFormSelect
            }
        })
    ], CivilitySelect);
    return CivilitySelect;
}(lib/* Vue */.lD));
/* harmony default export */ var CivilitySelectvue_type_script_lang_ts_external = (CivilitySelect);

;// ./src/components/CivilitySelect/CivilitySelect.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CivilitySelect_CivilitySelectvue_type_script_lang_ts_external = (CivilitySelectvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CivilitySelect/CivilitySelect.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CivilitySelect_CivilitySelectvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CivilitySelect_CivilitySelect = (component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CommentsDelete/CommentsDelete.vue?vue&type=template&id=8d88d5f8
var CommentsDeletevue_type_template_id_8d88d5f8_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-modal',{attrs:{"title":_vm.$t('interface.deleteConfirmation'),"cancel-title":_vm.$t('interface.cancel'),"ok-title":_vm.$t('interface.delete'),"busy":_vm.loading,"hide-header-close":_vm.loading,"no-close-on-esc":_vm.loading,"no-close-on-backdrop":_vm.loading,"visible":""},on:{"ok":_vm.onOk,"hidden":function($event){return _vm.$emit('hidden')}}},[_c('b-overlay',{attrs:{"show":_vm.loading,"rounded":"sm","variant":"white","opacity":.8,"blur":"5px"}},[_vm._v(" "+_vm._s(_vm.$t('interface.comments.deleteMsg'))+" ")])],1)],1)
}
var CommentsDeletevue_type_template_id_8d88d5f8_staticRenderFns = []


// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CommentsDelete/CommentsDelete.ts?vue&type=script&lang=ts&external



var CommentsDelete = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CommentsDelete, _super);
    function CommentsDelete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showModal = false;
        _this.loading = false;
        return _this;
    }
    CommentsDelete.prototype.mounted = function () {
        this.watchValue(this.value);
    };
    CommentsDelete.prototype.watchValue = function (value) {
        this.value = value;
        this.showModal = value !== null;
    };
    CommentsDelete.prototype.onOk = function (event) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        this.loading = true;
                        return [4 /*yield*/, this.$kwInterface.axios.delete(this.apiUrl)
                                .then(function () {
                                _this.$emit('deleted');
                                _this.showModal = false;
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(CommentsDelete.prototype, "apiUrl", {
        get: function () {
            return '/comment/' + this.value;
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CommentsDelete.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value')
    ], CommentsDelete.prototype, "watchValue", null);
    CommentsDelete = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BModal: external_bootstrap_vue_.BModal, BOverlay: external_bootstrap_vue_.BOverlay
            }
        })
    ], CommentsDelete);
    return CommentsDelete;
}(lib/* Vue */.lD));
/* harmony default export */ var CommentsDeletevue_type_script_lang_ts_external = (CommentsDelete);

;// ./src/components/CommentsDelete/CommentsDelete.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CommentsDelete_CommentsDeletevue_type_script_lang_ts_external = (CommentsDeletevue_type_script_lang_ts_external); 
;// ./src/components/CommentsDelete/CommentsDelete.vue





/* normalize component */
;
var CommentsDelete_component = (0,componentNormalizer/* default */.A)(
  CommentsDelete_CommentsDeletevue_type_script_lang_ts_external,
  CommentsDeletevue_type_template_id_8d88d5f8_render,
  CommentsDeletevue_type_template_id_8d88d5f8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CommentsDelete_CommentsDelete = (CommentsDelete_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CommentsForm/CommentsForm.vue?vue&type=template&id=08cc840f
var CommentsFormvue_type_template_id_08cc840f_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form',{attrs:{"action":_vm.formUrl,"method":_vm.formMethod,"validateDatas":_vm.validateDatas},on:{"submitComplete":_vm.submitComplete}},[(_vm.id)?_c('input',{attrs:{"type":"hidden","name":"element_id"},domProps:{"value":_vm.id}}):_vm._e(),(_vm.type)?_c('input',{attrs:{"type":"hidden","name":"element_type"},domProps:{"value":_vm.type}}):_vm._e(),_c('b-form-group',{staticClass:"mb-1",attrs:{"label":_vm.formLabel}},[_c('k-form-editor',{ref:"editor",attrs:{"config":_vm.editorOptions,"size":"sm","name":"body"},model:{value:(_vm.comment.body),callback:function ($$v) {_vm.$set(_vm.comment, "body", $$v)},expression:"comment.body"}})],1),(_vm.formOnly === false)?_c('p',{staticClass:"mb-0 text-right"},[(_vm.comment && _vm.comment.id)?_c('b-button',{staticClass:"mr-1",attrs:{"variant":"secondary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.clearForm.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('interface.cancel'))+" ")]):_vm._e(),_c('b-button',{attrs:{"type":"submit","variant":"primary","size":"sm"}},[_vm._v(" "+_vm._s(_vm.btnLabel)+" ")])],1):_vm._e()],1)
}
var CommentsFormvue_type_template_id_08cc840f_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CommentsForm/CommentsForm.ts?vue&type=script&lang=ts&external




var CommentsForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CommentsForm, _super);
    function CommentsForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.comment = {
            body: ''
        };
        _this.editorOptions = {
            enter: 2,
            listAdvancedTypes: false,
            quickInsertEnabled: false,
            toolbarButtons: {
                moreText: {
                    buttons: [
                        'bold',
                        'italic',
                        'underline',
                        '|',
                        'alignLeft',
                        'alignCenter',
                        'alignRight',
                        'alignJustify'
                    ],
                    buttonsVisible: 3
                },
                moreText2: {
                    buttons: [
                        'textColor',
                        'backgroundColor',
                        '|',
                        'formatUL',
                        'formatOL',
                        '|',
                        'insertLink'
                    ],
                    buttonsVisible: 11
                },
                moreMisc: {
                    buttons: [],
                    align: 'right',
                    buttonsVisible: 0
                }
            }
        };
        return _this;
    }
    Object.defineProperty(CommentsForm.prototype, "formUrl", {
        get: function () {
            var url = '/comment';
            if (this.comment.id) {
                url += '/' + this.comment.id;
            }
            return url + '?with_file=true';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommentsForm.prototype, "formMethod", {
        get: function () {
            return this.comment.id ? 'PUT' : 'POST';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommentsForm.prototype, "formLabel", {
        get: function () {
            return this.comment.id || this.formOnly !== false ? null : this.$t('interface.comments.addTitle');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommentsForm.prototype, "btnLabel", {
        get: function () {
            return this.$t('interface.' + (this.comment.id ? 'edit' : 'add'));
        },
        enumerable: false,
        configurable: true
    });
    CommentsForm.prototype.watchValue = function (value) {
        this.comment = value ? JSON.parse(JSON.stringify(value)) : {};
    };
    CommentsForm.prototype.validateDatas = function (data) {
        var body = data.get('body');
        if (!body || body === '') {
            return {
                body: [this.$t('interface.requiredField')]
            };
        }
    };
    CommentsForm.prototype.submitComplete = function (response) {
        this.comment = {
            body: ''
        };
        return response.data;
    };
    CommentsForm.prototype.clearForm = function () {
        this.comment = {
            body: ''
        };
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CommentsForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CommentsForm.prototype, "id", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CommentsForm.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CommentsForm.prototype, "formOnly", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], CommentsForm.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('submitted')
    ], CommentsForm.prototype, "submitComplete", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('canceled')
    ], CommentsForm.prototype, "clearForm", null);
    CommentsForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormEditor: form_vue_.KFormEditor,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BButton: external_bootstrap_vue_.BButton
            }
        })
    ], CommentsForm);
    return CommentsForm;
}(lib/* Vue */.lD));
/* harmony default export */ var CommentsFormvue_type_script_lang_ts_external = (CommentsForm);

;// ./src/components/CommentsForm/CommentsForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CommentsForm_CommentsFormvue_type_script_lang_ts_external = (CommentsFormvue_type_script_lang_ts_external); 
;// ./src/components/CommentsForm/CommentsForm.vue





/* normalize component */
;
var CommentsForm_component = (0,componentNormalizer/* default */.A)(
  CommentsForm_CommentsFormvue_type_script_lang_ts_external,
  CommentsFormvue_type_template_id_08cc840f_render,
  CommentsFormvue_type_template_id_08cc840f_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CommentsForm_CommentsForm = (CommentsForm_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CommentsItem/CommentsItem.vue?vue&type=template&id=4f644128
var CommentsItemvue_type_template_id_4f644128_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-form-row',{staticClass:"comment-row"},[(_vm.withoutInformations === false)?_c('b-col',{staticClass:"px-0 pt-1 pr-1",attrs:{"cols":"auto"}},[_c('b-avatar',{attrs:{"text":_vm.value.team_user.initials,"src":_vm.value.team_user.avatar ? 'data:image.png;base64,' + _vm.value.team_user.avatar.file : null,"size":"2rem"}})],1):_vm._e(),_c('b-col',[(_vm.withoutInformations === false)?_c('p',{staticClass:"mb-0 small text-muted pb-1 text-underline"},[_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.datetime(_vm.value.created_at)))]),_vm._v(" par "+_vm._s(_vm.value.team_user.fullname)+" ")]):_vm._e(),(_vm.toEdit)?_c('CommentsForm',{staticClass:"mb-2",on:{"canceled":function($event){_vm.toEdit = false},"submitted":_vm.submitted},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}):_c('froalaView',{model:{value:(_vm.value.body),callback:function ($$v) {_vm.$set(_vm.value, "body", $$v)},expression:"value.body"}}),(_vm.toEdit === false)?_c('small',{staticClass:"actions mt-2 pb-1"},[_c('b-button',{staticClass:"p-0",attrs:{"variant":"link","size":"sm"},on:{"click":function($event){$event.preventDefault();_vm.toEdit = true}}},[_vm._v(" "+_vm._s(_vm.$t('interface.edit'))+" ")]),_vm._v(" | "),_c('b-button',{staticClass:"p-0",attrs:{"variant":"link","size":"sm"},on:{"click":function($event){$event.preventDefault();_vm.toDelete = true}}},[_vm._v(" "+_vm._s(_vm.$t('interface.delete'))+" ")])],1):_vm._e()],1),(_vm.toDelete)?_c('CommentsDelete',{on:{"hidden":function($event){_vm.toDelete = false},"deleted":function($event){return _vm.$emit('deleted')}},model:{value:(_vm.value.id),callback:function ($$v) {_vm.$set(_vm.value, "id", $$v)},expression:"value.id"}}):_vm._e()],1)
}
var CommentsItemvue_type_template_id_4f644128_staticRenderFns = []


// EXTERNAL MODULE: ./src/mixins/DateMixin.ts
var DateMixin = __webpack_require__(4774);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CommentsItem/CommentsItem.ts?vue&type=script&lang=ts&external






var CommentsItem = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CommentsItem, _super);
    function CommentsItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.toEdit = false;
        _this.toDelete = false;
        return _this;
    }
    CommentsItem.prototype.submitted = function (comment) {
        this.$emit('input', comment);
        this.toEdit = false;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CommentsItem.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CommentsItem.prototype, "withoutInformations", void 0);
    CommentsItem = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                CommentsForm: CommentsForm_CommentsForm,
                CommentsDelete: CommentsDelete_CommentsDelete,
                BFormRow: external_bootstrap_vue_.BFormRow, BCol: external_bootstrap_vue_.BCol, BAvatar: external_bootstrap_vue_.BAvatar, BButton: external_bootstrap_vue_.BButton
            }
        })
    ], CommentsItem);
    return CommentsItem;
}((0,lib/* Mixins */.Xe)(DateMixin/* default */.A)));
/* harmony default export */ var CommentsItemvue_type_script_lang_ts_external = (CommentsItem);

;// ./src/components/CommentsItem/CommentsItem.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CommentsItem_CommentsItemvue_type_script_lang_ts_external = (CommentsItemvue_type_script_lang_ts_external); 
;// ./src/components/CommentsItem/CommentsItem.vue





/* normalize component */
;
var CommentsItem_component = (0,componentNormalizer/* default */.A)(
  CommentsItem_CommentsItemvue_type_script_lang_ts_external,
  CommentsItemvue_type_template_id_4f644128_render,
  CommentsItemvue_type_template_id_4f644128_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CommentsItem_CommentsItem = (CommentsItem_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CommentsList/CommentsList.vue?vue&type=template&id=9dcac134
var CommentsListvue_type_template_id_9dcac134_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"comments-list"},[(!_vm.loading && _vm.total === 0)?_c('div',{staticClass:"text-center p-4"},[_c('small',[_vm._v(_vm._s(_vm.$t('interface.comments.empty')))])]):_vm._e(),_c('div',{staticClass:"comments p-2"},_vm._l((_vm.comments),function(comment,i){return _c('CommentsItem',{key:comment.id,staticClass:"pt-2",on:{"deleted":function($event){return _vm.deleted(i)}},model:{value:(_vm.comments[i]),callback:function ($$v) {_vm.$set(_vm.comments, i, $$v)},expression:"comments[i]"}})}),1),(_vm.loading)?_c('Spinner'):_vm._e(),_c('CommentsForm',{staticClass:"p-3",attrs:{"type":_vm.type,"id":_vm.id},on:{"submitted":_vm.added}})],1)
}
var CommentsListvue_type_template_id_9dcac134_staticRenderFns = []


// EXTERNAL MODULE: ./src/components/Spinner/Spinner.vue + 3 modules
var Spinner = __webpack_require__(683);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CommentsList/CommentsList.ts?vue&type=script&lang=ts&external





var CommentsList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CommentsList, _super);
    function CommentsList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.total = 0;
        _this.page = 1;
        _this.comments = [];
        _this.loading = false;
        return _this;
    }
    CommentsList.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchNotes()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(CommentsList.prototype, "apiUrl", {
        get: function () {
            return '/comment?sort=created_at:desc' +
                '&filter[element][0][type]=' + this.type +
                '&filter[element][0][id]=' + this.id + '' +
                '&with_file=1';
        },
        enumerable: false,
        configurable: true
    });
    CommentsList.prototype.watchTotal = function (total) {
        this.$emit('total', total);
    };
    CommentsList.prototype.watchApiUrl = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.reset()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CommentsList.prototype.reset = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.total = 0;
                        this.page = 1;
                        this.comments = [];
                        return [4 /*yield*/, this.fetchNotes()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CommentsList.prototype.fetchNotes = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.$kwInterface.axios.get(this.apiUrl)
                                .then(function (response) {
                                var _a;
                                var data = response.data;
                                (_a = _this.comments).push.apply(_a, data.data);
                                _this.total = data.meta.total;
                                _this.page = data.meta.current_page;
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CommentsList.prototype.added = function (comment) {
        this.total++;
        this.comments.unshift(comment);
    };
    CommentsList.prototype.deleted = function (index) {
        this.comments.splice(index, 1);
        this.total--;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CommentsList.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CommentsList.prototype, "id", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('total')
    ], CommentsList.prototype, "watchTotal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('apiUrl')
    ], CommentsList.prototype, "watchApiUrl", null);
    CommentsList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: Spinner/* default */.A,
                CommentsItem: CommentsItem_CommentsItem,
                CommentsForm: CommentsForm_CommentsForm
            }
        })
    ], CommentsList);
    return CommentsList;
}(lib/* Vue */.lD));
/* harmony default export */ var CommentsListvue_type_script_lang_ts_external = (CommentsList);

;// ./src/components/CommentsList/CommentsList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CommentsList_CommentsListvue_type_script_lang_ts_external = (CommentsListvue_type_script_lang_ts_external); 
;// ./src/components/CommentsList/CommentsList.vue





/* normalize component */
;
var CommentsList_component = (0,componentNormalizer/* default */.A)(
  CommentsList_CommentsListvue_type_script_lang_ts_external,
  CommentsListvue_type_template_id_9dcac134_render,
  CommentsListvue_type_template_id_9dcac134_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CommentsList_CommentsList = (CommentsList_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CommentsTab/CommentsTab.vue?vue&type=template&id=06a6b03a
var CommentsTabvue_type_template_id_06a6b03a_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-tab',{staticClass:"p-0"},[_c('template',{slot:"title"},[_vm._v(" "+_vm._s(_vm.$t('interface.comments.tabTitle'))+" "),_c('b-badge',{staticClass:"ml-1",attrs:{"variant":_vm.active ? 'primary' : 'secondary'}},[_vm._v(_vm._s(_vm.total))])],1),_c('CommentsList',{attrs:{"id":_vm.id,"type":_vm.type},on:{"total":val => _vm.total = val}})],2)
}
var CommentsTabvue_type_template_id_06a6b03a_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CommentsTab/CommentsTab.ts?vue&type=script&lang=ts&external




var CommentsTab = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CommentsTab, _super);
    function CommentsTab() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.total = 0;
        return _this;
    }
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CommentsTab.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CommentsTab.prototype, "id", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CommentsTab.prototype, "active", void 0);
    CommentsTab = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                CommentsList: CommentsList_CommentsList,
                BTab: external_bootstrap_vue_.BTab,
                BBadge: external_bootstrap_vue_.BBadge
            }
        })
    ], CommentsTab);
    return CommentsTab;
}(lib/* Vue */.lD));
/* harmony default export */ var CommentsTabvue_type_script_lang_ts_external = (CommentsTab);

;// ./src/components/CommentsTab/CommentsTab.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CommentsTab_CommentsTabvue_type_script_lang_ts_external = (CommentsTabvue_type_script_lang_ts_external); 
;// ./src/components/CommentsTab/CommentsTab.vue





/* normalize component */
;
var CommentsTab_component = (0,componentNormalizer/* default */.A)(
  CommentsTab_CommentsTabvue_type_script_lang_ts_external,
  CommentsTabvue_type_template_id_06a6b03a_render,
  CommentsTabvue_type_template_id_06a6b03a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CommentsTab_CommentsTab = (CommentsTab_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ConfirmModal/ConfirmModal.vue?vue&type=template&id=666c38ec
var ConfirmModalvue_type_template_id_666c38ec_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{attrs:{"ok-title":_vm.computedOkTitle,"cancel-title":_vm.$t('interface.cancel'),"visible":""},on:{"ok":_vm.confirmed,"cancel":_vm.canceled,"hidden":_vm.hidden}},[_c('p',{staticClass:"mb-0 text-justify"},[(_vm.$slots.default)?_vm._t("default"):[_vm._v(" "+_vm._s(_vm.message)+" ")]],2)])
}
var ConfirmModalvue_type_template_id_666c38ec_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ConfirmModal/ConfirmModal.ts?vue&type=script&lang=ts&external



var ConfirmModal = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ConfirmModal, _super);
    function ConfirmModal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ConfirmModal.prototype, "computedOkTitle", {
        get: function () {
            var _a;
            return (_a = this.okTitle) !== null && _a !== void 0 ? _a : this.$t('interface.continue');
        },
        enumerable: false,
        configurable: true
    });
    ConfirmModal.prototype.confirmed = function () {
        this.$emit('confirmed');
    };
    ConfirmModal.prototype.canceled = function () {
        this.$emit('canceled');
    };
    ConfirmModal.prototype.hidden = function () {
        this.$emit('hidden');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ConfirmModal.prototype, "message", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ConfirmModal.prototype, "okTitle", void 0);
    ConfirmModal = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BModal: external_bootstrap_vue_.BModal
            }
        })
    ], ConfirmModal);
    return ConfirmModal;
}(lib/* Vue */.lD));
/* harmony default export */ var ConfirmModalvue_type_script_lang_ts_external = (ConfirmModal);

;// ./src/components/ConfirmModal/ConfirmModal.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ConfirmModal_ConfirmModalvue_type_script_lang_ts_external = (ConfirmModalvue_type_script_lang_ts_external); 
;// ./src/components/ConfirmModal/ConfirmModal.vue





/* normalize component */
;
var ConfirmModal_component = (0,componentNormalizer/* default */.A)(
  ConfirmModal_ConfirmModalvue_type_script_lang_ts_external,
  ConfirmModalvue_type_template_id_666c38ec_render,
  ConfirmModalvue_type_template_id_666c38ec_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ConfirmModal_ConfirmModal = (ConfirmModal_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CountrySelect/CountrySelect.vue?vue&type=template&id=2c795147
var CountrySelectvue_type_template_id_2c795147_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form-select',_vm._g(_vm._b({attrs:{"options":_vm.countries,"label":"name"}},'k-form-select',_vm.attributes,false),_vm.$listeners))
}
var CountrySelectvue_type_template_id_2c795147_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CountrySelect/CountrySelect.ts?vue&type=script&lang=ts&external




var CountrySelect = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CountrySelect, _super);
    function CountrySelect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CountrySelect.prototype.created = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadCountries()];
                    case 1:
                        _a.sent();
                        if (this.selectDefault !== false && !this.value && this.country) {
                            this.$emit('input', this.country);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(CountrySelect.prototype, "attributes", {
        get: function () {
            return Object.assign({}, {
                value: this.value,
                clearable: false
            }, this.$attrs);
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CountrySelect.prototype, "selectDefault", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CountrySelect.prototype, "value", void 0);
    CountrySelect = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadCountries'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['country'])), (0,external_vuex_.mapState)('globalDatas', ['countries'])),
            components: {
                KFormSelect: form_vue_.KFormSelect
            }
        })
    ], CountrySelect);
    return CountrySelect;
}(lib/* Vue */.lD));
/* harmony default export */ var CountrySelectvue_type_script_lang_ts_external = (CountrySelect);

;// ./src/components/CountrySelect/CountrySelect.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CountrySelect_CountrySelectvue_type_script_lang_ts_external = (CountrySelectvue_type_script_lang_ts_external); 
;// ./src/components/CountrySelect/CountrySelect.vue





/* normalize component */
;
var CountrySelect_component = (0,componentNormalizer/* default */.A)(
  CountrySelect_CountrySelectvue_type_script_lang_ts_external,
  CountrySelectvue_type_template_id_2c795147_render,
  CountrySelectvue_type_template_id_2c795147_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CountrySelect_CountrySelect = (CountrySelect_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CurrencySelect/CurrencySelect.vue?vue&type=template&id=d85a3060
var CurrencySelectvue_type_template_id_d85a3060_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form-select',_vm._g(_vm._b({attrs:{"options":_vm.currencies,"getOptionLabel":opt => opt.name + ' (' + opt.symbol + ')'}},'k-form-select',_vm.attributes,false),_vm.$listeners))
}
var CurrencySelectvue_type_template_id_d85a3060_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CurrencySelect/CurrencySelect.ts?vue&type=script&lang=ts&external




var CurrencySelect = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CurrencySelect, _super);
    function CurrencySelect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CurrencySelect.prototype.created = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadCurrencies()];
                    case 1:
                        _a.sent();
                        if (this.selectDefault !== false && !this.value && this.currency) {
                            this.$emit('input', this.currency);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(CurrencySelect.prototype, "attributes", {
        get: function () {
            return Object.assign({}, {
                value: this.value,
                clearable: false
            }, this.$attrs);
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CurrencySelect.prototype, "selectDefault", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CurrencySelect.prototype, "value", void 0);
    CurrencySelect = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadCurrencies'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['currency'])), (0,external_vuex_.mapState)('globalDatas', ['currencies'])),
            components: {
                KFormSelect: form_vue_.KFormSelect
            }
        })
    ], CurrencySelect);
    return CurrencySelect;
}(lib/* Vue */.lD));
/* harmony default export */ var CurrencySelectvue_type_script_lang_ts_external = (CurrencySelect);

;// ./src/components/CurrencySelect/CurrencySelect.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CurrencySelect_CurrencySelectvue_type_script_lang_ts_external = (CurrencySelectvue_type_script_lang_ts_external); 
;// ./src/components/CurrencySelect/CurrencySelect.vue





/* normalize component */
;
var CurrencySelect_component = (0,componentNormalizer/* default */.A)(
  CurrencySelect_CurrencySelectvue_type_script_lang_ts_external,
  CurrencySelectvue_type_template_id_d85a3060_render,
  CurrencySelectvue_type_template_id_d85a3060_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CurrencySelect_CurrencySelect = (CurrencySelect_component.exports);
// EXTERNAL MODULE: ./src/components/Disconnect/Disconnect.vue + 3 modules
var Disconnect = __webpack_require__(3497);
// EXTERNAL MODULE: ./src/components/DynamicList/DynamicList.vue + 4 modules
var DynamicList = __webpack_require__(3425);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/DynamicModal/DynamicModal.vue?vue&type=template&id=1dad196d
var DynamicModalvue_type_template_id_1dad196d_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.instances),function(modal,i){return _c('FormModal',{key:modal.id,attrs:{"title":_vm.$t(_vm.getTitle(modal)),"size":modal.size,"scrollable":modal.scrollable !== undefined ? modal.scrollable : true},on:{"hidden":function($event){return _vm.closeModal(i)},"submitComplete":response => _vm.submitted(modal, response)},scopedSlots:_vm._u([(modal.buttons)?{key:"modal-footer",fn:function({ ok, cancel, close, hide }){return [_vm._l((modal.buttons),function(button,j){return [(button.separator && (!button.if || button.if(modal.value)))?_c('div',{key:j,staticClass:"modal-footer-separator"}):(button.component && (!button.if || button.if(modal.value)))?_c(button.component,_vm._g(_vm._b({key:j,tag:"component",attrs:{"value":button.useValue ? modal.value : null}},'component',button.attributes,false),_vm.buttonEvents(button.events, i))):((button.show === undefined || button.show(modal)) && (!button.if || button.if(modal.value)))?_c('b-button',{key:j,attrs:{"variant":button.variant},on:{"click":function($event){$event.preventDefault();return button.click(modal, { ok, cancel, close, hide }, _vm.$refs['component-' + i])}}},[_vm._v(" "+_vm._s(button.label)+" ")]):_vm._e()]})]}}:null],null,true),model:{value:(modal.state),callback:function ($$v) {_vm.$set(modal, "state", $$v)},expression:"modal.state"}},[_c(modal.component,_vm._g(_vm._b({tag:"component",model:{value:(modal.value),callback:function ($$v) {_vm.$set(modal, "value", $$v)},expression:"modal.value"}},'component',modal.attributes,false),_vm.events(modal, i)))],1)}),1)
}
var DynamicModalvue_type_template_id_1dad196d_staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/lodash/forEach.js
var forEach = __webpack_require__(9754);
var forEach_default = /*#__PURE__*/__webpack_require__.n(forEach);
// EXTERNAL MODULE: ./src/components/FormModal/FormModal.vue + 2 modules
var FormModal = __webpack_require__(7401);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/DynamicModal/DynamicModal.ts?vue&type=script&lang=ts&external






var DynamicModal = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(DynamicModal, _super);
    function DynamicModal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DynamicModal.prototype.getTitle = function (modal) {
        if (typeof modal.title === 'string') {
            return modal.title;
        }
        return modal.title(modal.value);
    };
    DynamicModal.prototype.submitted = function (modal, response) {
        return modal.submitted ? modal.submitted(response, modal) : null;
    };
    DynamicModal.prototype.events = function (modal, i) {
        var _this = this;
        var events = {};
        if (modal.events) {
            var close_1 = function () { return _this.closeModal(i); };
            forEach_default()(modal.events, function (event, listener) {
                events[listener] = function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    event(modal, args, close_1);
                };
            });
        }
        return events;
    };
    DynamicModal.prototype.buttonEvents = function (btnEvents, i) {
        var _this = this;
        var events = {};
        if (btnEvents) {
            var close_2 = function () { return _this.closeModal(i); };
            forEach_default()(btnEvents, function (event, listener) {
                events[listener] = function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    event(args, close_2);
                };
            });
        }
        return events;
    };
    DynamicModal = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('dynamicModals', ['instances'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('dynamicModals', ['closeModal'])),
            components: {
                FormModal: FormModal/* default */.A,
                BButton: external_bootstrap_vue_.BButton
            }
        })
    ], DynamicModal);
    return DynamicModal;
}(lib/* Vue */.lD));
/* harmony default export */ var DynamicModalvue_type_script_lang_ts_external = (DynamicModal);

;// ./src/components/DynamicModal/DynamicModal.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var DynamicModal_DynamicModalvue_type_script_lang_ts_external = (DynamicModalvue_type_script_lang_ts_external); 
;// ./src/components/DynamicModal/DynamicModal.vue





/* normalize component */
;
var DynamicModal_component = (0,componentNormalizer/* default */.A)(
  DynamicModal_DynamicModalvue_type_script_lang_ts_external,
  DynamicModalvue_type_template_id_1dad196d_render,
  DynamicModalvue_type_template_id_1dad196d_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DynamicModal_DynamicModal = (DynamicModal_component.exports);
// EXTERNAL MODULE: ./src/components/EmailVerification/EmailVerification.vue + 3 modules
var EmailVerification = __webpack_require__(1306);
// EXTERNAL MODULE: ./src/components/Error404/Error404.vue + 3 modules
var Error404 = __webpack_require__(8122);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/FileDelete/FileDelete.vue?vue&type=template&id=d2804c44
var FileDeletevue_type_template_id_d2804c44_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{attrs:{"cancel-title":_vm.$t('interface.cancel'),"ok-title":_vm.$t('interface.delete'),"visible":"","busy":_vm.loading,"hide-header-close":_vm.loading,"no-close-on-esc":_vm.loading,"no-close-on-backdrop":_vm.loading},on:{"ok":_vm.deleteFile,"hidden":_vm.hide}},[(_vm.loading)?_c('Spinner'):[_vm._v(" "+_vm._s(_vm.$t('interface.files.deleteMsg'))+" ")]],2)
}
var FileDeletevue_type_template_id_d2804c44_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/FileDelete/FileDelete.ts?vue&type=script&lang=ts&external




var FileDelete = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(FileDelete, _super);
    function FileDelete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        return _this;
    }
    FileDelete.prototype.deleteFile = function (event) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        this.loading = true;
                        return [4 /*yield*/, this.$kwInterface.axios.delete(this.baseUrl + '/' + this.value.id)
                                .then(function () {
                                _this.$emit('deleted');
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.loading = false;
                                _this.hide();
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    FileDelete.prototype.hide = function () {
        this.$emit('hidden');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], FileDelete.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: '/file' })
    ], FileDelete.prototype, "baseUrl", void 0);
    FileDelete = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BModal: external_bootstrap_vue_.BModal,
                Spinner: Spinner/* default */.A
            }
        })
    ], FileDelete);
    return FileDelete;
}(lib/* Vue */.lD));
/* harmony default export */ var FileDeletevue_type_script_lang_ts_external = (FileDelete);

;// ./src/components/FileDelete/FileDelete.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var FileDelete_FileDeletevue_type_script_lang_ts_external = (FileDeletevue_type_script_lang_ts_external); 
;// ./src/components/FileDelete/FileDelete.vue





/* normalize component */
;
var FileDelete_component = (0,componentNormalizer/* default */.A)(
  FileDelete_FileDeletevue_type_script_lang_ts_external,
  FileDeletevue_type_template_id_d2804c44_render,
  FileDeletevue_type_template_id_d2804c44_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FileDelete_FileDelete = (FileDelete_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/FileItem/FileItem.vue?vue&type=template&id=31b498cd
var FileItemvue_type_template_id_31b498cd_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"file text-center"},[_c('b-overlay',{attrs:{"show":_vm.loading}},[_c('div',{attrs:{"id":'file-' + _vm.value.id}},[_c('font-awesome-icon',{staticClass:"icon",style:({ color: _vm.fileIconColor(_vm.value.extension) }),attrs:{"icon":['fad', _vm.fileIcon(_vm.value.extension) ]}}),_c('span',{staticClass:"d-inline-block text-truncate w-100 small pt-1"},[_vm._v(" "+_vm._s(_vm.value.filename)+" ")])],1),_c('b-row',{staticClass:"actions px-0",attrs:{"no-gutters":"","cols":"3"}},[_c('b-col',[(_vm.fileCanBePreview(_vm.value.extension))?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.bottom",modifiers:{"bottom":true}}],staticClass:"btn-icon p-0",attrs:{"variant":"link","title":_vm.$t('interface.filePreview')},on:{"click":function($event){$event.preventDefault();_vm.preview = true}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'search' ]}})],1):_vm._e()],1),_c('b-col',[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.bottom",modifiers:{"bottom":true}}],staticClass:"btn-icon p-0",attrs:{"variant":"link","title":_vm.$t('interface.download')},on:{"click":function($event){$event.preventDefault();return _vm.download.apply(null, arguments)}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'download' ]}})],1)],1),(_vm.cantDelete === false)?_c('b-col',[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.bottom",modifiers:{"bottom":true}}],staticClass:"btn-icon p-0",attrs:{"variant":"link","title":_vm.$t('interface.delete')},on:{"click":function($event){$event.preventDefault();_vm.toDelete = true}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'trash' ]}})],1)],1):_vm._e()],1),_c('b-tooltip',_vm._b({},'b-tooltip',_vm.tooltipAttributes,false),[_c('p',{staticClass:"mb-1 text-left"},[_vm._v(_vm._s(_vm.value.filename))]),_c('p',{staticClass:"mb-0 text-left"},[_vm._v(_vm._s(_vm.$t('interface.files.weight'))+" : "+_vm._s(_vm.filesize(_vm.value.size)))]),_c('p',{staticClass:"mb-0 text-left"},[_vm._v(_vm._s(_vm.$t('interface.files.type'))+" : "+_vm._s(_vm.filetype(_vm.value.extension)))])]),(_vm.preview)?_c('FilePreview',{attrs:{"baseUrl":_vm.baseUrl},on:{"hidden":function($event){_vm.preview = false}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}):_vm._e(),(_vm.toDelete)?_c('FileDelete',{attrs:{"baseUrl":_vm.baseUrl},on:{"hidden":function($event){_vm.toDelete = false},"deleted":function($event){return _vm.$emit('deleted')}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}):_vm._e()],1)],1)
}
var FileItemvue_type_template_id_31b498cd_staticRenderFns = []


// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(9356);
// EXTERNAL MODULE: ./node_modules/lodash/assign.js
var lodash_assign = __webpack_require__(6139);
var assign_default = /*#__PURE__*/__webpack_require__.n(lodash_assign);
;// ./src/mixins/FileMixin.ts


var FileMixin = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(FileMixin, _super);
    function FileMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // Return filesize for human
    FileMixin.prototype.filesize = function (bytes, si, dp) {
        if (si === void 0) { si = true; }
        if (dp === void 0) { dp = 1; }
        var thresh = si ? 1000 : 1024;
        if (Math.abs(bytes) < thresh) {
            return bytes + ' B';
        }
        var units = si
            ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
            : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
        var u = -1;
        var r = Math.pow(10, dp);
        do {
            bytes /= thresh;
            ++u;
        } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);
        return bytes.toFixed(dp) + ' ' + units[u];
    };
    // Return filetype for human
    FileMixin.prototype.filetype = function (extension) {
        switch (extension) {
            case 'doc':
            case 'docx':
                return 'Word';
            case 'ppt':
            case 'pptx':
                return 'Powerpoint';
            case 'xls':
            case 'xlsx':
                return 'Excel';
            case 'mp3':
                return 'Audio';
            case 'avi':
                return 'Video';
            case 'jpg':
            case 'jpeg':
            case 'png':
                return 'Image';
            default:
                return extension.charAt(0).toUpperCase() + extension.slice(1);
        }
    };
    // Return fontawesome icon key
    FileMixin.prototype.fileIcon = function (extension) {
        switch (extension) {
            case 'doc':
            case 'docx':
                return 'file-word';
            case 'ppt':
            case 'pptx':
                return 'file-powerpoint';
            case 'pdf':
                return 'file-pdf';
            case 'xls':
            case 'xlsx':
                return 'file-excel';
            case 'csv':
                return 'file-csv';
            case 'zip':
            case 'rar':
                return 'file-archive';
            case 'mp3':
                return 'file-audio';
            case 'avi':
                return 'file-video';
            case 'jpg':
            case 'jpeg':
            case 'png':
                return 'file-image';
            default:
                return 'file-alt';
        }
    };
    // Return icon color to use
    FileMixin.prototype.fileIconColor = function (extension) {
        switch (extension) {
            case 'doc':
            case 'docx':
                return '#5959ff';
            case 'pdf':
                return '#f90d0d';
            case 'xls':
            case 'xlsx':
                return '#037d03';
            case 'jpg':
            case 'jpeg':
            case 'png':
                return '#ef7c03';
            default:
                return null;
        }
    };
    // If a file can be preview in App
    FileMixin.prototype.fileCanBePreview = function (extension) {
        return ['jpg', 'jpeg', 'png', 'pdf'].includes(extension);
    };
    // Transform a base64 file content in blob
    FileMixin.prototype.base64ToBlob = function (content, contentType, sliceSize) {
        if (contentType === void 0) { contentType = ''; }
        if (sliceSize === void 0) { sliceSize = 512; }
        var byteCharacters = atob(content);
        var byteArrays = [];
        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);
            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        return new Blob(byteArrays, { type: contentType });
    };
    // Download a file in navigator
    FileMixin.prototype.downloadFile = function (content, filename, isBase64) {
        if (isBase64 === void 0) { isBase64 = true; }
        var blob = isBase64 ? this.base64ToBlob(content) : new Blob([content]);
        var url = URL.createObjectURL(blob);
        var element = document.createElement('a');
        element.setAttribute('href', url);
        element.setAttribute('download', filename);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    };
    FileMixin = (0,tslib_es6/* __decorate */.Cg)([
        lib/* Component */.uA
    ], FileMixin);
    return FileMixin;
}(lib/* Vue */.lD));
/* harmony default export */ var mixins_FileMixin = (FileMixin);

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/FilePreview/FilePreview.vue?vue&type=template&id=c75e436c
var FilePreviewvue_type_template_id_c75e436c_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{attrs:{"size":"xxl","ok-only":"","ok-title":_vm.$t('interface.close'),"visible":"","content-class":"file-preview-modal","scrollable":""},on:{"hidden":function($event){return _vm.$emit('hidden')}}},[(_vm.loading)?_c('Spinner'):(_vm.file.extension === 'pdf')?_c('PdfViewer',{attrs:{"src":'data:application/pdf;base64,' + _vm.file.file}}):_c('img',{attrs:{"src":'data:image/' + _vm.file.extension + ';base64,' + _vm.file.file,"alt":_vm.$t('interface.preview')}})],1)
}
var FilePreviewvue_type_template_id_c75e436c_staticRenderFns = []


;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/PdfViewer/PdfViewer.vue?vue&type=template&id=646dd3f1
var PdfViewervue_type_template_id_646dd3f1_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pdf-viewer"},[_c('div',{ref:"pages",staticClass:"pdf-files",style:({ height: _vm.canvasHeight })},_vm._l((_vm.pageNums),function(pageNum){return _c('div',{key:pageNum,ref:"page",refInFor:true},[_c('canvas',{on:{"contextmenu":function($event){$event.preventDefault();}}})])}),0),_c('ul',{staticClass:"menu"},[_c('li',[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],attrs:{"title":_vm.$t('interface.print')},on:{"click":function($event){$event.preventDefault();return _vm.print.apply(null, arguments)}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'print']}})],1)],1),_c('li',[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],attrs:{"target":"_blank","title":_vm.$t('interface.download')},on:{"click":function($event){$event.preventDefault();return _vm.download.apply(null, arguments)}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'file-download']}})],1)],1)])])
}
var PdfViewervue_type_template_id_646dd3f1_staticRenderFns = []


;// external "pdfjs-dist/legacy/build/pdf.min.js"
var pdf_min_js_namespaceObject = require("pdfjs-dist/legacy/build/pdf.min.js");
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/PdfViewer/PdfViewer.ts?vue&type=script&lang=ts&external






var PdfViewer = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PdfViewer, _super);
    function PdfViewer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.document = null;
        _this.pageCount = null;
        _this.pageNums = [];
        _this.canvasHeight = null;
        return _this;
    }
    PdfViewer.prototype.watchSrc = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.load()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.renderPdf()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PdfViewer.prototype.load = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var documentLoadingTask, _a, e_1;
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        documentLoadingTask = pdf_min_js_namespaceObject.getDocument(this.src);
                        documentLoadingTask.onPassword = function (callback, reason) {
                            var retry = reason === pdf_min_js_namespaceObject.PasswordResponses.INCORRECT_PASSWORD;
                            _this.$emit('password-requested', callback, retry);
                        };
                        _a = this;
                        return [4 /*yield*/, documentLoadingTask.promise];
                    case 1:
                        _a.document = (_b.sent());
                        this.pageCount = this.document.numPages;
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _b.sent();
                        this.document = null;
                        this.pageCount = null;
                        this.pageNums = [];
                        this.$emit('loading-failed', e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    PdfViewer.prototype.getPageDimensions = function (ratio) {
        var width, height;
        if (this.height && !this.width) {
            height = Number(this.height);
            width = height / ratio;
        }
        else {
            width = Number(this.width) || (this.$el.clientWidth - 1);
            height = width * ratio;
        }
        return [width, height];
    };
    PdfViewer.prototype.renderPdf = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var document, div_1, e_2;
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        document = this.document;
                        if (!document) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        this.pageNums = this.page
                            ? [this.page]
                            : Array.from({ length: document.numPages + 1 }, function (v, i) { return i; }).slice(1);
                        div_1 = this.$refs.pages;
                        return [4 /*yield*/, Promise.all(this.pageNums.map(function (pageNum, i) { return (0,tslib_es6/* __awaiter */.sH)(_this, void 0, void 0, function () {
                                var page, children, canvas, _a, actualWidth, actualHeight, viewport;
                                return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                                    switch (_b.label) {
                                        case 0: return [4 /*yield*/, document.getPage(pageNum)];
                                        case 1:
                                            page = _b.sent();
                                            children = div_1.children[i].children;
                                            canvas = children[0];
                                            _a = this.getPageDimensions(page.view[3] / page.view[2]), actualWidth = _a[0], actualHeight = _a[1];
                                            viewport = page.getViewport({
                                                scale: Math.ceil(Number(actualWidth) / page.view[2]) + 1,
                                            });
                                            canvas.width = viewport.width;
                                            canvas.height = viewport.height;
                                            canvas.style.width = Math.floor(Number(actualWidth)) + "px";
                                            canvas.style.height = Math.floor(Number(actualHeight)) + "px";
                                            this.canvasHeight = canvas.style.height;
                                            return [4 /*yield*/, page.render({
                                                    canvasContext: canvas.getContext('2d'),
                                                    viewport: viewport,
                                                }).promise];
                                        case 2:
                                            _b.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 2:
                        _a.sent();
                        this.$emit('rendered');
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _a.sent();
                        this.document = null;
                        this.pageCount = null;
                        this.pageNums = [];
                        this.$emit('rendering-failed', e_2);
                        throw new Error(e_2);
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    PdfViewer.prototype.print = function () {
        var _this = this;
        var _a;
        (_a = this.document) === null || _a === void 0 ? void 0 : _a.getData().then(function (value) {
            var iframe = _this.$el.querySelector('iframe');
            if (!iframe) {
                iframe = document.createElement('iframe');
                iframe.style.display = 'none';
                iframe.onload = function () {
                    if (!(iframe === null || iframe === void 0 ? void 0 : iframe.src)) {
                        return;
                    }
                    var contentWindow = iframe === null || iframe === void 0 ? void 0 : iframe.contentWindow;
                    if (contentWindow) {
                        contentWindow.focus();
                        contentWindow.print();
                    }
                };
                _this.$el.prepend(iframe);
            }
            var blob = new Blob([value], { type: 'application/pdf' });
            iframe.src = URL.createObjectURL(blob);
        });
    };
    PdfViewer.prototype.download = function () {
        var _this = this;
        var _a;
        (_a = this.document) === null || _a === void 0 ? void 0 : _a.getData().then(function (value) {
            var blob = new Blob([value], { type: 'application/pdf' });
            var url = URL.createObjectURL(blob);
            var element = document.createElement('a');
            element.setAttribute('href', url);
            element.setAttribute('download', _this.filename);
            element.style.display = 'none';
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], PdfViewer.prototype, "src", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'document.pdf' })
    ], PdfViewer.prototype, "filename", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PdfViewer.prototype, "height", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PdfViewer.prototype, "width", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PdfViewer.prototype, "page", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('src', { immediate: true })
    ], PdfViewer.prototype, "watchSrc", null);
    PdfViewer = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                Spinner: Spinner/* default */.A,
                BButton: external_bootstrap_vue_.BButton
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], PdfViewer);
    return PdfViewer;
}(lib/* Vue */.lD));
/* harmony default export */ var PdfViewervue_type_script_lang_ts_external = (PdfViewer);

;// ./src/components/PdfViewer/PdfViewer.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var PdfViewer_PdfViewervue_type_script_lang_ts_external = (PdfViewervue_type_script_lang_ts_external); 
;// ./src/components/PdfViewer/PdfViewer.vue





/* normalize component */
;
var PdfViewer_component = (0,componentNormalizer/* default */.A)(
  PdfViewer_PdfViewervue_type_script_lang_ts_external,
  PdfViewervue_type_template_id_646dd3f1_render,
  PdfViewervue_type_template_id_646dd3f1_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PdfViewer_PdfViewer = (PdfViewer_component.exports);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/FilePreview/FilePreview.ts?vue&type=script&lang=ts&external





var FilePreview = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(FilePreview, _super);
    function FilePreview() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.file = null;
        return _this;
    }
    FilePreview.prototype.watchFile = function (file) {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.file = JSON.parse(JSON.stringify(file));
                        if (!!((_a = this.file) === null || _a === void 0 ? void 0 : _a.file)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.fetchFile()];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    FilePreview.prototype.fetchFile = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$kwInterface.axios.get(this.baseUrl + '/' + this.value.id + '?with_file=1')
                            .then(function (response) {
                            _this.file = response.data;
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], FilePreview.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: '/file' })
    ], FilePreview.prototype, "baseUrl", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], FilePreview.prototype, "watchFile", null);
    FilePreview = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BModal: external_bootstrap_vue_.BModal,
                PdfViewer: PdfViewer_PdfViewer,
                Spinner: Spinner/* default */.A
            }
        })
    ], FilePreview);
    return FilePreview;
}(lib/* Vue */.lD));
/* harmony default export */ var FilePreviewvue_type_script_lang_ts_external = (FilePreview);

;// ./src/components/FilePreview/FilePreview.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var FilePreview_FilePreviewvue_type_script_lang_ts_external = (FilePreviewvue_type_script_lang_ts_external); 
;// ./src/components/FilePreview/FilePreview.vue





/* normalize component */
;
var FilePreview_component = (0,componentNormalizer/* default */.A)(
  FilePreview_FilePreviewvue_type_script_lang_ts_external,
  FilePreviewvue_type_template_id_c75e436c_render,
  FilePreviewvue_type_template_id_c75e436c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FilePreview_FilePreview = (FilePreview_component.exports);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/FileItem/FileItem.ts?vue&type=script&lang=ts&external








var FileItem = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(FileItem, _super);
    function FileItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.toDelete = false;
        _this.preview = false;
        _this.loading = false;
        return _this;
    }
    Object.defineProperty(FileItem.prototype, "tooltipAttributes", {
        get: function () {
            return assign_default()(this.tooltipOpts, {
                target: 'file-' + this.value.id
            });
        },
        enumerable: false,
        configurable: true
    });
    FileItem.prototype.download = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.$kwInterface.axios.get(this.baseUrl + '/' + this.value.id + '?with_file=1')
                                .then(function (response) {
                                var file = response.data;
                                _this.downloadFile(file.file, file.filename);
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], FileItem.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], FileItem.prototype, "cantDelete", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: '/file' })
    ], FileItem.prototype, "baseUrl", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: function () { return ({}); } })
    ], FileItem.prototype, "tooltipOpts", void 0);
    FileItem = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BButton: external_bootstrap_vue_.BButton, BTooltip: external_bootstrap_vue_.BTooltip, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BOverlay: external_bootstrap_vue_.BOverlay,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                FilePreview: FilePreview_FilePreview,
                FileDelete: FileDelete_FileDelete,
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], FileItem);
    return FileItem;
}((0,lib/* Mixins */.Xe)(mixins_FileMixin)));
/* harmony default export */ var FileItemvue_type_script_lang_ts_external = (FileItem);

;// ./src/components/FileItem/FileItem.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var FileItem_FileItemvue_type_script_lang_ts_external = (FileItemvue_type_script_lang_ts_external); 
;// ./src/components/FileItem/FileItem.vue





/* normalize component */
;
var FileItem_component = (0,componentNormalizer/* default */.A)(
  FileItem_FileItemvue_type_script_lang_ts_external,
  FileItemvue_type_template_id_31b498cd_render,
  FileItemvue_type_template_id_31b498cd_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FileItem_FileItem = (FileItem_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/FilesList/FilesList.vue?vue&type=template&id=33d4eaf9
var FilesListvue_type_template_id_33d4eaf9_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"files-list"},[(_vm.readonly === false)?_c('k-form-file',{ref:"fileupload",attrs:{"name":"file","url":_vm.url,"datas":_vm.datas,"method":"post","multiple":"","removeUploadedFile":"","imagePreview":false,"btnMode":_vm.btnMode,"btnLabel":_vm.btnLabel,"btnSize":_vm.btnSize,"btnTheme":_vm.btnTheme},on:{"onUpload":_vm.onUpload}}):_vm._e(),_c('b-form-row',_vm._l((_vm.files),function(file,i){return _c('b-col',{key:i,staticClass:"file text-center mb-3",attrs:{"cols":"auto"}},[_c('FileItem',{attrs:{"value":file,"baseUrl":_vm.baseUrl,"cantDelete":_vm.readonly === false},on:{"deleted":function($event){return _vm.deleted(i)}}})],1)}),1)],1)
}
var FilesListvue_type_template_id_33d4eaf9_staticRenderFns = []


// EXTERNAL MODULE: ./src/mitt.ts + 1 modules
var mitt = __webpack_require__(6912);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/FilesList/FilesList.ts?vue&type=script&lang=ts&external







var FilesList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(FilesList, _super);
    function FilesList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.total = 0;
        _this.page = 1;
        _this.files = [];
        return _this;
    }
    Object.defineProperty(FilesList.prototype, "listenerEventName", {
        get: function () {
            return 'selectFiles-' + this.type + '-' + this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilesList.prototype, "url", {
        get: function () {
            return this.baseUrl +
                '?filter[elements][0][type]=' + this.type +
                '&filter[elements][0][id]=' + this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilesList.prototype, "datas", {
        get: function () {
            return {
                element_id: this.id,
                element_type: this.type
            };
        },
        enumerable: false,
        configurable: true
    });
    FilesList.prototype.created = function () {
        mitt/* default */.A.on(this.listenerEventName, this.selectFiles);
    };
    FilesList.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchFiles()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    FilesList.prototype.destroyed = function () {
        mitt/* default */.A.off(this.listenerEventName, this.selectFiles);
    };
    FilesList.prototype.selectFiles = function () {
        this.$refs.fileupload.selectFile();
    };
    FilesList.prototype.watchTotal = function (total) {
        this.$emit('total', total);
    };
    FilesList.prototype.watchUrl = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.reset()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    FilesList.prototype.reset = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.total = 0;
                        this.page = 1;
                        this.files = [];
                        return [4 /*yield*/, this.fetchFiles()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    FilesList.prototype.fetchFiles = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$kwInterface.axios.get(this.url)
                            .then(function (response) {
                            var _a;
                            var data = response.data;
                            (_a = _this.files).push.apply(_a, data.data);
                            _this.total = data.meta.total;
                            _this.page = data.meta.current_page;
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    FilesList.prototype.onUpload = function (file) {
        this.total++;
        this.files.push(file);
    };
    FilesList.prototype.deleted = function (index) {
        this.files.splice(index, 1);
        this.total--;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], FilesList.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], FilesList.prototype, "id", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: '/file' })
    ], FilesList.prototype, "baseUrl", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], FilesList.prototype, "btnMode", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'Sélectionner un fichier' })
    ], FilesList.prototype, "btnLabel", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], FilesList.prototype, "btnSize", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'primary' })
    ], FilesList.prototype, "btnTheme", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], FilesList.prototype, "readonly", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('total')
    ], FilesList.prototype, "watchTotal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('url')
    ], FilesList.prototype, "watchUrl", null);
    FilesList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                FileItem: FileItem_FileItem,
                KFormFile: form_vue_.KFormFileUpload,
                BFormRow: external_bootstrap_vue_.BFormRow,
                BCol: external_bootstrap_vue_.BCol
            }
        })
    ], FilesList);
    return FilesList;
}((0,lib/* Mixins */.Xe)(mixins_FileMixin)));
/* harmony default export */ var FilesListvue_type_script_lang_ts_external = (FilesList);

;// ./src/components/FilesList/FilesList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var FilesList_FilesListvue_type_script_lang_ts_external = (FilesListvue_type_script_lang_ts_external); 
;// ./src/components/FilesList/FilesList.vue





/* normalize component */
;
var FilesList_component = (0,componentNormalizer/* default */.A)(
  FilesList_FilesListvue_type_script_lang_ts_external,
  FilesListvue_type_template_id_33d4eaf9_render,
  FilesListvue_type_template_id_33d4eaf9_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FilesList_FilesList = (FilesList_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/FilesTab/FilesTab.vue?vue&type=template&id=433a438a
var FilesTabvue_type_template_id_433a438a_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-tab',[_c('template',{slot:"title"},[_vm._v(" "+_vm._s(_vm.$t('interface.files.tabTitle'))+" "),_c('b-badge',{staticClass:"ml-1",attrs:{"variant":_vm.active ? 'primary' : 'secondary'}},[_vm._v(_vm._s(_vm.total))]),_c('b-button',{staticClass:"p-0 pl-1",attrs:{"variant":"icon"},on:{"click":_vm.uploadFiles}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'plus-circle']}})],1)],1),_c('FilesList',{attrs:{"type":_vm.type,"id":_vm.id,"baseUrl":_vm.baseUrl},on:{"total":val => _vm.total = val}})],2)
}
var FilesTabvue_type_template_id_433a438a_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/FilesTab/FilesTab.ts?vue&type=script&lang=ts&external






var FilesTab = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(FilesTab, _super);
    function FilesTab() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.total = 0;
        return _this;
    }
    FilesTab.prototype.uploadFiles = function () {
        mitt/* default */.A.emit('selectFiles-' + this.type + '-' + this.id);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], FilesTab.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], FilesTab.prototype, "id", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], FilesTab.prototype, "active", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: '/file' })
    ], FilesTab.prototype, "baseUrl", void 0);
    FilesTab = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                FilesList: FilesList_FilesList,
                BTab: external_bootstrap_vue_.BTab, BBadge: external_bootstrap_vue_.BBadge, BButton: external_bootstrap_vue_.BButton,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            }
        })
    ], FilesTab);
    return FilesTab;
}(lib/* Vue */.lD));
/* harmony default export */ var FilesTabvue_type_script_lang_ts_external = (FilesTab);

;// ./src/components/FilesTab/FilesTab.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var FilesTab_FilesTabvue_type_script_lang_ts_external = (FilesTabvue_type_script_lang_ts_external); 
;// ./src/components/FilesTab/FilesTab.vue





/* normalize component */
;
var FilesTab_component = (0,componentNormalizer/* default */.A)(
  FilesTab_FilesTabvue_type_script_lang_ts_external,
  FilesTabvue_type_template_id_433a438a_render,
  FilesTabvue_type_template_id_433a438a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FilesTab_FilesTab = (FilesTab_component.exports);
// EXTERNAL MODULE: ./src/components/ForgotPassword/ForgotPassword.vue + 3 modules
var ForgotPassword = __webpack_require__(8000);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Header/Header.vue?vue&type=template&id=84d81418
var Headervue_type_template_id_84d81418_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"header"}},[((_vm.sidebarMode === 3 && !_vm.mobileSidebar) || !_vm.haveMainMenu)?_c('div',{attrs:{"id":"header-logo"}},[_c('img',{attrs:{"src":_vm.logo,"alt":"Logo"},on:{"click":function($event){$event.preventDefault();return _vm.goToHome.apply(null, arguments)}}})]):_vm._e(),((_vm.mobileSidebar || _vm.tabletSidebar) && _vm.haveMainMenu)?_c('font-awesome-icon',{staticClass:"sidebar-button",attrs:{"id":"mobile-sidebar-button","icon":['far', 'bars']},on:{"click":function($event){return _vm.changeSidebarHiddenState()}}}):(_vm.haveMainMenu)?_c('font-awesome-icon',{staticClass:"sidebar-button",attrs:{"id":"sidebar-button","icon":['far', 'bars']},on:{"click":function($event){return _vm.changeSidebarMode()}}}):(_vm.mobileSidebar && !_vm.haveMainMenu)?_c('font-awesome-icon',{staticClass:"sidebar-button",attrs:{"id":"mobile-sidebar-button","icon":['far', 'bars']},on:{"click":function($event){_vm.showHeaderMenu = !_vm.showHeaderMenu}}}):_vm._e(),(_vm.$kwInterface.showMainSearch === undefined || _vm.$kwInterface.showMainSearch(_vm.$store))?_c(_vm.searchComponent,{tag:"component"}):_vm._e(),_c('div',{staticClass:"center-part"},[(!_vm.mobileSidebar || (!_vm.haveMainMenu && _vm.showHeaderMenu))?_c('HeaderMenu'):_vm._e()],1),_c('ul',{staticClass:"secondary-menu"},[(_vm.$kwInterface.headerSecondaryMenu)?_vm._l((_vm.$kwInterface.headerSecondaryMenu),function(component,i){return _c('li',{key:i},[_c(component,{tag:"component"})],1)}):_vm._e(),(_vm.$kwInterface.notifications?.state)?_c('li',[_c('NotificationsHeader')],1):_vm._e()],2),_c('div',{staticClass:"right-menu"},[_c('UserMenu')],1)],1)
}
var Headervue_type_template_id_84d81418_staticRenderFns = []


;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/HeaderMenu/HeaderMenu.vue?vue&type=template&id=5f34c0fb
var HeaderMenuvue_type_template_id_5f34c0fb_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{class:{ 'header-menu-responsive': this.mobileSidebar },attrs:{"id":"header-menu"}},_vm._l((_vm.menu),function(entry,i){return _c('li',{key:i},[(entry.path)?_c('router-link',{staticClass:"element",attrs:{"to":entry.path}},[(entry.icon)?_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":entry.icon}}):_vm._e(),_c('span',{staticClass:"text"},[_vm._v(" "+_vm._s(entry.label)+" ")])],1):(entry.action)?_c('span',{staticClass:"element",on:{"click":function($event){$event.preventDefault();return entry.action.apply(null, arguments)}}},[(entry.icon)?_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":entry.icon}}):_vm._e(),_c('span',{staticClass:"text"},[_vm._v(" "+_vm._s(entry.label)+" ")])],1):_c('span',{class:{ element: true, active: _vm.subIsActive(entry.active)}},[(entry.icon)?_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":entry.icon}}):_vm._e(),_c('span',{staticClass:"text"},[_vm._v(" "+_vm._s(entry.label)+" ")]),_c('font-awesome-icon',{staticClass:"indicator-icon",attrs:{"icon":['fas', 'caret-down']}})],1),(entry.items)?_c('div',{staticClass:"dropdown"},[_c('p',{staticClass:"caret"}),_c('ul',_vm._l((_vm.subMenu(entry.items)),function(item,j){return _c('li',{key:j},[(item.path)?_c('router-link',{staticClass:"element",attrs:{"to":item.path}},[_c('span',{staticClass:"text"},[_vm._v(" "+_vm._s(item.label)+" ")]),(item.add && (item.addUserPermission === undefined || _vm.can(item.addUserPermission[0], item.addUserPermission[1])))?_c('font-awesome-icon',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: item.addTitle, placement: 'right' }),expression:"{ title: item.addTitle, placement: 'right' }"}],staticClass:"add-icon",attrs:{"icon":item.addIcon ? item.addIcon : ['fas', 'plus-circle']},on:{"mouseleave":function($event){item.addIcon = _vm.addIcon},"mouseover":function($event){item.addIcon = _vm.addIconHover},"click":function($event){$event.preventDefault();return item.add()}}}):_vm._e()],1):_vm._e()],1)}),0)]):_vm._e()],1)}),0)
}
var HeaderMenuvue_type_template_id_5f34c0fb_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/HeaderMenu/HeaderMenu.ts?vue&type=script&lang=ts&external





var HeaderMenu = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(HeaderMenu, _super);
    function HeaderMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.addIcon = ['fal', 'plus-circle'];
        _this.addIconHover = ['fas', 'plus-circle'];
        return _this;
    }
    Object.defineProperty(HeaderMenu.prototype, "menu", {
        get: function () {
            var _this = this;
            var _a;
            var menu = (_a = this.$kwInterface.headerMenu) !== null && _a !== void 0 ? _a : [];
            if (typeof menu === 'function') {
                menu = menu(this.$kwInterface.i18n);
            }
            return menu.filter(function (menu) {
                return _this.showMenuEntry(menu)
                    && (menu.userPermission === undefined || _this.can(menu.userPermission[0], menu.userPermission[1]));
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HeaderMenu.prototype, "subMenu", {
        get: function () {
            var _this = this;
            return function (menu) {
                return menu.filter(function (menu) {
                    return _this.showMenuEntry(menu)
                        && (menu.userPermission === undefined || _this.can(menu.userPermission[0], menu.userPermission[1]));
                });
            };
        },
        enumerable: false,
        configurable: true
    });
    HeaderMenu.prototype.showMenuEntry = function (entry) {
        var showMenuEntry = this.$kwInterface.showMenuEntry;
        return showMenuEntry ? showMenuEntry(entry, this.$kwInterface.store) : true;
    };
    HeaderMenu.prototype.subIsActive = function (input) {
        var _this = this;
        var paths = Array.isArray(input) ? input : [input];
        return paths.some(function (path) {
            return _this.$route.path.indexOf(path) === 0;
        });
    };
    HeaderMenu = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            },
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['can'])), (0,external_vuex_.mapGetters)('app', ['mobileSidebar'])),
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], HeaderMenu);
    return HeaderMenu;
}(lib/* Vue */.lD));
/* harmony default export */ var HeaderMenuvue_type_script_lang_ts_external = (HeaderMenu);

;// ./src/components/HeaderMenu/HeaderMenu.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var HeaderMenu_HeaderMenuvue_type_script_lang_ts_external = (HeaderMenuvue_type_script_lang_ts_external); 
;// ./src/components/HeaderMenu/HeaderMenu.vue





/* normalize component */
;
var HeaderMenu_component = (0,componentNormalizer/* default */.A)(
  HeaderMenu_HeaderMenuvue_type_script_lang_ts_external,
  HeaderMenuvue_type_template_id_5f34c0fb_render,
  HeaderMenuvue_type_template_id_5f34c0fb_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var HeaderMenu_HeaderMenu = (HeaderMenu_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/MainSearch/MainSearch.vue?vue&type=template&id=5b3f0743
var MainSearchvue_type_template_id_5b3f0743_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"main-search"}},[_c('font-awesome-icon',{staticClass:"search-button",attrs:{"icon":['fas', 'search']},on:{"click":_vm.openSearch}}),(_vm.activeSearch)?_c('div',{staticClass:"search-area"},[_c('div',{staticClass:"content"},[_c('k-form',{attrs:{"method":"post","action":"#"}},[_c('k-form-input',{attrs:{"id":"input-main-search","type":"text","placeholder":_vm.$t('interface.globalSearch')}}),_c('div',{staticClass:"close-search",on:{"click":function($event){_vm.activeSearch = false}}},[_c('font-awesome-icon',{attrs:{"icon":['far', 'times']}})],1)],1)],1)]):_vm._e()],1)
}
var MainSearchvue_type_template_id_5b3f0743_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/MainSearch/MainSearch.ts?vue&type=script&lang=ts&external





var MainSearch = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(MainSearch, _super);
    function MainSearch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.activeSearch = false;
        return _this;
    }
    MainSearch.prototype.openSearch = function () {
        var _this = this;
        this.activeSearch = true;
        this.$nextTick(function () {
            var input = _this.$el.querySelector('#input-main-search');
            input.focus();
        });
    };
    MainSearch.prototype.onSearchState = function (state) {
        if (state) {
            document.addEventListener('keydown', this.onKeyDown);
        }
        else {
            document.removeEventListener('keydown', this.onKeyDown);
        }
        this.setDynamicAppClass({
            'global-search-active': state
        });
    };
    MainSearch.prototype.onKeyDown = function (e) {
        if (e.key === 'Escape') {
            this.activeSearch = false;
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('activeSearch')
    ], MainSearch.prototype, "onSearchState", null);
    MainSearch = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('app', ['setDynamicAppClass'])),
            components: {
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput
            }
        })
    ], MainSearch);
    return MainSearch;
}(lib/* Vue */.lD));
/* harmony default export */ var MainSearchvue_type_script_lang_ts_external = (MainSearch);

;// ./src/components/MainSearch/MainSearch.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var MainSearch_MainSearchvue_type_script_lang_ts_external = (MainSearchvue_type_script_lang_ts_external); 
;// ./src/components/MainSearch/MainSearch.vue





/* normalize component */
;
var MainSearch_component = (0,componentNormalizer/* default */.A)(
  MainSearch_MainSearchvue_type_script_lang_ts_external,
  MainSearchvue_type_template_id_5b3f0743_render,
  MainSearchvue_type_template_id_5b3f0743_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var MainSearch_MainSearch = (MainSearch_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserMenu/UserMenu.vue?vue&type=template&id=63880eaa
var UserMenuvue_type_template_id_63880eaa_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{
    'user-menu': true,
    'user-menu-hover': _vm.display
  },on:{"mouseover":function($event){_vm.display = true; _vm.changeSidebarHiddenState(true)},"mouseleave":function($event){_vm.display = false}}},[_c('div',{staticClass:"link"},[_c('div',[_c('p',{staticClass:"username"},[_vm._v(" "+_vm._s(_vm.user.firstname)+" "+_vm._s(_vm.user.lastname)+" ")]),_c('p',{staticClass:"company-name"},[_vm._v(" "+_vm._s(_vm.team.company_name)+" ")])]),_c('b-avatar',{attrs:{"text":_vm.user.initials,"src":_vm.avatar}}),_c('font-awesome-icon',{attrs:{"icon":['fas', 'caret-down']}})],1),_c('div',{staticClass:"dropdown"},[_c('p',{staticClass:"caret"}),_c('ul',{staticClass:"submenu"},[(_vm.user.teamUsers.length > 1)?[_c('li',{staticClass:"px-2 pt-1"},[_c('p',{staticClass:"small mb-0"},[_vm._v(" "+_vm._s(_vm.$t('interface.user.switchAccount'))+" ")]),_c('b-dropdown',{staticClass:"w-100 team-selector-menu",attrs:{"variant":"outline-secondary","dropleft":""},scopedSlots:_vm._u([{key:"button-content",fn:function(){return [_c('span',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.team.company_name)+" ")])]},proxy:true}],null,false,4260167566)},_vm._l((_vm.user.teamUsers),function(element){return _c('b-dropdown-item',{key:element.id,attrs:{"disabled":_vm.teamUser.id === element.id,"link-class":{ 'text-primary': _vm.teamUser.id === element.id }},on:{"click":function($event){$event.preventDefault();return _vm.switchAccount(element)}}},[_vm._v(" "+_vm._s(element.team.company_name)+" ")])}),1),(_vm.confirm !== null)?_c('ConfirmModal',{attrs:{"message":""},on:{"hidden":function($event){_vm.confirm = null},"confirmed":function($event){return _vm.processSwitchAccount(_vm.confirm)}}},[_c('p',[_vm._v(" "+_vm._s(_vm.$t('interface.user.switchAccountConfirm1'))+" ")]),_vm._v(" "+_vm._s(_vm.$t('interface.user.switchAccountConfirm2'))+" ")]):_vm._e()],1),_c('li',{staticClass:"separator"})]:_vm._e(),_vm._l((_vm.menu),function(item,i){return _c('li',{key:i,class:{ separator: item.isSeparator }},[(item.to)?_c('b-button',{class:{
            'router-link-active': _vm.$route.matched.some(route => route.path.includes(item.to))
          },attrs:{"variant":"link","to":item.to},on:{"click":function($event){_vm.display = false}}},[_vm._v(" "+_vm._s(item.label)+" ")]):(item.component)?_c(item.component,_vm._g(_vm._b({tag:"component"},'component',item.attributes,false),item.events)):_vm._e()],1)})],2)])])
}
var UserMenuvue_type_template_id_63880eaa_staticRenderFns = []


;// ./src/mixins/UserFormMixin.ts



var UserFormMixin = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(UserFormMixin, _super);
    function UserFormMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.localUser = {};
        return _this;
    }
    UserFormMixin.prototype.mounted = function () {
        this.setLocalUser(this.user);
    };
    Object.defineProperty(UserFormMixin.prototype, "formAction", {
        get: function () {
            return '/user?with_file=1';
        },
        enumerable: false,
        configurable: true
    });
    UserFormMixin.prototype.formSubmitted = function (response) {
        this.applyNewUser(response.data);
    };
    UserFormMixin.prototype.setLocalUser = function (user) {
        this.localUser = JSON.parse(JSON.stringify(user));
    };
    UserFormMixin.prototype.applyNewUser = function (user) {
        this.setUser(user);
        this.localUser = user;
    };
    UserFormMixin.prototype.cancel = function () {
        this.setLocalUser(this.user);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('user')
    ], UserFormMixin.prototype, "setLocalUser", null);
    UserFormMixin = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('user', ['user'])),
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('user', ['setUser'])), (0,external_vuex_.mapActions)('globalDatas', ['setTeamUser']))
        })
    ], UserFormMixin);
    return UserFormMixin;
}(lib/* Vue */.lD));
/* harmony default export */ var mixins_UserFormMixin = (UserFormMixin);

;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/UserMenu/UserMenu.ts?vue&type=script&lang=ts&external








var UserMenu = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(UserMenu, _super);
    function UserMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.display = false;
        _this.confirm = null;
        return _this;
    }
    Object.defineProperty(UserMenu.prototype, "menu", {
        get: function () {
            var _this = this;
            var _a;
            var userMenu = (_a = this.$kwInterface.userMenu) !== null && _a !== void 0 ? _a : [];
            if (typeof userMenu === 'function') {
                userMenu = userMenu(this.$kwInterface.i18n);
            }
            return userMenu.filter(function (menu) {
                return _this.showMenuEntry(menu)
                    && (menu.userPermission === undefined || _this.can(menu.userPermission[0], menu.userPermission[1]));
            });
        },
        enumerable: false,
        configurable: true
    });
    UserMenu.prototype.showMenuEntry = function (entry) {
        var showMenuEntry = this.$kwInterface.showMenuEntry;
        return showMenuEntry ? showMenuEntry(entry, this.$kwInterface.store) : true;
    };
    UserMenu.prototype.switchAccount = function (teamUser) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var tabsNb;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tabsNb = Number(localStorage.getItem('tabs'));
                        if (tabsNb > 1) {
                            this.confirm = teamUser;
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.processSwitchAccount(teamUser)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    UserMenu.prototype.processSwitchAccount = function (teamUser) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var form;
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                this.setRouteLoadingState(true);
                form = new FormData();
                form.set('_method', 'PUT');
                form.set('active_team_user', String(teamUser.id));
                this.$kwInterface.axios.post(this.formAction, form)
                    .then(function (response) {
                    _this.applyNewUser(response.data);
                    _this.clearStore();
                    if (_this.$broadcast) {
                        _this.$broadcast.updateChannel('team');
                    }
                })
                    .finally(function () { return (0,tslib_es6/* __awaiter */.sH)(_this, void 0, void 0, function () {
                    return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                this.display = false;
                                this.setRouteLoadingState(false);
                                if (!(Object.keys(this.$route.params).length > 0 && this.$kwInterface.goToHome)) return [3 /*break*/, 2];
                                return [4 /*yield*/, this.$kwInterface.goToHome(this.$router, this.$store)];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2: return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    UserMenu = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Disconnect: Disconnect/* default */.A, ConfirmModal: ConfirmModal_ConfirmModal,
                BAvatar: external_bootstrap_vue_.BAvatar, BDropdown: external_bootstrap_vue_.BDropdown, BDropdownItem: external_bootstrap_vue_.BDropdownItem, BDropdownText: external_bootstrap_vue_.BDropdownText, BButton: external_bootstrap_vue_.BButton,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['team', 'avatar', 'can', 'teamUser'])),
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('auth', ['clearStore'])), (0,external_vuex_.mapActions)('app', ['setRouteLoadingState', 'changeSidebarHiddenState']))
        })
    ], UserMenu);
    return UserMenu;
}((0,lib/* Mixins */.Xe)(mixins_UserFormMixin)));
/* harmony default export */ var UserMenuvue_type_script_lang_ts_external = (UserMenu);

;// ./src/components/UserMenu/UserMenu.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var UserMenu_UserMenuvue_type_script_lang_ts_external = (UserMenuvue_type_script_lang_ts_external); 
;// ./src/components/UserMenu/UserMenu.vue





/* normalize component */
;
var UserMenu_component = (0,componentNormalizer/* default */.A)(
  UserMenu_UserMenuvue_type_script_lang_ts_external,
  UserMenuvue_type_template_id_63880eaa_render,
  UserMenuvue_type_template_id_63880eaa_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var UserMenu_UserMenu = (UserMenu_component.exports);
;// ./src/mixins/SidebarOptions.ts


var SidebarOptions = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SidebarOptions, _super);
    function SidebarOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SidebarOptions.prototype, "haveMainMenu", {
        get: function () {
            var _a;
            var options = this.$kwInterface;
            if (options.showSidebar !== undefined && !options.showSidebar(this.$store)) {
                return false;
            }
            var route = this.$route;
            var customMenu = null;
            var routeMenu = (_a = route.meta) === null || _a === void 0 ? void 0 : _a.mainMenu;
            if (routeMenu) {
                customMenu = routeMenu;
            }
            else {
                // If parent route has menu
                var parentMenu = route.matched.find(function (el) { return el.meta.mainMenu !== undefined; });
                if (parentMenu) {
                    customMenu = parentMenu.meta.mainMenu;
                }
            }
            return customMenu !== null || options.sidebarMenu !== false;
        },
        enumerable: false,
        configurable: true
    });
    SidebarOptions = (0,tslib_es6/* __decorate */.Cg)([
        lib/* Component */.uA
    ], SidebarOptions);
    return SidebarOptions;
}(lib/* Vue */.lD));
/* harmony default export */ var mixins_SidebarOptions = (SidebarOptions);

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/NotificationsHeader/NotificationsHeader.vue?vue&type=template&id=50c4b46e
var NotificationsHeadervue_type_template_id_50c4b46e_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"notifications-header",on:{"mouseenter":function($event){_vm.show = true},"mouseleave":function($event){_vm.show = false}}},[(_vm.loading)?_c('Spinner',{attrs:{"size":"1.5"}}):_c('div',{staticClass:"notifications-header-button",on:{"click":function($event){$event.preventDefault();return _vm.goToNotifications.apply(null, arguments)}}},[_c('font-awesome-icon',{staticClass:"menu-icon",attrs:{"icon":['fas', 'bell']}}),_c('b-badge',{staticClass:"menu-badge",attrs:{"pill":"","variant":_vm.headerNotificationsTotal > 0 ? 'primary' : 'light'}},[_vm._v(" "+_vm._s(_vm.headerNotificationsTotal)+" ")])],1),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"notifications-list"},[_c('div',{staticClass:"caret"}),_c('ul',[(_vm.headerNotifications.length === 0)?_c('li',{staticClass:"empty"},[_vm._v(" Aucune notification ")]):_vm._e(),_vm._l((_vm.headerNotifications),function(notification,i){return _c('li',{key:i},[_c('NotificationsItem',{on:{"input":_vm.notificationUpdated},model:{value:(_vm.headerNotifications[i]),callback:function ($$v) {_vm.$set(_vm.headerNotifications, i, $$v)},expression:"headerNotifications[i]"}})],1)}),(_vm.moreNotifications > 0)?_c('li',{staticClass:"more"},[_c('b-button',{staticClass:"p-0",attrs:{"variant":"link"},on:{"click":function($event){$event.preventDefault();return _vm.goToNotifications.apply(null, arguments)}}},[_vm._v(" Voir toutes les notifications ")])],1):_vm._e()],2)])],1)
}
var NotificationsHeadervue_type_template_id_50c4b46e_staticRenderFns = []


// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(622);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
// EXTERNAL MODULE: ./src/components/NotificationsItem/NotificationsItem.vue + 3 modules
var NotificationsItem = __webpack_require__(9450);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/NotificationsHeader/NotificationsHeader.ts?vue&type=script&lang=ts&external









var NotificationsHeader = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(NotificationsHeader, _super);
    function NotificationsHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.show = false;
        return _this;
    }
    NotificationsHeader.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadHeaderNotifications()];
                    case 1:
                        _a.sent();
                        this.loading = false;
                        mitt/* default */.A.on('notificationCreated', this.notificationCreated);
                        mitt/* default */.A.on('notificationUpdated', this.notificationUpdated);
                        return [2 /*return*/];
                }
            });
        });
    };
    NotificationsHeader.prototype.beforeDestroy = function () {
        mitt/* default */.A.off('notificationCreated', this.notificationCreated);
        mitt/* default */.A.off('notificationUpdated', this.notificationUpdated);
    };
    Object.defineProperty(NotificationsHeader.prototype, "moreNotifications", {
        get: function () {
            return this.headerNotificationsTotal - this.headerNotifications.length;
        },
        enumerable: false,
        configurable: true
    });
    NotificationsHeader.prototype.notificationCreated = function (notification) {
        this.addHeaderNotifications(notification);
    };
    NotificationsHeader.prototype.notificationUpdated = function (notification) {
        if (notification.read) {
            this.removeHeaderNotifications(notification);
        }
    };
    NotificationsHeader.prototype.goToNotifications = function () {
        this.$router.push({ name: 'notifications' });
        this.show = false;
    };
    NotificationsHeader = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                BBadge: external_bootstrap_vue_.BBadge, BButton: external_bootstrap_vue_.BButton,
                Spinner: Spinner/* default */.A,
                NotificationsItem: NotificationsItem/* default */.A
            },
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('notifications', ['loadHeaderNotifications', 'addHeaderNotifications', 'removeHeaderNotifications'])),
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('notifications', ['headerNotifications', 'headerNotificationsTotal']))
        })
    ], NotificationsHeader);
    return NotificationsHeader;
}((external_vue_default())));
/* harmony default export */ var NotificationsHeadervue_type_script_lang_ts_external = (NotificationsHeader);

;// ./src/components/NotificationsHeader/NotificationsHeader.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var NotificationsHeader_NotificationsHeadervue_type_script_lang_ts_external = (NotificationsHeadervue_type_script_lang_ts_external); 
;// ./src/components/NotificationsHeader/NotificationsHeader.vue





/* normalize component */
;
var NotificationsHeader_component = (0,componentNormalizer/* default */.A)(
  NotificationsHeader_NotificationsHeadervue_type_script_lang_ts_external,
  NotificationsHeadervue_type_template_id_50c4b46e_render,
  NotificationsHeadervue_type_template_id_50c4b46e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var NotificationsHeader_NotificationsHeader = (NotificationsHeader_component.exports);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Header/Header.ts?vue&type=script&lang=ts&external










var Header = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(Header, _super);
    function Header() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showHeaderMenu = false;
        return _this;
    }
    Object.defineProperty(Header.prototype, "logo", {
        get: function () {
            var _a;
            if (this.team.logo_sidebar_hidden) {
                return 'data:image/' + this.team.logo_sidebar_hidden.extension + ';base64,' + this.team.logo_sidebar_hidden.file;
            }
            var logo = this.app.logo_sidebar_hidden;
            if (logo && logo.file) {
                return 'data:image/' + logo.extension + ';base64,' + logo.file;
            }
            if ((_a = this.$kwInterface) === null || _a === void 0 ? void 0 : _a.sidebarHiddenLogo) {
                return this.$kwInterface.sidebarHiddenLogo;
            }
            var images = __webpack_require__(8141);
            return images('./logo-sidebar-alt.png');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Header.prototype, "searchComponent", {
        get: function () {
            var _a;
            if ((_a = this.$kwInterface) === null || _a === void 0 ? void 0 : _a.searchComponent) {
                return this.$kwInterface.searchComponent;
            }
            return MainSearch_MainSearch;
        },
        enumerable: false,
        configurable: true
    });
    Header.prototype.goToHome = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, lib/* Vue */.lD.prototype.$kwInterface.goToHome(this.$router, this.$store)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Header = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                BBadge: external_bootstrap_vue_.BBadge,
                HeaderMenu: HeaderMenu_HeaderMenu,
                UserMenu: UserMenu_UserMenu,
                NotificationsHeader: NotificationsHeader_NotificationsHeader
            },
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('app', [
                'sidebarHidden', 'app'
            ])), (0,external_vuex_.mapGetters)('app', [
                'mobileSidebar',
                'sidebarMode',
                'tabletSidebar'
            ])), (0,external_vuex_.mapGetters)('user', ['team'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('app', [
                'changeSidebarMode',
                'changeSidebarHiddenState'
            ]))
        })
    ], Header);
    return Header;
}((0,lib/* Mixins */.Xe)(mixins_SidebarOptions)));
/* harmony default export */ var Headervue_type_script_lang_ts_external = (Header);

;// ./src/components/Header/Header.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var Header_Headervue_type_script_lang_ts_external = (Headervue_type_script_lang_ts_external); 
;// ./src/components/Header/Header.vue





/* normalize component */
;
var Header_component = (0,componentNormalizer/* default */.A)(
  Header_Headervue_type_script_lang_ts_external,
  Headervue_type_template_id_84d81418_render,
  Headervue_type_template_id_84d81418_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Header_Header = (Header_component.exports);
// EXTERNAL MODULE: ./src/components/HistoricList/HistoricList.vue + 3 modules
var HistoricList = __webpack_require__(9209);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/HistoricTab/HistoricTab.vue?vue&type=template&id=fdbcc66e
var HistoricTabvue_type_template_id_fdbcc66e_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-tab',[_c('template',{slot:"title"},[_vm._v(" "+_vm._s(_vm.$t('interface.historics.tabTitle'))+" "),_c('b-badge',{staticClass:"ml-1",attrs:{"variant":_vm.active ? 'primary' : 'secondary'}},[_vm._v(_vm._s(_vm.total))])],1),_c('HistoricList',{attrs:{"type":_vm.type,"id":_vm.id},on:{"total":val => _vm.total = val}})],2)
}
var HistoricTabvue_type_template_id_fdbcc66e_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/HistoricTab/HistoricTab.ts?vue&type=script&lang=ts&external




var HistoricTab = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(HistoricTab, _super);
    function HistoricTab() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.total = 0;
        return _this;
    }
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], HistoricTab.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], HistoricTab.prototype, "id", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], HistoricTab.prototype, "active", void 0);
    HistoricTab = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                HistoricList: HistoricList/* default */.A,
                BTab: external_bootstrap_vue_.BTab, BBadge: external_bootstrap_vue_.BBadge
            }
        })
    ], HistoricTab);
    return HistoricTab;
}(lib/* Vue */.lD));
/* harmony default export */ var HistoricTabvue_type_script_lang_ts_external = (HistoricTab);

;// ./src/components/HistoricTab/HistoricTab.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var HistoricTab_HistoricTabvue_type_script_lang_ts_external = (HistoricTabvue_type_script_lang_ts_external); 
;// ./src/components/HistoricTab/HistoricTab.vue





/* normalize component */
;
var HistoricTab_component = (0,componentNormalizer/* default */.A)(
  HistoricTab_HistoricTabvue_type_script_lang_ts_external,
  HistoricTabvue_type_template_id_fdbcc66e_render,
  HistoricTabvue_type_template_id_fdbcc66e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var HistoricTab_HistoricTab = (HistoricTab_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/IFrame/IFrame.vue?vue&type=template&id=c50b0ddc
var IFramevue_type_template_id_c50b0ddc_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-friendly-iframe"})
}
var IFramevue_type_template_id_c50b0ddc_staticRenderFns = []


;// ./src/components/IFrame/utils.js
/* eslint-disable */
//borrowed from David Walsh : https://davidwalsh.name/javascript-debounce-function
function debounce(func, wait, immediate) {
  let timeout;

  return function () {
    const args = arguments;

    const later = function () {
      timeout = null;
      if (!immediate) func.apply(this, args);
    };

    const callNow = immediate && !timeout;

    clearTimeout(timeout);

    timeout = setTimeout(later, wait);

    if (callNow) func.apply(this, args);
  };
}

/* harmony default export */ var utils = ({
  debounce
});

;// external "uuid"
var external_uuid_namespaceObject = require("uuid");
;// ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/IFrame/IFrame.vue?vue&type=script&lang=js

/* eslint-disable */



/* harmony default export */ var IFramevue_type_script_lang_js = ({
  name: 'friendly-iframe',
  props: {
    src: {
      type: String,
      required: true
    },
    crossorigin: {
      type: String,
      required: false,
      default: 'anonymous'
    },
    target: {
      type: String,
      required: false,
      default: '_parent'
    },
    className: {
      type: String,
      required: false
    },
    allow: {
      type: String,
      required: false
    },
    name: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: false
    },
    sandbox: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      iframeEl: null,
      iframeLoadedMessage: `IFRAME_LOADED_${(0,external_uuid_namespaceObject.v4)()}`,
      iframeOnReadyStateChangeMessage: `IFRAME_ON_READ_STATE_CHANGE_${(0,external_uuid_namespaceObject.v4)()}`
    };
  },
  computed: {},
  watch: {
    src() {
      this.reinitIframe(this);
    }
  },
  methods: {
    removeIframe() {
      while (this.$el.firstChild) {
        this.$el.removeChild(this.$el.firstChild);
      }
    },
    setIframeUrl() {
      if (this.iframeEl.contentWindow === null) {
        setTimeout(this.setIframeUrl)
        return;
      }
      const iframeDoc = this.iframeEl.contentWindow.document;
      iframeDoc.open()
        .write(
          `
          <body onload="window.location.replace('${this.src}'); parent.postMessage('${this.iframeLoadedMessage}', '*')"></body>
          <script>
            window.document.onreadystatechange = function () {
              if (window.document.readyState === 'complete') {
                parent.postMessage('${this.iframeOnReadyStateChangeMessage}', '*')
              }
            };
          <\\/script>
          `
        );

      iframeDoc.close(); //iframe onload event happens
    },
    reinitIframe: utils.debounce(vm => {
      vm.removeIframe();
      vm.initIframe();
    }, 200),
    initIframe() {
      this.iframeEl = document.createElement('iframe');
      this.iframeEl.setAttribute('style', 'visibility: hidden; position: absolute; top: -99999px; border: none;');
      if (this.src) this.iframeEl.setAttribute('iframe-src', this.src);
      if (this.className) this.iframeEl.setAttribute('class', this.className);
      if (this.class) this.iframeEl.setAttribute('class', this.class);
      if (this.crossorigin) this.iframeEl.setAttribute('crossorigin', this.crossorigin);
      if (this.target) this.iframeEl.setAttribute('target', this.target);
      if (this.allow) this.iframeEl.setAttribute('allow', this.allow);
      if (this.name) this.iframeEl.setAttribute('name', this.name);
      if (this.title) this.iframeEl.setAttribute('title', this.title);
      if (this.sandbox) this.iframeEl.setAttribute('sandbox', this.sandbox);

      this.$el.appendChild(this.iframeEl);

      this.setIframeUrl();
    },
    listenForEvents() {
      // Create IE + others compatible event handler
      const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
      const eventer = window[eventMethod];
      const messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';

      // Listen to message from child window
      eventer(messageEvent, this.eventListener, false);
    },
    eventListener(event) {
      const data = event.data
      if (data === this.iframeLoadedMessage) {
        this.$emit('iframe-load');

        this.iframeEl.setAttribute('style', 'visibility: visible; border: none;');
        return;
      }

      if (data === this.iframeOnReadyStateChangeMessage) {
        this.$emit('load');
        return;
      }

      console.log(data)
      switch (data.type) {
        case 'link':
          this.$router.push(data.to)
          break;
      }
    }
  },
  mounted() {
    this.listenForEvents();

    this.initIframe();
  },
  beforeDestroy() {
    const eventMethod = window.removeEventListener ? 'removeEventListener' : 'detachEvent';
    const eventer = window[eventMethod];
    const messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';
    eventer(messageEvent, this.eventListener);
  }
});

;// ./src/components/IFrame/IFrame.vue?vue&type=script&lang=js
 /* harmony default export */ var IFrame_IFramevue_type_script_lang_js = (IFramevue_type_script_lang_js); 
;// ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/IFrame/IFrame.vue?vue&type=style&index=0&id=c50b0ddc&prod&lang=css
// extracted by mini-css-extract-plugin

;// ./src/components/IFrame/IFrame.vue?vue&type=style&index=0&id=c50b0ddc&prod&lang=css

;// ./src/components/IFrame/IFrame.vue



;


/* normalize component */

var IFrame_component = (0,componentNormalizer/* default */.A)(
  IFrame_IFramevue_type_script_lang_js,
  IFramevue_type_template_id_c50b0ddc_render,
  IFramevue_type_template_id_c50b0ddc_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var IFrame = (IFrame_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Interface/Interface.vue?vue&type=template&id=7ca2f1a2
var Interfacevue_type_template_id_7ca2f1a2_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.appClass,attrs:{"id":"app"}},[(_vm.appIsLoaded)?_c('AppUpdated'):_vm._e(),(((!_vm.user || _vm.$route.meta.isPublic) && _vm.routeLoading) || (!_vm.user && _vm.isAuth) || _vm.loading)?_c('div',{staticClass:"ajax-form-loading"},[_c('Spinner')],1):(_vm.$route.meta.isPublic)?[(_vm.$route.meta.noTemplate !== true)?_c('p',{staticClass:"logo"},[_c('img',{attrs:{"src":_vm.publicLogo,"alt":_vm.app.name}})]):_vm._e(),_c('router-view',{staticClass:"page-content"})]:(!_vm.isAuth)?_c('div',{staticClass:"speed-login"},[_c('p',{staticClass:"logo"},[_c('img',{attrs:{"src":_vm.publicLogo,"alt":_vm.app.name}})]),_c('Login',{attrs:{"email":_vm.user ? _vm.user.email : null,"readonlyEmail":"","canCreateAccount":false,"canResetPassword":false,"redirectAfterLogin":false}})],1):[(_vm.testMode)?_c('TestMode'):_vm._e(),_c('div',{attrs:{"id":"app-content"}},[(_vm.routeLoading)?_c('div',{staticClass:"ajax-form-loading"},[_c('Spinner')],1):_vm._e(),(_vm.withSidebar)?_c('Sidebar'):_vm._e(),_c('div',{attrs:{"id":"content"}},[(_vm.appIsLoaded)?_c(_vm.headerComponent,{tag:"component"}):_vm._e(),_c('div',{attrs:{"id":"page"}},[(!_vm.appIsLoaded)?_c('div',{staticClass:"ajax-form-loading"},[_c('Spinner')],1):_vm._e(),(_vm.appIsLoaded)?_c('div',{staticClass:"h-100 d-flex flex-column"},[_c('div',{staticClass:"page-container"},[(_vm.$route.meta.pageHeader !== false)?[_c('PageHeader',{attrs:{"use-meta":true,"title-cols":12,"title-cols-md":"*"}}),(_vm.$kwInterface.appMessages)?_c('AppMessages'):_vm._e()]:_vm._e(),_c('router-view',{staticClass:"page-content"})],2)]):_vm._e()])],1)],1),(_vm.appIsLoaded)?[_c('DynamicModal'),_c('NotificationsAlerts'),(_vm.$kwInterface.appComponents)?_vm._l((_vm.$kwInterface.appComponents),function(component,i){return _c(component,{key:i,tag:"component"})}):_vm._e()]:_vm._e(),(_vm.team && !_vm.team.account_installed && _vm.$kwInterface.broadcasts !== false)?_c('b-modal',{attrs:{"visible":"","no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","hide-footer":"","modal-class":"text-center"}},[_c('Spinner'),_vm._v(" "+_vm._s(_vm.$t('interface.accountInitialization'))+" ")],1):_vm._e()]],2)
}
var Interfacevue_type_template_id_7ca2f1a2_staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/lodash/merge.js
var merge = __webpack_require__(5364);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);
// EXTERNAL MODULE: ./src/components/PageHeader/PageHeader.vue + 3 modules
var PageHeader = __webpack_require__(6124);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Sidebar/Sidebar.vue?vue&type=template&id=3ce2ed17
var Sidebarvue_type_template_id_3ce2ed17_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"sidebar"}},[_c('div',{staticClass:"content",class:{
    'default': _vm.sidebarMode === 1,
    'collapsed': _vm.sidebarMode === 2 && _vm.sidebarHidden,
    'hidden': _vm.sidebarMode === 3,
    'show-absolute': (_vm.sidebarMode === 2 || _vm.sidebarMode === 3) && !_vm.sidebarHidden
  }},[_c('div',{staticClass:"header"},[_c('div',{attrs:{"id":"logo"}},[(_vm.$kwInterface.sidebarLogoComponent)?_c(_vm.$kwInterface.sidebarLogoComponent,{tag:"component"}):_c('img',{attrs:{"src":_vm.logo,"alt":"Logo"},on:{"click":function($event){$event.preventDefault();return _vm.goToHome.apply(null, arguments)}}})],1),(_vm.mobileSidebar || (_vm.tabletSidebar && !_vm.sidebarHidden))?_c('font-awesome-icon',{attrs:{"icon":['far', 'times'],"id":"hide-sidebar-button"},on:{"click":function($event){return _vm.changeSidebarHiddenState()}}}):_vm._e()],1),_c('MainMenu',{attrs:{"sidebarMode":_vm.sidebarMode}})],1)])
}
var Sidebarvue_type_template_id_3ce2ed17_staticRenderFns = []


;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/MainMenu/MainMenu.vue?vue&type=template&id=64c92770
var MainMenuvue_type_template_id_64c92770_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{attrs:{"id":"main-menu"}},_vm._l((_vm.sidebarMenu),function(entry,i){return _c('li',{key:i,class:entry.class},[(entry.path)?_c('b-button',{class:{
        element: true,
        'router-link-active': _vm.$route.matched.some(route => route.path.includes(entry.path))
      },attrs:{"variant":"link","to":entry.path},on:{"click":_vm.changeSidebarHiddenState}},[(entry.icon)?_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":entry.icon}}):_vm._e(),_c('span',{staticClass:"text"},[_vm._v(" "+_vm._s(entry.label)+" ")])],1):(entry.action)?_c('span',{staticClass:"element",on:{"click":function($event){$event.preventDefault();return entry.action.apply(null, arguments)}}},[(entry.icon)?_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":entry.icon}}):_vm._e(),_c('span',{staticClass:"text"},[_vm._v(" "+_vm._s(entry.label)+" ")])],1):_c('span',{class:{
        element: true,
        open: (entry.open || _vm.subIsActive(entry.active)) && _vm.sidebarMode !== 2,
        active: _vm.subIsActive(entry.active)
      },on:{"click":function($event){return _vm.openSubmenu(i)}}},[(entry.icon)?_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":entry.icon}}):_vm._e(),_c('span',{staticClass:"text"},[_vm._v(" "+_vm._s(entry.label)+" ")]),_c('font-awesome-icon',{staticClass:"indicator-icon",attrs:{"icon":['fas', entry.open || _vm.subIsActive(entry.active) || _vm.sidebarMode === 2 ? 'chevron-down' : 'chevron-right']}})],1),(entry.items)?_c('ul',{directives:[{name:"show",rawName:"v-show",value:(entry.open || _vm.subIsActive(entry.active) || _vm.sidebarMode === 2),expression:"entry.open || subIsActive(entry.active) || sidebarMode === 2"}]},_vm._l((_vm.subMenu(entry.items)),function(item,j){return _c('li',{key:j,class:item.class},[(item.path)?_c('b-button',{class:{
            element: true,
            'router-link-active': _vm.$route.matched.some(route => route.path.includes(item.path))
          },attrs:{"variant":"link","to":item.path},on:{"click":_vm.changeSidebarHiddenState}},[_c('font-awesome-icon',{staticClass:"list-icon",attrs:{"icon":['far', 'circle']}}),_c('span',{staticClass:"text"},[_vm._v(" "+_vm._s(item.label)+" ")]),((item.add || item.addModal || item.addRoute) && (item.addUserPermission === undefined || _vm.can(item.addUserPermission[0], item.addUserPermission[1])))?_c('font-awesome-icon',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: item.addTitle, placement: 'right', boundary: 'viewport' }),expression:"{ title: item.addTitle, placement: 'right', boundary: 'viewport' }"}],staticClass:"add-icon",attrs:{"icon":item.addIcon},on:{"mouseleave":function($event){item.addIcon = _vm.addIcon},"mouseover":function($event){item.addIcon = _vm.addIconHover},"click":function($event){$event.preventDefault();return _vm.processAction(item)}}}):_vm._e()],1):_vm._e()],1)}),0):_vm._e()],1)}),0)
}
var MainMenuvue_type_template_id_64c92770_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/MainMenu/MainMenu.ts?vue&type=script&lang=ts&external





var MainMenu = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(MainMenu, _super);
    function MainMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.addIcon = ['fal', 'plus-circle'];
        _this.addIconHover = ['fas', 'plus-circle'];
        _this.routeMenu = null;
        _this.localSidebarMenu = null;
        return _this;
    }
    Object.defineProperty(MainMenu.prototype, "menu", {
        get: function () {
            var _a;
            return (_a = this.localSidebarMenu) !== null && _a !== void 0 ? _a : [];
        },
        enumerable: false,
        configurable: true
    });
    MainMenu.prototype.mounted = function () {
        var menu = this.$kwInterface.sidebarMenu;
        if (typeof menu === 'function') {
            menu = menu(this.$kwInterface.i18n);
        }
        this.localSidebarMenu = menu;
        this.listenRouteMenu(this.$route);
    };
    Object.defineProperty(MainMenu.prototype, "sidebarMenu", {
        get: function () {
            var _this = this;
            var _a;
            var menu = (_a = this.routeMenu) !== null && _a !== void 0 ? _a : this.menu;
            return menu.filter(function (menu) {
                return _this.showMenuEntry(menu)
                    && (menu.userPermission === undefined || _this.can(menu.userPermission[0], menu.userPermission[1]));
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MainMenu.prototype, "subMenu", {
        get: function () {
            var _this = this;
            return function (menu) {
                return menu.filter(function (menu) {
                    return _this.showMenuEntry(menu)
                        && (menu.userPermission === undefined || _this.can(menu.userPermission[0], menu.userPermission[1]));
                });
            };
        },
        enumerable: false,
        configurable: true
    });
    MainMenu.prototype.showMenuEntry = function (entry) {
        var showMenuEntry = this.$kwInterface.showMenuEntry;
        return showMenuEntry ? showMenuEntry(entry, this.$kwInterface.store) : true;
    };
    MainMenu.prototype.processAction = function (entry) {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var routePath;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!entry.add) return [3 /*break*/, 1];
                        entry.add();
                        return [3 /*break*/, 4];
                    case 1:
                        if (!entry.addModal) return [3 /*break*/, 2];
                        this.openModal(entry.addModal);
                        return [3 /*break*/, 4];
                    case 2:
                        if (!entry.addRoute) return [3 /*break*/, 4];
                        routePath = typeof entry.addRoute === 'string' ? entry.addRoute : (_a = entry.addRoute) === null || _a === void 0 ? void 0 : _a.path;
                        if (!(routePath !== this.$route.path)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.$router.push(entry.addRoute)];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    MainMenu.prototype.listenRouteMenu = function (route) {
        var _a;
        var customMenu;
        // If route has custom menu
        var routeMenu = (_a = route.meta) === null || _a === void 0 ? void 0 : _a.mainMenu;
        if (routeMenu) {
            customMenu = routeMenu;
        }
        else {
            // If parent route has menu
            var parentMenu = route.matched.find(function (el) { return el.meta.mainMenu !== undefined; });
            if (parentMenu) {
                customMenu = parentMenu.meta.mainMenu;
            }
        }
        if (customMenu) {
            if (typeof customMenu === 'function') {
                customMenu = customMenu(this.$kwInterface.i18n);
            }
            customMenu = JSON.parse(JSON.stringify(customMenu));
            if (this.menu) {
                var back = this.menu.find(function (el) { return 'path' in el; });
                customMenu.unshift({
                    label: 'Retour',
                    icon: ['fas', 'caret-square-left'],
                    path: back.path,
                    class: 'backlink router-link-active'
                });
            }
        }
        this.routeMenu = customMenu;
    };
    MainMenu.prototype.subIsActive = function (input) {
        var _this = this;
        var paths = Array.isArray(input) ? input : [input];
        return paths.some(function (path) {
            return _this.$route.path.indexOf(path) === 0;
        });
    };
    MainMenu.prototype.openSubmenu = function (i) {
        var _this = this;
        this.sidebarMenu.forEach(function (entry, key) {
            if (!('open' in entry)) {
                return;
            }
            if (i !== key) {
                entry.open = false;
            }
            else if (entry.active && !_this.subIsActive(entry.active)) {
                entry.open = !entry.open;
            }
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)()
    ], MainMenu.prototype, "sidebarMode", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('$route')
    ], MainMenu.prototype, "listenRouteMenu", null);
    MainMenu = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('dynamicModals', ['openModal'])), (0,external_vuex_.mapActions)('app', ['changeSidebarHiddenState'])),
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['can'])),
            components: {
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                BButton: external_bootstrap_vue_.BButton
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], MainMenu);
    return MainMenu;
}(lib/* Vue */.lD));
/* harmony default export */ var MainMenuvue_type_script_lang_ts_external = (MainMenu);

;// ./src/components/MainMenu/MainMenu.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var MainMenu_MainMenuvue_type_script_lang_ts_external = (MainMenuvue_type_script_lang_ts_external); 
;// ./src/components/MainMenu/MainMenu.vue





/* normalize component */
;
var MainMenu_component = (0,componentNormalizer/* default */.A)(
  MainMenu_MainMenuvue_type_script_lang_ts_external,
  MainMenuvue_type_template_id_64c92770_render,
  MainMenuvue_type_template_id_64c92770_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var MainMenu_MainMenu = (MainMenu_component.exports);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Sidebar/Sidebar.ts?vue&type=script&lang=ts&external





var Sidebar = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(Sidebar, _super);
    function Sidebar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Sidebar.prototype, "logo", {
        get: function () {
            if (this.sidebarMode === 2 && this.sidebarHidden) {
                if (this.team.logo_sidebar_collapsed) {
                    return 'data:image/' + this.team.logo_sidebar_collapsed.extension + ';base64,' + this.team.logo_sidebar_collapsed.file;
                }
                var logo = this.app.logo_sidebar_collapsed;
                if (logo && logo.file) {
                    return 'data:image/' + logo.extension + ';base64,' + logo.file;
                }
            }
            else {
                if (this.team.logo_sidebar) {
                    return 'data:image/' + this.team.logo_sidebar.extension + ';base64,' + this.team.logo_sidebar.file;
                }
                var logo = this.app.logo_sidebar;
                if (logo && logo.file) {
                    return 'data:image/' + logo.extension + ';base64,' + logo.file;
                }
            }
            if (this.$kwInterface) {
                if (this.sidebarMode === 2 && this.$kwInterface.sidebarCollapsedLogo) {
                    return this.$kwInterface.sidebarCollapsedLogo;
                }
                else if (this.$kwInterface.sidebarLogo) {
                    return this.$kwInterface.sidebarLogo;
                }
            }
            var images = __webpack_require__(8141);
            return images('./logo-sidebar' +
                (this.sidebarMode === 2 && this.sidebarHidden ? '-collapsed' : '') +
                '.png');
        },
        enumerable: false,
        configurable: true
    });
    Sidebar.prototype.onSidebarChange = function () {
        if (this.sidebarMode === 3 && !this.mobileSidebar) {
            window.addEventListener('mousemove', this.onMouseMove);
        }
        else {
            window.removeEventListener('mousemove', this.onMouseMove);
        }
    };
    Sidebar.prototype.onMouseMove = function (e) {
        this.changeSidebarHiddenState((!this.sidebarHidden && e.clientX > 250) || (this.sidebarHidden && e.clientX > 5));
    };
    Sidebar.prototype.goToHome = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, lib/* Vue */.lD.prototype.$kwInterface.goToHome(this.$router, this.$store)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)()
    ], Sidebar.prototype, "menu", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('sidebarMode'),
        (0,lib/* Watch */.ox)('mobileSidebar')
    ], Sidebar.prototype, "onSidebarChange", null);
    Sidebar = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('app', [
                'sidebarHidden', 'app'
            ])), (0,external_vuex_.mapGetters)('app', [
                'sidebarMode',
                'mobileSidebar',
                'tabletSidebar'
            ])), (0,external_vuex_.mapGetters)('user', ['team'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('app', [
                'changeSidebarHiddenState'
            ])),
            components: {
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                MainMenu: MainMenu_MainMenu
            }
        })
    ], Sidebar);
    return Sidebar;
}(lib/* Vue */.lD));
/* harmony default export */ var Sidebarvue_type_script_lang_ts_external = (Sidebar);

;// ./src/components/Sidebar/Sidebar.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var Sidebar_Sidebarvue_type_script_lang_ts_external = (Sidebarvue_type_script_lang_ts_external); 
;// ./src/components/Sidebar/Sidebar.vue





/* normalize component */
;
var Sidebar_component = (0,componentNormalizer/* default */.A)(
  Sidebar_Sidebarvue_type_script_lang_ts_external,
  Sidebarvue_type_template_id_3ce2ed17_render,
  Sidebarvue_type_template_id_3ce2ed17_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Sidebar_Sidebar = (Sidebar_component.exports);
// EXTERNAL MODULE: ./src/components/Login/Login.vue + 3 modules
var Login = __webpack_require__(7033);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TestMode/TestMode.vue?vue&type=template&id=5d72f554
var TestModevue_type_template_id_5d72f554_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"test-mode-bar"},[_vm._v(" "+_vm._s(_vm.$t('interface.demoMode.label'))+" "),(_vm.can('app-configuration', 1))?_c('b-button',{attrs:{"size":"sm","variant":"secondary"},on:{"click":function($event){$event.preventDefault();_vm.modal = true}}},[_vm._v(" "+_vm._s(_vm.$t('interface.demoMode.outLabel'))+" ")]):_vm._e(),_c('b-modal',{attrs:{"modal-class":"test-mode-modal","ok-only":"","ok-title":_vm.$t('interface.close'),"size":"lg","no-close-on-backdrop":_vm.transferring,"no-close-on-esc":_vm.transferring,"hide-header":_vm.transferring,"hide-footer":_vm.transferring},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[(!_vm.isMaster && (_vm.transferring || _vm.team.test_mode_out === 2))?[_c('Spinner'),_c('p',{staticClass:"text-center mb-0"},[_vm._v(" "+_vm._s(_vm.$t('interface.demoMode.transferring'))+" ")])]:(_vm.team.test_mode_out === 1 || _vm.team.test_mode_out === 2)?[(_vm.transferring || _vm.team.test_mode_out === 2)?[_c('Spinner'),_c('p',{staticClass:"text-center mb-0"},[_vm._v(" "+_vm._s(_vm.$t('interface.demoMode.transferring'))+" ")])]:_vm._e(),_c('k-form',{class:{ 'd-none': _vm.transferring },attrs:{"action":"/out-test-mode","value":_vm.formDatas},on:{"beforeSubmit":_vm.beforeSubmit,"submitError":_vm.submitError}},[_c('b-alert',{staticClass:"mb-4 text-justify",attrs:{"variant":"warning","show":""}},[_vm._v(" "+_vm._s(_vm.$t('interface.demoMode.outExplain'))+" ")]),_c('p'),(_vm.availableDatas.length > 0)?_c('b-form-group',{staticClass:"mt-3 text-danger",attrs:{"label":_vm.$t('interface.demoMode.dontMigrateLabel')}},[_c('k-form-checkbox-group',{attrs:{"options":_vm.availableDatas,"text-field":"label","stacked":""},model:{value:(_vm.excludeDatas),callback:function ($$v) {_vm.excludeDatas=$$v},expression:"excludeDatas"}})],1):_vm._e(),_c('k-form-checkbox',{staticClass:"mt-4",attrs:{"name":"confirm"},model:{value:(_vm.confirm),callback:function ($$v) {_vm.confirm=$$v},expression:"confirm"}},[_c('span',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('interface.demoMode.confirm'))+" ")])]),(_vm.confirm)?_c('b-form-group',{staticClass:"mt-4",attrs:{"label":_vm.$t('interface.demoMode.password')}},[_c('k-form-input',{attrs:{"type":"password","name":"password","automaticRules":false,"required":""},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1):_vm._e(),_c('p',{staticClass:"text-center mb-0 mt-4"},[_c('b-button',{attrs:{"type":"submit","variant":"primary","disabled":!_vm.confirm}},[_vm._v(" "+_vm._s(_vm.$t('interface.demoMode.goRealLabel'))+" ")])],1)],1)]:_c('div',{staticClass:"text-center"},[_c('p',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('interface.demoMode.useInDemo'))+" ")]),_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.goOutDemoMode.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('interface.demoMode.outLabel'))+" ")])],1)],2),_c('b-modal',{attrs:{"visible":_vm.transfered && !_vm.isMaster,"cancel-title":_vm.$t('interface.demoMode.stayDemo'),"ok-title":_vm.$t('interface.demoMode.goRealLabel'),"size":"lg","no-close-on-backdrop":"","no-close-on-esc":"","hide-header":""},on:{"ok":_vm.goOutDemoMode}},[_c('p',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.$t('interface.demoMode.justMigrated'))+" ")]),_c('p',{staticClass:"text-center mb-0"},[_vm._v(" "+_vm._s(_vm.$t('interface.demoMode.goRealOrNot'))+" ")])]),_c('b-modal',{attrs:{"visible":_vm.transfered && _vm.isMaster,"ok-title":_vm.$t('interface.close'),"ok-only":"","modal-class":"text-center"},on:{"hidden":_vm.goOutDemoMode}},[_vm._v(" "+_vm._s(_vm.$t('interface.demoMode.migrated'))+" ")])],1)
}
var TestModevue_type_template_id_5d72f554_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/TestMode/TestMode.ts?vue&type=script&lang=ts&external







var TestMode = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TestMode, _super);
    function TestMode() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modal = false;
        _this.confirm = false;
        _this.transferring = false;
        _this.transfered = false;
        _this.password = null;
        _this.isMaster = false;
        _this.excludeDatas = [];
        return _this;
    }
    TestMode.prototype.mounted = function () {
        if (this.team.test_mode_out === 2) {
            this.modal = true;
            this.transferring = true;
        }
        mitt/* default */.A.on('demoModeTransferring', this.demoModeTransferring);
        mitt/* default */.A.on('demoModeTransferred', this.demoModeTransfered);
    };
    TestMode.prototype.destroyed = function () {
        mitt/* default */.A.off('demoModeTransferring', this.demoModeTransferring);
        mitt/* default */.A.off('demoModeTransferred', this.demoModeTransfered);
    };
    Object.defineProperty(TestMode.prototype, "availableDatas", {
        get: function () {
            var _a;
            return (_a = this.$kwInterface.testModeCanExclude) !== null && _a !== void 0 ? _a : [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TestMode.prototype, "formDatas", {
        get: function () {
            return {
                confirm: this.confirm,
                password: this.password,
                exclude: this.excludeDatas
            };
        },
        enumerable: false,
        configurable: true
    });
    TestMode.prototype.beforeSubmit = function () {
        this.isMaster = true;
        this.transferring = true;
    };
    TestMode.prototype.submitError = function () {
        this.isMaster = false;
        this.transferring = false;
    };
    TestMode.prototype.demoModeTransferring = function () {
        this.transferring = true;
        this.modal = true;
    };
    TestMode.prototype.demoModeTransfered = function () {
        if (this.modal) {
            this.transfered = true;
            this.transferring = false;
            this.modal = false;
        }
    };
    TestMode.prototype.goOutDemoMode = function () {
        var _this = this;
        this.setRouteLoadingState(true);
        this.setTestMode(false);
        this.$kwInterface.axios.get('/user?with_file=1')
            .then(function (response) {
            _this.setUser(response.data);
            _this.clearStore();
            _this.setRouteLoadingState(false);
        });
    };
    TestMode = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BButton: external_bootstrap_vue_.BButton, BModal: external_bootstrap_vue_.BModal, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup, BFormGroup: external_bootstrap_vue_.BFormGroup, BAlert: external_bootstrap_vue_.BAlert,
                KFormCheckboxGroup: form_vue_.KFormCheckboxGroup, KFormCheckbox: form_vue_.KFormCheckbox, KFormInput: form_vue_.KFormInput,
                Spinner: Spinner/* default */.A
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['team', 'can'])),
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('user', ['setTestMode', 'setUser'])), (0,external_vuex_.mapActions)('auth', ['clearStore'])), (0,external_vuex_.mapActions)('app', ['setRouteLoadingState']))
        })
    ], TestMode);
    return TestMode;
}(lib/* Vue */.lD));
/* harmony default export */ var TestModevue_type_script_lang_ts_external = (TestMode);

;// ./src/components/TestMode/TestMode.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var TestMode_TestModevue_type_script_lang_ts_external = (TestModevue_type_script_lang_ts_external); 
;// ./src/components/TestMode/TestMode.vue





/* normalize component */
;
var TestMode_component = (0,componentNormalizer/* default */.A)(
  TestMode_TestModevue_type_script_lang_ts_external,
  TestModevue_type_template_id_5d72f554_render,
  TestModevue_type_template_id_5d72f554_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TestMode_TestMode = (TestMode_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AppUpdated/AppUpdated.vue?vue&type=template&id=282299ce
var AppUpdatedvue_type_template_id_282299ce_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-toast',{attrs:{"no-auto-hide":"","solid":"","toaster":"b-toaster-top-center","toast-class":"app-updated-toaster","title":_vm.$t('interface.update.title', { name: _vm.app.name }),"variant":"danger"},model:{value:(_vm.appUpdated),callback:function ($$v) {_vm.appUpdated=$$v},expression:"appUpdated"}},[_c('p',{staticClass:"mb-1"},[_vm._v(" "+_vm._s(_vm.$t('interface.update.available'))+" ")]),_c('p',{staticClass:"text-center mb-0"},[_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.processUpdatedApp.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('interface.update.reload'))+" ")])],1),(_vm.openedTabsNumber)?_c('p',{staticClass:"small font-weight-bold mt-3"},[_vm._v(" "+_vm._s(_vm.$t('interface.update.warning', { name: _vm.app.name }))+" ")]):_vm._e(),(_vm.$kwInterface.appVersions)?_c('p',{staticClass:"text-center mb-0"},[_c('router-link',{staticClass:"font-weight-bold small",attrs:{"to":{ name: 'app-versions'},"target":"_blank"}},[_vm._v(" Consulter les notes de version ")])],1):_vm._e()])
}
var AppUpdatedvue_type_template_id_282299ce_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/AppUpdated/AppUpdated.ts?vue&type=script&lang=ts&external





var AppUpdated = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(AppUpdated, _super);
    function AppUpdated() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.appUpdated = false;
        return _this;
    }
    AppUpdated.prototype.mounted = function () {
        mitt/* default */.A.on('appUpdated', this.appVersionUpdated);
        mitt/* default */.A.on('processUpdateApp', this.updateApp);
    };
    AppUpdated.prototype.destroyed = function () {
        mitt/* default */.A.off('appUpdated', this.appVersionUpdated);
        mitt/* default */.A.off('processUpdateApp', this.updateApp);
    };
    Object.defineProperty(AppUpdated.prototype, "openedTabsNumber", {
        get: function () {
            return Number(localStorage.getItem('tabs'));
        },
        enumerable: false,
        configurable: true
    });
    AppUpdated.prototype.appVersionUpdated = function () {
        this.appUpdated = true;
    };
    AppUpdated.prototype.processUpdatedApp = function () {
        mitt/* default */.A.emit('processUpdateApp');
    };
    AppUpdated.prototype.updateApp = function () {
        window.location.reload(true);
    };
    AppUpdated = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BToast: external_bootstrap_vue_.BToast,
                BButton: external_bootstrap_vue_.BButton
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('app', ['app']))
        })
    ], AppUpdated);
    return AppUpdated;
}(lib/* Vue */.lD));
/* harmony default export */ var AppUpdatedvue_type_script_lang_ts_external = (AppUpdated);

;// ./src/components/AppUpdated/AppUpdated.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var AppUpdated_AppUpdatedvue_type_script_lang_ts_external = (AppUpdatedvue_type_script_lang_ts_external); 
;// ./src/components/AppUpdated/AppUpdated.vue





/* normalize component */
;
var AppUpdated_component = (0,componentNormalizer/* default */.A)(
  AppUpdated_AppUpdatedvue_type_script_lang_ts_external,
  AppUpdatedvue_type_template_id_282299ce_render,
  AppUpdatedvue_type_template_id_282299ce_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AppUpdated_AppUpdated = (AppUpdated_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/NotificationsAlerts/NotificationsAlerts.vue?vue&type=template&id=23304f4e
var NotificationsAlertsvue_type_template_id_23304f4e_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"notifications-alerts"},[_c('TransitionGroup',_vm._l((_vm.notifications),function(notification,i){return _c('NotificationsItem',{key:i,attrs:{"value":notification},on:{"click":function($event){return _vm.removeNotification(notification.id)},"mouseenter":function($event){return _vm.removeTimeout(notification.id)},"mouseleave":function($event){return _vm.initTimeout(notification.id)}}})}),1)],1)
}
var NotificationsAlertsvue_type_template_id_23304f4e_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/NotificationsAlerts/NotificationsAlerts.ts?vue&type=script&lang=ts&external




var NotificationsAlerts = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(NotificationsAlerts, _super);
    function NotificationsAlerts() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.notifications = [];
        _this.timeout = {};
        return _this;
    }
    NotificationsAlerts.prototype.mounted = function () {
        mitt/* default */.A.on('notificationCreated', this.notificationCreated);
    };
    NotificationsAlerts.prototype.beforeDestroy = function () {
        mitt/* default */.A.off('notificationCreated', this.notificationCreated);
    };
    NotificationsAlerts.prototype.notificationCreated = function (notification) {
        this.notifications.unshift(notification);
        this.initTimeout(notification.id);
    };
    NotificationsAlerts.prototype.removeTimeout = function (id) {
        if (this.timeout[id]) {
            clearTimeout(this.timeout[id]);
            delete this.timeout[id];
        }
    };
    NotificationsAlerts.prototype.initTimeout = function (id) {
        var _this = this;
        this.timeout[id] = setTimeout(function () {
            _this.removeNotification(id);
        }, 3000);
    };
    NotificationsAlerts.prototype.removeNotification = function (id) {
        this.removeTimeout(id);
        var index = this.notifications.findIndex(function (val) { return val.id === id; });
        if (index >= 0) {
            this.notifications.splice(index, 1);
        }
    };
    NotificationsAlerts = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                NotificationsItem: NotificationsItem/* default */.A
            }
        })
    ], NotificationsAlerts);
    return NotificationsAlerts;
}(lib/* Vue */.lD));
/* harmony default export */ var NotificationsAlertsvue_type_script_lang_ts_external = (NotificationsAlerts);

;// ./src/components/NotificationsAlerts/NotificationsAlerts.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var NotificationsAlerts_NotificationsAlertsvue_type_script_lang_ts_external = (NotificationsAlertsvue_type_script_lang_ts_external); 
;// ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/NotificationsAlerts/NotificationsAlerts.vue?vue&type=style&index=0&id=23304f4e&prod&lang=css
// extracted by mini-css-extract-plugin

;// ./src/components/NotificationsAlerts/NotificationsAlerts.vue?vue&type=style&index=0&id=23304f4e&prod&lang=css

;// ./src/components/NotificationsAlerts/NotificationsAlerts.vue



;


/* normalize component */

var NotificationsAlerts_component = (0,componentNormalizer/* default */.A)(
  NotificationsAlerts_NotificationsAlertsvue_type_script_lang_ts_external,
  NotificationsAlertsvue_type_template_id_23304f4e_render,
  NotificationsAlertsvue_type_template_id_23304f4e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var NotificationsAlerts_NotificationsAlerts = (NotificationsAlerts_component.exports);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Interface/Interface.ts?vue&type=script&lang=ts&external

















var Interface = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(Interface, _super);
    function Interface() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        return _this;
    }
    Object.defineProperty(Interface.prototype, "headerComponent", {
        get: function () {
            var _a;
            return (_a = this.$kwInterface.headerComponent) !== null && _a !== void 0 ? _a : Header_Header;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Interface.prototype, "publicLogo", {
        get: function () {
            var _a;
            var logo = this.app.logo_home;
            if (logo && logo.file) {
                return 'data:image/' + logo.extension + ';base64,' + logo.file;
            }
            if ((_a = this.$kwInterface) === null || _a === void 0 ? void 0 : _a.publicLogo) {
                return this.$kwInterface.publicLogo;
            }
            var images = __webpack_require__(8141);
            return images('./logo-public.png');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Interface.prototype, "appIsLoaded", {
        get: function () {
            return this.initialized;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Interface.prototype, "appClass", {
        get: function () {
            var _a;
            var defaultClass;
            if ((_a = this.$route.meta) === null || _a === void 0 ? void 0 : _a.isPublic) {
                defaultClass = {
                    'public-page': true
                };
            }
            else {
                defaultClass = {
                    'with-sidebar': this.sidebarMode === 1,
                    'with-short-sidebar': this.sidebarMode === 2,
                    'without-page-header': this.$route.meta !== undefined && this.$route.meta.pageHeader !== undefined && this.$route.meta.pageHeader === false,
                    fullscreen: this.fullscreenMode,
                    testMode: this.testMode
                };
            }
            var pagesClass = this.$route.matched.map(function (route) { var _a; return (_a = route.meta) === null || _a === void 0 ? void 0 : _a.appClass; }).filter(function (appClass) { return appClass !== undefined; });
            var routeClass = {};
            var routeName = this.$route.name;
            if (routeName) {
                routeClass['page-' + routeName] = true;
            }
            return merge_default().apply(void 0, (0,tslib_es6/* __spreadArrays */.aN)([defaultClass], pagesClass, [routeClass,
                this.dynamicAppClass]));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Interface.prototype, "withSidebar", {
        get: function () {
            var _a;
            var userProfileSidebar = !(this.$kwInterface.userProfileSidebar === false && this.$route.name === 'user-profile');
            return this.appIsLoaded && ((_a = this.$route.meta) === null || _a === void 0 ? void 0 : _a.sidebar) !== false && this.haveMainMenu && userProfileSidebar;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Interface.prototype, "favicon", {
        get: function () {
            var logo = this.app.favicon;
            if (logo && logo.file) {
                return 'data:image/' + logo.extension + ';base64,' + logo.file;
            }
            else if (this.$kwInterface.favicon) {
                return this.$kwInterface.favicon;
            }
            var images = __webpack_require__(8141);
            return images('./favicon.png');
        },
        enumerable: false,
        configurable: true
    });
    Interface.prototype.created = function () {
        window.addEventListener('resize', this.updateWindowWidth);
        window.addEventListener('load', this.windowLoad);
        window.addEventListener('unload', this.windowUnload);
    };
    Interface.prototype.mounted = function () {
        // this.parseLocationForModal()
    };
    Interface.prototype.watchInitialize = function (state) {
        if (state) {
            this.applyFavicon();
            this.applyColors();
        }
    };
    Interface.prototype.watchApp = function (app, oldApp) {
        if (this.initialized && app && oldApp) {
            this.applyFavicon();
            this.applyColors();
        }
    };
    Interface.prototype.watchIsAuth = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$nextTick(function () { return (0,tslib_es6/* __awaiter */.sH)(_this, void 0, void 0, function () {
                            var _a;
                            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        if (!(this.isAuth && ((_a = this.$route.meta) === null || _a === void 0 ? void 0 : _a.onlyGuest) && this.$kwInterface.goToHome)) return [3 /*break*/, 2];
                                        return [4 /*yield*/, this.$kwInterface.goToHome(this.$router, this.$store)];
                                    case 1:
                                        _b.sent();
                                        _b.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Interface.prototype.watchTeamId = function () {
        var _this = this;
        this.loading = true;
        this.$nextTick(function () {
            _this.loading = false;
        });
    };
    // When a window is open
    Interface.prototype.windowLoad = function () {
        var _a;
        var tabsNb = (_a = (Number(localStorage.getItem('tabs')) + 1)) !== null && _a !== void 0 ? _a : 1;
        localStorage.setItem('tabs', String(tabsNb));
    };
    // When a window is closed
    Interface.prototype.windowUnload = function () {
        var _a;
        // Get the number of opened tab
        var tabsNb = (_a = (Number(localStorage.getItem('tabs')) - 1)) !== null && _a !== void 0 ? _a : 0;
        if (tabsNb < 0) {
            tabsNb = 0;
        }
        if (tabsNb === 0) {
            // if the last tab is closed, clear all the localstorage
            localStorage.removeItem('tabs');
            localStorage.removeItem('vuex-multi-tab');
        }
        else {
            // Update the number of opened tab in localstorage
            localStorage.setItem('tabs', String(tabsNb));
        }
    };
    Interface.prototype.parseLocationForModal = function () {
        var hash = window.location.hash;
        if (hash.substr(0, 7) === '#modal-') {
            this.openModal(hash.substr(7));
        }
    };
    Interface.prototype.applyFavicon = function () {
        var favicon = window.document.querySelector('link[rel="icon"]');
        if (favicon) {
            favicon.setAttribute('href', this.favicon);
            return;
        }
        favicon = window.document.createElement('link');
        favicon.setAttribute('rel', 'icon');
        favicon.setAttribute('href', this.favicon);
        window.document.head.append(favicon);
    };
    Interface.prototype.applyColors = function () {
        var _this = this;
        var style = document.documentElement.style;
        forEach_default()(this.app.colors, function (color, key) {
            if (_this.teamConfigs['app_color_' + key]) {
                color = _this.teamConfigs['app_color_' + key];
            }
            if (!color) {
                return;
            }
            style.setProperty('--' + key.replaceAll('_', '-'), color);
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('initialized')
    ], Interface.prototype, "watchInitialize", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('app', { deep: true }),
        (0,lib/* Watch */.ox)('teamConfigs', { deep: true })
    ], Interface.prototype, "watchApp", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('isAuth')
    ], Interface.prototype, "watchIsAuth", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('team.id')
    ], Interface.prototype, "watchTeamId", null);
    Interface = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                AppUpdated: AppUpdated_AppUpdated,
                DynamicModal: DynamicModal_DynamicModal,
                Header: Header_Header,
                PageHeader: PageHeader/* default */.A,
                Sidebar: Sidebar_Sidebar,
                Spinner: Spinner/* default */.A,
                Login: Login/* default */.A,
                TestMode: TestMode_TestMode,
                BModal: external_bootstrap_vue_.BModal,
                NotificationsAlerts: NotificationsAlerts_NotificationsAlerts,
                AppMessages: AppMessages/* default */.A
            },
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('user', ['user'])), (0,external_vuex_.mapGetters)('user', ['teamConfigs', 'timezone', 'testMode', 'team'])), (0,external_vuex_.mapState)('app', ['initialized', 'app', 'fullscreenMode', 'dynamicAppClass', 'routeLoading'])), (0,external_vuex_.mapGetters)('app', ['sidebarMode'])), (0,external_vuex_.mapGetters)('auth', ['isAuth'])),
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('app', ['updateWindowWidth'])), (0,external_vuex_.mapActions)('dynamicModals', ['openModal']))
        })
    ], Interface);
    return Interface;
}((0,lib/* Mixins */.Xe)(mixins_SidebarOptions)));
/* harmony default export */ var Interfacevue_type_script_lang_ts_external = (Interface);

;// ./src/components/Interface/Interface.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var Interface_Interfacevue_type_script_lang_ts_external = (Interfacevue_type_script_lang_ts_external); 
;// ./src/components/Interface/Interface.vue





/* normalize component */
;
var Interface_component = (0,componentNormalizer/* default */.A)(
  Interface_Interfacevue_type_script_lang_ts_external,
  Interfacevue_type_template_id_7ca2f1a2_render,
  Interfacevue_type_template_id_7ca2f1a2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Interface_Interface = (Interface_component.exports);
// EXTERNAL MODULE: ./src/components/NotificationsConfig/NotificationsConfig.vue + 3 modules
var NotificationsConfig = __webpack_require__(768);
// EXTERNAL MODULE: ./src/components/NotificationsList/NotificationsList.vue + 4 modules
var NotificationsList = __webpack_require__(5713);
// EXTERNAL MODULE: ./src/components/PageHeaderButtons/PageHeaderButtons.vue + 3 modules
var PageHeaderButtons = __webpack_require__(3615);
// EXTERNAL MODULE: ./src/components/Password/Password.vue + 3 modules
var Password = __webpack_require__(593);
// EXTERNAL MODULE: ./src/components/PaymentMethods/PaymentMethods.vue + 3 modules
var PaymentMethods = __webpack_require__(9017);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/PaymentMethodSelect/PaymentMethodSelect.vue?vue&type=template&id=1d18caf4
var PaymentMethodSelectvue_type_template_id_1d18caf4_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form-select',_vm._g(_vm._b({attrs:{"options":_vm.paymentMethods}},'k-form-select',_vm.attributes,false),_vm.$listeners))
}
var PaymentMethodSelectvue_type_template_id_1d18caf4_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/PaymentMethodSelect/PaymentMethodSelect.ts?vue&type=script&lang=ts&external




var PaymentMethodSelect = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PaymentMethodSelect, _super);
    function PaymentMethodSelect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PaymentMethodSelect.prototype.created = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadPaymentMethods()];
                    case 1:
                        _a.sent();
                        if (this.selectFirst !== false && !this.value && this.paymentMethods.length > 0) {
                            this.$emit('input', this.paymentMethods[0]);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(PaymentMethodSelect.prototype, "attributes", {
        get: function () {
            return Object.assign({}, {
                value: this.value,
                clearable: false
            }, this.$attrs);
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], PaymentMethodSelect.prototype, "selectFirst", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PaymentMethodSelect.prototype, "value", void 0);
    PaymentMethodSelect = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadPaymentMethods'])),
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('globalDatas', ['paymentMethods'])),
            components: {
                KFormSelect: form_vue_.KFormSelect
            }
        })
    ], PaymentMethodSelect);
    return PaymentMethodSelect;
}(lib/* Vue */.lD));
/* harmony default export */ var PaymentMethodSelectvue_type_script_lang_ts_external = (PaymentMethodSelect);

;// ./src/components/PaymentMethodSelect/PaymentMethodSelect.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var PaymentMethodSelect_PaymentMethodSelectvue_type_script_lang_ts_external = (PaymentMethodSelectvue_type_script_lang_ts_external); 
;// ./src/components/PaymentMethodSelect/PaymentMethodSelect.vue





/* normalize component */
;
var PaymentMethodSelect_component = (0,componentNormalizer/* default */.A)(
  PaymentMethodSelect_PaymentMethodSelectvue_type_script_lang_ts_external,
  PaymentMethodSelectvue_type_template_id_1d18caf4_render,
  PaymentMethodSelectvue_type_template_id_1d18caf4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PaymentMethodSelect_PaymentMethodSelect = (PaymentMethodSelect_component.exports);
// EXTERNAL MODULE: ./src/components/PaymentTermForm/PaymentTermForm.vue + 3 modules
var PaymentTermForm = __webpack_require__(6890);
// EXTERNAL MODULE: ./src/components/PaymentTerms/PaymentTerms.vue + 3 modules
var PaymentTerms = __webpack_require__(4043);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/PaymentTermSelect/PaymentTermSelect.vue?vue&type=template&id=ceb7772c
var PaymentTermSelectvue_type_template_id_ceb7772c_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form-select',_vm._g(_vm._b({attrs:{"options":_vm.paymentTerms}},'k-form-select',_vm.attributes,false),_vm.$listeners))
}
var PaymentTermSelectvue_type_template_id_ceb7772c_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/PaymentTermSelect/PaymentTermSelect.ts?vue&type=script&lang=ts&external




var PaymentTermSelect = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PaymentTermSelect, _super);
    function PaymentTermSelect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PaymentTermSelect.prototype.created = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadPaymentTerms()];
                    case 1:
                        _a.sent();
                        if (this.selectFirst !== false && !this.value && this.paymentTerms.length > 0) {
                            this.$emit('input', this.paymentTerms[0]);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(PaymentTermSelect.prototype, "attributes", {
        get: function () {
            return Object.assign({}, {
                value: this.value,
                clearable: false
            }, this.$attrs);
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], PaymentTermSelect.prototype, "selectFirst", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PaymentTermSelect.prototype, "value", void 0);
    PaymentTermSelect = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadPaymentTerms'])),
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('globalDatas', ['paymentTerms'])),
            components: {
                KFormSelect: form_vue_.KFormSelect
            }
        })
    ], PaymentTermSelect);
    return PaymentTermSelect;
}(lib/* Vue */.lD));
/* harmony default export */ var PaymentTermSelectvue_type_script_lang_ts_external = (PaymentTermSelect);

;// ./src/components/PaymentTermSelect/PaymentTermSelect.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var PaymentTermSelect_PaymentTermSelectvue_type_script_lang_ts_external = (PaymentTermSelectvue_type_script_lang_ts_external); 
;// ./src/components/PaymentTermSelect/PaymentTermSelect.vue





/* normalize component */
;
var PaymentTermSelect_component = (0,componentNormalizer/* default */.A)(
  PaymentTermSelect_PaymentTermSelectvue_type_script_lang_ts_external,
  PaymentTermSelectvue_type_template_id_ceb7772c_render,
  PaymentTermSelectvue_type_template_id_ceb7772c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PaymentTermSelect_PaymentTermSelect = (PaymentTermSelect_component.exports);
// EXTERNAL MODULE: ./src/components/Register/Register.vue + 3 modules
var Register = __webpack_require__(9727);
// EXTERNAL MODULE: ./src/components/ResetPassword/ResetPassword.vue + 3 modules
var ResetPassword = __webpack_require__(3048);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Tabs/Tab.vue?vue&type=template&id=4462556e
var Tabvue_type_template_id_4462556e_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return ((_vm.parentTabs && _vm.parentTabs.lazy === false && _vm.lazy === false) || _vm.actived)?_c(_vm.tag,{tag:"component",class:_vm.panelClass},[_vm._t("default")],2):_vm._e()
}
var Tabvue_type_template_id_4462556e_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Tabs/Tab.ts?vue&type=script&lang=ts&external



var Tab = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(Tab, _super);
    function Tab() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.actived = false;
        _this.parentTabs = null;
        return _this;
    }
    Tab.prototype.mounted = function () {
        this.parentTabs = this.getParentTabs();
        this.parentTabs && this.parentTabs.registerTab(this);
    };
    Tab.prototype.destroyed = function () {
        this.parentTabs && this.parentTabs.unregisterTab(this);
    };
    Object.defineProperty(Tab.prototype, "panelClass", {
        get: function () {
            var _a, _b;
            var cssClass = {
                'tab-pane': true,
                show: this.actived,
                active: this.actived,
                'card-body': this.parentTabs !== null && this.parentTabs.card !== false && this.noBody === false
            };
            if (this.actived && ((_a = this.parentTabs) === null || _a === void 0 ? void 0 : _a.activeTabClass)) {
                var tabClass = (_b = this.parentTabs) === null || _b === void 0 ? void 0 : _b.activeTabClass;
                if (typeof tabClass === 'string') {
                    cssClass[tabClass] = true;
                }
                else if (typeof tabClass === 'object') {
                    cssClass = merge_default()(cssClass, tabClass);
                }
            }
            return cssClass;
        },
        enumerable: false,
        configurable: true
    });
    Tab.prototype.watchActive = function (state) {
        var _this = this;
        if (state !== false) {
            this.$nextTick(function () {
                var _a;
                (_a = _this.parentTabs) === null || _a === void 0 ? void 0 : _a.activeTab(_this);
            });
        }
    };
    Tab.prototype.onClick = function (evt) {
        var _a;
        (_a = this.parentTabs) === null || _a === void 0 ? void 0 : _a.changeTab(this);
        this.$emit('click', evt);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Inject */.y_)({ from: 'getParentTabs', default: function () { return null; } })
    ], Tab.prototype, "getParentTabs", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], Tab.prototype, "title", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], Tab.prototype, "noBody", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], Tab.prototype, "titleLinkClass", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], Tab.prototype, "titleLinkAttributes", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], Tab.prototype, "titleItemClass", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], Tab.prototype, "lazy", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'div' })
    ], Tab.prototype, "tag", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], Tab.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], Tab.prototype, "buttonId", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], Tab.prototype, "active", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], Tab.prototype, "group", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], Tab.prototype, "groupSlot", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], Tab.prototype, "groupDividerBefore", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('active', { immediate: true })
    ], Tab.prototype, "watchActive", null);
    Tab = (0,tslib_es6/* __decorate */.Cg)([
        lib/* Component */.uA
    ], Tab);
    return Tab;
}(lib/* Vue */.lD));
/* harmony default export */ var Tabvue_type_script_lang_ts_external = (Tab);

;// ./src/components/Tabs/Tab.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var Tabs_Tabvue_type_script_lang_ts_external = (Tabvue_type_script_lang_ts_external); 
;// ./src/components/Tabs/Tab.vue





/* normalize component */
;
var Tab_component = (0,componentNormalizer/* default */.A)(
  Tabs_Tabvue_type_script_lang_ts_external,
  Tabvue_type_template_id_4462556e_render,
  Tabvue_type_template_id_4462556e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Tabs_Tab = (Tab_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Tabs/Tabs.vue?vue&type=template&id=5821f9d0
var Tabsvue_type_template_id_5821f9d0_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.tag,{tag:"component",class:_vm.tabsClass},[(_vm.end === false)?_c('div',{class:_vm.headerClass},[_c('TabNav')],1):_vm._e(),_c('div',{class:_vm.tabContentClass},[(_vm.registeredTabs.length === 0)?_vm._t("empty"):_vm._e(),_vm._t("default")],2),(_vm.end !== false)?_c('div',{class:_vm.footerClass},[_c('TabNav')],1):_vm._e()])
}
var Tabsvue_type_template_id_5821f9d0_staticRenderFns = []


;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Tabs/TabNav.vue?vue&type=template&id=01bb0222
var TabNavvue_type_template_id_01bb0222_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.parentTabs)?_c('ul',{class:_vm.navClass},[(_vm.parentTabs.$slots['tabs-start'])?_c('vnodes',{attrs:{"vnodes":_vm.parentTabs.$slots['tabs-start']}}):_vm._e(),_vm._l((_vm.tabsButtons),function(tab,i){return _c('li',{key:i,class:_vm.navItemClass(tab)},[('isDropdown' in tab)?_c('b-dropdown',_vm._b({staticClass:"p-0",attrs:{"variant":"link","toggle-tag":"a","toggle-class":_vm.dropdownClass(tab)},scopedSlots:_vm._u([{key:"button-content",fn:function(){return [(_vm.dropdownTitle(tab))?[(_vm.slotTitle(_vm.dropdownTitle(tab)))?_c('vnodes',{attrs:{"vnodes":_vm.slotTitle(_vm.dropdownTitle(tab))}}):[_vm._v(_vm._s(_vm.dropdownTitle(tab).title))]]:(tab.slot)?_c('vnodes',{attrs:{"vnodes":_vm.slotGroup(tab)}}):[_vm._v(" "+_vm._s(tab.title)+" ")]]},proxy:true}],null,true)},'b-dropdown',tab.titleLinkAttributes,false),[_vm._l((tab.items),function(subTab,j){return [(subTab.groupDividerBefore !== false)?_c('b-dropdown-divider',{key:'divider-' + j}):_vm._e(),_c('b-dropdown-item',{key:'sub-' + j,on:{"click":function($event){$event.preventDefault();return (evt => subTab.onClick(evt)).apply(null, arguments)}}},[(_vm.slotTitle(subTab))?_c('vnodes',{attrs:{"vnodes":_vm.slotTitle(subTab)}}):[_vm._v(_vm._s(subTab.title))]],2)]})],2):_c('a',_vm._b({class:_vm.navLinkClass(tab),attrs:{"href":"#","id":tab.buttonId},on:{"click":function($event){$event.preventDefault();return (evt => tab.onClick(evt)).apply(null, arguments)}}},'a',tab.titleLinkAttributes,false),[(_vm.slotTitle(tab))?_c('vnodes',{attrs:{"vnodes":_vm.slotTitle(tab)}}):[_vm._v(_vm._s(tab.title))]],2)],1)}),(_vm.parentTabs.$slots['tabs-end'])?_c('vnodes',{attrs:{"vnodes":_vm.parentTabs.$slots['tabs-end']}}):_vm._e()],2):_vm._e()
}
var TabNavvue_type_template_id_01bb0222_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Tabs/TabNav.ts?vue&type=script&lang=ts&external




var TabNav = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TabNav, _super);
    function TabNav() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.parentTabs = null;
        return _this;
    }
    TabNav.prototype.mounted = function () {
        this.parentTabs = this.getParentTabs();
    };
    Object.defineProperty(TabNav.prototype, "tabsButtons", {
        get: function () {
            var _a;
            var buttons = [];
            (_a = this.parentTabs) === null || _a === void 0 ? void 0 : _a.registeredTabs.forEach(function (tab) {
                if (!tab.group && !tab.groupSlot) {
                    buttons.push(tab);
                    return;
                }
                var index = buttons.findIndex(function (btn) {
                    return 'isDropdown' in btn && ((tab.group && tab.group === btn.title) || (tab.groupSlot && tab.groupSlot === btn.slot));
                });
                if (index === -1) {
                    index = buttons.push({
                        isDropdown: true,
                        title: tab.group,
                        slot: tab.groupSlot,
                        items: []
                    });
                    index--;
                }
                var dropdown = buttons[index];
                dropdown.items.push(tab);
            });
            return buttons;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TabNav.prototype, "slotTitle", {
        get: function () {
            return function (tab) {
                var _a;
                return (_a = tab.$slots.title) !== null && _a !== void 0 ? _a : tab.$scopedSlots.title;
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TabNav.prototype, "slotGroup", {
        get: function () {
            var _this = this;
            return function (tab) {
                var _a, _b, _c;
                return (_b = (_a = _this.parentTabs) === null || _a === void 0 ? void 0 : _a.$slots[tab.slot]) !== null && _b !== void 0 ? _b : (_c = _this.parentTabs) === null || _c === void 0 ? void 0 : _c.$scopedSlots[tab.slot];
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TabNav.prototype, "navClass", {
        get: function () {
            var _a;
            var tabs = this.parentTabs;
            var cssClass = {
                nav: true,
                'nav-tabs': tabs.pills === false && tabs.noNavStyle === false,
                small: tabs.small !== false,
                'nav-fill': tabs.fill !== false,
                'nav-justified': tabs.justified !== false,
                'nav-pills': tabs.pills !== false,
                'card-header-pills': tabs.pills !== false && tabs.vertical === false,
                'card-header': tabs.pills !== false && tabs.vertical !== false,
                'justify-content-center': tabs.align === 'center',
                'justify-content-end': tabs.align === 'end' || tabs.align === 'right',
                'card-header-tabs': tabs.card !== false && tabs.pills === false,
                'flex-column h-100 border-bottom-0 rounded-0': tabs.vertical !== false
            };
            var navClass = (_a = this.parentTabs) === null || _a === void 0 ? void 0 : _a.navClass;
            if (typeof navClass === 'string') {
                cssClass[navClass] = true;
            }
            else if (typeof navClass === 'object') {
                cssClass = merge_default()(cssClass, navClass);
            }
            return cssClass;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TabNav.prototype, "dropdownTitle", {
        get: function () {
            return function (dropdown) {
                return dropdown.items.find(function (tab) { return tab.actived; });
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TabNav.prototype, "dropdownClass", {
        get: function () {
            return function (dropdown) {
                return {
                    'nav-link': true,
                    active: dropdown.items.find(function (tab) { return tab.actived; }) !== undefined
                };
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TabNav.prototype, "navLinkClass", {
        get: function () {
            var _this = this;
            return function (tab) {
                var cssClass = {
                    'nav-link': true,
                    active: tab.actived,
                    disabled: 'disabled' in tab && tab.disabled !== false
                };
                var tabs = _this.parentTabs;
                if (tab.actived && tabs.activeNavItemClass) {
                    if (typeof tabs.activeNavItemClass === 'string') {
                        cssClass[tabs.activeNavItemClass] = true;
                    }
                    else if (typeof tabs.activeNavItemClass === 'object') {
                        cssClass = merge_default()(cssClass, tabs.activeNavItemClass);
                    }
                }
                if (tab.titleLinkClass) {
                    if (typeof tab.titleLinkClass === 'string') {
                        cssClass[tab.titleLinkClass] = true;
                    }
                    else if (typeof tab.titleLinkClass === 'object') {
                        cssClass = merge_default()(cssClass, tab.titleLinkClass);
                    }
                }
                return cssClass;
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TabNav.prototype, "navItemClass", {
        get: function () {
            return function (tab) {
                var cssClass = {
                    'nav-item': true
                };
                if (tab.titleItemClass) {
                    if (typeof tab.titleItemClass === 'string') {
                        cssClass[tab.titleItemClass] = true;
                    }
                    else if (typeof tab.titleItemClass === 'object') {
                        cssClass = merge_default()(cssClass, tab.titleItemClass);
                    }
                }
                return cssClass;
            };
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Inject */.y_)({ from: 'getParentTabs' })
    ], TabNav.prototype, "getParentTabs", void 0);
    TabNav = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BDropdown: external_bootstrap_vue_.BDropdown,
                BDropdownItem: external_bootstrap_vue_.BDropdownItem,
                BDropdownDivider: external_bootstrap_vue_.BDropdownDivider,
                Vnodes: {
                    functional: true,
                    render: function (h, ctx) {
                        if (typeof ctx.props.vnodes === 'function') {
                            return ctx.props.vnodes();
                        }
                        return ctx.props.vnodes;
                    }
                }
            }
        })
    ], TabNav);
    return TabNav;
}(lib/* Vue */.lD));
/* harmony default export */ var TabNavvue_type_script_lang_ts_external = (TabNav);

;// ./src/components/Tabs/TabNav.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var Tabs_TabNavvue_type_script_lang_ts_external = (TabNavvue_type_script_lang_ts_external); 
;// ./src/components/Tabs/TabNav.vue





/* normalize component */
;
var TabNav_component = (0,componentNormalizer/* default */.A)(
  Tabs_TabNavvue_type_script_lang_ts_external,
  TabNavvue_type_template_id_01bb0222_render,
  TabNavvue_type_template_id_01bb0222_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Tabs_TabNav = (TabNav_component.exports);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Tabs/Tabs.ts?vue&type=script&lang=ts&external




var Tabs = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(Tabs, _super);
    function Tabs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.registeredTabs = [];
        _this.active = 0;
        _this.initialize = false;
        return _this;
    }
    Tabs.prototype.mounted = function () {
        var _a;
        this.activeTab((_a = this.value) !== null && _a !== void 0 ? _a : this.active);
        this.initialize = true;
    };
    Tabs.prototype.beforeDestroy = function () {
        this.initialize = false;
    };
    Object.defineProperty(Tabs.prototype, "tabsClass", {
        get: function () {
            return {
                tabs: true,
                row: this.vertical !== false,
                'no-gutters': this.vertical !== false
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Tabs.prototype, "tabContentClass", {
        get: function () {
            var cssClass = {
                'tab-content': true,
                col: this.vertical !== false
            };
            if (typeof this.contentClass === 'string') {
                cssClass[this.contentClass] = true;
            }
            else if (typeof this.contentClass === 'object') {
                cssClass = merge_default()(cssClass, this.contentClass);
            }
            return cssClass;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Tabs.prototype, "headerClass", {
        get: function () {
            var cssClass = {
                'card-header': this.card !== false && this.vertical === false,
                'col-auto': this.vertical !== false
            };
            if (typeof this.navWrapperClass === 'string') {
                cssClass[this.navWrapperClass] = true;
            }
            else if (typeof this.navWrapperClass === 'object') {
                cssClass = merge_default()(cssClass, this.navWrapperClass);
            }
            return cssClass;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Tabs.prototype, "footerClass", {
        get: function () {
            var cssClass = {
                'card-footer': this.vertical === false,
                'col-auto': this.vertical !== false
            };
            if (typeof this.navWrapperClass === 'string') {
                cssClass[this.navWrapperClass] = true;
            }
            else if (typeof this.navWrapperClass === 'object') {
                cssClass = merge_default()(cssClass, this.navWrapperClass);
            }
            return cssClass;
        },
        enumerable: false,
        configurable: true
    });
    Tabs.prototype.registerTab = function (tab) {
        var old = Array.from(this.registeredTabs);
        this.registeredTabs.push(tab);
        this.emitChanged(old);
    };
    Tabs.prototype.unregisterTab = function (tab) {
        var old = Array.from(this.registeredTabs);
        this.registeredTabs = this.registeredTabs.slice().filter(function (t) { return t !== tab; });
        this.emitChanged(old);
    };
    Tabs.prototype.getParentTabs = function () {
        return this;
    };
    Tabs.prototype.watchValue = function (value) {
        value = Number(value);
        this.active = value;
        this.activeTab(value);
    };
    Tabs.prototype.emitChanged = function (oldTabs) {
        if (this.initialize) {
            this.$emit('changed', Array.from(this.registeredTabs), oldTabs);
        }
    };
    Tabs.prototype.activeTab = function (tab) {
        var index = this.getTabIndex(tab);
        this.registeredTabs.forEach(function (t, i) {
            t.actived = i === index;
        });
        this.$emit('input', index);
    };
    Tabs.prototype.changeTab = function (tab) {
        var event = new Event('activate-tab', { cancelable: true });
        var index = this.getTabIndex(tab);
        this.$emit('activate-tab', index, this.active, event);
        if (!event.defaultPrevented) {
            this.activeTab(index);
        }
    };
    Tabs.prototype.getTabIndex = function (tab) {
        var index;
        if (typeof tab === 'number') {
            index = tab;
        }
        else {
            index = this.registeredTabs.findIndex(function (t) { return t === tab; });
        }
        return index;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], Tabs.prototype, "card", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], Tabs.prototype, "pills", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], Tabs.prototype, "contentClass", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], Tabs.prototype, "fill", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], Tabs.prototype, "justified", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], Tabs.prototype, "end", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], Tabs.prototype, "vertical", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'left' })
    ], Tabs.prototype, "align", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], Tabs.prototype, "navClass", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], Tabs.prototype, "navWrapperClass", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], Tabs.prototype, "activeNavItemClass", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], Tabs.prototype, "activeTabClass", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], Tabs.prototype, "lazy", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], Tabs.prototype, "noNavStyle", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], Tabs.prototype, "small", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'div' })
    ], Tabs.prototype, "tag", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], Tabs.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Provide */.ku)('getParentTabs')
    ], Tabs.prototype, "getParentTabs", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value')
    ], Tabs.prototype, "watchValue", null);
    Tabs = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                TabNav: Tabs_TabNav
            }
        })
    ], Tabs);
    return Tabs;
}(lib/* Vue */.lD));
/* harmony default export */ var Tabsvue_type_script_lang_ts_external = (Tabs);

;// ./src/components/Tabs/Tabs.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var Tabs_Tabsvue_type_script_lang_ts_external = (Tabsvue_type_script_lang_ts_external); 
;// ./src/components/Tabs/Tabs.vue





/* normalize component */
;
var Tabs_component = (0,componentNormalizer/* default */.A)(
  Tabs_Tabsvue_type_script_lang_ts_external,
  Tabsvue_type_template_id_5821f9d0_render,
  Tabsvue_type_template_id_5821f9d0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Tabs_Tabs = (Tabs_component.exports);
// EXTERNAL MODULE: ./src/components/Tags/Tags.vue + 3 modules
var Tags = __webpack_require__(7005);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TagSelect/TagSelect.vue?vue&type=template&id=02fe2184
var TagSelectvue_type_template_id_02fe2184_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form-select',_vm._g(_vm._b({attrs:{"options":_vm.tags,"label":"name"}},'k-form-select',_vm.attributes,false),_vm.$listeners))
}
var TagSelectvue_type_template_id_02fe2184_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/TagSelect/TagSelect.ts?vue&type=script&lang=ts&external




var TagSelect = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TagSelect, _super);
    function TagSelect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TagSelect.prototype.created = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadTags()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(TagSelect.prototype, "attributes", {
        get: function () {
            return Object.assign({}, {
                multiple: true,
                taggable: true
            }, this.$attrs);
        },
        enumerable: false,
        configurable: true
    });
    TagSelect = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadTags'])),
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('globalDatas', ['tags'])),
            components: {
                KFormSelect: form_vue_.KFormSelect
            }
        })
    ], TagSelect);
    return TagSelect;
}(lib/* Vue */.lD));
/* harmony default export */ var TagSelectvue_type_script_lang_ts_external = (TagSelect);

;// ./src/components/TagSelect/TagSelect.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var TagSelect_TagSelectvue_type_script_lang_ts_external = (TagSelectvue_type_script_lang_ts_external); 
;// ./src/components/TagSelect/TagSelect.vue





/* normalize component */
;
var TagSelect_component = (0,componentNormalizer/* default */.A)(
  TagSelect_TagSelectvue_type_script_lang_ts_external,
  TagSelectvue_type_template_id_02fe2184_render,
  TagSelectvue_type_template_id_02fe2184_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TagSelect_TagSelect = (TagSelect_component.exports);
// EXTERNAL MODULE: ./src/components/TeamApiToken/TeamApiToken.vue + 3 modules
var TeamApiToken = __webpack_require__(3838);
// EXTERNAL MODULE: ./src/components/TeamApiTokenForm/TeamApiTokenForm.vue + 3 modules
var TeamApiTokenForm = __webpack_require__(5324);
// EXTERNAL MODULE: ./src/components/TeamInfos/TeamInfos.vue + 3 modules
var TeamInfos = __webpack_require__(9282);
// EXTERNAL MODULE: ./src/components/TeamParams/TeamParams.vue + 3 modules
var TeamParams = __webpack_require__(4587);
// EXTERNAL MODULE: ./src/components/TeamUserSelect/TeamUserSelect.vue + 3 modules
var TeamUserSelect = __webpack_require__(2735);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TestModeActivation/TestModeActivation.vue?vue&type=template&id=3f420860
var TestModeActivationvue_type_template_id_3f420860_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.testMode && _vm.$kwInterface.hasTestMode)?_c('b-button',{staticClass:"mt-2 mt-md-0",attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();_vm.modal = true}}},[_vm._v(" "+_vm._s(_vm.$t('interface.demoMode.goDemo'))+" "),_c('b-modal',{attrs:{"title":_vm.$t('interface.demoMode.label'),"cancel-title":_vm.$t('interface.close'),"ok-title":_vm.$t('interface.demoMode.goDemo'),"modal-class":"text-justify","size":"lg"},on:{"ok":_vm.goInDemoMode},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('p',[_vm._v(" "+_vm._s(_vm.$t('interface.demoMode.goDemoAlert'))+" ")]),_c('p',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('interface.demoMode.goDemoExplain'))+" ")]),_c('b-alert',{attrs:{"variant":"warning","show":""}},[_vm._v(" "+_vm._s(_vm.$t('interface.demoMode.goDemoWarning1'))+" "),_c('span',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('interface.demoMode.goDemoWarning2'))+" ")])])],1)],1):_vm._e()
}
var TestModeActivationvue_type_template_id_3f420860_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/TestModeActivation/TestModeActivation.ts?vue&type=script&lang=ts&external




var TestModeActivation = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TestModeActivation, _super);
    function TestModeActivation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modal = false;
        return _this;
    }
    TestModeActivation.prototype.goInDemoMode = function () {
        var _this = this;
        this.setRouteLoadingState(true);
        this.setTestMode(true);
        this.$kwInterface.axios.get('/user?with_file=1')
            .then(function (response) {
            _this.setUser(response.data);
            _this.clearStore();
            _this.setRouteLoadingState(false);
        });
    };
    TestModeActivation = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BModal: external_bootstrap_vue_.BModal, BButton: external_bootstrap_vue_.BButton, BAlert: external_bootstrap_vue_.BAlert
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['testMode'])),
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('user', ['setTestMode', 'setUser'])), (0,external_vuex_.mapActions)('auth', ['clearStore'])), (0,external_vuex_.mapActions)('app', ['setRouteLoadingState']))
        })
    ], TestModeActivation);
    return TestModeActivation;
}(lib/* Vue */.lD));
/* harmony default export */ var TestModeActivationvue_type_script_lang_ts_external = (TestModeActivation);

;// ./src/components/TestModeActivation/TestModeActivation.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var TestModeActivation_TestModeActivationvue_type_script_lang_ts_external = (TestModeActivationvue_type_script_lang_ts_external); 
;// ./src/components/TestModeActivation/TestModeActivation.vue





/* normalize component */
;
var TestModeActivation_component = (0,componentNormalizer/* default */.A)(
  TestModeActivation_TestModeActivationvue_type_script_lang_ts_external,
  TestModeActivationvue_type_template_id_3f420860_render,
  TestModeActivationvue_type_template_id_3f420860_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TestModeActivation_TestModeActivation = (TestModeActivation_component.exports);
// EXTERNAL MODULE: ./src/components/TextareaView/TextareaView.vue + 3 modules
var TextareaView = __webpack_require__(4598);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TimezoneSelect/TimezoneSelect.vue?vue&type=template&id=3a5a229c
var TimezoneSelectvue_type_template_id_3a5a229c_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form-select',_vm._g(_vm._b({attrs:{"options":_vm.timezones,"label":"name","getOptionLabel":opt => opt.name + ' (' + opt.timezone + ')'}},'k-form-select',_vm.attributes,false),_vm.$listeners))
}
var TimezoneSelectvue_type_template_id_3a5a229c_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/TimezoneSelect/TimezoneSelect.ts?vue&type=script&lang=ts&external




var TimezoneSelect = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TimezoneSelect, _super);
    function TimezoneSelect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimezoneSelect.prototype.created = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadTimezones()];
                    case 1:
                        _a.sent();
                        if (this.selectDefault !== false && !this.value && this.timezone) {
                            this.$emit('input', this.timezone);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(TimezoneSelect.prototype, "attributes", {
        get: function () {
            return Object.assign({}, {
                value: this.value,
                clearable: false
            }, this.$attrs);
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], TimezoneSelect.prototype, "selectDefault", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], TimezoneSelect.prototype, "value", void 0);
    TimezoneSelect = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadTimezones'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['timezone'])), (0,external_vuex_.mapState)('globalDatas', ['timezones'])),
            components: {
                KFormSelect: form_vue_.KFormSelect
            }
        })
    ], TimezoneSelect);
    return TimezoneSelect;
}(lib/* Vue */.lD));
/* harmony default export */ var TimezoneSelectvue_type_script_lang_ts_external = (TimezoneSelect);

;// ./src/components/TimezoneSelect/TimezoneSelect.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var TimezoneSelect_TimezoneSelectvue_type_script_lang_ts_external = (TimezoneSelectvue_type_script_lang_ts_external); 
;// ./src/components/TimezoneSelect/TimezoneSelect.vue





/* normalize component */
;
var TimezoneSelect_component = (0,componentNormalizer/* default */.A)(
  TimezoneSelect_TimezoneSelectvue_type_script_lang_ts_external,
  TimezoneSelectvue_type_template_id_3a5a229c_render,
  TimezoneSelectvue_type_template_id_3a5a229c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TimezoneSelect_TimezoneSelect = (TimezoneSelect_component.exports);
// EXTERNAL MODULE: ./src/components/Units/Units.vue + 3 modules
var Units = __webpack_require__(7563);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UnitSelect/UnitSelect.vue?vue&type=template&id=586aa4e0
var UnitSelectvue_type_template_id_586aa4e0_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form-select',_vm._g(_vm._b({attrs:{"options":_vm.units}},'k-form-select',_vm.attributes,false),_vm.$listeners))
}
var UnitSelectvue_type_template_id_586aa4e0_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/UnitSelect/UnitSelect.ts?vue&type=script&lang=ts&external




var UnitSelect = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(UnitSelect, _super);
    function UnitSelect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UnitSelect.prototype.created = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadUnits()];
                    case 1:
                        _a.sent();
                        if (this.selectDefault !== false && !this.value && this.defaultUnit) {
                            this.$emit('input', this.defaultUnit);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(UnitSelect.prototype, "attributes", {
        get: function () {
            return Object.assign({}, {
                value: this.value
            }, this.$attrs);
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], UnitSelect.prototype, "selectDefault", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], UnitSelect.prototype, "value", void 0);
    UnitSelect = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadUnits'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('globalDatas', ['defaultUnit'])), (0,external_vuex_.mapState)('globalDatas', ['units'])),
            components: {
                KFormSelect: form_vue_.KFormSelect
            }
        })
    ], UnitSelect);
    return UnitSelect;
}(lib/* Vue */.lD));
/* harmony default export */ var UnitSelectvue_type_script_lang_ts_external = (UnitSelect);

;// ./src/components/UnitSelect/UnitSelect.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var UnitSelect_UnitSelectvue_type_script_lang_ts_external = (UnitSelectvue_type_script_lang_ts_external); 
;// ./src/components/UnitSelect/UnitSelect.vue





/* normalize component */
;
var UnitSelect_component = (0,componentNormalizer/* default */.A)(
  UnitSelect_UnitSelectvue_type_script_lang_ts_external,
  UnitSelectvue_type_template_id_586aa4e0_render,
  UnitSelectvue_type_template_id_586aa4e0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var UnitSelect_UnitSelect = (UnitSelect_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserAuth/UserAuth.vue?vue&type=template&id=0cf22e32
var UserAuthvue_type_template_id_0cf22e32_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-card',{staticClass:"rounded-10"},[_c('h3',[_vm._v(_vm._s(_vm.$t('interface.user.loginInformations')))]),_c('b-form-group',{class:{
        'mb-0': _vm.user.email_validation
      },attrs:{"label":_vm.$t('interface.user.loginEmail'),"label-cols":"auto"}},[_c('k-form-input',{attrs:{"plaintext":""},model:{value:(_vm.user.email),callback:function ($$v) {_vm.$set(_vm.user, "email", $$v)},expression:"user.email"}})],1),(_vm.user.email_validation)?_c('b-alert',{attrs:{"show":"","variant":"warning"}},[_c('p',{staticClass:"mb-1 font-weight-bold text-danger"},[(_vm.isSameEmailValidation)?[_vm._v(" "+_vm._s(_vm.$t('interface.user.emailValidationInProgress'))+" ")]:[_vm._v(" "+_vm._s(_vm.$t('interface.user.emailChangeInProgress'))+" "+_vm._s(_vm.user.email_validation.email)+" ")]],2),_c('p',{staticClass:"mb-0"},[_c('b-button',{staticClass:"mr-3",attrs:{"size":"sm","variant":"primary","disabled":_vm.resendEmailValidationStatus},on:{"click":function($event){$event.preventDefault();return _vm.resendEmailValidation.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('interface.user.resendValidation'))+" "),(_vm.resendEmailValidationStatus)?_c('font-awesome-icon',{attrs:{"icon":['fad', 'spinner-third'],"spin":""}}):_vm._e()],1),(!_vm.isSameEmailValidation)?_c('b-button',{attrs:{"size":"sm","disabled":_vm.cancelEmailValidationStatus},on:{"click":function($event){$event.preventDefault();return _vm.cancelEmailValidation.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('interface.cancel'))+" "),(_vm.cancelEmailValidationStatus)?_c('font-awesome-icon',{attrs:{"icon":['fad', 'spinner-third'],"spin":""}}):_vm._e()],1):_vm._e()],1),_c('b-toast',{attrs:{"visible":_vm.successMsg !== null,"variant":"success","solid":true,"no-close-button":true,"toaster":"b-toaster-top-center mt-5"},on:{"hide":function($event){_vm.successMsg = null}}},[_vm._v(" "+_vm._s(_vm.successMsg)+" ")]),_c('b-toast',{attrs:{"visible":_vm.errorMsg !== null,"variant":"danger","solid":true,"no-close-button":true,"toaster":"b-toaster-top-center mt-5"},on:{"hide":function($event){_vm.errorMsg = null}}},[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")])],1):_vm._e(),_c('FormModal',{attrs:{"id":"modal-email-change","title":_vm.$t('interface.user.changeEmailTitle')}},[_c('UserEmail')],1),(!_vm.user.email_validation)?_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.modal-email-change",modifiers:{"modal-email-change":true}}],staticClass:"mr-3 mb-2"},[_vm._v(" "+_vm._s(_vm.$t('interface.user.changeEmailButton'))+" ")]):_vm._e(),_c('FormModal',{attrs:{"id":"modal-password-change","title":_vm.$t('interface.user.passwordChangeTitle')}},[_c('UserPassword')],1),_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.modal-password-change",modifiers:{"modal-password-change":true}}],staticClass:"mb-2"},[_vm._v(" "+_vm._s(_vm.$t('interface.user.passwordChangeButton'))+" ")]),_c('k-form',{ref:"newslettersForm",attrs:{"action":_vm.formAction,"method":"put"},on:{"submitComplete":_vm.formSubmitted},model:{value:(_vm.formDatas),callback:function ($$v) {_vm.formDatas=$$v},expression:"formDatas"}},[_c('k-form-checkbox',{staticClass:"mt-4",attrs:{"name":"newsletter_offers","id":"newsletter_offers"},on:{"input":_vm.newslettersUpdate},model:{value:(_vm.formDatas.newsletter_offers),callback:function ($$v) {_vm.$set(_vm.formDatas, "newsletter_offers", $$v)},expression:"formDatas.newsletter_offers"}},[_vm._v(" "+_vm._s(_vm.$t('interface.user.newsletter'))+" ")]),_c('k-form-checkbox',{staticClass:"mt-2",attrs:{"name":"newsletter_updates","id":"newsletter_updates"},on:{"input":_vm.newslettersUpdate},model:{value:(_vm.formDatas.newsletter_updates),callback:function ($$v) {_vm.$set(_vm.formDatas, "newsletter_updates", $$v)},expression:"formDatas.newsletter_updates"}},[_vm._v(" "+_vm._s(_vm.$t('interface.user.updates'))+" ")])],1)],1)],1)
}
var UserAuthvue_type_template_id_0cf22e32_staticRenderFns = []


;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserPassword/UserPassword.vue?vue&type=template&id=44008b30
var UserPasswordvue_type_template_id_44008b30_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form',{attrs:{"action":_vm.formAction,"method":"put"},on:{"submit":function($event){$event.preventDefault();return _vm.formSubmitted.apply(null, arguments)}}},[_c('b-form-group',{attrs:{"label":_vm.$t('interface.user.currentPassword'),"label-for":"current_password"}},[_c('k-form-input',{attrs:{"type":"password","name":"current_password","id":"current_password","required":"","noCustomRules":""}})],1),_c('Password')],1)
}
var UserPasswordvue_type_template_id_44008b30_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/UserPassword/UserPassword.ts?vue&type=script&lang=ts&external






var UserPassword = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(UserPassword, _super);
    function UserPassword() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserPassword = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput,
                BFormGroup: external_bootstrap_vue_.BFormGroup,
                Password: Password/* default */.A
            }
        })
    ], UserPassword);
    return UserPassword;
}((0,lib/* Mixins */.Xe)(mixins_UserFormMixin)));
/* harmony default export */ var UserPasswordvue_type_script_lang_ts_external = (UserPassword);

;// ./src/components/UserPassword/UserPassword.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var UserPassword_UserPasswordvue_type_script_lang_ts_external = (UserPasswordvue_type_script_lang_ts_external); 
;// ./src/components/UserPassword/UserPassword.vue





/* normalize component */
;
var UserPassword_component = (0,componentNormalizer/* default */.A)(
  UserPassword_UserPasswordvue_type_script_lang_ts_external,
  UserPasswordvue_type_template_id_44008b30_render,
  UserPasswordvue_type_template_id_44008b30_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var UserPassword_UserPassword = (UserPassword_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserEmail/UserEmail.vue?vue&type=template&id=21c57135
var UserEmailvue_type_template_id_21c57135_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form',{attrs:{"action":_vm.formAction,"method":"put"},on:{"submitComplete":_vm.formSubmitted}},[_c('b-form-group',{attrs:{"label":_vm.$t('interface.user.currentPassword'),"label-for":"current_password"}},[_c('k-form-input',{attrs:{"type":"password","name":"current_password","id":"current_password","required":"","noCustomRules":""}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('interface.user.newMail'),"label-for":"email"}},[_c('k-form-input',{attrs:{"type":"email","name":"email","id":"email","required":""}})],1),_c('b-alert',{staticClass:"mb-0",attrs:{"show":"","variant":"danger"}},[_c('p',{staticClass:"mb-1"},[_vm._v(" "+_vm._s(_vm.$t('interface.user.newMailExplain'))+" ")]),_c('p',{staticClass:"mb-2 font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('interface.user.newMailExplain2'))+" ")]),_c('p',{staticClass:"mb-0 text-danger font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('interface.user.newMailExplain3'))+" ")])])],1)
}
var UserEmailvue_type_template_id_21c57135_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/UserEmail/UserEmail.ts?vue&type=script&lang=ts&external





var UserEmail = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(UserEmail, _super);
    function UserEmail() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserEmail = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BAlert: external_bootstrap_vue_.BAlert
            }
        })
    ], UserEmail);
    return UserEmail;
}((0,lib/* Mixins */.Xe)(mixins_UserFormMixin)));
/* harmony default export */ var UserEmailvue_type_script_lang_ts_external = (UserEmail);

;// ./src/components/UserEmail/UserEmail.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var UserEmail_UserEmailvue_type_script_lang_ts_external = (UserEmailvue_type_script_lang_ts_external); 
;// ./src/components/UserEmail/UserEmail.vue





/* normalize component */
;
var UserEmail_component = (0,componentNormalizer/* default */.A)(
  UserEmail_UserEmailvue_type_script_lang_ts_external,
  UserEmailvue_type_template_id_21c57135_render,
  UserEmailvue_type_template_id_21c57135_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var UserEmail_UserEmail = (UserEmail_component.exports);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/UserAuth/UserAuth.ts?vue&type=script&lang=ts&external









var UserAuth = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(UserAuth, _super);
    function UserAuth() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.timeout = null;
        _this.resendEmailValidationStatus = false;
        _this.cancelEmailValidationStatus = false;
        _this.successMsg = null;
        _this.errorMsg = null;
        _this.formDatas = {
            newsletter_offers: false,
            newsletter_updates: false
        };
        return _this;
    }
    Object.defineProperty(UserAuth.prototype, "isSameEmailValidation", {
        get: function () {
            var _a;
            return this.user.email === ((_a = this.user.email_validation) === null || _a === void 0 ? void 0 : _a.email);
        },
        enumerable: false,
        configurable: true
    });
    UserAuth.prototype.setLocalUser = function (user) {
        var _a, _b;
        this.localUser = JSON.parse(JSON.stringify(user));
        this.formDatas.newsletter_offers = (_a = this.localUser.newsletter_offers) !== null && _a !== void 0 ? _a : false;
        this.formDatas.newsletter_updates = (_b = this.localUser.newsletter_updates) !== null && _b !== void 0 ? _b : false;
    };
    UserAuth.prototype.newslettersUpdate = function () {
        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
        this.timeout = setTimeout(this.submitForm, 1000);
    };
    UserAuth.prototype.submitForm = function () {
        this.timeout = null;
        if (this.user.newsletter_offers !== this.formDatas.newsletter_offers ||
            this.user.newsletter_updates !== this.formDatas.newsletter_updates) {
            var form = this.$refs.newslettersForm;
            form.submit();
        }
    };
    UserAuth.prototype.confirm = function (response, message) {
        this.formSubmitted(response);
        this.successMsg = message;
    };
    UserAuth.prototype.error = function (response) {
        this.formSubmitted(response);
        this.errorMsg = this.$t('interface.saveError');
    };
    UserAuth.prototype.resendEmailValidation = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.resendEmailValidationStatus = true;
                        return [4 /*yield*/, this.$kwInterface.axios.post('/user/email-validation/resend')
                                .then(function (response) { return _this.confirm(response, _this.$t('interface.user.confirmSendValidation')); })
                                .catch(this.error)
                                .finally(function () {
                                _this.resendEmailValidationStatus = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    UserAuth.prototype.cancelEmailValidation = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.cancelEmailValidationStatus = true;
                        return [4 /*yield*/, this.$kwInterface.axios.post('/user/email-validation/cancel')
                                .then(function (response) { return _this.confirm(response, _this.$t('interface.user.confirmEmailChange')); })
                                .catch(this.error)
                                .finally(function () {
                                _this.cancelEmailValidationStatus = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    UserAuth = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                UserPassword: UserPassword_UserPassword,
                UserEmail: UserEmail_UserEmail,
                FormModal: FormModal/* default */.A,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                KForm: form_vue_.KForm, KFormCheckbox: form_vue_.KFormCheckbox, KFormInput: form_vue_.KFormInput,
                BCard: external_bootstrap_vue_.BCard, BFormGroup: external_bootstrap_vue_.BFormGroup, BButton: external_bootstrap_vue_.BButton, BModal: external_bootstrap_vue_.BModal, BToast: external_bootstrap_vue_.BToast, BAlert: external_bootstrap_vue_.BAlert
            },
            directives: {
                'b-modal': external_bootstrap_vue_.VBModal
            }
        })
    ], UserAuth);
    return UserAuth;
}((0,lib/* Mixins */.Xe)(mixins_UserFormMixin)));
/* harmony default export */ var UserAuthvue_type_script_lang_ts_external = (UserAuth);

;// ./src/components/UserAuth/UserAuth.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var UserAuth_UserAuthvue_type_script_lang_ts_external = (UserAuthvue_type_script_lang_ts_external); 
;// ./src/components/UserAuth/UserAuth.vue





/* normalize component */
;
var UserAuth_component = (0,componentNormalizer/* default */.A)(
  UserAuth_UserAuthvue_type_script_lang_ts_external,
  UserAuthvue_type_template_id_0cf22e32_render,
  UserAuthvue_type_template_id_0cf22e32_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var UserAuth_UserAuth = (UserAuth_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserInfos/UserInfos.vue?vue&type=template&id=16833ac8
var UserInfosvue_type_template_id_16833ac8_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('FormModal',{attrs:{"id":"delete-user-avatar","title":_vm.$t('interface.deleteConfirmation')}},[_c('k-form',{attrs:{"action":_vm.formAction,"method":"PUT"},on:{"submitComplete":_vm.formSubmitted}},[_c('input',{attrs:{"type":"hidden","name":"avatar"}}),_vm._v(" "+_vm._s(_vm.$t('interface.user.deleteAvatarMsg'))+" ")])],1),_c('k-form',{attrs:{"action":_vm.formAction,"method":"PUT"},on:{"submitComplete":_vm.formSubmitted}},[_c('b-card',[_c('b-row',{attrs:{"align-v":"start"}},[_c('b-col',{staticClass:"mb-sm-4 mb-md-0",attrs:{"sm":"12","md":"4"}},[_c('div',{staticClass:"mx-auto",attrs:{"id":"user-avatar"}},[_c('b-avatar',{attrs:{"text":_vm.user.initials,"src":_vm.avatar,"size":_vm.avatar ? '100%' : '10rem'}}),_c('div',{staticClass:"actions"},[_c('b-row',{staticClass:"mx-0 w-100"},[_c('b-col',{attrs:{"cols":"12"}},[_c('k-form-file',{ref:"avatar",attrs:{"btnMode":"","btnLabel":_vm.$t('interface.' + (_vm.avatar ? 'edit' : 'add')),"btn-size":"sm","name":"avatar","url":_vm.formAction,"method":"put","datas":{ with_file: true },"imagePreview":false,"instant-upload":"","resizeWidth":100,"resizeHeight":100,"validateMinHeight":100,"validateMinWidth":100,"validateImageSize":true,"image-edit":"","instant-image-edit":"","cropCircle":"","accept":['image/*'],"removeUploadedFile":""},on:{"onUpload":_vm.applyNewUser}})],1),_c('b-col',{staticClass:"p-0",attrs:{"cols":_vm.avatar ? 6 : 12}},[_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.$refs.avatar.selectFile()}}},[_vm._v(" "+_vm._s(_vm.$t('interface.' + (_vm.avatar ? 'edit' : 'add')))+" ")])],1),(_vm.avatar)?_c('b-col',{staticClass:"p-0",attrs:{"cols":"6"}},[_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.delete-user-avatar",modifiers:{"delete-user-avatar":true}}],attrs:{"size":"sm"}},[_vm._v(" "+_vm._s(_vm.$t('interface.delete'))+" ")])],1):_vm._e()],1)],1)],1)]),_c('b-col',{attrs:{"sm":"12","md":"8"}},[_c('b-form-group',{attrs:{"label":_vm.$t('interface.user.firstname')}},[_c('k-form-input',{attrs:{"name":"firstname","required":""},model:{value:(_vm.localUser.firstname),callback:function ($$v) {_vm.$set(_vm.localUser, "firstname", $$v)},expression:"localUser.firstname"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('interface.user.lastname')}},[_c('k-form-input',{attrs:{"name":"lastname","required":""},model:{value:(_vm.localUser.lastname),callback:function ($$v) {_vm.$set(_vm.localUser, "lastname", $$v)},expression:"localUser.lastname"}})],1)],1)],1),_c('b-row',{staticClass:"mt-sm-0 mt-md-4"},[_c('b-col',{attrs:{"sm":"12","md":"4"}},[_c('b-form-group',{staticClass:"mb-sm-0",attrs:{"label":_vm.$t('interface.user.phone')}},[_c('k-form-phone',{attrs:{"name":"phone"},model:{value:(_vm.localUser.phone),callback:function ($$v) {_vm.$set(_vm.localUser, "phone", $$v)},expression:"localUser.phone"}})],1)],1),_c('b-col',{attrs:{"sm":"12","md":"4"}},[_c('b-form-group',{staticClass:"mb-sm-0",attrs:{"label":_vm.$t('interface.user.mobile')}},[_c('k-form-phone',{attrs:{"name":"mobile","placeholderNumberType":"MOBILE"},model:{value:(_vm.localUser.mobile),callback:function ($$v) {_vm.$set(_vm.localUser, "mobile", $$v)},expression:"localUser.mobile"}})],1)],1),_c('b-col',{attrs:{"sm":"12","md":"4"}},[_c('b-form-group',{staticClass:"mb-sm-0",attrs:{"label":_vm.$t('interface.user.fax')}},[_c('k-form-phone',{attrs:{"name":"fax"},model:{value:(_vm.localUser.fax),callback:function ($$v) {_vm.$set(_vm.localUser, "fax", $$v)},expression:"localUser.fax"}})],1)],1)],1)],1),_c('div',{staticClass:"text-center mt-3 mb-3 mb-lg-0"},[_c('b-button',{staticClass:"mr-4",attrs:{"type":"button","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('interface.cancel')))]),_c('b-button',{attrs:{"type":"submit","variant":"primary","size":"sm"}},[_vm._v(_vm._s(_vm.$t('interface.save')))])],1)],1)],1)
}
var UserInfosvue_type_template_id_16833ac8_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/UserInfos/UserInfos.ts?vue&type=script&lang=ts&external







var UserInfos = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(UserInfos, _super);
    function UserInfos() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserInfos = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['avatar'])),
            components: {
                FormModal: FormModal/* default */.A,
                KForm: form_vue_.KForm, KFormFile: form_vue_.KFormFileUpload, KFormInput: form_vue_.KFormInput, KFormPhone: form_vue_.KFormPhone,
                BCard: external_bootstrap_vue_.BCard, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BAvatar: external_bootstrap_vue_.BAvatar, BButton: external_bootstrap_vue_.BButton, BFormGroup: external_bootstrap_vue_.BFormGroup
            },
            directives: {
                'b-modal': external_bootstrap_vue_.VBModal
            }
        })
    ], UserInfos);
    return UserInfos;
}((0,lib/* Mixins */.Xe)(mixins_UserFormMixin)));
/* harmony default export */ var UserInfosvue_type_script_lang_ts_external = (UserInfos);

;// ./src/components/UserInfos/UserInfos.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var UserInfos_UserInfosvue_type_script_lang_ts_external = (UserInfosvue_type_script_lang_ts_external); 
;// ./src/components/UserInfos/UserInfos.vue





/* normalize component */
;
var UserInfos_component = (0,componentNormalizer/* default */.A)(
  UserInfos_UserInfosvue_type_script_lang_ts_external,
  UserInfosvue_type_template_id_16833ac8_render,
  UserInfosvue_type_template_id_16833ac8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var UserInfos_UserInfos = (UserInfos_component.exports);
// EXTERNAL MODULE: ./src/components/UserInvitation/UserInvitation.vue + 3 modules
var UserInvitation = __webpack_require__(9442);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserProfile/UserProfile.vue?vue&type=template&id=4c23329e
var UserProfilevue_type_template_id_4c23329e_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-row',{attrs:{"align-v":"stretch"}},[_c('b-col',{attrs:{"md":"12","lg":"6"}},[_c('UserInfos')],1),_c('b-col',{attrs:{"md":"12","lg":"6"}},[_c('UserAuth')],1)],1)
}
var UserProfilevue_type_template_id_4c23329e_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/UserProfile/UserProfile.ts?vue&type=script&lang=ts&external





var UserProfile = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(UserProfile, _super);
    function UserProfile() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserProfile = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                UserInfos: UserInfos_UserInfos,
                UserAuth: UserAuth_UserAuth,
                BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol
            }
        })
    ], UserProfile);
    return UserProfile;
}(lib/* Vue */.lD));
/* harmony default export */ var UserProfilevue_type_script_lang_ts_external = (UserProfile);

;// ./src/components/UserProfile/UserProfile.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var UserProfile_UserProfilevue_type_script_lang_ts_external = (UserProfilevue_type_script_lang_ts_external); 
;// ./src/components/UserProfile/UserProfile.vue





/* normalize component */
;
var UserProfile_component = (0,componentNormalizer/* default */.A)(
  UserProfile_UserProfilevue_type_script_lang_ts_external,
  UserProfilevue_type_template_id_4c23329e_render,
  UserProfilevue_type_template_id_4c23329e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var UserProfile_UserProfile = (UserProfile_component.exports);
// EXTERNAL MODULE: ./src/components/UsersDelete/UsersDelete.vue + 3 modules
var UsersDelete = __webpack_require__(994);
// EXTERNAL MODULE: ./src/components/UsersForm/UsersForm.vue + 3 modules
var UsersForm = __webpack_require__(303);
// EXTERNAL MODULE: ./src/components/UsersList/UsersList.vue + 3 modules
var UsersList = __webpack_require__(467);
// EXTERNAL MODULE: ./src/components/VatRates/VatRates.vue + 3 modules
var VatRates = __webpack_require__(4448);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VatRateSelect/VatRateSelect.vue?vue&type=template&id=3afb192a
var VatRateSelectvue_type_template_id_3afb192a_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form-select',_vm._g(_vm._b({attrs:{"options":_vm.computedVatRates}},'k-form-select',_vm.attributes,false),_vm.$listeners))
}
var VatRateSelectvue_type_template_id_3afb192a_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/VatRateSelect/VatRateSelect.ts?vue&type=script&lang=ts&external




var VatRateSelect = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(VatRateSelect, _super);
    function VatRateSelect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VatRateSelect.prototype.created = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadVatRates()];
                    case 1:
                        _a.sent();
                        if (this.selectDefault !== false && !this.value && this.defaultVatRate) {
                            this.$emit('input', this.defaultVatRate);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(VatRateSelect.prototype, "computedVatRates", {
        get: function () {
            return this.vatRates.filter(function (rate) { return rate.status.active; });
        },
        enumerable: false,
        configurable: true
    });
    VatRateSelect.prototype.watchVatRates = function () {
        var _this = this;
        if (!this.value) {
            return;
        }
        var index = this.vatRates.findIndex(function (rate) { var _a; return rate.id === ((_a = _this.value) === null || _a === void 0 ? void 0 : _a.id); });
        if (index < 0) {
            if (this.defaultVatRate) {
                this.$emit('input', this.defaultVatRate);
            }
            else {
                this.$emit('input', this.vatRates[0]);
            }
        }
    };
    Object.defineProperty(VatRateSelect.prototype, "attributes", {
        get: function () {
            return Object.assign({}, {
                value: this.value,
                clearable: false,
                getOptionLabel: function (rate) {
                    var label = rate.rate + ' %';
                    if (rate.label) {
                        label += ' (' + rate.label + ')';
                    }
                    return label;
                }
            }, this.$attrs);
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], VatRateSelect.prototype, "selectDefault", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], VatRateSelect.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('vatRates')
    ], VatRateSelect.prototype, "watchVatRates", null);
    VatRateSelect = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadVatRates'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('globalDatas', ['defaultVatRate'])), (0,external_vuex_.mapState)('globalDatas', ['vatRates'])),
            components: {
                KFormSelect: form_vue_.KFormSelect
            }
        })
    ], VatRateSelect);
    return VatRateSelect;
}(lib/* Vue */.lD));
/* harmony default export */ var VatRateSelectvue_type_script_lang_ts_external = (VatRateSelect);

;// ./src/components/VatRateSelect/VatRateSelect.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var VatRateSelect_VatRateSelectvue_type_script_lang_ts_external = (VatRateSelectvue_type_script_lang_ts_external); 
;// ./src/components/VatRateSelect/VatRateSelect.vue





/* normalize component */
;
var VatRateSelect_component = (0,componentNormalizer/* default */.A)(
  VatRateSelect_VatRateSelectvue_type_script_lang_ts_external,
  VatRateSelectvue_type_template_id_3afb192a_render,
  VatRateSelectvue_type_template_id_3afb192a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VatRateSelect_VatRateSelect = (VatRateSelect_component.exports);
;// ./src/mixins/NotificationMixin.ts


var NotificationMixin = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(NotificationMixin, _super);
    function NotificationMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], NotificationMixin.prototype, "value", void 0);
    NotificationMixin = (0,tslib_es6/* __decorate */.Cg)([
        lib/* Component */.uA
    ], NotificationMixin);
    return NotificationMixin;
}(lib/* Vue */.lD));
/* harmony default export */ var mixins_NotificationMixin = (NotificationMixin);

;// ./node_modules/libphonenumber-js/metadata.min.json.js
// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
/* harmony default export */ var metadata_min_json = ({"version":4,"country_calling_codes":{"1":["US","AG","AI","AS","BB","BM","BS","CA","DM","DO","GD","GU","JM","KN","KY","LC","MP","MS","PR","SX","TC","TT","VC","VG","VI"],"7":["RU","KZ"],"20":["EG"],"27":["ZA"],"30":["GR"],"31":["NL"],"32":["BE"],"33":["FR"],"34":["ES"],"36":["HU"],"39":["IT","VA"],"40":["RO"],"41":["CH"],"43":["AT"],"44":["GB","GG","IM","JE"],"45":["DK"],"46":["SE"],"47":["NO","SJ"],"48":["PL"],"49":["DE"],"51":["PE"],"52":["MX"],"53":["CU"],"54":["AR"],"55":["BR"],"56":["CL"],"57":["CO"],"58":["VE"],"60":["MY"],"61":["AU","CC","CX"],"62":["ID"],"63":["PH"],"64":["NZ"],"65":["SG"],"66":["TH"],"81":["JP"],"82":["KR"],"84":["VN"],"86":["CN"],"90":["TR"],"91":["IN"],"92":["PK"],"93":["AF"],"94":["LK"],"95":["MM"],"98":["IR"],"211":["SS"],"212":["MA","EH"],"213":["DZ"],"216":["TN"],"218":["LY"],"220":["GM"],"221":["SN"],"222":["MR"],"223":["ML"],"224":["GN"],"225":["CI"],"226":["BF"],"227":["NE"],"228":["TG"],"229":["BJ"],"230":["MU"],"231":["LR"],"232":["SL"],"233":["GH"],"234":["NG"],"235":["TD"],"236":["CF"],"237":["CM"],"238":["CV"],"239":["ST"],"240":["GQ"],"241":["GA"],"242":["CG"],"243":["CD"],"244":["AO"],"245":["GW"],"246":["IO"],"247":["AC"],"248":["SC"],"249":["SD"],"250":["RW"],"251":["ET"],"252":["SO"],"253":["DJ"],"254":["KE"],"255":["TZ"],"256":["UG"],"257":["BI"],"258":["MZ"],"260":["ZM"],"261":["MG"],"262":["RE","YT"],"263":["ZW"],"264":["NA"],"265":["MW"],"266":["LS"],"267":["BW"],"268":["SZ"],"269":["KM"],"290":["SH","TA"],"291":["ER"],"297":["AW"],"298":["FO"],"299":["GL"],"350":["GI"],"351":["PT"],"352":["LU"],"353":["IE"],"354":["IS"],"355":["AL"],"356":["MT"],"357":["CY"],"358":["FI","AX"],"359":["BG"],"370":["LT"],"371":["LV"],"372":["EE"],"373":["MD"],"374":["AM"],"375":["BY"],"376":["AD"],"377":["MC"],"378":["SM"],"380":["UA"],"381":["RS"],"382":["ME"],"383":["XK"],"385":["HR"],"386":["SI"],"387":["BA"],"389":["MK"],"420":["CZ"],"421":["SK"],"423":["LI"],"500":["FK"],"501":["BZ"],"502":["GT"],"503":["SV"],"504":["HN"],"505":["NI"],"506":["CR"],"507":["PA"],"508":["PM"],"509":["HT"],"590":["GP","BL","MF"],"591":["BO"],"592":["GY"],"593":["EC"],"594":["GF"],"595":["PY"],"596":["MQ"],"597":["SR"],"598":["UY"],"599":["CW","BQ"],"670":["TL"],"672":["NF"],"673":["BN"],"674":["NR"],"675":["PG"],"676":["TO"],"677":["SB"],"678":["VU"],"679":["FJ"],"680":["PW"],"681":["WF"],"682":["CK"],"683":["NU"],"685":["WS"],"686":["KI"],"687":["NC"],"688":["TV"],"689":["PF"],"690":["TK"],"691":["FM"],"692":["MH"],"850":["KP"],"852":["HK"],"853":["MO"],"855":["KH"],"856":["LA"],"880":["BD"],"886":["TW"],"960":["MV"],"961":["LB"],"962":["JO"],"963":["SY"],"964":["IQ"],"965":["KW"],"966":["SA"],"967":["YE"],"968":["OM"],"970":["PS"],"971":["AE"],"972":["IL"],"973":["BH"],"974":["QA"],"975":["BT"],"976":["MN"],"977":["NP"],"992":["TJ"],"993":["TM"],"994":["AZ"],"995":["GE"],"996":["KG"],"998":["UZ"]},"countries":{"AC":["247","00","(?:[01589]\\d|[46])\\d{4}",[5,6]],"AD":["376","00","(?:1|6\\d)\\d{7}|[135-9]\\d{5}",[6,8,9],[["(\\d{3})(\\d{3})","$1 $2",["[135-9]"]],["(\\d{4})(\\d{4})","$1 $2",["1"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]]],"AE":["971","00","(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",[5,6,7,8,9,10,11,12],[["(\\d{3})(\\d{2,9})","$1 $2",["60|8"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[236]|[479][2-8]"],"0$1"],["(\\d{3})(\\d)(\\d{5})","$1 $2 $3",["[479]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"]],"0"],"AF":["93","00","[2-7]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"]],"0"],"AG":["1","011","(?:268|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([457]\\d{6})$|1","268$1",0,"268"],"AI":["1","011","(?:264|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2457]\\d{6})$|1","264$1",0,"264"],"AL":["355","00","(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",[6,7,8,9],[["(\\d{3})(\\d{3,4})","$1 $2",["80|9"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["4[2-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2358][2-5]|4"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["[23578]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["6"],"0$1"]],"0"],"AM":["374","00","(?:[1-489]\\d|55|60|77)\\d{6}",[8],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[89]0"],"0 $1"],["(\\d{3})(\\d{5})","$1 $2",["2|3[12]"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["1|47"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["[3-9]"],"0$1"]],"0"],"AO":["244","00","[29]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[29]"]]]],"AR":["54","00","(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",[10,11],[["(\\d{4})(\\d{2})(\\d{4})","$1 $2-$3",["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])","2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],"0$1",1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["1"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[68]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2-$3",["[23]"],"0$1",1],["(\\d)(\\d{4})(\\d{2})(\\d{4})","$2 15-$3-$4",["9(?:2[2-469]|3[3-578])","9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))","9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],"0$1",0,"$1 $2 $3-$4"],["(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 15-$3-$4",["91"],"0$1",0,"$1 $2 $3-$4"],["(\\d{3})(\\d{3})(\\d{5})","$1-$2-$3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 15-$3-$4",["9"],"0$1",0,"$1 $2 $3-$4"]],"0",0,"0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?","9$1"],"AS":["1","011","(?:[58]\\d\\d|684|900)\\d{7}",[10],0,"1",0,"([267]\\d{6})$|1","684$1",0,"684"],"AT":["43","00","1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",[4,5,6,7,8,9,10,11,12,13],[["(\\d)(\\d{3,12})","$1 $2",["1(?:11|[2-9])"],"0$1"],["(\\d{3})(\\d{2})","$1 $2",["517"],"0$1"],["(\\d{2})(\\d{3,5})","$1 $2",["5[079]"],"0$1"],["(\\d{3})(\\d{3,10})","$1 $2",["(?:31|4)6|51|6(?:48|5[0-3579]|[6-9])|7(?:20|32|8)|[89]","(?:31|4)6|51|6(?:485|5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],"0$1"],["(\\d{4})(\\d{3,9})","$1 $2",["[2-467]|5[2-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["5"],"0$1"],["(\\d{2})(\\d{4})(\\d{4,7})","$1 $2 $3",["5"],"0$1"]],"0"],"AU":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",[5,6,7,8,9,10,12],[["(\\d{2})(\\d{3,4})","$1 $2",["16"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["14|4"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:30|[89])"]]],"0",0,"(183[12])|0",0,0,0,[["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",[9]],["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,["163\\d{2,6}",[5,6,7,8,9]],["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",[6,8,10,12]]],"0011"],"AW":["297","00","(?:[25-79]\\d\\d|800)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[25-9]"]]]],"AX":["358","00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",[5,6,7,8,9,10,11,12],0,"0",0,0,0,0,"18",0,"00"],"AZ":["994","00","365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["90"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[28]|2|365|46","1[28]|2|365[45]|46","1[28]|2|365(?:4|5[02])|46"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[13-9]"],"0$1"]],"0"],"BA":["387","00","6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["6[1-3]|[7-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2-$3",["[3-5]|6[56]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["6"],"0$1"]],"0"],"BB":["1","011","(?:246|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","246$1",0,"246"],"BD":["880","00","[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",[6,7,8,9,10],[["(\\d{2})(\\d{4,6})","$1-$2",["31[5-8]|[459]1"],"0$1"],["(\\d{3})(\\d{3,7})","$1-$2",["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"],"0$1"],["(\\d{4})(\\d{3,6})","$1-$2",["[13-9]|2[23]"],"0$1"],["(\\d)(\\d{7,8})","$1-$2",["2"],"0$1"]],"0"],"BE":["32","00","4\\d{8}|[1-9]\\d{7}",[8,9],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:80|9)0"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[239]|4[23]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[15-8]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4"],"0$1"]],"0"],"BF":["226","00","[025-7]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[025-7]"]]]],"BG":["359","00","00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",[6,7,8,9,12],[["(\\d)(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["2"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["43[1-6]|70[1-9]"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:70|8)0"],"0$1"],["(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["43[1-7]|7"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[48]|9[08]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"]],"0"],"BH":["973","00","[136-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[13679]|8[02-4679]"]]]],"BI":["257","00","(?:[267]\\d|31)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2367]"]]]],"BJ":["229","00","(?:01\\d|[24-689])\\d{7}",[8,10],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-689]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["0"]]]],"BL":["590","00","(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",[9],0,"0",0,0,0,0,0,[["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"],["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"],["80[0-5]\\d{6}"],0,0,0,0,0,["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]],"BM":["1","011","(?:441|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","441$1",0,"441"],"BN":["673","00","[2-578]\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-578]"]]]],"BO":["591","00(?:1\\d)?","8001\\d{5}|(?:[2-467]\\d|50)\\d{6}",[8,9],[["(\\d)(\\d{7})","$1 $2",["[235]|4[46]"]],["(\\d{8})","$1",["[67]"]],["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["8"]]],"0",0,"0(1\\d)?"],"BQ":["599","00","(?:[34]1|7\\d)\\d{5}",[7],0,0,0,0,0,0,"[347]"],"BR":["55","00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)","(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",[8,9,10,11],[["(\\d{4})(\\d{4})","$1-$2",["300|4(?:0[02]|37)","4(?:02|37)0|[34]00"]],["(\\d{3})(\\d{2,3})(\\d{4})","$1 $2 $3",["(?:[358]|90)0"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"],"($1)"],["(\\d{2})(\\d{5})(\\d{4})","$1 $2-$3",["[16][1-9]|[2-57-9]"],"($1)"]],"0",0,"(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?","$2"],"BS":["1","011","(?:242|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([3-8]\\d{6})$|1","242$1",0,"242"],"BT":["975","00","[17]\\d{7}|[2-8]\\d{6}",[7,8],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[2-68]|7[246]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[67]|7"]]]],"BW":["267","00","(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",[7,8,10],[["(\\d{2})(\\d{5})","$1 $2",["90"]],["(\\d{3})(\\d{4})","$1 $2",["[24-6]|3[15-9]"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37]"]],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["0"]],["(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["8"]]]],"BY":["375","810","(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",[6,7,8,9,10,11],[["(\\d{3})(\\d{3})","$1 $2",["800"],"8 $1"],["(\\d{3})(\\d{2})(\\d{2,4})","$1 $2 $3",["800"],"8 $1"],["(\\d{4})(\\d{2})(\\d{3})","$1 $2-$3",["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])","1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],"8 0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["1(?:[56]|7[467])|2[1-3]"],"8 0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-4]"],"8 0$1"],["(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["[89]"],"8 $1"]],"8",0,"0|80?",0,0,0,0,"8~10"],"BZ":["501","00","(?:0800\\d|[2-8])\\d{6}",[7,11],[["(\\d{3})(\\d{4})","$1-$2",["[2-8]"]],["(\\d)(\\d{3})(\\d{4})(\\d{3})","$1-$2-$3-$4",["0"]]]],"CA":["1","011","[2-9]\\d{9}|3\\d{6}",[7,10],0,"1",0,0,0,0,0,[["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}",[10]],["",[10]],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",[10]],["900[2-9]\\d{6}",[10]],["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}",[10]],0,["310\\d{4}",[7]],0,["600[2-9]\\d{6}",[10]]]],"CC":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",[6,7,8,9,10,12],0,"0",0,"([59]\\d{7})$|0","8$1",0,0,[["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",[9]],["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,0,["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",[6,8,10,12]]],"0011"],"CD":["243","00","(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}",[7,8,9,10],[["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["88"],"0$1"],["(\\d{2})(\\d{5})","$1 $2",["[1-6]"],"0$1"],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["5"],"0$1"]],"0"],"CF":["236","00","(?:[27]\\d{3}|8776)\\d{4}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[278]"]]]],"CG":["242","00","222\\d{6}|(?:0\\d|80)\\d{7}",[9],[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["8"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[02]"]]]],"CH":["41","00","8\\d{11}|[2-9]\\d{8}",[9,12],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8[047]|90"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-79]|81"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["8"],"0$1"]],"0"],"CI":["225","00","[02]\\d{9}",[10],[["(\\d{2})(\\d{2})(\\d)(\\d{5})","$1 $2 $3 $4",["2"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3 $4",["0"]]]],"CK":["682","00","[2-578]\\d{4}",[5],[["(\\d{2})(\\d{3})","$1 $2",["[2-578]"]]]],"CL":["56","(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0","12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",[9,10,11],[["(\\d{5})(\\d{4})","$1 $2",["219","2196"],"($1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["44"]],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2[1-36]"],"($1)"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["9[2-9]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"],"($1)"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["60|8"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{3})(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3 $4",["60"]]]],"CM":["237","00","[26]\\d{8}|88\\d{6,7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["88"]],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[26]|88"]]]],"CN":["86","00|1(?:[12]\\d|79)\\d\\d00","(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}",[7,8,9,10,11,12],[["(\\d{2})(\\d{5,6})","$1 $2",["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]","(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1","10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12","10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123","10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"],"0$1"],["(\\d{3})(\\d{5,6})","$1 $2",["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]","(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]","85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])","85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["(?:4|80)0"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["10|2(?:[02-57-9]|1[1-9])","10|2(?:[02-57-9]|1[1-9])","10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"],"0$1",1],["(\\d{3})(\\d{7,8})","$1 $2",["9"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["80"],"0$1",1],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[3-578]"],"0$1",1],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["1[3-9]"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3 $4",["[12]"],"0$1",1]],"0",0,"(1(?:[12]\\d|79)\\d\\d)|0",0,0,0,0,"00"],"CO":["57","00(?:4(?:[14]4|56)|[579])","(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}",[8,10,11],[["(\\d{4})(\\d{4})","$1 $2",["46"]],["(\\d{3})(\\d{7})","$1 $2",["6|90"],"($1)"],["(\\d{3})(\\d{7})","$1 $2",["3[0-357]|91"]],["(\\d)(\\d{3})(\\d{7})","$1-$2-$3",["1"],"0$1",0,"$1 $2 $3"]],"0",0,"0([3579]|4(?:[14]4|56))?"],"CR":["506","00","(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",[8,10],[["(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[3-9]"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[89]"]]],0,0,"(19(?:0[0-2468]|1[09]|20|66|77|99))"],"CU":["53","119","(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}",[6,7,8,10],[["(\\d{2})(\\d{4,6})","$1 $2",["2[1-4]|[34]"],"(0$1)"],["(\\d)(\\d{6,7})","$1 $2",["7"],"(0$1)"],["(\\d)(\\d{7})","$1 $2",["[56]"],"0$1"],["(\\d{3})(\\d{7})","$1 $2",["8"],"0$1"]],"0"],"CV":["238","0","(?:[2-59]\\d\\d|800)\\d{4}",[7],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2-589]"]]]],"CW":["599","00","(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[3467]"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["9[4-8]"]]],0,0,0,0,0,"[69]"],"CX":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",[6,7,8,9,10,12],0,"0",0,"([59]\\d{7})$|0","8$1",0,0,[["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",[9]],["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,0,["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",[6,8,10,12]]],"0011"],"CY":["357","00","(?:[279]\\d|[58]0)\\d{6}",[8],[["(\\d{2})(\\d{6})","$1 $2",["[257-9]"]]]],"CZ":["420","00","(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",[9,10,11,12],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]|9[015-7]"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3 $4",["96"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]]],"DE":["49","00","[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",[4,5,6,7,8,9,10,11,12,13,14,15],[["(\\d{2})(\\d{3,13})","$1 $2",["3[02]|40|[68]9"],"0$1"],["(\\d{3})(\\d{3,12})","$1 $2",["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1","2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"],"0$1"],["(\\d{4})(\\d{2,11})","$1 $2",["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]","[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["138"],"0$1"],["(\\d{5})(\\d{2,10})","$1 $2",["3"],"0$1"],["(\\d{3})(\\d{5,11})","$1 $2",["181"],"0$1"],["(\\d{3})(\\d)(\\d{4,10})","$1 $2 $3",["1(?:3|80)|9"],"0$1"],["(\\d{3})(\\d{7,8})","$1 $2",["1[67]"],"0$1"],["(\\d{3})(\\d{7,12})","$1 $2",["8"],"0$1"],["(\\d{5})(\\d{6})","$1 $2",["185","1850","18500"],"0$1"],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{4})(\\d{7})","$1 $2",["18[68]"],"0$1"],["(\\d{4})(\\d{7})","$1 $2",["15[1279]"],"0$1"],["(\\d{5})(\\d{6})","$1 $2",["15[03568]","15(?:[0568]|31)"],"0$1"],["(\\d{3})(\\d{8})","$1 $2",["18"],"0$1"],["(\\d{3})(\\d{2})(\\d{7,8})","$1 $2 $3",["1(?:6[023]|7)"],"0$1"],["(\\d{4})(\\d{2})(\\d{7})","$1 $2 $3",["15[279]"],"0$1"],["(\\d{3})(\\d{2})(\\d{8})","$1 $2 $3",["15"],"0$1"]],"0"],"DJ":["253","00","(?:2\\d|77)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[27]"]]]],"DK":["45","00","[2-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-9]"]]]],"DM":["1","011","(?:[58]\\d\\d|767|900)\\d{7}",[10],0,"1",0,"([2-7]\\d{6})$|1","767$1",0,"767"],"DO":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,0,0,0,"8001|8[024]9"],"DZ":["213","00","(?:[1-4]|[5-79]\\d|80)\\d{7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-4]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["9"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-8]"],"0$1"]],"0"],"EC":["593","00","1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",[8,9,10,11],[["(\\d)(\\d{3})(\\d{4})","$1 $2-$3",["[2-7]"],"(0$1)",0,"$1-$2-$3"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["9"],"0$1"],["(\\d{4})(\\d{3})(\\d{3,4})","$1 $2 $3",["1"]]],"0"],"EE":["372","00","8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",[7,8,10],[["(\\d{3})(\\d{4})","$1 $2",["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88","[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]],["(\\d{4})(\\d{3,4})","$1 $2",["[45]|8(?:00|[1-49])","[45]|8(?:00[1-9]|[1-49])"]],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["7"]],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]]],"EG":["20","00","[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",[8,9,10],[["(\\d)(\\d{7,8})","$1 $2",["[23]"],"0$1"],["(\\d{2})(\\d{6,7})","$1 $2",["1[35]|[4-6]|8[2468]|9[235-7]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{2})(\\d{8})","$1 $2",["1"],"0$1"]],"0"],"EH":["212","00","[5-8]\\d{8}",[9],0,"0",0,0,0,0,"528[89]"],"ER":["291","00","[178]\\d{6}",[7],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[178]"],"0$1"]],"0"],"ES":["34","00","[5-9]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]00"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-9]"]]]],"ET":["251","00","(?:11|[2-579]\\d)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-579]"],"0$1"]],"0"],"FI":["358","00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",[5,6,7,8,9,10,11,12],[["(\\d{5})","$1",["20[2-59]"],"0$1"],["(\\d{3})(\\d{3,7})","$1 $2",["(?:[1-3]0|[68])0|70[07-9]"],"0$1"],["(\\d{2})(\\d{4,8})","$1 $2",["[14]|2[09]|50|7[135]"],"0$1"],["(\\d{2})(\\d{6,10})","$1 $2",["7"],"0$1"],["(\\d)(\\d{4,9})","$1 $2",["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"],"0$1"]],"0",0,0,0,0,"1[03-79]|[2-9]",0,"00"],"FJ":["679","0(?:0|52)","45\\d{5}|(?:0800\\d|[235-9])\\d{6}",[7,11],[["(\\d{3})(\\d{4})","$1 $2",["[235-9]|45"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]]],0,0,0,0,0,0,0,"00"],"FK":["500","00","[2-7]\\d{4}",[5]],"FM":["691","00","(?:[39]\\d\\d|820)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[389]"]]]],"FO":["298","00","[2-9]\\d{5}",[6],[["(\\d{6})","$1",["[2-9]"]]],0,0,"(10(?:01|[12]0|88))"],"FR":["33","00","[1-9]\\d{8}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0 $1"],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[1-79]"],"0$1"]],"0"],"GA":["241","00","(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",[7,8],[["(\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-7]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["11|[67]"],"0$1"]],0,0,"0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})","$1"],"GB":["44","00","[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",[7,9,10],[["(\\d{3})(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["845","8454","84546","845464"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["800"],"0$1"],["(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:(?:38|69)7|5(?:24|39)|768|946)","1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"],"0$1"],["(\\d{4})(\\d{5,6})","$1 $2",["1(?:[2-69][02-9]|[78])"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[25]|7(?:0|6[02-9])","[25]|7(?:0|6(?:[03-9]|2[356]))"],"0$1"],["(\\d{4})(\\d{6})","$1 $2",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[1389]"],"0$1"]],"0",0,0,0,0,0,[["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",[9,10]],["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",[10]],["80[08]\\d{7}|800\\d{6}|8001111"],["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",[7,10]],["70\\d{8}",[10]],0,["(?:3[0347]|55)\\d{8}",[10]],["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",[10]],["56\\d{8}",[10]]],0," x"],"GD":["1","011","(?:473|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","473$1",0,"473"],"GE":["995","00","(?:[3-57]\\d\\d|800)\\d{6}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["32"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[57]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[348]"],"0$1"]],"0"],"GF":["594","00","(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]|9[47]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[89]"],"0$1"]],"0"],"GG":["44","00","(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",[7,9,10],0,"0",0,"([25-9]\\d{5})$|0","1481$1",0,0,[["1481[25-9]\\d{5}",[10]],["7(?:(?:781|839)\\d|911[17])\\d{5}",[10]],["80[08]\\d{7}|800\\d{6}|8001111"],["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",[7,10]],["70\\d{8}",[10]],0,["(?:3[0347]|55)\\d{8}",[10]],["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",[10]],["56\\d{8}",[10]]]],"GH":["233","00","(?:[235]\\d{3}|800)\\d{5}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["8"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[235]"],"0$1"]],"0"],"GI":["350","00","(?:[25]\\d|60)\\d{6}",[8],[["(\\d{3})(\\d{5})","$1 $2",["2"]]]],"GL":["299","00","(?:19|[2-689]\\d|70)\\d{4}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["19|[2-9]"]]]],"GM":["220","00","[2-9]\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],"GN":["224","00","722\\d{6}|(?:3|6\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["3"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[67]"]]]],"GP":["590","00","(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-79]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0",0,0,0,0,0,[["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"],["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"],["80[0-5]\\d{6}"],0,0,0,0,0,["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]],"GQ":["240","00","222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235]"]],["(\\d{3})(\\d{6})","$1 $2",["[89]"]]]],"GR":["30","00","5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",[10,11,12],[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["21|7"]],["(\\d{4})(\\d{6})","$1 $2",["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2689]"]],["(\\d{3})(\\d{3,4})(\\d{5})","$1 $2 $3",["8"]]]],"GT":["502","00","80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",[8,11],[["(\\d{4})(\\d{4})","$1 $2",["[2-8]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]]],"GU":["1","011","(?:[58]\\d\\d|671|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","671$1",0,"671"],"GW":["245","00","[49]\\d{8}|4\\d{6}",[7,9],[["(\\d{3})(\\d{4})","$1 $2",["40"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"]]]],"GY":["592","001","(?:[2-8]\\d{3}|9008)\\d{3}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],"HK":["852","00(?:30|5[09]|[126-9]?)","8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",[5,6,7,8,9,11],[["(\\d{3})(\\d{2,5})","$1 $2",["900","9003"]],["(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],["(\\d{3})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]],0,0,0,0,0,0,0,"00"],"HN":["504","00","8\\d{10}|[237-9]\\d{7}",[8,11],[["(\\d{4})(\\d{4})","$1-$2",["[237-9]"]]]],"HR":["385","00","[2-69]\\d{8}|80\\d{5,7}|[1-79]\\d{7}|6\\d{6}",[7,8,9],[["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["6[01]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{4})(\\d{3})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["6|7[245]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-57]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"]],"0"],"HT":["509","00","(?:[2-489]\\d|55)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[2-589]"]]]],"HU":["36","00","[235-7]\\d{8}|[1-9]\\d{7}",[8,9],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"(06 $1)"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"],"(06 $1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"06 $1"]],"06"],"ID":["62","00[89]","00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}",[7,8,9,10,11,12,13,14,15,16,17],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["15"]],["(\\d{2})(\\d{5,9})","$1 $2",["2[124]|[36]1"],"(0$1)"],["(\\d{3})(\\d{5,7})","$1 $2",["800"],"0$1"],["(\\d{3})(\\d{5,8})","$1 $2",["[2-79]"],"(0$1)"],["(\\d{3})(\\d{3,4})(\\d{3})","$1-$2-$3",["8[1-35-9]"],"0$1"],["(\\d{3})(\\d{6,8})","$1 $2",["1"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["804"],"0$1"],["(\\d{3})(\\d)(\\d{3})(\\d{3})","$1 $2 $3 $4",["80"],"0$1"],["(\\d{3})(\\d{4})(\\d{4,5})","$1-$2-$3",["8"],"0$1"]],"0"],"IE":["353","00","(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",[7,8,9,10],[["(\\d{2})(\\d{5})","$1 $2",["2[24-9]|47|58|6[237-9]|9[35-9]"],"(0$1)"],["(\\d{3})(\\d{5})","$1 $2",["[45]0"],"(0$1)"],["(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["1"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2569]|4[1-69]|7[14]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["81"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[78]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["4"],"(0$1)"],["(\\d{2})(\\d)(\\d{3})(\\d{4})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"IL":["972","0(?:0|1[2-9])","1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",[7,8,9,10,11,12],[["(\\d{4})(\\d{3})","$1-$2",["125"]],["(\\d{4})(\\d{2})(\\d{2})","$1-$2-$3",["121"]],["(\\d)(\\d{3})(\\d{4})","$1-$2-$3",["[2-489]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1-$2-$3",["12"]],["(\\d{4})(\\d{6})","$1-$2",["159"]],["(\\d)(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3-$4",["1[7-9]"]],["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})","$1-$2 $3-$4",["15"]]],"0"],"IM":["44","00","1624\\d{6}|(?:[3578]\\d|90)\\d{8}",[10],0,"0",0,"([25-8]\\d{5})$|0","1624$1",0,"74576|(?:16|7[56])24"],"IN":["91","00","(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",[8,9,10,11,12,13],[["(\\d{8})","$1",["5(?:0|2[23]|3[03]|[67]1|88)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"],0,1],["(\\d{4})(\\d{4,5})","$1 $2",["180","1800"],0,1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["140"],0,1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["11|2[02]|33|4[04]|79[1-7]|80[2-46]","11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])","11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"],"0$1",1],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807","1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]","1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"],"0$1",1],["(\\d{5})(\\d{5})","$1 $2",["[6-9]"],"0$1",1],["(\\d{4})(\\d{2,4})(\\d{4})","$1 $2 $3",["1(?:6|8[06])","1(?:6|8[06]0)"],0,1],["(\\d{4})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["18"],0,1]],"0"],"IO":["246","00","3\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["3"]]]],"IQ":["964","00","(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-6]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"]],"0"],"IR":["98","00","[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",[4,5,6,7,10],[["(\\d{4,5})","$1",["96"],"0$1"],["(\\d{2})(\\d{4,5})","$1 $2",["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[1-8]"],"0$1"]],"0"],"IS":["354","00|1(?:0(?:01|[12]0)|100)","(?:38\\d|[4-9])\\d{6}",[7,9],[["(\\d{3})(\\d{4})","$1 $2",["[4-9]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["3"]]],0,0,0,0,0,0,0,"00"],"IT":["39","00","0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",[6,7,8,9,10,11,12],[["(\\d{2})(\\d{4,6})","$1 $2",["0[26]"]],["(\\d{3})(\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]],["(\\d{4})(\\d{2,6})","$1 $2",["0(?:[13-579][2-46-8]|8[236-8])"]],["(\\d{4})(\\d{4})","$1 $2",["894"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[26]|5"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["1(?:44|[679])|[378]|43"]],["(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[13-57-9][0159]|14"]],["(\\d{2})(\\d{4})(\\d{5})","$1 $2 $3",["0[26]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]],["(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["3"]]],0,0,0,0,0,0,[["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}",[6,7,8,9,10,11]],["3[2-9]\\d{7,8}|(?:31|43)\\d{8}",[9,10]],["80(?:0\\d{3}|3)\\d{3}",[6,9]],["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",[6,8,9,10]],["1(?:78\\d|99)\\d{6}",[9,10]],["3[2-8]\\d{9,10}",[11,12]],0,0,["55\\d{8}",[10]],["84(?:[08]\\d{3}|[17])\\d{3}",[6,9]]]],"JE":["44","00","1534\\d{6}|(?:[3578]\\d|90)\\d{8}",[10],0,"0",0,"([0-24-8]\\d{5})$|0","1534$1",0,0,[["1534[0-24-8]\\d{5}"],["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"],["80(?:07(?:35|81)|8901)\\d{4}"],["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"],["701511\\d{4}"],0,["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"],["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"],["56\\d{8}"]]],"JM":["1","011","(?:[58]\\d\\d|658|900)\\d{7}",[10],0,"1",0,0,0,0,"658|876"],"JO":["962","00","(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",[8,9],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2356]|87"],"(0$1)"],["(\\d{3})(\\d{5,6})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["70"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"]],"0"],"JP":["81","010","00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",[8,9,10,11,12,13,14,15,16,17],[["(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3",["(?:12|57|99)0"],"0$1"],["(\\d{4})(\\d)(\\d{4})","$1-$2-$3",["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1-$2-$3",["[36]|4(?:2[09]|7[01])","[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"],"0$1"],["(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["[14]|[289][2-9]|5[3-9]|7[2-4679]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["800"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[257-9]"],"0$1"]],"0",0,"(000[259]\\d{6})$|(?:(?:003768)0?)|0","$1"],"KE":["254","000","(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",[7,8,9,10],[["(\\d{2})(\\d{5,7})","$1 $2",["[24-6]"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["[17]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],"0"],"KG":["996","00","8\\d{9}|[235-9]\\d{8}",[9,10],[["(\\d{4})(\\d{5})","$1 $2",["3(?:1[346]|[24-79])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235-79]|88"],"0$1"],["(\\d{3})(\\d{3})(\\d)(\\d{2,3})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"KH":["855","00[14-9]","1\\d{9}|[1-9]\\d{7,8}",[8,9,10],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-9]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"KI":["686","00","(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",[5,8],0,"0"],"KM":["269","00","[3478]\\d{6}",[7],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[3478]"]]]],"KN":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-7]\\d{6})$|1","869$1",0,"869"],"KP":["850","00|99","85\\d{6}|(?:19\\d|[2-7])\\d{7}",[8,10],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"]],"0"],"KR":["82","00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))","00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",[5,6,8,9,10,11,12,13,14],[["(\\d{2})(\\d{3,4})","$1-$2",["(?:3[1-3]|[46][1-4]|5[1-5])1"],"0$1"],["(\\d{4})(\\d{4})","$1-$2",["1"]],["(\\d)(\\d{3,4})(\\d{4})","$1-$2-$3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[36]0|8"],"0$1"],["(\\d{2})(\\d{3,4})(\\d{4})","$1-$2-$3",["[1346]|5[1-5]"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(\\d{2})(\\d{5})(\\d{4})","$1-$2-$3",["5"],"0$1"]],"0",0,"0(8(?:[1-46-8]|5\\d\\d))?"],"KW":["965","00","18\\d{5}|(?:[2569]\\d|41)\\d{6}",[7,8],[["(\\d{4})(\\d{3,4})","$1 $2",["[169]|2(?:[235]|4[1-35-9])|52"]],["(\\d{3})(\\d{5})","$1 $2",["[245]"]]]],"KY":["1","011","(?:345|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","345$1",0,"345"],"KZ":["7","810","(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",[10,14],0,"8",0,0,0,0,"33|7",0,"8~10"],"LA":["856","00","[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",[8,9,10],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2[13]|3[14]|[4-8]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["30[0135-9]"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[23]"],"0$1"]],"0"],"LB":["961","00","[27-9]\\d{7}|[13-9]\\d{6}",[7,8],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27-9]"]]],"0"],"LC":["1","011","(?:[58]\\d\\d|758|900)\\d{7}",[10],0,"1",0,"([2-8]\\d{6})$|1","758$1",0,"758"],"LI":["423","00","[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",[7,9],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2379]|8(?:0[09]|7)","[2379]|8(?:0(?:02|9)|7)"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["69"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]],"0",0,"(1001)|0"],"LK":["94","00","[1-9]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[1-689]"],"0$1"]],"0"],"LR":["231","00","(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",[7,8,9],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["4[67]|[56]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[2-578]"],"0$1"]],"0"],"LS":["266","00","(?:[256]\\d\\d|800)\\d{5}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[2568]"]]]],"LT":["370","00","(?:[3469]\\d|52|[78]0)\\d{6}",[8],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["52[0-7]"],"(0-$1)",1],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[7-9]"],"0 $1",1],["(\\d{2})(\\d{6})","$1 $2",["37|4(?:[15]|6[1-8])"],"(0-$1)",1],["(\\d{3})(\\d{5})","$1 $2",["[3-6]"],"(0-$1)",1]],"0",0,"[08]"],"LU":["352","00","35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",[4,5,6,7,8,9,10,11],[["(\\d{2})(\\d{3})","$1 $2",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]],["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["20[2-689]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4",["2(?:[0367]|4[3-8])"]],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["80[01]|90[015]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["20"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4 $5",["2(?:[0367]|4[3-8])"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})","$1 $2 $3 $4",["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]],0,0,"(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"],"LV":["371","00","(?:[268]\\d|90)\\d{6}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[269]|8[01]"]]]],"LY":["218","00","[2-9]\\d{8}",[9],[["(\\d{2})(\\d{7})","$1-$2",["[2-9]"],"0$1"]],"0"],"MA":["212","00","[5-8]\\d{8}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5[45]"],"0$1"],["(\\d{4})(\\d{5})","$1-$2",["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"],"0$1"],["(\\d{2})(\\d{7})","$1-$2",["8"],"0$1"],["(\\d{3})(\\d{6})","$1-$2",["[5-7]"],"0$1"]],"0",0,0,0,0,0,[["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"],["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-5]))\\d{6}"],["80[0-7]\\d{6}"],["89\\d{7}"],0,0,0,0,["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]],"MC":["377","00","(?:[3489]|6\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["4"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[389]"]],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["6"],"0$1"]],"0"],"MD":["373","00","(?:[235-7]\\d|[89]0)\\d{6}",[8],[["(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["22|3"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[25-7]"],"0$1"]],"0"],"ME":["382","00","(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"0$1"]],"0"],"MF":["590","00","(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",[9],0,"0",0,0,0,0,0,[["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"],["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"],["80[0-5]\\d{6}"],0,0,0,0,0,["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]],"MG":["261","00","[23]\\d{8}",[9],[["(\\d{2})(\\d{2})(\\d{3})(\\d{2})","$1 $2 $3 $4",["[23]"],"0$1"]],"0",0,"([24-9]\\d{6})$|0","20$1"],"MH":["692","011","329\\d{4}|(?:[256]\\d|45)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1-$2",["[2-6]"]]],"1"],"MK":["389","00","[2-578]\\d{7}",[8],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2|34[47]|4(?:[37]7|5[47]|64)"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[347]"],"0$1"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["[58]"],"0$1"]],"0"],"ML":["223","00","[24-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-9]"]]]],"MM":["95","00","1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",[6,7,8,9,10],[["(\\d)(\\d{2})(\\d{3})","$1 $2 $3",["16|2"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]|452|678|86","[12]|452|6788|86"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[4-7]|8[1-35]"],"0$1"],["(\\d)(\\d{3})(\\d{4,6})","$1 $2 $3",["9(?:2[0-4]|[35-9]|4[137-9])"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["92"],"0$1"],["(\\d)(\\d{5})(\\d{4})","$1 $2 $3",["9"],"0$1"]],"0"],"MN":["976","001","[12]\\d{7,9}|[5-9]\\d{7}",[8,9,10],[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[12]1"],"0$1"],["(\\d{4})(\\d{4})","$1 $2",["[5-9]"]],["(\\d{3})(\\d{5,6})","$1 $2",["[12]2[1-3]"],"0$1"],["(\\d{4})(\\d{5,6})","$1 $2",["[12](?:27|3[2-8]|4[2-68]|5[1-4689])","[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"],"0$1"],["(\\d{5})(\\d{4,5})","$1 $2",["[12]"],"0$1"]],"0"],"MO":["853","00","0800\\d{3}|(?:28|[68]\\d)\\d{6}",[7,8],[["(\\d{4})(\\d{3})","$1 $2",["0"]],["(\\d{4})(\\d{4})","$1 $2",["[268]"]]]],"MP":["1","011","[58]\\d{9}|(?:67|90)0\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","670$1",0,"670"],"MQ":["596","00","(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-79]|8(?:0[6-9]|[36])"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"MR":["222","00","(?:[2-4]\\d\\d|800)\\d{5}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-48]"]]]],"MS":["1","011","(?:[58]\\d\\d|664|900)\\d{7}",[10],0,"1",0,"([34]\\d{6})$|1","664$1",0,"664"],"MT":["356","00","3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[2357-9]"]]]],"MU":["230","0(?:0|[24-7]0|3[03])","(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",[7,8,10],[["(\\d{3})(\\d{4})","$1 $2",["[2-46]|8[013]"]],["(\\d{4})(\\d{4})","$1 $2",["[57]"]],["(\\d{5})(\\d{5})","$1 $2",["8"]]],0,0,0,0,0,0,0,"020"],"MV":["960","0(?:0|19)","(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",[7,10],[["(\\d{3})(\\d{4})","$1-$2",["[34679]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"]]],0,0,0,0,0,0,0,"00"],"MW":["265","00","(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",[7,9],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["1[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[137-9]"],"0$1"]],"0"],"MX":["52","0[09]","[2-9]\\d{9}",[10],[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["33|5[56]|81"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2-9]"]]],0,0,0,0,0,0,0,"00"],"MY":["60","00","1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1-$2 $3",["[4-79]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1-$2 $3",["1(?:[02469]|[378][1-9]|53)|8","1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1-$2 $3",["3"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3-$4",["1(?:[367]|80)"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2 $3",["15"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2 $3",["1"],"0$1"]],"0"],"MZ":["258","00","(?:2|8\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2|8[2-79]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]]],"NA":["264","00","[68]\\d{7,8}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["88"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["6"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["87"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],"0"],"NC":["687","00","(?:050|[2-57-9]\\d\\d)\\d{3}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1.$2.$3",["[02-57-9]"]]]],"NE":["227","00","[027-9]\\d{7}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["08"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[089]|2[013]|7[0467]"]]]],"NF":["672","00","[13]\\d{5}",[6],[["(\\d{2})(\\d{4})","$1 $2",["1[0-3]"]],["(\\d)(\\d{5})","$1 $2",["[13]"]]],0,0,"([0-258]\\d{4})$","3$1"],"NG":["234","009","38\\d{6}|[78]\\d{9,13}|(?:20|9\\d)\\d{8}",[8,10,11,12,13,14],[["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["3"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[7-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["20[129]"],"0$1"],["(\\d{4})(\\d{2})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["[78]"],"0$1"],["(\\d{3})(\\d{5})(\\d{5,6})","$1 $2 $3",["[78]"],"0$1"]],"0"],"NI":["505","00","(?:1800|[25-8]\\d{3})\\d{4}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[125-8]"]]]],"NL":["31","00","(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",[5,6,7,8,9,10,11],[["(\\d{3})(\\d{4,7})","$1 $2",["[89]0"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["66"],"0$1"],["(\\d)(\\d{8})","$1 $2",["6"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-578]|91"],"0$1"],["(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3",["9"],"0$1"]],"0"],"NO":["47","00","(?:0|[2-9]\\d{3})\\d{4}",[5,8],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["8"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-79]"]]],0,0,0,0,0,"[02-689]|7[0-8]"],"NP":["977","00","(?:1\\d|9)\\d{9}|[1-9]\\d{7}",[8,10,11],[["(\\d)(\\d{7})","$1-$2",["1[2-6]"],"0$1"],["(\\d{2})(\\d{6})","$1-$2",["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"],"0$1"],["(\\d{3})(\\d{7})","$1-$2",["9"]]],"0"],"NR":["674","00","(?:222|444|(?:55|8\\d)\\d|666|777|999)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[24-9]"]]]],"NU":["683","00","(?:[4-7]|888\\d)\\d{3}",[4,7],[["(\\d{3})(\\d{4})","$1 $2",["8"]]]],"NZ":["64","0(?:0|161)","[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,8})","$1 $2",["8[1-79]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["50[036-8]|8|90","50(?:[0367]|88)|8|90"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["24|[346]|7[2-57-9]|9[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:10|74)|[589]"],"0$1"],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["1|2[028]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,5})","$1 $2 $3",["2(?:[169]|7[0-35-9])|7"],"0$1"]],"0",0,0,0,0,0,0,"00"],"OM":["968","00","(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",[7,8,9],[["(\\d{3})(\\d{4,6})","$1 $2",["[58]"]],["(\\d{2})(\\d{6})","$1 $2",["2"]],["(\\d{4})(\\d{4})","$1 $2",["[179]"]]]],"PA":["507","00","(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",[7,8,10,11],[["(\\d{3})(\\d{4})","$1-$2",["[1-57-9]"]],["(\\d{4})(\\d{4})","$1-$2",["[68]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]]],"PE":["51","00|19(?:1[124]|77|90)00","(?:[14-8]|9\\d)\\d{7}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["80"],"(0$1)"],["(\\d)(\\d{7})","$1 $2",["1"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["[4-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"]]],"0",0,0,0,0,0,0,"00"," Anexo "],"PF":["689","00","4\\d{5}(?:\\d{2})?|8\\d{7,8}",[6,8,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["44"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4|8[7-9]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]]],"PG":["675","00|140[1-3]","(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["18|[2-69]|85"]],["(\\d{4})(\\d{4})","$1 $2",["[78]"]]],0,0,0,0,0,0,0,"00"],"PH":["63","00","(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",[6,8,9,10,11,12,13],[["(\\d)(\\d{5})","$1 $2",["2"],"(0$1)"],["(\\d{4})(\\d{4,6})","$1 $2",["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2","3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],"(0$1)"],["(\\d{5})(\\d{4})","$1 $2",["346|4(?:27|9[35])|883","3469|4(?:279|9(?:30|56))|8834"],"(0$1)"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3-7]|8[2-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})","$1 $2 $3 $4",["1"]]],"0"],"PK":["92","00","122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",[8,9,10,11,12],[["(\\d{3})(\\d{3})(\\d{2,7})","$1 $2 $3",["[89]0"],"0$1"],["(\\d{4})(\\d{5})","$1 $2",["1"]],["(\\d{3})(\\d{6,7})","$1 $2",["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])","9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"],"(0$1)"],["(\\d{2})(\\d{7,8})","$1 $2",["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"],"(0$1)"],["(\\d{5})(\\d{5})","$1 $2",["58"],"(0$1)"],["(\\d{3})(\\d{7})","$1 $2",["3"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[24-9]"],"(0$1)"]],"0"],"PL":["48","00","(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",[6,7,8,9,10],[["(\\d{5})","$1",["19"]],["(\\d{3})(\\d{3})","$1 $2",["11|20|64"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1","(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["64"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[2-8]|[2-7]|8[1-79]|9[145]"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["8"]]]],"PM":["508","00","[45]\\d{5}|(?:708|8\\d\\d)\\d{6}",[6,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[45]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"PR":["1","011","(?:[589]\\d\\d|787)\\d{7}",[10],0,"1",0,0,0,0,"787|939"],"PS":["970","00","[2489]2\\d{6}|(?:1\\d|5)\\d{8}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2489]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["5"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"PT":["351","00","1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["2[12]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["16|[236-9]"]]]],"PW":["680","01[12]","(?:[24-8]\\d\\d|345|900)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],"PY":["595","00","59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",[6,7,8,9,10,11],[["(\\d{3})(\\d{3,6})","$1 $2",["[2-9]0"],"0$1"],["(\\d{2})(\\d{5})","$1 $2",["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"],"(0$1)"],["(\\d{3})(\\d{4,5})","$1 $2",["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["87"]],["(\\d{3})(\\d{6})","$1 $2",["9(?:[5-79]|8[1-7])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]"],"0$1"],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["9"]]],"0"],"QA":["974","00","800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",[7,8,9,11],[["(\\d{3})(\\d{4})","$1 $2",["2[16]|8"]],["(\\d{4})(\\d{4})","$1 $2",["[3-7]"]]]],"RE":["262","00","709\\d{6}|(?:26|[689]\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[26-9]"],"0$1"]],"0",0,0,0,0,0,[["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"],["(?:69(?:2\\d\\d|3(?:[06][0-6]|1[0-3]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"],["80\\d{7}"],["89[1-37-9]\\d{6}"],0,0,0,0,["9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}"],["8(?:1[019]|2[0156]|84|90)\\d{6}"]]],"RO":["40","00","(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}",[6,9],[["(\\d{3})(\\d{3})","$1 $2",["2[3-6]","2[3-6]\\d9"],"0$1"],["(\\d{2})(\\d{4})","$1 $2",["219|31"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[23]1"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[236-9]"],"0$1"]],"0",0,0,0,0,0,0,0," int "],"RS":["381","00","38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",[6,7,8,9,10,11,12],[["(\\d{3})(\\d{3,9})","$1 $2",["(?:2[389]|39)0|[7-9]"],"0$1"],["(\\d{2})(\\d{5,10})","$1 $2",["[1-36]"],"0$1"]],"0"],"RU":["7","810","8\\d{13}|[347-9]\\d{9}",[10,14],[["(\\d{4})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-8]|2[1-9])","7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))","7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"],"8 ($1)",1],["(\\d{5})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-68]|2[1-9])","7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))","7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],"8 ($1)",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"8 ($1)",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[349]|8(?:[02-7]|1[1-8])"],"8 ($1)",1],["(\\d{4})(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3 $4",["8"],"8 ($1)"]],"8",0,0,0,0,"3[04-689]|[489]",0,"8~10"],"RW":["250","00","(?:06|[27]\\d\\d|[89]00)\\d{6}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[7-9]"],"0$1"]],"0"],"SA":["966","00","92\\d{7}|(?:[15]|8\\d)\\d{8}",[9,10],[["(\\d{4})(\\d{5})","$1 $2",["9"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["81"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]],"0"],"SB":["677","0[01]","[6-9]\\d{6}|[1-6]\\d{4}",[5,7],[["(\\d{2})(\\d{5})","$1 $2",["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]]],"SC":["248","010|0[0-2]","(?:[2489]\\d|64)\\d{5}",[7],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[246]|9[57]"]]],0,0,0,0,0,0,0,"00"],"SD":["249","00","[19]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[19]"],"0$1"]],"0"],"SE":["46","00","(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",[6,7,8,9,10,12],[["(\\d{2})(\\d{2,3})(\\d{2})","$1-$2 $3",["20"],"0$1",0,"$1 $2 $3"],["(\\d{3})(\\d{4})","$1-$2",["9(?:00|39|44|9)"],"0$1",0,"$1 $2"],["(\\d{2})(\\d{3})(\\d{2})","$1-$2 $3",["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"],"0$1",0,"$1 $2 $3"],["(\\d)(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["8"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2,3})(\\d{2})","$1-$2 $3",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1",0,"$1 $2 $3"],["(\\d{3})(\\d{2,3})(\\d{3})","$1-$2 $3",["9(?:00|39|44)"],"0$1",0,"$1 $2 $3"],["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"],"0$1",0,"$1 $2 $3 $4"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["10|7"],"0$1",0,"$1 $2 $3 $4"],["(\\d)(\\d{3})(\\d{3})(\\d{2})","$1-$2 $3 $4",["8"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1-$2 $3 $4",["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{2})(\\d{3})","$1-$2 $3 $4",["9"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4 $5",["[26]"],"0$1",0,"$1 $2 $3 $4 $5"]],"0"],"SG":["65","0[0-3]\\d","(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",[8,10,11],[["(\\d{4})(\\d{4})","$1 $2",["[369]|8(?:0[1-9]|[1-9])"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]],["(\\d{4})(\\d{4})(\\d{3})","$1 $2 $3",["7"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]]],"SH":["290","00","(?:[256]\\d|8)\\d{3}",[4,5],0,0,0,0,0,0,"[256]"],"SI":["386","00|10(?:22|66|88|99)","[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",[5,6,7,8],[["(\\d{2})(\\d{3,6})","$1 $2",["8[09]|9"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["59|8"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37][01]|4[0139]|51|6"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-57]"],"(0$1)"]],"0",0,0,0,0,0,0,"00"],"SJ":["47","00","0\\d{4}|(?:[489]\\d|79)\\d{6}",[5,8],0,0,0,0,0,0,"79"],"SK":["421","00","[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",[6,7,9],[["(\\d)(\\d{2})(\\d{3,4})","$1 $2 $3",["21"],"0$1"],["(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["[3-5][1-8]1","[3-5][1-8]1[67]"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{2})","$1/$2 $3 $4",["2"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[689]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1/$2 $3 $4",["[3-5]"],"0$1"]],"0"],"SL":["232","00","(?:[237-9]\\d|66)\\d{6}",[8],[["(\\d{2})(\\d{6})","$1 $2",["[236-9]"],"(0$1)"]],"0"],"SM":["378","00","(?:0549|[5-7]\\d)\\d{6}",[8,10],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]"]],["(\\d{4})(\\d{6})","$1 $2",["0"]]],0,0,"([89]\\d{5})$","0549$1"],"SN":["221","00","(?:[378]\\d|93)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[379]"]]]],"SO":["252","00","[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",[6,7,8,9],[["(\\d{2})(\\d{4})","$1 $2",["8[125]"]],["(\\d{6})","$1",["[134]"]],["(\\d)(\\d{6})","$1 $2",["[15]|2[0-79]|3[0-46-8]|4[0-7]"]],["(\\d)(\\d{7})","$1 $2",["(?:2|90)4|[67]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[348]|64|79|90"]],["(\\d{2})(\\d{5,7})","$1 $2",["1|28|6[0-35-9]|7[67]|9[2-9]"]]],"0"],"SR":["597","00","(?:[2-5]|68|[78]\\d)\\d{5}",[6,7],[["(\\d{2})(\\d{2})(\\d{2})","$1-$2-$3",["56"]],["(\\d{3})(\\d{3})","$1-$2",["[2-5]"]],["(\\d{3})(\\d{4})","$1-$2",["[6-8]"]]]],"SS":["211","00","[19]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[19]"],"0$1"]],"0"],"ST":["239","00","(?:22|9\\d)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[29]"]]]],"SV":["503","00","[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?",[7,8,11],[["(\\d{3})(\\d{4})","$1 $2",["[89]"]],["(\\d{4})(\\d{4})","$1 $2",["[267]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[89]"]]]],"SX":["1","011","7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"(5\\d{6})$|1","721$1",0,"721"],"SY":["963","00","[1-359]\\d{8}|[1-5]\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-4]|5[1-3]"],"0$1",1],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[59]"],"0$1",1]],"0"],"SZ":["268","00","0800\\d{4}|(?:[237]\\d|900)\\d{6}",[8,9],[["(\\d{4})(\\d{4})","$1 $2",["[0237]"]],["(\\d{5})(\\d{4})","$1 $2",["9"]]]],"TA":["290","00","8\\d{3}",[4],0,0,0,0,0,0,"8"],"TC":["1","011","(?:[58]\\d\\d|649|900)\\d{7}",[10],0,"1",0,"([2-479]\\d{6})$|1","649$1",0,"649"],"TD":["235","00|16","(?:22|[689]\\d|77)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[26-9]"]]],0,0,0,0,0,0,0,"00"],"TG":["228","00","[279]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[279]"]]]],"TH":["66","00[1-9]","(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",[8,9,10,13],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[13-9]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"TJ":["992","810","[0-57-9]\\d{8}",[9],[["(\\d{6})(\\d)(\\d{2})","$1 $2 $3",["331","3317"]],["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["44[02-479]|[34]7"]],["(\\d{4})(\\d)(\\d{4})","$1 $2 $3",["3(?:[1245]|3[12])"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[0-57-9]"]]],0,0,0,0,0,0,0,"8~10"],"TK":["690","00","[2-47]\\d{3,6}",[4,5,6,7]],"TL":["670","00","7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[2-489]|70"]],["(\\d{4})(\\d{4})","$1 $2",["7"]]]],"TM":["993","810","(?:[1-6]\\d|71)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["12"],"(8 $1)"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-5]"],"(8 $1)"],["(\\d{2})(\\d{6})","$1 $2",["[67]"],"8 $1"]],"8",0,0,0,0,0,0,"8~10"],"TN":["216","00","[2-57-9]\\d{7}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-57-9]"]]]],"TO":["676","00","(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",[5,7],[["(\\d{2})(\\d{3})","$1-$2",["[2-4]|50|6[09]|7[0-24-69]|8[05]"]],["(\\d{4})(\\d{3})","$1 $2",["0"]],["(\\d{3})(\\d{4})","$1 $2",["[5-9]"]]]],"TR":["90","00","4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",[7,10,12,13],[["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["512|8[01589]|90"],"0$1",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5(?:[0-59]|61)","5(?:[0-59]|61[06])","5(?:[0-59]|61[06]1)"],"0$1",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24][1-8]|3[1-9]"],"(0$1)",1],["(\\d{3})(\\d{3})(\\d{6,7})","$1 $2 $3",["80"],"0$1",1]],"0"],"TT":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-46-8]\\d{6})$|1","868$1",0,"868"],"TV":["688","00","(?:2|7\\d\\d|90)\\d{4}",[5,6,7],[["(\\d{2})(\\d{3})","$1 $2",["2"]],["(\\d{2})(\\d{4})","$1 $2",["90"]],["(\\d{2})(\\d{5})","$1 $2",["7"]]]],"TW":["886","0(?:0[25-79]|19)","[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",[7,8,9,10,11],[["(\\d{2})(\\d)(\\d{4})","$1 $2 $3",["202"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[258]0"],"0$1"],["(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]","[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"],"0$1"],["(\\d{2})(\\d{4})(\\d{4,5})","$1 $2 $3",["7"],"0$1"]],"0",0,0,0,0,0,0,0,"#"],"TZ":["255","00[056]","(?:[25-8]\\d|41|90)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[24]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["5"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[67]"],"0$1"]],"0"],"UA":["380","00","[89]\\d{9}|[3-9]\\d{8}",[9,10],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]","6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"],"0$1"],["(\\d{4})(\\d{5})","$1 $2",["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])","3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3-7]|89|9[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],"0",0,0,0,0,0,0,"0~0"],"UG":["256","00[057]","800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",[9],[["(\\d{4})(\\d{5})","$1 $2",["202","2024"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["[27-9]|4(?:6[45]|[7-9])"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["[34]"],"0$1"]],"0"],"US":["1","011","[2-9]\\d{9}|3\\d{6}",[10],[["(\\d{3})(\\d{4})","$1-$2",["310"],0,1],["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",["[2-9]"],0,1,"$1-$2-$3"]],"1",0,0,0,0,0,[["(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[0-468]))\\d{4}|(?:2742|305[3-9]|472[247-9]|505[2-57-9]|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[0168]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"],[""],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"],0,0,0,["305209\\d{4}"]]],"UY":["598","0(?:0|1[3-9]\\d)","0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",[6,7,8,9,10,11,12,13],[["(\\d{3})(\\d{3,4})","$1 $2",["0"]],["(\\d{3})(\\d{4})","$1 $2",["[49]0|8"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"],["(\\d{4})(\\d{4})","$1 $2",["[124]"]],["(\\d{3})(\\d{3})(\\d{2,4})","$1 $2 $3",["0"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})","$1 $2 $3 $4",["0"]]],"0",0,0,0,0,0,0,"00"," int. "],"UZ":["998","00","(?:20|33|[5-9]\\d)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[235-9]"]]]],"VA":["39","00","0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",[6,7,8,9,10,11,12],0,0,0,0,0,0,"06698"],"VC":["1","011","(?:[58]\\d\\d|784|900)\\d{7}",[10],0,"1",0,"([2-7]\\d{6})$|1","784$1",0,"784"],"VE":["58","00","[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",[10],[["(\\d{3})(\\d{7})","$1-$2",["[24-689]"],"0$1"]],"0"],"VG":["1","011","(?:284|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-578]\\d{6})$|1","284$1",0,"284"],"VI":["1","011","[58]\\d{9}|(?:34|90)0\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","340$1",0,"340"],"VN":["84","00","[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",[7,8,9,10],[["(\\d{2})(\\d{5})","$1 $2",["80"],"0$1",1],["(\\d{4})(\\d{4,6})","$1 $2",["1"],0,1],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["6"],"0$1",1],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[357-9]"],"0$1",1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2[48]"],"0$1",1],["(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["2"],"0$1",1]],"0"],"VU":["678","00","[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",[5,7],[["(\\d{3})(\\d{4})","$1 $2",["[57-9]"]]]],"WF":["681","00","(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}",[6,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[47-9]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]]],"WS":["685","0","(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",[5,6,7,10],[["(\\d{5})","$1",["[2-5]|6[1-9]"]],["(\\d{3})(\\d{3,7})","$1 $2",["[68]"]],["(\\d{2})(\\d{5})","$1 $2",["7"]]]],"XK":["383","00","2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}",[8,9,10,11,12],[["(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-4]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2|39"],"0$1"],["(\\d{2})(\\d{7,10})","$1 $2",["3"],"0$1"]],"0"],"YE":["967","00","(?:1|7\\d)\\d{7}|[1-7]\\d{6}",[7,8,9],[["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-6]|7(?:[24-6]|8[0-7])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"],"0$1"]],"0"],"YT":["262","00","7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",[9],0,"0",0,0,0,0,0,[["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"],["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"],["80\\d{7}"],0,0,0,0,0,["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]],"ZA":["27","00","[1-79]\\d{8}|8\\d{4,9}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,4})","$1 $2",["8[1-4]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["8[1-4]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["860"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],"0"],"ZM":["260","00","800\\d{6}|(?:21|[579]\\d|63)\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[28]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["[579]"],"0$1"]],"0"],"ZW":["263","00","2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",[5,6,7,8,9,10],[["(\\d{3})(\\d{3,5})","$1 $2",["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"],"0$1"],["(\\d)(\\d{3})(\\d{2,4})","$1 $2 $3",["[49]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["80"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2","2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)","2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"],"0$1"],["(\\d{4})(\\d{6})","$1 $2",["8"],"0$1"],["(\\d{2})(\\d{3,5})","$1 $2",["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["29[013-9]|39|54"],"0$1"],["(\\d{4})(\\d{3,5})","$1 $2",["(?:25|54)8","258|5483"],"0$1"]],"0"]},"nonGeographic":{"800":["800",0,"(?:00|[1-9]\\d)\\d{6}",[8],[["(\\d{4})(\\d{4})","$1 $2",["\\d"]]],0,0,0,0,0,0,[0,0,["(?:00|[1-9]\\d)\\d{6}"]]],"808":["808",0,"[1-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[1-9]"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,0,["[1-9]\\d{7}"]]],"870":["870",0,"7\\d{11}|[235-7]\\d{8}",[9,12],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235-7]"]]],0,0,0,0,0,0,[0,["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"],0,0,0,0,0,0,["2\\d{8}",[9]]]],"878":["878",0,"10\\d{10}",[12],[["(\\d{2})(\\d{5})(\\d{5})","$1 $2 $3",["1"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,["10\\d{10}"]]],"881":["881",0,"6\\d{9}|[0-36-9]\\d{8}",[9,10],[["(\\d)(\\d{3})(\\d{5})","$1 $2 $3",["[0-37-9]"]],["(\\d)(\\d{3})(\\d{5,6})","$1 $2 $3",["6"]]],0,0,0,0,0,0,[0,["6\\d{9}|[0-36-9]\\d{8}"]]],"882":["882",0,"[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",[7,8,9,10,11,12],[["(\\d{2})(\\d{5})","$1 $2",["16|342"]],["(\\d{2})(\\d{6})","$1 $2",["49"]],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["1[36]|9"]],["(\\d{2})(\\d{4})(\\d{3})","$1 $2 $3",["3[23]"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["16"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["10|23|3(?:[15]|4[57])|4|51"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["34"]],["(\\d{2})(\\d{4,5})(\\d{5})","$1 $2 $3",["[1-35]"]]],0,0,0,0,0,0,[0,["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",[7,8,9,10,12]],0,0,0,["348[57]\\d{7}",[11]],0,0,["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]],"883":["883",0,"(?:[1-4]\\d|51)\\d{6,10}",[8,9,10,11,12],[["(\\d{3})(\\d{3})(\\d{2,8})","$1 $2 $3",["[14]|2[24-689]|3[02-689]|51[24-9]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["510"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["21"]],["(\\d{4})(\\d{4})(\\d{4})","$1 $2 $3",["51[13]"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[235]"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]],"888":["888",0,"\\d{11}",[11],[["(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3"]],0,0,0,0,0,0,[0,0,0,0,0,0,["\\d{11}"]]],"979":["979",0,"[1359]\\d{8}",[9],[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[1359]"]]],0,0,0,0,0,0,[0,0,0,["[1359]\\d{8}"]]]}});
;// ./node_modules/libphonenumber-js/min/exports/withMetadataArgument.js
// Importing from a ".js" file is a workaround for Node.js "ES Modules"
// importing system which is even uncapable of importing "*.json" files.


function withMetadataArgument(func, _arguments) {
	var args = Array.prototype.slice.call(_arguments)
	args.push(metadata_min_json)
	return func.apply(this, args)
}
;// ./node_modules/libphonenumber-js/es6/helpers/isObject.js
var objectConstructor = {}.constructor;
function isObject(object) {
  return object !== undefined && object !== null && object.constructor === objectConstructor;
}
//# sourceMappingURL=isObject.js.map
;// ./node_modules/libphonenumber-js/es6/normalizeArguments.js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

 // Extracts the following properties from function arguments:
// * input `text`
// * `options` object
// * `metadata` JSON

function normalizeArguments(args) {
  var _Array$prototype$slic = Array.prototype.slice.call(args),
      _Array$prototype$slic2 = _slicedToArray(_Array$prototype$slic, 4),
      arg_1 = _Array$prototype$slic2[0],
      arg_2 = _Array$prototype$slic2[1],
      arg_3 = _Array$prototype$slic2[2],
      arg_4 = _Array$prototype$slic2[3];

  var text;
  var options;
  var metadata; // If the phone number is passed as a string.
  // `parsePhoneNumber('88005553535', ...)`.

  if (typeof arg_1 === 'string') {
    text = arg_1;
  } else throw new TypeError('A text for parsing must be a string.'); // If "default country" argument is being passed then move it to `options`.
  // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.


  if (!arg_2 || typeof arg_2 === 'string') {
    if (arg_4) {
      options = arg_3;
      metadata = arg_4;
    } else {
      options = undefined;
      metadata = arg_3;
    }

    if (arg_2) {
      options = _objectSpread({
        defaultCountry: arg_2
      }, options);
    }
  } // `defaultCountry` is not passed.
  // Example: `parsePhoneNumber('+78005553535', [options], metadata)`.
  else if (isObject(arg_2)) {
    if (arg_3) {
      options = arg_2;
      metadata = arg_3;
    } else {
      metadata = arg_2;
    }
  } else throw new Error("Invalid second argument: ".concat(arg_2));

  return {
    text: text,
    options: options,
    metadata: metadata
  };
}
//# sourceMappingURL=normalizeArguments.js.map
;// ./node_modules/libphonenumber-js/es6/constants.js
// The minimum length of the national significant number.
var MIN_LENGTH_FOR_NSN = 2; // The ITU says the maximum length should be 15,
// but one can find longer numbers in Germany.

var MAX_LENGTH_FOR_NSN = 17; // The maximum length of the country calling code.

var MAX_LENGTH_COUNTRY_CODE = 3; // Digits accepted in phone numbers
// (ascii, fullwidth, arabic-indic, and eastern arabic digits).

var VALID_DIGITS = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9"; // `DASHES` will be right after the opening square bracket of the "character class"

var DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var SLASHES = "\uFF0F/";
var DOTS = "\uFF0E.";
var WHITESPACE = " \xA0\xAD\u200B\u2060\u3000";
var BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['

var TILDES = "~\u2053\u223C\uFF5E"; // Regular expression of acceptable punctuation found in phone numbers. This
// excludes punctuation found as a leading character only. This consists of dash
// characters, white space characters, full stops, slashes, square brackets,
// parentheses and tildes. Full-width variants are also present.

var VALID_PUNCTUATION = "".concat(DASHES).concat(SLASHES).concat(DOTS).concat(WHITESPACE).concat(BRACKETS).concat(TILDES);
var PLUS_CHARS = "+\uFF0B"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')
//# sourceMappingURL=constants.js.map
;// ./node_modules/libphonenumber-js/es6/ParseError.js
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// https://stackoverflow.com/a/46971044/970769
// "Breaking changes in Typescript 2.1"
// "Extending built-ins like Error, Array, and Map may no longer work."
// "As a recommendation, you can manually adjust the prototype immediately after any super(...) calls."
// https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
var ParseError = /*#__PURE__*/function (_Error) {
  _inherits(ParseError, _Error);

  var _super = _createSuper(ParseError);

  function ParseError(code) {
    var _this;

    _classCallCheck(this, ParseError);

    _this = _super.call(this, code); // Set the prototype explicitly.
    // Any subclass of FooError will have to manually set the prototype as well.

    Object.setPrototypeOf(_assertThisInitialized(_this), ParseError.prototype);
    _this.name = _this.constructor.name;
    return _this;
  }

  return _createClass(ParseError);
}( /*#__PURE__*/_wrapNativeSuper(Error));


//# sourceMappingURL=ParseError.js.map
;// ./node_modules/libphonenumber-js/es6/tools/semver-compare.js
// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
/* harmony default export */ function semver_compare(a, b) {
  a = a.split('-');
  b = b.split('-');
  var pa = a[0].split('.');
  var pb = b[0].split('.');

  for (var i = 0; i < 3; i++) {
    var na = Number(pa[i]);
    var nb = Number(pb[i]);
    if (na > nb) return 1;
    if (nb > na) return -1;
    if (!isNaN(na) && isNaN(nb)) return 1;
    if (isNaN(na) && !isNaN(nb)) return -1;
  }

  if (a[1] && b[1]) {
    return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
  }

  return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}
//# sourceMappingURL=semver-compare.js.map
;// ./node_modules/libphonenumber-js/es6/metadata.js
function metadata_typeof(obj) { "@babel/helpers - typeof"; return metadata_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, metadata_typeof(obj); }

function metadata_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function metadata_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function metadata_createClass(Constructor, protoProps, staticProps) { if (protoProps) metadata_defineProperties(Constructor.prototype, protoProps); if (staticProps) metadata_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }


 // Added "possibleLengths" and renamed
// "country_phone_code_to_countries" to "country_calling_codes".

var V2 = '1.0.18'; // Added "idd_prefix" and "default_idd_prefix".

var V3 = '1.2.0'; // Moved `001` country code to "nonGeographic" section of metadata.

var V4 = '1.7.35';
var DEFAULT_EXT_PREFIX = ' ext. ';
var CALLING_CODE_REG_EXP = /^\d+$/;
/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */

var Metadata = /*#__PURE__*/function () {
  function Metadata(metadata) {
    metadata_classCallCheck(this, Metadata);

    validateMetadata(metadata);
    this.metadata = metadata;
    setVersion.call(this, metadata);
  }

  metadata_createClass(Metadata, [{
    key: "getCountries",
    value: function getCountries() {
      return Object.keys(this.metadata.countries).filter(function (_) {
        return _ !== '001';
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function getCountryMetadata(countryCode) {
      return this.metadata.countries[countryCode];
    }
  }, {
    key: "nonGeographic",
    value: function nonGeographic() {
      if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
      // It's present in metadata generated from `1.7.35` to `1.7.37`.
      // The test case could be found by searching for "nonGeographical".

      return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function hasCountry(country) {
      return this.getCountryMetadata(country) !== undefined;
    }
  }, {
    key: "hasCallingCode",
    value: function hasCallingCode(callingCode) {
      if (this.getCountryCodesForCallingCode(callingCode)) {
        return true;
      }

      if (this.nonGeographic()) {
        if (this.nonGeographic()[callingCode]) {
          return true;
        }
      } else {
        // A hacky workaround for old custom metadata (generated before V4).
        var countryCodes = this.countryCallingCodes()[callingCode];

        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
          return true;
        }
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function isNonGeographicCallingCode(callingCode) {
      if (this.nonGeographic()) {
        return this.nonGeographic()[callingCode] ? true : false;
      } else {
        return this.getCountryCodesForCallingCode(callingCode) ? false : true;
      }
    } // Deprecated.

  }, {
    key: "country",
    value: function country(countryCode) {
      return this.selectNumberingPlan(countryCode);
    }
  }, {
    key: "selectNumberingPlan",
    value: function selectNumberingPlan(countryCode, callingCode) {
      // Supports just passing `callingCode` as the first argument.
      if (countryCode && CALLING_CODE_REG_EXP.test(countryCode)) {
        callingCode = countryCode;
        countryCode = null;
      }

      if (countryCode && countryCode !== '001') {
        if (!this.hasCountry(countryCode)) {
          throw new Error("Unknown country: ".concat(countryCode));
        }

        this.numberingPlan = new NumberingPlan(this.getCountryMetadata(countryCode), this);
      } else if (callingCode) {
        if (!this.hasCallingCode(callingCode)) {
          throw new Error("Unknown calling code: ".concat(callingCode));
        }

        this.numberingPlan = new NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
      } else {
        this.numberingPlan = undefined;
      }

      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function getCountryCodesForCallingCode(callingCode) {
      var countryCodes = this.countryCallingCodes()[callingCode];

      if (countryCodes) {
        // Metadata before V4 included "non-geographic entity" calling codes
        // inside `country_calling_codes` (for example, `"881":["001"]`).
        // Now the semantics of `country_calling_codes` has changed:
        // it's specifically for "countries" now.
        // Older versions of custom metadata will simply skip parsing
        // "non-geographic entity" phone numbers with new versions
        // of this library: it's not considered a bug,
        // because such numbers are extremely rare,
        // and developers extremely rarely use custom metadata.
        if (countryCodes.length === 1 && countryCodes[0].length === 3) {
          return;
        }

        return countryCodes;
      }
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function getCountryCodeForCallingCode(callingCode) {
      var countryCodes = this.getCountryCodesForCallingCode(callingCode);

      if (countryCodes) {
        return countryCodes[0];
      }
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function getNumberingPlanMetadata(callingCode) {
      var countryCode = this.getCountryCodeForCallingCode(callingCode);

      if (countryCode) {
        return this.getCountryMetadata(countryCode);
      }

      if (this.nonGeographic()) {
        var metadata = this.nonGeographic()[callingCode];

        if (metadata) {
          return metadata;
        }
      } else {
        // A hacky workaround for old custom metadata (generated before V4).
        // In that metadata, there was no concept of "non-geographic" metadata
        // so metadata for `001` country code was stored along with other countries.
        // The test case can be found by searching for:
        // "should work around `nonGeographic` metadata not existing".
        var countryCodes = this.countryCallingCodes()[callingCode];

        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
          return this.metadata.countries['001'];
        }
      }
    } // Deprecated.

  }, {
    key: "countryCallingCode",
    value: function countryCallingCode() {
      return this.numberingPlan.callingCode();
    } // Deprecated.

  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      return this.numberingPlan.IDDPrefix();
    } // Deprecated.

  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      return this.numberingPlan.defaultIDDPrefix();
    } // Deprecated.

  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      return this.numberingPlan.nationalNumberPattern();
    } // Deprecated.

  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      return this.numberingPlan.possibleLengths();
    } // Deprecated.

  }, {
    key: "formats",
    value: function formats() {
      return this.numberingPlan.formats();
    } // Deprecated.

  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      return this.numberingPlan.nationalPrefixForParsing();
    } // Deprecated.

  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.numberingPlan.nationalPrefixTransformRule();
    } // Deprecated.

  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.numberingPlan.leadingDigits();
    } // Deprecated.

  }, {
    key: "hasTypes",
    value: function hasTypes() {
      return this.numberingPlan.hasTypes();
    } // Deprecated.

  }, {
    key: "type",
    value: function type(_type) {
      return this.numberingPlan.type(_type);
    } // Deprecated.

  }, {
    key: "ext",
    value: function ext() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function countryCallingCodes() {
      if (this.v1) return this.metadata.country_phone_code_to_countries;
      return this.metadata.country_calling_codes;
    } // Deprecated.

  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function chooseCountryByCountryCallingCode(callingCode) {
      return this.selectNumberingPlan(callingCode);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function hasSelectedNumberingPlan() {
      return this.numberingPlan !== undefined;
    }
  }]);

  return Metadata;
}();



var NumberingPlan = /*#__PURE__*/function () {
  function NumberingPlan(metadata, globalMetadataObject) {
    metadata_classCallCheck(this, NumberingPlan);

    this.globalMetadataObject = globalMetadataObject;
    this.metadata = metadata;
    setVersion.call(this, globalMetadataObject.metadata);
  }

  metadata_createClass(NumberingPlan, [{
    key: "callingCode",
    value: function callingCode() {
      return this.metadata[0];
    } // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.

  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function getDefaultCountryMetadataForRegion() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    } // Is always present.

  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[1];
    } // Is only present when a country supports multiple IDD prefixes.

  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      if (this.v1 || this.v2) return this.metadata[1];
      return this.metadata[2];
    } // "possible length" data is always present in Google's metadata.

  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.v1) return;
      return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function _getFormats(metadata) {
      return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
    } // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "formats",
    value: function formats() {
      var _this = this;

      var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return formats.map(function (_) {
        return new Format(_, _this);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function nationalPrefix() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function _getNationalPrefixFormattingRule(metadata) {
      return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
    } // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function _nationalPrefixForParsing() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      // If `national_prefix_for_parsing` is not set explicitly,
      // then infer it from `national_prefix` (if any)
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function _getNationalPrefixIsOptionalWhenFormatting() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    } // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function types() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      // Versions 1.2.0 - 1.2.4: can be `[]`.

      /* istanbul ignore next */
      if (this.types() && this.types().length === 0) {
        return false;
      } // Versions <= 1.2.4: can be `undefined`.
      // Version >= 1.2.5: can be `0`.


      return !!this.types();
    }
  }, {
    key: "type",
    value: function type(_type2) {
      if (this.hasTypes() && getType(this.types(), _type2)) {
        return new Type(getType(this.types(), _type2), this);
      }
    }
  }, {
    key: "ext",
    value: function ext() {
      if (this.v1 || this.v2) return DEFAULT_EXT_PREFIX;
      return this.metadata[13] || DEFAULT_EXT_PREFIX;
    }
  }]);

  return NumberingPlan;
}();

var Format = /*#__PURE__*/function () {
  function Format(format, metadata) {
    metadata_classCallCheck(this, Format);

    this._format = format;
    this.metadata = metadata;
  }

  metadata_createClass(Format, [{
    key: "pattern",
    value: function pattern() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function format() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function leadingDigitsPatterns() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
      // National prefix is omitted if there's no national prefix formatting rule
      // set for this country, or when the national prefix formatting rule
      // contains no national prefix itself, or when this rule is set but
      // national prefix is optional for this phone number format
      // (and it is not enforced explicitly)
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    } // Checks whether national prefix formatting rule contains national prefix.

  }, {
    key: "usesNationalPrefix",
    value: function usesNationalPrefix() {
      return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
      // when `national_prefix_formatting_rule` is not present.
      // So, `true` or `false` are returned explicitly here, so that
      // `0` number isn't returned.
      ? true : false;
    }
  }, {
    key: "internationalFormat",
    value: function internationalFormat() {
      return this._format[5] || this.format();
    }
  }]);

  return Format;
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */


var FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;

var Type = /*#__PURE__*/function () {
  function Type(type, metadata) {
    metadata_classCallCheck(this, Type);

    this.type = type;
    this.metadata = metadata;
  }

  metadata_createClass(Type, [{
    key: "pattern",
    value: function pattern() {
      if (this.metadata.v1) return this.type;
      return this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.metadata.v1) return;
      return this.type[1] || this.metadata.possibleLengths();
    }
  }]);

  return Type;
}();

function getType(types, type) {
  switch (type) {
    case 'FIXED_LINE':
      return types[0];

    case 'MOBILE':
      return types[1];

    case 'TOLL_FREE':
      return types[2];

    case 'PREMIUM_RATE':
      return types[3];

    case 'PERSONAL_NUMBER':
      return types[4];

    case 'VOICEMAIL':
      return types[5];

    case 'UAN':
      return types[6];

    case 'PAGER':
      return types[7];

    case 'VOIP':
      return types[8];

    case 'SHARED_COST':
      return types[9];
  }
}

function validateMetadata(metadata) {
  if (!metadata) {
    throw new Error('[libphonenumber-js] `metadata` argument not passed. Check your arguments.');
  } // `country_phone_code_to_countries` was renamed to `country_calling_codes` in `1.0.18`.
  // For that reason, it's not used in this detection algorithm.
  // Instead, it detects by `countries: {}` property existence.


  if (!isObject(metadata) || !isObject(metadata.countries)) {
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(isObject(metadata) ? 'an object of shape: { ' + Object.keys(metadata).join(', ') + ' }' : 'a ' + typeOf(metadata) + ': ' + metadata, "."));
  }
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".

/* istanbul ignore next */

var typeOf = function typeOf(_) {
  return metadata_typeof(_);
};
/**
 * Returns extension prefix for a country.
 * @param  {string} country
 * @param  {object} metadata
 * @return {string?}
 * @example
 * // Returns " ext. "
 * getExtPrefix("US")
 */


function getExtPrefix(country, metadata) {
  metadata = new Metadata(metadata);

  if (metadata.hasCountry(country)) {
    return metadata.country(country).ext();
  }

  return DEFAULT_EXT_PREFIX;
}
/**
 * Returns "country calling code" for a country.
 * Throws an error if the country doesn't exist or isn't supported by this library.
 * @param  {string} country
 * @param  {object} metadata
 * @return {string}
 * @example
 * // Returns "44"
 * getCountryCallingCode("GB")
 */

function getCountryCallingCode(country, metadata) {
  metadata = new Metadata(metadata);

  if (metadata.hasCountry(country)) {
    return metadata.country(country).countryCallingCode();
  }

  throw new Error("Unknown country: ".concat(country));
}
function isSupportedCountry(country, metadata) {
  // metadata = new Metadata(metadata)
  // return metadata.hasCountry(country)
  return metadata.countries.hasOwnProperty(country);
}

function setVersion(metadata) {
  var version = metadata.version;

  if (typeof version === 'number') {
    this.v1 = version === 1;
    this.v2 = version === 2;
    this.v3 = version === 3;
    this.v4 = version === 4;
  } else {
    if (!version) {
      this.v1 = true;
    } else if (semver_compare(version, V3) === -1) {
      this.v2 = true;
    } else if (semver_compare(version, V4) === -1) {
      this.v3 = true;
    } else {
      this.v4 = true;
    }
  }
} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
// function isCountryCode(countryCode) {
// 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
// }
//# sourceMappingURL=metadata.js.map
;// ./node_modules/libphonenumber-js/es6/helpers/extension/createExtensionPattern.js
 // The RFC 3966 format for extensions.

var RFC3966_EXTN_PREFIX = ';ext=';
/**
 * Helper method for constructing regular expressions for parsing. Creates
 * an expression that captures up to max_length digits.
 * @return {string} RegEx pattern to capture extension digits.
 */

var getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
  return "([".concat(VALID_DIGITS, "]{1,").concat(maxLength, "})");
};
/**
 * Helper initialiser method to create the regular-expression pattern to match
 * extensions.
 * Copy-pasted from Google's `libphonenumber`:
 * https://github.com/google/libphonenumber/blob/55b2646ec9393f4d3d6661b9c82ef9e258e8b829/javascript/i18n/phonenumbers/phonenumberutil.js#L759-L766
 * @return {string} RegEx pattern to capture extensions.
 */


function createExtensionPattern(purpose) {
  // We cap the maximum length of an extension based on the ambiguity of the way
  // the extension is prefixed. As per ITU, the officially allowed length for
  // extensions is actually 40, but we don't support this since we haven't seen real
  // examples and this introduces many false interpretations as the extension labels
  // are not standardized.

  /** @type {string} */
  var extLimitAfterExplicitLabel = '20';
  /** @type {string} */

  var extLimitAfterLikelyLabel = '15';
  /** @type {string} */

  var extLimitAfterAmbiguousChar = '9';
  /** @type {string} */

  var extLimitWhenNotSure = '6';
  /** @type {string} */

  var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xA0\\t,]*"; // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.

  /** @type {string} */

  var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xA0\\t,-]*";
  /** @type {string} */

  var optionalExtnSuffix = "#?"; // Here the extension is called out in more explicit way, i.e mentioning it obvious
  // patterns like "ext.".

  /** @type {string} */

  var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)"; // One-character symbols that can be used to indicate an extension, and less
  // commonly used or more ambiguous extension labels.

  /** @type {string} */

  var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)"; // When extension is not separated clearly.

  /** @type {string} */

  var ambiguousSeparator = "[- ]+"; // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
  // comma as extension label may have it.

  /** @type {string} */

  var possibleSeparatorsNumberExtLabelNoComma = "[ \xA0\\t]*"; // ",," is commonly used for auto dialling the extension when connected. First
  // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
  // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
  // button with the extension number following.

  /** @type {string} */

  var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
  /** @type {string} */

  var rfcExtn = RFC3966_EXTN_PREFIX + getExtensionDigitsPattern(extLimitAfterExplicitLabel);
  /** @type {string} */

  var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
  /** @type {string} */

  var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
  /** @type {string} */

  var americanStyleExtnWithSuffix = ambiguousSeparator + getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
  /** @type {string} */

  var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
  /** @type {string} */

  var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix; // The first regular expression covers RFC 3966 format, where the extension is added
  // using ";ext=". The second more generic where extension is mentioned with explicit
  // labels like "ext:". In both the above cases we allow more numbers in extension than
  // any other extension labels. The third one captures when single character extension
  // labels or less commonly used labels are used. In such cases we capture fewer
  // extension digits in order to reduce the chance of falsely interpreting two
  // numbers beside each other as a number + extension. The fourth one covers the
  // special case of American numbers where the extension is written with a hash
  // at the end, such as "- 503#". The fifth one is exclusively for extension
  // autodialling formats which are used when dialling and in this case we accept longer
  // extensions. The last one is more liberal on the number of commas that acts as
  // extension labels, so we have a strict cap on the number of digits in such extensions.

  return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}
//# sourceMappingURL=createExtensionPattern.js.map
;// ./node_modules/libphonenumber-js/es6/helpers/isViablePhoneNumber.js

 //  Regular expression of viable phone numbers. This is location independent.
//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//

var MIN_LENGTH_PHONE_NUMBER_PATTERN = '[' + VALID_DIGITS + ']{' + MIN_LENGTH_FOR_NSN + '}'; //
// And this is the second reg-exp:
// (see MIN_LENGTH_PHONE_NUMBER_PATTERN for a full description of this reg-exp)
//

var VALID_PHONE_NUMBER = '[' + PLUS_CHARS + ']{0,1}' + '(?:' + '[' + VALID_PUNCTUATION + ']*' + '[' + VALID_DIGITS + ']' + '){3,}' + '[' + VALID_PUNCTUATION + VALID_DIGITS + ']*'; // This regular expression isn't present in Google's `libphonenumber`
// and is only used to determine whether the phone number being input
// is too short for it to even consider it a "valid" number.
// This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.

var VALID_PHONE_NUMBER_START_REG_EXP = new RegExp('^' + '[' + PLUS_CHARS + ']{0,1}' + '(?:' + '[' + VALID_PUNCTUATION + ']*' + '[' + VALID_DIGITS + ']' + '){1,2}' + '$', 'i');
var VALID_PHONE_NUMBER_WITH_EXTENSION = VALID_PHONE_NUMBER + // Phone number extensions
'(?:' + createExtensionPattern() + ')?'; // The combined regular expression for valid phone numbers:
//

var VALID_PHONE_NUMBER_PATTERN = new RegExp( // Either a short two-digit-only phone number
'^' + MIN_LENGTH_PHONE_NUMBER_PATTERN + '$' + '|' + // Or a longer fully parsed phone number (min 3 characters)
'^' + VALID_PHONE_NUMBER_WITH_EXTENSION + '$', 'i'); // Checks to see if the string of characters could possibly be a phone number at
// all. At the moment, checks to see that the string begins with at least 2
// digits, ignoring any punctuation commonly found in phone numbers. This method
// does not require the number to be normalized in advance - but does assume
// that leading non-number symbols have been removed, such as by the method
// `extract_possible_number`.
//

function isViablePhoneNumber_isViablePhoneNumber(number) {
  return number.length >= MIN_LENGTH_FOR_NSN && VALID_PHONE_NUMBER_PATTERN.test(number);
} // This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.

function isViablePhoneNumberStart(number) {
  return VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}
//# sourceMappingURL=isViablePhoneNumber.js.map
;// ./node_modules/libphonenumber-js/es6/helpers/extension/extractExtension.js
 // Regexp of all known extension prefixes used by different regions followed by
// 1 or more valid digits, for use when parsing.

var EXTN_PATTERN = new RegExp('(?:' + createExtensionPattern() + ')$', 'i'); // Strips any extension (as in, the part of the number dialled after the call is
// connected, usually indicated with extn, ext, x or similar) from the end of
// the number, and returns it.

function extractExtension(number) {
  var start = number.search(EXTN_PATTERN);

  if (start < 0) {
    return {};
  } // If we find a potential extension, and the number preceding this is a viable
  // number, we assume it is an extension.


  var numberWithoutExtension = number.slice(0, start);
  var matches = number.match(EXTN_PATTERN);
  var i = 1;

  while (i < matches.length) {
    if (matches[i]) {
      return {
        number: numberWithoutExtension,
        ext: matches[i]
      };
    }

    i++;
  }
}
//# sourceMappingURL=extractExtension.js.map
;// ./node_modules/libphonenumber-js/es6/helpers/parseDigits.js
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = parseDigits_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function parseDigits_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return parseDigits_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return parseDigits_arrayLikeToArray(o, minLen); }

function parseDigits_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// These mappings map a character (key) to a specific digit that should
// replace it for normalization purposes. Non-European digits that
// may be used in phone numbers are mapped to a European equivalent.
//
// E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
//
var DIGITS = {
  '0': '0',
  '1': '1',
  '2': '2',
  '3': '3',
  '4': '4',
  '5': '5',
  '6': '6',
  '7': '7',
  '8': '8',
  '9': '9',
  "\uFF10": '0',
  // Fullwidth digit 0
  "\uFF11": '1',
  // Fullwidth digit 1
  "\uFF12": '2',
  // Fullwidth digit 2
  "\uFF13": '3',
  // Fullwidth digit 3
  "\uFF14": '4',
  // Fullwidth digit 4
  "\uFF15": '5',
  // Fullwidth digit 5
  "\uFF16": '6',
  // Fullwidth digit 6
  "\uFF17": '7',
  // Fullwidth digit 7
  "\uFF18": '8',
  // Fullwidth digit 8
  "\uFF19": '9',
  // Fullwidth digit 9
  "\u0660": '0',
  // Arabic-indic digit 0
  "\u0661": '1',
  // Arabic-indic digit 1
  "\u0662": '2',
  // Arabic-indic digit 2
  "\u0663": '3',
  // Arabic-indic digit 3
  "\u0664": '4',
  // Arabic-indic digit 4
  "\u0665": '5',
  // Arabic-indic digit 5
  "\u0666": '6',
  // Arabic-indic digit 6
  "\u0667": '7',
  // Arabic-indic digit 7
  "\u0668": '8',
  // Arabic-indic digit 8
  "\u0669": '9',
  // Arabic-indic digit 9
  "\u06F0": '0',
  // Eastern-Arabic digit 0
  "\u06F1": '1',
  // Eastern-Arabic digit 1
  "\u06F2": '2',
  // Eastern-Arabic digit 2
  "\u06F3": '3',
  // Eastern-Arabic digit 3
  "\u06F4": '4',
  // Eastern-Arabic digit 4
  "\u06F5": '5',
  // Eastern-Arabic digit 5
  "\u06F6": '6',
  // Eastern-Arabic digit 6
  "\u06F7": '7',
  // Eastern-Arabic digit 7
  "\u06F8": '8',
  // Eastern-Arabic digit 8
  "\u06F9": '9' // Eastern-Arabic digit 9

};
function parseDigit(character) {
  return DIGITS[character];
}
/**
 * Parses phone number digits from a string.
 * Drops all punctuation leaving only digits.
 * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
 * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
 * @param  {string} string
 * @return {string}
 * @example
 * ```js
 * parseDigits('8 (800) 555')
 * // Outputs '8800555'.
 * ```
 */

function parseDigits(string) {
  var result = ''; // Using `.split('')` here instead of normal `for ... of`
  // because the importing application doesn't neccessarily include an ES6 polyfill.
  // The `.split('')` approach discards "exotic" UTF-8 characters
  // (the ones consisting of four bytes) but digits
  // (including non-European ones) don't fall into that range
  // so such "exotic" characters would be discarded anyway.

  for (var _iterator = _createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;) {
    var character = _step.value;
    var digit = parseDigit(character);

    if (digit) {
      result += digit;
    }
  }

  return result;
}
//# sourceMappingURL=parseDigits.js.map
;// ./node_modules/libphonenumber-js/es6/parseIncompletePhoneNumber.js
function parseIncompletePhoneNumber_createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = parseIncompletePhoneNumber_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function parseIncompletePhoneNumber_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return parseIncompletePhoneNumber_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return parseIncompletePhoneNumber_arrayLikeToArray(o, minLen); }

function parseIncompletePhoneNumber_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


/**
 * Parses phone number characters from a string.
 * Drops all punctuation leaving only digits and the leading `+` sign (if any).
 * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
 * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
 * @param  {string} string
 * @return {string}
 * @example
 * ```js
 * // Outputs '8800555'.
 * parseIncompletePhoneNumber('8 (800) 555')
 * // Outputs '+7800555'.
 * parseIncompletePhoneNumber('+7 800 555')
 * ```
 */

function parseIncompletePhoneNumber(string) {
  var result = ''; // Using `.split('')` here instead of normal `for ... of`
  // because the importing application doesn't neccessarily include an ES6 polyfill.
  // The `.split('')` approach discards "exotic" UTF-8 characters
  // (the ones consisting of four bytes) but digits
  // (including non-European ones) don't fall into that range
  // so such "exotic" characters would be discarded anyway.

  for (var _iterator = parseIncompletePhoneNumber_createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;) {
    var character = _step.value;
    result += parsePhoneNumberCharacter(character, result) || '';
  }

  return result;
}
/**
 * Parses next character while parsing phone number digits (including a `+`)
 * from text: discards everything except `+` and digits, and `+` is only allowed
 * at the start of a phone number.
 * For example, is used in `react-phone-number-input` where it uses
 * [`input-format`](https://gitlab.com/catamphetamine/input-format).
 * @param  {string} character - Yet another character from raw input string.
 * @param  {string?} prevParsedCharacters - Previous parsed characters.
 * @param  {function?} emitEvent - An optional "emit event" function.
 * @return {string?} The parsed character.
 */

function parsePhoneNumberCharacter(character, prevParsedCharacters, emitEvent) {
  // Only allow a leading `+`.
  if (character === '+') {
    // If this `+` is not the first parsed character
    // then discard it.
    if (prevParsedCharacters) {
      // `emitEvent` argument was added to this `export`ed function on Dec 26th, 2023.
      // Any 3rd-party code that used to `import` and call this function before that
      // won't be passing any `emitEvent` argument.
      //
      // The addition of the `emitEvent` argument was to fix the slightly-weird behavior
      // of parsing an input string when the user inputs something like `"2+7"
      // https://github.com/catamphetamine/react-phone-number-input/issues/437
      //
      // If the parser encounters an unexpected `+` in a string being parsed
      // then it simply discards that out-of-place `+` and any following characters.
      //
      if (typeof emitEvent === 'function') {
        emitEvent('end');
      }

      return;
    }

    return '+';
  } // Allow digits.


  return parseDigit(character);
}
//# sourceMappingURL=parseIncompletePhoneNumber.js.map
;// ./node_modules/libphonenumber-js/es6/helpers/mergeArrays.js
function mergeArrays_createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = mergeArrays_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function mergeArrays_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return mergeArrays_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return mergeArrays_arrayLikeToArray(o, minLen); }

function mergeArrays_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Merges two arrays.
 * @param  {*} a
 * @param  {*} b
 * @return {*}
 */
function mergeArrays(a, b) {
  var merged = a.slice();

  for (var _iterator = mergeArrays_createForOfIteratorHelperLoose(b), _step; !(_step = _iterator()).done;) {
    var element = _step.value;

    if (a.indexOf(element) < 0) {
      merged.push(element);
    }
  }

  return merged.sort(function (a, b) {
    return a - b;
  }); // ES6 version, requires Set polyfill.
  // let merged = new Set(a)
  // for (const element of b) {
  // 	merged.add(i)
  // }
  // return Array.from(merged).sort((a, b) => a - b)
}
//# sourceMappingURL=mergeArrays.js.map
;// ./node_modules/libphonenumber-js/es6/helpers/checkNumberLength.js

function checkNumberLength(nationalNumber, metadata) {
  return checkNumberLengthForType(nationalNumber, undefined, metadata);
} // Checks whether a number is possible for the country based on its length.
// Should only be called for the "new" metadata which has "possible lengths".

function checkNumberLengthForType(nationalNumber, type, metadata) {
  var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
  // This is declared in the XML schema.
  // For size efficiency, where a sub-description (e.g. fixed-line)
  // has the same "<possiblePengths/>" as the "general description", this is missing,
  // so we fall back to the "general description". Where no numbers of the type
  // exist at all, there is one possible length (-1) which is guaranteed
  // not to match the length of any real phone number.

  var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
  // Metadata before version `1.0.18` didn't contain `possible_lengths`.

  if (!possible_lengths) {
    return 'IS_POSSIBLE';
  }

  if (type === 'FIXED_LINE_OR_MOBILE') {
    // No such country in metadata.

    /* istanbul ignore next */
    if (!metadata.type('FIXED_LINE')) {
      // The rare case has been encountered where no fixedLine data is available
      // (true for some non-geographic entities), so we just check mobile.
      return checkNumberLengthForType(nationalNumber, 'MOBILE', metadata);
    }

    var mobile_type = metadata.type('MOBILE');

    if (mobile_type) {
      // Merge the mobile data in if there was any. "Concat" creates a new
      // array, it doesn't edit possible_lengths in place, so we don't need a copy.
      // Note that when adding the possible lengths from mobile, we have
      // to again check they aren't empty since if they are this indicates
      // they are the same as the general desc and should be obtained from there.
      possible_lengths = mergeArrays(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
      // re-sort (duplicates are okay). Sorting isn't so expensive because
      // the lists are very small.
      // if (local_lengths) {
      // 	local_lengths = mergeArrays(local_lengths, mobile_type.possibleLengthsLocal())
      // } else {
      // 	local_lengths = mobile_type.possibleLengthsLocal()
      // }
    }
  } // If the type doesn't exist then return 'INVALID_LENGTH'.
  else if (type && !type_info) {
    return 'INVALID_LENGTH';
  }

  var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
  // // This is safe because there is never an overlap beween the possible lengths
  // // and the local-only lengths; this is checked at build time.
  // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
  // {
  // 	return 'IS_POSSIBLE_LOCAL_ONLY'
  // }

  var minimum_length = possible_lengths[0];

  if (minimum_length === actual_length) {
    return 'IS_POSSIBLE';
  }

  if (minimum_length > actual_length) {
    return 'TOO_SHORT';
  }

  if (possible_lengths[possible_lengths.length - 1] < actual_length) {
    return 'TOO_LONG';
  } // We skip the first element since we've already checked it.


  return possible_lengths.indexOf(actual_length, 1) >= 0 ? 'IS_POSSIBLE' : 'INVALID_LENGTH';
}
//# sourceMappingURL=checkNumberLength.js.map
;// ./node_modules/libphonenumber-js/es6/isPossible.js


/**
 * Checks if a phone number is "possible" (basically just checks its length).
 *
 * isPossible(phoneNumberInstance, { ..., v2: true }, metadata)
 *
 * isPossible({ phone: '8005553535', country: 'RU' }, { ... }, metadata)
 * isPossible({ phone: '8005553535', country: 'RU' }, undefined, metadata)
 *
 * @param  {object|PhoneNumber} input — If `options.v2: true` flag is passed, the `input` should be a `PhoneNumber` instance. Otherwise, it should be an object of shape `{ phone: '...', country: '...' }`.
 * @param  {object} [options]
 * @param  {object} metadata
 * @return {string}
 */

function isPossiblePhoneNumber(input, options, metadata) {
  /* istanbul ignore if */
  if (options === undefined) {
    options = {};
  }

  metadata = new Metadata(metadata);

  if (options.v2) {
    if (!input.countryCallingCode) {
      throw new Error('Invalid phone number object passed');
    }

    metadata.selectNumberingPlan(input.countryCallingCode);
  } else {
    if (!input.phone) {
      return false;
    }

    if (input.country) {
      if (!metadata.hasCountry(input.country)) {
        throw new Error("Unknown country: ".concat(input.country));
      }

      metadata.country(input.country);
    } else {
      if (!input.countryCallingCode) {
        throw new Error('Invalid phone number object passed');
      }

      metadata.selectNumberingPlan(input.countryCallingCode);
    }
  } // Old metadata (< 1.0.18) had no "possible length" data.


  if (metadata.possibleLengths()) {
    return isPossibleNumber(input.phone || input.nationalNumber, metadata);
  } else {
    // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
    // were missing for "non-geographical" numbering plans.
    // Just assume the number is possible in such cases:
    // it's unlikely that anyone generated their custom metadata
    // in that short period of time (one day).
    // This code can be removed in some future major version update.
    if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) {
      // "Non-geographic entities" did't have `possibleLengths`
      // due to a bug in metadata generation process.
      return true;
    } else {
      throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
  }
}
function isPossibleNumber(nationalNumber, metadata) {
  //, isInternational) {
  switch (checkNumberLength(nationalNumber, metadata)) {
    case 'IS_POSSIBLE':
      return true;
    // This library ignores "local-only" phone numbers (for simplicity).
    // See the readme for more info on what are "local-only" phone numbers.
    // case 'IS_POSSIBLE_LOCAL_ONLY':
    // 	return !isInternational

    default:
      return false;
  }
}
//# sourceMappingURL=isPossible.js.map
;// ./node_modules/libphonenumber-js/es6/helpers/matchesEntirely.js
/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */
function matchesEntirely(text, regular_expression) {
  // If assigning the `''` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  text = text || '';
  return new RegExp('^(?:' + regular_expression + ')$').test(text);
}
//# sourceMappingURL=matchesEntirely.js.map
;// ./node_modules/libphonenumber-js/es6/helpers/getNumberType.js
function getNumberType_createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = getNumberType_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function getNumberType_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return getNumberType_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return getNumberType_arrayLikeToArray(o, minLen); }

function getNumberType_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



var NON_FIXED_LINE_PHONE_TYPES = ['MOBILE', 'PREMIUM_RATE', 'TOLL_FREE', 'SHARED_COST', 'VOIP', 'PERSONAL_NUMBER', 'PAGER', 'UAN', 'VOICEMAIL']; // Finds out national phone number type (fixed line, mobile, etc)

function getNumberType(input, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {}; // When `parse()` returns an empty object — `{}` —
  // that means that the phone number is malformed,
  // so it can't possibly be valid.

  if (!input.country && !input.countryCallingCode) {
    return;
  }

  metadata = new Metadata(metadata);
  metadata.selectNumberingPlan(input.country, input.countryCallingCode);
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
  // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
  // Is this national number even valid for this country

  if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern())) {
    return;
  } // Is it fixed line number


  if (isNumberTypeEqualTo(nationalNumber, 'FIXED_LINE', metadata)) {
    // Because duplicate regular expressions are removed
    // to reduce metadata size, if "mobile" pattern is ""
    // then it means it was removed due to being a duplicate of the fixed-line pattern.
    //
    if (metadata.type('MOBILE') && metadata.type('MOBILE').pattern() === '') {
      return 'FIXED_LINE_OR_MOBILE';
    } // `MOBILE` type pattern isn't included if it matched `FIXED_LINE` one.
    // For example, for "US" country.
    // Old metadata (< `1.0.18`) had a specific "types" data structure
    // that happened to be `undefined` for `MOBILE` in that case.
    // Newer metadata (>= `1.0.18`) has another data structure that is
    // not `undefined` for `MOBILE` in that case (it's just an empty array).
    // So this `if` is just for backwards compatibility with old metadata.


    if (!metadata.type('MOBILE')) {
      return 'FIXED_LINE_OR_MOBILE';
    } // Check if the number happens to qualify as both fixed line and mobile.
    // (no such country in the minimal metadata set)

    /* istanbul ignore if */


    if (isNumberTypeEqualTo(nationalNumber, 'MOBILE', metadata)) {
      return 'FIXED_LINE_OR_MOBILE';
    }

    return 'FIXED_LINE';
  }

  for (var _iterator = getNumberType_createForOfIteratorHelperLoose(NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done;) {
    var type = _step.value;

    if (isNumberTypeEqualTo(nationalNumber, type, metadata)) {
      return type;
    }
  }
}
function isNumberTypeEqualTo(nationalNumber, type, metadata) {
  type = metadata.type(type);

  if (!type || !type.pattern()) {
    return false;
  } // Check if any possible number lengths are present;
  // if so, we use them to avoid checking
  // the validation pattern if they don't match.
  // If they are absent, this means they match
  // the general description, which we have
  // already checked before a specific number type.


  if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) {
    return false;
  }

  return matchesEntirely(nationalNumber, type.pattern());
}
//# sourceMappingURL=getNumberType.js.map
;// ./node_modules/libphonenumber-js/es6/isValid.js



/**
 * Checks if a given phone number is valid.
 *
 * isValid(phoneNumberInstance, { ..., v2: true }, metadata)
 *
 * isPossible({ phone: '8005553535', country: 'RU' }, { ... }, metadata)
 * isPossible({ phone: '8005553535', country: 'RU' }, undefined, metadata)
 *
 * If the `number` is a string, it will be parsed to an object,
 * but only if it contains only valid phone number characters (including punctuation).
 * If the `number` is an object, it is used as is.
 *
 * The optional `defaultCountry` argument is the default country.
 * I.e. it does not restrict to just that country,
 * e.g. in those cases where several countries share
 * the same phone numbering rules (NANPA, Britain, etc).
 * For example, even though the number `07624 369230`
 * belongs to the Isle of Man ("IM" country code)
 * calling `isValidNumber('07624369230', 'GB', metadata)`
 * still returns `true` because the country is not restricted to `GB`,
 * it's just that `GB` is the default one for the phone numbering rules.
 * For restricting the country see `isValidNumberForRegion()`
 * though restricting a country might not be a good idea.
 * https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
 *
 * Examples:
 *
 * ```js
 * isValidNumber('+78005553535', metadata)
 * isValidNumber('8005553535', 'RU', metadata)
 * isValidNumber('88005553535', 'RU', metadata)
 * isValidNumber({ phone: '8005553535', country: 'RU' }, metadata)
 * ```
 */

function isValidNumber(input, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {};
  metadata = new Metadata(metadata);
  metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
  // distinguishing different countries having the same `countryCallingCode`.

  if (metadata.hasTypes()) {
    return getNumberType(input, options, metadata.metadata) !== undefined;
  } // If there are no type regexps for this country in metadata then use
  // `nationalNumberPattern` as a "better than nothing" replacement.


  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
  return matchesEntirely(nationalNumber, metadata.nationalNumberPattern());
}
//# sourceMappingURL=isValid.js.map
;// ./node_modules/libphonenumber-js/es6/helpers/getPossibleCountriesForNumber.js

/**
 * Returns a list of countries that the phone number could potentially belong to.
 * @param  {string} callingCode — Calling code.
 * @param  {string} nationalNumber — National (significant) number.
 * @param  {object} metadata — Metadata.
 * @return {string[]} A list of possible countries.
 */

function getPossibleCountriesForNumber(callingCode, nationalNumber, metadata) {
  var _metadata = new Metadata(metadata);

  var possibleCountries = _metadata.getCountryCodesForCallingCode(callingCode);

  if (!possibleCountries) {
    return [];
  }

  return possibleCountries.filter(function (country) {
    return couldNationalNumberBelongToCountry(nationalNumber, country, metadata);
  });
}

function couldNationalNumberBelongToCountry(nationalNumber, country, metadata) {
  var _metadata = new Metadata(metadata);

  _metadata.selectNumberingPlan(country);

  if (_metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0) {
    return true;
  }

  return false;
}
//# sourceMappingURL=getPossibleCountriesForNumber.js.map
;// ./node_modules/libphonenumber-js/es6/helpers/stripIddPrefix.js


var CAPTURING_DIGIT_PATTERN = new RegExp('([' + VALID_DIGITS + '])');
function stripIddPrefix(number, country, callingCode, metadata) {
  if (!country) {
    return;
  } // Check if the number is IDD-prefixed.


  var countryMetadata = new Metadata(metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);
  var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());

  if (number.search(IDDPrefixPattern) !== 0) {
    return;
  } // Strip IDD prefix.


  number = number.slice(number.match(IDDPrefixPattern)[0].length); // If there're any digits after an IDD prefix,
  // then those digits are a country calling code.
  // Since no country code starts with a `0`,
  // the code below validates that the next digit (if present) is not `0`.

  var matchedGroups = number.match(CAPTURING_DIGIT_PATTERN);

  if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
    if (matchedGroups[1] === '0') {
      return;
    }
  }

  return number;
}
//# sourceMappingURL=stripIddPrefix.js.map
;// ./node_modules/libphonenumber-js/es6/helpers/extractNationalNumberFromPossiblyIncompleteNumber.js
/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`. Even if a national prefix was extracted, it's not necessarily present in the returned object, so don't rely on its presence in the returned object in order to find out whether a national prefix has been extracted or not.
 */
function extractNationalNumberFromPossiblyIncompleteNumber(number, metadata) {
  if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
    // See METADATA.md for the description of
    // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
    // Attempt to parse the first digits as a national prefix.
    var prefixPattern = new RegExp('^(?:' + metadata.numberingPlan.nationalPrefixForParsing() + ')');
    var prefixMatch = prefixPattern.exec(number);

    if (prefixMatch) {
      var nationalNumber;
      var carrierCode; // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
      // If a `national_prefix_for_parsing` has any "capturing groups"
      // then it means that the national (significant) number is equal to
      // those "capturing groups" transformed via `national_prefix_transform_rule`,
      // and nothing could be said about the actual national prefix:
      // what is it and was it even there.
      // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
      // then everything it matches is a national prefix.
      // To determine whether `national_prefix_for_parsing` matched any
      // "capturing groups", the value of the result of calling `.exec()`
      // is looked at, and if it has non-undefined values where there're
      // "capturing groups" in the regular expression, then it means
      // that "capturing groups" have been matched.
      // It's not possible to tell whether there'll be any "capturing gropus"
      // before the matching process, because a `national_prefix_for_parsing`
      // could exhibit both behaviors.

      var capturedGroupsCount = prefixMatch.length - 1;
      var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];

      if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
        nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // If there's more than one captured group,
        // then carrier code is the second one.

        if (capturedGroupsCount > 1) {
          carrierCode = prefixMatch[1];
        }
      } // If there're no "capturing groups",
      // or if there're "capturing groups" but no
      // `national_prefix_transform_rule`,
      // then just strip the national prefix from the number,
      // and possibly a carrier code.
      // Seems like there could be more.
      else {
        // `prefixBeforeNationalNumber` is the whole substring matched by
        // the `national_prefix_for_parsing` regular expression.
        // There seem to be no guarantees that it's just a national prefix.
        // For example, if there's a carrier code, it's gonna be a
        // part of `prefixBeforeNationalNumber` too.
        var prefixBeforeNationalNumber = prefixMatch[0];
        nationalNumber = number.slice(prefixBeforeNationalNumber.length); // If there's at least one captured group,
        // then carrier code is the first one.

        if (hasCapturedGroups) {
          carrierCode = prefixMatch[1];
        }
      } // Tries to guess whether a national prefix was present in the input.
      // This is not something copy-pasted from Google's library:
      // they don't seem to have an equivalent for that.
      // So this isn't an "officially approved" way of doing something like that.
      // But since there seems no other existing method, this library uses it.


      var nationalPrefix;

      if (hasCapturedGroups) {
        var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
        var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup); // Example: an Argentinian (AR) phone number `0111523456789`.
        // `prefixMatch[0]` is `01115`, and `$1` is `11`,
        // and the rest of the phone number is `23456789`.
        // The national number is transformed via `9$1` to `91123456789`.
        // National prefix `0` is detected being present at the start.
        // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {

        if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) {
          nationalPrefix = metadata.numberingPlan.nationalPrefix();
        }
      } else {
        nationalPrefix = prefixMatch[0];
      }

      return {
        nationalNumber: nationalNumber,
        nationalPrefix: nationalPrefix,
        carrierCode: carrierCode
      };
    }
  }

  return {
    nationalNumber: number
  };
}
//# sourceMappingURL=extractNationalNumberFromPossiblyIncompleteNumber.js.map
;// ./node_modules/libphonenumber-js/es6/helpers/extractNationalNumber.js



/**
 * Strips national prefix and carrier code from a complete phone number.
 * The difference from the non-"FromCompleteNumber" function is that
 * it won't extract national prefix if the resultant number is too short
 * to be a complete number for the selected phone numbering plan.
 * @param  {string} number — Complete phone number digits.
 * @param  {Metadata} metadata — Metadata with a phone numbering plan selected.
 * @return {object} `{ nationalNumber: string, carrierCode: string? }`.
 */

function extractNationalNumber(number, metadata) {
  // Parsing national prefixes and carrier codes
  // is only required for local phone numbers
  // but some people don't understand that
  // and sometimes write international phone numbers
  // with national prefixes (or maybe even carrier codes).
  // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
  // Google's original library forgives such mistakes
  // and so does this library, because it has been requested:
  // https://github.com/catamphetamine/libphonenumber-js/issues/127
  var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(number, metadata),
      carrierCode = _extractNationalNumbe.carrierCode,
      nationalNumber = _extractNationalNumbe.nationalNumber;

  if (nationalNumber !== number) {
    if (!shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) {
      // Don't strip the national prefix.
      return {
        nationalNumber: number
      };
    } // Check the national (significant) number length after extracting national prefix and carrier code.
    // Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature.


    if (metadata.possibleLengths()) {
      // The number remaining after stripping the national prefix and carrier code
      // should be long enough to have a possible length for the country.
      // Otherwise, don't strip the national prefix and carrier code,
      // since the original number could be a valid number.
      // This check has been copy-pasted "as is" from Google's original library:
      // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
      // It doesn't check for the "possibility" of the original `number`.
      // I guess it's fine not checking that one. It works as is anyway.
      if (!isPossibleIncompleteNationalNumber(nationalNumber, metadata)) {
        // Don't strip the national prefix.
        return {
          nationalNumber: number
        };
      }
    }
  }

  return {
    nationalNumber: nationalNumber,
    carrierCode: carrierCode
  };
} // In some countries, the same digit could be a national prefix
// or a leading digit of a valid phone number.
// For example, in Russia, national prefix is `8`,
// and also `800 555 35 35` is a valid number
// in which `8` is not a national prefix, but the first digit
// of a national (significant) number.
// Same's with Belarus:
// `82004910060` is a valid national (significant) number,
// but `2004910060` is not.
// To support such cases (to prevent the code from always stripping
// national prefix), a condition is imposed: a national prefix
// is not extracted when the original number is "viable" and the
// resultant number is not, a "viable" national number being the one
// that matches `national_number_pattern`.

function shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
  // The equivalent in Google's code is:
  // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
  if (matchesEntirely(nationalNumberBefore, metadata.nationalNumberPattern()) && !matchesEntirely(nationalNumberAfter, metadata.nationalNumberPattern())) {
    return false;
  } // This "is possible" national number (length) check has been commented out
  // because it's superceded by the (effectively) same check done in the
  // `extractNationalNumber()` function after it calls `shouldHaveExtractedNationalPrefix()`.
  // In other words, why run the same check twice if it could only be run once.
  // // Check the national (significant) number length after extracting national prefix and carrier code.
  // // Fixes a minor "weird behavior" bug: https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/57
  // // (Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature).
  // if (metadata.possibleLengths()) {
  // 	if (isPossibleIncompleteNationalNumber(nationalNumberBefore, metadata) &&
  // 		!isPossibleIncompleteNationalNumber(nationalNumberAfter, metadata)) {
  // 		return false
  // 	}
  // }


  return true;
}

function isPossibleIncompleteNationalNumber(nationalNumber, metadata) {
  switch (checkNumberLength(nationalNumber, metadata)) {
    case 'TOO_SHORT':
    case 'INVALID_LENGTH':
      // This library ignores "local-only" phone numbers (for simplicity).
      // See the readme for more info on what are "local-only" phone numbers.
      // case 'IS_POSSIBLE_LOCAL_ONLY':
      return false;

    default:
      return true;
  }
}
//# sourceMappingURL=extractNationalNumber.js.map
;// ./node_modules/libphonenumber-js/es6/helpers/extractCountryCallingCodeFromInternationalNumberWithoutPlusSign.js





/**
 * Sometimes some people incorrectly input international phone numbers
 * without the leading `+`. This function corrects such input.
 * @param  {string} number — Phone number digits.
 * @param  {string?} country
 * @param  {string?} callingCode
 * @param  {object} metadata
 * @return {object} `{ countryCallingCode: string?, number: string }`.
 */

function extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata) {
  var countryCallingCode = country ? getCountryCallingCode(country, metadata) : callingCode;

  if (number.indexOf(countryCallingCode) === 0) {
    metadata = new Metadata(metadata);
    metadata.selectNumberingPlan(country, callingCode);
    var possibleShorterNumber = number.slice(countryCallingCode.length);

    var _extractNationalNumbe = extractNationalNumber(possibleShorterNumber, metadata),
        possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;

    var _extractNationalNumbe2 = extractNationalNumber(number, metadata),
        nationalNumber = _extractNationalNumbe2.nationalNumber; // If the number was not valid before but is valid now,
    // or if it was too long before, we consider the number
    // with the country calling code stripped to be a better result
    // and keep that instead.
    // For example, in Germany (+49), `49` is a valid area code,
    // so if a number starts with `49`, it could be both a valid
    // national German number or an international number without
    // a leading `+`.


    if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) && matchesEntirely(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || checkNumberLength(nationalNumber, metadata) === 'TOO_LONG') {
      return {
        countryCallingCode: countryCallingCode,
        number: possibleShorterNumber
      };
    }
  }

  return {
    number: number
  };
}
//# sourceMappingURL=extractCountryCallingCodeFromInternationalNumberWithoutPlusSign.js.map
;// ./node_modules/libphonenumber-js/es6/helpers/extractCountryCallingCode.js




/**
 * Converts a phone number digits (possibly with a `+`)
 * into a calling code and the rest phone number digits.
 * The "rest phone number digits" could include
 * a national prefix, carrier code, and national
 * (significant) number.
 * @param  {string} number — Phone number digits (possibly with a `+`).
 * @param  {string} [country] — Default country.
 * @param  {string} [callingCode] — Default calling code (some phone numbering plans are non-geographic).
 * @param  {object} metadata
 * @return {object} `{ countryCallingCodeSource: string?, countryCallingCode: string?, number: string }`
 * @example
 * // Returns `{ countryCallingCode: "1", number: "2133734253" }`.
 * extractCountryCallingCode('2133734253', 'US', null, metadata)
 * extractCountryCallingCode('2133734253', null, '1', metadata)
 * extractCountryCallingCode('+12133734253', null, null, metadata)
 * extractCountryCallingCode('+12133734253', 'RU', null, metadata)
 */

function extractCountryCallingCode(number, country, callingCode, metadata) {
  if (!number) {
    return {};
  }

  var isNumberWithIddPrefix; // If this is not an international phone number,
  // then either extract an "IDD" prefix, or extract a
  // country calling code from a number by autocorrecting it
  // by prepending a leading `+` in cases when it starts
  // with the country calling code.
  // https://wikitravel.org/en/International_dialling_prefix
  // https://github.com/catamphetamine/libphonenumber-js/issues/376

  if (number[0] !== '+') {
    // Convert an "out-of-country" dialing phone number
    // to a proper international phone number.
    var numberWithoutIDD = stripIddPrefix(number, country, callingCode, metadata); // If an IDD prefix was stripped then
    // convert the number to international one
    // for subsequent parsing.

    if (numberWithoutIDD && numberWithoutIDD !== number) {
      isNumberWithIddPrefix = true;
      number = '+' + numberWithoutIDD;
    } else {
      // Check to see if the number starts with the country calling code
      // for the default country. If so, we remove the country calling code,
      // and do some checks on the validity of the number before and after.
      // https://github.com/catamphetamine/libphonenumber-js/issues/376
      if (country || callingCode) {
        var _extractCountryCallin = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata),
            countryCallingCode = _extractCountryCallin.countryCallingCode,
            shorterNumber = _extractCountryCallin.number;

        if (countryCallingCode) {
          return {
            countryCallingCodeSource: 'FROM_NUMBER_WITHOUT_PLUS_SIGN',
            countryCallingCode: countryCallingCode,
            number: shorterNumber
          };
        }
      }

      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: number
      };
    }
  } // Fast abortion: country codes do not begin with a '0'


  if (number[1] === '0') {
    return {};
  }

  metadata = new Metadata(metadata); // The thing with country phone codes
  // is that they are orthogonal to each other
  // i.e. there's no such country phone code A
  // for which country phone code B exists
  // where B starts with A.
  // Therefore, while scanning digits,
  // if a valid country code is found,
  // that means that it is the country code.
  //

  var i = 2;

  while (i - 1 <= MAX_LENGTH_COUNTRY_CODE && i <= number.length) {
    var _countryCallingCode = number.slice(1, i);

    if (metadata.hasCallingCode(_countryCallingCode)) {
      metadata.selectNumberingPlan(_countryCallingCode);
      return {
        countryCallingCodeSource: isNumberWithIddPrefix ? 'FROM_NUMBER_WITH_IDD' : 'FROM_NUMBER_WITH_PLUS_SIGN',
        countryCallingCode: _countryCallingCode,
        number: number.slice(i)
      };
    }

    i++;
  }

  return {};
} // The possible values for the returned `countryCallingCodeSource` are:
//
// Copy-pasted from:
// https://github.com/google/libphonenumber/blob/master/resources/phonenumber.proto
//
// // The source from which the country_code is derived. This is not set in the
// // general parsing method, but in the method that parses and keeps raw_input.
// // New fields could be added upon request.
// enum CountryCodeSource {
//  // Default value returned if this is not set, because the phone number was
//  // created using parse, not parseAndKeepRawInput. hasCountryCodeSource will
//  // return false if this is the case.
//  UNSPECIFIED = 0;
//
//  // The country_code is derived based on a phone number with a leading "+",
//  // e.g. the French number "+33 1 42 68 53 00".
//  FROM_NUMBER_WITH_PLUS_SIGN = 1;
//
//  // The country_code is derived based on a phone number with a leading IDD,
//  // e.g. the French number "011 33 1 42 68 53 00", as it is dialled from US.
//  FROM_NUMBER_WITH_IDD = 5;
//
//  // The country_code is derived based on a phone number without a leading
//  // "+", e.g. the French number "33 1 42 68 53 00" when defaultCountry is
//  // supplied as France.
//  FROM_NUMBER_WITHOUT_PLUS_SIGN = 10;
//
//  // The country_code is derived NOT based on the phone number itself, but
//  // from the defaultCountry parameter provided in the parsing function by the
//  // clients. This happens mostly for numbers written in the national format
//  // (without country code). For example, this would be set when parsing the
//  // French number "01 42 68 53 00", when defaultCountry is supplied as
//  // France.
//  FROM_DEFAULT_COUNTRY = 20;
// }
//# sourceMappingURL=extractCountryCallingCode.js.map
;// ./node_modules/libphonenumber-js/es6/helpers/applyInternationalSeparatorStyle.js
 // Removes brackets and replaces dashes with spaces.
//
// E.g. "(999) 111-22-33" -> "999 111 22 33"
//
// For some reason Google's metadata contains `<intlFormat/>`s with brackets and dashes.
// Meanwhile, there's no single opinion about using punctuation in international phone numbers.
//
// For example, Google's `<intlFormat/>` for USA is `+1 213-373-4253`.
// And here's a quote from WikiPedia's "North American Numbering Plan" page:
// https://en.wikipedia.org/wiki/North_American_Numbering_Plan
//
// "The country calling code for all countries participating in the NANP is 1.
// In international format, an NANP number should be listed as +1 301 555 01 00,
// where 301 is an area code (Maryland)."
//
// I personally prefer the international format without any punctuation.
// For example, brackets are remnants of the old age, meaning that the
// phone number part in brackets (so called "area code") can be omitted
// if dialing within the same "area".
// And hyphens were clearly introduced for splitting local numbers into memorizable groups.
// For example, remembering "5553535" is difficult but "555-35-35" is much simpler.
// Imagine a man taking a bus from home to work and seeing an ad with a phone number.
// He has a couple of seconds to memorize that number until it passes by.
// If it were spaces instead of hyphens the man wouldn't necessarily get it,
// but with hyphens instead of spaces the grouping is more explicit.
// I personally think that hyphens introduce visual clutter,
// so I prefer replacing them with spaces in international numbers.
// In the modern age all output is done on displays where spaces are clearly distinguishable
// so hyphens can be safely replaced with spaces without losing any legibility.
//

function applyInternationalSeparatorStyle(formattedNumber) {
  return formattedNumber.replace(new RegExp("[".concat(VALID_PUNCTUATION, "]+"), 'g'), ' ').trim();
}
//# sourceMappingURL=applyInternationalSeparatorStyle.js.map
;// ./node_modules/libphonenumber-js/es6/helpers/formatNationalNumberUsingFormat.js
 // This was originally set to $1 but there are some countries for which the
// first group is not used in the national pattern (e.g. Argentina) so the $1
// group does not match correctly. Therefore, we use `\d`, so that the first
// group actually used in the pattern will be matched.

var FIRST_GROUP_PATTERN = /(\$\d)/;
function formatNationalNumberUsingFormat(number, format, _ref) {
  var useInternationalFormat = _ref.useInternationalFormat,
      withNationalPrefix = _ref.withNationalPrefix,
      carrierCode = _ref.carrierCode,
      metadata = _ref.metadata;
  var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : // This library doesn't use `domestic_carrier_code_formatting_rule`,
  // because that one is only used when formatting phone numbers
  // for dialing from a mobile phone, and this is not a dialing library.
  // carrierCode && format.domesticCarrierCodeFormattingRule()
  // 	// First, replace the $CC in the formatting rule with the desired carrier code.
  // 	// Then, replace the $FG in the formatting rule with the first group
  // 	// and the carrier code combined in the appropriate way.
  // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
  // 	: (
  // 		withNationalPrefix && format.nationalPrefixFormattingRule()
  // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
  // 			: format.format()
  // 	)
  withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()) : format.format());

  if (useInternationalFormat) {
    return applyInternationalSeparatorStyle(formattedNumber);
  }

  return formattedNumber;
}
//# sourceMappingURL=formatNationalNumberUsingFormat.js.map
;// ./node_modules/libphonenumber-js/es6/helpers/getIddPrefix.js

/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */

var SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
// a preferred IDD prefix is returned.

function getIddPrefix(country, callingCode, metadata) {
  var countryMetadata = new Metadata(metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);

  if (countryMetadata.defaultIDDPrefix()) {
    return countryMetadata.defaultIDDPrefix();
  }

  if (SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) {
    return countryMetadata.IDDPrefix();
  }
}
//# sourceMappingURL=getIddPrefix.js.map
;// ./node_modules/libphonenumber-js/es6/helpers/RFC3966.js
function RFC3966_slicedToArray(arr, i) { return RFC3966_arrayWithHoles(arr) || RFC3966_iterableToArrayLimit(arr, i) || RFC3966_unsupportedIterableToArray(arr, i) || RFC3966_nonIterableRest(); }

function RFC3966_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function RFC3966_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function RFC3966_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function RFC3966_createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = RFC3966_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function RFC3966_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return RFC3966_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return RFC3966_arrayLikeToArray(o, minLen); }

function RFC3966_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

 // https://www.ietf.org/rfc/rfc3966.txt

/**
 * @param  {string} text - Phone URI (RFC 3966).
 * @return {object} `{ ?number, ?ext }`.
 */

function parseRFC3966(text) {
  var number;
  var ext; // Replace "tel:" with "tel=" for parsing convenience.

  text = text.replace(/^tel:/, 'tel=');

  for (var _iterator = RFC3966_createForOfIteratorHelperLoose(text.split(';')), _step; !(_step = _iterator()).done;) {
    var part = _step.value;

    var _part$split = part.split('='),
        _part$split2 = RFC3966_slicedToArray(_part$split, 2),
        name = _part$split2[0],
        value = _part$split2[1];

    switch (name) {
      case 'tel':
        number = value;
        break;

      case 'ext':
        ext = value;
        break;

      case 'phone-context':
        // Only "country contexts" are supported.
        // "Domain contexts" are ignored.
        if (value[0] === '+') {
          number = value + number;
        }

        break;
    }
  } // If the phone number is not viable, then abort.


  if (!isViablePhoneNumber(number)) {
    return {};
  }

  var result = {
    number: number
  };

  if (ext) {
    result.ext = ext;
  }

  return result;
}
/**
 * @param  {object} - `{ ?number, ?extension }`.
 * @return {string} Phone URI (RFC 3966).
 */

function formatRFC3966(_ref) {
  var number = _ref.number,
      ext = _ref.ext;

  if (!number) {
    return '';
  }

  if (number[0] !== '+') {
    throw new Error("\"formatRFC3966()\" expects \"number\" to be in E.164 format.");
  }

  return "tel:".concat(number).concat(ext ? ';ext=' + ext : '');
}
//# sourceMappingURL=RFC3966.js.map
;// ./node_modules/libphonenumber-js/es6/format.js
function format_createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = format_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function format_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return format_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return format_arrayLikeToArray(o, minLen); }

function format_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function format_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function format_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? format_ownKeys(Object(source), !0).forEach(function (key) { format_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : format_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function format_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js





var DEFAULT_OPTIONS = {
  formatExtension: function formatExtension(formattedNumber, extension, metadata) {
    return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
  }
};
/**
 * Formats a phone number.
 *
 * format(phoneNumberInstance, 'INTERNATIONAL', { ..., v2: true }, metadata)
 * format(phoneNumberInstance, 'NATIONAL', { ..., v2: true }, metadata)
 *
 * format({ phone: '8005553535', country: 'RU' }, 'INTERNATIONAL', { ... }, metadata)
 * format({ phone: '8005553535', country: 'RU' }, 'NATIONAL', undefined, metadata)
 *
 * @param  {object|PhoneNumber} input — If `options.v2: true` flag is passed, the `input` should be a `PhoneNumber` instance. Otherwise, it should be an object of shape `{ phone: '...', country: '...' }`.
 * @param  {string} format
 * @param  {object} [options]
 * @param  {object} metadata
 * @return {string}
 */

function formatNumber(input, format, options, metadata) {
  // Apply default options.
  if (options) {
    options = format_objectSpread(format_objectSpread({}, DEFAULT_OPTIONS), options);
  } else {
    options = DEFAULT_OPTIONS;
  }

  metadata = new Metadata(metadata);

  if (input.country && input.country !== '001') {
    // Validate `input.country`.
    if (!metadata.hasCountry(input.country)) {
      throw new Error("Unknown country: ".concat(input.country));
    }

    metadata.country(input.country);
  } else if (input.countryCallingCode) {
    metadata.selectNumberingPlan(input.countryCallingCode);
  } else return input.phone || '';

  var countryCallingCode = metadata.countryCallingCode();
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
  // but Babel has a bug and it says "duplicate variable declaration".

  var number;

  switch (format) {
    case 'NATIONAL':
      // Legacy argument support.
      // (`{ country: ..., phone: '' }`)
      if (!nationalNumber) {
        return '';
      }

      number = formatNationalNumber(nationalNumber, input.carrierCode, 'NATIONAL', metadata, options);
      return addExtension(number, input.ext, metadata, options.formatExtension);

    case 'INTERNATIONAL':
      // Legacy argument support.
      // (`{ country: ..., phone: '' }`)
      if (!nationalNumber) {
        return "+".concat(countryCallingCode);
      }

      number = formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata, options);
      number = "+".concat(countryCallingCode, " ").concat(number);
      return addExtension(number, input.ext, metadata, options.formatExtension);

    case 'E.164':
      // `E.164` doesn't define "phone number extensions".
      return "+".concat(countryCallingCode).concat(nationalNumber);

    case 'RFC3966':
      return formatRFC3966({
        number: "+".concat(countryCallingCode).concat(nationalNumber),
        ext: input.ext
      });
    // For reference, here's Google's IDD formatter:
    // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
    // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
    // Who would even need to format phone numbers in IDD format anyway?

    case 'IDD':
      if (!options.fromCountry) {
        return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
      }

      var formattedNumber = formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
      return addExtension(formattedNumber, input.ext, metadata, options.formatExtension);

    default:
      throw new Error("Unknown \"format\" argument passed to \"formatNumber()\": \"".concat(format, "\""));
  }
}

function formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
  var format = chooseFormatForNumber(metadata.formats(), number);

  if (!format) {
    return number;
  }

  return formatNationalNumberUsingFormat(number, format, {
    useInternationalFormat: formatAs === 'INTERNATIONAL',
    withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
    carrierCode: carrierCode,
    metadata: metadata
  });
}

function chooseFormatForNumber(availableFormats, nationalNnumber) {
  for (var _iterator = format_createForOfIteratorHelperLoose(availableFormats), _step; !(_step = _iterator()).done;) {
    var format = _step.value;

    // Validate leading digits.
    // The test case for "else path" could be found by searching for
    // "format.leadingDigitsPatterns().length === 0".
    if (format.leadingDigitsPatterns().length > 0) {
      // The last leading_digits_pattern is used here, as it is the most detailed
      var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format

      if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) {
        continue;
      }
    } // Check that the national number matches the phone number format regular expression


    if (matchesEntirely(nationalNnumber, format.pattern())) {
      return format;
    }
  }
}

function addExtension(formattedNumber, ext, metadata, formatExtension) {
  return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}

function formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
  var fromCountryCallingCode = getCountryCallingCode(fromCountry, metadata.metadata); // When calling within the same country calling code.

  if (fromCountryCallingCode === countryCallingCode) {
    var formattedNumber = formatNationalNumber(nationalNumber, carrierCode, 'NATIONAL', metadata); // For NANPA regions, return the national format for these regions
    // but prefix it with the country calling code.

    if (countryCallingCode === '1') {
      return countryCallingCode + ' ' + formattedNumber;
    } // If regions share a country calling code, the country calling code need
    // not be dialled. This also applies when dialling within a region, so this
    // if clause covers both these cases. Technically this is the case for
    // dialling from La Reunion to other overseas departments of France (French
    // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
    // this edge case for now and for those cases return the version including
    // country calling code. Details here:
    // http://www.petitfute.com/voyage/225-info-pratiques-reunion
    //


    return formattedNumber;
  }

  var iddPrefix = getIddPrefix(fromCountry, undefined, metadata.metadata);

  if (iddPrefix) {
    return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat(formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata));
  }
}
//# sourceMappingURL=format.js.map
;// ./node_modules/libphonenumber-js/es6/PhoneNumber.js
function PhoneNumber_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function PhoneNumber_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PhoneNumber_ownKeys(Object(source), !0).forEach(function (key) { PhoneNumber_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PhoneNumber_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function PhoneNumber_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function PhoneNumber_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PhoneNumber_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function PhoneNumber_createClass(Constructor, protoProps, staticProps) { if (protoProps) PhoneNumber_defineProperties(Constructor.prototype, protoProps); if (staticProps) PhoneNumber_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }



 // import checkNumberLength from './helpers/checkNumberLength.js'






var USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;

var PhoneNumber = /*#__PURE__*/function () {
  /**
   * @param  {string} countryOrCountryCallingCode
   * @param  {string} nationalNumber
   * @param  {object} metadata — Metadata JSON
   * @return {PhoneNumber}
   */
  function PhoneNumber(countryOrCountryCallingCode, nationalNumber, metadata) {
    PhoneNumber_classCallCheck(this, PhoneNumber);

    // Validate `countryOrCountryCallingCode` argument.
    if (!countryOrCountryCallingCode) {
      throw new TypeError('First argument is required');
    }

    if (typeof countryOrCountryCallingCode !== 'string') {
      throw new TypeError('First argument must be a string');
    } // In case of public API use: `constructor(number, metadata)`.
    // Transform the arguments from `constructor(number, metadata)` to
    // `constructor(countryOrCountryCallingCode, nationalNumber, metadata)`.


    if (typeof countryOrCountryCallingCode === 'string') {
      if (countryOrCountryCallingCode[0] === '+' && !nationalNumber) {
        throw new TypeError('`metadata` argument not passed');
      }

      if (isObject(nationalNumber) && isObject(nationalNumber.countries)) {
        metadata = nationalNumber;
        var e164Number = countryOrCountryCallingCode;

        if (!E164_NUMBER_REGEXP.test(e164Number)) {
          throw new Error('Invalid `number` argument passed: must consist of a "+" followed by digits');
        }

        var _extractCountryCallin = extractCountryCallingCode(e164Number, undefined, undefined, metadata),
            _countryCallingCode = _extractCountryCallin.countryCallingCode,
            number = _extractCountryCallin.number;

        nationalNumber = number;
        countryOrCountryCallingCode = _countryCallingCode;

        if (!nationalNumber) {
          throw new Error('Invalid `number` argument passed: too short');
        }
      }
    } // Validate `nationalNumber` argument.


    if (!nationalNumber) {
      throw new TypeError('`nationalNumber` argument is required');
    }

    if (typeof nationalNumber !== 'string') {
      throw new TypeError('`nationalNumber` argument must be a string');
    } // Validate `metadata` argument.


    validateMetadata(metadata); // Initialize properties.

    var _getCountryAndCountry = getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadata),
        country = _getCountryAndCountry.country,
        countryCallingCode = _getCountryAndCountry.countryCallingCode;

    this.country = country;
    this.countryCallingCode = countryCallingCode;
    this.nationalNumber = nationalNumber;
    this.number = '+' + this.countryCallingCode + this.nationalNumber; // Exclude `metadata` property output from `PhoneNumber.toString()`
    // so that it doesn't clutter the console output of Node.js.
    // Previously, when Node.js did `console.log(new PhoneNumber(...))`,
    // it would output the whole internal structure of the `metadata` object.

    this.getMetadata = function () {
      return metadata;
    };
  }

  PhoneNumber_createClass(PhoneNumber, [{
    key: "setExt",
    value: function setExt(ext) {
      this.ext = ext;
    }
  }, {
    key: "getPossibleCountries",
    value: function getPossibleCountries() {
      if (this.country) {
        return [this.country];
      }

      return getPossibleCountriesForNumber(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function isPossible() {
      return isPossiblePhoneNumber(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return isValidNumber(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function isNonGeographic() {
      var metadata = new Metadata(this.getMetadata());
      return metadata.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function isEqual(phoneNumber) {
      return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
    } // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }

  }, {
    key: "getType",
    value: function getType() {
      return getNumberType(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function format(_format, options) {
      return formatNumber(this, _format, options ? PhoneNumber_objectSpread(PhoneNumber_objectSpread({}, options), {}, {
        v2: true
      }) : {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function formatNational(options) {
      return this.format('NATIONAL', options);
    }
  }, {
    key: "formatInternational",
    value: function formatInternational(options) {
      return this.format('INTERNATIONAL', options);
    }
  }, {
    key: "getURI",
    value: function getURI(options) {
      return this.format('RFC3966', options);
    }
  }]);

  return PhoneNumber;
}();



var isCountryCode = function isCountryCode(value) {
  return /^[A-Z]{2}$/.test(value);
};

function getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadataJson) {
  var country;
  var countryCallingCode;
  var metadata = new Metadata(metadataJson); // If country code is passed then derive `countryCallingCode` from it.
  // Also store the country code as `.country`.

  if (isCountryCode(countryOrCountryCallingCode)) {
    country = countryOrCountryCallingCode;
    metadata.selectNumberingPlan(country);
    countryCallingCode = metadata.countryCallingCode();
  } else {
    countryCallingCode = countryOrCountryCallingCode;
    /* istanbul ignore if */

    if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
      if (metadata.isNonGeographicCallingCode(countryCallingCode)) {
        country = '001';
      }
    }
  }

  return {
    country: country,
    countryCallingCode: countryCallingCode
  };
}

var E164_NUMBER_REGEXP = /^\+\d+$/;
//# sourceMappingURL=PhoneNumber.js.map
;// ./node_modules/libphonenumber-js/es6/helpers/getCountryByNationalNumber.js
function getCountryByNationalNumber_createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = getCountryByNationalNumber_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function getCountryByNationalNumber_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return getCountryByNationalNumber_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return getCountryByNationalNumber_arrayLikeToArray(o, minLen); }

function getCountryByNationalNumber_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



function getCountryByNationalNumber(nationalPhoneNumber, _ref) {
  var countries = _ref.countries,
      defaultCountry = _ref.defaultCountry,
      metadata = _ref.metadata;
  // Re-create `metadata` because it will be selecting a `country`.
  metadata = new Metadata(metadata); // const matchingCountries = []

  for (var _iterator = getCountryByNationalNumber_createForOfIteratorHelperLoose(countries), _step; !(_step = _iterator()).done;) {
    var country = _step.value;
    metadata.country(country); // "Leading digits" patterns are only defined for about 20% of all countries.
    // By definition, matching "leading digits" is a sufficient but not a necessary
    // condition for a phone number to belong to a country.
    // The point of "leading digits" check is that it's the fastest one to get a match.
    // https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md#leading_digits
    // I'd suppose that "leading digits" patterns are mutually exclusive for different countries
    // because of the intended use of that feature.

    if (metadata.leadingDigits()) {
      if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) {
        return country;
      }
    } // Else perform full validation with all of those
    // fixed-line/mobile/etc regular expressions.
    else if (getNumberType({
      phone: nationalPhoneNumber,
      country: country
    }, undefined, metadata.metadata)) {
      // If both the `defaultCountry` and the "main" one match the phone number,
      // don't prefer the `defaultCountry` over the "main" one.
      // https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/154
      return country; // // If the `defaultCountry` is among the `matchingCountries` then return it.
      // if (defaultCountry) {
      // 	if (country === defaultCountry) {
      // 		return country
      // 	}
      // 	matchingCountries.push(country)
      // } else {
      // 	return country
      // }
    }
  } // // Return the first ("main") one of the `matchingCountries`.
  // if (matchingCountries.length > 0) {
  // 	return matchingCountries[0]
  // }

}
//# sourceMappingURL=getCountryByNationalNumber.js.map
;// ./node_modules/libphonenumber-js/es6/helpers/getCountryByCallingCode.js

var getCountryByCallingCode_USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
function getCountryByCallingCode(callingCode, _ref) {
  var nationalPhoneNumber = _ref.nationalNumber,
      defaultCountry = _ref.defaultCountry,
      metadata = _ref.metadata;

  /* istanbul ignore if */
  if (getCountryByCallingCode_USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
    if (metadata.isNonGeographicCallingCode(callingCode)) {
      return '001';
    }
  }

  var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);

  if (!possibleCountries) {
    return;
  } // If there's just one country corresponding to the country code,
  // then just return it, without further phone number digits validation.


  if (possibleCountries.length === 1) {
    return possibleCountries[0];
  }

  return getCountryByNationalNumber(nationalPhoneNumber, {
    countries: possibleCountries,
    defaultCountry: defaultCountry,
    metadata: metadata.metadata
  });
}
//# sourceMappingURL=getCountryByCallingCode.js.map
;// ./node_modules/libphonenumber-js/es6/helpers/extractPhoneContext.js
// When phone numbers are written in `RFC3966` format — `"tel:+12133734253"` —
// they can have their "calling code" part written separately in a `phone-context` parameter.
// Example: `"tel:12133734253;phone-context=+1"`.
// This function parses the full phone number from the local number and the `phone-context`
// when the `phone-context` contains a `+` sign.

var PLUS_SIGN = '+';
var RFC3966_VISUAL_SEPARATOR_ = '[\\-\\.\\(\\)]?';
var RFC3966_PHONE_DIGIT_ = '(' + '[' + VALID_DIGITS + ']' + '|' + RFC3966_VISUAL_SEPARATOR_ + ')';
var RFC3966_GLOBAL_NUMBER_DIGITS_ = '^' + '\\' + PLUS_SIGN + RFC3966_PHONE_DIGIT_ + '*' + '[' + VALID_DIGITS + ']' + RFC3966_PHONE_DIGIT_ + '*' + '$';
/**
 * Regular expression of valid global-number-digits for the phone-context
 * parameter, following the syntax defined in RFC3966.
 */

var RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp(RFC3966_GLOBAL_NUMBER_DIGITS_, 'g'); // In this port of Google's library, we don't accept alpha characters in phone numbers.
// const ALPHANUM_ = VALID_ALPHA_ + VALID_DIGITS

var ALPHANUM_ = VALID_DIGITS;
var RFC3966_DOMAINLABEL_ = '[' + ALPHANUM_ + ']+((\\-)*[' + ALPHANUM_ + '])*';
var VALID_ALPHA_ = 'a-zA-Z';
var RFC3966_TOPLABEL_ = '[' + VALID_ALPHA_ + ']+((\\-)*[' + ALPHANUM_ + '])*';
var RFC3966_DOMAINNAME_ = '^(' + RFC3966_DOMAINLABEL_ + '\\.)*' + RFC3966_TOPLABEL_ + '\\.?$';
/**
 * Regular expression of valid domainname for the phone-context parameter,
 * following the syntax defined in RFC3966.
 */

var RFC3966_DOMAINNAME_PATTERN_ = new RegExp(RFC3966_DOMAINNAME_, 'g');
var RFC3966_PREFIX_ = 'tel:';
var RFC3966_PHONE_CONTEXT_ = ';phone-context=';
var RFC3966_ISDN_SUBADDRESS_ = ';isub=';
/**
 * Extracts the value of the phone-context parameter of `numberToExtractFrom`,
 * following the syntax defined in RFC3966.
 *
 * @param {string} numberToExtractFrom
 * @return {string|null} the extracted string (possibly empty), or `null` if no phone-context parameter is found.
 */

function extractPhoneContext(numberToExtractFrom) {
  var indexOfPhoneContext = numberToExtractFrom.indexOf(RFC3966_PHONE_CONTEXT_); // If no phone-context parameter is present

  if (indexOfPhoneContext < 0) {
    return null;
  }

  var phoneContextStart = indexOfPhoneContext + RFC3966_PHONE_CONTEXT_.length; // If phone-context parameter is empty

  if (phoneContextStart >= numberToExtractFrom.length) {
    return '';
  }

  var phoneContextEnd = numberToExtractFrom.indexOf(';', phoneContextStart); // If phone-context is not the last parameter

  if (phoneContextEnd >= 0) {
    return numberToExtractFrom.substring(phoneContextStart, phoneContextEnd);
  } else {
    return numberToExtractFrom.substring(phoneContextStart);
  }
}
/**
 * Returns whether the value of phoneContext follows the syntax defined in RFC3966.
 *
 * @param {string|null} phoneContext
 * @return {boolean}
 */

function isPhoneContextValid(phoneContext) {
  if (phoneContext === null) {
    return true;
  }

  if (phoneContext.length === 0) {
    return false;
  } // Does phone-context value match pattern of global-number-digits or domainname.


  return RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(phoneContext) || RFC3966_DOMAINNAME_PATTERN_.test(phoneContext);
}
//# sourceMappingURL=extractPhoneContext.js.map
;// ./node_modules/libphonenumber-js/es6/helpers/extractFormattedPhoneNumberFromPossibleRfc3966NumberUri.js


/**
 * @param  {string} numberToParse
 * @param  {string} nationalNumber
 * @return {}
 */

function extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(numberToParse, _ref) {
  var extractFormattedPhoneNumber = _ref.extractFormattedPhoneNumber;
  var phoneContext = extractPhoneContext(numberToParse);

  if (!isPhoneContextValid(phoneContext)) {
    throw new ParseError('NOT_A_NUMBER');
  }

  var phoneNumberString;

  if (phoneContext === null) {
    // Extract a possible number from the string passed in.
    // (this strips leading characters that could not be the start of a phone number)
    phoneNumberString = extractFormattedPhoneNumber(numberToParse) || '';
  } else {
    phoneNumberString = ''; // If the phone context contains a phone number prefix, we need to capture
    // it, whereas domains will be ignored.

    if (phoneContext.charAt(0) === PLUS_SIGN) {
      phoneNumberString += phoneContext;
    } // Now append everything between the "tel:" prefix and the phone-context.
    // This should include the national number, an optional extension or
    // isdn-subaddress component. Note we also handle the case when "tel:" is
    // missing, as we have seen in some of the phone number inputs.
    // In that case, we append everything from the beginning.


    var indexOfRfc3966Prefix = numberToParse.indexOf(RFC3966_PREFIX_);
    var indexOfNationalNumber; // RFC 3966 "tel:" prefix is preset at this stage because
    // `isPhoneContextValid()` requires it to be present.

    /* istanbul ignore else */

    if (indexOfRfc3966Prefix >= 0) {
      indexOfNationalNumber = indexOfRfc3966Prefix + RFC3966_PREFIX_.length;
    } else {
      indexOfNationalNumber = 0;
    }

    var indexOfPhoneContext = numberToParse.indexOf(RFC3966_PHONE_CONTEXT_);
    phoneNumberString += numberToParse.substring(indexOfNationalNumber, indexOfPhoneContext);
  } // Delete the isdn-subaddress and everything after it if it is present.
  // Note extension won't appear at the same time with isdn-subaddress
  // according to paragraph 5.3 of the RFC3966 spec.


  var indexOfIsdn = phoneNumberString.indexOf(RFC3966_ISDN_SUBADDRESS_);

  if (indexOfIsdn > 0) {
    phoneNumberString = phoneNumberString.substring(0, indexOfIsdn);
  } // If both phone context and isdn-subaddress are absent but other
  // parameters are present, the parameters are left in nationalNumber.
  // This is because we are concerned about deleting content from a potential
  // number string when there is no strong evidence that the number is
  // actually written in RFC3966.


  if (phoneNumberString !== '') {
    return phoneNumberString;
  }
}
//# sourceMappingURL=extractFormattedPhoneNumberFromPossibleRfc3966NumberUri.js.map
;// ./node_modules/libphonenumber-js/es6/parse.js
// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js







 // import { parseRFC3966 } from './helpers/RFC3966.js'







 // We don't allow input strings for parsing to be longer than 250 chars.
// This prevents malicious input from consuming CPU.

var MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.

var PHONE_NUMBER_START_PATTERN = new RegExp('[' + PLUS_CHARS + VALID_DIGITS + ']'); // Regular expression of trailing characters that we want to remove.
// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
// Example: "+1 (645) 123 1234-910#" number has extension "910".

var AFTER_PHONE_NUMBER_END_PATTERN = new RegExp('[^' + VALID_DIGITS + '#' + ']+$');
var parse_USE_NON_GEOGRAPHIC_COUNTRY_CODE = false; // Examples:
//
// ```js
// parse('8 (800) 555-35-35', 'RU')
// parse('8 (800) 555-35-35', 'RU', metadata)
// parse('8 (800) 555-35-35', { country: { default: 'RU' } })
// parse('8 (800) 555-35-35', { country: { default: 'RU' } }, metadata)
// parse('+7 800 555 35 35')
// parse('+7 800 555 35 35', metadata)
// ```
//

/**
 * Parses a phone number.
 *
 * parse('123456789', { defaultCountry: 'RU', v2: true }, metadata)
 * parse('123456789', { defaultCountry: 'RU' }, metadata)
 * parse('123456789', undefined, metadata)
 *
 * @param  {string} input
 * @param  {object} [options]
 * @param  {object} metadata
 * @return {object|PhoneNumber?} If `options.v2: true` flag is passed, it returns a `PhoneNumber?` instance. Otherwise, returns an object of shape `{ phone: '...', country: '...' }` (or just `{}` if no phone number was parsed).
 */

function parse(text, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {};
  metadata = new Metadata(metadata); // Validate `defaultCountry`.

  if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
    if (options.v2) {
      throw new ParseError('INVALID_COUNTRY');
    }

    throw new Error("Unknown country: ".concat(options.defaultCountry));
  } // Parse the phone number.


  var _parseInput = parseInput(text, options.v2, options.extract),
      formattedPhoneNumber = _parseInput.number,
      ext = _parseInput.ext,
      error = _parseInput.error; // If the phone number is not viable then return nothing.


  if (!formattedPhoneNumber) {
    if (options.v2) {
      if (error === 'TOO_SHORT') {
        throw new ParseError('TOO_SHORT');
      }

      throw new ParseError('NOT_A_NUMBER');
    }

    return {};
  }

  var _parsePhoneNumber = parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata),
      country = _parsePhoneNumber.country,
      nationalNumber = _parsePhoneNumber.nationalNumber,
      countryCallingCode = _parsePhoneNumber.countryCallingCode,
      countryCallingCodeSource = _parsePhoneNumber.countryCallingCodeSource,
      carrierCode = _parsePhoneNumber.carrierCode;

  if (!metadata.hasSelectedNumberingPlan()) {
    if (options.v2) {
      throw new ParseError('INVALID_COUNTRY');
    }

    return {};
  } // Validate national (significant) number length.


  if (!nationalNumber || nationalNumber.length < MIN_LENGTH_FOR_NSN) {
    // Won't throw here because the regexp already demands length > 1.

    /* istanbul ignore if */
    if (options.v2) {
      throw new ParseError('TOO_SHORT');
    } // Google's demo just throws an error in this case.


    return {};
  } // Validate national (significant) number length.
  //
  // A sidenote:
  //
  // They say that sometimes national (significant) numbers
  // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
  // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
  // Such numbers will just be discarded.
  //


  if (nationalNumber.length > MAX_LENGTH_FOR_NSN) {
    if (options.v2) {
      throw new ParseError('TOO_LONG');
    } // Google's demo just throws an error in this case.


    return {};
  }

  if (options.v2) {
    var phoneNumber = new PhoneNumber(countryCallingCode, nationalNumber, metadata.metadata);

    if (country) {
      phoneNumber.country = country;
    }

    if (carrierCode) {
      phoneNumber.carrierCode = carrierCode;
    }

    if (ext) {
      phoneNumber.ext = ext;
    }

    phoneNumber.__countryCallingCodeSource = countryCallingCodeSource;
    return phoneNumber;
  } // Check if national phone number pattern matches the number.
  // National number pattern is different for each country,
  // even for those ones which are part of the "NANPA" group.


  var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) : false;

  if (!options.extended) {
    return valid ? result(country, nationalNumber, ext) : {};
  } // isInternational: countryCallingCode !== undefined


  return {
    country: country,
    countryCallingCode: countryCallingCode,
    carrierCode: carrierCode,
    valid: valid,
    possible: valid ? true : options.extended === true && metadata.possibleLengths() && isPossibleNumber(nationalNumber, metadata) ? true : false,
    phone: nationalNumber,
    ext: ext
  };
}
/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} [extract] — If `false`, then will parse the entire `text` as a phone number.
 * @param  {boolean} [throwOnError] — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */

function _extractFormattedPhoneNumber(text, extract, throwOnError) {
  if (!text) {
    return;
  }

  if (text.length > MAX_INPUT_STRING_LENGTH) {
    if (throwOnError) {
      throw new ParseError('TOO_LONG');
    }

    return;
  }

  if (extract === false) {
    return text;
  } // Attempt to extract a possible number from the string passed in


  var startsAt = text.search(PHONE_NUMBER_START_PATTERN);

  if (startsAt < 0) {
    return;
  }

  return text // Trim everything to the left of the phone number
  .slice(startsAt) // Remove trailing non-numerical characters
  .replace(AFTER_PHONE_NUMBER_END_PATTERN, '');
}
/**
 * @param  {string} text - Input.
 * @param  {boolean} v2 - Legacy API functions don't pass `v2: true` flag.
 * @param  {boolean} [extract] - Whether to extract a phone number from `text`, or attempt to parse the entire text as a phone number.
 * @return {object} `{ ?number, ?ext }`.
 */


function parseInput(text, v2, extract) {
  // // Parse RFC 3966 phone number URI.
  // if (text && text.indexOf('tel:') === 0) {
  // 	return parseRFC3966(text)
  // }
  // let number = extractFormattedPhoneNumber(text, extract, v2)
  var number = extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(text, {
    extractFormattedPhoneNumber: function extractFormattedPhoneNumber(text) {
      return _extractFormattedPhoneNumber(text, extract, v2);
    }
  }); // If the phone number is not viable, then abort.

  if (!number) {
    return {};
  }

  if (!isViablePhoneNumber_isViablePhoneNumber(number)) {
    if (isViablePhoneNumberStart(number)) {
      return {
        error: 'TOO_SHORT'
      };
    }

    return {};
  } // Attempt to parse extension first, since it doesn't require region-specific
  // data and we want to have the non-normalised number here.


  var withExtensionStripped = extractExtension(number);

  if (withExtensionStripped.ext) {
    return withExtensionStripped;
  }

  return {
    number: number
  };
}
/**
 * Creates `parse()` result object.
 */


function result(country, nationalNumber, ext) {
  var result = {
    country: country,
    phone: nationalNumber
  };

  if (ext) {
    result.ext = ext;
  }

  return result;
}
/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */


function parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
  // Extract calling code from phone number.
  var _extractCountryCallin = extractCountryCallingCode(parseIncompletePhoneNumber(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata),
      countryCallingCodeSource = _extractCountryCallin.countryCallingCodeSource,
      countryCallingCode = _extractCountryCallin.countryCallingCode,
      number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.


  var country;

  if (countryCallingCode) {
    metadata.selectNumberingPlan(countryCallingCode);
  } // If `formattedPhoneNumber` is passed in "national" format
  // then `number` is defined and `countryCallingCode` is `undefined`.
  else if (number && (defaultCountry || defaultCallingCode)) {
    metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);

    if (defaultCountry) {
      country = defaultCountry;
    } else {
      /* istanbul ignore if */
      if (parse_USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        if (metadata.isNonGeographicCallingCode(defaultCallingCode)) {
          country = '001';
        }
      }
    }

    countryCallingCode = defaultCallingCode || getCountryCallingCode(defaultCountry, metadata.metadata);
  } else return {};

  if (!number) {
    return {
      countryCallingCodeSource: countryCallingCodeSource,
      countryCallingCode: countryCallingCode
    };
  }

  var _extractNationalNumbe = extractNationalNumber(parseIncompletePhoneNumber(number), metadata),
      nationalNumber = _extractNationalNumbe.nationalNumber,
      carrierCode = _extractNationalNumbe.carrierCode; // Sometimes there are several countries
  // corresponding to the same country phone code
  // (e.g. NANPA countries all having `1` country phone code).
  // Therefore, to reliably determine the exact country,
  // national (significant) number should have been parsed first.
  //
  // When `metadata.json` is generated, all "ambiguous" country phone codes
  // get their countries populated with the full set of
  // "phone number type" regular expressions.
  //


  var exactCountry = getCountryByCallingCode(countryCallingCode, {
    nationalNumber: nationalNumber,
    defaultCountry: defaultCountry,
    metadata: metadata
  });

  if (exactCountry) {
    country = exactCountry;
    /* istanbul ignore if */

    if (exactCountry === '001') {// Can't happen with `USE_NON_GEOGRAPHIC_COUNTRY_CODE` being `false`.
      // If `USE_NON_GEOGRAPHIC_COUNTRY_CODE` is set to `true` for some reason,
      // then remove the "istanbul ignore if".
    } else {
      metadata.country(country);
    }
  }

  return {
    country: country,
    countryCallingCode: countryCallingCode,
    countryCallingCodeSource: countryCallingCodeSource,
    nationalNumber: nationalNumber,
    carrierCode: carrierCode
  };
}
//# sourceMappingURL=parse.js.map
;// ./node_modules/libphonenumber-js/es6/parsePhoneNumberWithError_.js
function parsePhoneNumberWithError_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function parsePhoneNumberWithError_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? parsePhoneNumberWithError_ownKeys(Object(source), !0).forEach(function (key) { parsePhoneNumberWithError_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : parsePhoneNumberWithError_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function parsePhoneNumberWithError_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


function parsePhoneNumberWithError(text, options, metadata) {
  return parse(text, parsePhoneNumberWithError_objectSpread(parsePhoneNumberWithError_objectSpread({}, options), {}, {
    v2: true
  }), metadata);
}
//# sourceMappingURL=parsePhoneNumberWithError_.js.map
;// ./node_modules/libphonenumber-js/es6/parsePhoneNumber_.js
function parsePhoneNumber_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function parsePhoneNumber_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? parsePhoneNumber_ownKeys(Object(source), !0).forEach(function (key) { parsePhoneNumber_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : parsePhoneNumber_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function parsePhoneNumber_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




function parsePhoneNumber_parsePhoneNumber(text, options, metadata) {
  // Validate `defaultCountry`.
  if (options && options.defaultCountry && !isSupportedCountry(options.defaultCountry, metadata)) {
    options = parsePhoneNumber_objectSpread(parsePhoneNumber_objectSpread({}, options), {}, {
      defaultCountry: undefined
    });
  } // Parse phone number.


  try {
    return parsePhoneNumberWithError(text, options, metadata);
  } catch (error) {
    /* istanbul ignore else */
    if (error instanceof ParseError) {//
    } else {
      throw error;
    }
  }
}
//# sourceMappingURL=parsePhoneNumber_.js.map
;// ./node_modules/libphonenumber-js/es6/parsePhoneNumber.js


function es6_parsePhoneNumber_parsePhoneNumber() {
  var _normalizeArguments = normalizeArguments(arguments),
      text = _normalizeArguments.text,
      options = _normalizeArguments.options,
      metadata = _normalizeArguments.metadata;

  return parsePhoneNumber_parsePhoneNumber(text, options, metadata);
}
//# sourceMappingURL=parsePhoneNumber.js.map
;// ./node_modules/libphonenumber-js/min/exports/parsePhoneNumber.js



function exports_parsePhoneNumber_parsePhoneNumber() {
	return withMetadataArgument(es6_parsePhoneNumber_parsePhoneNumber, arguments)
}
;// ./src/utils/phone.ts


var defaultCountry = function () {
    var teamCountry = (external_vue_default()).prototype.$kwInterface.store.getters['user/country'];
    return teamCountry.code;
};
// Parse a string for phone number
var parsePhone = function (data, country) {
    return exports_parsePhoneNumber_parsePhoneNumber(data, country || defaultCountry());
};
// Format a phone number for display
var showPhone = function (data, country) {
    if (data === '')
        return '';
    var phoneNumber = parsePhone(data, country);
    if (!phoneNumber) {
        return data;
    }
    if (phoneNumber.country === defaultCountry()) {
        return phoneNumber.formatNational();
    }
    return phoneNumber.formatInternational();
};


;// ./src/mixins/PhoneMixin.ts



var PhoneMixin_DateMixin = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(DateMixin, _super);
    function DateMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // Parse a string for phone number
    DateMixin.prototype.parsePhone = function (phone) {
        if (!phone) {
            return null;
        }
        return parsePhone(phone);
    };
    // Return a formated phone for display
    DateMixin.prototype.showPhone = function (phone, countryCode) {
        if (!phone) {
            return null;
        }
        return showPhone(phone, countryCode);
    };
    DateMixin = (0,tslib_es6/* __decorate */.Cg)([
        lib/* Component */.uA
    ], DateMixin);
    return DateMixin;
}(lib/* Vue */.lD));
/* harmony default export */ var PhoneMixin = (PhoneMixin_DateMixin);

// EXTERNAL MODULE: ./src/mixins/NumberMixin.ts
var NumberMixin = __webpack_require__(1781);
// EXTERNAL MODULE: ./src/mixins/TeamConfigMixin.ts
var TeamConfigMixin = __webpack_require__(2399);
// EXTERNAL MODULE: ./src/mixins/TeamFormMixin.ts
var TeamFormMixin = __webpack_require__(2783);
;// ./src/utils/text.ts
var convertHtmlToText = function (html) {
    if (html === null) {
        return '';
    }
    var div = document.createElement('div');
    div.innerHTML = html.replaceAll(/<br( +)?(\/)?>(?!\\n|\\r|\\r\\n)/gm, '<br>\n');
    return div.textContent || div.innerText || '';
};


;// ./src/mixins/TextMixin.ts



var TextMixin = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TextMixin, _super);
    function TextMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // Show a formated date
    TextMixin.prototype.htmlToText = function (html) {
        return convertHtmlToText(html);
    };
    TextMixin = (0,tslib_es6/* __decorate */.Cg)([
        lib/* Component */.uA
    ], TextMixin);
    return TextMixin;
}(lib/* Vue */.lD));
/* harmony default export */ var mixins_TextMixin = (TextMixin);

// EXTERNAL MODULE: ./src/views/UserInvitationView/UserInvitationView.vue + 3 modules
var UserInvitationView = __webpack_require__(137);
// EXTERNAL MODULE: ./src/views/AppColorsView.vue + 3 modules
var AppColorsView = __webpack_require__(5262);
// EXTERNAL MODULE: ./src/views/AppVersionsView.vue + 3 modules
var AppVersionsView = __webpack_require__(6571);
// EXTERNAL MODULE: ./src/views/CivilitiesView.vue + 3 modules
var CivilitiesView = __webpack_require__(6697);
// EXTERNAL MODULE: ./src/views/ConfigurationView.vue + 3 modules
var ConfigurationView = __webpack_require__(1305);
// EXTERNAL MODULE: ./src/views/EmailVerificationView.vue + 3 modules
var EmailVerificationView = __webpack_require__(5355);
// EXTERNAL MODULE: ./src/views/Error404View.vue + 3 modules
var Error404View = __webpack_require__(3346);
// EXTERNAL MODULE: ./src/views/ForgotPasswordView.vue + 3 modules
var ForgotPasswordView = __webpack_require__(2854);
// EXTERNAL MODULE: ./src/views/HistoricsView.vue + 3 modules
var HistoricsView = __webpack_require__(8430);
// EXTERNAL MODULE: ./src/views/LoginView.vue + 3 modules
var LoginView = __webpack_require__(1908);
// EXTERNAL MODULE: ./src/views/NotificationsView.vue + 3 modules
var NotificationsView = __webpack_require__(6342);
// EXTERNAL MODULE: ./src/views/PaymentMethodsView.vue + 3 modules
var PaymentMethodsView = __webpack_require__(8349);
// EXTERNAL MODULE: ./src/views/PaymentTermsView.vue + 3 modules
var PaymentTermsView = __webpack_require__(2478);
// EXTERNAL MODULE: ./src/views/RegisterView.vue + 3 modules
var RegisterView = __webpack_require__(1901);
// EXTERNAL MODULE: ./src/views/ResetPasswordView.vue + 3 modules
var ResetPasswordView = __webpack_require__(7309);
// EXTERNAL MODULE: ./src/views/TagsView.vue + 3 modules
var TagsView = __webpack_require__(4600);
// EXTERNAL MODULE: ./src/views/TeamApiTokenView.vue + 3 modules
var TeamApiTokenView = __webpack_require__(8662);
// EXTERNAL MODULE: ./src/views/TeamInformationsView.vue + 3 modules
var TeamInformationsView = __webpack_require__(8583);
// EXTERNAL MODULE: ./src/views/TeamParamsView.vue + 3 modules
var TeamParamsView = __webpack_require__(2165);
// EXTERNAL MODULE: ./src/views/UnitsView.vue + 3 modules
var UnitsView = __webpack_require__(2513);
// EXTERNAL MODULE: ./src/views/UserProfileView.vue + 3 modules
var UserProfileView = __webpack_require__(3670);
// EXTERNAL MODULE: ./src/views/UsersView.vue + 3 modules
var UsersView = __webpack_require__(9851);
// EXTERNAL MODULE: ./src/views/VatRatesView.vue + 3 modules
var VatRatesView = __webpack_require__(8856);
;// ./src/lang/en.ts
var lang = {};
/* harmony default export */ var en = (lang);

;// ./src/lang/fr.ts
var interfaceLang = {
    yes: 'Oui',
    no: 'Non',
    ok: 'Ok',
    cancel: 'Annuler',
    save: 'Enregistrer',
    add: 'Ajouter',
    edit: 'Modifier',
    delete: 'Supprimer',
    create: 'Créer',
    close: 'Fermer',
    item: 'Fiche',
    example: 'Exemple',
    continue: 'Continuer',
    download: 'Télécharger',
    print: 'Imprimer',
    preview: 'Aperçu',
    filePreview: 'Prévisualiser',
    searchPlaceholder: 'Rechercher...',
    rowLengthSelectPrefix: 'Afficher ',
    rowLengthSelectSuffix: ' lignes',
    paginationInfos: 'Résultats : {begin} à {end} (Total : {total})',
    deleteConfirmation: 'Confirmation de suppression',
    useForDefault: 'Utiliser par défaut',
    byDefault: 'Par défaut',
    noResults: 'Aucun élément',
    speedEdit: 'Modification rapide',
    saveError: 'Erreur lors de l\'enregistrement',
    backToHome: 'Retour à l\'accueil',
    backToLogin: 'Retour à l\'écran de connexion',
    canDeleteLastOne: 'Vous ne pouvez pas supprimer le dernier élément',
    accountInitialization: 'Initialisation de votre compte en cours...',
    menu: 'Menu',
    others: 'Autres',
    replacementElement: {
        title: 'Sélection d\'un élément de remplacement',
        message: 'Cet élément est utilisé et nécessite un élément de remplacement pour être supprimé',
        label: 'Élément de remplacement :'
    },
    activeStatus: {
        label: 'Statut',
        on: 'Actif',
        off: 'Inactif'
    },
    list: {
        createdAt: 'Date de création',
        updatedAt: 'Date de modification'
    },
    configuration: 'Configuration',
    parameters: 'Paramètres',
    duration: {
        hour: 'heure | heure | heures',
        minute: 'minute | minute | minutes'
    },
    datetime: '[Le] {date} [à] {time}',
    datetimeToday: '[Aujourd\'hui à] {time}',
    datetimeYesterday: '[Hier à] {time}',
    today: 'Aujourd\'hui',
    tomorrow: 'Demain',
    yesterday: 'Hier',
    day: 'Jour',
    month: 'Mois',
    requiredField: 'Ce champ est obligatoire',
    globalSearch: 'Rechercher un client, un document...',
    error404Content: 'Cette page n\'existe pas',
    error404Link: 'Retour à l\'accueil',
    menuLabel: {
        userProfile: 'Mes informations',
        teamInformations: 'Mon entreprise',
        teamParams: 'Paramètres',
        tiers: 'Tiers',
        civilities: 'Civilités',
        sales: 'Ventes',
        paymentTerms: 'Conditions de règlement',
        units: 'Unités',
        paymentMethods: 'Moyens de paiement',
        vatrates: 'Taux de TVA',
        tags: 'Mots-clés',
        importsExports: 'Imports / Exports',
        users: 'Utilisateurs',
        historics: 'Historique des actions',
        api: 'Accès API',
        customizeApp: 'Personnalisation',
        appVersions: 'Mises à jour'
    },
    pageTitle: {
        error404: 'Cette page n\'existe pas',
        login: 'Se connecter',
        forgotPassword: 'Mot de passe oublié',
        resetPassword: 'Réinitialisation du mot de passe',
        register: 'Création d\'un compte',
        emailValidation: 'Validation d\'une adresse email',
        accountInvitation: 'Gestion d\'une invitation',
        userProfile: 'Mes informations',
        teamInformations: 'Informations de mon entreprise',
        teamParams: 'Paramètres',
        civilities: 'Gestion des civilités',
        paymentTerms: 'Gestion des conditions de règlement',
        units: 'Gestion des unités',
        paymentMethods: 'Gestion des moyens de paiement',
        vatrates: 'Gestion des taux de TVA',
        tags: 'Gestion des mots-clés',
        importsExports: 'Imports et Exports de données',
        users: 'Gestion des utilisateurs',
        historics: 'Historique des actions des utilisateurs',
        apiToken: 'Clés API',
        customizeApp: 'Personnalisation de l\'interface',
        notificationCenter: 'Centre de notifications',
        appVersions: 'Historique des versions du logiciel'
    },
    team: {
        companyName: 'Nom de votre entreprise',
        addressTitle: 'Adresse de votre entreprise',
        coordinatesTitle: 'Coordonnées de votre entreprise',
        phone: 'Téléphone :',
        mobile: 'Portable :',
        fax: 'Fax :',
        email: 'Email :',
        website: 'Site internet :',
        companyInfosTitle: 'Informations fiscales de votre entreprise',
        companyType: 'Type d\'entreprise :',
        companySiret: 'Numéro SIRET :',
        companyRcs: 'Numéro RCS :',
        companyVatRate: 'Numéro TVA intracommunautaire :',
        companyNaf: 'Code NAF :',
        companyCapital: 'Capital :'
    },
    teamParams: {
        accountParams: 'Paramètres du compte',
        currency: 'Devise :',
        timezone: 'Timezone :',
        phoneNumber: 'Numéro de téléphone',
        phoneNumberClick: 'Rendre cliquables les numéros de téléphone',
        numberFormat: 'Formatage des nombres',
        decimalsSeparator: 'Séparateur pour les décimales :',
        thousandsSeparator: 'Séparateur pour les milliers :',
        currencyPosition: 'Affichage de la devise :',
        nbDecimals: 'Nombre de décimales autorisées',
        nbDecimalsDescription: 'Attention, si vous indiquez 0 décimales, tous les montants ne pourront plus avoir de décimales',
        dateFormatTitle: 'Formatage des dates',
        dateFormat: 'Format des dates',
        currencyPositionsBefore: 'Afficher avant le montant',
        currencyPositionsAfter: 'Afficher après le montant',
        currencyPositionsNone: 'Ne pas afficher la devise',
        numberNbDecimals0: 'Pas de décimale',
        numberNbDecimals1: '1 décimale',
        numberNbDecimals2: '2 décimales',
        numberFormatThousandsSpace: 'Insérer un espace',
        numberFormatThousandsNone: 'Ne rien ajouter'
    },
    user: {
        currentPassword: 'Mot de passe actuel :',
        newPassword: 'Nouveau mot de passe :',
        confirmPassword: 'Confirmez le mot de passe :',
        passwordNotEquals: 'Les mots de passe ne sont pas identiques',
        newMail: 'Nouvel email à utiliser :',
        newMailExplain: 'Un email avec un lien de validation sera envoyé sur la nouvelle adresse email.',
        newMailExplain2: 'Le nouvel email ne sera effectif que lors vous aurez cliqué sur le lien de validation.',
        newMailExplain3: 'Ce lien n\'est valable que 24H. Passez ce délai, la demande sera annulée et vous devrez recommencer le processus de changement d\'email.',
        deleteAvatarMsg: 'Êtes-vous sûr de vouloir supprimer votre avatar ?',
        firstname: 'Prénom',
        lastname: 'Nom',
        phone: 'Téléphone :',
        mobile: 'Portable :',
        fax: 'Fax :',
        myProfile: 'Mes informations',
        myCompany: 'Mon entreprise',
        configuration: 'Configuration',
        modules: 'Modules',
        confirmSendValidation: 'La validation a bien été renvoyée',
        confirmEmailChange: 'Le changement d\'email a bien été annulé',
        loginInformations: 'Informations de connexion',
        loginEmail: 'Email de connexion :',
        emailChangeInProgress: 'Changement d\'email en cours :',
        emailValidationInProgress: 'Email en attente de validation',
        resendValidation: 'Renvoyer la validation',
        changeEmailTitle: 'Changement de l\'email',
        changeEmailButton: 'Modifier mon email',
        passwordChangeTitle: 'Changement de mot de passe',
        passwordChangeButton: 'Modifier mon mot de passe',
        newsletter: 'Recevoir les offres commerciales',
        updates: 'Recevoir les emails de mise à jour',
        switchAccount: 'Changer de compte :',
        switchAccountConfirm1: 'Plusieurs fenêtres ou onglets utilisant l\'application sont ouverts dans votre navigateur.',
        switchAccountConfirm2: 'En changeant de compte, tous les onglets seront mis à jour, vous perdrez toutes données non-enregistrée.'
    },
    userInvitation: {
        rightToAccount: 'Droits d\'accès au compte',
        canManage: 'Vous ne pouvez pas gérer l\'invitation à accéder au compte de la société "{team}" avec l\'utilisateur depuis lequel vous êtes connecté.',
        needRegister: 'Afin d\'accéder au compte de la société "{team}", vous devez vous créer un accès.',
        firstname: 'Prénom',
        lastname: 'Nom',
        email: 'Email',
        password: 'Mot de passe',
        createAccount: 'Créer un compte',
        loggedUser: 'Utilisateur connecté :',
        inAccept: 'En acceptant, vous aurez les droits d\'accès sur le compte "{team}"',
        deny: 'Refuser',
        accept: 'Accepter',
        needLogin: 'Vous devez vous connecter afin de gérer l\'invitation à accéder au compte de la société "{team}".'
    },
    civility: {
        menu: 'Civilités',
        pageTitle: 'Gestion des civilités',
        label: 'Nom de la civilité',
        label2: 'Nom court',
        new: 'Création d\'une civilité',
        edit: 'Modification d\'une civilité',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette civilité ?'
    },
    comments: {
        tabTitle: 'Notes',
        addTitle: 'Ajouter une note',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce commentaire ?',
        empty: 'Aucune note'
    },
    files: {
        label: 'Fichier',
        weight: 'Poids',
        type: 'Type',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce fichier ?',
        tabTitle: 'Fichiers',
        addFiles: 'Ajouter des fichiers'
    },
    historics: {
        date: 'Date',
        action: 'Action',
        user: 'Utilisateur',
        tabTitle: 'Historique'
    },
    auth: {
        title: 'Se connecter',
        email: 'Email :',
        password: 'Mot de passe :',
        confirmPassword: 'Confirmer le mot de passe :',
        rememberMe: 'Se rappeler de moi',
        connect: 'Se connecter',
        forgotPassword: 'Mot de passe oublié ?',
        createAccount: 'Créer un compte',
        disconnect: 'Se déconnecter',
        loginEmail: 'Votre email de connexion :',
        forgotPasswordBtn: 'Réinitialiser mon mot de passe',
        companyName: 'Nom de l\'entreprise',
        firstname: 'Prénom',
        lastname: 'Nom',
        phone: 'Téléphone'
    },
    password: {
        minLetter: 'Au moins une lettre minuscule',
        minUppercase: 'Au moins une lettre majuscule',
        minNumber: 'Au moins un chiffre',
        minSpecial: 'Au moins un caractère spécial (,;:=+_()#?!@$%^&*-)',
        minLength: 'Fait au moins 8 caractères',
    },
    tag: {
        menu: 'Mots-clés',
        pageTitle: 'Gestion des mots-clés',
        label: 'Nom du mot-clé',
        new: 'Création d\'un mot-clé',
        edit: 'Modification d\'un mot-clé',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce mot-clé ?'
    },
    paymentTerm: {
        menu: 'Conditions de paiement',
        pageTitle: 'Gestion des conditions de paiement',
        new: 'Création d\'une condition de paiement',
        edit: 'Modification d\'une condition de paiement',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette condition de paiement ?',
        label: 'Nom de la condition de paiement',
        nbDays: 'Nombre de jour',
        endMonth: 'Fin de mois',
        endMonthDay: 'Fin de mois le'
    },
    paymentMethod: {
        menu: 'Moyens de paiement',
        pageTitle: 'Gestion des moyens de paiement',
        label: 'Nom du moyen de paiement',
        typeLabel: 'Type de moyen de paiement',
        typeComments: 'Il est nécessaire d\'indiquer le type de moyen de paiement au logiciel afin que les fonctionnalités liées aux moyens de paiement fonctionnent correctement.',
        pdfContent: 'Désignation du moyen de paiement sur les PDF',
        pdfContentComments: 'Si non renseigné, le nom sera affiché',
        bankAccount: 'Compte de banque',
        bankAccountComments: '(Facultatif) Utilisé pour la génération des journaux comptable. Si non renseigné, le compte de banque par défaut sera alors utilisé.',
        new: 'Création d\'un moyen de paiement',
        edit: 'Modification d\'un moyen de paiement',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce moyen de paiement ?',
        types: {
            card: 'Carte bancaire',
            check: 'Chèque',
            cash: 'Espèce',
            directDebit: 'Prélèvement',
            directTransfert: 'Virement',
            other: 'Autre'
        },
        replacementComments: 'Ce moyen de paiement est utilisé, il doit donc être fusionné avec un autre moyen de paiement afin que le logiciel fonctionne normalement.'
    },
    vatRate: {
        menu: 'Taux de TVA',
        pageTitle: 'Gestion des taux de TVA',
        rateLabel: 'Taux de TVA',
        label: 'Label',
        commentsLabel: 'Le label vous permet d\'identifier un taux de TVA lorsque vous avez plusieurs taux de TVA identiques.',
        mentionLabel: 'Mention à afficher sur les documents PDF',
        rateAccount: 'Compte de TVA',
        rateAccountComments: 'Utilisé pour la génération des journaux comptable. N\'est obligatoire que si vous utiliser les exports comptable.',
        salesAccount: 'Compte de vente',
        salesAccountComments: '(Facultatif) Utilisé pour la génération des journaux comptable. N\'est utilisé que si aucune catégorie de vente n\'est rattachée lors de l\'export comptable.',
        new: 'Création d\'un taux de TVA',
        edit: 'Modification d\'un taux de TVA',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce taux de TVA ?',
        replacementComments: 'Ce taux de TVA est utilisé, vous ne pouvez donc pas le supprimer. Cependant, il est possible de le fusionner avec un taux de TVA indentique.'
    },
    apiToken: {
        documentation: 'La documentation de l\'API est disponible à cette adresse :',
        new: 'Création d\'une nouvelle clé API',
        edit: 'Modification d\'une clé API',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette clé API ?',
        name: 'Nom',
        expireAt: 'Expiration',
        rights: 'Droits d\'accès',
        createdAt: 'Date de création',
        lastUse: 'Dernière utilisation',
        copy: 'Copier',
        copied: 'Copier !',
        copyLine1: 'Merci de copier cette clé API et de la sauvegarder.',
        copyLine2: 'Pour des raisons de sécurité, vous ne pourrez plus la visualiser.',
        form: {
            name: 'Nom de la clé API',
            expireAt: 'Expire le (facultatif)'
        }
    },
    unit: {
        menu: 'Unités',
        pageTitle: 'Gestion des unités',
        label: 'Nom de l\'unité',
        new: 'Création d\'une unité',
        edit: 'Modification d\'une unité',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette unité ?'
    },
    users: {
        newLabel: 'Créer un utilisateur',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer l\'accès de cet utilisateur ?',
        newTitle: 'Création d\'un utilisateur',
        editTitle: 'Modification d\'un utilisateur',
        list: {
            fullname: 'Nom',
            email: 'Email',
            lastConnexion: 'Dernière connexion',
            roles: 'Rôles',
            status: 'Statut',
            withInvitation: 'Invitation en attente'
        },
        form: {
            email: 'Email :',
            invitationExplain: 'Une invitation sera envoyée par email. L\'utilisateur pourra alors créer son accès en cliquant sur le lien contenu dans cette invitation.',
            resendInvitation: 'Renvoyer une invitation',
            roles: 'Rôles',
            managedUsers: 'Utilisateurs à manager :',
            limitations: 'Droits d\'accès'
        },
        roles: {
            commercial: 'Commercial',
            technical: 'Technicien',
            manager: 'Manager'
        },
        invitation: {
            refused: 'Invitation refusée',
            expired: 'Invitation expirée',
            wait: 'En attente de validation de l\'invitation'
        }
    },
    demoMode: {
        label: 'Mode démonstration',
        outLabel: 'Sortir du mode démonstration',
        transferring: 'Transfert de vos données vers le mode réel en cours...',
        outExplain: 'Vous êtes sur le point de sortir du mode démonstration pour la première fois. Les documents de vente, les opportunités, les contrats et les commandes fournisseurs réalisées pendant le mode de test ne seront pas disponible dans le mode réel. Cependant, toutes les autres données seront transférées.',
        dontMigrateLabel: 'Données à NE PAS conserver :',
        confirm: 'Je confirme vouloir sortir du mode démonstration',
        password: 'Saisissez votre mot de passe de connexion :',
        goRealLabel: 'Passer en mode réel',
        useInDemo: 'Vous êtes actuellement en mode démonstration.',
        stayDemo: 'Rester en mode démonstration',
        justMigrated: 'Votre compte vient d\'être migré vers le mode réel.',
        goRealOrNot: 'Souhaitez-vous rester dans le mode démonstration pour le moment ou passer en mode réel ?',
        migrated: 'La migration de votre compte vers le mode réel est terminée.',
        goDemo: 'Passer en mode démonstration',
        goDemoAlert: 'Vous êtes sur le point de passer en mode démonstration. Ce mode permet d\'utiliser le logiciel sans apporter de modification au mode réel.',
        goDemoExplain: 'Le mode démonstration ne s\'activera que sur ce navigateur.',
        goDemoWarning1: 'Attention : les informations de votre entreprise et les utilisateurs sont partagés entre le mode réel et le mode démonstration.',
        goDemoWarning2: 'Toute modification de l\'une de ces informations dans le mode démonstration affectera le mode réel.'
    },
    customize: {
        logo: 'Logo',
        example: 'Exemple',
        myLogo: 'Mon logo',
        logoSideBar: 'Logo barre latérale normale',
        logoSidebarSize: 'Taille : 200px x 50px',
        logoCollapsedSideBar: 'Logo barre petite latérale',
        logoCollapsedSidebarSize: 'Taille : 30px x 35px',
        logoHiddenSideBar: 'Logo barre latérale masquée',
        logoHiddenSidebarSize: 'Taille : 200px x 50px',
        colorTab: 'Couleurs',
        logoTab: 'Logos',
        color: {
            main: 'Couleurs principales',
            sidebar: 'Barre latérale',
            sidebarConfig: 'Barre latérale de la partie configuration',
            sidebarMenuBackground: 'Couleur de fond pour les groupes ouvert',
            sidebarMenuColor: 'Couleur du texte pour les groupes ouvert',
            sidebarGroupBackground: 'Couleur de fond pour les liens actifs',
            sidebarGroupColor: 'Couleur du texte pour les liens actifs',
            sidebarElementBackground: 'Couleur de fond pour les liens actifs',
            sidebarElementColor: 'Couleur du texte pour les liens actifs',
            header: 'Header',
            headerMenuColor: 'Couleur des liens',
            headerMenuHoverColor: 'Couleur des liens au survol',
            headerMenuActiveColor: 'Couleur des liens actifs',
            headerDropdownHoverColor: 'Couleur du texte au survol pour les menus déroulants',
            headerDropdownHoverBackground: 'Couleur de fond au survol pour les menus déroulants',
            link: 'Liens et boutons',
            linkPrimary: 'Couleur de fond des boutons 1',
            linkBtnPrimaryColor: 'Couleur de texte des boutons 1',
            linkBtnPrimaryHover: 'Couleur de fond au survol des boutons 1',
            linkBtnPrimaryColorHover: 'Couleur du text au survol des boutons 1',
            linkSecondary: 'Couleur de fond des boutons 2',
            linkBtnSecondaryColor: 'Couleur de texte des boutons 2',
            linkBtnSecondaryHover: 'Couleur de fond au survol des boutons 2',
            linkBtnSecondaryColorHover: 'Couleur du text au survol des boutons 2',
            linkLight: 'Couleur de fond des boutons 3',
            linkBtnLightColor: 'Couleur de texte des boutons 3',
            linkBtnLightHover: 'Couleur de fond au survol des boutons 3',
            linkBtnLightColorHover: 'Couleur du text au survol des boutons 3',
            linkLinkColor: 'Couleur des liens',
            linkLinkColorHover: 'Couleur des liens au survol',
            table: 'Tableaux',
            tableHoverBackgroudn: 'Couleur de fond au survol',
            tableHoverColor: 'Couleur du texte au survol',
            background: 'Couleur de fond',
            color: 'Couleur du texte',
            cardBackground: 'Couleur de fond des cadres',
            cardColor: 'Couleur du texte des cadres'
        }
    },
    update: {
        title: 'Mise à jour de {name}',
        available: 'Une nouvelle version de l\'application est disponible.',
        reload: 'Recharger',
        warning: 'Attention : Tous les onglets du navigateur utilisant {name} seront actualisés.'
    },
    notifications: {
        modalTitle: 'Configuration des notifications',
        receiveActivityOf: 'Recevoir l\'activité de :',
        receiveActivityAll: 'Tous les utilisateurs',
        receiveActivityUsers: 'Des utilisateurs suivants :',
        receiveOnlyMyUser: 'Recevoir uniquement des notifications me concernant',
        receiveOnlyMyUserExplain: '(Clients, documents... auxquels je suis attribué)',
        eventToReceive: 'Notifications à recevoir',
        markAsRead: 'Marquer comme lue',
        markAllAsRead: 'Tout marquer comme lu',
        unread: 'Non lue',
        state: 'État',
        date: 'Date',
        sincePeriod: 'Du',
        untilPeriod: 'au',
        empty: 'Aucune notification'
    }
};
/* harmony default export */ var fr = ({
    interface: interfaceLang
});

;// ./src/lang/index.ts


var Lang = {
    en: en,
    fr: fr
};
/* harmony default export */ var src_lang = (Lang);

;// ./src/axios/interceptors.ts


var interceptors = function (axios) {
    var interfaceConfig = (external_vue_default()).prototype.$kwInterface;
    var store = interfaceConfig.store;
    axios.interceptors.request.use(function (config) {
        var _a;
        if (!config.baseURL) {
            var location = window.location;
            if (interfaceConfig.domainsApiUrl && interfaceConfig.domainsApiUrl[location.origin] !== undefined) {
                config.baseURL = interfaceConfig.domainsApiUrl[location.origin];
            }
            else {
                var url = location.hostname.split('.');
                url = url.slice(url.length - 2).join('.');
                config.baseURL = 'https://api.' + url;
            }
        }
        if (!config.headers) {
            // config.headers = {}
        }
        var token = (_a = store.state.auth.token) === null || _a === void 0 ? void 0 : _a.access_token;
        if (token) {
            config.headers.Authorization = 'Bearer ' + token;
        }
        if (store.getters['user/testMode']) {
            config.headers.testMode = '1';
        }
        return config;
    }, function (error) { return error; });
    axios.interceptors.response.use(function (response) {
        var _a;
        var serverVersion = (_a = response.headers['Front-App-Version']) !== null && _a !== void 0 ? _a : response.headers['front-app-version'];
        var appVersion = (external_vue_default()).prototype.$kwInterface.appVersion;
        if (appVersion && serverVersion && appVersion !== serverVersion) {
            mitt/* default */.A.emit('appUpdated');
        }
        return response;
    }, function (error) {
        var _a, _b;
        if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 401 && !((_b = error.config) === null || _b === void 0 ? void 0 : _b.isKForm)) {
            var response = error.response;
            var responseURL = response.request.responseURL;
            var baseURL = response.config.baseURL;
            if (!responseURL || !baseURL || response.request.responseURL.includes(response.config.baseURL)) {
                store.commit('auth/updateToken', null);
            }
        }
        throw error;
    });
};
/* harmony default export */ var axios_interceptors = (interceptors);

;// ./node_modules/vuex-module-decorators/dist/esm/index.js
/**
 * Takes the properties on object from parameter source and adds them to the object
 * parameter target
 * @param {object} target  Object to have properties copied onto from y
 * @param {object} source  Object with properties to be copied to x
 */
function addPropertiesToObject(target, source) {
    var _loop_1 = function (k) {
        Object.defineProperty(target, k, {
            get: function () { return source[k]; }
        });
    };
    for (var _i = 0, _a = Object.keys(source || {}); _i < _a.length; _i++) {
        var k = _a[_i];
        _loop_1(k);
    }
}
/**
 * Returns a namespaced name of the module to be used as a store getter
 * @param module
 */
function getModuleName(module) {
    if (!module._vmdModuleName) {
        throw new Error("ERR_GET_MODULE_NAME : Could not get module accessor.\n      Make sure your module has name, we can't make accessors for unnamed modules\n      i.e. @Module({ name: 'something' })");
    }
    return "vuexModuleDecorators/".concat(module._vmdModuleName);
}

var VuexModule = /** @class */ (function () {
    function VuexModule(module) {
        this.actions = module.actions;
        this.mutations = module.mutations;
        this.state = module.state;
        this.getters = module.getters;
        this.namespaced = module.namespaced;
        this.modules = module.modules;
    }
    return VuexModule;
}());
function getModule(moduleClass, store) {
    var moduleName = getModuleName(moduleClass);
    if (store && store.getters[moduleName]) {
        return store.getters[moduleName];
    }
    else if (moduleClass._statics) {
        return moduleClass._statics;
    }
    var genStatic = moduleClass._genStatic;
    if (!genStatic) {
        throw new Error("ERR_GET_MODULE_NO_STATICS : Could not get module accessor.\n      Make sure your module has name, we can't make accessors for unnamed modules\n      i.e. @Module({ name: 'something' })");
    }
    var storeModule = genStatic(store);
    if (store) {
        store.getters[moduleName] = storeModule;
    }
    else {
        moduleClass._statics = storeModule;
    }
    return storeModule;
}

var reservedKeys = ['actions', 'getters', 'mutations', 'modules', 'state', 'namespaced', 'commit'];
function stateFactory(module) {
    var state = new module.prototype.constructor({});
    var s = {};
    Object.keys(state).forEach(function (key) {
        if (reservedKeys.indexOf(key) !== -1) {
            if (typeof state[key] !== 'undefined') {
                throw new Error("ERR_RESERVED_STATE_KEY_USED: You cannot use the following\n        ['actions', 'getters', 'mutations', 'modules', 'state', 'namespaced', 'commit']\n        as fields in your module. These are reserved as they have special purpose in Vuex");
            }
            return;
        }
        if (state.hasOwnProperty(key)) {
            if (typeof state[key] !== 'function') {
                s[key] = state[key];
            }
        }
    });
    return s;
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function staticStateGenerator(module, modOpt, statics) {
    var state = modOpt.stateFactory ? module.state() : module.state;
    Object.keys(state).forEach(function (key) {
        if (state.hasOwnProperty(key)) {
            // If not undefined or function means it is a state value
            if (['undefined', 'function'].indexOf(typeof state[key]) === -1) {
                Object.defineProperty(statics, key, {
                    get: function () {
                        var path = modOpt.name.split('/');
                        var data = statics.store.state;
                        for (var _i = 0, path_1 = path; _i < path_1.length; _i++) {
                            var segment = path_1[_i];
                            data = data[segment];
                        }
                        return data[key];
                    }
                });
            }
        }
    });
}
function staticGetterGenerator(module, modOpt, statics) {
    Object.keys(module.getters).forEach(function (key) {
        if (module.namespaced) {
            Object.defineProperty(statics, key, {
                get: function () {
                    return statics.store.getters["".concat(modOpt.name, "/").concat(key)];
                }
            });
        }
        else {
            Object.defineProperty(statics, key, {
                get: function () {
                    return statics.store.getters[key];
                }
            });
        }
    });
}
function staticMutationGenerator(module, modOpt, statics) {
    Object.keys(module.mutations).forEach(function (key) {
        if (module.namespaced) {
            statics[key] = function () {
                var _a;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                (_a = statics.store).commit.apply(_a, __spreadArray(["".concat(modOpt.name, "/").concat(key)], args, false));
            };
        }
        else {
            statics[key] = function () {
                var _a;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                (_a = statics.store).commit.apply(_a, __spreadArray([key], args, false));
            };
        }
    });
}
function staticActionGenerators(module, modOpt, statics) {
    Object.keys(module.actions).forEach(function (key) {
        if (module.namespaced) {
            statics[key] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return __awaiter(this, void 0, void 0, function () {
                    var _a;
                    return __generator(this, function (_b) {
                        return [2 /*return*/, (_a = statics.store).dispatch.apply(_a, __spreadArray(["".concat(modOpt.name, "/").concat(key)], args, false))];
                    });
                });
            };
        }
        else {
            statics[key] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return __awaiter(this, void 0, void 0, function () {
                    var _a;
                    return __generator(this, function (_b) {
                        return [2 /*return*/, (_a = statics.store).dispatch.apply(_a, __spreadArray([key], args, false))];
                    });
                });
            };
        }
    });
}

function registerDynamicModule(module, modOpt) {
    if (!modOpt.name) {
        throw new Error('Name of module not provided in decorator options');
    }
    if (!modOpt.store) {
        throw new Error('Store not provided in decorator options when using dynamic option');
    }
    modOpt.store.registerModule(modOpt.name, // TODO: Handle nested modules too in future
    module, { preserveState: modOpt.preserveState || false });
}
function addGettersToModule(targetModule, srcModule) {
    Object.getOwnPropertyNames(srcModule.prototype).forEach(function (funcName) {
        var descriptor = Object.getOwnPropertyDescriptor(srcModule.prototype, funcName);
        if (descriptor.get && targetModule.getters) {
            targetModule.getters[funcName] = function (state, getters, rootState, rootGetters) {
                var thisObj = { context: { state: state, getters: getters, rootState: rootState, rootGetters: rootGetters } };
                addPropertiesToObject(thisObj, state);
                addPropertiesToObject(thisObj, getters);
                var got = descriptor.get.call(thisObj);
                return got;
            };
        }
    });
}
function moduleDecoratorFactory(moduleOptions) {
    return function (constructor) {
        var module = constructor;
        var stateFactory$1 = function () { return stateFactory(module); };
        if (!module.state) {
            module.state = moduleOptions && moduleOptions.stateFactory ? stateFactory$1 : stateFactory$1();
        }
        if (!module.getters) {
            module.getters = {};
        }
        if (!module.namespaced) {
            module.namespaced = moduleOptions && moduleOptions.namespaced;
        }
        var parentModule = Object.getPrototypeOf(module);
        while (parentModule.name !== 'VuexModule' && parentModule.name !== '') {
            addGettersToModule(module, parentModule);
            parentModule = Object.getPrototypeOf(parentModule);
        }
        addGettersToModule(module, module);
        var modOpt = moduleOptions;
        if (modOpt.name) {
            Object.defineProperty(constructor, '_genStatic', {
                value: function (store) {
                    var statics = { store: store || modOpt.store };
                    if (!statics.store) {
                        throw new Error("ERR_STORE_NOT_PROVIDED: To use getModule(), either the module\n            should be decorated with store in decorator, i.e. @Module({store: store}) or\n            store should be passed when calling getModule(), i.e. getModule(MyModule, this.$store)");
                    }
                    // ===========  For statics ==============
                    // ------ state -------
                    staticStateGenerator(module, modOpt, statics);
                    // ------- getters -------
                    if (module.getters) {
                        staticGetterGenerator(module, modOpt, statics);
                    }
                    // -------- mutations --------
                    if (module.mutations) {
                        staticMutationGenerator(module, modOpt, statics);
                    }
                    // -------- actions ---------
                    if (module.actions) {
                        staticActionGenerators(module, modOpt, statics);
                    }
                    return statics;
                }
            });
            Object.defineProperty(constructor, '_vmdModuleName', {
                value: modOpt.name
            });
        }
        if (modOpt.dynamic) {
            registerDynamicModule(module, modOpt);
        }
        return constructor;
    };
}
function Module(modOrOpt) {
    if (typeof modOrOpt === 'function') {
        /*
         * @Module decorator called without options (directly on the class definition)
         */
        moduleDecoratorFactory({})(modOrOpt);
    }
    else {
        /*
         * @Module({...}) decorator called with options
         */
        return moduleDecoratorFactory(modOrOpt);
    }
}

var config = {};

function actionDecoratorFactory(params) {
    var _a = params || {}, _b = _a.commit, commit = _b === void 0 ? undefined : _b, _c = _a.rawError, rawError = _c === void 0 ? !!config.rawError : _c, _d = _a.root, root = _d === void 0 ? false : _d;
    return function (target, key, descriptor) {
        var module = target.constructor;
        if (!module.hasOwnProperty('actions')) {
            module.actions = Object.assign({}, module.actions);
        }
        var actionFunction = descriptor.value;
        var action = function (context, payload) {
            return __awaiter(this, void 0, void 0, function () {
                var actionPayload, moduleName, moduleAccessor, thisObj, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 5, , 6]);
                            actionPayload = null;
                            if (!module._genStatic) return [3 /*break*/, 2];
                            moduleName = getModuleName(module);
                            moduleAccessor = context.rootGetters[moduleName]
                                ? context.rootGetters[moduleName]
                                : getModule(module);
                            moduleAccessor.context = context;
                            return [4 /*yield*/, actionFunction.call(moduleAccessor, payload)];
                        case 1:
                            actionPayload = _a.sent();
                            return [3 /*break*/, 4];
                        case 2:
                            thisObj = { context: context };
                            addPropertiesToObject(thisObj, context.state);
                            addPropertiesToObject(thisObj, context.getters);
                            return [4 /*yield*/, actionFunction.call(thisObj, payload)];
                        case 3:
                            actionPayload = _a.sent();
                            _a.label = 4;
                        case 4:
                            if (commit) {
                                context.commit(commit, actionPayload);
                            }
                            return [2 /*return*/, actionPayload];
                        case 5:
                            e_1 = _a.sent();
                            throw rawError
                                ? e_1
                                : new Error('ERR_ACTION_ACCESS_UNDEFINED: Are you trying to access ' +
                                    'this.someMutation() or this.someGetter inside an @Action? \n' +
                                    'That works only in dynamic modules. \n' +
                                    'If not dynamic use this.context.commit("mutationName", payload) ' +
                                    'and this.context.getters["getterName"]' +
                                    '\n' +
                                    new Error("Could not perform action ".concat(key.toString())).stack +
                                    '\n' +
                                    e_1.stack);
                        case 6: return [2 /*return*/];
                    }
                });
            });
        };
        module.actions[key] = root ? { root: root, handler: action } : action;
    };
}
/**
 * The @Action decorator turns an async function into an Vuex action
 *
 * @param targetOrParams the module class
 * @param key name of the action
 * @param descriptor the action function descriptor
 * @constructor
 */
function Action(targetOrParams, key, descriptor) {
    if (!key && !descriptor) {
        /*
         * This is the case when `targetOrParams` is params.
         * i.e. when used as -
         * <pre>
            @Action({commit: 'incrCount'})
            async getCountDelta() {
              return 5
            }
         * </pre>
         */
        return actionDecoratorFactory(targetOrParams);
    }
    else {
        /*
         * This is the case when @Action is called on action function
         * without any params
         * <pre>
         *   @Action
         *   async doSomething() {
         *    ...
         *   }
         * </pre>
         */
        actionDecoratorFactory()(targetOrParams, key, descriptor);
    }
}

function Mutation(target, key, descriptor) {
    var module = target.constructor;
    if (!module.hasOwnProperty('mutations')) {
        module.mutations = Object.assign({}, module.mutations);
    }
    var mutationFunction = descriptor.value;
    var mutation = function (state, payload) {
        mutationFunction.call(state, payload);
    };
    module.mutations[key] = mutation;
}

function mutationActionDecoratorFactory(params) {
    return function (target, key, descriptor) {
        var module = target.constructor;
        if (!module.hasOwnProperty('mutations')) {
            module.mutations = Object.assign({}, module.mutations);
        }
        if (!module.hasOwnProperty('actions')) {
            module.actions = Object.assign({}, module.actions);
        }
        var mutactFunction = descriptor.value;
        var action = function (context, payload) {
            return __awaiter(this, void 0, void 0, function () {
                var thisObj, actionPayload, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            thisObj = { context: context };
                            addPropertiesToObject(thisObj, context.state);
                            addPropertiesToObject(thisObj, context.getters);
                            return [4 /*yield*/, mutactFunction.call(thisObj, payload)];
                        case 1:
                            actionPayload = _a.sent();
                            if (actionPayload === undefined)
                                return [2 /*return*/];
                            context.commit(key, actionPayload);
                            return [3 /*break*/, 3];
                        case 2:
                            e_1 = _a.sent();
                            if (params.rawError) {
                                throw e_1;
                            }
                            else {
                                console.error('Could not perform action ' + key.toString());
                                console.error(e_1);
                                return [2 /*return*/, Promise.reject(e_1)];
                            }
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        var mutation = function (state, payload) {
            if (!params.mutate) {
                params.mutate = Object.keys(payload);
            }
            for (var _i = 0, _a = params.mutate; _i < _a.length; _i++) {
                var stateItem = _a[_i];
                if (state.hasOwnProperty(stateItem) && payload.hasOwnProperty(stateItem)) {
                    state[stateItem] = payload[stateItem];
                }
                else {
                    throw new Error("ERR_MUTATE_PARAMS_NOT_IN_PAYLOAD\n          In @MutationAction, mutate: ['a', 'b', ...] array keys must\n          match with return type = {a: {}, b: {}, ...} and must\n          also be in state.");
                }
            }
        };
        module.actions[key] = params.root ? { root: true, handler: action } : action;
        module.mutations[key] = mutation;
    };
}
/**
 * The @MutationAction decorator turns this into an action that further calls a mutation
 * Both the action and the mutation are generated for you
 *
 * @param paramsOrTarget the params or the target class
 * @param key the name of the function
 * @param descriptor the function body
 * @constructor
 */
function MutationAction(paramsOrTarget, key, descriptor) {
    if (!key && !descriptor) {
        /*
         * This is the case when `paramsOrTarget` is params.
         * i.e. when used as -
         * <pre>
            @MutationAction({mutate: ['incrCount']})
            async getCountDelta() {
              return {incrCount: 5}
            }
         * </pre>
         */
        return mutationActionDecoratorFactory(paramsOrTarget);
    }
    else {
        /*
         * This is the case when `paramsOrTarget` is target.
         * i.e. when used as -
         * <pre>
            @MutationAction
            async getCountDelta() {
              return {incrCount: 5}
            }
         * </pre>
         */
        mutationActionDecoratorFactory({})(paramsOrTarget, key, descriptor);
    }
}


//# sourceMappingURL=index.js.map

;// ./src/store/modules/App.ts



var App = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(App, _super);
    function App() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.initialized = false;
        // App information
        _this.app = {};
        // Window width
        _this.windowWidth = window.innerWidth;
        // Sidebar mode selected by the user
        _this.activeSidebarMode = 1;
        // Sidebar mode forced by app
        _this.temporarySidebarMode = null;
        // When sidebar mode is 3, the status of sidebar
        _this.sidebarHidden = true;
        // Store open datatables to access them for updating from other components
        _this.tables = {};
        // If #page must be show in fullscreen mode
        _this.fullscreenMode = false;
        // Add css class to #app
        _this.dynamicAppClass = null;
        // Used for pass action from page Header
        _this.headerAction = null;
        // Used to pass param between pages
        _this.pageParams = null;
        // Spinner for route change
        _this.routeLoading = false;
        return _this;
    }
    App.prototype.setInitialized = function (state) {
        this.initialized = state;
    };
    App.prototype.markAsInitialized = function () {
        this.context.commit('setInitialized', true);
    };
    /**
     * Set the window width
     * @param state
     */
    App.prototype.setRouteLoading = function (state) {
        this.routeLoading = state;
    };
    /**
     * Set the window width
     * @param state
     */
    App.prototype.setRouteLoadingState = function (state) {
        this.context.commit('setRouteLoading', state);
    };
    /**
     * Set the app into the store
     */
    App.prototype.setAppStore = function (app) {
        this.app = app;
    };
    /**
     * Set the app
     */
    App.prototype.setApp = function (app) {
        this.context.commit('setAppStore', app);
    };
    /**
     * Get the app from API
     */
    App.prototype.getApp = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, external_vue_default().prototype.$kwInterface.axios.get('/app', { params: { with_file: true } })
                            .then(function (response) {
                            _this.context.commit('setAppStore', response.data);
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Set the window width
     * @param width
     */
    App.prototype.setWindowWidth = function (width) {
        this.windowWidth = width;
    };
    /**
     * Update the window width
     */
    App.prototype.updateWindowWidth = function () {
        this.context.commit('setWindowWidth', window.innerWidth);
    };
    Object.defineProperty(App.prototype, "mobileSidebar", {
        /**
         * Return if the sidebar to show is for mobile or not
         */
        get: function () {
            return this.windowWidth < 700;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(App.prototype, "tabletSidebar", {
        /**
         * Return if the sidebar to show is for mobile or not
         */
        get: function () {
            return this.windowWidth < 1200;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(App.prototype, "sidebarMode", {
        /**
         * Return the sidebar mode
         */
        get: function () {
            var _a;
            if (this.mobileSidebar) {
                return 3;
            }
            else if (this.tabletSidebar) {
                return 2;
            }
            return (_a = this.temporarySidebarMode) !== null && _a !== void 0 ? _a : this.activeSidebarMode;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Set the sidebar mode selected by user
     * @param mode
     */
    App.prototype.setSidebarMode = function (mode) {
        this.activeSidebarMode = mode;
    };
    /**
     * Switch between the different sidebar modes
     */
    App.prototype.changeSidebarMode = function () {
        var mode = this.activeSidebarMode;
        mode++;
        if (mode > 3) {
            mode = 1;
        }
        this.context.commit('setSidebarMode', mode);
    };
    /**
     * Force the sidebar mode to use (ex: for a route who need small sidebar)
     * @param mode
     */
    App.prototype.setTemporarySidebarMode = function (mode) {
        this.temporarySidebarMode = mode;
    };
    /**
     * Force the sidebar mode to use (ex: for a route who need small sidebar)
     * @param mode
     */
    App.prototype.changeTemporarySidebarMode = function (mode) {
        this.context.commit('setTemporarySidebarMode', mode);
    };
    /**
     * When sidebar mode is 3, the status of sidebar
     * @param mode
     */
    App.prototype.setSidebarHiddenState = function (mode) {
        this.sidebarHidden = mode;
    };
    /**
     * When sidebar mode is 3, the status of sidebar
     * @param state
     */
    App.prototype.changeSidebarHiddenState = function (state) {
        this.context.commit('setSidebarHiddenState', state !== undefined ? state : !this.sidebarHidden);
    };
    Object.defineProperty(App.prototype, "getTable", {
        /**
         * Return an instance of a table
         */
        get: function () {
            var _this = this;
            return function (key) { return _this.tables[key]; };
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Add an open table
     * @param param
     */
    App.prototype.addTable = function (param) {
        this.tables[param.key] = param.table;
    };
    /**
     * Remove an open table
     * @param key
     */
    App.prototype.removeTable = function (key) {
        delete this.tables[key];
    };
    /**
     * Register a new open table
     * @param param
     */
    App.prototype.registerTable = function (param) {
        this.context.commit('addTable', param);
    };
    /**
     * Unregister an open table
     * @param key
     */
    App.prototype.unregisterTable = function (key) {
        this.context.commit('removeTable', key);
    };
    /**
     * Set fullscreen mode
     * @param state
     */
    App.prototype.updateFullscreenMode = function (state) {
        this.fullscreenMode = state;
    };
    /**
     * Set fullscreen mode
     * @param state
     */
    App.prototype.setFullscreenMode = function (state) {
        this.context.commit('updateFullscreenMode', state);
    };
    /**
     * Set fullscreen mode
     * @param cssClass
     */
    App.prototype.updateDynamicAppClass = function (cssClass) {
        this.dynamicAppClass = cssClass;
    };
    /**
     * Set fullscreen mode
     * @param cssClass
     */
    App.prototype.setDynamicAppClass = function (cssClass) {
        this.context.commit('updateDynamicAppClass', cssClass);
    };
    /**
     * Used for pass action from page Header
     * @param action
     */
    App.prototype.updateHeaderAction = function (action) {
        this.headerAction = action;
    };
    /**
     * Used for pass action from page Header
     * @param action
     */
    App.prototype.setHeaderAction = function (action) {
        this.context.commit('updateHeaderAction', action);
    };
    /**
     * Used for pass action from page Header
     */
    App.prototype.resetHeaderAction = function () {
        this.context.commit('updateHeaderAction', null);
    };
    /**
     * Set page params, used for share data between pages
     * Reset on beforeRouteLeave guard
     * @param params
     */
    App.prototype.updatePageParams = function (params) {
        this.pageParams = params;
    };
    /**
     * Used for pass action from page Header
     */
    App.prototype.setPageParams = function (params) {
        this.context.commit('updatePageParams', params);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], App.prototype, "setInitialized", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], App.prototype, "markAsInitialized", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], App.prototype, "setRouteLoading", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], App.prototype, "setRouteLoadingState", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], App.prototype, "setAppStore", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], App.prototype, "setApp", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], App.prototype, "getApp", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], App.prototype, "setWindowWidth", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], App.prototype, "updateWindowWidth", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], App.prototype, "setSidebarMode", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], App.prototype, "changeSidebarMode", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], App.prototype, "setTemporarySidebarMode", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], App.prototype, "changeTemporarySidebarMode", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], App.prototype, "setSidebarHiddenState", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], App.prototype, "changeSidebarHiddenState", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], App.prototype, "addTable", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], App.prototype, "removeTable", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], App.prototype, "registerTable", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], App.prototype, "unregisterTable", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], App.prototype, "updateFullscreenMode", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], App.prototype, "setFullscreenMode", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], App.prototype, "updateDynamicAppClass", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], App.prototype, "setDynamicAppClass", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], App.prototype, "updateHeaderAction", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], App.prototype, "setHeaderAction", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], App.prototype, "resetHeaderAction", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], App.prototype, "updatePageParams", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], App.prototype, "setPageParams", null);
    App = (0,tslib_es6/* __decorate */.Cg)([
        Module({
            namespaced: true
        })
    ], App);
    return App;
}(VuexModule));
/* harmony default export */ var modules_App = (App);

;// ./src/store/modules/Auth.ts




var Auth = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(Auth, _super);
    function Auth() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.token = null;
        _this.redirectTo = null;
        return _this;
    }
    Auth.prototype.clearStore = function () {
        var store = (external_vue_default()).prototype.$kwInterface.store;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        var modules = store._modules.root._children;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        var actions = store._actions;
        forEach_default()(modules, function (module, key) {
            if (key !== 'auth' && actions[key + '/clearStore']) {
                store.dispatch(key + '/clearStore');
            }
        });
    };
    Auth.prototype.updateToken = function (token) {
        var _a, _b;
        this.token = token;
        localStorage.setItem('auth-token', (_a = token === null || token === void 0 ? void 0 : token.access_token) !== null && _a !== void 0 ? _a : '');
        localStorage.setItem('auth-token-expire', (_b = token === null || token === void 0 ? void 0 : token.expires_at) !== null && _b !== void 0 ? _b : '');
    };
    Auth.prototype.setToken = function (token) {
        this.context.commit('updateToken', token);
        if (!token) {
            external_vue_default().prototype.$kwInterface.store.dispatch('user/setUser', null);
            this.context.dispatch('clearStore');
        }
    };
    Auth.prototype.getTokenFromStorage = function () {
        var _a;
        var access_token = localStorage.getItem('auth-token');
        var expires_at = localStorage.getItem('auth-token-expire');
        if (access_token && expires_at && ((_a = this.token) === null || _a === void 0 ? void 0 : _a.access_token) !== access_token) {
            this.context.commit('updateToken', {
                access_token: access_token,
                expires_at: expires_at
            });
        }
    };
    Auth.prototype.updateRedirectTo = function (redirect) {
        this.redirectTo = redirect;
    };
    Auth.prototype.setRedirectTo = function (redirect) {
        this.context.commit('updateRedirectTo', redirect);
    };
    Object.defineProperty(Auth.prototype, "bearerToken", {
        get: function () {
            var _a, _b;
            return (_b = (_a = this.token) === null || _a === void 0 ? void 0 : _a.access_token) !== null && _b !== void 0 ? _b : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Auth.prototype, "isAuth", {
        get: function () {
            return this.bearerToken !== null;
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], Auth.prototype, "clearStore", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], Auth.prototype, "updateToken", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], Auth.prototype, "setToken", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], Auth.prototype, "getTokenFromStorage", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], Auth.prototype, "updateRedirectTo", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], Auth.prototype, "setRedirectTo", null);
    Auth = (0,tslib_es6/* __decorate */.Cg)([
        Module({
            namespaced: true
        })
    ], Auth);
    return Auth;
}(VuexModule));
/* harmony default export */ var modules_Auth = (Auth);

;// ./src/store/modules/DynamicModals.ts



var DynamicModals = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(DynamicModals, _super);
    function DynamicModals() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modals = [];
        _this.instances = [];
        return _this;
    }
    DynamicModals.prototype.addModal = function (modal) {
        this.modals.push(modal);
    };
    DynamicModals.prototype.registerModal = function (modal) {
        this.context.commit('addModal', modal);
    };
    DynamicModals.prototype.addInstance = function (modal) {
        if (!modal.id) {
            modal.id = Math.random().toString(16).slice(2);
        }
        this.instances.push(modal);
    };
    DynamicModals.prototype.removeInstance = function (index) {
        this.instances.splice(index, 1);
    };
    DynamicModals.prototype.openModal = function (params) {
        var _a;
        var key = typeof params === 'string' ? params : params.key;
        var modal = this.modals.find(function (el) { return el.key === key; });
        if (modal) {
            var value = typeof params === 'string' ? null : params.value;
            var submitted = typeof params === 'object' && params.submitted ? params.submitted : ((_a = modal.submitted) !== null && _a !== void 0 ? _a : (function () { return undefined; }));
            var attributes = typeof params === 'object' && params.attributes ? params.attributes : undefined;
            var events = typeof params === 'object' && params.events ? params.events : undefined;
            var buttons = modal.buttons;
            var component = modal.component;
            var title = modal.title;
            modal = JSON.parse(JSON.stringify(modal));
            modal.state = true;
            modal.component = component;
            modal.title = title;
            modal.value = value;
            modal.originalValue = value ? JSON.parse(JSON.stringify(value)) : null;
            modal.submitted = submitted;
            modal.attributes = merge_default()({}, modal.attributes, attributes);
            modal.events = merge_default()({}, modal.events, events);
            modal.buttons = buttons;
            this.context.commit('addInstance', modal);
            // window.location.hash = '#modal-' + key
        }
    };
    DynamicModals.prototype.closeModal = function (index) {
        // const modal = this.instances[index]
        this.context.commit('removeInstance', index);
        /*
        const hash = '#modal-' + modal.key
        if (window.location.hash === hash) {
          window.location.hash = ''
        }
        */
    };
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], DynamicModals.prototype, "addModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], DynamicModals.prototype, "registerModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], DynamicModals.prototype, "addInstance", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], DynamicModals.prototype, "removeInstance", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], DynamicModals.prototype, "openModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], DynamicModals.prototype, "closeModal", null);
    DynamicModals = (0,tslib_es6/* __decorate */.Cg)([
        Module({
            namespaced: true
        })
    ], DynamicModals);
    return DynamicModals;
}(VuexModule));
/* harmony default export */ var modules_DynamicModals = (DynamicModals);

;// ./src/store/modules/GlobalDatas.ts



var GlobalDatas = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(GlobalDatas, _super);
    function GlobalDatas() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.countries = [];
        _this.timezones = [];
        _this.currencies = [];
        _this.userRoles = [];
        _this.userPermissions = [];
        _this.vatRatesLoaded = false;
        _this.vatRates = [];
        _this.teamUsersLoaded = false;
        _this.teamUsers = [];
        _this.unitsLoaded = false;
        _this.units = [];
        _this.civilitiesLoaded = false;
        _this.civilities = [];
        _this.paymentMethodsLoaded = false;
        _this.paymentMethods = [];
        _this.paymentTermsLoaded = false;
        _this.paymentTerms = [];
        _this.tagsLoaded = false;
        _this.tags = [];
        return _this;
    }
    // CLEAR STORE STATE
    GlobalDatas.prototype.clearStore = function () {
        var _this = this;
        var elements = ['VatRates', 'TeamUsers', 'Units', 'Civilities', 'PaymentMethods', 'PaymentTerms', 'Tags'];
        elements.forEach(function (key) {
            _this.context.commit('set' + key, []);
            _this.context.commit('set' + key + 'Loaded', false);
        });
    };
    // COUNTRIES
    GlobalDatas.prototype.setCountries = function (countries) {
        this.countries = countries;
    };
    GlobalDatas.prototype.loadCountries = function (force) {
        if (force === void 0) { force = false; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.countries.length === 0 || force)) return [3 /*break*/, 3];
                        return [4 /*yield*/, external_vue_default().prototype.$kwInterface.axios.get('/country?per_page=500')];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.context.commit('setCountries', response.data.data)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // TIMEZONES
    GlobalDatas.prototype.setTimezones = function (timezones) {
        this.timezones = timezones;
    };
    GlobalDatas.prototype.loadTimezones = function (force) {
        if (force === void 0) { force = false; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.timezones.length === 0 || force)) return [3 /*break*/, 3];
                        return [4 /*yield*/, external_vue_default().prototype.$kwInterface.axios.get('/timezone?per_page=500')];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.context.commit('setTimezones', response.data.data)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // CURRENCIES
    GlobalDatas.prototype.setCurrencies = function (currencies) {
        this.currencies = currencies;
    };
    GlobalDatas.prototype.loadCurrencies = function (force) {
        if (force === void 0) { force = false; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.currencies.length === 0 || force)) return [3 /*break*/, 3];
                        return [4 /*yield*/, external_vue_default().prototype.$kwInterface.axios.get('/currency?per_page=500')];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.context.commit('setCurrencies', response.data.data)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // USER ROLES
    GlobalDatas.prototype.setUserRoles = function (roles) {
        this.userRoles = roles;
    };
    GlobalDatas.prototype.loadUserRoles = function (force) {
        if (force === void 0) { force = false; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.userRoles.length === 0 || force)) return [3 /*break*/, 2];
                        return [4 /*yield*/, external_vue_default().prototype.$kwInterface.axios.get('/user/role')];
                    case 1:
                        response = _a.sent();
                        this.context.commit('setUserRoles', response.data);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    GlobalDatas.prototype.clearUserRoles = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.userRoles.length > 0)) return [3 /*break*/, 2];
                        this.context.commit('setUserRoles', []);
                        return [4 /*yield*/, this.context.dispatch('loadUserRoles')];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    // USER PERMISSIONS
    GlobalDatas.prototype.setUserPermissions = function (permissions) {
        this.userPermissions = permissions;
    };
    GlobalDatas.prototype.loadUserPermissions = function (force) {
        if (force === void 0) { force = false; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.userPermissions.length === 0 || force)) return [3 /*break*/, 3];
                        return [4 /*yield*/, external_vue_default().prototype.$kwInterface.axios.get('/user/permission')];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.context.commit('setUserPermissions', response.data)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GlobalDatas.prototype.clearUserPermissions = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.userPermissions.length > 0)) return [3 /*break*/, 2];
                        this.context.commit('setUserPermissions', []);
                        return [4 /*yield*/, this.context.dispatch('loadUserPermissions')];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(GlobalDatas.prototype, "defaultVatRate", {
        // VAT RATES
        get: function () {
            return this.vatRates.find(function (rate) { return rate.use_default; });
        },
        enumerable: false,
        configurable: true
    });
    GlobalDatas.prototype.setVatRatesLoaded = function (state) {
        if (state === void 0) { state = true; }
        this.vatRatesLoaded = state;
    };
    GlobalDatas.prototype.setVatRates = function (vatRates) {
        this.vatRates = vatRates;
    };
    GlobalDatas.prototype.updateVatRate = function (vatRate) {
        if (!this.vatRatesLoaded) {
            return;
        }
        var index = this.vatRates.findIndex(function (rate) { return rate.id === vatRate.id; });
        if (index >= 0) {
            external_vue_default().set(this.vatRates, index, vatRate);
        }
        else {
            this.vatRates.push(vatRate);
        }
    };
    GlobalDatas.prototype.removeVatRate = function (vatRate) {
        if (!this.vatRatesLoaded) {
            return;
        }
        var index = this.vatRates.findIndex(function (rate) { return rate.id === vatRate.id; });
        if (index >= 0) {
            external_vue_default()["delete"](this.vatRates, index);
        }
    };
    GlobalDatas.prototype.loadVatRates = function (force) {
        if (force === void 0) { force = false; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.vatRatesLoaded || force)) return [3 /*break*/, 3];
                        this.context.commit('setVatRatesLoaded');
                        return [4 /*yield*/, external_vue_default().prototype.$kwInterface.axios.get('/vat_rate?per_page=500&sort=rate')];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.context.commit('setVatRates', response.data.data)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GlobalDatas.prototype.setVatRate = function (vatRate) {
        this.context.commit('updateVatRate', vatRate);
        if (this.vatRatesLoaded) {
            this.context.commit('orderList', { list: this.vatRates, key: 'rate' });
        }
    };
    GlobalDatas.prototype.deleteVatRate = function (vatRate) {
        this.context.commit('removeVatRate', vatRate);
    };
    Object.defineProperty(GlobalDatas.prototype, "teamUsersRole", {
        // TEAM USERS
        get: function () {
            var _this = this;
            return function (role, onlyActive) {
                if (onlyActive === void 0) { onlyActive = true; }
                var teamUsers = onlyActive ? _this.activeTeamUsers : _this.teamUsers;
                return teamUsers.filter(function (teamUser) {
                    var _a;
                    return (_a = teamUser.roles) === null || _a === void 0 ? void 0 : _a.find(function (val) { return val === role; });
                });
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GlobalDatas.prototype, "activeTeamUsers", {
        // Active team users
        get: function () {
            return this.teamUsers.filter(function (teamUser) { return teamUser.status.active && teamUser.user_id !== null; });
        },
        enumerable: false,
        configurable: true
    });
    GlobalDatas.prototype.setTeamUsersLoaded = function (state) {
        if (state === void 0) { state = true; }
        this.teamUsersLoaded = state;
    };
    GlobalDatas.prototype.setTeamUsers = function (teamUsers) {
        this.teamUsers = teamUsers;
    };
    GlobalDatas.prototype.updateTeamUser = function (teamUser) {
        if (!this.teamUsersLoaded) {
            return;
        }
        var index = this.teamUsers.findIndex(function (user) { return user.id === teamUser.id; });
        if (index >= 0) {
            external_vue_default().set(this.teamUsers, index, teamUser);
        }
        else {
            this.teamUsers.push(teamUser);
        }
    };
    GlobalDatas.prototype.removeTeamUser = function (teamUser) {
        if (!this.teamUsersLoaded) {
            return;
        }
        var index = this.teamUsers.findIndex(function (user) { return user.id === teamUser.id; });
        if (index >= 0) {
            external_vue_default()["delete"](this.teamUsers, index);
        }
    };
    GlobalDatas.prototype.loadTeamUsers = function (force) {
        if (force === void 0) { force = false; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response, teamUsers;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.teamUsersLoaded || force)) return [3 /*break*/, 3];
                        this.context.commit('setTeamUsersLoaded');
                        return [4 /*yield*/, external_vue_default().prototype.$kwInterface.axios.get('/team/user', {
                                params: {
                                    per_page: 500,
                                    with_file: true,
                                    include: 'user,roles',
                                    sort: 'fullname'
                                }
                            })];
                    case 1:
                        response = _a.sent();
                        teamUsers = response.data.data.filter(function (teamUser) {
                            return teamUser.invitation === undefined;
                        });
                        return [4 /*yield*/, this.context.commit('setTeamUsers', teamUsers)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GlobalDatas.prototype.setTeamUser = function (teamUser) {
        this.context.commit('updateTeamUser', teamUser);
        if (this.teamUsersLoaded) {
            this.context.commit('orderList', { list: this.teamUsers, key: 'fullname' });
        }
    };
    GlobalDatas.prototype.reloadTeamUser = function (id) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.teamUsersLoaded) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, external_vue_default().prototype.$kwInterface.axios.get('/team/user/' + id, {
                                params: {
                                    with_file: true,
                                    include: 'user,roles',
                                }
                            })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.context.commit('updateTeamUser', response.data)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    GlobalDatas.prototype.deleteTeamUser = function (teamUser) {
        this.context.commit('removeTeamUser', teamUser);
    };
    GlobalDatas.prototype.deleteTeamUserFromId = function (id) {
        var user = this.teamUsers.find(function (user) { return user.id === id; });
        if (user) {
            this.deleteTeamUser(user);
        }
    };
    Object.defineProperty(GlobalDatas.prototype, "defaultUnit", {
        // UNITS
        get: function () {
            return this.units.find(function (unit) { return unit.use_default; });
        },
        enumerable: false,
        configurable: true
    });
    GlobalDatas.prototype.setUnitsLoaded = function (state) {
        if (state === void 0) { state = true; }
        this.unitsLoaded = state;
    };
    GlobalDatas.prototype.setUnits = function (units) {
        this.units = units;
    };
    GlobalDatas.prototype.updateUnit = function (unit) {
        if (!this.unitsLoaded) {
            return;
        }
        var index = this.units.findIndex(function (val) { return val.id === unit.id; });
        if (index >= 0) {
            external_vue_default().set(this.units, index, unit);
        }
        else {
            this.units.push(unit);
        }
    };
    GlobalDatas.prototype.removeUnit = function (unit) {
        if (!this.unitsLoaded) {
            return;
        }
        var index = this.units.findIndex(function (val) { return val.id === unit.id; });
        if (index >= 0) {
            external_vue_default()["delete"](this.units, index);
        }
    };
    GlobalDatas.prototype.loadUnits = function (force) {
        if (force === void 0) { force = false; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.unitsLoaded || force)) return [3 /*break*/, 3];
                        return [4 /*yield*/, external_vue_default().prototype.$kwInterface.axios.get('/unit?per_page=500&sort=label')];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.context.commit('setUnits', response.data.data)];
                    case 2:
                        _a.sent();
                        this.context.commit('setUnitsLoaded');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GlobalDatas.prototype.setUnit = function (unit) {
        this.context.commit('updateUnit', unit);
        if (this.unitsLoaded) {
            this.context.commit('orderList', { list: this.units, key: 'label' });
        }
    };
    GlobalDatas.prototype.deleteUnit = function (unit) {
        this.context.commit('removeUnit', unit);
    };
    Object.defineProperty(GlobalDatas.prototype, "defaultCivility", {
        // CIVILITIES
        get: function () {
            return this.civilities.find(function (civility) { return civility.use_default; });
        },
        enumerable: false,
        configurable: true
    });
    GlobalDatas.prototype.setCivilitiesLoaded = function (state) {
        if (state === void 0) { state = true; }
        this.civilitiesLoaded = state;
    };
    GlobalDatas.prototype.setCivilities = function (civilities) {
        this.civilities = civilities;
    };
    GlobalDatas.prototype.updateCivility = function (civility) {
        if (!this.civilitiesLoaded) {
            return;
        }
        var index = this.civilities.findIndex(function (val) { return val.id === civility.id; });
        if (index >= 0) {
            external_vue_default().set(this.civilities, index, civility);
        }
        else {
            this.civilities.push(civility);
        }
    };
    GlobalDatas.prototype.removeCivility = function (civility) {
        if (!this.civilitiesLoaded) {
            return;
        }
        var index = this.civilities.findIndex(function (val) { return val.id === civility.id; });
        if (index >= 0) {
            external_vue_default()["delete"](this.civilities, index);
        }
    };
    GlobalDatas.prototype.loadCivilities = function (force) {
        if (force === void 0) { force = false; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.civilitiesLoaded || force)) return [3 /*break*/, 3];
                        return [4 /*yield*/, external_vue_default().prototype.$kwInterface.axios.get('/civility?per_page=500&sort=name')];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.context.commit('setCivilities', response.data.data)];
                    case 2:
                        _a.sent();
                        this.context.commit('setCivilitiesLoaded');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GlobalDatas.prototype.setCivility = function (civility) {
        this.context.commit('updateCivility', civility);
        if (this.civilitiesLoaded) {
            this.context.commit('orderList', { list: this.civilities, key: 'name' });
        }
    };
    GlobalDatas.prototype.deleteCivility = function (civility) {
        this.context.commit('removeCivility', civility);
    };
    // PAYMENT METHODS
    GlobalDatas.prototype.setPaymentMethodsLoaded = function (state) {
        if (state === void 0) { state = true; }
        this.paymentMethodsLoaded = state;
    };
    GlobalDatas.prototype.setPaymentMethods = function (paymentMethods) {
        this.paymentMethods = paymentMethods;
    };
    GlobalDatas.prototype.updatePaymentMethod = function (paymentMethod) {
        if (!this.paymentMethodsLoaded) {
            return;
        }
        var index = this.paymentMethods.findIndex(function (val) { return val.id === paymentMethod.id; });
        if (index >= 0) {
            if (paymentMethod.status.active) {
                external_vue_default().set(this.paymentMethods, index, paymentMethod);
            }
            else {
                external_vue_default()["delete"](this.paymentMethods, index);
            }
        }
        else if (paymentMethod.status.active) {
            this.paymentMethods.push(paymentMethod);
        }
    };
    GlobalDatas.prototype.removePaymentMethod = function (paymentMethod) {
        if (!this.paymentMethodsLoaded) {
            return;
        }
        var index = this.paymentMethods.findIndex(function (val) { return val.id === paymentMethod.id; });
        if (index >= 0) {
            external_vue_default()["delete"](this.paymentMethods, index);
        }
    };
    GlobalDatas.prototype.loadPaymentMethods = function (force) {
        if (force === void 0) { force = false; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.paymentMethodsLoaded || force)) return [3 /*break*/, 3];
                        return [4 /*yield*/, external_vue_default().prototype.$kwInterface.axios.get('/payment_method', {
                                params: {
                                    per_page: 500,
                                    sort: 'label',
                                    filter: {
                                        status: 1
                                    }
                                }
                            })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.context.commit('setPaymentMethods', response.data.data)];
                    case 2:
                        _a.sent();
                        this.context.commit('setPaymentMethodsLoaded');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GlobalDatas.prototype.setPaymentMethod = function (paymentMethod) {
        this.context.commit('updatePaymentMethod', paymentMethod);
        if (this.paymentMethodsLoaded) {
            this.context.commit('orderList', { list: this.paymentMethods, key: 'label' });
        }
    };
    GlobalDatas.prototype.deletePaymentMethod = function (paymentMethod) {
        this.context.commit('removePaymentMethod', paymentMethod);
    };
    // PAYMENT TERMS
    GlobalDatas.prototype.setPaymentTermsLoaded = function (state) {
        if (state === void 0) { state = true; }
        this.paymentTermsLoaded = state;
    };
    GlobalDatas.prototype.setPaymentTerms = function (paymentTerms) {
        this.paymentTerms = paymentTerms;
    };
    GlobalDatas.prototype.updatePaymentTerm = function (paymentTerm) {
        if (!this.paymentTermsLoaded) {
            return;
        }
        var index = this.paymentTerms.findIndex(function (val) { return val.id === paymentTerm.id; });
        if (index >= 0) {
            external_vue_default().set(this.paymentTerms, index, paymentTerm);
        }
        else {
            this.paymentTerms.push(paymentTerm);
        }
    };
    GlobalDatas.prototype.removePaymentTerm = function (paymentTerm) {
        if (!this.paymentTermsLoaded) {
            return;
        }
        var index = this.paymentTerms.findIndex(function (val) { return val.id === paymentTerm.id; });
        if (index >= 0) {
            external_vue_default()["delete"](this.paymentTerms, index);
        }
    };
    GlobalDatas.prototype.loadPaymentTerms = function (force) {
        if (force === void 0) { force = false; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.paymentTermsLoaded || force)) return [3 /*break*/, 3];
                        return [4 /*yield*/, external_vue_default().prototype.$kwInterface.axios.get('/payment_term?per_page=500&sort=label')];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.context.commit('setPaymentTerms', response.data.data)];
                    case 2:
                        _a.sent();
                        this.context.commit('setPaymentTermsLoaded');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GlobalDatas.prototype.setPaymentTerm = function (paymentTerm) {
        this.context.commit('updatePaymentTerm', paymentTerm);
        if (this.paymentTermsLoaded) {
            this.context.commit('orderList', { list: this.paymentTerms, key: 'label' });
        }
    };
    GlobalDatas.prototype.deletePaymentTerm = function (paymentTerm) {
        this.context.commit('removePaymentTerm', paymentTerm);
    };
    // TAGS
    GlobalDatas.prototype.setTagsLoaded = function (state) {
        if (state === void 0) { state = true; }
        this.tagsLoaded = state;
    };
    GlobalDatas.prototype.setTags = function (tags) {
        this.tags = tags;
    };
    GlobalDatas.prototype.updateTag = function (tag) {
        if (!this.tagsLoaded) {
            return;
        }
        var index = this.tags.findIndex(function (val) { return val.id === tag.id; });
        if (index >= 0) {
            external_vue_default().set(this.tags, index, tag);
        }
        else {
            this.tags.push(tag);
        }
    };
    GlobalDatas.prototype.removeTag = function (tag) {
        if (!this.tagsLoaded) {
            return;
        }
        var index = this.tags.findIndex(function (val) { return val.id === tag.id; });
        if (index >= 0) {
            external_vue_default()["delete"](this.tags, index);
        }
    };
    GlobalDatas.prototype.loadTags = function (force) {
        if (force === void 0) { force = false; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.tagsLoaded || force)) return [3 /*break*/, 3];
                        return [4 /*yield*/, external_vue_default().prototype.$kwInterface.axios.get('/tag?per_page=500&sort=name')];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.context.commit('setTags', response.data.data)];
                    case 2:
                        _a.sent();
                        this.context.commit('setTagsLoaded');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GlobalDatas.prototype.setTag = function (tag) {
        this.context.commit('updateTag', tag);
        if (this.tagsLoaded) {
            this.context.commit('orderList', { list: this.tags, key: 'name' });
        }
    };
    GlobalDatas.prototype.deleteTag = function (tag) {
        this.context.commit('removeTag', tag);
    };
    // Sort a list alphabetically
    GlobalDatas.prototype.orderList = function (param) {
        var key = param.key;
        param.list.sort(function (a, b) {
            var aKey = a[key];
            if (typeof aKey === 'string') {
                aKey = aKey.toLowerCase();
            }
            var bKey = b[key];
            if (typeof bKey === 'string') {
                bKey = bKey.toLowerCase();
            }
            if (aKey < bKey)
                return -1;
            else if (aKey > bKey)
                return 1;
            else
                return 0;
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], GlobalDatas.prototype, "clearStore", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], GlobalDatas.prototype, "setCountries", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], GlobalDatas.prototype, "loadCountries", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], GlobalDatas.prototype, "setTimezones", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], GlobalDatas.prototype, "loadTimezones", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], GlobalDatas.prototype, "setCurrencies", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], GlobalDatas.prototype, "loadCurrencies", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], GlobalDatas.prototype, "setUserRoles", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], GlobalDatas.prototype, "loadUserRoles", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], GlobalDatas.prototype, "clearUserRoles", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], GlobalDatas.prototype, "setUserPermissions", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], GlobalDatas.prototype, "loadUserPermissions", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], GlobalDatas.prototype, "clearUserPermissions", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], GlobalDatas.prototype, "setVatRatesLoaded", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], GlobalDatas.prototype, "setVatRates", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], GlobalDatas.prototype, "updateVatRate", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], GlobalDatas.prototype, "removeVatRate", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], GlobalDatas.prototype, "loadVatRates", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], GlobalDatas.prototype, "setVatRate", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], GlobalDatas.prototype, "deleteVatRate", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], GlobalDatas.prototype, "setTeamUsersLoaded", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], GlobalDatas.prototype, "setTeamUsers", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], GlobalDatas.prototype, "updateTeamUser", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], GlobalDatas.prototype, "removeTeamUser", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], GlobalDatas.prototype, "loadTeamUsers", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], GlobalDatas.prototype, "setTeamUser", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], GlobalDatas.prototype, "reloadTeamUser", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], GlobalDatas.prototype, "deleteTeamUser", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], GlobalDatas.prototype, "deleteTeamUserFromId", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], GlobalDatas.prototype, "setUnitsLoaded", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], GlobalDatas.prototype, "setUnits", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], GlobalDatas.prototype, "updateUnit", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], GlobalDatas.prototype, "removeUnit", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], GlobalDatas.prototype, "loadUnits", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], GlobalDatas.prototype, "setUnit", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], GlobalDatas.prototype, "deleteUnit", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], GlobalDatas.prototype, "setCivilitiesLoaded", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], GlobalDatas.prototype, "setCivilities", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], GlobalDatas.prototype, "updateCivility", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], GlobalDatas.prototype, "removeCivility", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], GlobalDatas.prototype, "loadCivilities", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], GlobalDatas.prototype, "setCivility", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], GlobalDatas.prototype, "deleteCivility", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], GlobalDatas.prototype, "setPaymentMethodsLoaded", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], GlobalDatas.prototype, "setPaymentMethods", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], GlobalDatas.prototype, "updatePaymentMethod", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], GlobalDatas.prototype, "removePaymentMethod", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], GlobalDatas.prototype, "loadPaymentMethods", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], GlobalDatas.prototype, "setPaymentMethod", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], GlobalDatas.prototype, "deletePaymentMethod", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], GlobalDatas.prototype, "setPaymentTermsLoaded", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], GlobalDatas.prototype, "setPaymentTerms", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], GlobalDatas.prototype, "updatePaymentTerm", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], GlobalDatas.prototype, "removePaymentTerm", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], GlobalDatas.prototype, "loadPaymentTerms", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], GlobalDatas.prototype, "setPaymentTerm", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], GlobalDatas.prototype, "deletePaymentTerm", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], GlobalDatas.prototype, "setTagsLoaded", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], GlobalDatas.prototype, "setTags", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], GlobalDatas.prototype, "updateTag", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], GlobalDatas.prototype, "removeTag", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], GlobalDatas.prototype, "loadTags", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], GlobalDatas.prototype, "setTag", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], GlobalDatas.prototype, "deleteTag", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], GlobalDatas.prototype, "orderList", null);
    GlobalDatas = (0,tslib_es6/* __decorate */.Cg)([
        Module({
            namespaced: true
        })
    ], GlobalDatas);
    return GlobalDatas;
}(VuexModule));
/* harmony default export */ var modules_GlobalDatas = (GlobalDatas);

;// ./src/store/modules/User.ts



var User = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(User, _super);
    function User() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.user = null;
        _this.testModeState = false;
        _this.appMessages = [];
        _this.appMessagesLoaded = false;
        return _this;
    }
    // CLEAR STORE STATE
    User.prototype.clearStore = function () {
        var _this = this;
        var elements = ['AppMessages'];
        elements.forEach(function (key) {
            _this.context.commit('set' + key, []);
            _this.context.commit('set' + key + 'Loaded', false);
        });
    };
    User.prototype.getUserFromApi = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, external_vue_default().prototype.$kwInterface.axios.get('/user', {
                            params: {
                                with_file: true
                            }
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, { user: response.data }];
                }
            });
        });
    };
    User.prototype.updateUser = function (user) {
        this.user = user;
    };
    User.prototype.setUser = function (user) {
        this.context.commit('updateUser', user);
    };
    User.prototype.updateTeamUser = function (teamUser) {
        var _a;
        if ((_a = this.user) === null || _a === void 0 ? void 0 : _a.active_team_user) {
            this.user.active_team_user = teamUser;
        }
    };
    User.prototype.setTeamUser = function (teamUser) {
        this.context.commit('updateTeamUser', teamUser);
    };
    User.prototype.updateTeam = function (team) {
        var _a;
        if ((_a = this.user) === null || _a === void 0 ? void 0 : _a.active_team_user) {
            this.user.active_team_user.team = team;
        }
    };
    User.prototype.setTeam = function (team) {
        this.context.commit('updateTeam', team);
    };
    Object.defineProperty(User.prototype, "avatar", {
        // Return user avatar
        get: function () {
            var _a;
            var avatar = (_a = this.user) === null || _a === void 0 ? void 0 : _a.avatar;
            if (!avatar) {
                return null;
            }
            return 'data:image.png;base64,' + avatar.file;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "teamUser", {
        // Return used team user
        get: function () {
            var _a, _b;
            return (_b = (_a = this.user) === null || _a === void 0 ? void 0 : _a.active_team_user) !== null && _b !== void 0 ? _b : {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "team", {
        // Return used team
        get: function () {
            var _a;
            return (_a = this.teamUser.team) !== null && _a !== void 0 ? _a : {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "country", {
        // Return team currency
        get: function () {
            var _a;
            return (_a = this.team.country) !== null && _a !== void 0 ? _a : {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "teamConfigs", {
        // Return team config
        get: function () {
            var _a;
            return (_a = this.team.configs) !== null && _a !== void 0 ? _a : {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "teamUserConfigs", {
        // Return team user config
        get: function () {
            var _a;
            return (_a = this.teamUser.configs) !== null && _a !== void 0 ? _a : {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "currency", {
        // Return team currency
        get: function () {
            var _a;
            return (_a = this.teamConfigs.currency) !== null && _a !== void 0 ? _a : {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "timezone", {
        // Return team timezone
        get: function () {
            var _a;
            return (_a = this.teamConfigs.timezone) !== null && _a !== void 0 ? _a : {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "permissions", {
        // Return team user permissions
        get: function () {
            var _a;
            return (_a = this.teamUser.permissions) !== null && _a !== void 0 ? _a : {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "permission", {
        // Return a team user permission
        get: function () {
            var _this = this;
            return function (key) { return _this.permissions[key]; };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "can", {
        // Check if a team user have a specific permission
        get: function () {
            var _this = this;
            return function (key, level) { return _this.permissions[key] >= level; };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "testMode", {
        get: function () {
            if (this.team.test_mode_out && this.team.test_mode_out !== 3) {
                return true;
            }
            return this.testModeState;
        },
        enumerable: false,
        configurable: true
    });
    User.prototype.setTestModeState = function (state) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var needRefreshStore;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        needRefreshStore = state !== this.testMode;
                        this.testModeState = state;
                        if (!needRefreshStore) return [3 /*break*/, 4];
                        external_vue_default().prototype.$kwInterface.store.dispatch('auth/clearStore');
                        if (!((external_vue_default()).prototype.$kwInterface.router.currentRoute.name === 'home')) return [3 /*break*/, 2];
                        return [4 /*yield*/, external_vue_default().prototype.$kwInterface.router.push({ name: 'user-profile' })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!(external_vue_default()).prototype.$kwInterface.goToHome) return [3 /*break*/, 4];
                        return [4 /*yield*/, external_vue_default().prototype.$kwInterface.goToHome((external_vue_default()).prototype.$kwInterface.router, (external_vue_default()).prototype.$kwInterface.store)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    User.prototype.setTestMode = function (state) {
        this.context.commit('setTestModeState', state);
    };
    User.prototype.setAppMessages = function (messages) {
        this.appMessages = messages;
    };
    User.prototype.setAppMessagesLoaded = function (state) {
        if (state === void 0) { state = true; }
        this.appMessagesLoaded = state;
    };
    User.prototype.removeAppMessage = function (id) {
        var index = this.appMessages.findIndex(function (val) { return val.id === id; });
        if (index >= 0) {
            external_vue_default()["delete"](this.appMessages, index);
        }
    };
    User.prototype.updateMessage = function (message) {
        var index = this.appMessages.findIndex(function (val) { return val.id === message.id; });
        if (index >= 0) {
            external_vue_default().set(this.appMessages, index, message);
        }
        else {
            this.appMessages.push(message);
        }
    };
    User.prototype.loadAppMessages = function (force) {
        if (force === void 0) { force = false; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.appMessagesLoaded || force)) return [3 /*break*/, 2];
                        return [4 /*yield*/, external_vue_default().prototype.$kwInterface.axios.get('/app/message?per_page=500')];
                    case 1:
                        response = _a.sent();
                        this.context.commit('setAppMessages', response.data.data);
                        this.context.commit('setAppMessagesLoaded');
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    User.prototype.hideAppMessage = function (id) {
        this.context.commit('removeAppMessage', id);
    };
    User.prototype.setAppMessage = function (message) {
        this.context.commit('updateMessage', message);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], User.prototype, "clearStore", null);
    (0,tslib_es6/* __decorate */.Cg)([
        MutationAction({ mutate: ['user'] })
    ], User.prototype, "getUserFromApi", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], User.prototype, "updateUser", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], User.prototype, "setUser", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], User.prototype, "updateTeamUser", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], User.prototype, "setTeamUser", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], User.prototype, "updateTeam", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], User.prototype, "setTeam", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], User.prototype, "setTestModeState", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], User.prototype, "setTestMode", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], User.prototype, "setAppMessages", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], User.prototype, "setAppMessagesLoaded", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], User.prototype, "removeAppMessage", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], User.prototype, "updateMessage", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], User.prototype, "loadAppMessages", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], User.prototype, "hideAppMessage", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], User.prototype, "setAppMessage", null);
    User = (0,tslib_es6/* __decorate */.Cg)([
        Module({
            namespaced: true
        })
    ], User);
    return User;
}(VuexModule));
/* harmony default export */ var modules_User = (User);

;// ./src/store/modules/Notifications.ts



var Notifications = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(Notifications, _super);
    function Notifications() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.headerNotificationsLoaded = false;
        _this.headerNotificationsTotal = 0;
        _this.headerNotifications = [];
        return _this;
    }
    // CLEAR STORE STATE
    Notifications.prototype.clearStore = function () {
        var _this = this;
        var elements = ['HeaderNotifications'];
        elements.forEach(function (key) {
            _this.context.commit('set' + key, []);
            _this.context.commit('set' + key + 'Loaded', false);
        });
    };
    Notifications.prototype.setHeaderNotificationsLoaded = function (state) {
        if (state === void 0) { state = true; }
        this.headerNotificationsLoaded = state;
    };
    Notifications.prototype.setHeaderNotificationsTotal = function (total) {
        this.headerNotificationsTotal = total;
    };
    Notifications.prototype.setHeaderNotifications = function (notifications) {
        this.headerNotifications = notifications;
    };
    Notifications.prototype.insertHeaderNotifications = function (notification) {
        this.headerNotifications.unshift(notification);
        this.headerNotificationsTotal++;
    };
    Notifications.prototype.deleteHeaderNotifications = function (notification) {
        var index = this.headerNotifications.findIndex(function (val) { return val.id === notification.id; });
        if (index >= 0) {
            this.headerNotifications.splice(index, 1);
            if (this.headerNotificationsTotal > 0) {
                this.headerNotificationsTotal--;
            }
        }
    };
    Notifications.prototype.loadHeaderNotifications = function (force) {
        if (force === void 0) { force = false; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.headerNotificationsLoaded || force)) return [3 /*break*/, 2];
                        return [4 /*yield*/, external_vue_default().prototype.$kwInterface.axios.get('/notification', {
                                params: {
                                    per_page: 5,
                                    sort: 'created_at:desc',
                                    filter: {
                                        is_read: false
                                    }
                                }
                            })];
                    case 1:
                        response = _a.sent();
                        this.context.commit('setHeaderNotifications', response.data.data);
                        this.context.commit('setHeaderNotificationsTotal', response.data.meta.total);
                        this.context.commit('setHeaderNotificationsLoaded');
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    Notifications.prototype.resetHeaderNotifications = function () {
        this.context.commit('setHeaderNotifications', []);
        this.context.commit('setHeaderNotificationsTotal', 0);
    };
    Notifications.prototype.addHeaderNotifications = function (notification) {
        this.context.commit('insertHeaderNotifications', notification);
    };
    Notifications.prototype.removeHeaderNotifications = function (notification) {
        this.context.commit('deleteHeaderNotifications', notification);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], Notifications.prototype, "clearStore", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], Notifications.prototype, "setHeaderNotificationsLoaded", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], Notifications.prototype, "setHeaderNotificationsTotal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], Notifications.prototype, "setHeaderNotifications", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], Notifications.prototype, "insertHeaderNotifications", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], Notifications.prototype, "deleteHeaderNotifications", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], Notifications.prototype, "loadHeaderNotifications", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], Notifications.prototype, "resetHeaderNotifications", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], Notifications.prototype, "addHeaderNotifications", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], Notifications.prototype, "removeHeaderNotifications", null);
    Notifications = (0,tslib_es6/* __decorate */.Cg)([
        Module({
            namespaced: true
        })
    ], Notifications);
    return Notifications;
}(VuexModule));
/* harmony default export */ var modules_Notifications = (Notifications);

;// ./src/router/guardsFunctions.ts


// Check if a user have the permission
var checkUserPermission = function (permission) {
    return permission === undefined || external_vue_default().prototype.$kwInterface.store.getters['user/can'](permission[0], permission[1]);
};
// Redirect if a user has not the permission
var redirectIfForbidden = function (to, next) {
    var _a;
    var cant = false;
    for (var _i = 0, _b = to.matched; _i < _b.length; _i++) {
        var route = _b[_i];
        cant = !checkUserPermission((_a = route.meta) === null || _a === void 0 ? void 0 : _a.userPermission);
        if (cant) {
            break;
        }
    }
    if (cant) {
        next({ path: '/error-404' });
    }
    return cant;
};
// Check if a user is auth and the current route auth status
var checkAuth = function (to, next) {
    return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
        var store, meta, router, isAuth, status;
        return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    store = (external_vue_default()).prototype.$kwInterface.store;
                    meta = to.meta;
                    router = (external_vue_default()).prototype.$kwInterface.router;
                    // Check if user token is stored in memory and no user is stored
                    store.dispatch('auth/getTokenFromStorage');
                    isAuth = store.getters['auth/isAuth'];
                    status = null;
                    if (!(!store.state.user.user && isAuth)) return [3 /*break*/, 3];
                    // Fetch user from database
                    return [4 /*yield*/, store.dispatch('user/getUserFromApi')
                            .catch(function (error) {
                            var _a, _b;
                            // The token is invalid
                            status = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : null;
                        })];
                case 1:
                    // Fetch user from database
                    _a.sent();
                    if (status === 401) {
                        store.commit('auth/updateToken', null);
                        isAuth = false;
                    }
                    if (!((meta === null || meta === void 0 ? void 0 : meta.onlyGuest) && (external_vue_default()).prototype.$kwInterface)) return [3 /*break*/, 3];
                    return [4 /*yield*/, external_vue_default().prototype.$kwInterface.goToHome(router, store)];
                case 2:
                    _a.sent();
                    return [2 /*return*/, true];
                case 3:
                    if (!(!isAuth && (meta === null || meta === void 0 ? void 0 : meta.isPublic) !== true)) return [3 /*break*/, 4];
                    store.commit('auth/updateRedirectTo', to);
                    next({ name: 'login' });
                    return [2 /*return*/, true];
                case 4:
                    if (!(isAuth && (meta === null || meta === void 0 ? void 0 : meta.onlyGuest) === true && (external_vue_default()).prototype.$kwInterface)) return [3 /*break*/, 6];
                    return [4 /*yield*/, external_vue_default().prototype.$kwInterface.goToHome(router, store)];
                case 5:
                    _a.sent();
                    return [2 /*return*/, true];
                case 6: return [2 /*return*/, false];
            }
        });
    });
};
// For vue router, get the temporary sidebar mode from route meta paramaters
var beforeEach = function (to, from, next) {
    var _a;
    return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
        var store, meta, redirectAuth, checkRouteAccess, roadAccess, cant, page;
        return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    store = (external_vue_default()).prototype.$kwInterface.store;
                    meta = to.meta;
                    // Mark route as loading
                    store.commit('app/setRouteLoading', true);
                    if (!!store.state.app.initialized) return [3 /*break*/, 2];
                    // Retrieve app from api
                    return [4 /*yield*/, store.dispatch('app/getApp')
                        // Mark app is initialized
                    ];
                case 1:
                    // Retrieve app from api
                    _b.sent();
                    // Mark app is initialized
                    store.dispatch('app/markAsInitialized');
                    _b.label = 2;
                case 2: return [4 /*yield*/, checkAuth(to, next)];
                case 3:
                    redirectAuth = _b.sent();
                    if (redirectAuth) {
                        return [2 /*return*/];
                    }
                    // Only for app route
                    if ((meta === null || meta === void 0 ? void 0 : meta.isPublic) !== true) {
                        checkRouteAccess = (external_vue_default()).prototype.$kwInterface.checkRouteAccess;
                        roadAccess = checkRouteAccess ? checkRouteAccess(to, next, store) : true;
                        cant = redirectIfForbidden(to, next);
                        if (!roadAccess || cant) {
                            return [2 /*return*/];
                        }
                        store.commit('app/setTemporarySidebarMode', (_a = meta === null || meta === void 0 ? void 0 : meta.sidebarMode) !== null && _a !== void 0 ? _a : null);
                        // disable fullscreen if not allowed
                        if (!(meta === null || meta === void 0 ? void 0 : meta.allowFullscreen) && store.state.app.fullscreenMode) {
                            store.commit('app/updateFullscreenMode', false);
                        }
                    }
                    // Apply page title
                    if (meta === null || meta === void 0 ? void 0 : meta.title) {
                        document.title = typeof meta.title === 'function' ? null : meta.title;
                    }
                    page = document.querySelector('#page');
                    if (page) {
                        page.scrollTo({ top: 0 });
                    }
                    next();
                    return [2 /*return*/];
            }
        });
    });
};
var afterEach = (function () {
    external_vue_default().prototype.$kwInterface.store.commit('app/setRouteLoading', false);
});


;// ./src/router/routes.ts


var routes_Error404View = function () { return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 3346)); };
var routes_LoginView = function () { return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1908)); };
var routes_RegisterView = function () { return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1901)); };
var routes_ForgotPasswordView = function () { return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 2854)); };
var routes_ResetPasswordView = function () { return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 7309)); };
var routes_UserInvitationView = function () { return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 137)); };
var routes_EmailVerificationView = function () { return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 5355)); };
var routes_UserProfileView = function () { return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 3670)); };
var routes_ConfigurationView = function () { return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1305)); };
var routes_TeamInformationsView = function () { return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 8583)); };
var routes_TeamParamsView = function () { return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 2165)); };
var routes_CivilitiesView = function () { return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 6697)); };
var routes_PaymentTermsView = function () { return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 2478)); };
var routes_UnitsView = function () { return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 2513)); };
var routes_PaymentMethodsView = function () { return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 8349)); };
var routes_UsersView = function () { return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 9851)); };
var routes_TagsView = function () { return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 4600)); };
var routes_VatRatesView = function () { return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 8856)); };
var routes_HistoricsView = function () { return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 8430)); };
var routes_TeamApiTokenView = function () { return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 8662)); };
var routes_AppColorsView = function () { return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 5262)); };
var routes_AppVersionsView = function () { return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 6571)); };
var routes_NotificationsView = function () { return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 6342)); };
var routes = function (i18n) { return ([
    {
        name: 'user-profile',
        path: '/my-profile',
        component: routes_UserProfileView,
        meta: {
            title: i18n.t('interface.pageTitle.userProfile'),
            buttons: [
                {
                    component: TestModeActivation_TestModeActivation
                }
            ]
        }
    },
    {
        name: 'notifications',
        path: '/notifications',
        component: routes_NotificationsView,
        meta: {
            title: i18n.t('interface.pageTitle.notificationCenter'),
            pageHeader: false
        }
    },
    {
        path: '/configuration',
        name: 'configuration',
        component: routes_ConfigurationView,
        meta: {
            title: i18n.t('interface.configuration'),
            pageHeader: false,
            appClass: {
                'pages-configuration': true
            },
            userPermission: ['app-configuration', 1],
            mainMenu: function () {
                var _a;
                var menu = (_a = (external_vue_default()).prototype.$kwInterface.configMenu) !== null && _a !== void 0 ? _a : [];
                if (typeof menu === 'function') {
                    menu = menu((external_vue_default()).prototype.$kwInterface.i18n);
                }
                return menu;
            }
        },
        children: [
            {
                path: 'team/informations',
                name: 'Mon entreprise',
                component: routes_TeamInformationsView,
                meta: {
                    title: i18n.t('interface.pageTitle.teamInformations')
                }
            },
            {
                name: 'parameters',
                path: 'parameters',
                component: routes_TeamParamsView,
                meta: {
                    title: i18n.t('interface.pageTitle.teamParams')
                }
            },
            {
                name: 'civilities',
                path: 'tiers/civilities',
                component: routes_CivilitiesView,
                meta: {
                    title: i18n.t('interface.pageTitle.civilities')
                }
            },
            {
                name: 'sales-payment-terms',
                path: 'sales/payment-terms',
                component: routes_PaymentTermsView,
                meta: {
                    title: i18n.t('interface.pageTitle.paymentTerms')
                }
            },
            {
                name: 'sales-units',
                path: 'sales/units',
                component: routes_UnitsView,
                meta: {
                    title: i18n.t('interface.pageTitle.units')
                }
            },
            {
                name: 'sales-payment-methods',
                path: 'sales/payment-methods',
                component: routes_PaymentMethodsView,
                meta: {
                    title: i18n.t('interface.pageTitle.paymentMethods')
                }
            },
            {
                name: 'sales-vatrates',
                path: 'sales/vat-rates',
                component: routes_VatRatesView,
                meta: {
                    title: i18n.t('interface.pageTitle.vatrates')
                }
            },
            {
                name: 'config-tags',
                path: 'tags',
                component: routes_TagsView,
                meta: {
                    title: i18n.t('interface.pageTitle.tags')
                }
            },
            {
                name: 'config-users',
                path: 'users',
                component: routes_UsersView,
                meta: {
                    title: i18n.t('interface.pageTitle.users'),
                    pageHeader: false,
                    userPermission: ['manage-users', 1]
                }
            },
            {
                name: 'config-historics',
                path: 'historics',
                component: routes_HistoricsView,
                meta: {
                    title: i18n.t('interface.pageTitle.historics')
                }
            },
            {
                name: 'team-api-token',
                path: 'api-token',
                component: routes_TeamApiTokenView,
                meta: {
                    pageHeader: false,
                    title: i18n.t('interface.pageTitle.apiToken')
                }
            },
            {
                name: 'app-customize',
                path: 'app-customize',
                component: routes_AppColorsView,
                meta: {
                    title: i18n.t('interface.pageTitle.customizeApp')
                }
            },
            {
                name: 'app-versions',
                path: 'app-versions',
                component: routes_AppVersionsView,
                meta: {
                    title: i18n.t('interface.pageTitle.appVersions')
                }
            }
        ]
    },
    {
        name: 'login',
        path: '/',
        component: routes_LoginView,
        meta: {
            title: i18n.t('interface.pageTitle.login'),
            isPublic: true,
            onlyGuest: true
        }
    },
    {
        name: 'forgot-password',
        path: '/forgot-password',
        component: routes_ForgotPasswordView,
        meta: {
            title: i18n.t('interface.pageTitle.forgotPassword'),
            isPublic: true,
            onlyGuest: true
        }
    },
    {
        name: 'reset-password',
        path: '/password/reset/:token',
        component: routes_ResetPasswordView,
        meta: {
            title: i18n.t('interface.pageTitle.resetPassword'),
            isPublic: true,
            onlyGuest: true
        }
    },
    {
        name: 'register',
        path: '/register',
        component: routes_RegisterView,
        meta: {
            title: i18n.t('interface.pageTitle.register'),
            isPublic: true,
            onlyGuest: true
        }
    },
    {
        name: 'email-verify',
        path: '/email/verify/:token/:hash',
        component: routes_EmailVerificationView,
        meta: {
            title: i18n.t('interface.pageTitle.emailValidation'),
            sidebar: false
        }
    },
    {
        name: 'user-invitation',
        path: '/invitation/verify/:token/:hash',
        component: routes_UserInvitationView,
        meta: {
            title: i18n.t('interface.pageTitle.accountInvitation'),
            isPublic: true
        }
    },
    {
        name: 'error-404',
        path: '*',
        component: routes_Error404View,
        meta: {
            title: i18n.t('interface.pageTitle.error404'),
            isPublic: true
        }
    }
]); };
/* harmony default export */ var router_routes = (routes);

;// ./src/menu/header.ts
var header = [
    {
        label: 'Test',
        path: '/test',
        icon: ['fas', 'plus-circle']
    },
    {
        label: 'Page 1',
        path: '/page-1'
    },
    {
        label: 'Page 2',
        path: '/page-2'
    },
    {
        label: 'Submenu',
        open: false,
        icon: ['fas', 'plus-circle'],
        active: '/submenu',
        items: [
            {
                label: 'Page 1',
                path: '/submenu1/page-1',
                addIcon: ['fas', 'plus-circle'],
                addTitle: 'Nouvel élément',
                add: function () {
                    //
                }
            },
            {
                label: 'Page 2',
                path: '/submenu1/page-2'
            }
        ]
    },
    {
        label: 'Page 2',
        path: '/page-2'
    },
    {
        label: 'Submenu',
        open: false,
        icon: ['fas', 'plus-circle'],
        active: '/submenu',
        items: [
            {
                label: 'Page 1',
                path: '/submenu1/page-1',
                addIcon: ['fas', 'plus-circle'],
                addTitle: 'Nouvel élément',
                add: function () {
                    //
                }
            },
            {
                label: 'Page 2',
                path: '/submenu1/page-2'
            }
        ]
    }
];
/* harmony default export */ var menu_header = (header);

// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faChartLine.js
var faChartLine = __webpack_require__(7385);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faUserFriends.js
var faUserFriends = __webpack_require__(3928);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faFileAlt.js
var faFileAlt = __webpack_require__(2573);
;// ./src/menu/main.ts



var addIcon = ['fas', 'plus-circle'];
var menu = [
    {
        label: 'Home',
        path: '/home',
        icon: faChartLine/* faChartLine */.gK,
    },
    {
        label: 'Test Level 1',
        icon: faUserFriends/* faUserFriends */.O2,
        open: false,
        active: '/test',
        items: [
            {
                label: 'Test',
                path: '/test',
                addIcon: addIcon,
                addTitle: 'Nouvel élément',
                addRoute: '/submenu1/page-1-1'
            },
            {
                label: 'Page 2',
                path: '/submenu1/page-2',
            }
        ]
    },
    {
        label: 'Page 2',
        icon: faFileAlt/* faFileAlt */.h8,
        path: '/page-2'
    }
];
/* harmony default export */ var main = (menu);

;// ./src/menu/user.ts

var user_menu = function (i18n) { return ([
    {
        to: '/my-profile',
        label: i18n.t('interface.user.myProfile')
    },
    {
        to: '/configuration/team/informations',
        label: i18n.t('interface.user.myCompany'),
        userPermission: ['app-configuration', 1]
    },
    {
        to: '/configuration/app-modules',
        label: i18n.t('interface.user.modules'),
        userPermission: ['manage-subscription', 1]
    },
    {
        to: '/configuration',
        label: i18n.t('interface.user.configuration'),
        userPermission: ['app-configuration', 1]
    },
    {
        isSeparator: true
    },
    {
        component: Disconnect/* default */.A
    }
]); };
/* harmony default export */ var user = (user_menu);

;// ./src/menu/configs.ts
var configMenu = function (i18n) { return ([
    {
        label: i18n.t('interface.menuLabel.teamInformations'),
        path: '/configuration/team/informations',
        icon: ['fas', 'building']
    },
    {
        label: i18n.t('interface.menuLabel.teamParams'),
        path: '/configuration/parameters',
        icon: ['fas', 'cogs']
    },
    {
        label: i18n.t('interface.menuLabel.tiers'),
        icon: ['fas', 'users-cog'],
        open: false,
        active: '/configuration/tiers',
        items: [
            {
                label: i18n.t('interface.menuLabel.civilities'),
                path: '/configuration/tiers/civilities'
            }
        ]
    },
    {
        label: i18n.t('interface.menuLabel.sales'),
        icon: ['fas', 'shopping-cart'],
        open: false,
        active: '/configuration/sales',
        items: [
            {
                label: i18n.t('interface.menuLabel.paymentTerms'),
                path: '/configuration/sales/payment-terms'
            },
            {
                label: i18n.t('interface.menuLabel.units'),
                path: '/configuration/sales/units'
            },
            {
                label: i18n.t('interface.menuLabel.paymentMethods'),
                path: '/configuration/sales/payment-methods'
            },
            {
                label: i18n.t('interface.menuLabel.vatrates'),
                path: '/configuration/sales/vat-rates'
            }
        ]
    },
    {
        label: i18n.t('interface.menuLabel.tags'),
        path: '/configuration/tags',
        icon: ['fas', 'tags']
    },
    {
        label: i18n.t('interface.menuLabel.importsExports'),
        path: '/configuration/imports-exports',
        icon: ['fas', 'file-import']
    },
    {
        label: i18n.t('interface.menuLabel.users'),
        path: '/configuration/users',
        icon: ['fas', 'users']
    },
    {
        label: i18n.t('interface.menuLabel.historics'),
        path: '/configuration/historics',
        icon: ['fas', 'history']
    },
    {
        label: i18n.t('interface.menuLabel.api'),
        path: '/configuration/api-token',
        icon: ['fas', 'key']
    },
    {
        label: i18n.t('interface.menuLabel.customizeApp'),
        path: '/configuration/app-customize',
        icon: ['fas', 'palette']
    },
    {
        label: i18n.t('interface.menuLabel.appVersions'),
        path: '/configuration/app-versions',
        icon: ['fas', 'code']
    }
]); };
/* harmony default export */ var configs = (configMenu);

;// external "laravel-echo"
var external_laravel_echo_namespaceObject = require("laravel-echo");
var external_laravel_echo_default = /*#__PURE__*/__webpack_require__.n(external_laravel_echo_namespaceObject);
// EXTERNAL MODULE: external "pusher-js"
var external_pusher_js_ = __webpack_require__(2703);
var external_pusher_js_default = /*#__PURE__*/__webpack_require__.n(external_pusher_js_);
;// ./src/broadcasts/ServerBroadcast.ts
/* eslint-disable no-console */




window.Pusher = __webpack_require__(2703);
var ServerBroadcast = /** @class */ (function () {
    function ServerBroadcast(options) {
        this.echo = null;
        this.channels = [];
        this.options = options !== null && options !== void 0 ? options : {};
        if (options === null || options === void 0 ? void 0 : options.debug) {
            (external_pusher_js_default()).logToConsole = true;
        }
    }
    ServerBroadcast.prototype.getOptions = function () {
        var _this = this;
        return merge_default()({
            broadcaster: 'pusher',
            key: "e4637479ee4cb1334e35271b32f57f72",
            cluster: ({"NODE_ENV":"production","VUE_APP_VERSION":"1","VUE_APP_HERE_API_KEY":"23z1ejZ9DwiGvj9aAxpscJ_yr-et9lqeAeZKxgWynL4","VUE_APP_API_URL":"http://127.0.0.1:8000/api","VUE_APP_PUSHER_APP_KEY":"e4637479ee4cb1334e35271b32f57f72","VUE_APP_PUSHER_HOST":"socket.kwixeo.fr","VUE_APP_PUSHER_PORT":"6002","BASE_URL":"/"}).VUE_APP_PUSHER_CLUSTER,
            encrypted: true,
            debug: false,
            authorizer: function (channel) {
                return {
                    authorize: function (socketId, callback) {
                        var _a;
                        external_vue_default().prototype.$kwInterface.axios.post((_a = _this.options.authUrl) !== null && _a !== void 0 ? _a : '/broadcasting/auth', {
                            socket_id: socketId,
                            channel_name: channel.name
                        })
                            .then(function (response) {
                            callback(false, response.data);
                        })
                            .catch(function (error) {
                            callback(true, error);
                        });
                    }
                };
            }
        }, this.options);
    };
    /**
     * Return Echo instance
     */
    ServerBroadcast.prototype.getEcho = function () {
        if (!this.echo) {
            this.initEcho();
        }
        return this.echo;
    };
    /**
     * Active broadcast
     */
    ServerBroadcast.prototype.active = function () {
        if (this.options.debug) {
            console.log('broadcast active');
        }
        // noinspection TypeScriptValidateTypes
        this.getEcho().options = this.getOptions();
        this.joinChannels();
    };
    /**
     * Disable broadcast
     */
    ServerBroadcast.prototype.disable = function () {
        if (this.options.debug) {
            console.log('broadcast disable');
        }
        this.leaveChannels();
    };
    /**
     * Register a new channel
     *
     * @param channel
     */
    ServerBroadcast.prototype.registerChannel = function (channel) {
        if (this.channels.find(function (el) { return el.key === channel.key; })) {
            throw new Error('A channel with this name already exist');
        }
        this.channels.push(merge_default()({
            key: channel.key,
            isPrivate: true,
            channel: null,
            listens: [],
            activeName: null,
        }, channel));
    };
    /**
     * Register new channels
     *
     * @param channels
     */
    ServerBroadcast.prototype.registerChannels = function (channels) {
        var _this = this;
        channels.forEach(function (channel) { return _this.registerChannel(channel); });
    };
    /**
     * Return all channels
     */
    ServerBroadcast.prototype.getChannels = function () {
        return this.channels;
    };
    /**
     * Return a channel
     *
     * @param key
     */
    ServerBroadcast.prototype.getChannel = function (key) {
        return this.channels.find(function (channel) { return channel.key === key; });
    };
    /**
     * Find and return a channel
     *
     * @param key
     */
    ServerBroadcast.prototype.findChannel = function (key) {
        var channel = typeof key === 'string' ? this.getChannel(key) : key;
        if (!channel) {
            throw new Error('No channel with this name is registered');
        }
        return channel;
    };
    /**
     * Join all register channels
     */
    ServerBroadcast.prototype.joinChannels = function () {
        var _this = this;
        this.channels.forEach(function (channel) {
            if (!channel.channel) {
                _this.joinChannel(channel);
            }
        });
    };
    /**
     * Return the channel name
     *
     * @param channel
     * @private
     */
    ServerBroadcast.prototype.getChannelName = function (channel) {
        var name = channel.name;
        if (typeof name === 'function') {
            name = name((external_vue_default()).prototype.$kwInterface.store.state.user.user);
        }
        return name;
    };
    /**
     * Join a channel
     *
     * @param key
     */
    ServerBroadcast.prototype.joinChannel = function (key) {
        var channel = this.findChannel(key);
        var name = this.getChannelName(channel);
        if (channel.channel) {
            if ('activeName' in channel && channel.activeName !== null && channel.activeName !== name) {
                this.leaveChannel(channel);
            }
            else {
                throw new Error('This channel is already active');
            }
        }
        if ('activeName' in channel) {
            channel.activeName = name;
        }
        var join;
        if (channel.isPrivate) {
            join = this.getEcho().private(name);
        }
        else {
            join = this.getEcho().channel(name);
        }
        channel.channel = join;
        if (channel.listens.length > 0) {
            this.registerListeners(channel, channel.listens);
        }
        return channel;
    };
    /**
     * Leave all channels
     */
    ServerBroadcast.prototype.leaveChannels = function () {
        var _this = this;
        this.channels.forEach(function (channel) {
            if (channel.channel) {
                _this.leaveChannel(channel);
            }
        });
    };
    /**
     * Leave a channel
     *
     * @param key
     */
    ServerBroadcast.prototype.leaveChannel = function (key) {
        var _a;
        var channel = this.findChannel(key);
        if (!channel.channel) {
            throw new Error('This channel is not active');
        }
        this.getEcho().leaveChannel((_a = channel.channel.name) !== null && _a !== void 0 ? _a : this.getChannelName(channel));
        channel.channel = null;
    };
    /**
     * Leave a channel and join
     *
     * @param key
     */
    ServerBroadcast.prototype.updateChannel = function (key) {
        var channel = this.findChannel(key);
        if (!channel) {
            return;
        }
        if (channel.channel) {
            this.leaveChannel(channel);
        }
        this.joinChannel(channel);
    };
    /**
     * Register new listeners
     *
     * @param key
     * @param listens
     */
    ServerBroadcast.prototype.registerListeners = function (key, listens) {
        var _this = this;
        var channel = this.findChannel(key);
        listens.forEach(function (listen) { return _this.registerListener(channel, listen); });
    };
    /**
     * Register a new listener
     *
     * @param key
     * @param listen
     */
    ServerBroadcast.prototype.registerListener = function (key, listen) {
        var channel = this.findChannel(key);
        channel.listens.push(listen);
        if (channel.channel) {
            this.activeListener(channel, listen);
        }
    };
    /**
     * Unregister listeners
     *
     * @param key
     * @param listens
     */
    ServerBroadcast.prototype.unregisterListeners = function (key, listens) {
        var _this = this;
        var channel = this.findChannel(key);
        listens.forEach(function (listen) { return _this.unregisterListener(channel, listen); });
    };
    /**
     * Unregister a listener
     *
     * @param key
     * @param listen
     */
    ServerBroadcast.prototype.unregisterListener = function (key, listen) {
        var channel = this.findChannel(key);
        var listener = typeof listen === 'string' ? this.getListener(channel, listen) : listen;
        if (!listener) {
            throw new Error('No listener with this name is registered');
        }
        this.disableListener(channel, listener);
        var index = channel.listens.findIndex(function (el) { return el.name === listener.name; });
        external_vue_default()["delete"](channel.listens, index);
    };
    /**
     * Return a listen from a channel
     *
     * @param key
     * @param listen
     */
    ServerBroadcast.prototype.getListener = function (key, listen) {
        var channel = this.findChannel(key);
        return channel.listens.find(function (el) { return el.name === listen; });
    };
    /**
     * Active a listener
     *
     * @param key
     * @param listen
     */
    ServerBroadcast.prototype.activeListener = function (key, listen) {
        var channel = this.findChannel(key);
        if (!channel.channel) {
            this.joinChannel(channel);
        }
        var listener = typeof listen === 'string' ? this.getListener(channel, listen) : listen;
        if (!listener) {
            throw new Error('No listener with this name is registered');
        }
        channel.channel.listen(listener.name, listener.callback);
    };
    /**
     * disable a listener
     *
     * @param key
     * @param listen
     */
    ServerBroadcast.prototype.disableListener = function (key, listen) {
        var channel = this.findChannel(key);
        if (!channel.channel) {
            return;
        }
        var listener = typeof listen === 'string' ? this.getListener(channel, listen) : listen;
        if (!listener) {
            throw new Error('No listener with this name is registered');
        }
        channel.channel.stopListening(listener.name, listener.callback);
    };
    /**
     * Initialize Echo instance
     *
     * @private
     */
    ServerBroadcast.prototype.initEcho = function () {
        this.echo = new (external_laravel_echo_default())(this.getOptions());
    };
    return ServerBroadcast;
}());
/* harmony default export */ var broadcasts_ServerBroadcast = (ServerBroadcast);

// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__(1146);
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);
;// ./src/broadcasts/team.ts


/* harmony default export */ var team = (function (store) { return ([
    {
        name: '.AccountInstalled',
        callback: function () {
            var team = JSON.parse(JSON.stringify(store.getters['user/team']));
            if (team.account_installed === false) {
                store.dispatch('user/getUserFromApi');
            }
        }
    },
    {
        name: '.DemoModeTransferring',
        callback: function () {
            var team = JSON.parse(JSON.stringify(store.getters['user/team']));
            if (team.test_mode_out !== 2) {
                team.test_mode_out = 2;
                store.dispatch('user/setTestMode', true);
                store.dispatch('user/setTeam', team);
                mitt/* default */.A.emit('demoModeTransferring');
            }
        }
    },
    {
        name: '.DemoModeTransferred',
        callback: function () {
            var team = JSON.parse(JSON.stringify(store.getters['user/team']));
            if (team.test_mode_out !== 3) {
                team.test_mode_out = 3;
                store.dispatch('user/setTestMode', true);
                store.dispatch('user/setTeam', team);
                mitt/* default */.A.emit('demoModeTransferred');
            }
        }
    },
    {
        name: '.CivilityCreated',
        callback: function (civility) {
            store.dispatch('globalDatas/setCivility', civility);
        }
    },
    {
        name: '.CivilityUpdated',
        callback: function (civility) {
            store.dispatch('globalDatas/setCivility', civility);
        }
    },
    {
        name: '.CivilityDeleted',
        callback: function (civility) {
            store.dispatch('globalDatas/deleteCivility', civility);
        }
    },
    {
        name: '.VatRateCreated',
        callback: function (vatRate) {
            store.dispatch('globalDatas/setVatRate', vatRate);
        }
    },
    {
        name: '.VatRateUpdated',
        callback: function (vatRate) {
            store.dispatch('globalDatas/setVatRate', vatRate);
        }
    },
    {
        name: '.VatRateDeleted',
        callback: function (vatRate) {
            store.dispatch('globalDatas/deleteVatRate', vatRate);
        }
    },
    {
        name: '.UnitCreated',
        callback: function (unit) {
            store.dispatch('globalDatas/setUnit', unit);
        }
    },
    {
        name: '.UnitUpdated',
        callback: function (unit) {
            store.dispatch('globalDatas/setUnit', unit);
        }
    },
    {
        name: '.UnitDeleted',
        callback: function (unit) {
            store.dispatch('globalDatas/deleteUnit', unit);
        }
    },
    {
        name: '.PaymentMethodCreated',
        callback: function (paymentMethod) {
            store.dispatch('globalDatas/setPaymentMethod', paymentMethod);
        }
    },
    {
        name: '.PaymentMethodUpdated',
        callback: function (paymentMethod) {
            store.dispatch('globalDatas/setPaymentMethod', paymentMethod);
        }
    },
    {
        name: '.PaymentMethodDeleted',
        callback: function (paymentMethod) {
            store.dispatch('globalDatas/deletePaymentMethod', paymentMethod);
        }
    },
    {
        name: '.PaymentTermCreated',
        callback: function (paymentTerm) {
            store.dispatch('globalDatas/setPaymentTerm', paymentTerm);
        }
    },
    {
        name: '.PaymentTermUpdated',
        callback: function (paymentTerm) {
            store.dispatch('globalDatas/setPaymentTerm', paymentTerm);
        }
    },
    {
        name: '.PaymentTermDeleted',
        callback: function (paymentTerm) {
            store.dispatch('globalDatas/deletePaymentTerm', paymentTerm);
        }
    },
    {
        name: '.TagCreated',
        callback: function (tag) {
            store.dispatch('globalDatas/setTag', tag);
        }
    },
    {
        name: '.TagUpdated',
        callback: function (tag) {
            store.dispatch('globalDatas/setTag', tag);
        }
    },
    {
        name: '.TagDeleted',
        callback: function (tag) {
            store.dispatch('globalDatas/deleteTag', tag);
        },
    },
    {
        name: '.TeamUserCreated',
        callback: function (data) {
            store.dispatch('globalDatas/reloadTeamUser', data.id);
        }
    },
    {
        name: '.TeamUserUpdated',
        callback: function (data) {
            var teamUser = store.state.globalDatas.teamUsers.find(function (user) { return user.id === data.id; });
            if (teamUser && external_moment_default()(teamUser.updated_at).isBefore(data.updated_at)) {
                store.dispatch('globalDatas/reloadTeamUser', data.id);
            }
            //if (store.getters['user/teamUser'].id === data.id && moment(store.getters['user/teamUser'].updated_at).isBefore(data.updated_at)) {
            store.dispatch('user/getUserFromApi');
            //}
        }
    },
    {
        name: '.TeamUserDeleted',
        callback: function (data) {
            store.dispatch('globalDatas/deleteTeamUserFromId', data.id);
        }
    },
    {
        name: '.TeamUpdated',
        callback: function (data) {
            if (external_moment_default()(store.getters['user/team'].updated_at).isBefore(data.updated_at)) {
                store.dispatch('user/getUserFromApi');
            }
        }
    },
    {
        name: '.CommentCreated',
        callback: function (comment) {
            mitt/* default */.A.emit('commentCreated', comment);
        }
    },
    {
        name: '.CommentUpdated',
        callback: function (comment) {
            mitt/* default */.A.emit('commentUpdated', comment);
        }
    },
    {
        name: '.CommentDeleted',
        callback: function (comment) {
            mitt/* default */.A.emit('commentDeleted', comment);
        }
    },
    {
        name: '.TeamFileCreated',
        callback: function (file) {
            mitt/* default */.A.emit('fileCreated', file);
        }
    },
    {
        name: '.TeamFileUpdated',
        callback: function (file) {
            mitt/* default */.A.emit('fileUpdated', file);
        }
    },
    {
        name: '.TeamFileDeleted',
        callback: function (file) {
            mitt/* default */.A.emit('fileDeleted', file);
        }
    },
    {
        name: '.HistoricCreated',
        callback: function (historic) {
            mitt/* default */.A.emit('historicCreated', historic);
        }
    },
    {
        name: '.AppMessageCreated',
        callback: function (message) {
            store.dispatch('user/setAppMessage', message);
        }
    },
    {
        name: '.AppMessageUpdated',
        callback: function (message) {
            store.dispatch('user/setAppMessage', message);
        }
    },
    {
        name: '.AppMessageDeleted',
        callback: function (message) {
            store.dispatch('user/hideAppMessage', message.id);
        }
    }
]); });

;// ./src/broadcasts/teamUser.ts



var fetchNotification = function (id) { return (0,tslib_es6/* __awaiter */.sH)(void 0, void 0, Promise, function () {
    return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, external_vue_default().prototype.$kwSales.axios.get('/notification/' + id)
                    .then(function (response) {
                    return response.data;
                })
                    .catch(function (error) {
                    var _a;
                    throw new Error((_a = error.response) === null || _a === void 0 ? void 0 : _a.data);
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/* harmony default export */ var teamUser = (function () { return ([
    {
        name: '.NotificationCreated',
        callback: function (notification) { return (0,tslib_es6/* __awaiter */.sH)(void 0, void 0, Promise, function () {
            var _a, _b, _c;
            return (0,tslib_es6/* __generator */.YH)(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _b = (_a = mitt/* default */.A).emit;
                        _c = ['notificationCreated'];
                        return [4 /*yield*/, fetchNotification(notification.id)];
                    case 1:
                        _b.apply(_a, _c.concat([_d.sent()]));
                        return [2 /*return*/];
                }
            });
        }); }
    }
]); });

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(5093);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// ./src/broadcasts/user.ts

/* harmony default export */ var broadcasts_user = (function (store) { return ([
    {
        name: '.UserUpdated',
        callback: function (data) {
            setTimeout(function () {
                if (moment_default()(store.state.user.user.updated_at).isBefore(data.updated_at)) {
                    store.dispatch('user/getUserFromApi');
                }
            }, 1000);
        }
    }
]); });

;// ./src/install.ts






















var KwixeoInterface = {
    install: function (Vue, options) {
        // Install lang
        this.installLang(options);
        // Set default option (after lang initialization)
        options = this.setDefaultOptions(options);
        Vue.prototype.$kwInterface = options;
        // Install VueX
        this.installVueX(options);
        // Install axios interceptors
        axios_interceptors(options.axios);
        // Install routes
        this.installRoutes(options);
        // Load font awesome icons
        __webpack_require__(9467);
        // Initialize broadcasts
        this.installBroadcasts(Vue, options);
        // Register Bootstrap configuration
        this.setBootstrapVueOptions(Vue, options.bootstrapVue);
    },
    setDefaultOptions: function (options) {
        // Set user profil view
        if (!options.userProfileView) {
            options.userProfileView = UserProfile_UserProfile;
        }
        if (!options.headerMenu) {
            options.headerMenu = menu_header;
        }
        if (options.sidebarMenu === undefined) {
            options.sidebarMenu = main;
        }
        if (!options.userMenu) {
            options.userMenu = user;
        }
        if (!options.configMenu) {
            options.configMenu = configs;
        }
        if (!options.pageHeaderBreakpoints) {
            options.pageHeaderBreakpoints = {
                titleCols: {
                    xs: 12,
                    md: '*'
                }
            };
        }
        if (!options.serverTimezone) {
            options.serverTimezone = 'Europe/Paris';
        }
        if (!options.goToHome) {
            options.goToHome = function (router) { return (0,tslib_es6/* __awaiter */.sH)(void 0, void 0, void 0, function () {
                return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(router.currentRoute.name !== 'home')) return [3 /*break*/, 2];
                            return [4 /*yield*/, router.push({ name: 'home' })];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            }); };
        }
        return options;
    },
    installVueX: function (options) {
        var store = options.store;
        // Register VueX modules
        var modules = {
            app: modules_App,
            auth: modules_Auth,
            dynamicModals: modules_DynamicModals,
            globalDatas: modules_GlobalDatas,
            user: modules_User,
            notifications: modules_Notifications
        };
        forEach_default()(modules, function (module, key) {
            if (!store.hasModule(key)) {
                store.registerModule(key, module);
            }
        });
    },
    installRoutes: function (options) {
        var router = options.router;
        if (!router) {
            return;
        }
        router.beforeEach(beforeEach);
        router.afterEach(afterEach);
        if (options.installRoutes !== false) { // Install interface routes
            router_routes(options.i18n).forEach(function (route) {
                router.addRoute(route);
            });
        }
        if (options.configRoutes) { // Append config routes
            options.configRoutes.forEach(function (route) {
                router.addRoute('configuration', route);
            });
        }
    },
    installLang: function (options) {
        var i18n = options.i18n;
        forEach_default()(src_lang, function (messages, locale) {
            i18n.mergeLocaleMessage(locale, messages);
        });
    },
    installBroadcasts: function (Vue, options) {
        if (options.broadcasts === false) {
            return;
        }
        var broadcast = new broadcasts_ServerBroadcast(options.broadcasts);
        broadcast.registerChannel({
            key: 'team',
            name: function (user) {
                var _a, _b;
                return 'team.' + ((_b = (_a = user === null || user === void 0 ? void 0 : user.active_team_user) === null || _a === void 0 ? void 0 : _a.team) === null || _b === void 0 ? void 0 : _b.id);
            },
            isPrivate: true,
            listens: team(options.store)
        });
        broadcast.registerChannel({
            key: 'teamUser',
            name: function (user) {
                var _a;
                return 'teamUser.' + ((_a = user === null || user === void 0 ? void 0 : user.active_team_user) === null || _a === void 0 ? void 0 : _a.id);
            },
            isPrivate: true,
            listens: teamUser()
        });
        broadcast.registerChannel({
            key: 'user',
            name: function (user) {
                return 'user.' + (user === null || user === void 0 ? void 0 : user.id);
            },
            isPrivate: true,
            listens: broadcasts_user(options.store)
        });
        Vue.prototype.$broadcast = broadcast;
    },
    // Register Bootstrap configuration
    setBootstrapVueOptions: function (Vue, options) {
        Vue.use(external_bootstrap_vue_.BVConfigPlugin, Object.assign({
            breakpoints: ['xs', 'sm', 'lg', 'md', 'xl', 'xxl']
        }, options));
    }
};
/* harmony default export */ var install = (KwixeoInterface);

;// ./src/serialize.ts

var notEmpty = function (value) { return value !== '' && value !== null && value !== undefined; };
var serializeFunction = function (params, key) {
    var data = [];
    if (Array.isArray(params)) {
        params.forEach(function (param, i) {
            var array = serializeFunction(param, key + '[' + i + ']');
            if (notEmpty(array)) {
                data.push(array);
            }
        });
    }
    else if (typeof params === 'object') {
        forEach_default()(params, function (value, i) {
            if (key) {
                i = key + '[' + i + ']';
            }
            var object = serializeFunction(value, i);
            if (notEmpty(object)) {
                data.push(object);
            }
        });
    }
    else {
        if (notEmpty(params)) {
            data.push(key + '=' + params);
        }
    }
    return data.join('&');
};
// Serialize a nested object
var serialize = function (params) {
    return serializeFunction(params);
};
/* harmony default export */ var src_serialize = (serialize);

;// external "dot-object"
var external_dot_object_namespaceObject = require("dot-object");
;// ./src/broadcasts/LocalBroadcast.ts

/* eslint-disable no-console */
var LocalBroadcast = /** @class */ (function () {
    function LocalBroadcast(options) {
        var _this = this;
        // Options
        this.options = {};
        // If BroadcastChannel is supported
        this.canBroadcast = typeof window.BroadcastChannel === 'function';
        // Channel name
        this.channelName = 'app-local-broadcast';
        // Debug mode
        this.debug = false;
        // Uniq tab id
        this.tabId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        // If is primary
        this.primary = false;
        // List of all tabs
        this.tabList = [];
        // Inialize the broadcasting
        this.initializeBroadcasting = function () {
            if (_this.canBroadcast) {
                var channel = new BroadcastChannel(_this.channelName);
                channel.onmessage = function (event) {
                    _this.processMessage(event.data);
                };
                _this.channel = channel;
            }
            else {
                if (localStorage.getItem(_this.channelName)) {
                    localStorage.removeItem(_this.channelName);
                }
                window.addEventListener('storage', function (event) {
                    if (event.key !== _this.channelName || !event.newValue) {
                        return;
                    }
                    var message = JSON.parse(event.newValue);
                    _this.processMessage(message);
                });
            }
            _this.registerTab(_this.tabId, _this.timestamp);
            _this.sendHello();
        };
        // Send a goodbye message to unregister the tab
        this.sendGoodbye = function () {
            _this.sendMessage('goodbye');
        };
        // Process a received message
        this.processMessage = function (data) {
            if (data.toTab && data.toTab !== _this.tabId) {
                return;
            }
            if (_this.debug) {
                console.log('processMessage', data);
            }
            var tabId = data.tabId;
            var message = data.message;
            switch (data.event) {
                case 'hello':
                    _this.registerTab(tabId, message.timestamp);
                    _this.sendHello(tabId, 'imfine');
                    if (_this.options.onOpen) {
                        _this.options.onOpen(tabId);
                    }
                    break;
                case 'imfine':
                    _this.registerTab(tabId, message.timestamp);
                    break;
                case 'timestamp-updated':
                    _this.updatedTab(tabId, message.timestamp);
                    break;
                case 'goodbye':
                    _this.unregisterTab(tabId);
                    if (_this.options.onClose) {
                        _this.options.onClose(tabId);
                    }
                    break;
                case 'emitter':
                    _this.processEmitter(message.type, message.data);
                    break;
                default:
                    if (_this.options.onMessage) {
                        _this.options.onMessage(data);
                    }
            }
        };
        if (!this.canBroadcast && !this.hasLocalStorage) {
            throw new Error('Your browser don\'t support BroadcastChannel and localStorgage');
        }
        this.parseOptions(options);
        this.setTimestamp();
        window.addEventListener('load', this.initializeBroadcasting);
        window.addEventListener('unload', this.sendGoodbye);
    }
    // Parse the given options
    LocalBroadcast.prototype.parseOptions = function (options) {
        if (!options) {
            return;
        }
        this.options = Object.assign(options, this.options);
        if (options.name) {
            this.channelName = options.name;
        }
        if (options.debug !== undefined) {
            this.debug = options.debug;
        }
    };
    // Set the timestamp
    LocalBroadcast.prototype.setTimestamp = function () {
        this.timestamp = new Date().getTime();
    };
    // Update the timestamp
    LocalBroadcast.prototype.updateTimestamp = function () {
        var _this = this;
        setTimeout(function () {
            _this.setTimestamp();
            _this.sendMessage('timestamp-updated', { timestamp: _this.timestamp });
        }, Math.floor(Math.random() * 10));
        if (this.debug) {
            console.log('updateTimestamp');
        }
    };
    // Check if localstorage is supported
    LocalBroadcast.prototype.hasLocalStorage = function () {
        try {
            var name = this.channelName + '-test';
            localStorage.setItem(name, name);
            localStorage.removeItem(name);
            return true;
        }
        catch (e) {
            return false;
        }
    };
    // Send a hello message to register the tab
    LocalBroadcast.prototype.sendHello = function (tabId, event) {
        if (event === void 0) { event = 'hello'; }
        this.sendMessage(event, { timestamp: this.timestamp }, tabId);
    };
    LocalBroadcast.prototype.processEmitter = function (type, data) {
        if (!data) {
            data = {};
        }
        mitt/* default */.A.emit(type, Object.assign(data, { dontPropagate: true }));
        if (this.debug) {
            console.log('emitter received', type, data);
        }
    };
    // Register a new tab
    LocalBroadcast.prototype.registerTab = function (tabId, timestamp) {
        if (this.tabList.find(function (tab) { return tab.id === tabId; })) {
            return;
        }
        this.tabList.push({
            id: tabId,
            primary: false,
            timestamp: timestamp
        });
        if (tabId !== this.tabId && this.timestamp === timestamp) {
            this.updateTimestamp();
        }
        if (this.debug) {
            console.log('registerTab', tabId, this.tabList);
        }
        this.updatePrimary();
    };
    // Update a tab
    LocalBroadcast.prototype.updatedTab = function (tabId, timestamp) {
        var index = this.tabList.findIndex(function (tab) { return tab.id === tabId; });
        if (index === -1) {
            this.registerTab(tabId, timestamp);
        }
        this.tabList[index].timestamp = timestamp;
        if (this.debug) {
            console.log('updateTab', tabId, this.tabList);
        }
        this.updatePrimary();
    };
    // Unregister a new tab
    LocalBroadcast.prototype.unregisterTab = function (tabId) {
        var index = this.tabList.findIndex(function (tab) { return tab.id === tabId; });
        if (index === -1) {
            return;
        }
        this.tabList.splice(index, 1);
        if (this.debug) {
            console.log('unregisterTab', tabId, this.tabList);
        }
        this.updatePrimary();
    };
    // Update the primary tab
    LocalBroadcast.prototype.updatePrimary = function () {
        var _this = this;
        var primary = this.tabList.reduce(function (a, b) { return a.timestamp < b.timestamp ? a : b; });
        this.tabList.forEach(function (tab, i) {
            _this.tabList[i].primary = primary.id === tab.id;
        });
        if (this.debug) {
            console.log('Primary is ' + primary.id);
        }
        var state = primary.id === this.tabId;
        if (this.primary && !state) {
            this.becameSecondary();
        }
        else if (!this.primary && state) {
            this.becamePrimary();
        }
        this.primary = state;
        if (this.debug) {
            console.log(this.primary ? 'Is primary' : 'Is secondary');
        }
    };
    // This tab became a primary
    LocalBroadcast.prototype.becamePrimary = function () {
        if (this.debug) {
            console.log('becamePrimary');
        }
        if (this.options.becamePrimary) {
            this.options.becamePrimary();
        }
    };
    // This tab became a secondary
    LocalBroadcast.prototype.becameSecondary = function () {
        if (this.debug) {
            console.log('becameSecondary');
        }
        if (this.options.becameSecondary) {
            this.options.becameSecondary();
        }
    };
    // Broadcast a message
    LocalBroadcast.prototype.sendMessage = function (event, message, toTab) {
        var data = {
            event: event,
            tabId: this.tabId,
            message: message,
            toTab: toTab
        };
        if (this.canBroadcast) {
            if (this.channel) {
                this.channel.postMessage(data);
            }
        }
        else {
            localStorage.setItem(this.channelName, JSON.stringify(data));
            localStorage.removeItem(this.channelName);
        }
    };
    // Send a broadcast who are emitted
    LocalBroadcast.prototype.emitter = function (type, data) {
        this.sendMessage('emitter', { type: type, data: data });
    };
    // Return primary state
    LocalBroadcast.prototype.isPrimary = function () {
        return this.primary;
    };
    // Return the list of all opened tabs
    LocalBroadcast.prototype.list = function () {
        return this.tabList;
    };
    return LocalBroadcast;
}());
/* harmony default export */ var broadcasts_LocalBroadcast = (LocalBroadcast);

;// ./src/store/plugins/BroadcastStore.ts

/* eslint-disable no-console */



var broadcastStore = function (options) {
    // Default options values
    var debug = false;
    var statesRemove = [];
    var removeDefault = true;
    var ignoreMutations = [];
    var ignoreDefaultMutation = true;
    // States to remove by default
    var defaultStatesRemove = [
        'app.windowWidth', 'app.activeSidebarMode', 'app.temporarySidebarMode', 'app.sidebarHidden',
        'app.tables', 'app.fullscreenMode', 'app.dynamicAppClass', 'app.headerAction', 'app.pageParams', 'app.routeLoading',
        'dynamicModals'
    ];
    // Default mutations to ignore
    var defaultMutations = [
        'app/getApp', 'app/setInitialized', 'app/setRouteLoading', 'app/setWindowWidth', 'app/setSidebarMode', 'app/setTemporarySidebarMode',
        'app/setSidebarHiddenState', 'app/addTable', 'app/removeTable', 'app/updateFullscreenMode', 'app/updateDynamicAppClass',
        'app/updateHeaderAction', 'app/updatePageParams',
        'auth/updateRedirectTo',
        'dynamicModals/addModal', 'dynamicModals/addInstance', 'dynamicModals/removeInstance',
        'user/getUserFromApi'
    ];
    // Apply options
    if (options) {
        statesRemove = options.statesRemove ? options.statesRemove : statesRemove;
        removeDefault = options.removeDefault !== undefined ? options.removeDefault : removeDefault;
        ignoreDefaultMutation = options.ignoreDefaultMutation !== undefined ? options.ignoreDefaultMutation : ignoreDefaultMutation;
        ignoreMutations = options.ignoreMutations ? options.ignoreMutations : ignoreMutations;
        debug = options.debug ? options.debug : debug;
    }
    // If default states to remove, add them to statesRemove
    if (removeDefault) {
        statesRemove.push.apply(statesRemove, defaultStatesRemove);
    }
    // If default mutations to ignore, add them to ignoreMutations
    if (ignoreDefaultMutation) {
        ignoreMutations.push.apply(ignoreMutations, defaultMutations);
    }
    // Markers
    var lastReceivedMutation = null;
    var isAuth = false;
    var isPrimary = false;
    // simple object deep clone method
    var cloneObj = function (obj) {
        if (Array.isArray(obj)) {
            return obj.map(function (val) { return cloneObj(val); });
        }
        if (typeof obj === 'object' && obj !== null) {
            return Object.keys(obj).reduce(function (r, objKey) {
                r[objKey] = cloneObj(obj[objKey]);
                return r;
            }, {});
        }
        return obj;
    };
    // Remove elements from state
    var removeStates = function (state) {
        var result = cloneObj(state);
        statesRemove.forEach(function (statePath) {
            (0,external_dot_object_namespaceObject.remove)(statePath, result);
        });
        return result;
    };
    // Merge states
    var mergeState = function (oldState, newState) {
        if (statesRemove.length === 0) {
            return (0,tslib_es6/* __assign */.Cl)({}, newState);
        }
        var merged = cloneObj(newState);
        statesRemove.forEach(function (statePath) {
            // Apply value from old state
            var value = (0,external_dot_object_namespaceObject.pick)(statePath, oldState);
            (0,external_dot_object_namespaceObject.set)(statePath, value, merged);
        });
        return merged;
    };
    // Replace the store states
    var replaceStore = function (state, store) {
        store.replaceState(mergeState(store.state, state));
        if (debug) {
            console.log('Store updated', state);
        }
    };
    // Apply a mutation
    var processMutation = function (mutation, store) {
        lastReceivedMutation = mutation.type;
        store.commit(mutation.type, mutation.payload);
        if (debug) {
            console.log('Mutation applied', mutation);
        }
    };
    // Listen is user login ou logout
    var listenUserState = function (store) {
        var _a;
        if (!isPrimary) {
            return;
        }
        var user = (_a = store.state.user) === null || _a === void 0 ? void 0 : _a.user;
        isAuth = user !== null && user !== undefined;
        echoState(isAuth);
    };
    // Enable or disable Echo broadcasting
    var echoState = function (state) {
        var broadcast = (external_vue_default()).prototype.$broadcast;
        if (!broadcast) {
            return;
        }
        if (state) {
            if (typeof broadcast.active === 'function') {
                broadcast.active();
            }
            if (debug) {
                console.log('Active echo broadcast');
            }
        }
        else {
            if (typeof broadcast.disable === 'function') {
                broadcast.disable();
            }
            if (debug) {
                console.log('Disable echo broadcast');
            }
        }
    };
    return function (store) {
        var broadcast = new broadcasts_LocalBroadcast({
            becamePrimary: function () {
                isPrimary = true;
                if (isAuth) {
                    echoState(true);
                }
            },
            becameSecondary: function () {
                isPrimary = false;
                echoState(false);
            },
            onOpen: function (tabId) {
                broadcast.sendMessage('store', removeStates(store.state), tabId);
            },
            onMessage: function (message) {
                switch (message.event) {
                    case 'store':
                        replaceStore(message.message, store);
                        break;
                    case 'mutation':
                        processMutation(message.message, store);
                        break;
                }
            }
        });
        (external_vue_default()).prototype.$localBroadcast = broadcast;
        // Subscribe to store mutations
        store.subscribe(function (mutation) {
            if (['user/getUserFromApi', 'user/updateUser'].includes(mutation.type)) {
                listenUserState(store);
            }
            if (ignoreMutations.includes(mutation.type)) {
                // If is a muted mutation
                return;
            }
            if (lastReceivedMutation === mutation.type) {
                // If the mutation is received, don't propagate it
                lastReceivedMutation = null;
                return;
            }
            // Send a mutation
            broadcast.sendMessage('mutation', mutation);
        });
    };
};
/* harmony default export */ var BroadcastStore = (broadcastStore);

// EXTERNAL MODULE: ./src/utils/breakpoints.ts + 1 modules
var breakpoints = __webpack_require__(5118);
// EXTERNAL MODULE: ./src/utils/number.ts + 1 modules
var number = __webpack_require__(3757);
// EXTERNAL MODULE: ./src/utils/date.ts + 1 modules
var date = __webpack_require__(4755);
;// ./src/index.ts
// Individual components



















































































// Global mixins











// Individual view components































// Vue X Modules






















;// ./node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js



}();
module.exports = __webpack_exports__;
/******/ })()
;
//# sourceMappingURL=interface.common.js.map